/*! jQuery v3.1.1 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.1.1",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null==a?f.call(this):a<0?this[a+this.length]:this[a]},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=r.isArray(d)))?(e?(e=!1,f=c&&r.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0&&("form"in a||"label"in a)},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+sa(o[h]);r=o.join(","),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return function(b){return"form"in b?b.parentNode&&b.disabled===!1?"label"in b?"label"in b.parentNode?b.parentNode.disabled===a:b.disabled===a:b.isDisabled===a||b.isDisabled!==!a&&ea(b)===a:b.disabled===a:"label"in b&&b.disabled===a}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}}):(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c,d,e,f=b.getElementById(a);if(f){if(c=f.getAttributeNode("id"),c&&c.value===a)return[f];e=b.getElementsByName(a),d=0;while(f=e[d++])if(c=f.getAttributeNode("id"),c&&c.value===a)return[f]}return[]}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+"").replace(ba,ca)},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[c<0?c+b:c]}),even:pa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e);return!1}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}return!1}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;d<e;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&ya(a.slice(i,e)),e<f&&ya(a=a.slice(e)),e<f&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,c,e){var f,i,j,k,l,m="function"==typeof a&&a,n=!e&&g(a=m.selector||a);if(c=c||[],1===n.length){if(i=n[0]=n[0].slice(0),i.length>2&&"ID"===(j=i[0]).type&&9===b.nodeType&&p&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(_,aa),b)||[])[0],!b)return c;m&&(b=b.parentNode),a=a.slice(i.shift().value.length)}f=V.needsContext.test(a)?0:i.length;while(f--){if(j=i[f],d.relative[k=j.type])break;if((l=d.find[k])&&(e=l(j.matches[0].replace(_,aa),$.test(i[0].type)&&qa(b.parentNode)||b))){if(i.splice(f,1),a=e.length&&sa(i),!a)return G.apply(c,e),c;break}}}return(m||h(a,n))(e,b,!p,c,!b||$.test(a)&&qa(b.parentNode)||b),c},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext,B=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,C=/^.[^:#\[\.,]*$/;function D(a,b,c){return r.isFunction(b)?r.grep(a,function(a,d){return!!b.call(a,d,a)!==c}):b.nodeType?r.grep(a,function(a){return a===b!==c}):"string"!=typeof b?r.grep(a,function(a){return i.call(b,a)>-1!==c}):C.test(b)?r.filter(b,a,c):(b=r.filter(b,a),r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType}))}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(D(this,a||[],!1))},not:function(a){return this.pushStack(D(this,a||[],!0))},is:function(a){return!!D(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var E,F=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,G=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||E,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:F.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),B.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};G.prototype=r.fn,E=r(d);var H=/^(?:parents|prev(?:Until|All))/,I={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function J(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return J(a,"nextSibling")},prev:function(a){return J(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return a.contentDocument||r.merge([],a.childNodes)}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(I[a]||r.uniqueSort(e),H.test(a)&&e.reverse()),this.pushStack(e)}});var K=/[^\x20\t\r\n\f]+/g;function L(a){var b={};return r.each(a.match(K)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?L(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function M(a){return a}function N(a){throw a}function O(a,b,c){var d;try{a&&r.isFunction(d=a.promise)?d.call(a).done(b).fail(c):a&&r.isFunction(d=a.then)?d.call(a,b,c):b.call(void 0,a)}catch(a){c.call(void 0,a)}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},"catch":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,M,e),g(f,c,N,e)):(f++,j.call(a,g(f,c,M,e),g(f,c,N,e),g(f,c,M,c.notifyWith))):(d!==M&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==N&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:M,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:M)),c[2][3].add(g(0,a,r.isFunction(d)?d:N))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(O(a,g.done(h(c)).resolve,g.reject),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)O(e[c],h(c),g.reject);return g.promise()}});var P=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&P.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var Q=r.Deferred();r.fn.ready=function(a){return Q.then(a)["catch"](function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,holdReady:function(a){a?r.readyWait++:r.ready(!0)},ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||Q.resolveWith(d,[r]))}}),r.ready.then=Q.then;function R(){d.removeEventListener("DOMContentLoaded",R),
a.removeEventListener("load",R),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",R),a.addEventListener("load",R));var S=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)S(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},T=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function U(){this.expando=r.expando+U.uid++}U.uid=1,U.prototype={cache:function(a){var b=a[this.expando];return b||(b={},T(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){r.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(K)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var V=new U,W=new U,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Y=/[A-Z]/g;function Z(a){return"true"===a||"false"!==a&&("null"===a?null:a===+a+""?+a:X.test(a)?JSON.parse(a):a)}function $(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Y,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c=Z(c)}catch(e){}W.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return W.hasData(a)||V.hasData(a)},data:function(a,b,c){return W.access(a,b,c)},removeData:function(a,b){W.remove(a,b)},_data:function(a,b,c){return V.access(a,b,c)},_removeData:function(a,b){V.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=W.get(f),1===f.nodeType&&!V.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),$(f,d,e[d])));V.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){W.set(this,a)}):S(this,function(b){var c;if(f&&void 0===b){if(c=W.get(f,a),void 0!==c)return c;if(c=$(f,a),void 0!==c)return c}else this.each(function(){W.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){W.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=V.get(a,b),c&&(!d||r.isArray(c)?d=V.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return V.get(a,c)||V.access(a,c,{empty:r.Callbacks("once memory").add(function(){V.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=V.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var _=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,aa=new RegExp("^(?:([+-])=|)("+_+")([a-z%]*)$","i"),ba=["Top","Right","Bottom","Left"],ca=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function ea(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&aa.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var fa={};function ga(a){var b,c=a.ownerDocument,d=a.nodeName,e=fa[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),fa[d]=e,e)}function ha(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=V.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&ca(d)&&(e[f]=ga(d))):"none"!==c&&(e[f]="none",V.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ha(this,!0)},hide:function(){return ha(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){ca(this)?r(this).show():r(this).hide()})}});var ia=/^(?:checkbox|radio)$/i,ja=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,ka=/^$|\/(?:java|ecma)script/i,la={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};la.optgroup=la.option,la.tbody=la.tfoot=la.colgroup=la.caption=la.thead,la.th=la.td;function ma(a,b){var c;return c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[],void 0===b||b&&r.nodeName(a,b)?r.merge([a],c):c}function na(a,b){for(var c=0,d=a.length;c<d;c++)V.set(a[c],"globalEval",!b||V.get(b[c],"globalEval"))}var oa=/<|&#?\w+;/;function pa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(oa.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ja.exec(f)||["",""])[1].toLowerCase(),i=la[h]||la._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=ma(l.appendChild(f),"script"),j&&na(g),c){k=0;while(f=g[k++])ka.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var qa=d.documentElement,ra=/^key/,sa=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,ta=/^([^.]*)(?:\.(.+)|)/;function ua(){return!0}function va(){return!1}function wa(){try{return d.activeElement}catch(a){}}function xa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)xa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=va;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(qa,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(K)||[""],j=b.length;while(j--)h=ta.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.hasData(a)&&V.get(a);if(q&&(i=q.events)){b=(b||"").match(K)||[""],j=b.length;while(j--)if(h=ta.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&V.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(V.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&!("click"===a.type&&a.button>=1))for(;j!==this;j=j.parentNode||this)if(1===j.nodeType&&("click"!==a.type||j.disabled!==!0)){for(f=[],g={},c=0;c<i;c++)d=b[c],e=d.selector+" ",void 0===g[e]&&(g[e]=d.needsContext?r(e,this).index(j)>-1:r.find(e,this,null,[j]).length),g[e]&&f.push(d);f.length&&h.push({elem:j,handlers:f})}return j=this,i<b.length&&h.push({elem:j,handlers:b.slice(i)}),h},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==wa()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===wa()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&r.nodeName(this,"input"))return this.click(),!1},_default:function(a){return r.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ua:va,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:va,isPropagationStopped:va,isImmediatePropagationStopped:va,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ua,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ua,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ua,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&ra.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&sa.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return xa(this,a,b,c,d)},one:function(a,b,c,d){return xa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=va),this.each(function(){r.event.remove(this,a,c,b)})}});var ya=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,za=/<script|<style|<link/i,Aa=/checked\s*(?:[^=]|=\s*.checked.)/i,Ba=/^true\/(.*)/,Ca=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Da(a,b){return r.nodeName(a,"table")&&r.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function Ea(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Fa(a){var b=Ba.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Ga(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(V.hasData(a)&&(f=V.access(a),g=V.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}W.hasData(a)&&(h=W.access(a),i=r.extend({},h),W.set(b,i))}}function Ha(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ia.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ia(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&Aa.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ia(f,b,c,d)});if(m&&(e=pa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(ma(e,"script"),Ea),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,ma(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Fa),l=0;l<i;l++)j=h[l],ka.test(j.type||"")&&!V.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Ca,""),k))}return a}function Ja(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(ma(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&na(ma(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(ya,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=ma(h),f=ma(a),d=0,e=f.length;d<e;d++)Ha(f[d],g[d]);if(b)if(c)for(f=f||ma(a),g=g||ma(h),d=0,e=f.length;d<e;d++)Ga(f[d],g[d]);else Ga(a,h);return g=ma(h,"script"),g.length>0&&na(g,!i&&ma(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(T(c)){if(b=c[V.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[V.expando]=void 0}c[W.expando]&&(c[W.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ja(this,a,!0)},remove:function(a){return Ja(this,a)},text:function(a){return S(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ia(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Da(this,a);b.appendChild(a)}})},prepend:function(){return Ia(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Da(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ia(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ia(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(ma(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return S(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!za.test(a)&&!la[(ja.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(ma(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ia(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(ma(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var Ka=/^margin/,La=new RegExp("^("+_+")(?!px)[a-z%]+$","i"),Ma=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",qa.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,qa.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Na(a,b,c){var d,e,f,g,h=a.style;return c=c||Ma(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&La.test(g)&&Ka.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Oa(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Pa=/^(none|table(?!-c[ea]).+)/,Qa={position:"absolute",visibility:"hidden",display:"block"},Ra={letterSpacing:"0",fontWeight:"400"},Sa=["Webkit","Moz","ms"],Ta=d.createElement("div").style;function Ua(a){if(a in Ta)return a;var b=a[0].toUpperCase()+a.slice(1),c=Sa.length;while(c--)if(a=Sa[c]+b,a in Ta)return a}function Va(a,b,c){var d=aa.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Wa(a,b,c,d,e){var f,g=0;for(f=c===(d?"border":"content")?4:"width"===b?1:0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+ba[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+ba[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+ba[f]+"Width",!0,e))):(g+=r.css(a,"padding"+ba[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+ba[f]+"Width",!0,e)));return g}function Xa(a,b,c){var d,e=!0,f=Ma(a),g="border-box"===r.css(a,"boxSizing",!1,f);if(a.getClientRects().length&&(d=a.getBoundingClientRect()[b]),d<=0||null==d){if(d=Na(a,b,f),(d<0||null==d)&&(d=a.style[b]),La.test(d))return d;e=g&&(o.boxSizingReliable()||d===a.style[b]),d=parseFloat(d)||0}return d+Wa(a,b,c||(g?"border":"content"),e,f)+"px"}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Na(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=a.style;return b=r.cssProps[h]||(r.cssProps[h]=Ua(h)||h),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=aa.exec(c))&&e[1]&&(c=ea(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b);return b=r.cssProps[h]||(r.cssProps[h]=Ua(h)||h),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Na(a,b,d)),"normal"===e&&b in Ra&&(e=Ra[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Pa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?Xa(a,b,d):da(a,Qa,function(){return Xa(a,b,d)})},set:function(a,c,d){var e,f=d&&Ma(a),g=d&&Wa(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=aa.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Va(a,c,g)}}}),r.cssHooks.marginLeft=Oa(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Na(a,"marginLeft"))||a.getBoundingClientRect().left-da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+ba[d]+b]=f[d]||f[d-2]||f[0];return e}},Ka.test(a)||(r.cssHooks[a+b].set=Va)}),r.fn.extend({css:function(a,b){return S(this,function(a,b,c){var d,e,f={},g=0;if(r.isArray(b)){for(d=Ma(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function Ya(a,b,c,d,e){return new Ya.prototype.init(a,b,c,d,e)}r.Tween=Ya,Ya.prototype={constructor:Ya,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=Ya.propHooks[this.prop];return a&&a.get?a.get(this):Ya.propHooks._default.get(this)},run:function(a){var b,c=Ya.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ya.propHooks._default.set(this),this}},Ya.prototype.init.prototype=Ya.prototype,Ya.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},Ya.propHooks.scrollTop=Ya.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=Ya.prototype.init,r.fx.step={};var Za,$a,_a=/^(?:toggle|show|hide)$/,ab=/queueHooks$/;function bb(){$a&&(a.requestAnimationFrame(bb),r.fx.tick())}function cb(){return a.setTimeout(function(){Za=void 0}),Za=r.now()}function db(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=ba[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function eb(a,b,c){for(var d,e=(hb.tweeners[b]||[]).concat(hb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function fb(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&ca(a),q=V.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],_a.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=V.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ha([a],!0),j=a.style.display||j,k=r.css(a,"display"),ha([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=V.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ha([a],!0),m.done(function(){p||ha([a]),V.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=eb(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function gb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],r.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function hb(a,b,c){var d,e,f=0,g=hb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Za||cb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:Za||cb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(gb(k,j.opts.specialEasing);f<g;f++)if(d=hb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,eb,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}r.Animation=r.extend(hb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return ea(c.elem,a,aa.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(K);for(var c,d=0,e=a.length;d<e;d++)c=a[d],hb.tweeners[c]=hb.tweeners[c]||[],hb.tweeners[c].unshift(b)},prefilters:[fb],prefilter:function(a,b){b?hb.prefilters.unshift(a):hb.prefilters.push(a)}}),r.speed=function(a,b,c){var e=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off||d.hidden?e.duration=0:"number"!=typeof e.duration&&(e.duration in r.fx.speeds?e.duration=r.fx.speeds[e.duration]:e.duration=r.fx.speeds._default),null!=e.queue&&e.queue!==!0||(e.queue="fx"),e.old=e.complete,e.complete=function(){r.isFunction(e.old)&&e.old.call(this),e.queue&&r.dequeue(this,e.queue)},e},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(ca).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=hb(this,r.extend({},a),f);(e||V.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=V.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&ab.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=V.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(db(b,!0),a,d,e)}}),r.each({slideDown:db("show"),slideUp:db("hide"),slideToggle:db("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(Za=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),Za=void 0},r.fx.timer=function(a){r.timers.push(a),a()?r.fx.start():r.timers.pop()},r.fx.interval=13,r.fx.start=function(){$a||($a=a.requestAnimationFrame?a.requestAnimationFrame(bb):a.setInterval(r.fx.tick,r.fx.interval))},r.fx.stop=function(){a.cancelAnimationFrame?a.cancelAnimationFrame($a):a.clearInterval($a),$a=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var ib,jb=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return S(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?ib:void 0)),
void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&r.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(K);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),ib={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=jb[b]||r.find.attr;jb[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=jb[g],jb[g]=e,e=null!=c(a,b,d)?g:null,jb[g]=f),e}});var kb=/^(?:input|select|textarea|button)$/i,lb=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return S(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):kb.test(a.nodeName)||lb.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});function mb(a){var b=a.match(K)||[];return b.join(" ")}function nb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,nb(this)))});if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=nb(c),d=1===c.nodeType&&" "+mb(e)+" "){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=mb(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,nb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=nb(c),d=1===c.nodeType&&" "+mb(e)+" "){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=mb(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,nb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(K)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=nb(this),b&&V.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":V.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+mb(nb(c))+" ").indexOf(b)>-1)return!0;return!1}});var ob=/\r/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":r.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(ob,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:mb(r.text(a))}},select:{get:function(a){var b,c,d,e=a.options,f=a.selectedIndex,g="select-one"===a.type,h=g?null:[],i=g?f+1:e.length;for(d=f<0?i:g?f:0;d<i;d++)if(c=e[d],(c.selected||d===f)&&!c.disabled&&(!c.parentNode.disabled||!r.nodeName(c.parentNode,"optgroup"))){if(b=r(c).val(),g)return b;h.push(b)}return h},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(r.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var pb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!pb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,pb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(V.get(h,"events")||{})[b.type]&&V.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&T(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!T(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=V.access(d,b);e||d.addEventListener(a,c,!0),V.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=V.access(d,b)-1;e?V.access(d,b,e):(d.removeEventListener(a,c,!0),V.remove(d,b))}}});var qb=a.location,rb=r.now(),sb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var tb=/\[\]$/,ub=/\r?\n/g,vb=/^(?:submit|button|image|reset|file)$/i,wb=/^(?:input|select|textarea|keygen)/i;function xb(a,b,c,d){var e;if(r.isArray(b))r.each(b,function(b,e){c||tb.test(a)?d(a,e):xb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)xb(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(r.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)xb(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&wb.test(this.nodeName)&&!vb.test(a)&&(this.checked||!ia.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:r.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(ub,"\r\n")}}):{name:b.name,value:c.replace(ub,"\r\n")}}).get()}});var yb=/%20/g,zb=/#.*$/,Ab=/([?&])_=[^&]*/,Bb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Cb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Db=/^(?:GET|HEAD)$/,Eb=/^\/\//,Fb={},Gb={},Hb="*/".concat("*"),Ib=d.createElement("a");Ib.href=qb.href;function Jb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(K)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Kb(a,b,c,d){var e={},f=a===Gb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Lb(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Mb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Nb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:qb.href,type:"GET",isLocal:Cb.test(qb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Hb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Lb(Lb(a,r.ajaxSettings),b):Lb(r.ajaxSettings,a)},ajaxPrefilter:Jb(Fb),ajaxTransport:Jb(Gb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Bb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||qb.href)+"").replace(Eb,qb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(K)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Ib.protocol+"//"+Ib.host!=j.protocol+"//"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Kb(Fb,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Db.test(o.type),f=o.url.replace(zb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(yb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(sb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Ab,"$1"),n=(sb.test(f)?"&":"?")+"_="+rb++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Hb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Kb(Gb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,"No Transport");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Mb(o,y,d)),v=Nb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Ob={0:200,1223:204},Pb=r.ajaxSettings.xhr();o.cors=!!Pb&&"withCredentials"in Pb,o.ajax=Pb=!!Pb,r.ajaxTransport(function(b){var c,d;if(o.cors||Pb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Ob[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Qb=[],Rb=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Qb.pop()||r.expando+"_"+rb++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Rb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Rb.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Rb,"$1"+e):b.jsonp!==!1&&(b.url+=(sb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Qb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=B.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=pa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=mb(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length};function Sb(a){return r.isWindow(a)?a:9===a.nodeType&&a.defaultView}r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),d.width||d.height?(e=f.ownerDocument,c=Sb(e),b=e.documentElement,{top:d.top+c.pageYOffset-b.clientTop,left:d.left+c.pageXOffset-b.clientLeft}):d):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),r.nodeName(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||qa})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return S(this,function(a,d,e){var f=Sb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Oa(o.pixelPosition,function(a,c){if(c)return c=Na(a,b),La.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return S(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.parseJSON=JSON.parse,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Tb=a.jQuery,Ub=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Ub),b&&a.jQuery===r&&(a.jQuery=Tb),r},b||(a.jQuery=a.$=r),r});
; /** ----------------- **/ 
 (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.6
  //     https://underscorejs.org
  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.6';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global) ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));
//# sourceMappingURL=underscore-umd.js.map; /** ----------------- **/ 
 //     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

    // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
    // We use `self` instead of `window` for `WebWorker` support.
    var root = (typeof self == 'object' && self.self === self && self) ||
        (typeof global == 'object' && global.global === global && global);

    // Set up Backbone appropriately for the environment. Start with AMD.
    if (typeof define === 'function' && define.amd) {
        define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
            // Export global even in AMD case in case this script is loaded with
            // others that may still expect a global Backbone.
            root.Backbone = factory(root, exports, _, $);
        });

        // Next for Node.js or CommonJS. jQuery may not be needed as a module.
    } else if (typeof exports !== 'undefined') {
        var _ = require('underscore'), $;
        try { $ = require('jquery'); } catch (e) {}
        factory(root, exports, _, $);

        // Finally, as a browser global.
    } else {
        root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
    }

})(function(root, Backbone, _, $) {

    // Initial Setup
    // -------------

    // Save the previous value of the `Backbone` variable, so that it can be
    // restored later on, if `noConflict` is used.
    var previousBackbone = root.Backbone;

    // Create a local reference to a common array method we'll want to use later.
    var slice = Array.prototype.slice;

    // Current version of the library. Keep in sync with `package.json`.
    Backbone.VERSION = '1.3.3';

    // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
    // the `$` variable.
    Backbone.$ = $;

    // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
    // to its previous owner. Returns a reference to this Backbone object.
    Backbone.noConflict = function() {
        root.Backbone = previousBackbone;
        return this;
    };

    // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
    // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
    // set a `X-Http-Method-Override` header.
    Backbone.emulateHTTP = false;

    // Turn on `emulateJSON` to support legacy servers that can't deal with direct
    // `application/json` requests ... this will encode the body as
    // `application/x-www-form-urlencoded` instead and will send the model in a
    // form param named `model`.
    Backbone.emulateJSON = false;

    // Proxy Backbone class methods to Underscore functions, wrapping the model's
    // `attributes` object or collection's `models` array behind the scenes.
    //
    // collection.filter(function(model) { return model.get('age') > 10 });
    // collection.each(this.addView);
    //
    // `Function#apply` can be slow so we use the method's arg count, if we know it.
    var addMethod = function(length, method, attribute) {
        switch (length) {
            case 1: return function() {
                return _[method](this[attribute]);
            };
            case 2: return function(value) {
                return _[method](this[attribute], value);
            };
            case 3: return function(iteratee, context) {
                return _[method](this[attribute], cb(iteratee, this), context);
            };
            case 4: return function(iteratee, defaultVal, context) {
                return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
            };
            default: return function() {
                var args = slice.call(arguments);
                args.unshift(this[attribute]);
                return _[method].apply(_, args);
            };
        }
    };
    var addUnderscoreMethods = function(Class, methods, attribute) {
        _.each(methods, function(length, method) {
            if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
        });
    };

    // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
    var cb = function(iteratee, instance) {
        if (_.isFunction(iteratee)) return iteratee;
        if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
        if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
        return iteratee;
    };
    var modelMatcher = function(attrs) {
        var matcher = _.matches(attrs);
        return function(model) {
            return matcher(model.attributes);
        };
    };

    // Backbone.Events
    // ---------------

    // A module that can be mixed in to *any object* in order to provide it with
    // a custom event channel. You may bind a callback to an event with `on` or
    // remove with `off`; `trigger`-ing an event fires all callbacks in
    // succession.
    //
    //     var object = {};
    //     _.extend(object, Backbone.Events);
    //     object.on('expand', function(){ alert('expanded'); });
    //     object.trigger('expand');
    //
    var Events = Backbone.Events = {};

    // Regular expression used to split event strings.
    var eventSplitter = /\s+/;

    // Iterates over the standard `event, callback` (as well as the fancy multiple
    // space-separated events `"change blur", callback` and jQuery-style event
    // maps `{event: callback}`).
    var eventsApi = function(iteratee, events, name, callback, opts) {
        var i = 0, names;
        if (name && typeof name === 'object') {
            // Handle event maps.
            if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
            for (names = _.keys(name); i < names.length ; i++) {
                events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
            }
        } else if (name && eventSplitter.test(name)) {
            // Handle space-separated event names by delegating them individually.
            for (names = name.split(eventSplitter); i < names.length; i++) {
                events = iteratee(events, names[i], callback, opts);
            }
        } else {
            // Finally, standard events.
            events = iteratee(events, name, callback, opts);
        }
        return events;
    };

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    Events.on = function(name, callback, context) {
        return internalOn(this, name, callback, context);
    };

    // Guard the `listening` argument from the public API.
    var internalOn = function(obj, name, callback, context, listening) {
        obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
            context: context,
            ctx: obj,
            listening: listening
        });

        if (listening) {
            var listeners = obj._listeners || (obj._listeners = {});
            listeners[listening.id] = listening;
        }

        return obj;
    };

    // Inversion-of-control versions of `on`. Tell *this* object to listen to
    // an event in another object... keeping track of what it's listening to
    // for easier unbinding later.
    Events.listenTo = function(obj, name, callback) {
        if (!obj) return this;
        var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
        var listeningTo = this._listeningTo || (this._listeningTo = {});
        var listening = listeningTo[id];

        // This object is not listening to any other events on `obj` yet.
        // Setup the necessary references to track the listening callbacks.
        if (!listening) {
            var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
            listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
        }

        // Bind callbacks on obj, and keep track of them on listening.
        internalOn(obj, name, callback, this, listening);
        return this;
    };

    // The reducing API that adds a callback to the `events` object.
    var onApi = function(events, name, callback, options) {
        if (callback) {
            var handlers = events[name] || (events[name] = []);
            var context = options.context, ctx = options.ctx, listening = options.listening;
            if (listening) listening.count++;

            handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
        }
        return events;
    };

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    Events.off = function(name, callback, context) {
        if (!this._events) return this;
        this._events = eventsApi(offApi, this._events, name, callback, {
            context: context,
            listeners: this._listeners
        });
        return this;
    };

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    Events.stopListening = function(obj, name, callback) {
        var listeningTo = this._listeningTo;
        if (!listeningTo) return this;

        var ids = obj ? [obj._listenId] : _.keys(listeningTo);

        for (var i = 0; i < ids.length; i++) {
            var listening = listeningTo[ids[i]];

            // If listening doesn't exist, this object is not currently
            // listening to obj. Break out early.
            if (!listening) break;

            listening.obj.off(name, callback, this);
        }

        return this;
    };

    // The reducing API that removes a callback from the `events` object.
    var offApi = function(events, name, callback, options) {
        if (!events) return;

        var i = 0, listening;
        var context = options.context, listeners = options.listeners;

        // Delete all events listeners and "drop" events.
        if (!name && !callback && !context) {
            var ids = _.keys(listeners);
            for (; i < ids.length; i++) {
                listening = listeners[ids[i]];
                delete listeners[listening.id];
                delete listening.listeningTo[listening.objId];
            }
            return;
        }

        var names = name ? [name] : _.keys(events);
        for (; i < names.length; i++) {
            name = names[i];
            var handlers = events[name];

            // Bail out if there are no events stored.
            if (!handlers) break;

            // Replace events if there are any remaining.  Otherwise, clean up.
            var remaining = [];
            for (var j = 0; j < handlers.length; j++) {
                var handler = handlers[j];
                if (
                    callback && callback !== handler.callback &&
                    callback !== handler.callback._callback ||
                    context && context !== handler.context
                ) {
                    remaining.push(handler);
                } else {
                    listening = handler.listening;
                    if (listening && --listening.count === 0) {
                        delete listeners[listening.id];
                        delete listening.listeningTo[listening.objId];
                    }
                }
            }

            // Update tail event if the list has any events.  Otherwise, clean up.
            if (remaining.length) {
                events[name] = remaining;
            } else {
                delete events[name];
            }
        }
        return events;
    };

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, its listener will be removed. If multiple events
    // are passed in using the space-separated syntax, the handler will fire
    // once for each event, not once for a combination of all events.
    Events.once = function(name, callback, context) {
        // Map the event into a `{event: once}` object.
        var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
        if (typeof name === 'string' && context == null) callback = void 0;
        return this.on(events, callback, context);
    };

    // Inversion-of-control versions of `once`.
    Events.listenToOnce = function(obj, name, callback) {
        // Map the event into a `{event: once}` object.
        var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
        return this.listenTo(obj, events);
    };

    // Reduces the event callbacks into a map of `{event: onceWrapper}`.
    // `offer` unbinds the `onceWrapper` after it has been called.
    var onceMap = function(map, name, callback, offer) {
        if (callback) {
            var once = map[name] = _.once(function() {
                offer(name, once);
                callback.apply(this, arguments);
            });
            once._callback = callback;
        }
        return map;
    };

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    Events.trigger = function(name) {
        if (!this._events) return this;

        var length = Math.max(0, arguments.length - 1);
        var args = Array(length);
        for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

        eventsApi(triggerApi, this._events, name, void 0, args);
        return this;
    };

    // Handles triggering the appropriate event callbacks.
    var triggerApi = function(objEvents, name, callback, args) {
        if (objEvents) {
            var events = objEvents[name];
            var allEvents = objEvents.all;
            if (events && allEvents) allEvents = allEvents.slice();
            if (events) triggerEvents(events, args);
            if (allEvents) triggerEvents(allEvents, [name].concat(args));
        }
        return objEvents;
    };

    // A difficult-to-believe, but optimized internal dispatch function for
    // triggering events. Tries to keep the usual cases speedy (most internal
    // Backbone events have 3 arguments).
    var triggerEvents = function(events, args) {
        var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
        switch (args.length) {
            case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
            case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
            case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
            case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
            default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
        }
    };

    // Aliases for backwards compatibility.
    Events.bind   = Events.on;
    Events.unbind = Events.off;

    // Allow the `Backbone` object to serve as a global event bus, for folks who
    // want global "pubsub" in a convenient place.
    _.extend(Backbone, Events);

    // Backbone.Model
    // --------------

    // Backbone **Models** are the basic data object in the framework --
    // frequently representing a row in a table in a database on your server.
    // A discrete chunk of data and a bunch of useful, related methods for
    // performing computations and transformations on that data.

    // Create a new model with the specified attributes. A client id (`cid`)
    // is automatically generated and assigned for you.
    var Model = Backbone.Model = function(attributes, options) {
        var attrs = attributes || {};
        options || (options = {});
        this.cid = _.uniqueId(this.cidPrefix);
        this.attributes = {};
        if (options.collection) this.collection = options.collection;
        if (options.parse) attrs = this.parse(attrs, options) || {};
        var defaults = _.result(this, 'defaults');
        attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
        this.set(attrs, options);
        this.changed = {};
        this.initialize.apply(this, arguments);
    };

    // Attach all inheritable methods to the Model prototype.
    _.extend(Model.prototype, Events, {

        // A hash of attributes whose current and previous value differ.
        changed: null,

        // The value returned during the last failed validation.
        validationError: null,

        // The default name for the JSON `id` attribute is `"id"`. MongoDB and
        // CouchDB users may want to set this to `"_id"`.
        idAttribute: 'id',

        // The prefix is used to create the client id which is used to identify models locally.
        // You may want to override this if you're experiencing name clashes with model ids.
        cidPrefix: 'c',

        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function(){},

        // Return a copy of the model's `attributes` object.
        toJSON: function(options) {
            return _.clone(this.attributes);
        },

        // Proxy `Backbone.sync` by default -- but override this if you need
        // custom syncing semantics for *this* particular model.
        sync: function() {
            return Backbone.sync.apply(this, arguments);
        },

        // Get the value of an attribute.
        get: function(attr) {
            return this.attributes[attr];
        },

        // Get the HTML-escaped value of an attribute.
        escape: function(attr) {
            return _.escape(this.get(attr));
        },

        // Returns `true` if the attribute contains a value that is not null
        // or undefined.
        has: function(attr) {
            return this.get(attr) != null;
        },

        // Special-cased proxy to underscore's `_.matches` method.
        matches: function(attrs) {
            return !!_.iteratee(attrs, this)(this.attributes);
        },

        // Set a hash of model attributes on the object, firing `"change"`. This is
        // the core primitive operation of a model, updating the data and notifying
        // anyone who needs to know about the change in state. The heart of the beast.
        set: function(key, val, options) {
            if (key == null) return this;

            // Handle both `"key", value` and `{key: value}` -style arguments.
            var attrs;
            if (typeof key === 'object') {
                attrs = key;
                options = val;
            } else {
                (attrs = {})[key] = val;
            }

            options || (options = {});

            // Run validation.
            if (!this._validate(attrs, options)) return false;

            // Extract attributes and options.
            var unset      = options.unset;
            var silent     = options.silent;
            var changes    = [];
            var changing   = this._changing;
            this._changing = true;

            if (!changing) {
                this._previousAttributes = _.clone(this.attributes);
                this.changed = {};
            }

            var current = this.attributes;
            var changed = this.changed;
            var prev    = this._previousAttributes;

            // For each `set` attribute, update or delete the current value.
            for (var attr in attrs) {
                val = attrs[attr];
                if (!_.isEqual(current[attr], val)) changes.push(attr);
                if (!_.isEqual(prev[attr], val)) {
                    changed[attr] = val;
                } else {
                    delete changed[attr];
                }
                unset ? delete current[attr] : current[attr] = val;
            }

            // Update the `id`.
            if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

            // Trigger all relevant attribute changes.
            if (!silent) {
                if (changes.length) this._pending = options;
                for (var i = 0; i < changes.length; i++) {
                    this.trigger('change:' + changes[i], this, current[changes[i]], options, changes[i]);
                }
            }

            // You might be wondering why there's a `while` loop here. Changes can
            // be recursively nested within `"change"` events.
            if (changing) return this;
            if (!silent) {
                while (this._pending) {
                    options = this._pending;
                    this._pending = false;
                    this.trigger('change', this, options);
                }
            }
            this._pending = false;
            this._changing = false;
            return this;
        },

        // Remove an attribute from the model, firing `"change"`. `unset` is a noop
        // if the attribute doesn't exist.
        unset: function(attr, options) {
            return this.set(attr, void 0, _.extend({}, options, {unset: true}));
        },

        // Clear all attributes on the model, firing `"change"`.
        clear: function(options) {
            var attrs = {};
            for (var key in this.attributes) attrs[key] = void 0;
            return this.set(attrs, _.extend({}, options, {unset: true}));
        },

        // Determine if the model has changed since the last `"change"` event.
        // If you specify an attribute name, determine if that attribute has changed.
        hasChanged: function(attr) {
            if (attr == null) return !_.isEmpty(this.changed);
            return _.has(this.changed, attr);
        },

        // Return an object containing all the attributes that have changed, or
        // false if there are no changed attributes. Useful for determining what
        // parts of a view need to be updated and/or what attributes need to be
        // persisted to the server. Unset attributes will be set to undefined.
        // You can also pass an attributes object to diff against the model,
        // determining if there *would be* a change.
        changedAttributes: function(diff) {
            if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
            var old = this._changing ? this._previousAttributes : this.attributes;
            var changed = {};
            for (var attr in diff) {
                var val = diff[attr];
                if (_.isEqual(old[attr], val)) continue;
                changed[attr] = val;
            }
            return _.size(changed) ? changed : false;
        },

        // Get the previous value of an attribute, recorded at the time the last
        // `"change"` event was fired.
        previous: function(attr) {
            if (attr == null || !this._previousAttributes) return null;
            return this._previousAttributes[attr];
        },

        // Get all of the attributes of the model at the time of the previous
        // `"change"` event.
        previousAttributes: function() {
            return _.clone(this._previousAttributes);
        },

        // Fetch the model from the server, merging the response with the model's
        // local attributes. Any changed attributes will trigger a "change" event.
        fetch: function(options) {
            options = _.extend({parse: true}, options);
            var model = this;
            var success = options.success;
            options.success = function(resp) {
                var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                if (!model.set(serverAttrs, options)) return false;
                if (success) success.call(options.context, model, resp, options);
                model.trigger('sync', model, resp, options);
            };
            wrapError(this, options);
            return this.sync('read', this, options);
        },

        // Set a hash of model attributes, and sync the model to the server.
        // If the server returns an attributes hash that differs, the model's
        // state will be `set` again.
        save: function(key, val, options) {
            // Handle both `"key", value` and `{key: value}` -style arguments.
            var attrs;
            if (key == null || typeof key === 'object') {
                attrs = key;
                options = val;
            } else {
                (attrs = {})[key] = val;
            }

            options = _.extend({validate: true, parse: true}, options);
            var wait = options.wait;

            // If we're not waiting and attributes exist, save acts as
            // `set(attr).save(null, opts)` with validation. Otherwise, check if
            // the model will be valid when the attributes, if any, are set.
            if (attrs && !wait) {
                if (!this.set(attrs, options)) return false;
            } else if (!this._validate(attrs, options)) {
                return false;
            }

            // After a successful server-side save, the client is (optionally)
            // updated with the server-side state.
            var model = this;
            var success = options.success;
            var attributes = this.attributes;
            options.success = function(resp) {
                // Ensure attributes are restored during synchronous saves.
                model.attributes = attributes;
                var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
                if (serverAttrs && !model.set(serverAttrs, options)) return false;
                if (success) success.call(options.context, model, resp, options);
                model.trigger('sync', model, resp, options);
            };
            wrapError(this, options);

            // Set temporary attributes if `{wait: true}` to properly find new ids.
            if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

            var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
            if (method === 'patch' && !options.attrs) options.attrs = attrs;
            var xhr = this.sync(method, this, options);

            // Restore attributes.
            this.attributes = attributes;

            return xhr;
        },

        // Destroy this model on the server if it was already persisted.
        // Optimistically removes the model from its collection, if it has one.
        // If `wait: true` is passed, waits for the server to respond before removal.
        destroy: function(options) {
            options = options ? _.clone(options) : {};
            var model = this;
            var success = options.success;
            var wait = options.wait;

            var destroy = function() {
                model.stopListening();
                model.trigger('destroy', model, model.collection, options);
            };

            options.success = function(resp) {
                if (wait) destroy();
                if (success) success.call(options.context, model, resp, options);
                if (!model.isNew()) model.trigger('sync', model, resp, options);
            };

            var xhr = false;
            if (this.isNew()) {
                _.defer(options.success);
            } else {
                wrapError(this, options);
                xhr = this.sync('delete', this, options);
            }
            if (!wait) destroy();
            return xhr;
        },

        // Default URL for the model's representation on the server -- if you're
        // using Backbone's restful methods, override this to change the endpoint
        // that will be called.
        url: function() {
            var base =
                _.result(this, 'urlRoot') ||
                _.result(this.collection, 'url') ||
                urlError();
            if (this.isNew()) return base;
            var id = this.get(this.idAttribute);
            return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
        },

        // **parse** converts a response into the hash of attributes to be `set` on
        // the model. The default implementation is just to pass the response along.
        parse: function(resp, options) {
            return resp;
        },

        // Create a new model with identical attributes to this one.
        clone: function() {
            return new this.constructor(this.attributes);
        },

        // A model is new if it has never been saved to the server, and lacks an id.
        isNew: function() {
            return !this.has(this.idAttribute);
        },

        // Check if the model is currently in a valid state.
        isValid: function(options) {
            return this._validate({}, _.extend({}, options, {validate: true}));
        },

        // Run validation against the next complete set of model attributes,
        // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
        _validate: function(attrs, options) {
            if (!options.validate || !this.validate) return true;
            attrs = _.extend({}, this.attributes, attrs);
            var error = this.validationError = this.validate(attrs, options) || null;
            if (!error) return true;
            this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
            return false;
        }

    });

    // Underscore methods that we want to implement on the Model, mapped to the
    // number of arguments they take.
    var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
        omit: 0, chain: 1, isEmpty: 1};

    // Mix in each Underscore method as a proxy to `Model#attributes`.
    addUnderscoreMethods(Model, modelMethods, 'attributes');

    // Backbone.Collection
    // -------------------

    // If models tend to represent a single row of data, a Backbone Collection is
    // more analogous to a table full of data ... or a small slice or page of that
    // table, or a collection of rows that belong together for a particular reason
    // -- all of the messages in this particular folder, all of the documents
    // belonging to this particular author, and so on. Collections maintain
    // indexes of their models, both in order, and for lookup by `id`.

    // Create a new **Collection**, perhaps to contain a specific type of `model`.
    // If a `comparator` is specified, the Collection will maintain
    // its models in sort order, as they're added and removed.
    var Collection = Backbone.Collection = function(models, options) {
        options || (options = {});
        if (options.model) this.model = options.model;
        if (options.comparator !== void 0) this.comparator = options.comparator;
        this._reset();
        this.initialize.apply(this, arguments);
        if (models) this.reset(models, _.extend({silent: true}, options));
    };

    // Default options for `Collection#set`.
    var setOptions = {add: true, remove: true, merge: true};
    var addOptions = {add: true, remove: false};

    // Splices `insert` into `array` at index `at`.
    var splice = function(array, insert, at) {
        at = Math.min(Math.max(at, 0), array.length);
        var tail = Array(array.length - at);
        var length = insert.length;
        var i;
        for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
        for (i = 0; i < length; i++) array[i + at] = insert[i];
        for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
    };

    // Define the Collection's inheritable methods.
    _.extend(Collection.prototype, Events, {

        // The default model for a collection is just a **Backbone.Model**.
        // This should be overridden in most cases.
        model: Model,

        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function(){},

        // The JSON representation of a Collection is an array of the
        // models' attributes.
        toJSON: function(options) {
            return this.map(function(model) { return model.toJSON(options); });
        },

        // Proxy `Backbone.sync` by default.
        sync: function() {
            return Backbone.sync.apply(this, arguments);
        },

        // Add a model, or list of models to the set. `models` may be Backbone
        // Models or raw JavaScript objects to be converted to Models, or any
        // combination of the two.
        add: function(models, options) {
            return this.set(models, _.extend({merge: false}, options, addOptions));
        },

        // Remove a model, or a list of models from the set.
        remove: function(models, options) {
            options = _.extend({}, options);
            var singular = !_.isArray(models);
            models = singular ? [models] : models.slice();
            var removed = this._removeModels(models, options);
            if (!options.silent && removed.length) {
                options.changes = {added: [], merged: [], removed: removed};
                this.trigger('update', this, options);
            }
            return singular ? removed[0] : removed;
        },

        // Update a collection by `set`-ing a new list of models, adding new ones,
        // removing models that are no longer present, and merging models that
        // already exist in the collection, as necessary. Similar to **Model#set**,
        // the core operation for updating the data contained by the collection.
        set: function(models, options) {
            if (models == null) return;

            options = _.extend({}, setOptions, options);
            if (options.parse && !this._isModel(models)) {
                models = this.parse(models, options) || [];
            }

            var singular = !_.isArray(models);
            models = singular ? [models] : models.slice();

            var at = options.at;
            if (at != null) at = +at;
            if (at > this.length) at = this.length;
            if (at < 0) at += this.length + 1;

            var set = [];
            var toAdd = [];
            var toMerge = [];
            var toRemove = [];
            var modelMap = {};

            var add = options.add;
            var merge = options.merge;
            var remove = options.remove;

            var sort = false;
            var sortable = this.comparator && at == null && options.sort !== false;
            var sortAttr = _.isString(this.comparator) ? this.comparator : null;

            // Turn bare objects into model references, and prevent invalid models
            // from being added.
            var model, i;
            for (i = 0; i < models.length; i++) {
                model = models[i];

                // If a duplicate is found, prevent it from being added and
                // optionally merge it into the existing model.
                var existing = this.get(model);
                if (existing) {
                    if (merge && model !== existing) {
                        var attrs = this._isModel(model) ? model.attributes : model;
                        if (options.parse) attrs = existing.parse(attrs, options);
                        existing.set(attrs, options);
                        toMerge.push(existing);
                        if (sortable && !sort) sort = existing.hasChanged(sortAttr);
                    }
                    if (!modelMap[existing.cid]) {
                        modelMap[existing.cid] = true;
                        set.push(existing);
                    }
                    models[i] = existing;

                    // If this is a new, valid model, push it to the `toAdd` list.
                } else if (add) {
                    model = models[i] = this._prepareModel(model, options);
                    if (model) {
                        toAdd.push(model);
                        this._addReference(model, options);
                        modelMap[model.cid] = true;
                        set.push(model);
                    }
                }
            }

            // Remove stale models.
            if (remove) {
                for (i = 0; i < this.length; i++) {
                    model = this.models[i];
                    if (!modelMap[model.cid]) toRemove.push(model);
                }
                if (toRemove.length) this._removeModels(toRemove, options);
            }

            // See if sorting is needed, update `length` and splice in new models.
            var orderChanged = false;
            var replace = !sortable && add && remove;
            if (set.length && replace) {
                orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
                    return m !== set[index];
                });
                this.models.length = 0;
                splice(this.models, set, 0);
                this.length = this.models.length;
            } else if (toAdd.length) {
                if (sortable) sort = true;
                splice(this.models, toAdd, at == null ? this.length : at);
                this.length = this.models.length;
            }

            // Silently sort the collection if appropriate.
            if (sort) this.sort({silent: true});

            // Unless silenced, it's time to fire all appropriate add/sort/update events.
            if (!options.silent) {
                for (i = 0; i < toAdd.length; i++) {
                    if (at != null) options.index = at + i;
                    model = toAdd[i];
                    model.trigger('add', model, this, options);
                }
                if (sort || orderChanged) this.trigger('sort', this, options);
                if (toAdd.length || toRemove.length || toMerge.length) {
                    options.changes = {
                        added: toAdd,
                        removed: toRemove,
                        merged: toMerge
                    };
                    this.trigger('update', this, options);
                }
            }

            // Return the added (or merged) model (or models).
            return singular ? models[0] : models;
        },

        // When you have more items than you want to add or remove individually,
        // you can reset the entire set with a new list of models, without firing
        // any granular `add` or `remove` events. Fires `reset` when finished.
        // Useful for bulk operations and optimizations.
        reset: function(models, options) {
            options = options ? _.clone(options) : {};
            for (var i = 0; i < this.models.length; i++) {
                this._removeReference(this.models[i], options);
            }
            options.previousModels = this.models;
            this._reset();
            models = this.add(models, _.extend({silent: true}, options));
            if (!options.silent) this.trigger('reset', this, options);
            return models;
        },

        // Add a model to the end of the collection.
        push: function(model, options) {
            return this.add(model, _.extend({at: this.length}, options));
        },

        // Remove a model from the end of the collection.
        pop: function(options) {
            var model = this.at(this.length - 1);
            return this.remove(model, options);
        },

        // Add a model to the beginning of the collection.
        unshift: function(model, options) {
            return this.add(model, _.extend({at: 0}, options));
        },

        // Remove a model from the beginning of the collection.
        shift: function(options) {
            var model = this.at(0);
            return this.remove(model, options);
        },

        // Slice out a sub-array of models from the collection.
        slice: function() {
            return slice.apply(this.models, arguments);
        },

        // Get a model from the set by id, cid, model object with id or cid
        // properties, or an attributes object that is transformed through modelId.
        get: function(obj) {
            if (obj == null) return void 0;
            return this._byId[obj] ||
                this._byId[this.modelId(obj.attributes || obj)] ||
                obj.cid && this._byId[obj.cid];
        },

        // Returns `true` if the model is in the collection.
        has: function(obj) {
            return this.get(obj) != null;
        },

        // Get the model at the given index.
        at: function(index) {
            if (index < 0) index += this.length;
            return this.models[index];
        },

        // Return models with matching attributes. Useful for simple cases of
        // `filter`.
        where: function(attrs, first) {
            return this[first ? 'find' : 'filter'](attrs);
        },

        // Return the first model with matching attributes. Useful for simple cases
        // of `find`.
        findWhere: function(attrs) {
            return this.where(attrs, true);
        },

        // Force the collection to re-sort itself. You don't need to call this under
        // normal circumstances, as the set will maintain sort order as each item
        // is added.
        sort: function(options) {
            var comparator = this.comparator;
            if (!comparator) throw new Error('Cannot sort a set without a comparator');
            options || (options = {});

            var length = comparator.length;
            if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

            // Run sort based on type of `comparator`.
            if (length === 1 || _.isString(comparator)) {
                this.models = this.sortBy(comparator);
            } else {
                this.models.sort(comparator);
            }
            if (!options.silent) this.trigger('sort', this, options);
            return this;
        },

        // Pluck an attribute from each model in the collection.
        pluck: function(attr) {
            return this.map(attr + '');
        },

        // Fetch the default set of models for this collection, resetting the
        // collection when they arrive. If `reset: true` is passed, the response
        // data will be passed through the `reset` method instead of `set`.
        fetch: function(options) {
            options = _.extend({parse: true}, options);
            var success = options.success;
            var collection = this;
            options.success = function(resp) {
                var method = options.reset ? 'reset' : 'set';
                collection[method](resp, options);
                if (success) success.call(options.context, collection, resp, options);
                collection.trigger('sync', collection, resp, options);
            };
            wrapError(this, options);
            return this.sync('read', this, options);
        },

        // Create a new instance of a model in this collection. Add the model to the
        // collection immediately, unless `wait: true` is passed, in which case we
        // wait for the server to agree.
        create: function(model, options) {
            options = options ? _.clone(options) : {};
            var wait = options.wait;
            model = this._prepareModel(model, options);
            if (!model) return false;
            if (!wait) this.add(model, options);
            var collection = this;
            var success = options.success;
            options.success = function(m, resp, callbackOpts) {
                if (wait) collection.add(m, callbackOpts);
                if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
            };
            model.save(null, options);
            return model;
        },

        // **parse** converts a response into a list of models to be added to the
        // collection. The default implementation is just to pass it through.
        parse: function(resp, options) {
            return resp;
        },

        // Create a new collection with an identical list of models as this one.
        clone: function() {
            return new this.constructor(this.models, {
                model: this.model,
                comparator: this.comparator
            });
        },

        // Define how to uniquely identify models in the collection.
        modelId: function(attrs) {
            return attrs[this.model.prototype.idAttribute || 'id'];
        },

        // Private method to reset all internal state. Called when the collection
        // is first initialized or reset.
        _reset: function() {
            this.length = 0;
            this.models = [];
            this._byId  = {};
        },

        // Prepare a hash of attributes (or other model) to be added to this
        // collection.
        _prepareModel: function(attrs, options) {
            if (this._isModel(attrs)) {
                if (!attrs.collection) attrs.collection = this;
                return attrs;
            }
            options = options ? _.clone(options) : {};
            options.collection = this;
            var model = new this.model(attrs, options);
            if (!model.validationError) return model;
            this.trigger('invalid', this, model.validationError, options);
            return false;
        },

        // Internal method called by both remove and set.
        _removeModels: function(models, options) {
            var removed = [];
            for (var i = 0; i < models.length; i++) {
                var model = this.get(models[i]);
                if (!model) continue;

                var index = this.indexOf(model);
                this.models.splice(index, 1);
                this.length--;

                // Remove references before triggering 'remove' event to prevent an
                // infinite loop. #3693
                delete this._byId[model.cid];
                var id = this.modelId(model.attributes);
                if (id != null) delete this._byId[id];

                if (!options.silent) {
                    options.index = index;
                    model.trigger('remove', model, this, options);
                }

                removed.push(model);
                this._removeReference(model, options);
            }
            return removed;
        },

        // Method for checking whether an object should be considered a model for
        // the purposes of adding to the collection.
        _isModel: function(model) {
            return model instanceof Model;
        },

        // Internal method to create a model's ties to a collection.
        _addReference: function(model, options) {
            this._byId[model.cid] = model;
            var id = this.modelId(model.attributes);
            if (id != null) this._byId[id] = model;
            model.on('all', this._onModelEvent, this);
        },

        // Internal method to sever a model's ties to a collection.
        _removeReference: function(model, options) {
            delete this._byId[model.cid];
            var id = this.modelId(model.attributes);
            if (id != null) delete this._byId[id];
            if (this === model.collection) delete model.collection;
            model.off('all', this._onModelEvent, this);
        },

        // Internal method called every time a model in the set fires an event.
        // Sets need to update their indexes when models change ids. All other
        // events simply proxy through. "add" and "remove" events that originate
        // in other collections are ignored.
        _onModelEvent: function(event, model, collection, options) {
            if (model) {
                if ((event === 'add' || event === 'remove') && collection !== this) return;
                if (event === 'destroy') this.remove(model, options);
                if (event === 'change') {
                    var prevId = this.modelId(model.previousAttributes());
                    var id = this.modelId(model.attributes);
                    if (prevId !== id) {
                        if (prevId != null) delete this._byId[prevId];
                        if (id != null) this._byId[id] = model;
                    }
                }
            }
            this.trigger.apply(this, arguments);
        }

    });

    // Underscore methods that we want to implement on the Collection.
    // 90% of the core usefulness of Backbone Collections is actually implemented
    // right here:
    var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
        foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
        select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
        contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
        head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
        without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
        isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
        sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

    // Mix in each Underscore method as a proxy to `Collection#models`.
    addUnderscoreMethods(Collection, collectionMethods, 'models');

    // Backbone.View
    // -------------

    // Backbone Views are almost more convention than they are actual code. A View
    // is simply a JavaScript object that represents a logical chunk of UI in the
    // DOM. This might be a single item, an entire list, a sidebar or panel, or
    // even the surrounding frame which wraps your whole app. Defining a chunk of
    // UI as a **View** allows you to define your DOM events declaratively, without
    // having to worry about render order ... and makes it easy for the view to
    // react to specific changes in the state of your models.

    // Creating a Backbone.View creates its initial element outside of the DOM,
    // if an existing element is not provided...
    var View = Backbone.View = function(options) {
        this.cid = _.uniqueId('view');
        _.extend(this, _.pick(options, viewOptions));
        this._ensureElement();
        this.initialize.apply(this, arguments);
    };

    // Cached regex to split keys for `delegate`.
    var delegateEventSplitter = /^(\S+)\s*(.*)$/;

    // List of view options to be set as properties.
    var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

    // Set up all inheritable **Backbone.View** properties and methods.
    _.extend(View.prototype, Events, {

        // The default `tagName` of a View's element is `"div"`.
        tagName: 'div',

        // jQuery delegate for element lookup, scoped to DOM elements within the
        // current view. This should be preferred to global lookups where possible.
        $: function(selector) {
            return this.$el.find(selector);
        },

        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function(){},

        // **render** is the core function that your view should override, in order
        // to populate its element (`this.el`), with the appropriate HTML. The
        // convention is for **render** to always return `this`.
        render: function() {
            return this;
        },

        // Remove this view by taking the element out of the DOM, and removing any
        // applicable Backbone.Events listeners.
        remove: function() {
            this._removeElement();
            this.stopListening();
            return this;
        },

        // Remove this view's element from the document and all event listeners
        // attached to it. Exposed for subclasses using an alternative DOM
        // manipulation API.
        _removeElement: function() {
            this.$el.remove();
        },

        // Change the view's element (`this.el` property) and re-delegate the
        // view's events on the new element.
        setElement: function(element) {
            this.undelegateEvents();
            this._setElement(element);
            this.delegateEvents();
            return this;
        },

        // Creates the `this.el` and `this.$el` references for this view using the
        // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
        // context or an element. Subclasses can override this to utilize an
        // alternative DOM manipulation API and are only required to set the
        // `this.el` property.
        _setElement: function(el) {
            this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
            this.el = this.$el[0];
        },

        // Set callbacks, where `this.events` is a hash of
        //
        // *{"event selector": "callback"}*
        //
        //     {
        //       'mousedown .title':  'edit',
        //       'click .button':     'save',
        //       'click .open':       function(e) { ... }
        //     }
        //
        // pairs. Callbacks will be bound to the view, with `this` set properly.
        // Uses event delegation for efficiency.
        // Omitting the selector binds the event to `this.el`.
        delegateEvents: function(events) {
            events || (events = _.result(this, 'events'));
            if (!events) return this;
            this.undelegateEvents();
            for (var key in events) {
                var method = events[key];
                if (!_.isFunction(method)) method = this[method];
                if (!method) continue;
                var match = key.match(delegateEventSplitter);
                this.delegate(match[1], match[2], _.bind(method, this));
            }
            return this;
        },

        // Add a single event listener to the view's element (or a child element
        // using `selector`). This only works for delegate-able events: not `focus`,
        // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
        delegate: function(eventName, selector, listener) {
            this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
            return this;
        },

        // Clears all callbacks previously bound to the view by `delegateEvents`.
        // You usually don't need to use this, but may wish to if you have multiple
        // Backbone views attached to the same DOM element.
        undelegateEvents: function() {
            if (this.$el) this.$el.off('.delegateEvents' + this.cid);
            return this;
        },

        // A finer-grained `undelegateEvents` for removing a single delegated event.
        // `selector` and `listener` are both optional.
        undelegate: function(eventName, selector, listener) {
            this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
            return this;
        },

        // Produces a DOM element to be assigned to your view. Exposed for
        // subclasses using an alternative DOM manipulation API.
        _createElement: function(tagName) {
            return document.createElement(tagName);
        },

        // Ensure that the View has a DOM element to render into.
        // If `this.el` is a string, pass it through `$()`, take the first
        // matching element, and re-assign it to `el`. Otherwise, create
        // an element from the `id`, `className` and `tagName` properties.
        _ensureElement: function() {
            if (!this.el) {
                var attrs = _.extend({}, _.result(this, 'attributes'));
                if (this.id) attrs.id = _.result(this, 'id');
                if (this.className) attrs['class'] = _.result(this, 'className');
                this.setElement(this._createElement(_.result(this, 'tagName')));
                this._setAttributes(attrs);
            } else {
                this.setElement(_.result(this, 'el'));
            }
        },

        // Set attributes from a hash on this view's element.  Exposed for
        // subclasses using an alternative DOM manipulation API.
        _setAttributes: function(attributes) {
            this.$el.attr(attributes);
        }

    });

    // Backbone.sync
    // -------------

    // Override this function to change the manner in which Backbone persists
    // models to the server. You will be passed the type of request, and the
    // model in question. By default, makes a RESTful Ajax request
    // to the model's `url()`. Some possible customizations could be:
    //
    // * Use `setTimeout` to batch rapid-fire updates into a single request.
    // * Send up the models as XML instead of JSON.
    // * Persist models via WebSockets instead of Ajax.
    //
    // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
    // as `POST`, with a `_method` parameter containing the true HTTP method,
    // as well as all requests with the body as `application/x-www-form-urlencoded`
    // instead of `application/json` with the model in a param named `model`.
    // Useful when interfacing with server-side languages like **PHP** that make
    // it difficult to read the body of `PUT` requests.
    Backbone.sync = function(method, model, options) {
        var type = methodMap[method];

        // Default options, unless specified.
        _.defaults(options || (options = {}), {
            emulateHTTP: Backbone.emulateHTTP,
            emulateJSON: Backbone.emulateJSON
        });

        // Default JSON-request options.
        var params = {type: type, dataType: 'json'};

        // Ensure that we have a URL.
        if (!options.url) {
            params.url = _.result(model, 'url') || urlError();
        }

        // Ensure that we have the appropriate request data.
        if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
            params.contentType = 'application/json';
            params.data = JSON.stringify(options.attrs || model.toJSON(options));
        }

        // For older servers, emulate JSON by encoding the request into an HTML-form.
        if (options.emulateJSON) {
            params.contentType = 'application/x-www-form-urlencoded';
            params.data = params.data ? {model: params.data} : {};
        }

        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
        // And an `X-HTTP-Method-Override` header.
        if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
            params.type = 'POST';
            if (options.emulateJSON) params.data._method = type;
            var beforeSend = options.beforeSend;
            options.beforeSend = function(xhr) {
                xhr.setRequestHeader('X-HTTP-Method-Override', type);
                if (beforeSend) return beforeSend.apply(this, arguments);
            };
        }

        // Don't process data on a non-GET request.
        if (params.type !== 'GET' && !options.emulateJSON) {
            params.processData = false;
        }

        // Pass along `textStatus` and `errorThrown` from jQuery.
        var error = options.error;
        options.error = function(xhr, textStatus, errorThrown) {
            options.textStatus = textStatus;
            options.errorThrown = errorThrown;
            if (error) error.call(options.context, xhr, textStatus, errorThrown);
        };

        // Make the request, allowing the user to override any Ajax options.
        var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
        model.trigger('request', model, xhr, options);
        return xhr;
    };

    // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
    var methodMap = {
        'create': 'POST',
        'update': 'PUT',
        'patch': 'PATCH',
        'delete': 'DELETE',
        'read': 'GET'
    };

    // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
    // Override this if you'd like to use a different library.
    Backbone.ajax = function() {
        return Backbone.$.ajax.apply(Backbone.$, arguments);
    };

    // Backbone.Router
    // ---------------

    // Routers map faux-URLs to actions, and fire events when routes are
    // matched. Creating a new one sets its `routes` hash, if not set statically.
    var Router = Backbone.Router = function(options) {
        options || (options = {});
        if (options.routes) this.routes = options.routes;
        this._bindRoutes();
        this.initialize.apply(this, arguments);
    };

    // Cached regular expressions for matching named param parts and splatted
    // parts of route strings.
    var optionalParam = /\((.*?)\)/g;
    var namedParam    = /(\(\?)?:\w+/g;
    var splatParam    = /\*\w+/g;
    var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

    // Set up all inheritable **Backbone.Router** properties and methods.
    _.extend(Router.prototype, Events, {

        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function(){},

        // Manually bind a single named route to a callback. For example:
        //
        //     this.route('search/:query/p:num', 'search', function(query, num) {
        //       ...
        //     });
        //
        route: function(route, name, callback) {
            if (!_.isRegExp(route)) route = this._routeToRegExp(route);
            if (_.isFunction(name)) {
                callback = name;
                name = '';
            }
            if (!callback) callback = this[name];
            var router = this;
            Backbone.history.route(route, function(fragment) {
                var args = router._extractParameters(route, fragment);
                if (router.execute(callback, args, name) !== false) {
                    router.trigger.apply(router, ['route:' + name].concat(args));
                    router.trigger('route', name, args);
                    Backbone.history.trigger('route', router, name, args);
                }
            });
            return this;
        },

        // Execute a route handler with the provided parameters.  This is an
        // excellent place to do pre-route setup or post-route cleanup.
        execute: function(callback, args, name) {
            if (callback) callback.apply(this, args);
        },

        // Simple proxy to `Backbone.history` to save a fragment into the history.
        navigate: function(fragment, options) {
            Backbone.history.navigate(fragment, options);
            return this;
        },

        // Bind all defined routes to `Backbone.history`. We have to reverse the
        // order of the routes here to support behavior where the most general
        // routes can be defined at the bottom of the route map.
        _bindRoutes: function() {
            if (!this.routes) return;
            this.routes = _.result(this, 'routes');
            var route, routes = _.keys(this.routes);
            while ((route = routes.pop()) != null) {
                this.route(route, this.routes[route]);
            }
        },

        // Convert a route string into a regular expression, suitable for matching
        // against the current location hash.
        _routeToRegExp: function(route) {
            route = route.replace(escapeRegExp, '\\$&')
                .replace(optionalParam, '(?:$1)?')
                .replace(namedParam, function(match, optional) {
                    return optional ? match : '([^/?]+)';
                })
                .replace(splatParam, '([^?]*?)');
            return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
        },

        // Given a route, and a URL fragment that it matches, return the array of
        // extracted decoded parameters. Empty or unmatched parameters will be
        // treated as `null` to normalize cross-browser behavior.
        _extractParameters: function(route, fragment) {
            var params = route.exec(fragment).slice(1);
            return _.map(params, function(param, i) {
                // Don't decode the search params.
                if (i === params.length - 1) return param || null;
                return param ? decodeURIComponent(param) : null;
            });
        }

    });

    // Backbone.History
    // ----------------

    // Handles cross-browser history management, based on either
    // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
    // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
    // and URL fragments. If the browser supports neither (old IE, natch),
    // falls back to polling.
    var History = Backbone.History = function() {
        this.handlers = [];
        this.checkUrl = _.bind(this.checkUrl, this);

        // Ensure that `History` can be used outside of the browser.
        if (typeof window !== 'undefined') {
            this.location = window.location;
            this.history = window.history;
        }
    };

    // Cached regex for stripping a leading hash/slash and trailing space.
    var routeStripper = /^[#\/]|\s+$/g;

    // Cached regex for stripping leading and trailing slashes.
    var rootStripper = /^\/+|\/+$/g;

    // Cached regex for stripping urls of hash.
    var pathStripper = /#.*$/;

    // Has the history handling already been started?
    History.started = false;

    // Set up all inheritable **Backbone.History** properties and methods.
    _.extend(History.prototype, Events, {

        // The default interval to poll for hash changes, if necessary, is
        // twenty times a second.
        interval: 50,

        // Are we at the app root?
        atRoot: function() {
            var path = this.location.pathname.replace(/[^\/]$/, '$&/');
            return path === this.root && !this.getSearch();
        },

        // Does the pathname match the root?
        matchRoot: function() {
            var path = this.decodeFragment(this.location.pathname);
            var rootPath = path.slice(0, this.root.length - 1) + '/';
            return rootPath === this.root;
        },

        // Unicode characters in `location.pathname` are percent encoded so they're
        // decoded for comparison. `%25` should not be decoded since it may be part
        // of an encoded parameter.
        decodeFragment: function(fragment) {
            return decodeURI(fragment.replace(/%25/g, '%2525'));
        },

        // In IE6, the hash fragment and search params are incorrect if the
        // fragment contains `?`.
        getSearch: function() {
            var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
            return match ? match[0] : '';
        },

        // Gets the true hash value. Cannot use location.hash directly due to bug
        // in Firefox where location.hash will always be decoded.
        getHash: function(window) {
            var match = (window || this).location.href.match(/#(.*)$/);
            return match ? match[1] : '';
        },

        // Get the pathname and search params, without the root.
        getPath: function() {
            var path = this.decodeFragment(
                this.location.pathname + this.getSearch()
            ).slice(this.root.length - 1);
            return path.charAt(0) === '/' ? path.slice(1) : path;
        },

        // Get the cross-browser normalized URL fragment from the path or hash.
        getFragment: function(fragment) {
            if (fragment == null) {
                if (this._usePushState || !this._wantsHashChange) {
                    fragment = this.getPath();
                } else {
                    fragment = this.getHash();
                }
            }
            return fragment.replace(routeStripper, '');
        },

        // Start the hash change handling, returning `true` if the current URL matches
        // an existing route, and `false` otherwise.
        start: function(options) {
            if (History.started) throw new Error('Backbone.history has already been started');
            History.started = true;

            // Figure out the initial configuration. Do we need an iframe?
            // Is pushState desired ... is it available?
            this.options          = _.extend({root: '/'}, this.options, options);
            this.root             = this.options.root;
            this._wantsHashChange = this.options.hashChange !== false;
            this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
            this._useHashChange   = this._wantsHashChange && this._hasHashChange;
            this._wantsPushState  = !!this.options.pushState;
            this._hasPushState    = !!(this.history && this.history.pushState);
            this._usePushState    = this._wantsPushState && this._hasPushState;
            this.fragment         = this.getFragment();

            // Normalize root to always include a leading and trailing slash.
            this.root = ('/' + this.root + '/').replace(rootStripper, '/');

            // Transition from hashChange to pushState or vice versa if both are
            // requested.
            if (this._wantsHashChange && this._wantsPushState) {

                // If we've started off with a route from a `pushState`-enabled
                // browser, but we're currently in a browser that doesn't support it...
                if (!this._hasPushState && !this.atRoot()) {
                    var rootPath = this.root.slice(0, -1) || '/';
                    this.location.replace(rootPath + '#' + this.getPath());
                    // Return immediately as browser will do redirect to new url
                    return true;

                    // Or if we've started out with a hash-based route, but we're currently
                    // in a browser where it could be `pushState`-based instead...
                } else if (this._hasPushState && this.atRoot()) {
                    this.navigate(this.getHash(), {replace: true});
                }

            }

            // Proxy an iframe to handle location events if the browser doesn't
            // support the `hashchange` event, HTML5 history, or the user wants
            // `hashChange` but not `pushState`.
            if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                this.iframe = document.createElement('iframe');
                this.iframe.src = 'javascript:0';
                this.iframe.style.display = 'none';
                this.iframe.tabIndex = -1;
                var body = document.body;
                // Using `appendChild` will throw on IE < 9 if the document is not ready.
                var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
                iWindow.document.open();
                iWindow.document.close();
                iWindow.location.hash = '#' + this.fragment;
            }

            // Add a cross-platform `addEventListener` shim for older browsers.
            var addEventListener = window.addEventListener || function(eventName, listener) {
                return attachEvent('on' + eventName, listener);
            };

            // Depending on whether we're using pushState or hashes, and whether
            // 'onhashchange' is supported, determine how we check the URL state.
            if (this._usePushState) {
                addEventListener('popstate', this.checkUrl, false);
            } else if (this._useHashChange && !this.iframe) {
                addEventListener('hashchange', this.checkUrl, false);
            } else if (this._wantsHashChange) {
                this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
            }

            if (!this.options.silent) return this.loadUrl();
        },

        // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
        // but possibly useful for unit testing Routers.
        stop: function() {
            // Add a cross-platform `removeEventListener` shim for older browsers.
            var removeEventListener = window.removeEventListener || function(eventName, listener) {
                return detachEvent('on' + eventName, listener);
            };

            // Remove window listeners.
            if (this._usePushState) {
                removeEventListener('popstate', this.checkUrl, false);
            } else if (this._useHashChange && !this.iframe) {
                removeEventListener('hashchange', this.checkUrl, false);
            }

            // Clean up the iframe if necessary.
            if (this.iframe) {
                document.body.removeChild(this.iframe);
                this.iframe = null;
            }

            // Some environments will throw when clearing an undefined interval.
            if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
            History.started = false;
        },

        // Add a route to be tested when the fragment changes. Routes added later
        // may override previous routes.
        route: function(route, callback) {
            this.handlers.unshift({route: route, callback: callback});
        },

        // Checks the current URL to see if it has changed, and if it has,
        // calls `loadUrl`, normalizing across the hidden iframe.
        checkUrl: function(e) {
            var current = this.getFragment();

            // If the user pressed the back button, the iframe's hash will have
            // changed and we should use that for comparison.
            if (current === this.fragment && this.iframe) {
                current = this.getHash(this.iframe.contentWindow);
            }

            if (current === this.fragment) return false;
            if (this.iframe) this.navigate(current);
            this.loadUrl();
        },

        // Attempt to load the current URL fragment. If a route succeeds with a
        // match, returns `true`. If no defined routes matches the fragment,
        // returns `false`.
        loadUrl: function(fragment) {
            // If the root doesn't match, no routes can match either.
            if (!this.matchRoot()) return false;
            fragment = this.fragment = this.getFragment(fragment);
            return _.some(this.handlers, function(handler) {
                if (handler.route.test(fragment)) {
                    handler.callback(fragment);
                    return true;
                }
            });
        },

        // Save a fragment into the hash history, or replace the URL state if the
        // 'replace' option is passed. You are responsible for properly URL-encoding
        // the fragment in advance.
        //
        // The options object can contain `trigger: true` if you wish to have the
        // route callback be fired (not usually desirable), or `replace: true`, if
        // you wish to modify the current URL without adding an entry to the history.
        navigate: function(fragment, options) {
            if (!History.started) return false;
            if (!options || options === true) options = {trigger: !!options};

            // Normalize the fragment.
            fragment = this.getFragment(fragment || '');

            // Don't include a trailing slash on the root.
            var rootPath = this.root;
            if (fragment === '' || fragment.charAt(0) === '?') {
                rootPath = rootPath.slice(0, -1) || '/';
            }
            var url = rootPath + fragment;

            // Strip the hash and decode for matching.
            fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

            if (this.fragment === fragment) return;
            this.fragment = fragment;

            // If pushState is available, we use it to set the fragment as a real URL.
            if (this._usePushState) {
                this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

                // If hash changes haven't been explicitly disabled, update the hash
                // fragment to store history.
            } else if (this._wantsHashChange) {
                this._updateHash(this.location, fragment, options.replace);
                if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
                    var iWindow = this.iframe.contentWindow;

                    // Opening and closing the iframe tricks IE7 and earlier to push a
                    // history entry on hash-tag change.  When replace is true, we don't
                    // want this.
                    if (!options.replace) {
                        iWindow.document.open();
                        iWindow.document.close();
                    }

                    this._updateHash(iWindow.location, fragment, options.replace);
                }

                // If you've told us that you explicitly don't want fallback hashchange-
                // based history, then `navigate` becomes a page refresh.
            } else {
                return this.location.assign(url);
            }
            if (options.trigger) return this.loadUrl(fragment);
        },

        // Update the hash location, either replacing the current entry, or adding
        // a new one to the browser history.
        _updateHash: function(location, fragment, replace) {
            if (replace) {
                var href = location.href.replace(/(javascript:|#).*$/, '');
                location.replace(href + '#' + fragment);
            } else {
                // Some browsers require that `hash` contains a leading #.
                location.hash = '#' + fragment;
            }
        }

    });

    // Create the default Backbone.history.
    Backbone.history = new History;

    // Helpers
    // -------

    // Helper function to correctly set up the prototype chain for subclasses.
    // Similar to `goog.inherits`, but uses a hash of prototype properties and
    // class properties to be extended.
    var extend = function(protoProps, staticProps) {
        var parent = this;
        var child;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent constructor.
        if (protoProps && _.has(protoProps, 'constructor')) {
            child = protoProps.constructor;
        } else {
            child = function(){ return parent.apply(this, arguments); };
        }

        // Add static properties to the constructor function, if supplied.
        _.extend(child, parent, staticProps);

        // Set the prototype chain to inherit from `parent`, without calling
        // `parent`'s constructor function and add the prototype properties.
        child.prototype = _.create(parent.prototype, protoProps);
        child.prototype.constructor = child;

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;

        return child;
    };

    // Set up inheritance for the model, collection, router, view and history.
    Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

    // Throw an error when a URL is needed, and none is supplied.
    var urlError = function() {
        throw new Error('A "url" property or function must be specified');
    };

    // Wrap an optional error callback with a fallback error event.
    var wrapError = function(model, options) {
        var error = options.error;
        options.error = function(resp) {
            if (error) error.call(options.context, model, resp, options);
            model.trigger('error', model, resp, options);
        };
    };

    return Backbone;
});; /** ----------------- **/ 
 /**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.3
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Popper = factory());
}(this, (function () { 'use strict';

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && parent.nodeName === 'HTML') {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

return Popper;

})));
//# sourceMappingURL=popper.js.map
; /** ----------------- **/ 
 /*!
  * Bootstrap v4.1.2 (https://getbootstrap.com/)
  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery'), require('popper.js')) :
        typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
            (factory((global.bootstrap = {}),global.jQuery,global.Popper));
}(this, (function (exports,$,Popper) { 'use strict';

    $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
    Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);

            if (typeof Object.getOwnPropertySymbols === 'function') {
                ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }));
            }

            ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        }

        return target;
    }

    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): util.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Util = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Private TransitionEnd Helpers
         * ------------------------------------------------------------------------
         */
        var TRANSITION_END = 'transitionend';
        var MAX_UID = 1000000;
        var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

        function toType(obj) {
            return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
        }

        function getSpecialTransitionEndEvent() {
            return {
                bindType: TRANSITION_END,
                delegateType: TRANSITION_END,
                handle: function handle(event) {
                    if ($$$1(event.target).is(this)) {
                        return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                    }

                    return undefined; // eslint-disable-line no-undefined
                }
            };
        }

        function transitionEndEmulator(duration) {
            var _this = this;

            var called = false;
            $$$1(this).one(Util.TRANSITION_END, function () {
                called = true;
            });
            setTimeout(function () {
                if (!called) {
                    Util.triggerTransitionEnd(_this);
                }
            }, duration);
            return this;
        }

        function setTransitionEndSupport() {
            $$$1.fn.emulateTransitionEnd = transitionEndEmulator;
            $$$1.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
        }
        /**
         * --------------------------------------------------------------------------
         * Public Util Api
         * --------------------------------------------------------------------------
         */


        var Util = {
            TRANSITION_END: 'bsTransitionEnd',
            getUID: function getUID(prefix) {
                do {
                    // eslint-disable-next-line no-bitwise
                    prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
                } while (document.getElementById(prefix));

                return prefix;
            },
            getSelectorFromElement: function getSelectorFromElement(element) {
                var selector = element.getAttribute('data-target');

                if (!selector || selector === '#') {
                    selector = element.getAttribute('href') || '';
                }

                try {
                    return document.querySelector(selector) ? selector : null;
                } catch (err) {
                    return null;
                }
            },
            getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
                if (!element) {
                    return 0;
                } // Get transition-duration of the element


                var transitionDuration = $$$1(element).css('transition-duration');
                var floatTransitionDuration = parseFloat(transitionDuration); // Return 0 if element or transition duration is not found

                if (!floatTransitionDuration) {
                    return 0;
                } // If multiple durations are defined, take the first


                transitionDuration = transitionDuration.split(',')[0];
                return parseFloat(transitionDuration) * MILLISECONDS_MULTIPLIER;
            },
            reflow: function reflow(element) {
                return element.offsetHeight;
            },
            triggerTransitionEnd: function triggerTransitionEnd(element) {
                $$$1(element).trigger(TRANSITION_END);
            },
            // TODO: Remove in v5
            supportsTransitionEnd: function supportsTransitionEnd() {
                return Boolean(TRANSITION_END);
            },
            isElement: function isElement(obj) {
                return (obj[0] || obj).nodeType;
            },
            typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
                for (var property in configTypes) {
                    if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                        var expectedTypes = configTypes[property];
                        var value = config[property];
                        var valueType = value && Util.isElement(value) ? 'element' : toType(value);

                        if (!new RegExp(expectedTypes).test(valueType)) {
                            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
                        }
                    }
                }
            }
        };
        setTransitionEndSupport();
        return Util;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): alert.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Alert = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'alert';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.alert';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var Selector = {
            DISMISS: '[data-dismiss="alert"]'
        };
        var Event = {
            CLOSE: "close" + EVENT_KEY,
            CLOSED: "closed" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            ALERT: 'alert',
            FADE: 'fade',
            SHOW: 'show'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Alert =
            /*#__PURE__*/
            function () {
                function Alert(element) {
                    this._element = element;
                } // Getters


                var _proto = Alert.prototype;

                // Public
                _proto.close = function close(element) {
                    var rootElement = this._element;

                    if (element) {
                        rootElement = this._getRootElement(element);
                    }

                    var customEvent = this._triggerCloseEvent(rootElement);

                    if (customEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._removeElement(rootElement);
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Private


                _proto._getRootElement = function _getRootElement(element) {
                    var selector = Util.getSelectorFromElement(element);
                    var parent = false;

                    if (selector) {
                        parent = document.querySelector(selector);
                    }

                    if (!parent) {
                        parent = $$$1(element).closest("." + ClassName.ALERT)[0];
                    }

                    return parent;
                };

                _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
                    var closeEvent = $$$1.Event(Event.CLOSE);
                    $$$1(element).trigger(closeEvent);
                    return closeEvent;
                };

                _proto._removeElement = function _removeElement(element) {
                    var _this = this;

                    $$$1(element).removeClass(ClassName.SHOW);

                    if (!$$$1(element).hasClass(ClassName.FADE)) {
                        this._destroyElement(element);

                        return;
                    }

                    var transitionDuration = Util.getTransitionDurationFromElement(element);
                    $$$1(element).one(Util.TRANSITION_END, function (event) {
                        return _this._destroyElement(element, event);
                    }).emulateTransitionEnd(transitionDuration);
                };

                _proto._destroyElement = function _destroyElement(element) {
                    $$$1(element).detach().trigger(Event.CLOSED).remove();
                }; // Static


                Alert._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Alert(this);
                            $element.data(DATA_KEY, data);
                        }

                        if (config === 'close') {
                            data[config](this);
                        }
                    });
                };

                Alert._handleDismiss = function _handleDismiss(alertInstance) {
                    return function (event) {
                        if (event) {
                            event.preventDefault();
                        }

                        alertInstance.close(this);
                    };
                };

                _createClass(Alert, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Alert;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Alert._jQueryInterface;
        $$$1.fn[NAME].Constructor = Alert;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Alert._jQueryInterface;
        };

        return Alert;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): button.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Button = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'button';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.button';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ClassName = {
            ACTIVE: 'active',
            BUTTON: 'btn',
            FOCUS: 'focus'
        };
        var Selector = {
            DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
            DATA_TOGGLE: '[data-toggle="buttons"]',
            INPUT: 'input',
            ACTIVE: '.active',
            BUTTON: '.btn'
        };
        var Event = {
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
            FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Button =
            /*#__PURE__*/
            function () {
                function Button(element) {
                    this._element = element;
                } // Getters


                var _proto = Button.prototype;

                // Public
                _proto.toggle = function toggle() {
                    var triggerChangeEvent = true;
                    var addAriaPressed = true;
                    var rootElement = $$$1(this._element).closest(Selector.DATA_TOGGLE)[0];

                    if (rootElement) {
                        var input = this._element.querySelector(Selector.INPUT);

                        if (input) {
                            if (input.type === 'radio') {
                                if (input.checked && this._element.classList.contains(ClassName.ACTIVE)) {
                                    triggerChangeEvent = false;
                                } else {
                                    var activeElement = rootElement.querySelector(Selector.ACTIVE);

                                    if (activeElement) {
                                        $$$1(activeElement).removeClass(ClassName.ACTIVE);
                                    }
                                }
                            }

                            if (triggerChangeEvent) {
                                if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
                                    return;
                                }

                                input.checked = !this._element.classList.contains(ClassName.ACTIVE);
                                $$$1(input).trigger('change');
                            }

                            input.focus();
                            addAriaPressed = false;
                        }
                    }

                    if (addAriaPressed) {
                        this._element.setAttribute('aria-pressed', !this._element.classList.contains(ClassName.ACTIVE));
                    }

                    if (triggerChangeEvent) {
                        $$$1(this._element).toggleClass(ClassName.ACTIVE);
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Static


                Button._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        if (!data) {
                            data = new Button(this);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (config === 'toggle') {
                            data[config]();
                        }
                    });
                };

                _createClass(Button, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Button;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
            event.preventDefault();
            var button = event.target;

            if (!$$$1(button).hasClass(ClassName.BUTTON)) {
                button = $$$1(button).closest(Selector.BUTTON);
            }

            Button._jQueryInterface.call($$$1(button), 'toggle');
        }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
            var button = $$$1(event.target).closest(Selector.BUTTON)[0];
            $$$1(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Button._jQueryInterface;
        $$$1.fn[NAME].Constructor = Button;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Button._jQueryInterface;
        };

        return Button;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): carousel.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Carousel = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'carousel';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.carousel';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

        var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

        var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

        var Default = {
            interval: 5000,
            keyboard: true,
            slide: false,
            pause: 'hover',
            wrap: true
        };
        var DefaultType = {
            interval: '(number|boolean)',
            keyboard: 'boolean',
            slide: '(boolean|string)',
            pause: '(string|boolean)',
            wrap: 'boolean'
        };
        var Direction = {
            NEXT: 'next',
            PREV: 'prev',
            LEFT: 'left',
            RIGHT: 'right'
        };
        var Event = {
            SLIDE: "slide" + EVENT_KEY,
            SLID: "slid" + EVENT_KEY,
            KEYDOWN: "keydown" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY,
            TOUCHEND: "touchend" + EVENT_KEY,
            LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            CAROUSEL: 'carousel',
            ACTIVE: 'active',
            SLIDE: 'slide',
            RIGHT: 'carousel-item-right',
            LEFT: 'carousel-item-left',
            NEXT: 'carousel-item-next',
            PREV: 'carousel-item-prev',
            ITEM: 'carousel-item'
        };
        var Selector = {
            ACTIVE: '.active',
            ACTIVE_ITEM: '.active.carousel-item',
            ITEM: '.carousel-item',
            NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
            INDICATORS: '.carousel-indicators',
            DATA_SLIDE: '[data-slide], [data-slide-to]',
            DATA_RIDE: '[data-ride="carousel"]'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Carousel =
            /*#__PURE__*/
            function () {
                function Carousel(element, config) {
                    this._items = null;
                    this._interval = null;
                    this._activeElement = null;
                    this._isPaused = false;
                    this._isSliding = false;
                    this.touchTimeout = null;
                    this._config = this._getConfig(config);
                    this._element = $$$1(element)[0];
                    this._indicatorsElement = this._element.querySelector(Selector.INDICATORS);

                    this._addEventListeners();
                } // Getters


                var _proto = Carousel.prototype;

                // Public
                _proto.next = function next() {
                    if (!this._isSliding) {
                        this._slide(Direction.NEXT);
                    }
                };

                _proto.nextWhenVisible = function nextWhenVisible() {
                    // Don't call next when the page isn't visible
                    // or the carousel or its parent isn't visible
                    if (!document.hidden && $$$1(this._element).is(':visible') && $$$1(this._element).css('visibility') !== 'hidden') {
                        this.next();
                    }
                };

                _proto.prev = function prev() {
                    if (!this._isSliding) {
                        this._slide(Direction.PREV);
                    }
                };

                _proto.pause = function pause(event) {
                    if (!event) {
                        this._isPaused = true;
                    }

                    if (this._element.querySelector(Selector.NEXT_PREV)) {
                        Util.triggerTransitionEnd(this._element);
                        this.cycle(true);
                    }

                    clearInterval(this._interval);
                    this._interval = null;
                };

                _proto.cycle = function cycle(event) {
                    if (!event) {
                        this._isPaused = false;
                    }

                    if (this._interval) {
                        clearInterval(this._interval);
                        this._interval = null;
                    }

                    if (this._config.interval && !this._isPaused) {
                        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
                    }
                };

                _proto.to = function to(index) {
                    var _this = this;

                    this._activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

                    var activeIndex = this._getItemIndex(this._activeElement);

                    if (index > this._items.length - 1 || index < 0) {
                        return;
                    }

                    if (this._isSliding) {
                        $$$1(this._element).one(Event.SLID, function () {
                            return _this.to(index);
                        });
                        return;
                    }

                    if (activeIndex === index) {
                        this.pause();
                        this.cycle();
                        return;
                    }

                    var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

                    this._slide(direction, this._items[index]);
                };

                _proto.dispose = function dispose() {
                    $$$1(this._element).off(EVENT_KEY);
                    $$$1.removeData(this._element, DATA_KEY);
                    this._items = null;
                    this._config = null;
                    this._element = null;
                    this._interval = null;
                    this._isPaused = null;
                    this._isSliding = null;
                    this._activeElement = null;
                    this._indicatorsElement = null;
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, Default, config);
                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._addEventListeners = function _addEventListeners() {
                    var _this2 = this;

                    if (this._config.keyboard) {
                        $$$1(this._element).on(Event.KEYDOWN, function (event) {
                            return _this2._keydown(event);
                        });
                    }

                    if (this._config.pause === 'hover') {
                        $$$1(this._element).on(Event.MOUSEENTER, function (event) {
                            return _this2.pause(event);
                        }).on(Event.MOUSELEAVE, function (event) {
                            return _this2.cycle(event);
                        });

                        if ('ontouchstart' in document.documentElement) {
                            // If it's a touch-enabled device, mouseenter/leave are fired as
                            // part of the mouse compatibility events on first tap - the carousel
                            // would stop cycling until user tapped out of it;
                            // here, we listen for touchend, explicitly pause the carousel
                            // (as if it's the second time we tap on it, mouseenter compat event
                            // is NOT fired) and after a timeout (to allow for mouse compatibility
                            // events to fire) we explicitly restart cycling
                            $$$1(this._element).on(Event.TOUCHEND, function () {
                                _this2.pause();

                                if (_this2.touchTimeout) {
                                    clearTimeout(_this2.touchTimeout);
                                }

                                _this2.touchTimeout = setTimeout(function (event) {
                                    return _this2.cycle(event);
                                }, TOUCHEVENT_COMPAT_WAIT + _this2._config.interval);
                            });
                        }
                    }
                };

                _proto._keydown = function _keydown(event) {
                    if (/input|textarea/i.test(event.target.tagName)) {
                        return;
                    }

                    switch (event.which) {
                        case ARROW_LEFT_KEYCODE:
                            event.preventDefault();
                            this.prev();
                            break;

                        case ARROW_RIGHT_KEYCODE:
                            event.preventDefault();
                            this.next();
                            break;

                        default:
                    }
                };

                _proto._getItemIndex = function _getItemIndex(element) {
                    this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(Selector.ITEM)) : [];
                    return this._items.indexOf(element);
                };

                _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
                    var isNextDirection = direction === Direction.NEXT;
                    var isPrevDirection = direction === Direction.PREV;

                    var activeIndex = this._getItemIndex(activeElement);

                    var lastItemIndex = this._items.length - 1;
                    var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

                    if (isGoingToWrap && !this._config.wrap) {
                        return activeElement;
                    }

                    var delta = direction === Direction.PREV ? -1 : 1;
                    var itemIndex = (activeIndex + delta) % this._items.length;
                    return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
                };

                _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
                    var targetIndex = this._getItemIndex(relatedTarget);

                    var fromIndex = this._getItemIndex(this._element.querySelector(Selector.ACTIVE_ITEM));

                    var slideEvent = $$$1.Event(Event.SLIDE, {
                        relatedTarget: relatedTarget,
                        direction: eventDirectionName,
                        from: fromIndex,
                        to: targetIndex
                    });
                    $$$1(this._element).trigger(slideEvent);
                    return slideEvent;
                };

                _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
                    if (this._indicatorsElement) {
                        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(Selector.ACTIVE));
                        $$$1(indicators).removeClass(ClassName.ACTIVE);

                        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

                        if (nextIndicator) {
                            $$$1(nextIndicator).addClass(ClassName.ACTIVE);
                        }
                    }
                };

                _proto._slide = function _slide(direction, element) {
                    var _this3 = this;

                    var activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

                    var activeElementIndex = this._getItemIndex(activeElement);

                    var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

                    var nextElementIndex = this._getItemIndex(nextElement);

                    var isCycling = Boolean(this._interval);
                    var directionalClassName;
                    var orderClassName;
                    var eventDirectionName;

                    if (direction === Direction.NEXT) {
                        directionalClassName = ClassName.LEFT;
                        orderClassName = ClassName.NEXT;
                        eventDirectionName = Direction.LEFT;
                    } else {
                        directionalClassName = ClassName.RIGHT;
                        orderClassName = ClassName.PREV;
                        eventDirectionName = Direction.RIGHT;
                    }

                    if (nextElement && $$$1(nextElement).hasClass(ClassName.ACTIVE)) {
                        this._isSliding = false;
                        return;
                    }

                    var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

                    if (slideEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (!activeElement || !nextElement) {
                        // Some weirdness is happening, so we bail
                        return;
                    }

                    this._isSliding = true;

                    if (isCycling) {
                        this.pause();
                    }

                    this._setActiveIndicatorElement(nextElement);

                    var slidEvent = $$$1.Event(Event.SLID, {
                        relatedTarget: nextElement,
                        direction: eventDirectionName,
                        from: activeElementIndex,
                        to: nextElementIndex
                    });

                    if ($$$1(this._element).hasClass(ClassName.SLIDE)) {
                        $$$1(nextElement).addClass(orderClassName);
                        Util.reflow(nextElement);
                        $$$1(activeElement).addClass(directionalClassName);
                        $$$1(nextElement).addClass(directionalClassName);
                        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                        $$$1(activeElement).one(Util.TRANSITION_END, function () {
                            $$$1(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
                            $$$1(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
                            _this3._isSliding = false;
                            setTimeout(function () {
                                return $$$1(_this3._element).trigger(slidEvent);
                            }, 0);
                        }).emulateTransitionEnd(transitionDuration);
                    } else {
                        $$$1(activeElement).removeClass(ClassName.ACTIVE);
                        $$$1(nextElement).addClass(ClassName.ACTIVE);
                        this._isSliding = false;
                        $$$1(this._element).trigger(slidEvent);
                    }

                    if (isCycling) {
                        this.cycle();
                    }
                }; // Static


                Carousel._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = _objectSpread({}, Default, $$$1(this).data());

                        if (typeof config === 'object') {
                            _config = _objectSpread({}, _config, config);
                        }

                        var action = typeof config === 'string' ? config : _config.slide;

                        if (!data) {
                            data = new Carousel(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'number') {
                            data.to(config);
                        } else if (typeof action === 'string') {
                            if (typeof data[action] === 'undefined') {
                                throw new TypeError("No method named \"" + action + "\"");
                            }

                            data[action]();
                        } else if (_config.interval) {
                            data.pause();
                            data.cycle();
                        }
                    });
                };

                Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
                    var selector = Util.getSelectorFromElement(this);

                    if (!selector) {
                        return;
                    }

                    var target = $$$1(selector)[0];

                    if (!target || !$$$1(target).hasClass(ClassName.CAROUSEL)) {
                        return;
                    }

                    var config = _objectSpread({}, $$$1(target).data(), $$$1(this).data());

                    var slideIndex = this.getAttribute('data-slide-to');

                    if (slideIndex) {
                        config.interval = false;
                    }

                    Carousel._jQueryInterface.call($$$1(target), config);

                    if (slideIndex) {
                        $$$1(target).data(DATA_KEY).to(slideIndex);
                    }

                    event.preventDefault();
                };

                _createClass(Carousel, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Carousel;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
        $$$1(window).on(Event.LOAD_DATA_API, function () {
            var carousels = [].slice.call(document.querySelectorAll(Selector.DATA_RIDE));

            for (var i = 0, len = carousels.length; i < len; i++) {
                var $carousel = $$$1(carousels[i]);

                Carousel._jQueryInterface.call($carousel, $carousel.data());
            }
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Carousel._jQueryInterface;
        $$$1.fn[NAME].Constructor = Carousel;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Carousel._jQueryInterface;
        };

        return Carousel;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): collapse.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Collapse = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'collapse';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.collapse';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var Default = {
            toggle: true,
            parent: ''
        };
        var DefaultType = {
            toggle: 'boolean',
            parent: '(string|element)'
        };
        var Event = {
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            SHOW: 'show',
            COLLAPSE: 'collapse',
            COLLAPSING: 'collapsing',
            COLLAPSED: 'collapsed'
        };
        var Dimension = {
            WIDTH: 'width',
            HEIGHT: 'height'
        };
        var Selector = {
            ACTIVES: '.show, .collapsing',
            DATA_TOGGLE: '[data-toggle="collapse"]'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Collapse =
            /*#__PURE__*/
            function () {
                function Collapse(element, config) {
                    this._isTransitioning = false;
                    this._element = element;
                    this._config = this._getConfig(config);
                    this._triggerArray = $$$1.makeArray(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
                    var toggleList = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));

                    for (var i = 0, len = toggleList.length; i < len; i++) {
                        var elem = toggleList[i];
                        var selector = Util.getSelectorFromElement(elem);
                        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
                            return foundElem === element;
                        });

                        if (selector !== null && filterElement.length > 0) {
                            this._selector = selector;

                            this._triggerArray.push(elem);
                        }
                    }

                    this._parent = this._config.parent ? this._getParent() : null;

                    if (!this._config.parent) {
                        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
                    }

                    if (this._config.toggle) {
                        this.toggle();
                    }
                } // Getters


                var _proto = Collapse.prototype;

                // Public
                _proto.toggle = function toggle() {
                    if ($$$1(this._element).hasClass(ClassName.SHOW)) {
                        this.hide();
                    } else {
                        this.show();
                    }
                };

                _proto.show = function show() {
                    var _this = this;

                    if (this._isTransitioning || $$$1(this._element).hasClass(ClassName.SHOW)) {
                        return;
                    }

                    var actives;
                    var activesData;

                    if (this._parent) {
                        actives = [].slice.call(this._parent.querySelectorAll(Selector.ACTIVES)).filter(function (elem) {
                            return elem.getAttribute('data-parent') === _this._config.parent;
                        });

                        if (actives.length === 0) {
                            actives = null;
                        }
                    }

                    if (actives) {
                        activesData = $$$1(actives).not(this._selector).data(DATA_KEY);

                        if (activesData && activesData._isTransitioning) {
                            return;
                        }
                    }

                    var startEvent = $$$1.Event(Event.SHOW);
                    $$$1(this._element).trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (actives) {
                        Collapse._jQueryInterface.call($$$1(actives).not(this._selector), 'hide');

                        if (!activesData) {
                            $$$1(actives).data(DATA_KEY, null);
                        }
                    }

                    var dimension = this._getDimension();

                    $$$1(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
                    this._element.style[dimension] = 0;

                    if (this._triggerArray.length) {
                        $$$1(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
                    }

                    this.setTransitioning(true);

                    var complete = function complete() {
                        $$$1(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
                        _this._element.style[dimension] = '';

                        _this.setTransitioning(false);

                        $$$1(_this._element).trigger(Event.SHOWN);
                    };

                    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                    var scrollSize = "scroll" + capitalizedDimension;
                    var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                    $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                    this._element.style[dimension] = this._element[scrollSize] + "px";
                };

                _proto.hide = function hide() {
                    var _this2 = this;

                    if (this._isTransitioning || !$$$1(this._element).hasClass(ClassName.SHOW)) {
                        return;
                    }

                    var startEvent = $$$1.Event(Event.HIDE);
                    $$$1(this._element).trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    var dimension = this._getDimension();

                    this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
                    Util.reflow(this._element);
                    $$$1(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
                    var triggerArrayLength = this._triggerArray.length;

                    if (triggerArrayLength > 0) {
                        for (var i = 0; i < triggerArrayLength; i++) {
                            var trigger = this._triggerArray[i];
                            var selector = Util.getSelectorFromElement(trigger);

                            if (selector !== null) {
                                var $elem = $$$1([].slice.call(document.querySelectorAll(selector)));

                                if (!$elem.hasClass(ClassName.SHOW)) {
                                    $$$1(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
                                }
                            }
                        }
                    }

                    this.setTransitioning(true);

                    var complete = function complete() {
                        _this2.setTransitioning(false);

                        $$$1(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
                    };

                    this._element.style[dimension] = '';
                    var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                    $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                };

                _proto.setTransitioning = function setTransitioning(isTransitioning) {
                    this._isTransitioning = isTransitioning;
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._config = null;
                    this._parent = null;
                    this._element = null;
                    this._triggerArray = null;
                    this._isTransitioning = null;
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, Default, config);
                    config.toggle = Boolean(config.toggle); // Coerce string values

                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._getDimension = function _getDimension() {
                    var hasWidth = $$$1(this._element).hasClass(Dimension.WIDTH);
                    return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
                };

                _proto._getParent = function _getParent() {
                    var _this3 = this;

                    var parent = null;

                    if (Util.isElement(this._config.parent)) {
                        parent = this._config.parent; // It's a jQuery object

                        if (typeof this._config.parent.jquery !== 'undefined') {
                            parent = this._config.parent[0];
                        }
                    } else {
                        parent = document.querySelector(this._config.parent);
                    }

                    var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
                    var children = [].slice.call(parent.querySelectorAll(selector));
                    $$$1(children).each(function (i, element) {
                        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
                    });
                    return parent;
                };

                _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
                    if (element) {
                        var isOpen = $$$1(element).hasClass(ClassName.SHOW);

                        if (triggerArray.length) {
                            $$$1(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
                        }
                    }
                }; // Static


                Collapse._getTargetFromElement = function _getTargetFromElement(element) {
                    var selector = Util.getSelectorFromElement(element);
                    return selector ? document.querySelector(selector) : null;
                };

                Collapse._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var $this = $$$1(this);
                        var data = $this.data(DATA_KEY);

                        var _config = _objectSpread({}, Default, $this.data(), typeof config === 'object' && config ? config : {});

                        if (!data && _config.toggle && /show|hide/.test(config)) {
                            _config.toggle = false;
                        }

                        if (!data) {
                            data = new Collapse(this, _config);
                            $this.data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Collapse, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Collapse;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
            // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
            if (event.currentTarget.tagName === 'A') {
                event.preventDefault();
            }

            var $trigger = $$$1(this);
            var selector = Util.getSelectorFromElement(this);
            var selectors = [].slice.call(document.querySelectorAll(selector));
            $$$1(selectors).each(function () {
                var $target = $$$1(this);
                var data = $target.data(DATA_KEY);
                var config = data ? 'toggle' : $trigger.data();

                Collapse._jQueryInterface.call($target, config);
            });
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Collapse._jQueryInterface;
        $$$1.fn[NAME].Constructor = Collapse;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Collapse._jQueryInterface;
        };

        return Collapse;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): dropdown.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Dropdown = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'dropdown';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.dropdown';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

        var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

        var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

        var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

        var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

        var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

        var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
            KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
            KEYUP_DATA_API: "keyup" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            DISABLED: 'disabled',
            SHOW: 'show',
            DROPUP: 'dropup',
            DROPRIGHT: 'dropright',
            DROPLEFT: 'dropleft',
            MENURIGHT: 'dropdown-menu-right',
            MENULEFT: 'dropdown-menu-left',
            POSITION_STATIC: 'position-static'
        };
        var Selector = {
            DATA_TOGGLE: '[data-toggle="dropdown"]',
            FORM_CHILD: '.dropdown form',
            MENU: '.dropdown-menu',
            NAVBAR_NAV: '.navbar-nav',
            VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
        };
        var AttachmentMap = {
            TOP: 'top-start',
            TOPEND: 'top-end',
            BOTTOM: 'bottom-start',
            BOTTOMEND: 'bottom-end',
            RIGHT: 'right-start',
            RIGHTEND: 'right-end',
            LEFT: 'left-start',
            LEFTEND: 'left-end'
        };
        var Default = {
            offset: 0,
            flip: true,
            boundary: 'scrollParent',
            reference: 'toggle',
            display: 'dynamic'
        };
        var DefaultType = {
            offset: '(number|string|function)',
            flip: 'boolean',
            boundary: '(string|element)',
            reference: '(string|element)',
            display: 'string'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Dropdown =
            /*#__PURE__*/
            function () {
                function Dropdown(element, config) {
                    this._element = element;
                    this._popper = null;
                    this._config = this._getConfig(config);
                    this._menu = this._getMenuElement();
                    this._inNavbar = this._detectNavbar();

                    this._addEventListeners();
                } // Getters


                var _proto = Dropdown.prototype;

                // Public
                _proto.toggle = function toggle() {
                    if (this._element.disabled || $$$1(this._element).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var parent = Dropdown._getParentFromElement(this._element);

                    var isActive = $$$1(this._menu).hasClass(ClassName.SHOW);

                    Dropdown._clearMenus();

                    if (isActive) {
                        return;
                    }

                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    var showEvent = $$$1.Event(Event.SHOW, relatedTarget);
                    $$$1(parent).trigger(showEvent);

                    if (showEvent.isDefaultPrevented()) {
                        return;
                    } // Disable totally Popper.js for Dropdown in Navbar


                    if (!this._inNavbar) {
                        /**
                         * Check for Popper dependency
                         * Popper - https://popper.js.org
                         */
                        if (typeof Popper === 'undefined') {
                            throw new TypeError('Bootstrap dropdown require Popper.js (https://popper.js.org)');
                        }

                        var referenceElement = this._element;

                        if (this._config.reference === 'parent') {
                            referenceElement = parent;
                        } else if (Util.isElement(this._config.reference)) {
                            referenceElement = this._config.reference; // Check if it's jQuery element

                            if (typeof this._config.reference.jquery !== 'undefined') {
                                referenceElement = this._config.reference[0];
                            }
                        } // If boundary is not `scrollParent`, then set position to `static`
                        // to allow the menu to "escape" the scroll parent's boundaries
                        // https://github.com/twbs/bootstrap/issues/24251


                        if (this._config.boundary !== 'scrollParent') {
                            $$$1(parent).addClass(ClassName.POSITION_STATIC);
                        }

                        this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
                    } // If this is a touch-enabled device we add extra
                    // empty mouseover listeners to the body's immediate children;
                    // only needed because of broken event delegation on iOS
                    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


                    if ('ontouchstart' in document.documentElement && $$$1(parent).closest(Selector.NAVBAR_NAV).length === 0) {
                        $$$1(document.body).children().on('mouseover', null, $$$1.noop);
                    }

                    this._element.focus();

                    this._element.setAttribute('aria-expanded', true);

                    $$$1(this._menu).toggleClass(ClassName.SHOW);
                    $$$1(parent).toggleClass(ClassName.SHOW).trigger($$$1.Event(Event.SHOWN, relatedTarget));
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(this._element).off(EVENT_KEY);
                    this._element = null;
                    this._menu = null;

                    if (this._popper !== null) {
                        this._popper.destroy();

                        this._popper = null;
                    }
                };

                _proto.update = function update() {
                    this._inNavbar = this._detectNavbar();

                    if (this._popper !== null) {
                        this._popper.scheduleUpdate();
                    }
                }; // Private


                _proto._addEventListeners = function _addEventListeners() {
                    var _this = this;

                    $$$1(this._element).on(Event.CLICK, function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        _this.toggle();
                    });
                };

                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, this.constructor.Default, $$$1(this._element).data(), config);
                    Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
                    return config;
                };

                _proto._getMenuElement = function _getMenuElement() {
                    if (!this._menu) {
                        var parent = Dropdown._getParentFromElement(this._element);

                        if (parent) {
                            this._menu = parent.querySelector(Selector.MENU);
                        }
                    }

                    return this._menu;
                };

                _proto._getPlacement = function _getPlacement() {
                    var $parentDropdown = $$$1(this._element.parentNode);
                    var placement = AttachmentMap.BOTTOM; // Handle dropup

                    if ($parentDropdown.hasClass(ClassName.DROPUP)) {
                        placement = AttachmentMap.TOP;

                        if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                            placement = AttachmentMap.TOPEND;
                        }
                    } else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
                        placement = AttachmentMap.RIGHT;
                    } else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
                        placement = AttachmentMap.LEFT;
                    } else if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                        placement = AttachmentMap.BOTTOMEND;
                    }

                    return placement;
                };

                _proto._detectNavbar = function _detectNavbar() {
                    return $$$1(this._element).closest('.navbar').length > 0;
                };

                _proto._getPopperConfig = function _getPopperConfig() {
                    var _this2 = this;

                    var offsetConf = {};

                    if (typeof this._config.offset === 'function') {
                        offsetConf.fn = function (data) {
                            data.offsets = _objectSpread({}, data.offsets, _this2._config.offset(data.offsets) || {});
                            return data;
                        };
                    } else {
                        offsetConf.offset = this._config.offset;
                    }

                    var popperConfig = {
                        placement: this._getPlacement(),
                        modifiers: {
                            offset: offsetConf,
                            flip: {
                                enabled: this._config.flip
                            },
                            preventOverflow: {
                                boundariesElement: this._config.boundary
                            }
                        } // Disable Popper.js if we have a static display

                    };

                    if (this._config.display === 'static') {
                        popperConfig.modifiers.applyStyle = {
                            enabled: false
                        };
                    }

                    return popperConfig;
                }; // Static


                Dropdown._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' ? config : null;

                        if (!data) {
                            data = new Dropdown(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                Dropdown._clearMenus = function _clearMenus(event) {
                    if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
                        return;
                    }

                    var toggles = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));

                    for (var i = 0, len = toggles.length; i < len; i++) {
                        var parent = Dropdown._getParentFromElement(toggles[i]);

                        var context = $$$1(toggles[i]).data(DATA_KEY);
                        var relatedTarget = {
                            relatedTarget: toggles[i]
                        };

                        if (event && event.type === 'click') {
                            relatedTarget.clickEvent = event;
                        }

                        if (!context) {
                            continue;
                        }

                        var dropdownMenu = context._menu;

                        if (!$$$1(parent).hasClass(ClassName.SHOW)) {
                            continue;
                        }

                        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $$$1.contains(parent, event.target)) {
                            continue;
                        }

                        var hideEvent = $$$1.Event(Event.HIDE, relatedTarget);
                        $$$1(parent).trigger(hideEvent);

                        if (hideEvent.isDefaultPrevented()) {
                            continue;
                        } // If this is a touch-enabled device we remove the extra
                        // empty mouseover listeners we added for iOS support


                        if ('ontouchstart' in document.documentElement) {
                            $$$1(document.body).children().off('mouseover', null, $$$1.noop);
                        }

                        toggles[i].setAttribute('aria-expanded', 'false');
                        $$$1(dropdownMenu).removeClass(ClassName.SHOW);
                        $$$1(parent).removeClass(ClassName.SHOW).trigger($$$1.Event(Event.HIDDEN, relatedTarget));
                    }
                };

                Dropdown._getParentFromElement = function _getParentFromElement(element) {
                    var parent;
                    var selector = Util.getSelectorFromElement(element);

                    if (selector) {
                        parent = document.querySelector(selector);
                    }

                    return parent || element.parentNode;
                }; // eslint-disable-next-line complexity


                Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
                    // If not input/textarea:
                    //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
                    // If input/textarea:
                    //  - If space key => not a dropdown command
                    //  - If key is other than escape
                    //    - If key is not up or down => not a dropdown command
                    //    - If trigger inside the menu => not a dropdown command
                    if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $$$1(event.target).closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    if (this.disabled || $$$1(this).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var parent = Dropdown._getParentFromElement(this);

                    var isActive = $$$1(parent).hasClass(ClassName.SHOW);

                    if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
                        if (event.which === ESCAPE_KEYCODE) {
                            var toggle = parent.querySelector(Selector.DATA_TOGGLE);
                            $$$1(toggle).trigger('focus');
                        }

                        $$$1(this).trigger('click');
                        return;
                    }

                    var items = [].slice.call(parent.querySelectorAll(Selector.VISIBLE_ITEMS));

                    if (items.length === 0) {
                        return;
                    }

                    var index = items.indexOf(event.target);

                    if (event.which === ARROW_UP_KEYCODE && index > 0) {
                        // Up
                        index--;
                    }

                    if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
                        // Down
                        index++;
                    }

                    if (index < 0) {
                        index = 0;
                    }

                    items[index].focus();
                };

                _createClass(Dropdown, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Dropdown;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
            event.preventDefault();
            event.stopPropagation();

            Dropdown._jQueryInterface.call($$$1(this), 'toggle');
        }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
            e.stopPropagation();
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Dropdown._jQueryInterface;
        $$$1.fn[NAME].Constructor = Dropdown;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Dropdown._jQueryInterface;
        };

        return Dropdown;
    }($, Popper);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): modal.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Modal = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'modal';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.modal';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

        var Default = {
            backdrop: true,
            keyboard: true,
            focus: true,
            show: true
        };
        var DefaultType = {
            backdrop: '(boolean|string)',
            keyboard: 'boolean',
            focus: 'boolean',
            show: 'boolean'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            RESIZE: "resize" + EVENT_KEY,
            CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
            KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
            MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
            MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
            BACKDROP: 'modal-backdrop',
            OPEN: 'modal-open',
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            DIALOG: '.modal-dialog',
            DATA_TOGGLE: '[data-toggle="modal"]',
            DATA_DISMISS: '[data-dismiss="modal"]',
            FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
            STICKY_CONTENT: '.sticky-top'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Modal =
            /*#__PURE__*/
            function () {
                function Modal(element, config) {
                    this._config = this._getConfig(config);
                    this._element = element;
                    this._dialog = element.querySelector(Selector.DIALOG);
                    this._backdrop = null;
                    this._isShown = false;
                    this._isBodyOverflowing = false;
                    this._ignoreBackdropClick = false;
                    this._scrollbarWidth = 0;
                } // Getters


                var _proto = Modal.prototype;

                // Public
                _proto.toggle = function toggle(relatedTarget) {
                    return this._isShown ? this.hide() : this.show(relatedTarget);
                };

                _proto.show = function show(relatedTarget) {
                    var _this = this;

                    if (this._isTransitioning || this._isShown) {
                        return;
                    }

                    if ($$$1(this._element).hasClass(ClassName.FADE)) {
                        this._isTransitioning = true;
                    }

                    var showEvent = $$$1.Event(Event.SHOW, {
                        relatedTarget: relatedTarget
                    });
                    $$$1(this._element).trigger(showEvent);

                    if (this._isShown || showEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._isShown = true;

                    this._checkScrollbar();

                    this._setScrollbar();

                    this._adjustDialog();

                    $$$1(document.body).addClass(ClassName.OPEN);

                    this._setEscapeEvent();

                    this._setResizeEvent();

                    $$$1(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
                        return _this.hide(event);
                    });
                    $$$1(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
                        $$$1(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
                            if ($$$1(event.target).is(_this._element)) {
                                _this._ignoreBackdropClick = true;
                            }
                        });
                    });

                    this._showBackdrop(function () {
                        return _this._showElement(relatedTarget);
                    });
                };

                _proto.hide = function hide(event) {
                    var _this2 = this;

                    if (event) {
                        event.preventDefault();
                    }

                    if (this._isTransitioning || !this._isShown) {
                        return;
                    }

                    var hideEvent = $$$1.Event(Event.HIDE);
                    $$$1(this._element).trigger(hideEvent);

                    if (!this._isShown || hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._isShown = false;
                    var transition = $$$1(this._element).hasClass(ClassName.FADE);

                    if (transition) {
                        this._isTransitioning = true;
                    }

                    this._setEscapeEvent();

                    this._setResizeEvent();

                    $$$1(document).off(Event.FOCUSIN);
                    $$$1(this._element).removeClass(ClassName.SHOW);
                    $$$1(this._element).off(Event.CLICK_DISMISS);
                    $$$1(this._dialog).off(Event.MOUSEDOWN_DISMISS);

                    if (transition) {
                        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                        $$$1(this._element).one(Util.TRANSITION_END, function (event) {
                            return _this2._hideModal(event);
                        }).emulateTransitionEnd(transitionDuration);
                    } else {
                        this._hideModal();
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(window, document, this._element, this._backdrop).off(EVENT_KEY);
                    this._config = null;
                    this._element = null;
                    this._dialog = null;
                    this._backdrop = null;
                    this._isShown = null;
                    this._isBodyOverflowing = null;
                    this._ignoreBackdropClick = null;
                    this._scrollbarWidth = null;
                };

                _proto.handleUpdate = function handleUpdate() {
                    this._adjustDialog();
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, Default, config);
                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._showElement = function _showElement(relatedTarget) {
                    var _this3 = this;

                    var transition = $$$1(this._element).hasClass(ClassName.FADE);

                    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
                        // Don't move modal's DOM position
                        document.body.appendChild(this._element);
                    }

                    this._element.style.display = 'block';

                    this._element.removeAttribute('aria-hidden');

                    this._element.scrollTop = 0;

                    if (transition) {
                        Util.reflow(this._element);
                    }

                    $$$1(this._element).addClass(ClassName.SHOW);

                    if (this._config.focus) {
                        this._enforceFocus();
                    }

                    var shownEvent = $$$1.Event(Event.SHOWN, {
                        relatedTarget: relatedTarget
                    });

                    var transitionComplete = function transitionComplete() {
                        if (_this3._config.focus) {
                            _this3._element.focus();
                        }

                        _this3._isTransitioning = false;
                        $$$1(_this3._element).trigger(shownEvent);
                    };

                    if (transition) {
                        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                        $$$1(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
                    } else {
                        transitionComplete();
                    }
                };

                _proto._enforceFocus = function _enforceFocus() {
                    var _this4 = this;

                    $$$1(document).off(Event.FOCUSIN) // Guard against infinite focus loop
                        .on(Event.FOCUSIN, function (event) {
                            if (document !== event.target && _this4._element !== event.target && $$$1(_this4._element).has(event.target).length === 0) {
                                _this4._element.focus();
                            }
                        });
                };

                _proto._setEscapeEvent = function _setEscapeEvent() {
                    var _this5 = this;

                    if (this._isShown && this._config.keyboard) {
                        $$$1(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
                            if (event.which === ESCAPE_KEYCODE) {
                                event.preventDefault();

                                _this5.hide();
                            }
                        });
                    } else if (!this._isShown) {
                        $$$1(this._element).off(Event.KEYDOWN_DISMISS);
                    }
                };

                _proto._setResizeEvent = function _setResizeEvent() {
                    var _this6 = this;

                    if (this._isShown) {
                        $$$1(window).on(Event.RESIZE, function (event) {
                            return _this6.handleUpdate(event);
                        });
                    } else {
                        $$$1(window).off(Event.RESIZE);
                    }
                };

                _proto._hideModal = function _hideModal() {
                    var _this7 = this;

                    this._element.style.display = 'none';

                    this._element.setAttribute('aria-hidden', true);

                    this._isTransitioning = false;

                    this._showBackdrop(function () {
                        $$$1(document.body).removeClass(ClassName.OPEN);

                        _this7._resetAdjustments();

                        _this7._resetScrollbar();

                        $$$1(_this7._element).trigger(Event.HIDDEN);
                    });
                };

                _proto._removeBackdrop = function _removeBackdrop() {
                    if (this._backdrop) {
                        $$$1(this._backdrop).remove();
                        this._backdrop = null;
                    }
                };

                _proto._showBackdrop = function _showBackdrop(callback) {
                    var _this8 = this;

                    var animate = $$$1(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

                    if (this._isShown && this._config.backdrop) {
                        this._backdrop = document.createElement('div');
                        this._backdrop.className = ClassName.BACKDROP;

                        if (animate) {
                            this._backdrop.classList.add(animate);
                        }

                        $$$1(this._backdrop).appendTo(document.body);
                        $$$1(this._element).on(Event.CLICK_DISMISS, function (event) {
                            if (_this8._ignoreBackdropClick) {
                                _this8._ignoreBackdropClick = false;
                                return;
                            }

                            if (event.target !== event.currentTarget) {
                                return;
                            }

                            if (_this8._config.backdrop === 'static') {
                                _this8._element.focus();
                            } else {
                                _this8.hide();
                            }
                        });

                        if (animate) {
                            Util.reflow(this._backdrop);
                        }

                        $$$1(this._backdrop).addClass(ClassName.SHOW);

                        if (!callback) {
                            return;
                        }

                        if (!animate) {
                            callback();
                            return;
                        }

                        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                        $$$1(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
                    } else if (!this._isShown && this._backdrop) {
                        $$$1(this._backdrop).removeClass(ClassName.SHOW);

                        var callbackRemove = function callbackRemove() {
                            _this8._removeBackdrop();

                            if (callback) {
                                callback();
                            }
                        };

                        if ($$$1(this._element).hasClass(ClassName.FADE)) {
                            var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

                            $$$1(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                        } else {
                            callbackRemove();
                        }
                    } else if (callback) {
                        callback();
                    }
                }; // ----------------------------------------------------------------------
                // the following methods are used to handle overflowing modals
                // todo (fat): these should probably be refactored out of modal.js
                // ----------------------------------------------------------------------


                _proto._adjustDialog = function _adjustDialog() {
                    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

                    if (!this._isBodyOverflowing && isModalOverflowing) {
                        this._element.style.paddingLeft = this._scrollbarWidth + "px";
                    }

                    if (this._isBodyOverflowing && !isModalOverflowing) {
                        this._element.style.paddingRight = this._scrollbarWidth + "px";
                    }
                };

                _proto._resetAdjustments = function _resetAdjustments() {
                    this._element.style.paddingLeft = '';
                    this._element.style.paddingRight = '';
                };

                _proto._checkScrollbar = function _checkScrollbar() {
                    var rect = document.body.getBoundingClientRect();
                    this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
                    this._scrollbarWidth = this._getScrollbarWidth();
                };

                _proto._setScrollbar = function _setScrollbar() {
                    var _this9 = this;

                    if (this._isBodyOverflowing) {
                        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                        var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
                        var stickyContent = [].slice.call(document.querySelectorAll(Selector.STICKY_CONTENT)); // Adjust fixed content padding

                        $$$1(fixedContent).each(function (index, element) {
                            var actualPadding = element.style.paddingRight;
                            var calculatedPadding = $$$1(element).css('padding-right');
                            $$$1(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
                        }); // Adjust sticky content margin

                        $$$1(stickyContent).each(function (index, element) {
                            var actualMargin = element.style.marginRight;
                            var calculatedMargin = $$$1(element).css('margin-right');
                            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
                        }); // Adjust body padding

                        var actualPadding = document.body.style.paddingRight;
                        var calculatedPadding = $$$1(document.body).css('padding-right');
                        $$$1(document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
                    }
                };

                _proto._resetScrollbar = function _resetScrollbar() {
                    // Restore fixed content padding
                    var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
                    $$$1(fixedContent).each(function (index, element) {
                        var padding = $$$1(element).data('padding-right');
                        $$$1(element).removeData('padding-right');
                        element.style.paddingRight = padding ? padding : '';
                    }); // Restore sticky content

                    var elements = [].slice.call(document.querySelectorAll("" + Selector.STICKY_CONTENT));
                    $$$1(elements).each(function (index, element) {
                        var margin = $$$1(element).data('margin-right');

                        if (typeof margin !== 'undefined') {
                            $$$1(element).css('margin-right', margin).removeData('margin-right');
                        }
                    }); // Restore body padding

                    var padding = $$$1(document.body).data('padding-right');
                    $$$1(document.body).removeData('padding-right');
                    document.body.style.paddingRight = padding ? padding : '';
                };

                _proto._getScrollbarWidth = function _getScrollbarWidth() {
                    // thx d.walsh
                    var scrollDiv = document.createElement('div');
                    scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
                    document.body.appendChild(scrollDiv);
                    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                    return scrollbarWidth;
                }; // Static


                Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = _objectSpread({}, Default, $$$1(this).data(), typeof config === 'object' && config ? config : {});

                        if (!data) {
                            data = new Modal(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config](relatedTarget);
                        } else if (_config.show) {
                            data.show(relatedTarget);
                        }
                    });
                };

                _createClass(Modal, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Modal;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
            var _this10 = this;

            var target;
            var selector = Util.getSelectorFromElement(this);

            if (selector) {
                target = document.querySelector(selector);
            }

            var config = $$$1(target).data(DATA_KEY) ? 'toggle' : _objectSpread({}, $$$1(target).data(), $$$1(this).data());

            if (this.tagName === 'A' || this.tagName === 'AREA') {
                event.preventDefault();
            }

            var $target = $$$1(target).one(Event.SHOW, function (showEvent) {
                if (showEvent.isDefaultPrevented()) {
                    // Only register focus restorer if modal will actually get shown
                    return;
                }

                $target.one(Event.HIDDEN, function () {
                    if ($$$1(_this10).is(':visible')) {
                        _this10.focus();
                    }
                });
            });

            Modal._jQueryInterface.call($$$1(target), config, this);
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Modal._jQueryInterface;
        $$$1.fn[NAME].Constructor = Modal;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Modal._jQueryInterface;
        };

        return Modal;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): tooltip.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Tooltip = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'tooltip';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.tooltip';
        var EVENT_KEY = "." + DATA_KEY;
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var CLASS_PREFIX = 'bs-tooltip';
        var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
        var DefaultType = {
            animation: 'boolean',
            template: 'string',
            title: '(string|element|function)',
            trigger: 'string',
            delay: '(number|object)',
            html: 'boolean',
            selector: '(string|boolean)',
            placement: '(string|function)',
            offset: '(number|string)',
            container: '(string|element|boolean)',
            fallbackPlacement: '(string|array)',
            boundary: '(string|element)'
        };
        var AttachmentMap = {
            AUTO: 'auto',
            TOP: 'top',
            RIGHT: 'right',
            BOTTOM: 'bottom',
            LEFT: 'left'
        };
        var Default = {
            animation: true,
            template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
            trigger: 'hover focus',
            title: '',
            delay: 0,
            html: false,
            selector: false,
            placement: 'top',
            offset: 0,
            container: false,
            fallbackPlacement: 'flip',
            boundary: 'scrollParent'
        };
        var HoverState = {
            SHOW: 'show',
            OUT: 'out'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            INSERTED: "inserted" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            FOCUSOUT: "focusout" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY
        };
        var ClassName = {
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            TOOLTIP: '.tooltip',
            TOOLTIP_INNER: '.tooltip-inner',
            ARROW: '.arrow'
        };
        var Trigger = {
            HOVER: 'hover',
            FOCUS: 'focus',
            CLICK: 'click',
            MANUAL: 'manual'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Tooltip =
            /*#__PURE__*/
            function () {
                function Tooltip(element, config) {
                    /**
                     * Check for Popper dependency
                     * Popper - https://popper.js.org
                     */
                    if (typeof Popper === 'undefined') {
                        throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
                    } // private


                    this._isEnabled = true;
                    this._timeout = 0;
                    this._hoverState = '';
                    this._activeTrigger = {};
                    this._popper = null; // Protected

                    this.element = element;
                    this.config = this._getConfig(config);
                    this.tip = null;

                    this._setListeners();
                } // Getters


                var _proto = Tooltip.prototype;

                // Public
                _proto.enable = function enable() {
                    this._isEnabled = true;
                };

                _proto.disable = function disable() {
                    this._isEnabled = false;
                };

                _proto.toggleEnabled = function toggleEnabled() {
                    this._isEnabled = !this._isEnabled;
                };

                _proto.toggle = function toggle(event) {
                    if (!this._isEnabled) {
                        return;
                    }

                    if (event) {
                        var dataKey = this.constructor.DATA_KEY;
                        var context = $$$1(event.currentTarget).data(dataKey);

                        if (!context) {
                            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                            $$$1(event.currentTarget).data(dataKey, context);
                        }

                        context._activeTrigger.click = !context._activeTrigger.click;

                        if (context._isWithActiveTrigger()) {
                            context._enter(null, context);
                        } else {
                            context._leave(null, context);
                        }
                    } else {
                        if ($$$1(this.getTipElement()).hasClass(ClassName.SHOW)) {
                            this._leave(null, this);

                            return;
                        }

                        this._enter(null, this);
                    }
                };

                _proto.dispose = function dispose() {
                    clearTimeout(this._timeout);
                    $$$1.removeData(this.element, this.constructor.DATA_KEY);
                    $$$1(this.element).off(this.constructor.EVENT_KEY);
                    $$$1(this.element).closest('.modal').off('hide.bs.modal');

                    if (this.tip) {
                        $$$1(this.tip).remove();
                    }

                    this._isEnabled = null;
                    this._timeout = null;
                    this._hoverState = null;
                    this._activeTrigger = null;

                    if (this._popper !== null) {
                        this._popper.destroy();
                    }

                    this._popper = null;
                    this.element = null;
                    this.config = null;
                    this.tip = null;
                };

                _proto.show = function show() {
                    var _this = this;

                    if ($$$1(this.element).css('display') === 'none') {
                        throw new Error('Please use show on visible elements');
                    }

                    var showEvent = $$$1.Event(this.constructor.Event.SHOW);

                    if (this.isWithContent() && this._isEnabled) {
                        $$$1(this.element).trigger(showEvent);
                        var isInTheDom = $$$1.contains(this.element.ownerDocument.documentElement, this.element);

                        if (showEvent.isDefaultPrevented() || !isInTheDom) {
                            return;
                        }

                        var tip = this.getTipElement();
                        var tipId = Util.getUID(this.constructor.NAME);
                        tip.setAttribute('id', tipId);
                        this.element.setAttribute('aria-describedby', tipId);
                        this.setContent();

                        if (this.config.animation) {
                            $$$1(tip).addClass(ClassName.FADE);
                        }

                        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

                        var attachment = this._getAttachment(placement);

                        this.addAttachmentClass(attachment);
                        var container = this.config.container === false ? document.body : $$$1(document).find(this.config.container);
                        $$$1(tip).data(this.constructor.DATA_KEY, this);

                        if (!$$$1.contains(this.element.ownerDocument.documentElement, this.tip)) {
                            $$$1(tip).appendTo(container);
                        }

                        $$$1(this.element).trigger(this.constructor.Event.INSERTED);
                        this._popper = new Popper(this.element, tip, {
                            placement: attachment,
                            modifiers: {
                                offset: {
                                    offset: this.config.offset
                                },
                                flip: {
                                    behavior: this.config.fallbackPlacement
                                },
                                arrow: {
                                    element: Selector.ARROW
                                },
                                preventOverflow: {
                                    boundariesElement: this.config.boundary
                                }
                            },
                            onCreate: function onCreate(data) {
                                if (data.originalPlacement !== data.placement) {
                                    _this._handlePopperPlacementChange(data);
                                }
                            },
                            onUpdate: function onUpdate(data) {
                                _this._handlePopperPlacementChange(data);
                            }
                        });
                        $$$1(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
                        // empty mouseover listeners to the body's immediate children;
                        // only needed because of broken event delegation on iOS
                        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

                        if ('ontouchstart' in document.documentElement) {
                            $$$1(document.body).children().on('mouseover', null, $$$1.noop);
                        }

                        var complete = function complete() {
                            if (_this.config.animation) {
                                _this._fixTransition();
                            }

                            var prevHoverState = _this._hoverState;
                            _this._hoverState = null;
                            $$$1(_this.element).trigger(_this.constructor.Event.SHOWN);

                            if (prevHoverState === HoverState.OUT) {
                                _this._leave(null, _this);
                            }
                        };

                        if ($$$1(this.tip).hasClass(ClassName.FADE)) {
                            var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                            $$$1(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                        } else {
                            complete();
                        }
                    }
                };

                _proto.hide = function hide(callback) {
                    var _this2 = this;

                    var tip = this.getTipElement();
                    var hideEvent = $$$1.Event(this.constructor.Event.HIDE);

                    var complete = function complete() {
                        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
                            tip.parentNode.removeChild(tip);
                        }

                        _this2._cleanTipClass();

                        _this2.element.removeAttribute('aria-describedby');

                        $$$1(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

                        if (_this2._popper !== null) {
                            _this2._popper.destroy();
                        }

                        if (callback) {
                            callback();
                        }
                    };

                    $$$1(this.element).trigger(hideEvent);

                    if (hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    $$$1(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
                    // empty mouseover listeners we added for iOS support

                    if ('ontouchstart' in document.documentElement) {
                        $$$1(document.body).children().off('mouseover', null, $$$1.noop);
                    }

                    this._activeTrigger[Trigger.CLICK] = false;
                    this._activeTrigger[Trigger.FOCUS] = false;
                    this._activeTrigger[Trigger.HOVER] = false;

                    if ($$$1(this.tip).hasClass(ClassName.FADE)) {
                        var transitionDuration = Util.getTransitionDurationFromElement(tip);
                        $$$1(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                    } else {
                        complete();
                    }

                    this._hoverState = '';
                };

                _proto.update = function update() {
                    if (this._popper !== null) {
                        this._popper.scheduleUpdate();
                    }
                }; // Protected


                _proto.isWithContent = function isWithContent() {
                    return Boolean(this.getTitle());
                };

                _proto.addAttachmentClass = function addAttachmentClass(attachment) {
                    $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
                };

                _proto.getTipElement = function getTipElement() {
                    this.tip = this.tip || $$$1(this.config.template)[0];
                    return this.tip;
                };

                _proto.setContent = function setContent() {
                    var tip = this.getTipElement();
                    this.setElementContent($$$1(tip.querySelectorAll(Selector.TOOLTIP_INNER)), this.getTitle());
                    $$$1(tip).removeClass(ClassName.FADE + " " + ClassName.SHOW);
                };

                _proto.setElementContent = function setElementContent($element, content) {
                    var html = this.config.html;

                    if (typeof content === 'object' && (content.nodeType || content.jquery)) {
                        // Content is a DOM node or a jQuery
                        if (html) {
                            if (!$$$1(content).parent().is($element)) {
                                $element.empty().append(content);
                            }
                        } else {
                            $element.text($$$1(content).text());
                        }
                    } else {
                        $element[html ? 'html' : 'text'](content);
                    }
                };

                _proto.getTitle = function getTitle() {
                    var title = this.element.getAttribute('data-original-title');

                    if (!title) {
                        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
                    }

                    return title;
                }; // Private


                _proto._getAttachment = function _getAttachment(placement) {
                    return AttachmentMap[placement.toUpperCase()];
                };

                _proto._setListeners = function _setListeners() {
                    var _this3 = this;

                    var triggers = this.config.trigger.split(' ');
                    triggers.forEach(function (trigger) {
                        if (trigger === 'click') {
                            $$$1(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
                                return _this3.toggle(event);
                            });
                        } else if (trigger !== Trigger.MANUAL) {
                            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
                            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
                            $$$1(_this3.element).on(eventIn, _this3.config.selector, function (event) {
                                return _this3._enter(event);
                            }).on(eventOut, _this3.config.selector, function (event) {
                                return _this3._leave(event);
                            });
                        }

                        $$$1(_this3.element).closest('.modal').on('hide.bs.modal', function () {
                            return _this3.hide();
                        });
                    });

                    if (this.config.selector) {
                        this.config = _objectSpread({}, this.config, {
                            trigger: 'manual',
                            selector: ''
                        });
                    } else {
                        this._fixTitle();
                    }
                };

                _proto._fixTitle = function _fixTitle() {
                    var titleType = typeof this.element.getAttribute('data-original-title');

                    if (this.element.getAttribute('title') || titleType !== 'string') {
                        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
                        this.element.setAttribute('title', '');
                    }
                };

                _proto._enter = function _enter(event, context) {
                    var dataKey = this.constructor.DATA_KEY;
                    context = context || $$$1(event.currentTarget).data(dataKey);

                    if (!context) {
                        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                        $$$1(event.currentTarget).data(dataKey, context);
                    }

                    if (event) {
                        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
                    }

                    if ($$$1(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
                        context._hoverState = HoverState.SHOW;
                        return;
                    }

                    clearTimeout(context._timeout);
                    context._hoverState = HoverState.SHOW;

                    if (!context.config.delay || !context.config.delay.show) {
                        context.show();
                        return;
                    }

                    context._timeout = setTimeout(function () {
                        if (context._hoverState === HoverState.SHOW) {
                            context.show();
                        }
                    }, context.config.delay.show);
                };

                _proto._leave = function _leave(event, context) {
                    var dataKey = this.constructor.DATA_KEY;
                    context = context || $$$1(event.currentTarget).data(dataKey);

                    if (!context) {
                        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                        $$$1(event.currentTarget).data(dataKey, context);
                    }

                    if (event) {
                        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
                    }

                    if (context._isWithActiveTrigger()) {
                        return;
                    }

                    clearTimeout(context._timeout);
                    context._hoverState = HoverState.OUT;

                    if (!context.config.delay || !context.config.delay.hide) {
                        context.hide();
                        return;
                    }

                    context._timeout = setTimeout(function () {
                        if (context._hoverState === HoverState.OUT) {
                            context.hide();
                        }
                    }, context.config.delay.hide);
                };

                _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
                    for (var trigger in this._activeTrigger) {
                        if (this._activeTrigger[trigger]) {
                            return true;
                        }
                    }

                    return false;
                };

                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, this.constructor.Default, $$$1(this.element).data(), typeof config === 'object' && config ? config : {});

                    if (typeof config.delay === 'number') {
                        config.delay = {
                            show: config.delay,
                            hide: config.delay
                        };
                    }

                    if (typeof config.title === 'number') {
                        config.title = config.title.toString();
                    }

                    if (typeof config.content === 'number') {
                        config.content = config.content.toString();
                    }

                    Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
                    return config;
                };

                _proto._getDelegateConfig = function _getDelegateConfig() {
                    var config = {};

                    if (this.config) {
                        for (var key in this.config) {
                            if (this.constructor.Default[key] !== this.config[key]) {
                                config[key] = this.config[key];
                            }
                        }
                    }

                    return config;
                };

                _proto._cleanTipClass = function _cleanTipClass() {
                    var $tip = $$$1(this.getTipElement());
                    var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

                    if (tabClass !== null && tabClass.length) {
                        $tip.removeClass(tabClass.join(''));
                    }
                };

                _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
                    var popperInstance = popperData.instance;
                    this.tip = popperInstance.popper;

                    this._cleanTipClass();

                    this.addAttachmentClass(this._getAttachment(popperData.placement));
                };

                _proto._fixTransition = function _fixTransition() {
                    var tip = this.getTipElement();
                    var initConfigAnimation = this.config.animation;

                    if (tip.getAttribute('x-placement') !== null) {
                        return;
                    }

                    $$$1(tip).removeClass(ClassName.FADE);
                    this.config.animation = false;
                    this.hide();
                    this.show();
                    this.config.animation = initConfigAnimation;
                }; // Static


                Tooltip._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' && config;

                        if (!data && /dispose|hide/.test(config)) {
                            return;
                        }

                        if (!data) {
                            data = new Tooltip(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Tooltip, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "NAME",
                    get: function get() {
                        return NAME;
                    }
                }, {
                    key: "DATA_KEY",
                    get: function get() {
                        return DATA_KEY;
                    }
                }, {
                    key: "Event",
                    get: function get() {
                        return Event;
                    }
                }, {
                    key: "EVENT_KEY",
                    get: function get() {
                        return EVENT_KEY;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Tooltip;
            }();
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[NAME] = Tooltip._jQueryInterface;
        $$$1.fn[NAME].Constructor = Tooltip;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Tooltip._jQueryInterface;
        };

        return Tooltip;
    }($, Popper);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): popover.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Popover = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'popover';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.popover';
        var EVENT_KEY = "." + DATA_KEY;
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var CLASS_PREFIX = 'bs-popover';
        var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');

        var Default = _objectSpread({}, Tooltip.Default, {
            placement: 'right',
            trigger: 'click',
            content: '',
            template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
        });

        var DefaultType = _objectSpread({}, Tooltip.DefaultType, {
            content: '(string|element|function)'
        });

        var ClassName = {
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            TITLE: '.popover-header',
            CONTENT: '.popover-body'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            INSERTED: "inserted" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            FOCUSOUT: "focusout" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Popover =
            /*#__PURE__*/
            function (_Tooltip) {
                _inheritsLoose(Popover, _Tooltip);

                function Popover() {
                    return _Tooltip.apply(this, arguments) || this;
                }

                var _proto = Popover.prototype;

                // Overrides
                _proto.isWithContent = function isWithContent() {
                    return this.getTitle() || this._getContent();
                };

                _proto.addAttachmentClass = function addAttachmentClass(attachment) {
                    $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
                };

                _proto.getTipElement = function getTipElement() {
                    this.tip = this.tip || $$$1(this.config.template)[0];
                    return this.tip;
                };

                _proto.setContent = function setContent() {
                    var $tip = $$$1(this.getTipElement()); // We use append for html objects to maintain js events

                    this.setElementContent($tip.find(Selector.TITLE), this.getTitle());

                    var content = this._getContent();

                    if (typeof content === 'function') {
                        content = content.call(this.element);
                    }

                    this.setElementContent($tip.find(Selector.CONTENT), content);
                    $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
                }; // Private


                _proto._getContent = function _getContent() {
                    return this.element.getAttribute('data-content') || this.config.content;
                };

                _proto._cleanTipClass = function _cleanTipClass() {
                    var $tip = $$$1(this.getTipElement());
                    var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

                    if (tabClass !== null && tabClass.length > 0) {
                        $tip.removeClass(tabClass.join(''));
                    }
                }; // Static


                Popover._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' ? config : null;

                        if (!data && /destroy|hide/.test(config)) {
                            return;
                        }

                        if (!data) {
                            data = new Popover(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Popover, null, [{
                    key: "VERSION",
                    // Getters
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "NAME",
                    get: function get() {
                        return NAME;
                    }
                }, {
                    key: "DATA_KEY",
                    get: function get() {
                        return DATA_KEY;
                    }
                }, {
                    key: "Event",
                    get: function get() {
                        return Event;
                    }
                }, {
                    key: "EVENT_KEY",
                    get: function get() {
                        return EVENT_KEY;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Popover;
            }(Tooltip);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[NAME] = Popover._jQueryInterface;
        $$$1.fn[NAME].Constructor = Popover;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Popover._jQueryInterface;
        };

        return Popover;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): scrollspy.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var ScrollSpy = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'scrollspy';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.scrollspy';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var Default = {
            offset: 10,
            method: 'auto',
            target: ''
        };
        var DefaultType = {
            offset: 'number',
            method: 'string',
            target: '(string|element)'
        };
        var Event = {
            ACTIVATE: "activate" + EVENT_KEY,
            SCROLL: "scroll" + EVENT_KEY,
            LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            DROPDOWN_ITEM: 'dropdown-item',
            DROPDOWN_MENU: 'dropdown-menu',
            ACTIVE: 'active'
        };
        var Selector = {
            DATA_SPY: '[data-spy="scroll"]',
            ACTIVE: '.active',
            NAV_LIST_GROUP: '.nav, .list-group',
            NAV_LINKS: '.nav-link',
            NAV_ITEMS: '.nav-item',
            LIST_ITEMS: '.list-group-item',
            DROPDOWN: '.dropdown',
            DROPDOWN_ITEMS: '.dropdown-item',
            DROPDOWN_TOGGLE: '.dropdown-toggle'
        };
        var OffsetMethod = {
            OFFSET: 'offset',
            POSITION: 'position'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var ScrollSpy =
            /*#__PURE__*/
            function () {
                function ScrollSpy(element, config) {
                    var _this = this;

                    this._element = element;
                    this._scrollElement = element.tagName === 'BODY' ? window : element;
                    this._config = this._getConfig(config);
                    this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.LIST_ITEMS + ",") + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
                    this._offsets = [];
                    this._targets = [];
                    this._activeTarget = null;
                    this._scrollHeight = 0;
                    $$$1(this._scrollElement).on(Event.SCROLL, function (event) {
                        return _this._process(event);
                    });
                    this.refresh();

                    this._process();
                } // Getters


                var _proto = ScrollSpy.prototype;

                // Public
                _proto.refresh = function refresh() {
                    var _this2 = this;

                    var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
                    var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
                    var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
                    this._offsets = [];
                    this._targets = [];
                    this._scrollHeight = this._getScrollHeight();
                    var targets = [].slice.call(document.querySelectorAll(this._selector));
                    targets.map(function (element) {
                        var target;
                        var targetSelector = Util.getSelectorFromElement(element);

                        if (targetSelector) {
                            target = document.querySelector(targetSelector);
                        }

                        if (target) {
                            var targetBCR = target.getBoundingClientRect();

                            if (targetBCR.width || targetBCR.height) {
                                // TODO (fat): remove sketch reliance on jQuery position/offset
                                return [$$$1(target)[offsetMethod]().top + offsetBase, targetSelector];
                            }
                        }

                        return null;
                    }).filter(function (item) {
                        return item;
                    }).sort(function (a, b) {
                        return a[0] - b[0];
                    }).forEach(function (item) {
                        _this2._offsets.push(item[0]);

                        _this2._targets.push(item[1]);
                    });
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(this._scrollElement).off(EVENT_KEY);
                    this._element = null;
                    this._scrollElement = null;
                    this._config = null;
                    this._selector = null;
                    this._offsets = null;
                    this._targets = null;
                    this._activeTarget = null;
                    this._scrollHeight = null;
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _objectSpread({}, Default, typeof config === 'object' && config ? config : {});

                    if (typeof config.target !== 'string') {
                        var id = $$$1(config.target).attr('id');

                        if (!id) {
                            id = Util.getUID(NAME);
                            $$$1(config.target).attr('id', id);
                        }

                        config.target = "#" + id;
                    }

                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._getScrollTop = function _getScrollTop() {
                    return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
                };

                _proto._getScrollHeight = function _getScrollHeight() {
                    return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
                };

                _proto._getOffsetHeight = function _getOffsetHeight() {
                    return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
                };

                _proto._process = function _process() {
                    var scrollTop = this._getScrollTop() + this._config.offset;

                    var scrollHeight = this._getScrollHeight();

                    var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

                    if (this._scrollHeight !== scrollHeight) {
                        this.refresh();
                    }

                    if (scrollTop >= maxScroll) {
                        var target = this._targets[this._targets.length - 1];

                        if (this._activeTarget !== target) {
                            this._activate(target);
                        }

                        return;
                    }

                    if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                        this._activeTarget = null;

                        this._clear();

                        return;
                    }

                    var offsetLength = this._offsets.length;

                    for (var i = offsetLength; i--;) {
                        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

                        if (isActiveTarget) {
                            this._activate(this._targets[i]);
                        }
                    }
                };

                _proto._activate = function _activate(target) {
                    this._activeTarget = target;

                    this._clear();

                    var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


                    queries = queries.map(function (selector) {
                        return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
                    });
                    var $link = $$$1([].slice.call(document.querySelectorAll(queries.join(','))));

                    if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
                        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                        $link.addClass(ClassName.ACTIVE);
                    } else {
                        // Set triggered link as active
                        $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
                        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

                        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle special case when .nav-link is inside .nav-item

                        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
                    }

                    $$$1(this._scrollElement).trigger(Event.ACTIVATE, {
                        relatedTarget: target
                    });
                };

                _proto._clear = function _clear() {
                    var nodes = [].slice.call(document.querySelectorAll(this._selector));
                    $$$1(nodes).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
                }; // Static


                ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' && config;

                        if (!data) {
                            data = new ScrollSpy(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(ScrollSpy, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return ScrollSpy;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(window).on(Event.LOAD_DATA_API, function () {
            var scrollSpys = [].slice.call(document.querySelectorAll(Selector.DATA_SPY));
            var scrollSpysLength = scrollSpys.length;

            for (var i = scrollSpysLength; i--;) {
                var $spy = $$$1(scrollSpys[i]);

                ScrollSpy._jQueryInterface.call($spy, $spy.data());
            }
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = ScrollSpy._jQueryInterface;
        $$$1.fn[NAME].Constructor = ScrollSpy;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return ScrollSpy._jQueryInterface;
        };

        return ScrollSpy;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): tab.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Tab = function ($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'tab';
        var VERSION = '4.1.2';
        var DATA_KEY = 'bs.tab';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            DROPDOWN_MENU: 'dropdown-menu',
            ACTIVE: 'active',
            DISABLED: 'disabled',
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            DROPDOWN: '.dropdown',
            NAV_LIST_GROUP: '.nav, .list-group',
            ACTIVE: '.active',
            ACTIVE_UL: '> li > .active',
            DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
            DROPDOWN_TOGGLE: '.dropdown-toggle',
            DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Tab =
            /*#__PURE__*/
            function () {
                function Tab(element) {
                    this._element = element;
                } // Getters


                var _proto = Tab.prototype;

                // Public
                _proto.show = function show() {
                    var _this = this;

                    if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $$$1(this._element).hasClass(ClassName.ACTIVE) || $$$1(this._element).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var target;
                    var previous;
                    var listElement = $$$1(this._element).closest(Selector.NAV_LIST_GROUP)[0];
                    var selector = Util.getSelectorFromElement(this._element);

                    if (listElement) {
                        var itemSelector = listElement.nodeName === 'UL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
                        previous = $$$1.makeArray($$$1(listElement).find(itemSelector));
                        previous = previous[previous.length - 1];
                    }

                    var hideEvent = $$$1.Event(Event.HIDE, {
                        relatedTarget: this._element
                    });
                    var showEvent = $$$1.Event(Event.SHOW, {
                        relatedTarget: previous
                    });

                    if (previous) {
                        $$$1(previous).trigger(hideEvent);
                    }

                    $$$1(this._element).trigger(showEvent);

                    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (selector) {
                        target = document.querySelector(selector);
                    }

                    this._activate(this._element, listElement);

                    var complete = function complete() {
                        var hiddenEvent = $$$1.Event(Event.HIDDEN, {
                            relatedTarget: _this._element
                        });
                        var shownEvent = $$$1.Event(Event.SHOWN, {
                            relatedTarget: previous
                        });
                        $$$1(previous).trigger(hiddenEvent);
                        $$$1(_this._element).trigger(shownEvent);
                    };

                    if (target) {
                        this._activate(target, target.parentNode, complete);
                    } else {
                        complete();
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Private


                _proto._activate = function _activate(element, container, callback) {
                    var _this2 = this;

                    var activeElements;

                    if (container.nodeName === 'UL') {
                        activeElements = $$$1(container).find(Selector.ACTIVE_UL);
                    } else {
                        activeElements = $$$1(container).children(Selector.ACTIVE);
                    }

                    var active = activeElements[0];
                    var isTransitioning = callback && active && $$$1(active).hasClass(ClassName.FADE);

                    var complete = function complete() {
                        return _this2._transitionComplete(element, active, callback);
                    };

                    if (active && isTransitioning) {
                        var transitionDuration = Util.getTransitionDurationFromElement(active);
                        $$$1(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                    } else {
                        complete();
                    }
                };

                _proto._transitionComplete = function _transitionComplete(element, active, callback) {
                    if (active) {
                        $$$1(active).removeClass(ClassName.SHOW + " " + ClassName.ACTIVE);
                        var dropdownChild = $$$1(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

                        if (dropdownChild) {
                            $$$1(dropdownChild).removeClass(ClassName.ACTIVE);
                        }

                        if (active.getAttribute('role') === 'tab') {
                            active.setAttribute('aria-selected', false);
                        }
                    }

                    $$$1(element).addClass(ClassName.ACTIVE);

                    if (element.getAttribute('role') === 'tab') {
                        element.setAttribute('aria-selected', true);
                    }

                    Util.reflow(element);
                    $$$1(element).addClass(ClassName.SHOW);

                    if (element.parentNode && $$$1(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
                        var dropdownElement = $$$1(element).closest(Selector.DROPDOWN)[0];

                        if (dropdownElement) {
                            var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(Selector.DROPDOWN_TOGGLE));
                            $$$1(dropdownToggleList).addClass(ClassName.ACTIVE);
                        }

                        element.setAttribute('aria-expanded', true);
                    }

                    if (callback) {
                        callback();
                    }
                }; // Static


                Tab._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function () {
                        var $this = $$$1(this);
                        var data = $this.data(DATA_KEY);

                        if (!data) {
                            data = new Tab(this);
                            $this.data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Tab, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Tab;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
            event.preventDefault();

            Tab._jQueryInterface.call($$$1(this), 'show');
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Tab._jQueryInterface;
        $$$1.fn[NAME].Constructor = Tab;

        $$$1.fn[NAME].noConflict = function () {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Tab._jQueryInterface;
        };

        return Tab;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.1.2): index.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    (function ($$$1) {
        if (typeof $$$1 === 'undefined') {
            throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
        }

        var version = $$$1.fn.jquery.split(' ')[0].split('.');
        var minMajor = 1;
        var ltMajor = 2;
        var minMinor = 9;
        var minPatch = 1;
        var maxMajor = 4;

        if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
            throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
        }
    })($);

    exports.Util = Util;
    exports.Alert = Alert;
    exports.Button = Button;
    exports.Carousel = Carousel;
    exports.Collapse = Collapse;
    exports.Dropdown = Dropdown;
    exports.Modal = Modal;
    exports.Popover = Popover;
    exports.Scrollspy = ScrollSpy;
    exports.Tab = Tab;
    exports.Tooltip = Tooltip;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bootstrap.js.map
; /** ----------------- **/ 
 /*! jQuery UI - v1.11.4 - 2018-04-20
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, draggable.js, droppable.js, resizable.js, selectable.js, sortable.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(t){function e(e,s){var n,o,a,r=e.nodeName.toLowerCase();return"area"===r?(n=e.parentNode,o=n.name,e.href&&o&&"map"===n.nodeName.toLowerCase()?(a=t("img[usemap='#"+o+"']")[0],!!a&&i(a)):!1):(/^(input|select|textarea|button|object)$/.test(r)?!e.disabled:"a"===r?e.href||s:s)&&i(e)}function i(e){return t.expr.filters.visible(e)&&!t(e).parents().addBack().filter(function(){return"hidden"===t.css(this,"visibility")}).length}t.ui=t.ui||{},t.extend(t.ui,{version:"1.11.4",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),t.fn.extend({scrollParent:function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,o=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&o.length?o:t(this[0].ownerDocument||document)},uniqueId:function(){var t=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++t)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&t(this).removeAttr("id")})}}),t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])},focusable:function(i){return e(i,!isNaN(t.attr(i,"tabindex")))},tabbable:function(i){var s=t.attr(i,"tabindex"),n=isNaN(s);return(n||s>=0)&&e(i,!n)}}),t("<a>").outerWidth(1).jquery||t.each(["Width","Height"],function(e,i){function s(e,i,s,o){return t.each(n,function(){i-=parseFloat(t.css(e,"padding"+this))||0,s&&(i-=parseFloat(t.css(e,"border"+this+"Width"))||0),o&&(i-=parseFloat(t.css(e,"margin"+this))||0)}),i}var n="Width"===i?["Left","Right"]:["Top","Bottom"],o=i.toLowerCase(),a={innerWidth:t.fn.innerWidth,innerHeight:t.fn.innerHeight,outerWidth:t.fn.outerWidth,outerHeight:t.fn.outerHeight};t.fn["inner"+i]=function(e){return void 0===e?a["inner"+i].call(this):this.each(function(){t(this).css(o,s(this,e)+"px")})},t.fn["outer"+i]=function(e,n){return"number"!=typeof e?a["outer"+i].call(this,e):this.each(function(){t(this).css(o,s(this,e,!0,n)+"px")})}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(t.fn.removeData=function(e){return function(i){return arguments.length?e.call(this,t.camelCase(i)):e.call(this)}}(t.fn.removeData)),t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),t.fn.extend({focus:function(e){return function(i,s){return"number"==typeof i?this.each(function(){var e=this;setTimeout(function(){t(e).focus(),s&&s.call(e)},i)}):e.apply(this,arguments)}}(t.fn.focus),disableSelection:function(){var t="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.bind(t+".ui-disableSelection",function(t){t.preventDefault()})}}(),enableSelection:function(){return this.unbind(".ui-disableSelection")},zIndex:function(e){if(void 0!==e)return this.css("zIndex",e);if(this.length)for(var i,s,n=t(this[0]);n.length&&n[0]!==document;){if(i=n.css("position"),("absolute"===i||"relative"===i||"fixed"===i)&&(s=parseInt(n.css("zIndex"),10),!isNaN(s)&&0!==s))return s;n=n.parent()}return 0}}),t.ui.plugin={add:function(e,i,s){var n,o=t.ui[e].prototype;for(n in s)o.plugins[n]=o.plugins[n]||[],o.plugins[n].push([i,s[n]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;o.length>n;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}};var s=0,n=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,o;for(o=0;null!=(n=i[o]);o++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(a){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,o,a,r,l={},h=e.split(".")[0];return e=e.split(".")[1],n=h+"-"+e,s||(s=i,i=t.Widget),t.expr[":"][n.toLowerCase()]=function(e){return!!t.data(e,n)},t[h]=t[h]||{},o=t[h][e],a=t[h][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new a(t,e)},t.extend(a,o,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),r=new i,r.options=t.widget.extend({},r.options),t.each(s,function(e,s){return t.isFunction(s)?(l[e]=function(){var t=function(){return i.prototype[e].apply(this,arguments)},n=function(t){return i.prototype[e].apply(this,t)};return function(){var e,i=this._super,o=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=o,e}}(),void 0):(l[e]=s,void 0)}),a.prototype=t.widget.extend(r,{widgetEventPrefix:o?r.widgetEventPrefix||e:e},l,{constructor:a,namespace:h,widgetName:e,widgetFullName:n}),o?(t.each(o._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,a,i._proto)}),delete o._childConstructors):i._childConstructors.push(a),t.widget.bridge(e,a),a},t.widget.extend=function(e){for(var i,s,o=n.call(arguments,1),a=0,r=o.length;r>a;a++)for(i in o[a])s=o[a][i],o[a].hasOwnProperty(i)&&void 0!==s&&(e[i]=t.isPlainObject(s)?t.isPlainObject(e[i])?t.widget.extend({},e[i],s):t.widget.extend({},s):s);return e},t.widget.bridge=function(e,i){var s=i.prototype.widgetFullName||e;t.fn[e]=function(o){var a="string"==typeof o,r=n.call(arguments,1),l=this;return a?this.each(function(){var i,n=t.data(this,s);return"instance"===o?(l=n,!1):n?t.isFunction(n[o])&&"_"!==o.charAt(0)?(i=n[o].apply(n,r),i!==n&&void 0!==i?(l=i&&i.jquery?l.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+o+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+o+"'")}):(r.length&&(o=t.widget.extend.apply(null,[o].concat(r))),this.each(function(){var e=t.data(this,s);e?(e.option(o||{}),e._init&&e._init()):t.data(this,s,new i(o,this))})),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(e,i){i=t(i||this.defaultElement||this)[0],this.element=t(i),this.uuid=s++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),i!==this&&(t.data(i,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===i&&this.destroy()}}),this.document=t(i.style?i.ownerDocument:i.document||i),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:t.noop,_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetFullName).removeData(t.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,o,a=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(a={},s=e.split("."),e=s.shift(),s.length){for(n=a[e]=t.widget.extend({},this.options[e]),o=0;s.length-1>o;o++)n[s[o]]=n[s[o]]||{},n=n[s[o]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];a[e]=i}return this._setOptions(a),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return this.options[t]=e,"disabled"===t&&(this.widget().toggleClass(this.widgetFullName+"-disabled",!!e),e&&(this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus"))),this},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_on:function(e,i,s){var n,o=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,a){function r(){return e||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof a?o[a]:a).apply(o,arguments):void 0}"string"!=typeof a&&(r.guid=a.guid=a.guid||r.guid||t.guid++);var l=s.match(/^([\w:-]*)\s*(.*)$/),h=l[1]+o.eventNamespace,c=l[2];c?n.delegate(c,h,r):i.bind(h,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(i).undelegate(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){t(e.currentTarget).addClass("ui-state-hover")},mouseleave:function(e){t(e.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){t(e.currentTarget).addClass("ui-state-focus")},focusout:function(e){t(e.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}}),t.widget;var o=!1;t(document).mouseup(function(){o=!1}),t.widget("ui.mouse",{version:"1.11.4",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.bind("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).bind("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&this.document.unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!o){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,s=1===e.which,n="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return s&&!n&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),o=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){return this.document.unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),o=!1,!1},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),function(){function e(t,e,i){return[parseFloat(t[0])*(p.test(t[0])?e/100:1),parseFloat(t[1])*(p.test(t[1])?i/100:1)]}function i(e,i){return parseInt(t.css(e,i),10)||0}function s(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}t.ui=t.ui||{};var n,o,a=Math.max,r=Math.abs,l=Math.round,h=/left|center|right/,c=/top|center|bottom/,u=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=t.fn.position;t.position={scrollbarWidth:function(){if(void 0!==n)return n;var e,i,s=t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=s.children()[0];return t("body").append(s),e=o.offsetWidth,s.css("overflow","scroll"),i=o.offsetWidth,e===i&&(i=s[0].clientWidth),s.remove(),n=e-i},getScrollInfo:function(e){var i=e.isWindow||e.isDocument?"":e.element.css("overflow-x"),s=e.isWindow||e.isDocument?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,o="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:o?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType;return{element:i,isWindow:s,isDocument:n,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s||n?i.width():i.outerWidth(),height:s||n?i.height():i.outerHeight()}}},t.fn.position=function(n){if(!n||!n.of)return f.apply(this,arguments);n=t.extend({},n);var p,g,m,_,v,b,y=t(n.of),w=t.position.getWithinInfo(n.within),k=t.position.getScrollInfo(w),x=(n.collision||"flip").split(" "),C={};return b=s(y),y[0].preventDefault&&(n.at="left top"),g=b.width,m=b.height,_=b.offset,v=t.extend({},_),t.each(["my","at"],function(){var t,e,i=(n[this]||"").split(" ");1===i.length&&(i=h.test(i[0])?i.concat(["center"]):c.test(i[0])?["center"].concat(i):["center","center"]),i[0]=h.test(i[0])?i[0]:"center",i[1]=c.test(i[1])?i[1]:"center",t=u.exec(i[0]),e=u.exec(i[1]),C[this]=[t?t[0]:0,e?e[0]:0],n[this]=[d.exec(i[0])[0],d.exec(i[1])[0]]}),1===x.length&&(x[1]=x[0]),"right"===n.at[0]?v.left+=g:"center"===n.at[0]&&(v.left+=g/2),"bottom"===n.at[1]?v.top+=m:"center"===n.at[1]&&(v.top+=m/2),p=e(C.at,g,m),v.left+=p[0],v.top+=p[1],this.each(function(){var s,h,c=t(this),u=c.outerWidth(),d=c.outerHeight(),f=i(this,"marginLeft"),b=i(this,"marginTop"),D=u+f+i(this,"marginRight")+k.width,T=d+b+i(this,"marginBottom")+k.height,I=t.extend({},v),M=e(C.my,c.outerWidth(),c.outerHeight());"right"===n.my[0]?I.left-=u:"center"===n.my[0]&&(I.left-=u/2),"bottom"===n.my[1]?I.top-=d:"center"===n.my[1]&&(I.top-=d/2),I.left+=M[0],I.top+=M[1],o||(I.left=l(I.left),I.top=l(I.top)),s={marginLeft:f,marginTop:b},t.each(["left","top"],function(e,i){t.ui.position[x[e]]&&t.ui.position[x[e]][i](I,{targetWidth:g,targetHeight:m,elemWidth:u,elemHeight:d,collisionPosition:s,collisionWidth:D,collisionHeight:T,offset:[p[0]+M[0],p[1]+M[1]],my:n.my,at:n.at,within:w,elem:c})}),n.using&&(h=function(t){var e=_.left-I.left,i=e+g-u,s=_.top-I.top,o=s+m-d,l={target:{element:y,left:_.left,top:_.top,width:g,height:m},element:{element:c,left:I.left,top:I.top,width:u,height:d},horizontal:0>i?"left":e>0?"right":"center",vertical:0>o?"top":s>0?"bottom":"middle"};u>g&&g>r(e+i)&&(l.horizontal="center"),d>m&&m>r(s+o)&&(l.vertical="middle"),l.important=a(r(e),r(i))>a(r(s),r(o))?"horizontal":"vertical",n.using.call(this,t,l)}),c.offset(t.extend(I,{using:h}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,o=s.width,r=t.left-e.collisionPosition.marginLeft,l=n-r,h=r+e.collisionWidth-o-n;e.collisionWidth>o?l>0&&0>=h?(i=t.left+l+e.collisionWidth-o-n,t.left+=l-i):t.left=h>0&&0>=l?n:l>h?n+o-e.collisionWidth:n:l>0?t.left+=l:h>0?t.left-=h:t.left=a(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,o=e.within.height,r=t.top-e.collisionPosition.marginTop,l=n-r,h=r+e.collisionHeight-o-n;e.collisionHeight>o?l>0&&0>=h?(i=t.top+l+e.collisionHeight-o-n,t.top+=l-i):t.top=h>0&&0>=l?n:l>h?n+o-e.collisionHeight:n:l>0?t.top+=l:h>0?t.top-=h:t.top=a(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,o=n.offset.left+n.scrollLeft,a=n.width,l=n.isWindow?n.scrollLeft:n.offset.left,h=t.left-e.collisionPosition.marginLeft,c=h-l,u=h+e.collisionWidth-a-l,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-a-o,(0>i||r(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-l,(s>0||u>r(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,o=n.offset.top+n.scrollTop,a=n.height,l=n.isWindow?n.scrollTop:n.offset.top,h=t.top-e.collisionPosition.marginTop,c=h-l,u=h+e.collisionHeight-a-l,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-a-o,(0>s||r(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-l,(i>0||u>r(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,a,r=document.getElementsByTagName("body")[0],l=document.createElement("div");e=document.createElement(r?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},r&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(a in s)e.style[a]=s[a];e.appendChild(l),i=r||document.documentElement,i.insertBefore(e,i.firstChild),l.style.cssText="position: absolute; left: 10.7432222px;",n=t(l).offset().left,o=n>10&&11>n,e.innerHTML="",i.removeChild(e)}()}(),t.ui.position,t.widget("ui.draggable",t.ui.mouse,{version:"1.11.4",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?(this.destroyOnClear=!0,void 0):(this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(e){var i=this.options;return this._blurActiveElement(e),this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(this._blockFrames(i.iframeFix===!0?"iframe":i.iframeFix),!0):!1)},_blockFrames:function(e){this.iframeBlocks=this.document.find(e).map(function(){var e=t(this);return t("<div>").css("position","absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(e){var i=this.document[0];if(this.handleElement.is(e.target))try{i.activeElement&&"body"!==i.activeElement.nodeName.toLowerCase()&&t(i.activeElement).blur()}catch(s){}},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===t(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(e),this.originalPosition=this.position=this._generatePosition(e,!1),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._normalizeRightBottom(),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(e,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e,!0),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1},_mouseUp:function(e){return this._unblockFrames(),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),this.handleElement.is(e.target)&&this.element.focus(),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this.handleElement.addClass("ui-draggable-handle")},_removeHandleClassName:function(){this.handleElement.removeClass("ui-draggable-handle")},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper),n=s?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return n.parents("body").length||n.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css("position"))||n.css("position","absolute"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var e=this.offsetParent.offset(),i=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==i&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options,o=this.document[0];return this.relativeContainer=null,n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):"document"===n.containment?(this.containment=[0,0,t(o).width()-this.helperProportions.width-this.margins.left,(t(o).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)},_convertPositionTo:function(t,e){e||(e=this.position);var i="absolute"===t?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s,n,o,a=this.options,r=this._isRootNode(this.scrollParent[0]),l=t.pageX,h=t.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(l=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(h=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(l=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(h=i[3]+this.offset.click.top)),a.grid&&(n=a.grid[1]?this.originalPageY+Math.round((h-this.originalPageY)/a.grid[1])*a.grid[1]:this.originalPageY,h=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-a.grid[1]:n+a.grid[1]:n,o=a.grid[0]?this.originalPageX+Math.round((l-this.originalPageX)/a.grid[0])*a.grid[0]:this.originalPageX,l=i?o-this.offset.click.left>=i[0]||o-this.offset.click.left>i[2]?o:o-this.offset.click.left>=i[0]?o-a.grid[0]:o+a.grid[0]:o),"y"===a.axis&&(l=this.originalPageX),"x"===a.axis&&(h=this.originalPageY)),{top:h-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:l-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_normalizeRightBottom:function(){"y"!==this.options.axis&&"auto"!==this.helper.css("right")&&(this.helper.width(this.helper.width()),this.helper.css("right","auto")),"x"!==this.options.axis&&"auto"!==this.helper.css("bottom")&&(this.helper.height(this.helper.height()),this.helper.css("bottom","auto"))},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s,this],!0),/^(drag|start|stop)/.test(e)&&(this.positionAbs=this._convertPositionTo("absolute"),s.offset=this.positionAbs),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i,s){var n=t.extend({},i,{item:s.element});s.sortables=[],t(s.options.connectToSortable).each(function(){var i=t(this).sortable("instance");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger("activate",e,n))})},stop:function(e,i,s){var n=t.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,t.each(s.sortables,function(){var t=this;t.isOver?(t.isOver=0,s.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,n))})},drag:function(e,i,s){t.each(s.sortables,function(){var n=!1,o=this;o.positionAbs=s.positionAbs,o.helperProportions=s.helperProportions,o.offset.click=s.offset.click,o._intersectsWith(o.containerCache)&&(n=!0,t.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==o&&this._intersectsWith(this.containerCache)&&t.contains(o.element[0],this.element[0])&&(n=!1),n
    })),n?(o.isOver||(o.isOver=1,s._parent=i.helper.parent(),o.currentItem=i.helper.appendTo(o.element).data("ui-sortable-item",!0),o.options._helper=o.options.helper,o.options.helper=function(){return i.helper[0]},e.target=o.currentItem[0],o._mouseCapture(e,!0),o._mouseStart(e,!0,!0),o.offset.click.top=s.offset.click.top,o.offset.click.left=s.offset.click.left,o.offset.parent.left-=s.offset.parent.left-o.offset.parent.left,o.offset.parent.top-=s.offset.parent.top-o.offset.parent.top,s._trigger("toSortable",e),s.dropped=o.element,t.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,o.fromOutside=s),o.currentItem&&(o._mouseDrag(e),i.position=o.position)):o.isOver&&(o.isOver=0,o.cancelHelperRemoval=!0,o.options._revert=o.options.revert,o.options.revert=!1,o._trigger("out",e,o._uiHash(o)),o._mouseStop(e,!0),o.options.revert=o.options._revert,o.options.helper=o.options._helper,o.placeholder&&o.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(e),i.position=s._generatePosition(e,!0),s._trigger("fromSortable",e),s.dropped=!1,t.each(s.sortables,function(){this.refreshPositions()}))})}}),t.ui.plugin.add("draggable","cursor",{start:function(e,i,s){var n=t("body"),o=s.options;n.css("cursor")&&(o._cursor=n.css("cursor")),n.css("cursor",o.cursor)},stop:function(e,i,s){var n=s.options;n._cursor&&t("body").css("cursor",n._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("opacity")&&(o._opacity=n.css("opacity")),n.css("opacity",o.opacity)},stop:function(e,i,s){var n=s.options;n._opacity&&t(i.helper).css("opacity",n._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(e,i,s){var n=s.options,o=!1,a=s.scrollParentNotHidden[0],r=s.document[0];a!==r&&"HTML"!==a.tagName?(n.axis&&"x"===n.axis||(s.overflowOffset.top+a.offsetHeight-e.pageY<n.scrollSensitivity?a.scrollTop=o=a.scrollTop+n.scrollSpeed:e.pageY-s.overflowOffset.top<n.scrollSensitivity&&(a.scrollTop=o=a.scrollTop-n.scrollSpeed)),n.axis&&"y"===n.axis||(s.overflowOffset.left+a.offsetWidth-e.pageX<n.scrollSensitivity?a.scrollLeft=o=a.scrollLeft+n.scrollSpeed:e.pageX-s.overflowOffset.left<n.scrollSensitivity&&(a.scrollLeft=o=a.scrollLeft-n.scrollSpeed))):(n.axis&&"x"===n.axis||(e.pageY-t(r).scrollTop()<n.scrollSensitivity?o=t(r).scrollTop(t(r).scrollTop()-n.scrollSpeed):t(window).height()-(e.pageY-t(r).scrollTop())<n.scrollSensitivity&&(o=t(r).scrollTop(t(r).scrollTop()+n.scrollSpeed))),n.axis&&"y"===n.axis||(e.pageX-t(r).scrollLeft()<n.scrollSensitivity?o=t(r).scrollLeft(t(r).scrollLeft()-n.scrollSpeed):t(window).width()-(e.pageX-t(r).scrollLeft())<n.scrollSensitivity&&(o=t(r).scrollLeft(t(r).scrollLeft()+n.scrollSpeed)))),o!==!1&&t.ui.ddmanager&&!n.dropBehaviour&&t.ui.ddmanager.prepareOffsets(s,e)}}),t.ui.plugin.add("draggable","snap",{start:function(e,i,s){var n=s.options;s.snapElements=[],t(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var e=t(this),i=e.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:e.outerWidth(),height:e.outerHeight(),top:i.top,left:i.left})})},drag:function(e,i,s){var n,o,a,r,l,h,c,u,d,p,f=s.options,g=f.snapTolerance,m=i.offset.left,_=m+s.helperProportions.width,v=i.offset.top,b=v+s.helperProportions.height;for(d=s.snapElements.length-1;d>=0;d--)l=s.snapElements[d].left-s.margins.left,h=l+s.snapElements[d].width,c=s.snapElements[d].top-s.margins.top,u=c+s.snapElements[d].height,l-g>_||m>h+g||c-g>b||v>u+g||!t.contains(s.snapElements[d].item.ownerDocument,s.snapElements[d].item)?(s.snapElements[d].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=!1):("inner"!==f.snapMode&&(n=g>=Math.abs(c-b),o=g>=Math.abs(u-v),a=g>=Math.abs(l-_),r=g>=Math.abs(h-m),n&&(i.position.top=s._convertPositionTo("relative",{top:c-s.helperProportions.height,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h}).left)),p=n||o||a||r,"outer"!==f.snapMode&&(n=g>=Math.abs(c-v),o=g>=Math.abs(u-b),a=g>=Math.abs(l-m),r=g>=Math.abs(h-_),n&&(i.position.top=s._convertPositionTo("relative",{top:c,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h-s.helperProportions.width}).left)),!s.snapElements[d].snapping&&(n||o||a||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=n||o||a||r||p)}}),t.ui.plugin.add("draggable","stack",{start:function(e,i,s){var n,o=s.options,a=t.makeArray(t(o.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});a.length&&(n=parseInt(t(a[0]).css("zIndex"),10)||0,t(a).each(function(e){t(this).css("zIndex",n+e)}),this.css("zIndex",n+a.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("zIndex")&&(o._zIndex=n.css("zIndex")),n.css("zIndex",o.zIndex)},stop:function(e,i,s){var n=s.options;n._zIndex&&t(i.helper).css("zIndex",n._zIndex)}}),t.ui.draggable,t.widget("ui.droppable",{version:"1.11.4",widgetEventPrefix:"drop",options:{accept:"*",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var e,i=this.options,s=i.accept;this.isover=!1,this.isout=!0,this.accept=t.isFunction(s)?s:function(t){return t.is(s)},this.proportions=function(){return arguments.length?(e=arguments[0],void 0):e?e:e={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},this._addToManager(i.scope),i.addClasses&&this.element.addClass("ui-droppable")},_addToManager:function(e){t.ui.ddmanager.droppables[e]=t.ui.ddmanager.droppables[e]||[],t.ui.ddmanager.droppables[e].push(this)},_splice:function(t){for(var e=0;t.length>e;e++)t[e]===this&&t.splice(e,1)},_destroy:function(){var e=t.ui.ddmanager.droppables[this.options.scope];this._splice(e),this.element.removeClass("ui-droppable ui-droppable-disabled")},_setOption:function(e,i){if("accept"===e)this.accept=t.isFunction(i)?i:function(t){return t.is(i)};else if("scope"===e){var s=t.ui.ddmanager.droppables[this.options.scope];this._splice(s),this._addToManager(i)}this._super(e,i)},_activate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),i&&this._trigger("activate",e,this.ui(i))},_deactivate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),i&&this._trigger("deactivate",e,this.ui(i))},_over:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger("over",e,this.ui(i)))},_out:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("out",e,this.ui(i)))},_drop:function(e,i){var s=i||t.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var i=t(this).droppable("instance");return i.options.greedy&&!i.options.disabled&&i.options.scope===s.options.scope&&i.accept.call(i.element[0],s.currentItem||s.element)&&t.ui.intersect(s,t.extend(i,{offset:i.element.offset()}),i.options.tolerance,e)?(n=!0,!1):void 0}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("drop",e,this.ui(s)),this.element):!1):!1},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}}}),t.ui.intersect=function(){function t(t,e,i){return t>=e&&e+i>t}return function(e,i,s,n){if(!i.offset)return!1;var o=(e.positionAbs||e.position.absolute).left+e.margins.left,a=(e.positionAbs||e.position.absolute).top+e.margins.top,r=o+e.helperProportions.width,l=a+e.helperProportions.height,h=i.offset.left,c=i.offset.top,u=h+i.proportions().width,d=c+i.proportions().height;switch(s){case"fit":return o>=h&&u>=r&&a>=c&&d>=l;case"intersect":return o+e.helperProportions.width/2>h&&u>r-e.helperProportions.width/2&&a+e.helperProportions.height/2>c&&d>l-e.helperProportions.height/2;case"pointer":return t(n.pageY,c,i.proportions().height)&&t(n.pageX,h,i.proportions().width);case"touch":return(a>=c&&d>=a||l>=c&&d>=l||c>a&&l>d)&&(o>=h&&u>=o||r>=h&&u>=r||h>o&&r>u);default:return!1}}}(),t.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(e,i){var s,n,o=t.ui.ddmanager.droppables[e.options.scope]||[],a=i?i.type:null,r=(e.currentItem||e.element).find(":data(ui-droppable)").addBack();t:for(s=0;o.length>s;s++)if(!(o[s].options.disabled||e&&!o[s].accept.call(o[s].element[0],e.currentItem||e.element))){for(n=0;r.length>n;n++)if(r[n]===o[s].element[0]){o[s].proportions().height=0;continue t}o[s].visible="none"!==o[s].element.css("display"),o[s].visible&&("mousedown"===a&&o[s]._activate.call(o[s],i),o[s].offset=o[s].element.offset(),o[s].proportions({width:o[s].element[0].offsetWidth,height:o[s].element[0].offsetHeight}))}},drop:function(e,i){var s=!1;return t.each((t.ui.ddmanager.droppables[e.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&t.ui.intersect(e,this,this.options.tolerance,i)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(e,i){e.element.parentsUntil("body").bind("scroll.droppable",function(){e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)})},drag:function(e,i){e.options.refreshPositions&&t.ui.ddmanager.prepareOffsets(e,i),t.each(t.ui.ddmanager.droppables[e.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,o,a=t.ui.intersect(e,this,this.options.tolerance,i),r=!a&&this.isover?"isout":a&&!this.isover?"isover":null;r&&(this.options.greedy&&(n=this.options.scope,o=this.element.parents(":data(ui-droppable)").filter(function(){return t(this).droppable("instance").options.scope===n}),o.length&&(s=t(o[0]).droppable("instance"),s.greedyChild="isover"===r)),s&&"isover"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this["isout"===r?"isover":"isout"]=!1,this["isover"===r?"_over":"_out"].call(this,i),s&&"isout"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(e,i){e.element.parentsUntil("body").unbind("scroll.droppable"),e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)}},t.ui.droppable,t.widget("ui.resizable",t.ui.mouse,{version:"1.11.4",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseInt(t,10)||0},_isNumber:function(t){return!isNaN(parseInt(t,10))},_hasScroll:function(e,i){if("hidden"===t(e).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",n=!1;return e[s]>0?!0:(e[s]=1,n=e[s]>0,e[s]=0,n)},_create:function(){var e,i,s,n,o,a=this,r=this.options;if(this.element.addClass("ui-resizable"),t.extend(this,{_aspectRatio:!!r.aspectRatio,aspectRatio:r.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:r.helper||r.ghost||r.animate?r.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css("marginLeft"),marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css({margin:this.originalElement.css("margin")}),this._proportionallyResize()),this.handles=r.handles||(t(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=t(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),e=this.handles.split(","),this.handles={},i=0;e.length>i;i++)s=t.trim(e[i]),o="ui-resizable-"+s,n=t("<div class='ui-resizable-handle "+o+"'></div>"),n.css({zIndex:r.zIndex}),"se"===s&&n.addClass("ui-icon ui-icon-gripsmall-diagonal-se"),this.handles[s]=".ui-resizable-"+s,this.element.append(n);this._renderAxis=function(e){var i,s,n,o;e=e||this.element;for(i in this.handles)this.handles[i].constructor===String?this.handles[i]=this.element.children(this.handles[i]).first().show():(this.handles[i].jquery||this.handles[i].nodeType)&&(this.handles[i]=t(this.handles[i]),this._on(this.handles[i],{mousedown:a._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=t(this.handles[i],this.element),o=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),e.css(n,o),this._proportionallyResize()),this._handles=this._handles.add(this.handles[i])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.mouseover(function(){a.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),a.axis=n&&n[1]?n[1]:"se")}),r.autoHide&&(this._handles.hide(),t(this.element).addClass("ui-resizable-autohide").mouseenter(function(){r.disabled||(t(this).removeClass("ui-resizable-autohide"),a._handles.show())}).mouseleave(function(){r.disabled||a.resizing||(t(this).addClass("ui-resizable-autohide"),a._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var e,i=function(e){t(e).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_mouseCapture:function(e){var i,s,n=!1;for(i in this.handles)s=t(this.handles[i])[0],(s===e.target||t.contains(s,e.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(e){var i,s,n,o=this.options,a=this.element;return this.resizing=!0,this._renderProxy(),i=this._num(this.helper.css("left")),s=this._num(this.helper.css("top")),o.containment&&(i+=t(o.containment).scrollLeft()||0,s+=t(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:i,top:s},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:a.width(),height:a.height()},this.originalSize=this._helper?{width:a.outerWidth(),height:a.outerHeight()}:{width:a.width(),height:a.height()},this.sizeDiff={width:a.outerWidth()-a.width(),height:a.outerHeight()-a.height()},this.originalPosition={left:i,top:s},this.originalMousePosition={left:e.pageX,top:e.pageY},this.aspectRatio="number"==typeof o.aspectRatio?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,n=t(".ui-resizable-"+this.axis).css("cursor"),t("body").css("cursor","auto"===n?this.axis+"-resize":n),a.addClass("ui-resizable-resizing"),this._propagate("start",e),!0},_mouseDrag:function(e){var i,s,n=this.originalMousePosition,o=this.axis,a=e.pageX-n.left||0,r=e.pageY-n.top||0,l=this._change[o];return this._updatePrevProperties(),l?(i=l.apply(this,[e,a,r]),this._updateVirtualBoundaries(e.shiftKey),(this._aspectRatio||e.shiftKey)&&(i=this._updateRatio(i,e)),i=this._respectSize(i,e),this._updateCache(i),this._propagate("resize",e),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),t.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger("resize",e,this.ui()),this._applyChanges()),!1):!1},_mouseStop:function(e){this.resizing=!1;var i,s,n,o,a,r,l,h=this.options,c=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&this._hasScroll(i[0],"left")?0:c.sizeDiff.height,o=s?0:c.sizeDiff.width,a={width:c.helper.width()-o,height:c.helper.height()-n},r=parseInt(c.element.css("left"),10)+(c.position.left-c.originalPosition.left)||null,l=parseInt(c.element.css("top"),10)+(c.position.top-c.originalPosition.top)||null,h.animate||this.element.css(t.extend(a,{top:l,left:r})),c.helper.height(c.size.height),c.helper.width(c.size.width),this._helper&&!h.animate&&this._proportionallyResize()),t("body").css("cursor","auto"),this.element.removeClass("ui-resizable-resizing"),this._propagate("stop",e),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px"),this.helper.css(t),t},_updateVirtualBoundaries:function(t){var e,i,s,n,o,a=this.options;o={minWidth:this._isNumber(a.minWidth)?a.minWidth:0,maxWidth:this._isNumber(a.maxWidth)?a.maxWidth:1/0,minHeight:this._isNumber(a.minHeight)?a.minHeight:0,maxHeight:this._isNumber(a.maxHeight)?a.maxHeight:1/0},(this._aspectRatio||t)&&(e=o.minHeight*this.aspectRatio,s=o.minWidth/this.aspectRatio,i=o.maxHeight*this.aspectRatio,n=o.maxWidth/this.aspectRatio,e>o.minWidth&&(o.minWidth=e),s>o.minHeight&&(o.minHeight=s),o.maxWidth>i&&(o.maxWidth=i),o.maxHeight>n&&(o.maxHeight=n)),this._vBoundaries=o},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.position.top+this.size.height,h=/sw|nw|w/.test(i),c=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&c&&(t.top=l-e.minHeight),n&&c&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];4>e;e++)i[e]=parseInt(s[e],10)||0,i[e]+=parseInt(n[e],10)||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;this._proportionallyResizeElements.length>e;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var e=this.element,i=this.options;this.elementOffset=e.offset(),this._helper?(this.helper=this.helper||t("<div style='overflow:hidden;'></div>"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize,s=this.originalPosition;return{left:s.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},sw:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[e,i,s]))},ne:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},nw:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[e,i,s]))}},_propagate:function(e,i){t.ui.plugin.call(this,e,[i,this.ui()]),"resize"!==e&&this._trigger(e,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),t.ui.plugin.add("resizable","animate",{stop:function(e){var i=t(this).resizable("instance"),s=i.options,n=i._proportionallyResizeElements,o=n.length&&/textarea/i.test(n[0].nodeName),a=o&&i._hasScroll(n[0],"left")?0:i.sizeDiff.height,r=o?0:i.sizeDiff.width,l={width:i.size.width-r,height:i.size.height-a},h=parseInt(i.element.css("left"),10)+(i.position.left-i.originalPosition.left)||null,c=parseInt(i.element.css("top"),10)+(i.position.top-i.originalPosition.top)||null;i.element.animate(t.extend(l,c&&h?{top:c,left:h}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseInt(i.element.css("width"),10),height:parseInt(i.element.css("height"),10),top:parseInt(i.element.css("top"),10),left:parseInt(i.element.css("left"),10)};n&&n.length&&t(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",e)}})}}),t.ui.plugin.add("resizable","containment",{start:function(){var e,i,s,n,o,a,r,l=t(this).resizable("instance"),h=l.options,c=l.element,u=h.containment,d=u instanceof t?u.get(0):/parent/.test(u)?c.parent().get(0):u;d&&(l.containerElement=t(d),/document/.test(u)||u===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:t(document),left:0,top:0,width:t(document).width(),height:t(document).height()||document.body.parentNode.scrollHeight}):(e=t(d),i=[],t(["Top","Right","Left","Bottom"]).each(function(t,s){i[t]=l._num(e.css("padding"+s))}),l.containerOffset=e.offset(),l.containerPosition=e.position(),l.containerSize={height:e.innerHeight()-i[3],width:e.innerWidth()-i[1]},s=l.containerOffset,n=l.containerSize.height,o=l.containerSize.width,a=l._hasScroll(d,"left")?d.scrollWidth:o,r=l._hasScroll(d)?d.scrollHeight:n,l.parentData={element:d,left:s.left,top:s.top,width:a,height:r}))},resize:function(e){var i,s,n,o,a=t(this).resizable("instance"),r=a.options,l=a.containerOffset,h=a.position,c=a._aspectRatio||e.shiftKey,u={top:0,left:0},d=a.containerElement,p=!0;d[0]!==document&&/static/.test(d.css("position"))&&(u=l),h.left<(a._helper?l.left:0)&&(a.size.width=a.size.width+(a._helper?a.position.left-l.left:a.position.left-u.left),c&&(a.size.height=a.size.width/a.aspectRatio,p=!1),a.position.left=r.helper?l.left:0),h.top<(a._helper?l.top:0)&&(a.size.height=a.size.height+(a._helper?a.position.top-l.top:a.position.top),c&&(a.size.width=a.size.height*a.aspectRatio,p=!1),a.position.top=a._helper?l.top:0),n=a.containerElement.get(0)===a.element.parent().get(0),o=/relative|absolute/.test(a.containerElement.css("position")),n&&o?(a.offset.left=a.parentData.left+a.position.left,a.offset.top=a.parentData.top+a.position.top):(a.offset.left=a.element.offset().left,a.offset.top=a.element.offset().top),i=Math.abs(a.sizeDiff.width+(a._helper?a.offset.left-u.left:a.offset.left-l.left)),s=Math.abs(a.sizeDiff.height+(a._helper?a.offset.top-u.top:a.offset.top-l.top)),i+a.size.width>=a.parentData.width&&(a.size.width=a.parentData.width-i,c&&(a.size.height=a.size.width/a.aspectRatio,p=!1)),s+a.size.height>=a.parentData.height&&(a.size.height=a.parentData.height-s,c&&(a.size.width=a.size.height*a.aspectRatio,p=!1)),p||(a.position.left=a.prevPosition.left,a.position.top=a.prevPosition.top,a.size.width=a.prevSize.width,a.size.height=a.prevSize.height)},stop:function(){var e=t(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.containerPosition,o=e.containerElement,a=t(e.helper),r=a.offset(),l=a.outerWidth()-e.sizeDiff.width,h=a.outerHeight()-e.sizeDiff.height;e._helper&&!i.animate&&/relative/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h}),e._helper&&!i.animate&&/static/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h})}}),t.ui.plugin.add("resizable","alsoResize",{start:function(){var e=t(this).resizable("instance"),i=e.options;t(i.alsoResize).each(function(){var e=t(this);e.data("ui-resizable-alsoresize",{width:parseInt(e.width(),10),height:parseInt(e.height(),10),left:parseInt(e.css("left"),10),top:parseInt(e.css("top"),10)})})},resize:function(e,i){var s=t(this).resizable("instance"),n=s.options,o=s.originalSize,a=s.originalPosition,r={height:s.size.height-o.height||0,width:s.size.width-o.width||0,top:s.position.top-a.top||0,left:s.position.left-a.left||0};t(n.alsoResize).each(function(){var e=t(this),s=t(this).data("ui-resizable-alsoresize"),n={},o=e.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];t.each(o,function(t,e){var i=(s[e]||0)+(r[e]||0);i&&i>=0&&(n[e]=i||null)}),e.css(n)})},stop:function(){t(this).removeData("resizable-alsoresize")}}),t.ui.plugin.add("resizable","ghost",{start:function(){var e=t(this).resizable("instance"),i=e.options,s=e.size;e.ghost=e.originalElement.clone(),e.ghost.css({opacity:.25,display:"block",position:"relative",height:s.height,width:s.width,margin:0,left:0,top:0}).addClass("ui-resizable-ghost").addClass("string"==typeof i.ghost?i.ghost:""),e.ghost.appendTo(e.helper)},resize:function(){var e=t(this).resizable("instance");e.ghost&&e.ghost.css({position:"relative",height:e.size.height,width:e.size.width})},stop:function(){var e=t(this).resizable("instance");e.ghost&&e.helper&&e.helper.get(0).removeChild(e.ghost.get(0))}}),t.ui.plugin.add("resizable","grid",{resize:function(){var e,i=t(this).resizable("instance"),s=i.options,n=i.size,o=i.originalSize,a=i.originalPosition,r=i.axis,l="number"==typeof s.grid?[s.grid,s.grid]:s.grid,h=l[0]||1,c=l[1]||1,u=Math.round((n.width-o.width)/h)*h,d=Math.round((n.height-o.height)/c)*c,p=o.width+u,f=o.height+d,g=s.maxWidth&&p>s.maxWidth,m=s.maxHeight&&f>s.maxHeight,_=s.minWidth&&s.minWidth>p,v=s.minHeight&&s.minHeight>f;s.grid=l,_&&(p+=h),v&&(f+=c),g&&(p-=h),m&&(f-=c),/^(se|s|e)$/.test(r)?(i.size.width=p,i.size.height=f):/^(ne)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.top=a.top-d):/^(sw)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.left=a.left-u):((0>=f-c||0>=p-h)&&(e=i._getPaddingPlusBorderDimensions(this)),f-c>0?(i.size.height=f,i.position.top=a.top-d):(f=c-e.height,i.size.height=f,i.position.top=a.top+o.height-f),p-h>0?(i.size.width=p,i.position.left=a.left-u):(p=h-e.width,i.size.width=p,i.position.left=a.left+o.width-p))}}),t.ui.resizable,t.widget("ui.selectable",t.ui.mouse,{version:"1.11.4",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var e,i=this;this.element.addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){e=t(i.options.filter,i.element[0]),e.addClass("ui-selectee"),e.each(function(){var e=t(this),i=e.offset();t.data(this,"selectable-item",{element:this,$element:e,left:i.left,top:i.top,right:i.left+e.outerWidth(),bottom:i.top+e.outerHeight(),startselected:!1,selected:e.hasClass("ui-selected"),selecting:e.hasClass("ui-selecting"),unselecting:e.hasClass("ui-unselecting")})})},this.refresh(),this.selectees=e.addClass("ui-selectee"),this._mouseInit(),this.helper=t("<div class='ui-selectable-helper'></div>")},_destroy:function(){this.selectees.removeClass("ui-selectee").removeData("selectable-item"),this.element.removeClass("ui-selectable ui-selectable-disabled"),this._mouseDestroy()},_mouseStart:function(e){var i=this,s=this.options;this.opos=[e.pageX,e.pageY],this.options.disabled||(this.selectees=t(s.filter,this.element[0]),this._trigger("start",e),t(s.appendTo).append(this.helper),this.helper.css({left:e.pageX,top:e.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var s=t.data(this,"selectable-item");s.startselected=!0,e.metaKey||e.ctrlKey||(s.$element.removeClass("ui-selected"),s.selected=!1,s.$element.addClass("ui-unselecting"),s.unselecting=!0,i._trigger("unselecting",e,{unselecting:s.element}))}),t(e.target).parents().addBack().each(function(){var s,n=t.data(this,"selectable-item");return n?(s=!e.metaKey&&!e.ctrlKey||!n.$element.hasClass("ui-selected"),n.$element.removeClass(s?"ui-unselecting":"ui-selected").addClass(s?"ui-selecting":"ui-unselecting"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger("selecting",e,{selecting:n.element}):i._trigger("unselecting",e,{unselecting:n.element}),!1):void 0}))},_mouseDrag:function(e){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,o=this.opos[0],a=this.opos[1],r=e.pageX,l=e.pageY;return o>r&&(i=r,r=o,o=i),a>l&&(i=l,l=a,a=i),this.helper.css({left:o,top:a,width:r-o,height:l-a}),this.selectees.each(function(){var i=t.data(this,"selectable-item"),h=!1;
        i&&i.element!==s.element[0]&&("touch"===n.tolerance?h=!(i.left>r||o>i.right||i.top>l||a>i.bottom):"fit"===n.tolerance&&(h=i.left>o&&r>i.right&&i.top>a&&l>i.bottom),h?(i.selected&&(i.$element.removeClass("ui-selected"),i.selected=!1),i.unselecting&&(i.$element.removeClass("ui-unselecting"),i.unselecting=!1),i.selecting||(i.$element.addClass("ui-selecting"),i.selecting=!0,s._trigger("selecting",e,{selecting:i.element}))):(i.selecting&&((e.metaKey||e.ctrlKey)&&i.startselected?(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.$element.addClass("ui-selected"),i.selected=!0):(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.startselected&&(i.$element.addClass("ui-unselecting"),i.unselecting=!0),s._trigger("unselecting",e,{unselecting:i.element}))),i.selected&&(e.metaKey||e.ctrlKey||i.startselected||(i.$element.removeClass("ui-selected"),i.selected=!1,i.$element.addClass("ui-unselecting"),i.unselecting=!0,s._trigger("unselecting",e,{unselecting:i.element})))))}),!1}},_mouseStop:function(e){var i=this;return this.dragged=!1,t(".ui-unselecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-unselecting"),s.unselecting=!1,s.startselected=!1,i._trigger("unselected",e,{unselected:s.element})}),t(".ui-selecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-selecting").addClass("ui-selected"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger("selected",e,{selected:s.element})}),this._trigger("stop",e),this.helper.remove(),!1}}),t.widget("ui.sortable",t.ui.mouse,{version:"1.11.4",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return t>=e&&e+i>t},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this.element.addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){this.element.find(".ui-sortable-handle").removeClass("ui-sortable-handle"),t.each(this.items,function(){(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item).addClass("ui-sortable-handle")})},_destroy:function(){this.element.removeClass("ui-sortable ui-sortable-disabled").find(".ui-sortable-handle").removeClass("ui-sortable-handle"),this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):void 0}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this.helper.addClass("ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-this.document.scrollTop()<a.scrollSensitivity?r=this.document.scrollTop(this.document.scrollTop()-a.scrollSpeed):this.window.height()-(e.pageY-this.document.scrollTop())<a.scrollSensitivity&&(r=this.document.scrollTop(this.document.scrollTop()+a.scrollSpeed)),e.pageX-this.document.scrollLeft()<a.scrollSensitivity?r=this.document.scrollLeft(this.document.scrollLeft()-a.scrollSpeed):this.window.width()-(e.pageX-this.document.scrollLeft())<a.scrollSensitivity&&(r=this.document.scrollLeft(this.document.scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper"):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+h>r&&l>s+h,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&l>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var e="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),i="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width),s=e&&i,n=this._getDragVerticalDirection(),o=this._getDragHorizontalDirection();return s?this.floating?o&&"right"===o||"down"===n?2:1:n&&("down"===n?2:1):!1},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),s=this._getDragVerticalDirection(),n=this._getDragHorizontalDirection();return this.floating&&n?"right"===n&&i||"left"===n&&!i:s&&("down"===s&&e||"up"===s&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){function i(){r.push(this)}var s,n,o,a,r=[],l=[],h=this._connectWith();if(h&&e)for(s=h.length-1;s>=0;s--)for(o=t(h[s],this.document[0]),n=o.length-1;n>=0;n--)a=t.data(o[n],this.widgetFullName),a&&a!==this&&!a.options.disabled&&l.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(l.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),s=l.length-1;s>=0;s--)l[s][0].each(i);return t(r)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,l,h,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i],this.document[0]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,h=r.length;h>s;s++)l=t(r[s]),l.data(this.widgetName+"-item",a),c.push({item:l,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.floating=this.items.length?"x"===this.options.axis||this._isFloating(this.items[0].item):!1,this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]).addClass(i||e.currentItem[0].className+" ui-sortable-placeholder").removeClass("ui-sortable-helper");return"tbody"===s?e._createTrPlaceholder(e.currentItem.find("tr").eq(0),t("<tr>",e.document[0]).appendTo(n)):"tr"===s?e._createTrPlaceholder(e.currentItem,n):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_createTrPlaceholder:function(e,i){var s=this;e.children().each(function(){t("<td>&#160;</td>",s.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(i)})},_contactContainers:function(e){var i,s,n,o,a,r,l,h,c,u,d=null,p=null;for(i=this.containers.length-1;i>=0;i--)if(!t.contains(this.currentItem[0],this.containers[i].element[0]))if(this._intersectsWith(this.containers[i].containerCache)){if(d&&t.contains(this.containers[i].element[0],d.element[0]))continue;d=this.containers[i],p=i}else this.containers[i].containerCache.over&&(this.containers[i]._trigger("out",e,this._uiHash(this)),this.containers[i].containerCache.over=0);if(d)if(1===this.containers.length)this.containers[p].containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1);else{for(n=1e4,o=null,c=d.floating||this._isFloating(this.currentItem),a=c?"left":"top",r=c?"width":"height",u=c?"clientX":"clientY",s=this.items.length-1;s>=0;s--)t.contains(this.containers[p].element[0],this.items[s].item[0])&&this.items[s].item[0]!==this.currentItem[0]&&(l=this.items[s].item.offset()[a],h=!1,e[u]-l>this.items[s][r]/2&&(h=!0),n>Math.abs(e[u]-l)&&(n=Math.abs(e[u]-l),o=this.items[s],this.direction=h?"up":"down"));if(!o&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[p])return this.currentContainer.containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash()),this.currentContainer.containerCache.over=1),void 0;o?this._rearrange(e,o,null,!0):this._rearrange(e,null,this.containers[p].element,!0),this._trigger("change",e,this._uiHash()),this.containers[p]._trigger("change",e,this._uiHash(this)),this.currentContainer=this.containers[p],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===n.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===n.containment?this.document.width():this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,l=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():l?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():l?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){function i(t,e,i){return function(s){i._trigger(t,s,e._uiHash(e))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)("auto"===this._storedCSS[s]||"static"===this._storedCSS[s])&&(this._storedCSS[s]="");this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&n.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||n.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(n.push(function(t){this._trigger("remove",t,this._uiHash())}),n.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)e||n.push(i("deactivate",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i("out",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})});; /** ----------------- **/ 
 /*! js-cookie v2.1.1 | MIT */
!function(a){if("function"==typeof define&&define.amd)define(a);else if("object"==typeof exports)module.exports=a();else{var b=window.Cookies,c=window.Cookies=a();c.noConflict=function(){return window.Cookies=b,c}}}(function(){function a(){for(var a=0,b={};a<arguments.length;a++){var c=arguments[a];for(var d in c)b[d]=c[d]}return b}function b(c){function d(b,e,f){var g;if("undefined"!=typeof document){if(arguments.length>1){if(f=a({path:"/"},d.defaults,f),"number"==typeof f.expires){var h=new Date;h.setMilliseconds(h.getMilliseconds()+864e5*f.expires),f.expires=h}try{g=JSON.stringify(e),/^[\{\[]/.test(g)&&(e=g)}catch(i){}return e=c.write?c.write(e,b):encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),b=encodeURIComponent(String(b)),b=b.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),b=b.replace(/[\(\)]/g,escape),document.cookie=[b,"=",e,f.expires&&"; expires="+f.expires.toUTCString(),f.path&&"; path="+f.path,f.domain&&"; domain="+f.domain,f.secure?"; secure":""].join("")}b||(g={});for(var j=document.cookie?document.cookie.split("; "):[],k=/(%[0-9A-Z]{2})+/g,l=0;l<j.length;l++){var m=j[l].split("="),n=m[0].replace(k,decodeURIComponent),o=m.slice(1).join("=");'"'===o.charAt(0)&&(o=o.slice(1,-1));try{if(o=c.read?c.read(o,n):c(o,n)||o.replace(k,decodeURIComponent),this.json)try{o=JSON.parse(o)}catch(i){}if(b===n){g=o;break}b||(g[n]=o)}catch(i){}}return g}}return d.set=d,d.get=function(a){return d(a)},d.getJSON=function(){return d.apply({json:!0},[].slice.call(arguments))},d.defaults={},d.remove=function(b,c){d(b,"",a(c,{expires:-1}))},d.withConverter=b,d}return b(function(){})});; /** ----------------- **/ 
 !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).libphonenumber={})}(this,(function(t){"use strict";var e={version:4,country_calling_codes:{1:["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],381:["RS"],382:["ME"],383:["XK"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],880:["BD"],886:["TW"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},countries:{AC:["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6],0,0,0,0,0,0,0,[0,["4\\d{4}",[5]]]],AD:["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["690\\d{6}|[356]\\d{5}",[6,9]]]],AE:["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0",0,0,0,0,0,[0,["5[024-68]\\d{7}",[9]]]],AF:["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0",0,0,0,0,0,[0,["7\\d{8}"]]],AG:["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268",[0,["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"]]],AI:["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264",[0,["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"]]],AL:["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[78][2-9]|9\\d)\\d{6}",[9]]]],AM:["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"]]],AO:["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],0,0,0,0,0,0,[0,["9[1-59]\\d{7}"]]],AR:["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1",0,0,[0,["93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"]]],AS:["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684",[0,["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"]]],AT:["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",[7,8,9,10,11,12,13]]]],AU:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[0,["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]]],"0011"],AW:["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],0,0,0,0,0,0,[0,["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"]]],AX:["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",[0,["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]]],"00"],AZ:["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0",0,0,0,0,0,[0,["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"]]],BA:["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0",0,0,0,0,0,[0,["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"]]],BB:["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246",[0,["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"]]],BD:["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",[10]]]],BE:["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0",0,0,0,0,0,[0,["4[5-9]\\d{7}",[9]]]],BF:["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],0,0,0,0,0,0,[0,["(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}"]]],BG:["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0",0,0,0,0,0,[0,["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",[8,9]]]],BH:["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]],0,0,0,0,0,0,[0,["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"]]],BI:["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],0,0,0,0,0,0,[0,["(?:29|[67][125-9])\\d{6}"]]],BJ:["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]],0,0,0,0,0,0,[0,["(?:4[0-356]|[56]\\d|9[013-9])\\d{6}"]]],BL:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[0,["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"]]],BM:["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441",[0,["441(?:[2378]\\d|5[0-39]|92)\\d{5}"]]],BN:["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],0,0,0,0,0,0,[0,["(?:22[89]|[78]\\d\\d)\\d{4}"]]],BO:["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?",0,0,0,[0,["[67]\\d{7}",[8]]]],BQ:["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]",[0,["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]],BR:["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",0,0,[0,["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",[10,11]]]],BS:["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242",[0,["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"]]],BT:["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],0,0,0,0,0,0,[0,["(?:1[67]|77)\\d{6}",[8]]]],BW:["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}",[8]]]],BY:["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,[0,["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",[9]]],"8~10"],BZ:["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],0,0,0,0,0,0,[0,["6[0-35-7]\\d{5}",[7]]]],CA:["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[0,["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]]]],CC:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[0,["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]]],"0011"],CD:["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"]]],CF:["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],0,0,0,0,0,0,[0,["7[024-7]\\d{6}"]]],CG:["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],0,0,0,0,0,0,[0,["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"]]],CH:["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0",0,0,0,0,0,[0,["7[35-9]\\d{7}"]]],CI:["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],0,0,0,0,0,0,[0,["0[157]\\d{8}"]]],CK:["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],0,0,0,0,0,0,[0,["[578]\\d{4}"]]],CL:["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],0,0,0,0,0,0,[0,["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",[9]]]],CM:["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]],0,0,0,0,0,0,[0,["(?:24[23]|6[25-9]\\d)\\d{6}",[9]]]],CN:["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,[0,["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",[11]]],"00"],CO:["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0(4(?:[14]4|56)|[579])?",0,0,0,[0,["3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",[10]]]],CR:["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))",0,0,0,[0,["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",[8]]]],CU:["53","119","[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:5\\d|63)\\d{6}",[8]]]],CV:["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],0,0,0,0,0,0,[0,["(?:36|5[1-389]|9\\d)\\d{5}"]]],CW:["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]",[0,["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"]]],CX:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[0,["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]]],"0011"],CY:["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],0,0,0,0,0,0,[0,["9(?:10|[4-79]\\d)\\d{5}"]]],CZ:["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,[0,["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"]]],DE:["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0",0,0,0,0,0,[0,["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",[10,11]]]],DJ:["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],0,0,0,0,0,0,[0,["77\\d{6}"]]],DK:["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"]]],DM:["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767",[0,["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"]]],DO:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9",[0,["8[024]9[2-9]\\d{6}"]]],DZ:["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",[9]]]],EC:["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",[9]]]],EE:["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",[7,8]]]],EG:["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0",0,0,0,0,0,[0,["1[0-25]\\d{8}",[10]]]],EH:["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]",[0,["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"]]],ER:["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:17[1-3]|7\\d\\d)\\d{4}"]]],ES:["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],0,0,0,0,0,0,[0,["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"]]],ET:["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0",0,0,0,0,0,[0,["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]],FI:["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",[0,["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]]],"00"],FJ:["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,[0,["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",[7]]],"00"],FK:["500","00","[2-7]\\d{4}",[5],0,0,0,0,0,0,0,[0,["[56]\\d{4}"]]],FM:["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]],0,0,0,0,0,0,[0,["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]],FO:["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))",0,0,0,[0,["(?:[27][1-9]|5\\d|9[16])\\d{4}"]]],FR:["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"]]],GA:["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1",0,0,[0,["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]],GB:["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]]],0," x"],GD:["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473",[0,["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"]]],GE:["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0",0,0,0,0,0,[0,["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"]]],GF:["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["694(?:[0-249]\\d|3[0-8])\\d{4}"]]],GG:["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[0,["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]]]],GH:["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",[9]]]],GI:["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]],0,0,0,0,0,0,[0,["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]],GL:["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],0,0,0,0,0,0,[0,["[245]\\d{5}"]]],GM:["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:[23679]\\d|5[0-489])\\d{5}"]]],GN:["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]],0,0,0,0,0,0,[0,["6[0-356]\\d{7}",[9]]]],GP:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"]]],GQ:["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]],0,0,0,0,0,0,[0,["(?:222|55\\d)\\d{6}"]]],GR:["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["68[57-9]\\d{7}|(?:69|94)\\d{8}",[10]]]],GT:["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,["[3-5]\\d{7}",[8]]]],GU:["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([3-9]\\d{6})$|1","671$1",0,"671",[0,["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"]]],GW:["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],0,0,0,0,0,0,[0,["9(?:5\\d|6[569]|77)\\d{6}",[9]]]],GY:["592","001","9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}"]]],HK:["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,[0,["(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",[8]]],"00"],HN:["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],0,0,0,0,0,0,[0,["[37-9]\\d{7}",[8]]]],HR:["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}",[8,9]]]],HT:["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]],0,0,0,0,0,0,[0,["(?:[34]\\d|55)\\d{6}"]]],HU:["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06",0,0,0,0,0,[0,["(?:[257]0|3[01])\\d{7}",[9]]]],ID:["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["8[1-35-9]\\d{7,10}",[9,10,11,12]]]],IE:["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["8(?:22|[35-9]\\d)\\d{6}",[9]]]],IL:["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0",0,0,0,0,0,[0,["55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2[2-9]|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",[9]]]],IM:["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24",[0,["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"]]],IN:["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0",0,0,0,0,0,[0,["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",[10]]]],IO:["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]],0,0,0,0,0,0,[0,["38\\d{5}"]]],IQ:["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7[3-9]\\d{8}",[10]]]],IR:["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0",0,0,0,0,0,[0,["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",[10]]]],IS:["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[0,["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"]],"00"],IT:["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[0,["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]]]],JE:["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[0,["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"]]],JM:["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876",[0,["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"]]],JO:["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:[78][0-25-9]|9\\d)\\d{6}",[9]]]],JP:["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1",0,0,[0,["[7-9]0[1-9]\\d{7}",[10]]]],KE:["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",[9]]]],KG:["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",[9]]]],KH:["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",[8,9]]]],KI:["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0",0,0,0,0,0,[0,["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",[8]]]],KM:["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]],0,0,0,0,0,0,[0,["[34]\\d{6}"]]],KN:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869",[0,["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"]]],KP:["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0",0,0,0,0,0,[0,["19[1-3]\\d{7}",[10]]]],KR:["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?",0,0,0,[0,["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",[9,10]]]],KW:["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]],0,0,0,0,0,0,[0,["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",[8]]]],KY:["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345",[0,["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"]]],KZ:["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",[0,["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",[10]]],"8~10"],LA:["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",[10]]]],LB:["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0",0,0,0,0,0,[0,["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"]]],LC:["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758",[0,["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"]]],LI:["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0",0,0,0,[0,["(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"]]],LK:["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:[0-25-8]\\d|4[0-4])\\d{6}"]]],LR:["231","00","(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",[7,9]]]],LS:["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],0,0,0,0,0,0,[0,["[56]\\d{7}"]]],LT:["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]",0,0,0,[0,["6\\d{7}"]]],LU:["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",0,0,0,[0,["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",[9]]]],LV:["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]],0,0,0,0,0,0,[0,["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"]]],LY:["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0",0,0,0,0,0,[0,["9[1-6]\\d{7}"]]],MA:["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[1289]|389)","529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"]]],MC:["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0",0,0,0,0,0,[0,["4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"]]],MD:["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0",0,0,0,0,0,[0,["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"]]],ME:["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",[8]]]],MF:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[0,["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"]]],MG:["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1",0,0,[0,["3[2-47-9]\\d{7}"]]],MH:["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1",0,0,0,0,0,[0,["(?:(?:23|54)5|329|45[356])\\d{4}"]]],MK:["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"]]],ML:["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],0,0,0,0,0,0,[0,["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"]]],MM:["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0",0,0,0,0,0,[0,["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",[7,8,9,10]]]],MN:["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",[8]]]],MO:["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]],0,0,0,0,0,0,[0,["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",[8]]]],MP:["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670",[0,["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"]]],MQ:["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"]]],MR:["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]],0,0,0,0,0,0,[0,["[2-4][0-46-9]\\d{6}"]]],MS:["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664",[0,["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"]]],MT:["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],0,0,0,0,0,0,[0,["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"]]],MU:["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,[0,["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}",[8]]],"020"],MV:["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,[0,["(?:46[46]|[79]\\d\\d)\\d{4}",[7]]],"00"],MW:["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0",0,0,0,0,0,[0,["111\\d{6}|(?:31|77|[89][89])\\d{7}",[9]]]],MX:["52","0[09]","1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,[0,["657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"]],"00"],MY:["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0",0,0,0,0,0,[0,["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",[9,10]]]],MZ:["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["8[2-79]\\d{7}",[9]]]],NA:["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:60|8[1245])\\d{7}",[9]]]],NC:["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],0,0,0,0,0,0,[0,["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"]]],NE:["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]],0,0,0,0,0,0,[0,["(?:23|7[047]|[89]\\d)\\d{6}"]]],NF:["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1",0,0,[0,["(?:14|3[58])\\d{4}"]]],NG:["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",[10]]]],NI:["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],0,0,0,0,0,0,[0,["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"]]],NL:["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0",0,0,0,0,0,[0,["(?:6[1-58]|970\\d)\\d{7}",[9,11]]]],NO:["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]",[0,["(?:4[015-8]|9\\d)\\d{6}",[8]]]],NP:["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0",0,0,0,0,0,[0,["9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",[10]]]],NR:["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],0,0,0,0,0,0,[0,["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]],NU:["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]],0,0,0,0,0,0,[0,["888[4-9]\\d{3}",[7]]]],NZ:["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,[0,["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",[8,9,10]]],"00"],OM:["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]],0,0,0,0,0,0,[0,["1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",[8]]]],PA:["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",[7,8]]]],PE:["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,[0,["9\\d{8}",[9]]],"00"," Anexo "],PF:["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],0,0,0,0,0,0,[0,["8[7-9]\\d{6}",[8]]]],PG:["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,[0,["(?:7\\d|8[128])\\d{6}",[8]]],"00"],PH:["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0",0,0,0,0,0,[0,["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",[10]]]],PK:["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0",0,0,0,0,0,[0,["3(?:[0-24]\\d|3[0-79]|55|64)\\d{7}",[10]]]],PL:["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",[9]]]],PM:["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"]]],PR:["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939",[0,["(?:787|939)[2-9]\\d{6}"]]],PS:["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["5[69]\\d{7}",[9]]]],PT:["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],0,0,0,0,0,0,[0,["6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"]]],PW:["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]],PY:["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,[0,["9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",[9]]]],QA:["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]],0,0,0,0,0,0,[0,["[35-7]\\d{7}",[8]]]],RE:["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[0,["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))\\d{4}"]]],RO:["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,[0,["7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}",[9]]],0," int "],RS:["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[0-689]|7\\d)\\d{6,7}",[8,9,10]]]],RU:["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",[0,["9\\d{9}",[10]]],"8~10"],RW:["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0",0,0,0,0,0,[0,["7[237-9]\\d{7}",[9]]]],SA:["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0",0,0,0,0,0,[0,["579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",[9]]]],SB:["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],0,0,0,0,0,0,[0,["48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"]]],SC:["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,[0,["2[125-8]\\d{5}"]],"00"],SD:["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1[0-2]|9[0-3569])\\d{7}"]]],SE:["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0",0,0,0,0,0,[0,["7[02369]\\d{7}",[9]]]],SG:["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,["8(?:08[01]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",[8]]]],SH:["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]",[0,["[56]\\d{4}",[5]]]],SI:["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,[0,["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",[8]]],"00"],SJ:["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79",[0,["(?:4[015-8]|9\\d)\\d{6}",[8]]]],SK:["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0",0,0,0,0,0,[0,["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",[9]]]],SL:["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0",0,0,0,0,0,[0,["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]],SM:["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1",0,0,[0,["6[16]\\d{6}",[8]]]],SN:["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],0,0,0,0,0,0,[0,["7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"]]],SO:["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0",0,0,0,0,0,[0,["(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",[7,8,9]]]],SR:["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],0,0,0,0,0,0,[0,["(?:7[124-7]|8[124-9])\\d{5}",[7]]]],SS:["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:12|9[1257-9])\\d{7}"]]],ST:["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]],0,0,0,0,0,0,[0,["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]],SV:["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,[0,["[67]\\d{7}",[8]]]],SX:["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721",[0,["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"]]],SY:["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0",0,0,0,0,0,[0,["9[1-689]\\d{7}",[9]]]],SZ:["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]],0,0,0,0,0,0,[0,["7[6-9]\\d{6}",[8]]]],TA:["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],TC:["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649",[0,["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"]]],TD:["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,[0,["(?:6[0235689]|77|9\\d)\\d{6}"]],"00"],TG:["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],0,0,0,0,0,0,[0,["(?:7[019]|9[0-36-9])\\d{6}"]]],TH:["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",[9]]]],TJ:["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[04]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,[0,["(?:41[18]|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}"]],"8~10"],TK:["690","00","[2-47]\\d{3,6}",[4,5,6,7],0,0,0,0,0,0,0,[0,["7[2-4]\\d{2,5}"]]],TL:["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["7[2-8]\\d{6}",[8]]]],TM:["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,[0,["6\\d{7}"]],"8~10"],TN:["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],0,0,0,0,0,0,[0,["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"]]],TO:["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],0,0,0,0,0,0,[0,["(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",[7]]]],TR:["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0",0,0,0,0,0,[0,["56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",[10]]]],TT:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868",[0,["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"]]],TV:["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["(?:7[01]\\d|90)\\d{4}",[6,7]]]],TW:["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",[9]]],0,"#"],TZ:["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0",0,0,0,0,0,[0,["77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"]]],UA:["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",[9]]],"0~0"],UG:["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0",0,0,0,0,0,[0,["726[01]\\d{5}|7(?:[01578]\\d|20|36|4[0-4]|6[0-5]|9[89])\\d{6}"]]],US:["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[0,["5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"]]],UY:["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,[0,["9[1-9]\\d{6}",[8]]],"00"," int. "],UZ:["998","810","200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],"8",0,0,0,0,0,[0,["(?:(?:200[01]|(?:33|50|88|9[0-57-9])\\d\\d)\\d|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]],"8~10"],VA:["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698",[0,["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]]]],VC:["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784",[0,["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"]]],VE:["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0",0,0,0,0,0,[0,["4(?:1[24-8]|2[46])\\d{7}"]]],VG:["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284",[0,["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"]]],VI:["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340",[0,["340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"]]],VN:["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0",0,0,0,0,0,[0,["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",[9]]]],VU:["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],0,0,0,0,0,0,[0,["(?:[58]\\d|7[013-7])\\d{5}",[7]]]],WF:["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],0,0,0,0,0,0,[0,["(?:72|8[23])\\d{4}",[6]]]],WS:["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",[7,10]]]],XK:["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0",0,0,0,0,0,[0,["4[3-9]\\d{6}",[8]]]],YE:["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7[01378]\\d{7}",[9]]]],YT:["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[0,["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"]]],ZA:["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",[5,6,7,8,9]]]],ZM:["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:7[5-79]|9[5-8])\\d{7}"]]],ZW:["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:[178]\\d|3[1-9])\\d{6}",[9]]]]},nonGeographic:{800:["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],808:["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],870:["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],878:["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],881:["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],882:["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],883:["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],888:["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],979:["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};function n(t,n){var d=Array.prototype.slice.call(n);return d.push(e),t.apply(this,d)}function d(t){return d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},d(t)}function r(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}function a(t,e){if(e&&("object"===d(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return i(t)}function i(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function o(t){var e="function"==typeof Map?new Map:void 0;return o=function(t){if(null===t||(n=t,-1===Function.toString.call(n).indexOf("[native code]")))return t;var n;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==e){if(e.has(t))return e.get(t);e.set(t,d)}function d(){return $(t,arguments,c(this).constructor)}return d.prototype=Object.create(t.prototype,{constructor:{value:d,enumerable:!1,writable:!0,configurable:!0}}),l(d,t)},o(t)}function $(t,e,n){return $=u()?Reflect.construct:function(t,e,n){var d=[null];d.push.apply(d,e);var r=new(Function.bind.apply(t,d));return n&&l(r,n.prototype),r},$.apply(null,arguments)}function u(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}function l(t,e){return l=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},l(t,e)}function c(t){return c=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},c(t)}var s=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&l(t,e)}(f,t);var e,n,d,o,$,s=(e=f,n=u(),function(){var t,d=c(e);if(n){var r=c(this).constructor;t=Reflect.construct(d,arguments,r)}else t=d.apply(this,arguments);return a(this,t)});function f(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,f),e=s.call(this,t),Object.setPrototypeOf(i(e),f.prototype),e.name=e.constructor.name,e}return d=f,o&&r(d.prototype,o),$&&r(d,$),Object.defineProperty(d,"prototype",{writable:!1}),d}(o(Error)),f="0-9０-９٠-٩۰-۹",h="".concat("-‐-―−ー－").concat("／/").concat("．.").concat("  ­​⁠　").concat("()（）［］\\[\\]").concat("~⁓∼～"),y="+＋";function g(t,e){t=t.split("-"),e=e.split("-");for(var n=t[0].split("."),d=e[0].split("."),r=0;r<3;r++){var a=Number(n[r]),i=Number(d[r]);if(a>i)return 1;if(i>a)return-1;if(!isNaN(a)&&isNaN(i))return 1;if(isNaN(a)&&!isNaN(i))return-1}return t[1]&&e[1]?t[1]>e[1]?1:t[1]<e[1]?-1:0:!t[1]&&e[1]?1:t[1]&&!e[1]?-1:0}function m(t){return m="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},m(t)}function p(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function b(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}function v(t,e,n){return e&&b(t.prototype,e),n&&b(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var C=" ext. ",N=/^\d+$/,P=function(){function t(e){p(this,t),function(t){if(!t)throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");if(!I(t)||!I(t.countries))throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(I(t)?"an object of shape: { "+Object.keys(t).join(", ")+" }":"a "+A(t)+": "+t,"."))}(e),this.metadata=e,F.call(this,e)}return v(t,[{key:"getCountries",value:function(){return Object.keys(this.metadata.countries).filter((function(t){return"001"!==t}))}},{key:"getCountryMetadata",value:function(t){return this.metadata.countries[t]}},{key:"nonGeographic",value:function(){if(!(this.v1||this.v2||this.v3))return this.metadata.nonGeographic||this.metadata.nonGeographical}},{key:"hasCountry",value:function(t){return void 0!==this.getCountryMetadata(t)}},{key:"hasCallingCode",value:function(t){if(this.getCountryCodesForCallingCode(t))return!0;if(this.nonGeographic()){if(this.nonGeographic()[t])return!0}else{var e=this.countryCallingCodes()[t];if(e&&1===e.length&&"001"===e[0])return!0}}},{key:"isNonGeographicCallingCode",value:function(t){return this.nonGeographic()?!!this.nonGeographic()[t]:!this.getCountryCodesForCallingCode(t)}},{key:"country",value:function(t){return this.selectNumberingPlan(t)}},{key:"selectNumberingPlan",value:function(t,e){if(t&&N.test(t)&&(e=t,t=null),t&&"001"!==t){if(!this.hasCountry(t))throw new Error("Unknown country: ".concat(t));this.numberingPlan=new O(this.getCountryMetadata(t),this)}else if(e){if(!this.hasCallingCode(e))throw new Error("Unknown calling code: ".concat(e));this.numberingPlan=new O(this.getNumberingPlanMetadata(e),this)}else this.numberingPlan=void 0;return this}},{key:"getCountryCodesForCallingCode",value:function(t){var e=this.countryCallingCodes()[t];if(e){if(1===e.length&&3===e[0].length)return;return e}}},{key:"getCountryCodeForCallingCode",value:function(t){var e=this.getCountryCodesForCallingCode(t);if(e)return e[0]}},{key:"getNumberingPlanMetadata",value:function(t){var e=this.getCountryCodeForCallingCode(t);if(e)return this.getCountryMetadata(e);if(this.nonGeographic()){var n=this.nonGeographic()[t];if(n)return n}else{var d=this.countryCallingCodes()[t];if(d&&1===d.length&&"001"===d[0])return this.metadata.countries["001"]}}},{key:"countryCallingCode",value:function(){return this.numberingPlan.callingCode()}},{key:"IDDPrefix",value:function(){return this.numberingPlan.IDDPrefix()}},{key:"defaultIDDPrefix",value:function(){return this.numberingPlan.defaultIDDPrefix()}},{key:"nationalNumberPattern",value:function(){return this.numberingPlan.nationalNumberPattern()}},{key:"possibleLengths",value:function(){return this.numberingPlan.possibleLengths()}},{key:"formats",value:function(){return this.numberingPlan.formats()}},{key:"nationalPrefixForParsing",value:function(){return this.numberingPlan.nationalPrefixForParsing()}},{key:"nationalPrefixTransformRule",value:function(){return this.numberingPlan.nationalPrefixTransformRule()}},{key:"leadingDigits",value:function(){return this.numberingPlan.leadingDigits()}},{key:"hasTypes",value:function(){return this.numberingPlan.hasTypes()}},{key:"type",value:function(t){return this.numberingPlan.type(t)}},{key:"ext",value:function(){return this.numberingPlan.ext()}},{key:"countryCallingCodes",value:function(){return this.v1?this.metadata.country_phone_code_to_countries:this.metadata.country_calling_codes}},{key:"chooseCountryByCountryCallingCode",value:function(t){return this.selectNumberingPlan(t)}},{key:"hasSelectedNumberingPlan",value:function(){return void 0!==this.numberingPlan}}]),t}(),O=function(){function t(e,n){p(this,t),this.globalMetadataObject=n,this.metadata=e,F.call(this,n.metadata)}return v(t,[{key:"callingCode",value:function(){return this.metadata[0]}},{key:"getDefaultCountryMetadataForRegion",value:function(){return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode())}},{key:"IDDPrefix",value:function(){if(!this.v1&&!this.v2)return this.metadata[1]}},{key:"defaultIDDPrefix",value:function(){if(!this.v1&&!this.v2)return this.metadata[12]}},{key:"nationalNumberPattern",value:function(){return this.v1||this.v2?this.metadata[1]:this.metadata[2]}},{key:"possibleLengths",value:function(){if(!this.v1)return this.metadata[this.v2?2:3]}},{key:"_getFormats",value:function(t){return t[this.v1?2:this.v2?3:4]}},{key:"formats",value:function(){var t=this,e=this._getFormats(this.metadata)||this._getFormats(this.getDefaultCountryMetadataForRegion())||[];return e.map((function(e){return new x(e,t)}))}},{key:"nationalPrefix",value:function(){return this.metadata[this.v1?3:this.v2?4:5]}},{key:"_getNationalPrefixFormattingRule",value:function(t){return t[this.v1?4:this.v2?5:6]}},{key:"nationalPrefixFormattingRule",value:function(){return this._getNationalPrefixFormattingRule(this.metadata)||this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion())}},{key:"_nationalPrefixForParsing",value:function(){return this.metadata[this.v1?5:this.v2?6:7]}},{key:"nationalPrefixForParsing",value:function(){return this._nationalPrefixForParsing()||this.nationalPrefix()}},{key:"nationalPrefixTransformRule",value:function(){return this.metadata[this.v1?6:this.v2?7:8]}},{key:"_getNationalPrefixIsOptionalWhenFormatting",value:function(){return!!this.metadata[this.v1?7:this.v2?8:9]}},{key:"nationalPrefixIsOptionalWhenFormattingInNationalFormat",value:function(){return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata)||this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion())}},{key:"leadingDigits",value:function(){return this.metadata[this.v1?8:this.v2?9:10]}},{key:"types",value:function(){return this.metadata[this.v1?9:this.v2?10:11]}},{key:"hasTypes",value:function(){return(!this.types()||0!==this.types().length)&&!!this.types()}},{key:"type",value:function(t){if(this.hasTypes()&&E(this.types(),t))return new S(E(this.types(),t),this)}},{key:"ext",value:function(){return this.v1||this.v2?C:this.metadata[13]||C}}]),t}(),x=function(){function t(e,n){p(this,t),this._format=e,this.metadata=n}return v(t,[{key:"pattern",value:function(){return this._format[0]}},{key:"format",value:function(){return this._format[1]}},{key:"leadingDigitsPatterns",value:function(){return this._format[2]||[]}},{key:"nationalPrefixFormattingRule",value:function(){return this._format[3]||this.metadata.nationalPrefixFormattingRule()}},{key:"nationalPrefixIsOptionalWhenFormattingInNationalFormat",value:function(){return!!this._format[4]||this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat()}},{key:"nationalPrefixIsMandatoryWhenFormattingInNationalFormat",value:function(){return this.usesNationalPrefix()&&!this.nationalPrefixIsOptionalWhenFormattingInNationalFormat()}},{key:"usesNationalPrefix",value:function(){return!(!this.nationalPrefixFormattingRule()||w.test(this.nationalPrefixFormattingRule()))}},{key:"internationalFormat",value:function(){return this._format[5]||this.format()}}]),t}(),w=/^\(?\$1\)?$/,S=function(){function t(e,n){p(this,t),this.type=e,this.metadata=n}return v(t,[{key:"pattern",value:function(){return this.metadata.v1?this.type:this.type[0]}},{key:"possibleLengths",value:function(){if(!this.metadata.v1)return this.type[1]||this.metadata.possibleLengths()}}]),t}();function E(t,e){switch(e){case"FIXED_LINE":return t[0];case"MOBILE":return t[1];case"TOLL_FREE":return t[2];case"PREMIUM_RATE":return t[3];case"PERSONAL_NUMBER":return t[4];case"VOICEMAIL":return t[5];case"UAN":return t[6];case"PAGER":return t[7];case"VOIP":return t[8];case"SHARED_COST":return t[9]}}var I=function(t){return"object"===m(t)},A=function(t){return m(t)};function T(t,e){return(e=new P(e)).hasCountry(t)?e.country(t).ext():C}function j(t,e){if((e=new P(e)).hasCountry(t))return e.country(t).countryCallingCode();throw new Error("Unknown country: ".concat(t))}function k(t,e){return e.countries.hasOwnProperty(t)}function F(t){var e=t.version;"number"==typeof e?(this.v1=1===e,this.v2=2===e,this.v3=3===e,this.v4=4===e):e?-1===g(e,"1.2.0")?this.v2=!0:-1===g(e,"1.7.35")?this.v3=!0:this.v4=!0:this.v1=!0}var M=function(t){return"([".concat(f,"]{1,").concat(t,"})")};function D(t){var e="#?";return";ext="+M("20")+"|"+("[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*"+M("20")+e)+"|"+("[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*"+M("9")+e)+"|"+("[- ]+"+M("6")+"#")+"|"+("[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*"+M("15")+e)+"|"+("[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*"+M("9")+e)}var R="[+＋]{0,1}(?:["+h+"]*["+"0-9０-９٠-٩۰-۹]){3,}["+h+"0-9０-９٠-٩۰-۹]*",_=new RegExp("^[+＋]{0,1}(?:["+h+"]*["+"0-9０-９٠-٩۰-۹]){1,2}$","i"),L=R+"(?:"+D()+")?",G=new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^"+L+"$","i");function B(t){return t.length>=2&&G.test(t)}var U=new RegExp("(?:"+D()+")$","i");function H(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return W(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return W(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function W(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}var V={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","０":"0","１":"1","２":"2","３":"3","４":"4","５":"5","６":"6","７":"7","８":"8","９":"9","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9"};function K(t){return V[t]}function Y(t){for(var e,n="",d=H(t.split(""));!(e=d()).done;){var r=K(e.value);r&&(n+=r)}return n}function Z(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return X(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return X(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function X(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function J(t){for(var e,n="",d=Z(t.split(""));!(e=d()).done;){n+=Q(e.value,n)||""}return n}function Q(t,e){if("+"===t){if(e)return;return"+"}return K(t)}function z(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return q(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return q(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function q(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function tt(t,e){return et(t,void 0,e)}function et(t,e,n){var d=n.type(e),r=d&&d.possibleLengths()||n.possibleLengths();if(!r)return"IS_POSSIBLE";if("FIXED_LINE_OR_MOBILE"===e){if(!n.type("FIXED_LINE"))return et(t,"MOBILE",n);var a=n.type("MOBILE");a&&(r=function(t,e){for(var n,d=t.slice(),r=z(e);!(n=r()).done;){var a=n.value;t.indexOf(a)<0&&d.push(a)}return d.sort((function(t,e){return t-e}))}(r,a.possibleLengths()))}else if(e&&!d)return"INVALID_LENGTH";var i=t.length,o=r[0];return o===i?"IS_POSSIBLE":o>i?"TOO_SHORT":r[r.length-1]<i?"TOO_LONG":r.indexOf(i,1)>=0?"IS_POSSIBLE":"INVALID_LENGTH"}function nt(t,e){return"IS_POSSIBLE"===tt(t,e)}function dt(t,e){return t=t||"",new RegExp("^(?:"+e+")$").test(t)}function rt(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return at(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return at(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function at(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}var it=["MOBILE","PREMIUM_RATE","TOLL_FREE","SHARED_COST","VOIP","PERSONAL_NUMBER","PAGER","UAN","VOICEMAIL"];function ot(t,e,n){if(e=e||{},t.country){(n=new P(n)).selectNumberingPlan(t.country,t.countryCallingCode);var d=e.v2?t.nationalNumber:t.phone;if(dt(d,n.nationalNumberPattern())){if($t(d,"FIXED_LINE",n))return n.type("MOBILE")&&""===n.type("MOBILE").pattern()?"FIXED_LINE_OR_MOBILE":n.type("MOBILE")?$t(d,"MOBILE",n)?"FIXED_LINE_OR_MOBILE":"FIXED_LINE":"FIXED_LINE_OR_MOBILE";for(var r,a=rt(it);!(r=a()).done;){var i=r.value;if($t(d,i,n))return i}}}}function $t(t,e,n){return!(!(e=n.type(e))||!e.pattern())&&(!(e.possibleLengths()&&e.possibleLengths().indexOf(t.length)<0)&&dt(t,e.pattern()))}function ut(t,e,n){var d=new P(n).getCountryCodesForCallingCode(t);return d?d.filter((function(t){return function(t,e,n){var d=new P(n);if(d.selectNumberingPlan(e),d.numberingPlan.possibleLengths().indexOf(t.length)>=0)return!0;return!1}(e,t,n)})):[]}function lt(t){return t.replace(new RegExp("[".concat(h,"]+"),"g")," ").trim()}var ct=/(\$\d)/;function st(t,e,n){var d=n.useInternationalFormat,r=n.withNationalPrefix;n.carrierCode,n.metadata;var a=t.replace(new RegExp(e.pattern()),d?e.internationalFormat():r&&e.nationalPrefixFormattingRule()?e.format().replace(ct,e.nationalPrefixFormattingRule()):e.format());return d?lt(a):a}var ft=/^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;function ht(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var d,r,a=[],i=!0,o=!1;try{for(n=n.call(t);!(i=(d=n.next()).done)&&(a.push(d.value),!e||a.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==n.return||n.return()}finally{if(o)throw r}}return a}(t,e)||yt(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function yt(t,e){if(t){if("string"==typeof t)return gt(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?gt(t,e):void 0}}function gt(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function mt(t){var e=t.number,n=t.ext;if(!e)return"";if("+"!==e[0])throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');return"tel:".concat(e).concat(n?";ext="+n:"")}function pt(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return bt(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return bt(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function bt(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function vt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function Ct(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?vt(Object(n),!0).forEach((function(e){Nt(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):vt(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Nt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var Pt={formatExtension:function(t,e,n){return"".concat(t).concat(n.ext()).concat(e)}};function Ot(t,e,n,d){if(n=n?Ct(Ct({},Pt),n):Pt,d=new P(d),t.country&&"001"!==t.country){if(!d.hasCountry(t.country))throw new Error("Unknown country: ".concat(t.country));d.country(t.country)}else{if(!t.countryCallingCode)return t.phone||"";d.selectNumberingPlan(t.countryCallingCode)}var r,a=d.countryCallingCode(),i=n.v2?t.nationalNumber:t.phone;switch(e){case"NATIONAL":return i?St(r=xt(i,t.carrierCode,"NATIONAL",d,n),t.ext,d,n.formatExtension):"";case"INTERNATIONAL":return i?(r=xt(i,null,"INTERNATIONAL",d,n),St(r="+".concat(a," ").concat(r),t.ext,d,n.formatExtension)):"+".concat(a);case"E.164":return"+".concat(a).concat(i);case"RFC3966":return mt({number:"+".concat(a).concat(i),ext:t.ext});case"IDD":if(!n.fromCountry)return;var o=function(t,e,n,d,r){if(j(d,r.metadata)===n){var a=xt(t,e,"NATIONAL",r);return"1"===n?n+" "+a:a}var i=function(t,e,n){var d=new P(n);return d.selectNumberingPlan(t,e),d.defaultIDDPrefix()?d.defaultIDDPrefix():ft.test(d.IDDPrefix())?d.IDDPrefix():void 0}(d,void 0,r.metadata);if(i)return"".concat(i," ").concat(n," ").concat(xt(t,null,"INTERNATIONAL",r))}(i,t.carrierCode,a,n.fromCountry,d);return St(o,t.ext,d,n.formatExtension);default:throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e,'"'))}}function xt(t,e,n,d,r){var a=wt(d.formats(),t);return a?st(t,a,{useInternationalFormat:"INTERNATIONAL"===n,withNationalPrefix:!a.nationalPrefixIsOptionalWhenFormattingInNationalFormat()||!r||!1!==r.nationalPrefix,carrierCode:e,metadata:d}):t}function wt(t,e){for(var n,d=pt(t);!(n=d()).done;){var r=n.value;if(r.leadingDigitsPatterns().length>0){var a=r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length-1];if(0!==e.search(a))continue}if(dt(e,r.pattern()))return r}}function St(t,e,n,d){return e?d(t,e,n):t}function Et(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function It(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Et(Object(n),!0).forEach((function(e){At(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Et(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function At(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Tt(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var jt=function(){function t(e,n,d){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw new TypeError("`country` or `countryCallingCode` not passed");if(!n)throw new TypeError("`nationalNumber` not passed");if(!d)throw new TypeError("`metadata` not passed");var r=function(t,e){var n,d,r=new P(e);a=t,/^[A-Z]{2}$/.test(a)?(n=t,r.selectNumberingPlan(n),d=r.countryCallingCode()):d=t;var a;return{country:n,countryCallingCode:d}}(e,d),a=r.country,i=r.countryCallingCode;this.country=a,this.countryCallingCode=i,this.nationalNumber=n,this.number="+"+this.countryCallingCode+this.nationalNumber,this.getMetadata=function(){return d}}var e,n,d;return e=t,n=[{key:"setExt",value:function(t){this.ext=t}},{key:"getPossibleCountries",value:function(){return this.country?[this.country]:ut(this.countryCallingCode,this.nationalNumber,this.getMetadata())}},{key:"isPossible",value:function(){return function(t,e,n){if(void 0===e&&(e={}),n=new P(n),e.v2){if(!t.countryCallingCode)throw new Error("Invalid phone number object passed");n.selectNumberingPlan(t.countryCallingCode)}else{if(!t.phone)return!1;if(t.country){if(!n.hasCountry(t.country))throw new Error("Unknown country: ".concat(t.country));n.country(t.country)}else{if(!t.countryCallingCode)throw new Error("Invalid phone number object passed");n.selectNumberingPlan(t.countryCallingCode)}}if(n.possibleLengths())return nt(t.phone||t.nationalNumber,n);if(t.countryCallingCode&&n.isNonGeographicCallingCode(t.countryCallingCode))return!0;throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.')}(this,{v2:!0},this.getMetadata())}},{key:"isValid",value:function(){return function(t,e,n){return e=e||{},(n=new P(n)).selectNumberingPlan(t.country,t.countryCallingCode),n.hasTypes()?void 0!==ot(t,e,n.metadata):dt(e.v2?t.nationalNumber:t.phone,n.nationalNumberPattern())}(this,{v2:!0},this.getMetadata())}},{key:"isNonGeographic",value:function(){return new P(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode)}},{key:"isEqual",value:function(t){return this.number===t.number&&this.ext===t.ext}},{key:"getType",value:function(){return ot(this,{v2:!0},this.getMetadata())}},{key:"format",value:function(t,e){return Ot(this,t,e?It(It({},e),{},{v2:!0}):{v2:!0},this.getMetadata())}},{key:"formatNational",value:function(t){return this.format("NATIONAL",t)}},{key:"formatInternational",value:function(t){return this.format("INTERNATIONAL",t)}},{key:"getURI",value:function(t){return this.format("RFC3966",t)}}],n&&Tt(e.prototype,n),d&&Tt(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();var kt=new RegExp("([0-9０-９٠-٩۰-۹])");function Ft(t,e,n,d){if(e){var r=new P(d);r.selectNumberingPlan(e,n);var a=new RegExp(r.IDDPrefix());if(0===t.search(a)){var i=(t=t.slice(t.match(a)[0].length)).match(kt);if(!(i&&null!=i[1]&&i[1].length>0&&"0"===i[1]))return t}}}function Mt(t,e){if(t&&e.numberingPlan.nationalPrefixForParsing()){var n=new RegExp("^(?:"+e.numberingPlan.nationalPrefixForParsing()+")"),d=n.exec(t);if(d){var r,a,i,o=d.length-1,$=o>0&&d[o];if(e.nationalPrefixTransformRule()&&$)r=t.replace(n,e.nationalPrefixTransformRule()),o>1&&(a=d[1]);else{var u=d[0];r=t.slice(u.length),$&&(a=d[1])}if($){var l=t.indexOf(d[1]);t.slice(0,l)===e.numberingPlan.nationalPrefix()&&(i=e.numberingPlan.nationalPrefix())}else i=d[0];return{nationalNumber:r,nationalPrefix:i,carrierCode:a}}}return{nationalNumber:t}}function Dt(t,e){var n=Mt(t,e),d=n.carrierCode,r=n.nationalNumber;if(r!==t){if(!function(t,e,n){if(dt(t,n.nationalNumberPattern())&&!dt(e,n.nationalNumberPattern()))return!1;return!0}(t,r,e))return{nationalNumber:t};if(e.possibleLengths()&&!function(t,e){switch(tt(t,e)){case"TOO_SHORT":case"INVALID_LENGTH":return!1;default:return!0}}(r,e))return{nationalNumber:t}}return{nationalNumber:r,carrierCode:d}}function Rt(t,e,n,d){var r=e?j(e,d):n;if(0===t.indexOf(r)){(d=new P(d)).selectNumberingPlan(e,n);var a=t.slice(r.length),i=Dt(a,d).nationalNumber,o=Dt(t,d).nationalNumber;if(!dt(o,d.nationalNumberPattern())&&dt(i,d.nationalNumberPattern())||"TOO_LONG"===tt(o,d))return{countryCallingCode:r,number:a}}return{number:t}}function _t(t,e,n,d){if(!t)return{};var r;if("+"!==t[0]){var a=Ft(t,e,n,d);if(!a||a===t){if(e||n){var i=Rt(t,e,n,d),o=i.countryCallingCode,$=i.number;if(o)return{countryCallingCodeSource:"FROM_NUMBER_WITHOUT_PLUS_SIGN",countryCallingCode:o,number:$}}return{number:t}}r=!0,t="+"+a}if("0"===t[1])return{};d=new P(d);for(var u=2;u-1<=3&&u<=t.length;){var l=t.slice(1,u);if(d.hasCallingCode(l))return d.selectNumberingPlan(l),{countryCallingCodeSource:r?"FROM_NUMBER_WITH_IDD":"FROM_NUMBER_WITH_PLUS_SIGN",countryCallingCode:l,number:t.slice(u)};u++}return{}}function Lt(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return Gt(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Gt(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function Gt(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function Bt(t,e){var n=e.countries,d=e.defaultCountry,r=e.metadata;r=new P(r);for(var a,i=[],o=Lt(n);!(a=o()).done;){var $=a.value;if(r.country($),r.leadingDigits()){if(t&&0===t.search(r.leadingDigits()))return $}else if(ot({phone:t,country:$},void 0,r.metadata)){if(!d)return $;if($===d)return $;i.push($)}}if(i.length>0)return i[0]}function Ut(t,e){var n=e.nationalNumber,d=e.defaultCountry,r=e.metadata,a=r.getCountryCodesForCallingCode(t);if(a)return 1===a.length?a[0]:Bt(n,{countries:a,defaultCountry:d,metadata:r.metadata})}var Ht=new RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$","g"),Wt=new RegExp("^([0-9０-９٠-٩۰-۹]+((\\-)*[0-9０-９٠-٩۰-۹])*\\.)*[a-zA-Z]+((\\-)*[0-9０-９٠-٩۰-۹])*\\.?$","g"),Vt="tel:",Kt=";phone-context=";function Yt(t,e){var n,d=e.extractFormattedPhoneNumber,r=function(t){var e=t.indexOf(Kt);if(e<0)return null;var n=e+Kt.length;if(n>=t.length)return"";var d=t.indexOf(";",n);return d>=0?t.substring(n,d):t.substring(n)}(t);if(!function(t){return null===t||0!==t.length&&(Ht.test(t)||Wt.test(t))}(r))throw new s("NOT_A_NUMBER");if(null===r)n=d(t)||"";else{n="","+"===r.charAt(0)&&(n+=r);var a,i=t.indexOf(Vt);a=i>=0?i+Vt.length:0;var o=t.indexOf(Kt);n+=t.substring(a,o)}var $=n.indexOf(";isub=");if($>0&&(n=n.substring(0,$)),""!==n)return n}var Zt=new RegExp("[+＋0-9０-９٠-٩۰-۹]"),Xt=new RegExp("[^0-9０-９٠-٩۰-۹#]+$");function Jt(t,e,n){if(e=e||{},n=new P(n),e.defaultCountry&&!n.hasCountry(e.defaultCountry)){if(e.v2)throw new s("INVALID_COUNTRY");throw new Error("Unknown country: ".concat(e.defaultCountry))}var d=function(t,e,n){var d=Yt(t,{extractFormattedPhoneNumber:function(t){return function(t,e,n){if(!t)return;if(t.length>250){if(n)throw new s("TOO_LONG");return}if(!1===e)return t;var d=t.search(Zt);if(d<0)return;return t.slice(d).replace(Xt,"")}(t,n,e)}});if(!d)return{};if(!B(d))return function(t){return _.test(t)}(d)?{error:"TOO_SHORT"}:{};var r=function(t){var e=t.search(U);if(e<0)return{};for(var n=t.slice(0,e),d=t.match(U),r=1;r<d.length;){if(d[r])return{number:n,ext:d[r]};r++}}(d);if(r.ext)return r;return{number:d}}(t,e.v2,e.extract),r=d.number,a=d.ext,i=d.error;if(!r){if(e.v2){if("TOO_SHORT"===i)throw new s("TOO_SHORT");throw new s("NOT_A_NUMBER")}return{}}var o=function(t,e,n,d){var r,a=_t(J(t),e,n,d.metadata),i=a.countryCallingCodeSource,o=a.countryCallingCode,$=a.number;if(o)d.selectNumberingPlan(o);else{if(!$||!e&&!n)return{};d.selectNumberingPlan(e,n),e&&(r=e),o=n||j(e,d.metadata)}if(!$)return{countryCallingCodeSource:i,countryCallingCode:o};var u=Dt(J($),d),l=u.nationalNumber,c=u.carrierCode,s=Ut(o,{nationalNumber:l,defaultCountry:e,metadata:d});s&&(r=s,"001"===s||d.country(r));return{country:r,countryCallingCode:o,countryCallingCodeSource:i,nationalNumber:l,carrierCode:c}}(r,e.defaultCountry,e.defaultCallingCode,n),$=o.country,u=o.nationalNumber,l=o.countryCallingCode,c=o.countryCallingCodeSource,f=o.carrierCode;if(!n.hasSelectedNumberingPlan()){if(e.v2)throw new s("INVALID_COUNTRY");return{}}if(!u||u.length<2){if(e.v2)throw new s("TOO_SHORT");return{}}if(u.length>17){if(e.v2)throw new s("TOO_LONG");return{}}if(e.v2){var h=new jt(l,u,n.metadata);return $&&(h.country=$),f&&(h.carrierCode=f),a&&(h.ext=a),h.__countryCallingCodeSource=c,h}var y=!!(e.extended?n.hasSelectedNumberingPlan():$)&&dt(u,n.nationalNumberPattern());return e.extended?{country:$,countryCallingCode:l,carrierCode:f,valid:y,possible:!!y||!(!0!==e.extended||!n.possibleLengths()||!nt(u,n)),phone:u,ext:a}:y?function(t,e,n){var d={country:t,phone:e};n&&(d.ext=n);return d}($,u,a):{}}function Qt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function zt(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Qt(Object(n),!0).forEach((function(e){qt(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Qt(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function qt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function te(t,e,n){return Jt(t,zt(zt({},e),{},{v2:!0}),n)}function ee(t){return ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},ee(t)}function ne(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function de(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function re(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var d,r,a=[],i=!0,o=!1;try{for(n=n.call(t);!(i=(d=n.next()).done)&&(a.push(d.value),!e||a.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==n.return||n.return()}finally{if(o)throw r}}return a}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return ae(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ae(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function ae(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function ie(t){var e,n,d,r=re(Array.prototype.slice.call(t),4),a=r[0],i=r[1],o=r[2],$=r[3];if("string"!=typeof a)throw new TypeError("A text for parsing must be a string.");if(e=a,i&&"string"!=typeof i){if(!oe(i))throw new Error("Invalid second argument: ".concat(i));o?(n=i,d=o):d=i}else $?(n=o,d=$):(n=void 0,d=o),i&&(n=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ne(Object(n),!0).forEach((function(e){de(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ne(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}({defaultCountry:i},n));return{text:e,options:n,metadata:d}}var oe=function(t){return"object"===ee(t)};function $e(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata;return te(e,n,d)}function ue(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function le(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ue(Object(n),!0).forEach((function(e){ce(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ue(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function ce(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function se(t,e,n){e&&e.defaultCountry&&!k(e.defaultCountry,n)&&(e=le(le({},e),{},{defaultCountry:void 0}));try{return te(t,e,n)}catch(t){if(!(t instanceof s))throw t}}function fe(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata;return se(e,n,d)}function he(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function ye(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?he(Object(n),!0).forEach((function(e){ge(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):he(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function ge(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function me(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=se(e,n=ye(ye({},n),{},{extract:!1}),d);return r&&r.isValid()||!1}function pe(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function be(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?pe(Object(n),!0).forEach((function(e){ve(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):pe(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function ve(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Ce(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=se(e,n=be(be({},n),{},{extract:!1}),d);return r&&r.isPossible()||!1}function Ne(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function Pe(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ne(Object(n),!0).forEach((function(e){Oe(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ne(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Oe(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function xe(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata;n=Pe(Pe({},n),{},{extract:!1});try{var r=te(e,n,d);(d=new P(d)).selectNumberingPlan(r.countryCallingCode);var a=tt(r.nationalNumber,d);if("IS_POSSIBLE"!==a)return a}catch(t){if(t instanceof s)return t.message;throw t}}function we(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}function Se(t,e,n){return e&&we(t.prototype,e),n&&we(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function Ee(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var Ie=Se((function t(e,n){var d=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;Ee(this,t),this.key=e,this.value=n,this.next=d,this.prev=r})),Ae=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:10;Ee(this,t),this.size=0,this.limit=e,this.head=null,this.tail=null,this.cache={}}return Se(t,[{key:"put",value:function(t,e){if(this.ensureLimit(),this.head){var n=new Ie(t,e,this.head);this.head.prev=n,this.head=n}else this.head=this.tail=new Ie(t,e);this.cache[t]=this.head,this.size++}},{key:"get",value:function(t){if(this.cache[t]){var e=this.cache[t].value;return this.remove(t),this.put(t,e),e}console.log("Item not available in cache for key ".concat(t))}},{key:"ensureLimit",value:function(){this.size===this.limit&&this.remove(this.tail.key)}},{key:"remove",value:function(t){var e=this.cache[t];null!==e.prev?e.prev.next=e.next:this.head=e.next,null!==e.next?e.next.prev=e.prev:this.tail=e.prev,delete this.cache[t],this.size--}},{key:"clear",value:function(){this.head=null,this.tail=null,this.size=0,this.cache={}}}]),t}();function Te(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var je=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.cache=new Ae(e)}var e,n,d;return e=t,(n=[{key:"getPatternForRegExp",value:function(t){var e=this.cache.get(t);return e||(e=new RegExp("^"+t),this.cache.put(t,e)),e}}])&&Te(e.prototype,n),d&&Te(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function ke(t,e){if(t<0||e<=0||e<t)throw new TypeError;return"{".concat(t,",").concat(e,"}")}function Fe(t,e){var n=e.search(t);return n>=0?e.slice(0,n):e}var Me="   ᠎ - \u2028\u2029  　",De="[".concat(Me,"]"),Re="[^".concat(Me,"]"),_e="[".concat("0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꩐-꩙꯰-꯹０-９","]"),Le="A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",Ge="[".concat(Le,"]"),Be=new RegExp(Ge),Ue="[".concat("$¢-¥֏؋৲৳৻૱௹฿៛₠-₹꠸﷼﹩＄￠￡￥￦","]"),He=new RegExp(Ue),We="[".concat("̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࣤ-ࣾऀ-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣଁ଼ିୁ-ୄ୍ୖୢୣஂீ்ా-ీె-ైొ-్ౕౖౢౣ಼ಿೆೌ್ೢೣു-ൄ്ൢൣ්ි-ුූัิ-ฺ็-๎ັິ-ູົຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍ᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼ᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᯦᮫ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᷀-ᷦ᷼-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꣄꣠-꣱ꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꨩ-ꨮꨱꨲꨵꨶꩃꩌꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︦","]"),Ve=new RegExp(We),Ke=new RegExp("[\0--ÿĀ-ſḀ-ỿƀ-ɏ̀-ͯ]");function Ye(t){return!(!Be.test(t)&&!Ve.test(t))&&Ke.test(t)}function Ze(t){return"%"===t||He.test(t)}function Xe(t,e,n){var d=!0,r=fe(t,n);if(r||(d=!1,r=fe(t,{defaultCallingCode:e.countryCallingCode},n)),!r)return"INVALID_NUMBER";if(e.ext){if(r.ext!==e.ext)return"NO_MATCH"}else if(r.ext)return"NO_MATCH";return d&&e.countryCallingCode!==r.countryCallingCode?"NO_MATCH":e.number===r.number?d?"EXACT_MATCH":"NSN_MATCH":0===e.nationalNumber.indexOf(r.nationalNumber)||0===r.nationalNumber.indexOf(e.nationalNumber)?"SHORT_NSN_MATCH":"NO_MATCH"}var Je={POSSIBLE:function(t,e){return e.candidate,e.metadata,!0},VALID:function(t,e){var n=e.candidate;e.defaultCountry;var d=e.metadata;return!(!t.isValid()||!Qe(t,n,d))},STRICT_GROUPING:function(t,e){var n=e.candidate,d=e.defaultCountry,r=e.metadata;return e.regExpCache,!(!t.isValid()||!Qe(t,n,r)||qe(t,n)||!ze(t,{defaultCountry:d,metadata:r}))&&tn()},EXACT_GROUPING:function(t,e){var n=e.candidate,d=e.defaultCountry,r=e.metadata;return e.regExpCache,!(!t.isValid()||!Qe(t,n,r)||qe(t,n)||!ze(t,{defaultCountry:d,metadata:r}))&&tn()}};function Qe(t,e,n){for(var d=0;d<e.length-1;d++){var r=e.charAt(d);if("x"===r||"X"===r){var a=e.charAt(d+1);if("x"===a||"X"===a){if(d++,"NSN_MATCH"!==Xe(e.substring(d),t,n))return!1}else{var i=Y(e.substring(d));if(i){if(t.ext!==i)return!1}else if(t.ext)return!1}}}return!0}function ze(t,e){var n=e.defaultCountry,d=e.metadata;if("FROM_DEFAULT_COUNTRY"!==t.__countryCallingCodeSource)return!0;var r=new P(d);r.selectNumberingPlan(t.countryCallingCode),t.country||Ut(t.countryCallingCode,{nationalNumber:t.nationalNumber,defaultCountry:n,metadata:r});var a=t.nationalNumber,i=wt(r.numberingPlan.formats(),a);return!i.nationalPrefixFormattingRule()||(!!r.numberingPlan.nationalPrefixIsOptionalWhenFormattingInNationalFormat()||(!i.usesNationalPrefix()||Boolean(t.nationalPrefix)))}function qe(t,e){var n=e.indexOf("/");if(n<0)return!1;var d=e.indexOf("/",n+1);return!(d<0)&&(!("FROM_NUMBER_WITH_PLUS_SIGN"===t.__countryCallingCodeSource||"FROM_NUMBER_WITHOUT_PLUS_SIGN"===t.__countryCallingCodeSource)||Y(e.substring(0,n))!==t.countryCallingCode||e.slice(d+1).indexOf("/")>=0)}function tn(t,e,n,d,r){throw new Error("This part of code hasn't been ported")}var en=/[\\/] *x/;function nn(t){return Fe(en,t)}var dn=/(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/,rn=/[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/,an=/^:[0-5]\d/;function on(t,e,n){if(dn.test(t))return!1;if(rn.test(t)){var d=n.slice(e+t.length);if(an.test(d))return!1}return!0}var $n="(\\[（［",un=")\\]）］",ln="[^".concat($n).concat(un,"]"),cn="[".concat($n).concat(y,"]"),sn=new RegExp("^"+cn),fn=ke(0,3),hn=new RegExp("^(?:[(\\[（［])?(?:"+ln+"+["+")\\]）］])?"+ln+"+(?:["+"(\\[（［]"+ln+"+["+")\\]）］])"+fn+ln+"*$"),yn=/\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;function gn(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return mn(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return mn(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function mn(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function pn(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function bn(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var vn=D(),Cn=["\\/+(.*)/","(\\([^(]*)","(?:".concat(De,"-|-").concat(De,")").concat(De,"*(.+)"),"[‒-―－]".concat(De,"*(.+)"),"\\.+".concat(De,"*([^.]+)"),"".concat(De,"+(").concat(Re,"+)")],Nn=ke(0,2),Pn=ke(0,4),On=ke(0,20),xn="[".concat(h,"]")+Pn,wn=_e+ke(1,20),Sn="(?:"+cn+xn+")"+Nn+wn+"(?:"+xn+wn+")"+On+"(?:"+vn+")?",En=new RegExp("[^".concat("0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൦-൵๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꩐-꩙꯰-꯹０-９").concat(Le,"#]+$")),In=Number.MAX_SAFE_INTEGER||Math.pow(2,53)-1,An=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},d=arguments.length>2?arguments[2]:void 0;if(pn(this,t),!(n={v2:n.v2,defaultCallingCode:n.defaultCallingCode,defaultCountry:n.defaultCountry&&k(n.defaultCountry,d)?n.defaultCountry:void 0,leniency:n.leniency||(n.extended?"POSSIBLE":"VALID"),maxTries:n.maxTries||In}).leniency)throw new TypeError("`leniency` is required");if("POSSIBLE"!==n.leniency&&"VALID"!==n.leniency)throw new TypeError('Invalid `leniency`: "'.concat(n.leniency,'". Supported values: "POSSIBLE", "VALID".'));if(n.maxTries<0)throw new TypeError("`maxTries` must be `>= 0`");if(this.text=e,this.options=n,this.metadata=d,this.leniency=Je[n.leniency],!this.leniency)throw new TypeError('Unknown leniency: "'.concat(n.leniency,'"'));this.maxTries=n.maxTries,this.PATTERN=new RegExp(Sn,"ig"),this.state="NOT_READY",this.searchIndex=0,this.regExpCache=new je(32)}var e,n,d;return e=t,n=[{key:"find",value:function(){for(var t;this.maxTries>0&&null!==(t=this.PATTERN.exec(this.text));){var e=t[0],n=t.index;if(on(e=nn(e),n,this.text)){var d=this.parseAndVerify(e,n,this.text)||this.extractInnerMatch(e,n,this.text);if(d){if(this.options.v2)return{startsAt:d.startsAt,endsAt:d.endsAt,number:d.phoneNumber};var r=d.phoneNumber,a={startsAt:d.startsAt,endsAt:d.endsAt,phone:r.nationalNumber};return r.country?a.country=r.country:a.countryCallingCode=r.countryCallingCode,r.ext&&(a.ext=r.ext),a}}this.maxTries--}}},{key:"extractInnerMatch",value:function(t,e,n){for(var d,r=gn(Cn);!(d=r()).done;)for(var a=d.value,i=!0,o=void 0,$=new RegExp(a,"g");this.maxTries>0&&null!==(o=$.exec(t));){if(i){var u=Fe(En,t.slice(0,o.index)),l=this.parseAndVerify(u,e,n);if(l)return l;this.maxTries--,i=!1}var c=Fe(En,o[1]),s=t.indexOf(c,o.index),f=this.parseAndVerify(c,e+s,n);if(f)return f;this.maxTries--}}},{key:"parseAndVerify",value:function(t,e,n){if(function(t,e,n,d){if(hn.test(t)&&!yn.test(t)){if("POSSIBLE"!==d){if(e>0&&!sn.test(t)){var r=n[e-1];if(Ze(r)||Ye(r))return!1}var a=e+t.length;if(a<n.length){var i=n[a];if(Ze(i)||Ye(i))return!1}}return!0}}(t,e,n,this.options.leniency)){var d=fe(t,{extended:!0,defaultCountry:this.options.defaultCountry,defaultCallingCode:this.options.defaultCallingCode},this.metadata);if(d&&d.isPossible())return this.leniency(d,{candidate:t,defaultCountry:this.options.defaultCountry,metadata:this.metadata,regExpCache:this.regExpCache})?{startsAt:e,endsAt:e+t.length,phoneNumber:d}:void 0}}},{key:"hasNext",value:function(){return"NOT_READY"===this.state&&(this.lastMatch=this.find(),this.lastMatch?this.state="READY":this.state="DONE"),"READY"===this.state}},{key:"next",value:function(){if(!this.hasNext())throw new Error("No next element");var t=this.lastMatch;return this.lastMatch=null,this.state="NOT_READY",t}}],n&&bn(e.prototype,n),d&&bn(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function Tn(){for(var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=new An(e,n,d),a=[];r.hasNext();)a.push(r.next());return a}function jn(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function kn(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=new An(e,n,d);return jn({},Symbol.iterator,(function(){return{next:function(){return r.hasNext()?{done:!1,value:r.next()}:{done:!0}}}}))}function Fn(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function Mn(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Fn(Object(n),!0).forEach((function(e){Dn(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Fn(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Dn(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Rn(){for(var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=new An(e,Mn(Mn({},n),{},{v2:!0}),d),a=[];r.hasNext();)a.push(r.next());return a}function _n(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(t);e&&(d=d.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,d)}return n}function Ln(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?_n(Object(n),!0).forEach((function(e){Gn(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):_n(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Gn(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Bn(){var t=ie(arguments),e=t.text,n=t.options,d=t.metadata,r=new An(e,Ln(Ln({},n),{},{v2:!0}),d);return Gn({},Symbol.iterator,(function(){return{next:function(){return r.hasNext()?{done:!1,value:r.next()}:{done:!0}}}}))}function Un(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var Hn=function(){function t(e){var n=e.onCountryChange,d=e.onCallingCodeChange;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.onCountryChange=n,this.onCallingCodeChange=d}var e,n,d;return e=t,(n=[{key:"reset",value:function(t){var e=t.country,n=t.callingCode;this.international=!1,this.missingPlus=!1,this.IDDPrefix=void 0,this.callingCode=void 0,this.digits="",this.resetNationalSignificantNumber(),this.initCountryAndCallingCode(e,n)}},{key:"resetNationalSignificantNumber",value:function(){this.nationalSignificantNumber=this.getNationalDigits(),this.nationalSignificantNumberMatchesInput=!0,this.nationalPrefix=void 0,this.carrierCode=void 0,this.complexPrefixBeforeNationalSignificantNumber=void 0}},{key:"update",value:function(t){for(var e=0,n=Object.keys(t);e<n.length;e++){var d=n[e];this[d]=t[d]}}},{key:"initCountryAndCallingCode",value:function(t,e){this.setCountry(t),this.setCallingCode(e)}},{key:"setCountry",value:function(t){this.country=t,this.onCountryChange(t)}},{key:"setCallingCode",value:function(t){this.callingCode=t,this.onCallingCodeChange(t,this.country)}},{key:"startInternationalNumber",value:function(t,e){this.international=!0,this.initCountryAndCallingCode(t,e)}},{key:"appendDigits",value:function(t){this.digits+=t}},{key:"appendNationalSignificantNumberDigits",value:function(t){this.nationalSignificantNumber+=t}},{key:"getNationalDigits",value:function(){return this.international?this.digits.slice((this.IDDPrefix?this.IDDPrefix.length:0)+(this.callingCode?this.callingCode.length:0)):this.digits}},{key:"getDigitsWithoutInternationalPrefix",value:function(){return this.international&&this.IDDPrefix?this.digits.slice(this.IDDPrefix.length):this.digits}}])&&Un(e.prototype,n),d&&Un(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function Wn(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return Vn(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Vn(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function Vn(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}var Kn="x",Yn=new RegExp(Kn);function Zn(t,e){if(e<1)return"";for(var n="";e>1;)1&e&&(n+=t),e>>=1,t+=t;return n+t}function Xn(t,e){return")"===t[e]&&e++,function(t){var e=[],n=0;for(;n<t.length;)"("===t[n]?e.push(n):")"===t[n]&&e.pop(),n++;var d=0,r="";e.push(t.length);for(var a=0,i=e;a<i.length;a++){var o=i[a];r+=t.slice(d,o),d=o+1}return r}(t.slice(0,e))}function Jn(t,e,n){var d=n.metadata,r=n.shouldTryNationalPrefixFormattingRule,a=n.getSeparatorAfterNationalPrefix;if(new RegExp("^(?:".concat(e.pattern(),")$")).test(t.nationalSignificantNumber))return function(t,e,n){var d=n.metadata,r=n.shouldTryNationalPrefixFormattingRule,a=n.getSeparatorAfterNationalPrefix;if(t.nationalSignificantNumber,t.international,t.nationalPrefix,t.carrierCode,r(e)){var i=Qn(t,e,{useNationalPrefixFormattingRule:!0,getSeparatorAfterNationalPrefix:a,metadata:d});if(i)return i}return Qn(t,e,{useNationalPrefixFormattingRule:!1,getSeparatorAfterNationalPrefix:a,metadata:d})}(t,e,{metadata:d,shouldTryNationalPrefixFormattingRule:r,getSeparatorAfterNationalPrefix:a})}function Qn(t,e,n){var d=n.metadata,r=n.useNationalPrefixFormattingRule,a=n.getSeparatorAfterNationalPrefix,i=st(t.nationalSignificantNumber,e,{carrierCode:t.carrierCode,useInternationalFormat:t.international,withNationalPrefix:r,metadata:d});if(r||(t.nationalPrefix?i=t.nationalPrefix+a(e)+i:t.complexPrefixBeforeNationalSignificantNumber&&(i=t.complexPrefixBeforeNationalSignificantNumber+" "+i)),function(t,e){return Y(t)===e.getNationalDigits()}(i,t))return i}function zn(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var qn=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t)}var e,n,d;return e=t,(n=[{key:"parse",value:function(t){if(this.context=[{or:!0,instructions:[]}],this.parsePattern(t),1!==this.context.length)throw new Error("Non-finalized contexts left when pattern parse ended");var e=this.context[0],n=e.branches,d=e.instructions;if(n)return{op:"|",args:n.concat([dd(d)])};if(0===d.length)throw new Error("Pattern is required");return 1===d.length?d[0]:d}},{key:"startContext",value:function(t){this.context.push(t)}},{key:"endContext",value:function(){this.context.pop()}},{key:"getContext",value:function(){return this.context[this.context.length-1]}},{key:"parsePattern",value:function(t){if(!t)throw new Error("Pattern is required");var e=t.match(nd);if(e){var n=e[1],d=t.slice(0,e.index),r=t.slice(e.index+n.length);switch(n){case"(?:":d&&this.parsePattern(d),this.startContext({or:!0,instructions:[],branches:[]});break;case")":if(!this.getContext().or)throw new Error('")" operator must be preceded by "(?:" operator');if(d&&this.parsePattern(d),0===this.getContext().instructions.length)throw new Error('No instructions found after "|" operator in an "or" group');var a=this.getContext().branches;a.push(dd(this.getContext().instructions)),this.endContext(),this.getContext().instructions.push({op:"|",args:a});break;case"|":if(!this.getContext().or)throw new Error('"|" operator can only be used inside "or" groups');if(d&&this.parsePattern(d),!this.getContext().branches){if(1!==this.context.length)throw new Error('"branches" not found in an "or" group context');this.getContext().branches=[]}this.getContext().branches.push(dd(this.getContext().instructions)),this.getContext().instructions=[];break;case"[":d&&this.parsePattern(d),this.startContext({oneOfSet:!0});break;case"]":if(!this.getContext().oneOfSet)throw new Error('"]" operator must be preceded by "[" operator');this.endContext(),this.getContext().instructions.push({op:"[]",args:td(d)});break;default:throw new Error("Unknown operator: ".concat(n))}r&&this.parsePattern(r)}else{if(ed.test(t))throw new Error("Illegal characters found in a pattern: ".concat(t));this.getContext().instructions=this.getContext().instructions.concat(t.split(""))}}}])&&zn(e.prototype,n),d&&zn(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function td(t){for(var e=[],n=0;n<t.length;){if("-"===t[n]){if(0===n||n===t.length-1)throw new Error("Couldn't parse a one-of set pattern: ".concat(t));for(var d=t[n-1].charCodeAt(0)+1,r=t[n+1].charCodeAt(0)-1,a=d;a<=r;)e.push(String.fromCharCode(a)),a++}else e.push(t[n]);n++}return e}var ed=/[\(\)\[\]\?\:\|]/,nd=new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");function dd(t){return 1===t.length?t[0]:t}function rd(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return ad(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ad(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function ad(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function id(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var od=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.matchTree=(new qn).parse(e)}var e,n,d;return e=t,n=[{key:"match",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.allowOverflow;if(!t)throw new Error("String is required");var d=$d(t.split(""),this.matchTree,!0);if(d&&d.match&&delete d.matchedChars,!d||!d.overflow||n)return d}}],n&&id(e.prototype,n),d&&id(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function $d(t,e,n){if("string"==typeof e){var d=t.join("");return 0===e.indexOf(d)?t.length===e.length?{match:!0,matchedChars:t}:{partialMatch:!0}:0===d.indexOf(e)?n&&t.length>e.length?{overflow:!0}:{match:!0,matchedChars:t.slice(0,e.length)}:void 0}if(Array.isArray(e)){for(var r=t.slice(),a=0;a<e.length;){var i=$d(r,e[a],n&&a===e.length-1);if(!i)return;if(i.overflow)return i;if(!i.match){if(i.partialMatch)return{partialMatch:!0};throw new Error("Unsupported match result:\n".concat(JSON.stringify(i,null,2)))}if(0===(r=r.slice(i.matchedChars.length)).length)return a===e.length-1?{match:!0,matchedChars:t}:{partialMatch:!0};a++}return n?{overflow:!0}:{match:!0,matchedChars:t.slice(0,t.length-r.length)}}switch(e.op){case"|":for(var o,$,u=rd(e.args);!($=u()).done;){var l=$d(t,$.value,n);if(l){if(l.overflow)return l;if(l.match)return{match:!0,matchedChars:l.matchedChars};if(!l.partialMatch)throw new Error("Unsupported match result:\n".concat(JSON.stringify(l,null,2)));o=!0}}return o?{partialMatch:!0}:void 0;case"[]":for(var c,s=rd(e.args);!(c=s()).done;){var f=c.value;if(t[0]===f)return 1===t.length?{match:!0,matchedChars:t}:n?{overflow:!0}:{match:!0,matchedChars:[f]}}return;default:throw new Error("Unsupported instruction tree: ".concat(e))}}function ud(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(!t)return;if("string"==typeof t)return ld(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ld(t,e)}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function ld(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function cd(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var sd=Zn("9",15),fd=/[- ]/,hd=new RegExp("["+h+"]*\\$1["+h+"]*(\\$\\d["+h+"]*)*$"),yd=function(){function t(e){e.state;var n=e.metadata;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.metadata=n,this.resetFormat()}var e,n,d;return e=t,n=[{key:"resetFormat",value:function(){this.chosenFormat=void 0,this.template=void 0,this.nationalNumberTemplate=void 0,this.populatedNationalNumberTemplate=void 0,this.populatedNationalNumberTemplatePosition=-1}},{key:"reset",value:function(t,e){this.resetFormat(),t?(this.isNANP="1"===t.callingCode(),this.matchingFormats=t.formats(),e.nationalSignificantNumber&&this.narrowDownMatchingFormats(e)):(this.isNANP=void 0,this.matchingFormats=[])}},{key:"format",value:function(t,e){var n=this;if(function(t,e){return"IS_POSSIBLE"===tt(t,e)}(e.nationalSignificantNumber,this.metadata))for(var d,r=ud(this.matchingFormats);!(d=r()).done;){var a=d.value,i=Jn(e,a,{metadata:this.metadata,shouldTryNationalPrefixFormattingRule:function(t){return n.shouldTryNationalPrefixFormattingRule(t,{international:e.international,nationalPrefix:e.nationalPrefix})},getSeparatorAfterNationalPrefix:function(t){return n.getSeparatorAfterNationalPrefix(t)}});if(i)return this.resetFormat(),this.chosenFormat=a,this.setNationalNumberTemplate(i.replace(/\d/g,Kn),e),this.populatedNationalNumberTemplate=i,this.populatedNationalNumberTemplatePosition=this.template.lastIndexOf(Kn),i}return this.formatNationalNumberWithNextDigits(t,e)}},{key:"formatNationalNumberWithNextDigits",value:function(t,e){var n=this.chosenFormat,d=this.chooseFormat(e);if(d)return d===n?this.formatNextNationalNumberDigits(t):this.formatNextNationalNumberDigits(e.getNationalDigits())}},{key:"narrowDownMatchingFormats",value:function(t){var e=this,n=t.nationalSignificantNumber,d=t.nationalPrefix,r=t.international,a=n,i=a.length-3;i<0&&(i=0),this.matchingFormats=this.matchingFormats.filter((function(t){return e.formatSuits(t,r,d)&&e.formatMatches(t,a,i)})),this.chosenFormat&&-1===this.matchingFormats.indexOf(this.chosenFormat)&&this.resetFormat()}},{key:"formatSuits",value:function(t,e,n){return!(n&&!t.usesNationalPrefix()&&!t.nationalPrefixIsOptionalWhenFormattingInNationalFormat()||!e&&!n&&t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat())}},{key:"formatMatches",value:function(t,e,n){var d=t.leadingDigitsPatterns().length;if(0===d)return!0;n=Math.min(n,d-1);var r=t.leadingDigitsPatterns()[n];if(e.length<3)try{return void 0!==new od(r).match(e,{allowOverflow:!0})}catch(t){return console.error(t),!0}return new RegExp("^(".concat(r,")")).test(e)}},{key:"getFormatFormat",value:function(t,e){return e?t.internationalFormat():t.format()}},{key:"chooseFormat",value:function(t){for(var e,n=this,d=function(){var d=e.value;return n.chosenFormat===d?"break":hd.test(n.getFormatFormat(d,t.international))?n.createTemplateForFormat(d,t)?(n.chosenFormat=d,"break"):(n.matchingFormats=n.matchingFormats.filter((function(t){return t!==d})),"continue"):"continue"},r=ud(this.matchingFormats.slice());!(e=r()).done;){var a=d();if("break"===a)break}return this.chosenFormat||this.resetFormat(),this.chosenFormat}},{key:"createTemplateForFormat",value:function(t,e){if(!(t.pattern().indexOf("|")>=0)){var n=this.getTemplateForFormat(t,e);return n?(this.setNationalNumberTemplate(n,e),!0):void 0}}},{key:"getSeparatorAfterNationalPrefix",value:function(t){return this.isNANP||t&&t.nationalPrefixFormattingRule()&&fd.test(t.nationalPrefixFormattingRule())?" ":""}},{key:"getInternationalPrefixBeforeCountryCallingCode",value:function(t,e){var n=t.IDDPrefix,d=t.missingPlus;return n?e&&!1===e.spacing?n:n+" ":d?"":"+"}},{key:"getTemplate",value:function(t){if(this.template){for(var e=-1,n=0,d=t.international?this.getInternationalPrefixBeforeCountryCallingCode(t,{spacing:!1}):"";n<d.length+t.getDigitsWithoutInternationalPrefix().length;)e=this.template.indexOf(Kn,e+1),n++;return Xn(this.template,e+1)}}},{key:"setNationalNumberTemplate",value:function(t,e){this.nationalNumberTemplate=t,this.populatedNationalNumberTemplate=t,this.populatedNationalNumberTemplatePosition=-1,e.international?this.template=this.getInternationalPrefixBeforeCountryCallingCode(e).replace(/[\d\+]/g,Kn)+Zn(Kn,e.callingCode.length)+" "+t:this.template=t}},{key:"getTemplateForFormat",value:function(t,e){var n=e.nationalSignificantNumber,d=e.international,r=e.nationalPrefix,a=e.complexPrefixBeforeNationalSignificantNumber,i=t.pattern();i=i.replace(/\[([^\[\]])*\]/g,"\\d").replace(/\d(?=[^,}][^,}])/g,"\\d");var o=sd.match(i)[0];if(!(n.length>o.length)){var $=new RegExp("^"+i+"$"),u=n.replace(/\d/g,"9");$.test(u)&&(o=u);var l,c=this.getFormatFormat(t,d);if(this.shouldTryNationalPrefixFormattingRule(t,{international:d,nationalPrefix:r})){var s=c.replace(ct,t.nationalPrefixFormattingRule());if(Y(t.nationalPrefixFormattingRule())===(r||"")+Y("$1")&&(c=s,l=!0,r))for(var f=r.length;f>0;)c=c.replace(/\d/,Kn),f--}var h=o.replace(new RegExp(i),c).replace(new RegExp("9","g"),Kn);return l||(a?h=Zn(Kn,a.length)+" "+h:r&&(h=Zn(Kn,r.length)+this.getSeparatorAfterNationalPrefix(t)+h)),d&&(h=lt(h)),h}}},{key:"formatNextNationalNumberDigits",value:function(t){var e=function(t,e,n){for(var d,r=Wn(n.split(""));!(d=r()).done;){var a=d.value;if(t.slice(e+1).search(Yn)<0)return;e=t.search(Yn),t=t.replace(Yn,a)}return[t,e]}(this.populatedNationalNumberTemplate,this.populatedNationalNumberTemplatePosition,t);if(e)return this.populatedNationalNumberTemplate=e[0],this.populatedNationalNumberTemplatePosition=e[1],Xn(this.populatedNationalNumberTemplate,this.populatedNationalNumberTemplatePosition+1);this.resetFormat()}},{key:"shouldTryNationalPrefixFormattingRule",value:function(t,e){var n=e.international,d=e.nationalPrefix;if(t.nationalPrefixFormattingRule()){var r=t.usesNationalPrefix();if(r&&d||!r&&!n)return!0}}}],n&&cd(e.prototype,n),d&&cd(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function gd(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var d,r,a=[],i=!0,o=!1;try{for(n=n.call(t);!(i=(d=n.next()).done)&&(a.push(d.value),!e||a.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==n.return||n.return()}finally{if(o)throw r}}return a}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return md(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return md(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function md(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function pd(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var bd=new RegExp("^"+("["+h+"0-9０-９٠-٩۰-۹]+")+"$","i"),vd="(?:[+＋]["+h+"0-9０-９٠-٩۰-۹]*|["+h+"0-9０-９٠-٩۰-۹]+)",Cd=new RegExp("[^"+h+"0-9０-９٠-٩۰-۹]+.*$"),Nd=/[^\d\[\]]/,Pd=function(){function t(e){var n=e.defaultCountry,d=e.defaultCallingCode,r=e.metadata,a=e.onNationalSignificantNumberChange;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.defaultCountry=n,this.defaultCallingCode=d,this.metadata=r,this.onNationalSignificantNumberChange=a}var e,n,d;return e=t,(n=[{key:"input",value:function(t,e){var n,d=function(t){var e=gd(function(t){var e=function(t){var e,n=t.search(vd);if(!(n<0))return"+"===(t=t.slice(n))[0]&&(e=!0,t=t.slice("+".length)),t=t.replace(Cd,""),e&&(t="+"+t),t}(t)||"";return"+"===e[0]?[e.slice("+".length),!0]:[e]}(t),2),n=e[0],d=e[1];return bd.test(n)||(n=""),[n,d]}(t),r=gd(d,2),a=r[0],i=r[1],o=Y(a);return i&&(e.digits||(e.startInternationalNumber(),o||(n=!0))),o&&this.inputDigits(o,e),{digits:o,justLeadingPlus:n}}},{key:"inputDigits",value:function(t,e){var n=e.digits,d=n.length<3&&n.length+t.length>=3;if(e.appendDigits(t),d&&this.extractIddPrefix(e),this.isWaitingForCountryCallingCode(e)){if(!this.extractCountryCallingCode(e))return}else e.appendNationalSignificantNumberDigits(t);e.international||this.hasExtractedNationalSignificantNumber||this.extractNationalSignificantNumber(e.getNationalDigits(),(function(t){return e.update(t)}))}},{key:"isWaitingForCountryCallingCode",value:function(t){var e=t.international,n=t.callingCode;return e&&!n}},{key:"extractCountryCallingCode",value:function(t){var e=_t("+"+t.getDigitsWithoutInternationalPrefix(),this.defaultCountry,this.defaultCallingCode,this.metadata.metadata),n=e.countryCallingCode,d=e.number;if(n)return t.setCallingCode(n),t.update({nationalSignificantNumber:d}),!0}},{key:"reset",value:function(t){if(t){this.hasSelectedNumberingPlan=!0;var e=t._nationalPrefixForParsing();this.couldPossiblyExtractAnotherNationalSignificantNumber=e&&Nd.test(e)}else this.hasSelectedNumberingPlan=void 0,this.couldPossiblyExtractAnotherNationalSignificantNumber=void 0}},{key:"extractNationalSignificantNumber",value:function(t,e){if(this.hasSelectedNumberingPlan){var n=Mt(t,this.metadata),d=n.nationalPrefix,r=n.nationalNumber,a=n.carrierCode;if(r!==t)return this.onExtractedNationalNumber(d,a,r,t,e),!0}}},{key:"extractAnotherNationalSignificantNumber",value:function(t,e,n){if(!this.hasExtractedNationalSignificantNumber)return this.extractNationalSignificantNumber(t,n);if(this.couldPossiblyExtractAnotherNationalSignificantNumber){var d=Mt(t,this.metadata),r=d.nationalPrefix,a=d.nationalNumber,i=d.carrierCode;if(a!==e)return this.onExtractedNationalNumber(r,i,a,t,n),!0}}},{key:"onExtractedNationalNumber",value:function(t,e,n,d,r){var a,i,o=d.lastIndexOf(n);if(o>=0&&o===d.length-n.length){i=!0;var $=d.slice(0,o);$!==t&&(a=$)}r({nationalPrefix:t,carrierCode:e,nationalSignificantNumber:n,nationalSignificantNumberMatchesInput:i,complexPrefixBeforeNationalSignificantNumber:a}),this.hasExtractedNationalSignificantNumber=!0,this.onNationalSignificantNumberChange()}},{key:"reExtractNationalSignificantNumber",value:function(t){return!!this.extractAnotherNationalSignificantNumber(t.getNationalDigits(),t.nationalSignificantNumber,(function(e){return t.update(e)}))||(this.extractIddPrefix(t)||this.fixMissingPlus(t)?(this.extractCallingCodeAndNationalSignificantNumber(t),!0):void 0)}},{key:"extractIddPrefix",value:function(t){var e=t.international,n=t.IDDPrefix,d=t.digits;if(t.nationalSignificantNumber,!e&&!n){var r=Ft(d,this.defaultCountry,this.defaultCallingCode,this.metadata.metadata);return void 0!==r&&r!==d?(t.update({IDDPrefix:d.slice(0,d.length-r.length)}),this.startInternationalNumber(t,{country:void 0,callingCode:void 0}),!0):void 0}}},{key:"fixMissingPlus",value:function(t){if(!t.international){var e=Rt(t.digits,this.defaultCountry,this.defaultCallingCode,this.metadata.metadata),n=e.countryCallingCode;if(e.number,n)return t.update({missingPlus:!0}),this.startInternationalNumber(t,{country:t.country,callingCode:n}),!0}}},{key:"startInternationalNumber",value:function(t,e){var n=e.country,d=e.callingCode;t.startInternationalNumber(n,d),t.nationalSignificantNumber&&(t.resetNationalSignificantNumber(),this.onNationalSignificantNumberChange(),this.hasExtractedNationalSignificantNumber=void 0)}},{key:"extractCallingCodeAndNationalSignificantNumber",value:function(t){this.extractCountryCallingCode(t)&&this.extractNationalSignificantNumber(t.getNationalDigits(),(function(e){return t.update(e)}))}}])&&pd(e.prototype,n),d&&pd(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function Od(t){return Od="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Od(t)}function xd(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var d,r,a=[],i=!0,o=!1;try{for(n=n.call(t);!(i=(d=n.next()).done)&&(a.push(d.value),!e||a.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==n.return||n.return()}finally{if(o)throw r}}return a}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return wd(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return wd(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function wd(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,d=new Array(e);n<e;n++)d[n]=t[n];return d}function Sd(t,e){for(var n=0;n<e.length;n++){var d=e[n];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(t,d.key,d)}}var Ed=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.metadata=new P(n);var d=xd(this.getCountryAndCallingCode(e),2),r=d[0],a=d[1];this.defaultCountry=r,this.defaultCallingCode=a,this.reset()}var e,n,d;return e=t,n=[{key:"getCountryAndCallingCode",value:function(t){var e,n;return t&&("object"===Od(t)?(e=t.defaultCountry,n=t.defaultCallingCode):e=t),e&&!this.metadata.hasCountry(e)&&(e=void 0),[e,n]}},{key:"input",value:function(t){var e=this.parser.input(t,this.state),n=e.digits;if(e.justLeadingPlus)this.formattedOutput="+";else if(n){var d;if(this.determineTheCountryIfNeeded(),this.state.nationalSignificantNumber&&this.formatter.narrowDownMatchingFormats(this.state),this.metadata.hasSelectedNumberingPlan()&&(d=this.formatter.format(n,this.state)),void 0===d&&this.parser.reExtractNationalSignificantNumber(this.state)){this.determineTheCountryIfNeeded();var r=this.state.getNationalDigits();r&&(d=this.formatter.format(r,this.state))}this.formattedOutput=d?this.getFullNumber(d):this.getNonFormattedNumber()}return this.formattedOutput}},{key:"reset",value:function(){var t=this;return this.state=new Hn({onCountryChange:function(e){t.country=e},onCallingCodeChange:function(e,n){t.metadata.selectNumberingPlan(n,e),t.formatter.reset(t.metadata.numberingPlan,t.state),t.parser.reset(t.metadata.numberingPlan)}}),this.formatter=new yd({state:this.state,metadata:this.metadata}),this.parser=new Pd({defaultCountry:this.defaultCountry,defaultCallingCode:this.defaultCallingCode,metadata:this.metadata,state:this.state,onNationalSignificantNumberChange:function(){t.determineTheCountryIfNeeded(),t.formatter.reset(t.metadata.numberingPlan,t.state)}}),this.state.reset({country:this.defaultCountry,callingCode:this.defaultCallingCode}),this.formattedOutput="",this}},{key:"isInternational",value:function(){return this.state.international}},{key:"getCallingCode",value:function(){if(this.isInternational())return this.state.callingCode}},{key:"getCountryCallingCode",value:function(){return this.getCallingCode()}},{key:"getCountry",value:function(){if(this.state.digits)return this._getCountry()}},{key:"_getCountry",value:function(){return this.state.country}},{key:"determineTheCountryIfNeeded",value:function(){this.state.country&&!this.isCountryCallingCodeAmbiguous()||this.determineTheCountry()}},{key:"getFullNumber",value:function(t){var e=this;if(this.isInternational()){var n=function(t){return e.formatter.getInternationalPrefixBeforeCountryCallingCode(e.state,{spacing:!!t})+t},d=this.state.callingCode;return n(d?t?"".concat(d," ").concat(t):d:"".concat(this.state.getDigitsWithoutInternationalPrefix()))}return t}},{key:"getNonFormattedNationalNumberWithPrefix",value:function(){var t=this.state,e=t.nationalSignificantNumber,n=t.complexPrefixBeforeNationalSignificantNumber,d=t.nationalPrefix,r=e,a=n||d;return a&&(r=a+r),r}},{key:"getNonFormattedNumber",value:function(){var t=this.state.nationalSignificantNumberMatchesInput;return this.getFullNumber(t?this.getNonFormattedNationalNumberWithPrefix():this.state.getNationalDigits())}},{key:"getNonFormattedTemplate",value:function(){var t=this.getNonFormattedNumber();if(t)return t.replace(/[\+\d]/g,Kn)}},{key:"isCountryCallingCodeAmbiguous",value:function(){var t=this.state.callingCode,e=this.metadata.getCountryCodesForCallingCode(t);return e&&e.length>1}},{key:"determineTheCountry",value:function(){this.state.setCountry(Ut(this.isInternational()?this.state.callingCode:this.defaultCallingCode,{nationalNumber:this.state.nationalSignificantNumber,defaultCountry:this.defaultCountry,metadata:this.metadata}))}},{key:"getNumberValue",value:function(){var t=this.state,e=t.digits,n=t.callingCode,d=t.country,r=t.nationalSignificantNumber;if(e)return this.isInternational()?n?"+"+n+r:"+"+e:d||n?"+"+(d?this.metadata.countryCallingCode():n)+r:void 0}},{key:"getNumber",value:function(){var t=this.state,e=t.nationalSignificantNumber,n=t.carrierCode,d=t.callingCode,r=this._getCountry();if(e&&(r||d)){if(r&&r===this.defaultCountry){var a=new P(this.metadata.metadata);a.selectNumberingPlan(r);var i=a.numberingPlan.callingCode(),o=this.metadata.getCountryCodesForCallingCode(i);if(o.length>1){var $=Bt(e,{countries:o,defaultCountry:this.defaultCountry,metadata:this.metadata.metadata});$&&(r=$)}}var u=new jt(r||d,e,this.metadata.metadata);return n&&(u.carrierCode=n),u}}},{key:"isPossible",value:function(){var t=this.getNumber();return!!t&&t.isPossible()}},{key:"isValid",value:function(){var t=this.getNumber();return!!t&&t.isValid()}},{key:"getNationalNumber",value:function(){return this.state.nationalSignificantNumber}},{key:"getChars",value:function(){return(this.state.international?"+":"")+this.state.digits}},{key:"getTemplate",value:function(){return this.formatter.getTemplate(this.state)||this.getNonFormattedTemplate()||""}}],n&&Sd(e.prototype,n),d&&Sd(e,d),Object.defineProperty(e,"prototype",{writable:!1}),t}();function Id(t){return new P(t).getCountries()}function Ad(t,e,n){if(e[t])return new jt(t,e[t],n)}function Td(t,e,n){return n||(n=e,e=void 0),new Ed(e,n).input(t)}function jd(){return n($e,arguments)}function kd(){return n(fe,arguments)}function Fd(t,n){return An.call(this,t,n,e)}function Md(t){return Ed.call(this,t,e)}function Dd(){return P.call(this,e)}Fd.prototype=Object.create(An.prototype,{}),Fd.prototype.constructor=Fd,Md.prototype=Object.create(Ed.prototype,{}),Md.prototype.constructor=Md,Dd.prototype=Object.create(P.prototype,{}),Dd.prototype.constructor=Dd,t.AsYouType=Md,t.DIGIT_PLACEHOLDER=Kn,t.Metadata=Dd,t.ParseError=s,t.PhoneNumberMatcher=Fd,t.default=kd,t.findNumbers=function(){return n(Tn,arguments)},t.findPhoneNumbersInText=function(){return n(Rn,arguments)},t.formatIncompletePhoneNumber=function(){return n(Td,arguments)},t.formatRFC3966=mt,t.getCountries=function(){return n(Id,arguments)},t.getCountryCallingCode=function(){return n(j,arguments)},t.getExampleNumber=function(){return n(Ad,arguments)},t.getExtPrefix=function(){return n(T,arguments)},t.isPossiblePhoneNumber=function(){return n(Ce,arguments)},t.isSupportedCountry=function(){return n(k,arguments)},t.isValidPhoneNumber=function(){return n(me,arguments)},t.parseDigits=Y,t.parseIncompletePhoneNumber=J,t.parsePhoneNumber=jd,t.parsePhoneNumberCharacter=Q,t.parsePhoneNumberFromString=kd,t.parsePhoneNumberWithError=jd,t.parseRFC3966=function(t){for(var e,n,d,r=function(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=yt(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var d=0;return function(){return d>=t.length?{done:!0}:{done:!1,value:t[d++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}((t=t.replace(/^tel:/,"tel=")).split(";"));!(d=r()).done;){var a=ht(d.value.split("="),2),i=a[0],o=a[1];switch(i){case"tel":e=o;break;case"ext":n=o;break;case"phone-context":"+"===o[0]&&(e=o+e)}}if(!B(e))return{};var $={number:e};return n&&($.ext=n),$},t.searchNumbers=function(){return n(kn,arguments)},t.searchPhoneNumbersInText=function(){return n(Bn,arguments)},t.validatePhoneNumberLength=function(){return n(xe,arguments)},Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=libphonenumber-mobile.js.map; /** ----------------- **/ 
 var libphonenumberExamples = {"AC":"40123","AD":"312345","AE":"501234567","AF":"701234567","AG":"2684641234","AI":"2642351234","AL":"672123456","AM":"77123456","AO":"923123456","AR":"91123456789","AS":"6847331234","AT":"664123456","AU":"412345678","AW":"5601234","AX":"412345678","AZ":"401234567","BA":"61123456","BB":"2462501234","BD":"1812345678","BE":"470123456","BF":"70123456","BG":"43012345","BH":"36001234","BI":"79561234","BJ":"90011234","BL":"690001234","BM":"4413701234","BN":"7123456","BO":"71234567","BQ":"3181234","BR":"11961234567","BS":"2423591234","BT":"17123456","BW":"71123456","BY":"294911911","BZ":"6221234","CA":"5062345678","CC":"412345678","CD":"991234567","CF":"70012345","CG":"061234567","CH":"781234567","CI":"0123456789","CK":"71234","CL":"221234567","CM":"671234567","CN":"13123456789","CO":"3211234567","CR":"83123456","CU":"51234567","CV":"9911234","CW":"95181234","CX":"412345678","CY":"96123456","CZ":"601123456","DE":"15123456789","DJ":"77831001","DK":"32123456","DM":"7672251234","DO":"8092345678","DZ":"551234567","EC":"991234567","EE":"51234567","EG":"1001234567","EH":"650123456","ER":"7123456","ES":"612345678","ET":"911234567","FI":"412345678","FJ":"7012345","FK":"51234","FM":"3501234","FO":"211234","FR":"612345678","GA":"06031234","GB":"7400123456","GD":"4734031234","GE":"555123456","GF":"694201234","GG":"7781123456","GH":"231234567","GI":"57123456","GL":"221234","GM":"3012345","GN":"601123456","GP":"690001234","GQ":"222123456","GR":"6912345678","GT":"51234567","GU":"6713001234","GW":"955012345","GY":"6091234","HK":"51234567","HN":"91234567","HR":"921234567","HT":"34101234","HU":"201234567","ID":"812345678","IE":"850123456","IL":"502345678","IM":"7924123456","IN":"8123456789","IO":"3801234","IQ":"7912345678","IR":"9123456789","IS":"6111234","IT":"3123456789","JE":"7797712345","JM":"8762101234","JO":"790123456","JP":"9012345678","KE":"712123456","KG":"700123456","KH":"91234567","KI":"72001234","KM":"3212345","KN":"8697652917","KP":"1921234567","KR":"1020000000","KW":"50012345","KY":"3453231234","KZ":"7710009998","LA":"2023123456","LB":"71123456","LC":"7582845678","LI":"660234567","LK":"712345678","LR":"770123456","LS":"50123456","LT":"61234567","LU":"628123456","LV":"21234567","LY":"912345678","MA":"650123456","MC":"612345678","MD":"62112345","ME":"67622901","MF":"690001234","MG":"321234567","MH":"2351234","MK":"72345678","ML":"65012345","MM":"92123456","MN":"88123456","MO":"66123456","MP":"6702345678","MQ":"696201234","MR":"22123456","MS":"6644923456","MT":"96961234","MU":"52512345","MV":"7712345","MW":"991234567","MX":"12221234567","MY":"123456789","MZ":"821234567","NA":"811234567","NC":"751234","NE":"93123456","NF":"381234","NG":"8021234567","NI":"81234567","NL":"612345678","NO":"40612345","NP":"9841234567","NR":"5551234","NU":"8884012","NZ":"211234567","OM":"92123456","PA":"61234567","PE":"912345678","PF":"87123456","PG":"70123456","PH":"9051234567","PK":"3012345678","PL":"512345678","PM":"551234","PR":"7872345678","PS":"599123456","PT":"912345678","PW":"6201234","PY":"961456789","QA":"33123456","RE":"692123456","RO":"712034567","RS":"601234567","RU":"9123456789","RW":"720123456","SA":"512345678","SB":"7421234","SC":"2510123","SD":"911231234","SE":"701234567","SG":"81234567","SH":"51234","SI":"31234567","SJ":"41234567","SK":"912123456","SL":"25123456","SM":"66661212","SN":"701234567","SO":"71123456","SR":"7412345","SS":"977123456","ST":"9812345","SV":"70123456","SX":"7215205678","SY":"944567890","SZ":"76123456","TA":"8999","TC":"6492311234","TD":"63012345","TG":"90112345","TH":"812345678","TJ":"917123456","TK":"7290","TL":"77212345","TM":"66123456","TN":"20123456","TO":"7715123","TR":"5012345678","TT":"8682911234","TV":"901234","TW":"912345678","TZ":"621234567","UA":"501234567","UG":"712345678","US":"2015550123","UY":"94231234","UZ":"912345678","VA":"3123456789","VC":"7844301234","VE":"4121234567","VG":"2843001234","VI":"3406421234","VN":"912345678","VU":"5912345","WF":"821234","WS":"7212345","XK":"43201234","YE":"712345678","YT":"639012345","ZA":"711234567","ZM":"955123456","ZW":"712345678"};
; /** ----------------- **/ 
 function translation(path) {
    var keysArray = path.split('.');
    var result = TRANSLATIONS;

    for (var key in keysArray) {
        if(result[keysArray[key]]) {
            result = result[keysArray[key]];
        } else {
            result = 'JS.' + path;
            break;
        }
    }

    return result;
}

; /** ----------------- **/ 
 /**
 * Twig.js 0.8.3
 *
 * @copyright 2011-2015 John Roepke and the Twig.js Contributors
 * @license   Available under the BSD 2-Clause License
 * @link      https://github.com/justjohn/twig.js
 */

var Twig = (function (Twig) {

    Twig.VERSION = "0.8.4";

    return Twig;
})(Twig || {});
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

var Twig = (function (Twig) {
    "use strict";
    // ## twig.core.js
    //
    // This file handles template level tokenizing, compiling and parsing.

    Twig.trace = false;
    Twig.debug = false;

    // Default caching to true for the improved performance it offers
    Twig.cache = true;

    Twig.placeholders = {
        parent: "{{|PARENT|}}"
    };

    /**
     * Fallback for Array.indexOf for IE8 et al
     */
    Twig.indexOf = function (arr, searchElement /*, fromIndex */ ) {
        if (Array.prototype.hasOwnProperty("indexOf")) {
            return arr.indexOf(searchElement);
        }
        if (arr === void 0 || arr === null) {
            throw new TypeError();
        }
        var t = Object(arr);
        var len = t.length >>> 0;
        if (len === 0) {
            return -1;
        }
        var n = 0;
        if (arguments.length > 0) {
            n = Number(arguments[1]);
            if (n !== n) { // shortcut for verifying if it's NaN
                n = 0;
            } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }
        if (n >= len) {
            // console.log("indexOf not found1 ", JSON.stringify(searchElement), JSON.stringify(arr));
            return -1;
        }
        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for (; k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }
        if (arr == searchElement) {
            return 0;
        }
        // console.log("indexOf not found2 ", JSON.stringify(searchElement), JSON.stringify(arr));

        return -1;
    }

    Twig.forEach = function (arr, callback, thisArg) {
        if (Array.prototype.forEach ) {
            return arr.forEach(callback, thisArg);
        }

        var T, k;

        if ( arr == null ) {
          throw new TypeError( " this is null or not defined" );
        }

        // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
        var O = Object(arr);

        // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0; // Hack to convert O.length to a UInt32

        // 4. If IsCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if ( {}.toString.call(callback) != "[object Function]" ) {
          throw new TypeError( callback + " is not a function" );
        }

        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if ( thisArg ) {
          T = thisArg;
        }

        // 6. Let k be 0
        k = 0;

        // 7. Repeat, while k < len
        while( k < len ) {

          var kValue;

          // a. Let Pk be ToString(k).
          //   This is implicit for LHS operands of the in operator
          // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
          //   This step can be combined with c
          // c. If kPresent is true, then
          if ( k in O ) {

            // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
            kValue = O[ k ];

            // ii. Call the Call internal method of callback with T as the this value and
            // argument list containing kValue, k, and O.
            callback.call( T, kValue, k, O );
          }
          // d. Increase k by 1.
          k++;
        }
        // 8. return undefined
    };

    Twig.merge = function(target, source, onlyChanged) {
        Twig.forEach(Object.keys(source), function (key) {
            if (onlyChanged && !(key in target)) {
                return;
            }

            target[key] = source[key]
        });

        return target;
    };

    /**
     * Exception thrown by twig.js.
     */
    Twig.Error = function(message) {
       this.message = message;
       this.name = "TwigException";
       this.type = "TwigException";
    };

    /**
     * Get the string representation of a Twig error.
     */
    Twig.Error.prototype.toString = function() {
        var output = this.name + ": " + this.message;

        return output;
    };

    /**
     * Wrapper for logging to the console.
     */
    Twig.log = {
        trace: function() {if (Twig.trace && console) {console.log(Array.prototype.slice.call(arguments));}},
        debug: function() {if (Twig.debug && console) {console.log(Array.prototype.slice.call(arguments));}}
    };

    if (typeof console !== "undefined") {
        if (typeof console.error !== "undefined") {
            Twig.log.error = function() {
                console.error.apply(console, arguments);
            }
        } else if (typeof console.log !== "undefined") {
            Twig.log.error = function() {
                console.log.apply(console, arguments);
            }
        }
    } else {
        Twig.log.error = function(){};
    }

    /**
     * Wrapper for child context objects in Twig.
     *
     * @param {Object} context Values to initialize the context with.
     */
    Twig.ChildContext = function(context) {
        var ChildContext = function ChildContext() {};
        ChildContext.prototype = context;
        return new ChildContext();
    };

    /**
     * Container for methods related to handling high level template tokens
     *      (for example: {{ expression }}, {% logic %}, {# comment #}, raw data)
     */
    Twig.token = {};

    /**
     * Token types.
     */
    Twig.token.type = {
        output:  'output',
        logic:   'logic',
        comment: 'comment',
        raw:     'raw'
    };

    /**
     * Token syntax definitions.
     */
    Twig.token.definitions = [
        {
            type: Twig.token.type.raw,
            open: '{% raw %}',
            close: '{% endraw %}'
        },
        {
            type: Twig.token.type.raw,
            open: '{% verbatim %}',
            close: '{% endverbatim %}'
        },
        // *Output type tokens*
        //
        // These typically take the form `{{ expression }}`.
        {
            type: Twig.token.type.output,
            open: '{{',
            close: '}}'
        },
        // *Logic type tokens*
        //
        // These typically take a form like `{% if expression %}` or `{% endif %}`
        {
            type: Twig.token.type.logic,
            open: '{%',
            close: '%}'
        },
        // *Comment type tokens*
        //
        // These take the form `{# anything #}`
        {
            type: Twig.token.type.comment,
            open: '{#',
            close: '#}'
        }
    ];


    /**
     * What characters start "strings" in token definitions. We need this to ignore token close
     * strings inside an expression.
     */
    Twig.token.strings = ['"', "'"];

    Twig.token.findStart = function (template) {
        var output = {
                position: null,
                def: null
            },
            i,
            token_template,
            first_key_position;

        for (i=0;i<Twig.token.definitions.length;i++) {
            token_template = Twig.token.definitions[i];
            first_key_position = template.indexOf(token_template.open);

            Twig.log.trace("Twig.token.findStart: ", "Searching for ", token_template.open, " found at ", first_key_position);

            // Does this token occur before any other types?
            if (first_key_position >= 0 && (output.position === null || first_key_position < output.position)) {
                output.position = first_key_position;
                output.def = token_template;
            }
        }

        return output;
    };

    Twig.token.findEnd = function (template, token_def, start) {
        var end = null,
            found = false,
            offset = 0,

            // String position variables
            str_pos = null,
            str_found = null,
            pos = null,
            end_offset = null,
            this_str_pos = null,
            end_str_pos = null,

            // For loop variables
            i,
            l;

        while (!found) {
            str_pos = null;
            str_found = null;
            pos = template.indexOf(token_def.close, offset);

            if (pos >= 0) {
                end = pos;
                found = true;
            } else {
                // throw an exception
                throw new Twig.Error("Unable to find closing bracket '" + token_def.close +
                                "'" + " opened near template position " + start);
            }

            // Ignore quotes within comments; just look for the next comment close sequence,
            // regardless of what comes before it. https://github.com/justjohn/twig.js/issues/95
            if (token_def.type === Twig.token.type.comment) {
              break;
            }

            l = Twig.token.strings.length;
            for (i = 0; i < l; i += 1) {
                this_str_pos = template.indexOf(Twig.token.strings[i], offset);

                if (this_str_pos > 0 && this_str_pos < pos &&
                        (str_pos === null || this_str_pos < str_pos)) {
                    str_pos = this_str_pos;
                    str_found = Twig.token.strings[i];
                }
            }

            // We found a string before the end of the token, now find the string's end and set the search offset to it
            if (str_pos !== null) {
                end_offset = str_pos + 1;
                end = null;
                found = false;
                while (true) {
                    end_str_pos = template.indexOf(str_found, end_offset);
                    if (end_str_pos < 0) {
                        throw "Unclosed string in template";
                    }
                    // Ignore escaped quotes
                    if (template.substr(end_str_pos - 1, 1) !== "\\") {
                        offset = end_str_pos + 1;
                        break;
                    } else {
                        end_offset = end_str_pos + 1;
                    }
                }
            }
        }
        return end;
    };

    /**
     * Convert a template into high-level tokens.
     */
    Twig.tokenize = function (template) {
        var tokens = [],
            // An offset for reporting errors locations in the template.
            error_offset = 0,

            // The start and type of the first token found in the template.
            found_token = null,
            // The end position of the matched token.
            end = null;

        while (template.length > 0) {
            // Find the first occurance of any token type in the template
            found_token = Twig.token.findStart(template);

            Twig.log.trace("Twig.tokenize: ", "Found token: ", found_token);

            if (found_token.position !== null) {
                // Add a raw type token for anything before the start of the token
                if (found_token.position > 0) {
                    tokens.push({
                        type: Twig.token.type.raw,
                        value: template.substring(0, found_token.position)
                    });
                }
                template = template.substr(found_token.position + found_token.def.open.length);
                error_offset += found_token.position + found_token.def.open.length;

                // Find the end of the token
                end = Twig.token.findEnd(template, found_token.def, error_offset);

                Twig.log.trace("Twig.tokenize: ", "Token ends at ", end);

                tokens.push({
                    type:  found_token.def.type,
                    value: template.substring(0, end).trim()
                });

                if ( found_token.def.type === "logic" && template.substr( end + found_token.def.close.length, 1 ) === "\n" ) {
                    // Newlines directly after logic tokens are ignored
                    end += 1;
                }

                template = template.substr(end + found_token.def.close.length);

                // Increment the position in the template
                error_offset += end + found_token.def.close.length;

            } else {
                // No more tokens -> add the rest of the template as a raw-type token
                tokens.push({
                    type: Twig.token.type.raw,
                    value: template
                });
                template = '';
            }
        }

        return tokens;
    };


    Twig.compile = function (tokens) {
        try {

            // Output and intermediate stacks
            var output = [],
                stack = [],
                // The tokens between open and close tags
                intermediate_output = [],

                token = null,
                logic_token = null,
                unclosed_token = null,
                // Temporary previous token.
                prev_token = null,
                // The previous token's template
                prev_template = null,
                // The output token
                tok_output = null,

                // Logic Token values
                type = null,
                open = null,
                next = null;

            while (tokens.length > 0) {
                token = tokens.shift();
                Twig.log.trace("Compiling token ", token);
                switch (token.type) {
                    case Twig.token.type.raw:
                        if (stack.length > 0) {
                            intermediate_output.push(token);
                        } else {
                            output.push(token);
                        }
                        break;

                    case Twig.token.type.logic:
                        // Compile the logic token
                        logic_token = Twig.logic.compile.apply(this, [token]);

                        type = logic_token.type;
                        open = Twig.logic.handler[type].open;
                        next = Twig.logic.handler[type].next;

                        Twig.log.trace("Twig.compile: ", "Compiled logic token to ", logic_token,
                                                         " next is: ", next, " open is : ", open);

                        // Not a standalone token, check logic stack to see if this is expected
                        if (open !== undefined && !open) {
                            prev_token = stack.pop();
                            prev_template = Twig.logic.handler[prev_token.type];

                            if (Twig.indexOf(prev_template.next, type) < 0) {
                                throw new Error(type + " not expected after a " + prev_token.type);
                            }

                            prev_token.output = prev_token.output || [];

                            prev_token.output = prev_token.output.concat(intermediate_output);
                            intermediate_output = [];

                            tok_output = {
                                type: Twig.token.type.logic,
                                token: prev_token
                            };
                            if (stack.length > 0) {
                                intermediate_output.push(tok_output);
                            } else {
                                output.push(tok_output);
                            }
                        }

                        // This token requires additional tokens to complete the logic structure.
                        if (next !== undefined && next.length > 0) {
                            Twig.log.trace("Twig.compile: ", "Pushing ", logic_token, " to logic stack.");

                            if (stack.length > 0) {
                                // Put any currently held output into the output list of the logic operator
                                // currently at the head of the stack before we push a new one on.
                                prev_token = stack.pop();
                                prev_token.output = prev_token.output || [];
                                prev_token.output = prev_token.output.concat(intermediate_output);
                                stack.push(prev_token);
                                intermediate_output = [];
                            }

                            // Push the new logic token onto the logic stack
                            stack.push(logic_token);

                        } else if (open !== undefined && open) {
                            tok_output = {
                                type: Twig.token.type.logic,
                                token: logic_token
                            };
                            // Standalone token (like {% set ... %}
                            if (stack.length > 0) {
                                intermediate_output.push(tok_output);
                            } else {
                                output.push(tok_output);
                            }
                        }
                        break;

                    // Do nothing, comments should be ignored
                    case Twig.token.type.comment:
                        break;

                    case Twig.token.type.output:
                        Twig.expression.compile.apply(this, [token]);
                        if (stack.length > 0) {
                            intermediate_output.push(token);
                        } else {
                            output.push(token);
                        }
                        break;
                }

                Twig.log.trace("Twig.compile: ", " Output: ", output,
                                                 " Logic Stack: ", stack,
                                                 " Pending Output: ", intermediate_output );
            }

            // Verify that there are no logic tokens left in the stack.
            if (stack.length > 0) {
                unclosed_token = stack.pop();
                throw new Error("Unable to find an end tag for " + unclosed_token.type +
                                ", expecting one of " + unclosed_token.next);
            }
            return output;
        } catch (ex) {
            Twig.log.error("Error compiling twig template " + this.id + ": ");
            if (ex.stack) {
                Twig.log.error(ex.stack);
            } else {
                Twig.log.error(ex.toString());
            }

            if (this.options.rethrow) throw ex;
        }
    };

    /**
     * Parse a compiled template.
     *
     * @param {Array} tokens The compiled tokens.
     * @param {Object} context The render context.
     *
     * @return {string} The parsed template.
     */
    Twig.parse = function (tokens, context) {
        try {
            var output = [],
                // Track logic chains
                chain = true,
                that = this;

            Twig.forEach(tokens, function parseToken(token) {
                Twig.log.debug("Twig.parse: ", "Parsing token: ", token);

                switch (token.type) {
                    case Twig.token.type.raw:
                        output.push(Twig.filters.raw(token.value));
                        break;

                    case Twig.token.type.logic:
                        var logic_token = token.token,
                            logic = Twig.logic.parse.apply(that, [logic_token, context, chain]);

                        if (logic.chain !== undefined) {
                            chain = logic.chain;
                        }
                        if (logic.context !== undefined) {
                            context = logic.context;
                        }
                        if (logic.output !== undefined) {
                            output.push(logic.output);
                        }
                        break;

                    case Twig.token.type.comment:
                        // Do nothing, comments should be ignored
                        break;

                    case Twig.token.type.output:
                        Twig.log.debug("Twig.parse: ", "Output token: ", token.stack);
                        // Parse the given expression in the given context
                        output.push(Twig.expression.parse.apply(that, [token.stack, context]));
                        break;
                }
            });
            return Twig.output.apply(this, [output]);
        } catch (ex) {
            Twig.log.error("Error parsing twig template " + this.id + ": ");
            if (ex.stack) {
                Twig.log.error(ex.stack);
            } else {
                Twig.log.error(ex.toString());
            }

            if (this.options.rethrow) throw ex;

            if (Twig.debug) {
                return ex.toString();
            }
        }
    };

    /**
     * Tokenize and compile a string template.
     *
     * @param {string} data The template.
     *
     * @return {Array} The compiled tokens.
     */
    Twig.prepare = function(data) {
        var tokens, raw_tokens;

        // Tokenize
        Twig.log.debug("Twig.prepare: ", "Tokenizing ", data);
        raw_tokens = Twig.tokenize.apply(this, [data]);

        // Compile
        Twig.log.debug("Twig.prepare: ", "Compiling ", raw_tokens);
        tokens = Twig.compile.apply(this, [raw_tokens]);

        Twig.log.debug("Twig.prepare: ", "Compiled ", tokens);

        return tokens;
    };

    /**
     * Join the output token's stack and escape it if needed
     *
     * @param {Array} Output token's stack
     *
     * @return {string|String} Autoescaped output
     */
    Twig.output = function(output) {
        if (!this.options.autoescape) {
            return output.join("");
        }

        // [].map would be better but it's not supported by IE8-
        var escaped_output = [];
        Twig.forEach(output, function (str) {
            if (str && !str.twig_markup) {
                str = Twig.filters.escape(str);
            }
            escaped_output.push(str);
        });
        return Twig.Markup(escaped_output.join(""));
    }

    // Namespace for template storage and retrieval
    Twig.Templates = {
        registry: {}
    };

    /**
     * Is this id valid for a twig template?
     *
     * @param {string} id The ID to check.
     *
     * @throws {Twig.Error} If the ID is invalid or used.
     * @return {boolean} True if the ID is valid.
     */
    Twig.validateId = function(id) {
        if (id === "prototype") {
            throw new Twig.Error(id + " is not a valid twig identifier");
        } else if (Twig.Templates.registry.hasOwnProperty(id)) {
            throw new Twig.Error("There is already a template with the ID " + id);
        }
        return true;
    }

    /**
     * Save a template object to the store.
     *
     * @param {Twig.Template} template   The twig.js template to store.
     */
    Twig.Templates.save = function(template) {
        if (template.id === undefined) {
            throw new Twig.Error("Unable to save template with no id");
        }
        Twig.Templates.registry[template.id] = template;
    };

    /**
     * Load a previously saved template from the store.
     *
     * @param {string} id   The ID of the template to load.
     *
     * @return {Twig.Template} A twig.js template stored with the provided ID.
     */
    Twig.Templates.load = function(id) {
        if (!Twig.Templates.registry.hasOwnProperty(id)) {
            // check the loader
            if (window && window.hasOwnProperty("custom_twig_loader"))
            {
                window["custom_twig_loader"](id);
            }

            if (!Twig.Templates.registry.hasOwnProperty(id)) {

				return null;
			}
        }
        return Twig.Templates.registry[id];
    };

    /**
     * Load a template from a remote location using AJAX and saves in with the given ID.
     *
     * Available parameters:
     *
     *      async:       Should the HTTP request be performed asynchronously.
     *                      Defaults to true.
     *      method:      What method should be used to load the template
     *                      (fs or ajax)
     *      precompiled: Has the template already been compiled.
     *
     * @param {string} location  The remote URL to load as a template.
     * @param {Object} params The template parameters.
     * @param {function} callback  A callback triggered when the template finishes loading.
     * @param {function} error_callback  A callback triggered if an error occurs loading the template.
     *
     *
     */
    Twig.Templates.loadRemote = function(location, params, callback, error_callback) {
        var id          = params.id,
            method      = params.method,
            async       = params.async,
            precompiled = params.precompiled,
            template    = null;

        // Default to async
        if (async === undefined) async = true;

        // Default to the URL so the template is cached.
        if (id === undefined) {
            id = location;
        }
        params.id = id;

        // Check for existing template
        if (Twig.cache && Twig.Templates.registry.hasOwnProperty(id)) {
            // A template is already saved with the given id.
            if (callback) {
                callback(Twig.Templates.registry[id]);
            }
            return Twig.Templates.registry[id];
        }

        if (method == 'ajax') {
            if (typeof XMLHttpRequest == "undefined") {
                throw new Twig.Error("Unsupported platform: Unable to do remote requests " +
                                     "because there is no XMLHTTPRequest implementation");
            }

            var xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function() {
                var data = null;

                if(xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) {
                        Twig.log.debug("Got template ", xmlhttp.responseText);

                        if (precompiled === true) {
                            data = JSON.parse(xmlhttp.responseText);
                        } else {
                            data = xmlhttp.responseText;
                        }

                        params.url = location;
                        params.data = data;

                        template = new Twig.Template(params);

                        if (callback) {
                            callback(template);
                        }
                    } else {
                        if (error_callback) {
                            error_callback(xmlhttp);
                        }
                    }
                }
            };
            xmlhttp.open("GET", location, async);
            xmlhttp.send();

        } else { // if method = 'fs'
            // Create local scope
            (function() {
                var fs = require('fs'),
                    path = require('path'),
                    data = null,
                    loadTemplateFn = function(err, data) {
                        if (err) {
                            if (error_callback) {
                                error_callback(err);
                            }
                            return;
                        }

                        if (precompiled === true) {
                            data = JSON.parse(data);
                        }

                        params.data = data;
                        params.path = location;

                        // template is in data
                        template = new Twig.Template(params);

                        if (callback) {
                            callback(template);
                        }
                    };

                if (async === true) {
                    fs.stat(location, function (err, stats) {
                        if (err || !stats.isFile())
                            throw new Twig.Error("Unable to find template file " + location);

                        fs.readFile(location, 'utf8', loadTemplateFn);
                    });
                } else {
                    if (!fs.statSync(location).isFile())
                        throw new Twig.Error("Unable to find template file " + location);

                    data = fs.readFileSync(location, 'utf8');
                    loadTemplateFn(undefined, data);
                }
            })();
        }
        if (async === false) {
            return template;
        } else {
            // placeholder for now, should eventually return a deferred object.
            return true;
        }
    };

    // Determine object type
    function is(type, obj) {
        var clas = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && clas === type;
    }

    /**
     * Create a new twig.js template.
     *
     * Parameters: {
     *      data:   The template, either pre-compiled tokens or a string template
     *      id:     The name of this template
     *      blocks: Any pre-existing block from a child template
     * }
     *
     * @param {Object} params The template parameters.
     */
    Twig.Template = function ( params ) {
        var data = params.data,
            id = params.id,
            blocks = params.blocks,
            macros = params.macros || {},
            base = params.base,
            path = params.path,
            url = params.url,
            // parser options
            options = params.options;

        // # What is stored in a Twig.Template
        //
        // The Twig Template hold several chucks of data.
        //
        //     {
        //          id:     The token ID (if any)
        //          tokens: The list of tokens that makes up this template.
        //          blocks: The list of block this template contains.
        //          base:   The base template (if any)
        //            options:  {
        //                Compiler/parser options
        //
        //                strict_variables: true/false
        //                    Should missing variable/keys emit an error message. If false, they default to null.
        //            }
        //     }
        //

        this.id     = id;
        this.base   = base;
        this.path   = path;
        this.url    = url;
        this.macros = macros;
        this.options = options;

        this.reset(blocks);

        if (is('String', data)) {
            this.tokens = Twig.prepare.apply(this, [data]);
        } else {
            this.tokens = data;
        }

        if (id !== undefined) {
            Twig.Templates.save(this);
        }
    };

    Twig.Template.prototype.unset = function(id) {
        delete Twig.Templates.registry[id];
    };

    Twig.Template.prototype.reset = function(blocks) {
        Twig.log.debug("Twig.Template.reset", "Reseting template " + this.id);
        this.blocks = {};
        this.importedBlocks = [];
        this.originalBlockTokens = {};
        this.child = {
            blocks: blocks || {}
        };
        this.extend = null;
    };

    Twig.Template.prototype.render = function (context, params) {
        params = params || {};

        var output,
            url;

        this.context = context || {};

        // Clear any previous state
        this.reset();
        if (params.blocks) {
            this.blocks = params.blocks;
        }
        if (params.macros) {
            this.macros = params.macros;
        }

        output = Twig.parse.apply(this, [this.tokens, this.context]);

        // Does this template extend another
        if (this.extend) {
            var ext_template;

            // check if the template is provided inline
            if ( this.options.allowInlineIncludes ) {
                ext_template = Twig.Templates.load(this.extend);
                if ( ext_template ) {
                    ext_template.options = this.options;
                }
            }

            // check for the template file via include
            if (!ext_template) {
                url = relativePath(this, this.extend);

                ext_template = Twig.Templates.loadRemote(url, {
                    method: this.url?'ajax':'fs',
                    base: this.base,
                    async:  false,
                    id:     url,
                    options: this.options
                });
            }

            this.parent = ext_template;

            return this.parent.render(this.context, {
                blocks: this.blocks
            });
        }

        if (params.output == 'blocks') {
            return this.blocks;
        } else if (params.output == 'macros') {
            return this.macros;
        } else {
            return output;
        }
    };

    Twig.Template.prototype.importFile = function(file) {
        var url, sub_template;
        if ( !this.url && !this.path && this.options.allowInlineIncludes ) {
            sub_template = Twig.Templates.load(file);
            sub_template.options = this.options;
            if ( sub_template ) {
                return sub_template;
            }

            throw new Twig.Error("Didn't find the inline template by id");
        }

        url = relativePath(this, file);

        // Load blocks from an external file
        sub_template = Twig.Templates.loadRemote(url, {
            method: this.url?'ajax':'fs',
            base: this.base,
            async: false,
            options: this.options,
            id: url
        });

        return sub_template;
    };

    Twig.Template.prototype.importBlocks = function(file, override) {
        var sub_template = this.importFile(file),
            context = this.context,
            that = this,
            key;

        override = override || false;

        sub_template.render(context);

        // Mixin blocks
        Twig.forEach(Object.keys(sub_template.blocks), function(key) {
            if (override || that.blocks[key] === undefined) {
                that.blocks[key] = sub_template.blocks[key];
                that.importedBlocks.push(key);
            }
        });
    };

    Twig.Template.prototype.compile = function(options) {
        // compile the template into raw JS
        return Twig.compiler.compile(this, options);
    };

    /**
     * Create safe output
     *
     * @param {string} Content safe to output
     *
     * @return {String} Content wrapped into a String
     */

    Twig.Markup = function(content) {
        if (typeof content === 'string' && content.length > 0) {
            content = new String(content);
            content.twig_markup = true;
        }
        return content;
    }

    /**
     * Generate the relative canonical version of a url based on the given base path and file path.
     *
     * @param {string} template The Twig.Template.
     * @param {string} file The file path, relative to the base path.
     *
     * @return {string} The canonical version of the path.
     */
    function relativePath(template, file) {
        var base,
            base_path,
            sep_chr = "/",
            new_path = [],
            val;

        if (template.url) {
            if (typeof template.base !== 'undefined') {
                base = template.base + ((template.base.charAt(template.base.length-1) === '/') ? '' : '/');
            } else {
                base = template.url;
            }
        } else if (template.path) {
            // Get the system-specific path separator
            var path = require("path"),
                sep = path.sep || sep_chr,
                relative = new RegExp("^\\.{1,2}" + sep.replace("\\", "\\\\"));
            file = file.replace(/\//g, sep);

            if (template.base !== undefined && file.match(relative) == null) {
                file = file.replace(template.base, '');
                base = template.base + sep;
            } else {
                base = template.path;
            }

            base = base.replace(sep+sep, sep);
            sep_chr = sep;
        } else {
            throw new Twig.Error("Cannot extend an inline template.");
        }

        base_path = base.split(sep_chr);

        // Remove file from url
        base_path.pop();
        base_path = base_path.concat(file.split(sep_chr));

        while (base_path.length > 0) {
            val = base_path.shift();
            if (val == ".") {
                // Ignore
            } else if (val == ".." && new_path.length > 0 && new_path[new_path.length-1] != "..") {
                new_path.pop();
            } else {
                new_path.push(val);
            }
        }

        return new_path.join(sep_chr);
    }

    return Twig;

}) (Twig || { });

// The following methods are from MDN and are available under a
// [MIT License](http://www.opensource.org/licenses/mit-license.php) or are
// [Public Domain](https://developer.mozilla.org/Project:Copyrights).
//
// See:
// * [Object.keys - MDN](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Object/keys)

// ## twig.fills.js
//
// This file contains fills for backwards compatability.
(function() {
    "use strict";
    // Handle methods that don't yet exist in every browser

    if (!String.prototype.trim) {
        String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g,'');
        }
    };

    if(!Object.keys) Object.keys = function(o){
        if (o !== Object(o)) {
            throw new TypeError('Object.keys called on non-object');
        }
        var ret = [], p;
        for (p in o) if (Object.prototype.hasOwnProperty.call(o, p)) ret.push(p);
        return ret;
    }

})();
// ## twig.lib.js
//
// This file contains 3rd party libraries used within twig.
//
// Copies of the licenses for the code included here can be found in the
// LICENSES.md file.
//

var Twig = (function(Twig) {

    // Namespace for libraries
    Twig.lib = { };

    /**
    sprintf() for JavaScript 1.0.3
    https://github.com/alexei/sprintf.js
    **/
    var sprintfLib = (function() {
        var re = {
            not_string: /[^s]/,
            number: /[diefg]/,
            json: /[j]/,
            not_json: /[^j]/,
            text: /^[^\x25]+/,
            modulo: /^\x25{2}/,
            placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
            key: /^([a-z_][a-z_\d]*)/i,
            key_access: /^\.([a-z_][a-z_\d]*)/i,
            index_access: /^\[(\d+)\]/,
            sign: /^[\+\-]/
        }

        function sprintf() {
            var key = arguments[0], cache = sprintf.cache
            if (!(cache[key] && cache.hasOwnProperty(key))) {
                cache[key] = sprintf.parse(key)
            }
            return sprintf.format.call(null, cache[key], arguments)
        }

        sprintf.format = function(parse_tree, argv) {
            var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
            for (i = 0; i < tree_length; i++) {
                node_type = get_type(parse_tree[i])
                if (node_type === "string") {
                    output[output.length] = parse_tree[i]
                }
                else if (node_type === "array") {
                    match = parse_tree[i] // convenience purposes only
                    if (match[2]) { // keyword argument
                        arg = argv[cursor]
                        for (k = 0; k < match[2].length; k++) {
                            if (!arg.hasOwnProperty(match[2][k])) {
                                throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
                            }
                            arg = arg[match[2][k]]
                        }
                    }
                    else if (match[1]) { // positional argument (explicit)
                        arg = argv[match[1]]
                    }
                    else { // positional argument (implicit)
                        arg = argv[cursor++]
                    }

                    if (get_type(arg) == "function") {
                        arg = arg()
                    }

                    if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
                        throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
                    }

                    if (re.number.test(match[8])) {
                        is_positive = arg >= 0
                    }

                    switch (match[8]) {
                        case "b":
                            arg = arg.toString(2)
                            break
                        case "c":
                            arg = String.fromCharCode(arg)
                            break
                        case "d":
                        case "i":
                            arg = parseInt(arg, 10)
                            break
                        case "j":
                            arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
                            break
                        case "e":
                            arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
                            break
                        case "f":
                            arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
                            break
                        case "g":
                            arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
                            break
                        case "o":
                            arg = arg.toString(8)
                            break
                        case "s":
                            arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
                            break
                        case "u":
                            arg = arg >>> 0
                            break
                        case "x":
                            arg = arg.toString(16)
                            break
                        case "X":
                            arg = arg.toString(16).toUpperCase()
                            break
                    }
                    if (re.json.test(match[8])) {
                        output[output.length] = arg
                    }
                    else {
                        if (re.number.test(match[8]) && (!is_positive || match[3])) {
                            sign = is_positive ? "+" : "-"
                            arg = arg.toString().replace(re.sign, "")
                        }
                        else {
                            sign = ""
                        }
                        pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
                        pad_length = match[6] - (sign + arg).length
                        pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
                        output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
                    }
                }
            }
            return output.join("")
        }

        sprintf.cache = {}

        sprintf.parse = function(fmt) {
            var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
            while (_fmt) {
                if ((match = re.text.exec(_fmt)) !== null) {
                    parse_tree[parse_tree.length] = match[0]
                }
                else if ((match = re.modulo.exec(_fmt)) !== null) {
                    parse_tree[parse_tree.length] = "%"
                }
                else if ((match = re.placeholder.exec(_fmt)) !== null) {
                    if (match[2]) {
                        arg_names |= 1
                        var field_list = [], replacement_field = match[2], field_match = []
                        if ((field_match = re.key.exec(replacement_field)) !== null) {
                            field_list[field_list.length] = field_match[1]
                            while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                                if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                    field_list[field_list.length] = field_match[1]
                                }
                                else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                    field_list[field_list.length] = field_match[1]
                                }
                                else {
                                    throw new SyntaxError("[sprintf] failed to parse named argument key")
                                }
                            }
                        }
                        else {
                            throw new SyntaxError("[sprintf] failed to parse named argument key")
                        }
                        match[2] = field_list
                    }
                    else {
                        arg_names |= 2
                    }
                    if (arg_names === 3) {
                        throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
                    }
                    parse_tree[parse_tree.length] = match
                }
                else {
                    throw new SyntaxError("[sprintf] unexpected placeholder")
                }
                _fmt = _fmt.substring(match[0].length)
            }
            return parse_tree
        }

        var vsprintf = function(fmt, argv, _argv) {
            _argv = (argv || []).slice(0)
            _argv.splice(0, 0, fmt)
            return sprintf.apply(null, _argv)
        }

        /**
         * helpers
         */
        function get_type(variable) {
            return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
        }

        function str_repeat(input, multiplier) {
            return Array(multiplier + 1).join(input)
        }

        /**
         * export
         */
        return {
            sprintf: sprintf,
            vsprintf: vsprintf
        }
    })();

    var sprintf = sprintfLib.sprintf;
    var vsprintf = sprintfLib.vsprintf;

    // Expose to Twig
    Twig.lib.sprintf = sprintf;
    Twig.lib.vsprintf = vsprintf;


    /**
     * jPaq - A fully customizable JavaScript/JScript library
     * http://jpaq.org/
     *
     * Copyright (c) 2011 Christopher West
     * Licensed under the MIT license.
     * http://jpaq.org/license/
     *
     * Version: 1.0.6.0000W
     * Revised: April 6, 2011
     */
    ; (function() {
        var shortDays = "Sun,Mon,Tue,Wed,Thu,Fri,Sat".split(",");
        var fullDays = "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(",");
        var shortMonths = "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(",");
        var fullMonths = "January,February,March,April,May,June,July,August,September,October,November,December".split(",");
        function getOrdinalFor(intNum) {
                return (((intNum = Math.abs(intNum) % 100) % 10 == 1 && intNum != 11) ? "st"
                        : (intNum % 10 == 2 && intNum != 12) ? "nd" : (intNum % 10 == 3
                        && intNum != 13) ? "rd" : "th");
        }
        function getISO8601Year(aDate) {
                var d = new Date(aDate.getFullYear() + 1, 0, 4);
                if((d - aDate) / 86400000 < 7 && (aDate.getDay() + 6) % 7 < (d.getDay() + 6) % 7)
                        return d.getFullYear();
                if(aDate.getMonth() > 0 || aDate.getDate() >= 4)
                        return aDate.getFullYear();
                return aDate.getFullYear() - (((aDate.getDay() + 6) % 7 - aDate.getDate() > 2) ? 1 : 0);
        }
        function getISO8601Week(aDate) {
                // Get a day during the first week of the year.
                var d = new Date(getISO8601Year(aDate), 0, 4);
                // Get the first monday of the year.
                d.setDate(d.getDate() - (d.getDay() + 6) % 7);
                return parseInt((aDate - d) / 604800000) + 1;
        }
        Twig.lib.formatDate = function(date, format) {
            /// <summary>
            ///   Gets a string for this date, formatted according to the given format
            ///   string.
            /// </summary>
            /// <param name="format" type="String">
            ///   The format of the output date string.  The format string works in a
            ///   nearly identical way to the PHP date function which is highlighted here:
            ///   http://php.net/manual/en/function.date.php.
            ///   The only difference is the fact that "u" signifies milliseconds
            ///   instead of microseconds.  The following characters are recognized in
            ///   the format parameter string:
            ///     d - Day of the month, 2 digits with leading zeros
            ///     D - A textual representation of a day, three letters
            ///     j - Day of the month without leading zeros
            ///     l (lowercase 'L') - A full textual representation of the day of the week
            ///     N - ISO-8601 numeric representation of the day of the week (starting from 1)
            ///     S - English ordinal suffix for the day of the month, 2 characters st,
            ///         nd, rd or th. Works well with j.
            ///     w - Numeric representation of the day of the week (starting from 0)
            ///     z - The day of the year (starting from 0)
            ///     W - ISO-8601 week number of year, weeks starting on Monday
            ///     F - A full textual representation of a month, such as January or March
            ///     m - Numeric representation of a month, with leading zeros
            ///     M - A short textual representation of a month, three letters
            ///     n - Numeric representation of a month, without leading zeros
            ///     t - Number of days in the given month
            ///     L - Whether it's a leap year
            ///     o - ISO-8601 year number. This has the same value as Y, except that if
            ///         the ISO week number (W) belongs to the previous or next year, that
            ///         year is used instead.
            ///     Y - A full numeric representation of a year, 4 digits
            ///     y - A two digit representation of a year
            ///     a - Lowercase Ante meridiem and Post meridiem
            ///     A - Uppercase Ante meridiem and Post meridiem
            ///     B - Swatch Internet time
            ///     g - 12-hour format of an hour without leading zeros
            ///     G - 24-hour format of an hour without leading zeros
            ///     h - 12-hour format of an hour with leading zeros
            ///     H - 24-hour format of an hour with leading zeros
            ///     i - Minutes with leading zeros
            ///     s - Seconds, with leading zeros
            ///     u - Milliseconds
            ///     U - Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)
            /// </param>
            /// <returns type="String">
            ///   Returns the string for this date, formatted according to the given
            ///   format string.
            /// </returns>
            // If the format was not passed, use the default toString method.
            if(typeof format !== "string" || /^\s*$/.test(format))
                    return date + "";
            var jan1st = new Date(date.getFullYear(), 0, 1);
            var me = date;
            return format.replace(/[dDjlNSwzWFmMntLoYyaABgGhHisuU]/g, function(option) {
                switch(option) {
                    // Day of the month, 2 digits with leading zeros
                    case "d": return ("0" + me.getDate()).replace(/^.+(..)$/, "$1");
                    // A textual representation of a day, three letters
                    case "D": return shortDays[me.getDay()];
                    // Day of the month without leading zeros
                    case "j": return me.getDate();
                    // A full textual representation of the day of the week
                    case "l": return fullDays[me.getDay()];
                    // ISO-8601 numeric representation of the day of the week
                    case "N": return (me.getDay() + 6) % 7 + 1;
                    // English ordinal suffix for the day of the month, 2 characters
                    case "S": return getOrdinalFor(me.getDate());
                    // Numeric representation of the day of the week
                    case "w": return me.getDay();
                    // The day of the year (starting from 0)
                    case "z": return Math.ceil((jan1st - me) / 86400000);
                    // ISO-8601 week number of year, weeks starting on Monday
                    case "W": return ("0" + getISO8601Week(me)).replace(/^.(..)$/, "$1");
                    // A full textual representation of a month, such as January or March
                    case "F": return fullMonths[me.getMonth()];
                    // Numeric representation of a month, with leading zeros
                    case "m": return ("0" + (me.getMonth() + 1)).replace(/^.+(..)$/, "$1");
                    // A short textual representation of a month, three letters
                    case "M": return shortMonths[me.getMonth()];
                    // Numeric representation of a month, without leading zeros
                    case "n": return me.getMonth() + 1;
                    // Number of days in the given month
                    case "t": return new Date(me.getFullYear(), me.getMonth() + 1, -1).getDate();
                    // Whether it's a leap year
                    case "L": return new Date(me.getFullYear(), 1, 29).getDate() == 29 ? 1 : 0;
                    // ISO-8601 year number. This has the same value as Y, except that if the
                    // ISO week number (W) belongs to the previous or next year, that year is
                    // used instead.
                    case "o": return getISO8601Year(me);
                    // A full numeric representation of a year, 4 digits
                    case "Y": return me.getFullYear();
                    // A two digit representation of a year
                    case "y": return (me.getFullYear() + "").replace(/^.+(..)$/, "$1");
                    // Lowercase Ante meridiem and Post meridiem
                    case "a": return me.getHours() < 12 ? "am" : "pm";
                    // Uppercase Ante meridiem and Post meridiem
                    case "A": return me.getHours() < 12 ? "AM" : "PM";
                    // Swatch Internet time
                    case "B": return Math.floor((((me.getUTCHours() + 1) % 24) + me.getUTCMinutes() / 60 + me.getUTCSeconds() / 3600) * 1000 / 24);
                    // 12-hour format of an hour without leading zeros
                    case "g": return me.getHours() % 12 != 0 ? me.getHours() % 12 : 12;
                    // 24-hour format of an hour without leading zeros
                    case "G": return me.getHours();
                    // 12-hour format of an hour with leading zeros
                    case "h": return ("0" + (me.getHours() % 12 != 0 ? me.getHours() % 12 : 12)).replace(/^.+(..)$/, "$1");
                    // 24-hour format of an hour with leading zeros
                    case "H": return ("0" + me.getHours()).replace(/^.+(..)$/, "$1");
                    // Minutes with leading zeros
                    case "i": return ("0" + me.getMinutes()).replace(/^.+(..)$/, "$1");
                    // Seconds, with leading zeros
                    case "s": return ("0" + me.getSeconds()).replace(/^.+(..)$/, "$1");
                    // Milliseconds
                    case "u": return me.getMilliseconds();
                    // Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)
                    case "U": return me.getTime() / 1000;
                }
            });
        };
    })();

    Twig.lib.strip_tags = function(input, allowed) {
        // Strips HTML and PHP tags from a string
        //
        // version: 1109.2015
        // discuss at: http://phpjs.org/functions/strip_tags
        // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Luke Godfrey
        // +      input by: Pul
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   bugfixed by: Onno Marsman
        // +      input by: Alex
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +      input by: Marc Palau
        // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +      input by: Brett Zamir (http://brett-zamir.me)
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   bugfixed by: Eric Nagel
        // +      input by: Bobby Drake
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   bugfixed by: Tomasz Wesolowski
        // +      input by: Evertjan Garretsen
        // +    revised by: Rafał Kukawski (http://blog.kukawski.pl/)
        // *     example 1: strip_tags('<p>Kevin</p> <b>van</b> <i>Zonneveld</i>', '<i><b>');
        // *     returns 1: 'Kevin <b>van</b> <i>Zonneveld</i>'
        // *     example 2: strip_tags('<p>Kevin <img src="someimage.png" onmouseover="someFunction()">van <i>Zonneveld</i></p>', '<p>');
        // *     returns 2: '<p>Kevin van Zonneveld</p>'
        // *     example 3: strip_tags("<a href='http://kevin.vanzonneveld.net'>Kevin van Zonneveld</a>", "<a>");
        // *     returns 3: '<a href='http://kevin.vanzonneveld.net'>Kevin van Zonneveld</a>'
        // *     example 4: strip_tags('1 < 5 5 > 1');
        // *     returns 4: '1 < 5 5 > 1'
        // *     example 5: strip_tags('1 <br/> 1');
        // *     returns 5: '1  1'
        // *     example 6: strip_tags('1 <br/> 1', '<br>');
        // *     returns 6: '1  1'
        // *     example 7: strip_tags('1 <br/> 1', '<br><br/>');
        // *     returns 7: '1 <br/> 1'
        allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
        return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
            return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
    }

    Twig.lib.parseISO8601Date = function (s){
        // Taken from http://n8v.enteuxis.org/2010/12/parsing-iso-8601-dates-in-javascript/
        // parenthese matches:
        // year month day    hours minutes seconds
        // dotmilliseconds
        // tzstring plusminus hours minutes
        var re = /(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)(\.\d+)?(Z|([+-])(\d\d):(\d\d))/;

        var d = [];
        d = s.match(re);

        // "2010-12-07T11:00:00.000-09:00" parses to:
        //  ["2010-12-07T11:00:00.000-09:00", "2010", "12", "07", "11",
        //     "00", "00", ".000", "-09:00", "-", "09", "00"]
        // "2010-12-07T11:00:00.000Z" parses to:
        //  ["2010-12-07T11:00:00.000Z",      "2010", "12", "07", "11",
        //     "00", "00", ".000", "Z", undefined, undefined, undefined]

        if (! d) {
            throw "Couldn't parse ISO 8601 date string '" + s + "'";
        }

        // parse strings, leading zeros into proper ints
        var a = [1,2,3,4,5,6,10,11];
        for (var i in a) {
            d[a[i]] = parseInt(d[a[i]], 10);
        }
        d[7] = parseFloat(d[7]);

        // Date.UTC(year, month[, date[, hrs[, min[, sec[, ms]]]]])
        // note that month is 0-11, not 1-12
        // see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Date/UTC
        var ms = Date.UTC(d[1], d[2] - 1, d[3], d[4], d[5], d[6]);

        // if there are milliseconds, add them
        if (d[7] > 0) {
            ms += Math.round(d[7] * 1000);
        }

        // if there's a timezone, calculate it
        if (d[8] != "Z" && d[10]) {
            var offset = d[10] * 60 * 60 * 1000;
            if (d[11]) {
                offset += d[11] * 60 * 1000;
            }
            if (d[9] == "-") {
                ms -= offset;
            }
            else {
                ms += offset;
            }
        }

        return new Date(ms);
    };

    Twig.lib.strtotime = function (text, now) {
        //  discuss at: http://phpjs.org/functions/strtotime/
        //     version: 1109.2016
        // original by: Caio Ariede (http://caioariede.com)
        // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // improved by: Caio Ariede (http://caioariede.com)
        // improved by: A. Matías Quezada (http://amatiasq.com)
        // improved by: preuter
        // improved by: Brett Zamir (http://brett-zamir.me)
        // improved by: Mirko Faber
        //    input by: David
        // bugfixed by: Wagner B. Soares
        // bugfixed by: Artur Tchernychev
        //        note: Examples all have a fixed timestamp to prevent tests to fail because of variable time(zones)
        //   example 1: strtotime('+1 day', 1129633200);
        //   returns 1: 1129719600
        //   example 2: strtotime('+1 week 2 days 4 hours 2 seconds', 1129633200);
        //   returns 2: 1130425202
        //   example 3: strtotime('last month', 1129633200);
        //   returns 3: 1127041200
        //   example 4: strtotime('2009-05-04 08:30:00 GMT');
        //   returns 4: 1241425800

        var parsed, match, today, year, date, days, ranges, len, times, regex, i, fail = false;

        if (!text) {
            return fail;
        }

        // Unecessary spaces
        text = text.replace(/^\s+|\s+$/g, '')
            .replace(/\s{2,}/g, ' ')
            .replace(/[\t\r\n]/g, '')
            .toLowerCase();

        // in contrast to php, js Date.parse function interprets:
        // dates given as yyyy-mm-dd as in timezone: UTC,
        // dates with "." or "-" as MDY instead of DMY
        // dates with two-digit years differently
        // etc...etc...
        // ...therefore we manually parse lots of common date formats
        match = text.match(
            /^(\d{1,4})([\-\.\/\:])(\d{1,2})([\-\.\/\:])(\d{1,4})(?:\s(\d{1,2}):(\d{2})?:?(\d{2})?)?(?:\s([A-Z]+)?)?$/);

        if (match && match[2] === match[4]) {
            if (match[1] > 1901) {
                switch (match[2]) {
                case '-':
                    {
                        // YYYY-M-D
                        if (match[3] > 12 || match[5] > 31) {
                            return fail;
                        }

                        return new Date(match[1], parseInt(match[3], 10) - 1, match[5],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                case '.':
                    {
                        // YYYY.M.D is not parsed by strtotime()
                        return fail;
                    }
                case '/':
                    {
                        // YYYY/M/D
                        if (match[3] > 12 || match[5] > 31) {
                            return fail;
                        }

                        return new Date(match[1], parseInt(match[3], 10) - 1, match[5],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                }
            } else if (match[5] > 1901) {
                switch (match[2]) {
                case '-':
                    {
                        // D-M-YYYY
                        if (match[3] > 12 || match[1] > 31) {
                            return fail;
                        }

                        return new Date(match[5], parseInt(match[3], 10) - 1, match[1],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                case '.':
                    {
                        // D.M.YYYY
                        if (match[3] > 12 || match[1] > 31) {
                            return fail;
                        }

                        return new Date(match[5], parseInt(match[3], 10) - 1, match[1],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                case '/':
                    {
                        // M/D/YYYY
                        if (match[1] > 12 || match[3] > 31) {
                            return fail;
                        }

                        return new Date(match[5], parseInt(match[1], 10) - 1, match[3],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                }
            } else {
                switch (match[2]) {
                case '-':
                    {
                        // YY-M-D
                        if (match[3] > 12 || match[5] > 31 || (match[1] < 70 && match[1] > 38)) {
                            return fail;
                        }

                        year = match[1] >= 0 && match[1] <= 38 ? +match[1] + 2000 : match[1];
                        return new Date(year, parseInt(match[3], 10) - 1, match[5],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                case '.':
                    {
                        // D.M.YY or H.MM.SS
                        if (match[5] >= 70) {
                            // D.M.YY
                            if (match[3] > 12 || match[1] > 31) {
                                return fail;
                            }

                            return new Date(match[5], parseInt(match[3], 10) - 1, match[1],
                                match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                        }
                        if (match[5] < 60 && !match[6]) {
                            // H.MM.SS
                            if (match[1] > 23 || match[3] > 59) {
                                return fail;
                            }

                            today = new Date();
                            return new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                                match[1] || 0, match[3] || 0, match[5] || 0, match[9] || 0) / 1000;
                        }

                        // invalid format, cannot be parsed
                        return fail;
                    }
                case '/':
                    {
                        // M/D/YY
                        if (match[1] > 12 || match[3] > 31 || (match[5] < 70 && match[5] > 38)) {
                            return fail;
                        }

                        year = match[5] >= 0 && match[5] <= 38 ? +match[5] + 2000 : match[5];
                        return new Date(year, parseInt(match[1], 10) - 1, match[3],
                            match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
                    }
                case ':':
                    {
                        // HH:MM:SS
                        if (match[1] > 23 || match[3] > 59 || match[5] > 59) {
                            return fail;
                        }

                        today = new Date();
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                            match[1] || 0, match[3] || 0, match[5] || 0) / 1000;
                    }
                }
            }
        }

        // other formats and "now" should be parsed by Date.parse()
        if (text === 'now') {
            return now === null || isNaN(now) ? new Date()
                .getTime() / 1000 | 0 : now | 0;
        }
        if (!isNaN(parsed = Date.parse(text))) {
            return parsed / 1000 | 0;
        }

        date = now ? new Date(now * 1000) : new Date();
        days = {
            'sun': 0,
            'mon': 1,
            'tue': 2,
            'wed': 3,
            'thu': 4,
            'fri': 5,
            'sat': 6
        };
        ranges = {
            'yea': 'FullYear',
            'mon': 'Month',
            'day': 'Date',
            'hou': 'Hours',
            'min': 'Minutes',
            'sec': 'Seconds'
        };

        function lastNext(type, range, modifier) {
            var diff, day = days[range];

            if (typeof day !== 'undefined') {
                diff = day - date.getDay();

                if (diff === 0) {
                    diff = 7 * modifier;
                } else if (diff > 0 && type === 'last') {
                    diff -= 7;
                } else if (diff < 0 && type === 'next') {
                    diff += 7;
                }

                date.setDate(date.getDate() + diff);
            }
        }

        function process(val) {
            var splt = val.split(' '), // Todo: Reconcile this with regex using \s, taking into account browser issues with split and regexes
                type = splt[0],
                range = splt[1].substring(0, 3),
                typeIsNumber = /\d+/.test(type),
                ago = splt[2] === 'ago',
                num = (type === 'last' ? -1 : 1) * (ago ? -1 : 1);

            if (typeIsNumber) {
                num *= parseInt(type, 10);
            }

            if (ranges.hasOwnProperty(range) && !splt[1].match(/^mon(day|\.)?$/i)) {
                return date['set' + ranges[range]](date['get' + ranges[range]]() + num);
            }

            if (range === 'wee') {
                return date.setDate(date.getDate() + (num * 7));
            }

            if (type === 'next' || type === 'last') {
                lastNext(type, range, num);
            } else if (!typeIsNumber) {
                return false;
            }

            return true;
        }

        times = '(years?|months?|weeks?|days?|hours?|minutes?|min|seconds?|sec' +
            '|sunday|sun\\.?|monday|mon\\.?|tuesday|tue\\.?|wednesday|wed\\.?' +
            '|thursday|thu\\.?|friday|fri\\.?|saturday|sat\\.?)';
        regex = '([+-]?\\d+\\s' + times + '|' + '(last|next)\\s' + times + ')(\\sago)?';

        match = text.match(new RegExp(regex, 'gi'));
        if (!match) {
            return fail;
        }

        for (i = 0, len = match.length; i < len; i++) {
            if (!process(match[i])) {
                return fail;
            }
        }

        // ECMAScript 5 only
        // if (!match.every(process))
        //    return false;

        return (date.getTime() / 1000);
    };

    Twig.lib.is = function(type, obj) {
        var clas = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && clas === type;
    };

    // shallow-copy an object
    Twig.lib.copy = function(src) {
        var target = {},
            key;
        for (key in src)
            target[key] = src[key];

        return target;
    };

    Twig.lib.replaceAll = function(string, search, replace) {
        return string.split(search).join(replace);
    };

    // chunk an array (arr) into arrays of (size) items, returns an array of arrays, or an empty array on invalid input
    Twig.lib.chunkArray = function (arr, size) {
        var returnVal = [],
            x = 0,
            len = arr.length;

        if (size < 1 || !Twig.lib.is("Array", arr)) {
            return [];
        }

        while (x < len) {
            returnVal.push(arr.slice(x, x += size));
        }

        return returnVal;
    };

    Twig.lib.round = function round(value, precision, mode) {
        //  discuss at: http://phpjs.org/functions/round/
        // original by: Philip Peterson
        //  revised by: Onno Marsman
        //  revised by: T.Wild
        //  revised by: Rafał Kukawski (http://blog.kukawski.pl/)
        //    input by: Greenseed
        //    input by: meo
        //    input by: William
        //    input by: Josep Sanz (http://www.ws3.es/)
        // bugfixed by: Brett Zamir (http://brett-zamir.me)
        //        note: Great work. Ideas for improvement:
        //        note: - code more compliant with developer guidelines
        //        note: - for implementing PHP constant arguments look at
        //        note: the pathinfo() function, it offers the greatest
        //        note: flexibility & compatibility possible
        //   example 1: round(1241757, -3);
        //   returns 1: 1242000
        //   example 2: round(3.6);
        //   returns 2: 4
        //   example 3: round(2.835, 2);
        //   returns 3: 2.84
        //   example 4: round(1.1749999999999, 2);
        //   returns 4: 1.17
        //   example 5: round(58551.799999999996, 2);
        //   returns 5: 58551.8

        var m, f, isHalf, sgn; // helper variables
        precision |= 0; // making sure precision is integer
        m = Math.pow(10, precision);
        value *= m;
        sgn = (value > 0) | -(value < 0); // sign of the number
        isHalf = value % 1 === 0.5 * sgn;
        f = Math.floor(value);

        if (isHalf) {
            switch (mode) {
                case 'PHP_ROUND_HALF_DOWN':
                    value = f + (sgn < 0); // rounds .5 toward zero
                    break;
                case 'PHP_ROUND_HALF_EVEN':
                    value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
                    break;
                case 'PHP_ROUND_HALF_ODD':
                    value = f + !(f % 2); // rounds .5 towards the next odd integer
                    break;
                default:
                    value = f + (sgn > 0); // rounds .5 away from zero
            }
        }

        return (isHalf ? value : Math.round(value)) / m;
    }

    return Twig;

})(Twig || { });
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.logic.js
//
// This file handles tokenizing, compiling and parsing logic tokens. {% ... %}
var Twig = (function (Twig) {
    "use strict";

    /**
     * Namespace for logic handling.
     */
    Twig.logic = {};

    /**
     * Logic token types.
     */
    Twig.logic.type = {
        if_:       'Twig.logic.type.if',
        endif:     'Twig.logic.type.endif',
        for_:      'Twig.logic.type.for',
        endfor:    'Twig.logic.type.endfor',
        else_:     'Twig.logic.type.else',
        elseif:    'Twig.logic.type.elseif',
        set:       'Twig.logic.type.set',
        setcapture:'Twig.logic.type.setcapture',
        endset:    'Twig.logic.type.endset',
        filter:    'Twig.logic.type.filter',
        endfilter: 'Twig.logic.type.endfilter',
        block:     'Twig.logic.type.block',
        endblock:  'Twig.logic.type.endblock',
        extends_:  'Twig.logic.type.extends',
        use:       'Twig.logic.type.use',
        include:   'Twig.logic.type.include',
        spaceless: 'Twig.logic.type.spaceless',
        endspaceless: 'Twig.logic.type.endspaceless',
        macro:     'Twig.logic.type.macro',
        endmacro:  'Twig.logic.type.endmacro',
        import_:   'Twig.logic.type.import',
        from:      'Twig.logic.type.from',
        embed:     'Twig.logic.type.embed',
        endembed:  'Twig.logic.type.endembed'
    };


    // Regular expressions for handling logic tokens.
    //
    // Properties:
    //
    //      type:  The type of expression this matches
    //
    //      regex: A regular expression that matches the format of the token
    //
    //      next:  What logic tokens (if any) pop this token off the logic stack. If empty, the
    //             logic token is assumed to not require an end tag and isn't push onto the stack.
    //
    //      open:  Does this tag open a logic expression or is it standalone. For example,
    //             {% endif %} cannot exist without an opening {% if ... %} tag, so open = false.
    //
    //  Functions:
    //
    //      compile: A function that handles compiling the token into an output token ready for
    //               parsing with the parse function.
    //
    //      parse:   A function that parses the compiled token into output (HTML / whatever the
    //               template represents).
    Twig.logic.definitions = [
        {
            /**
             * If type logic tokens.
             *
             *  Format: {% if expression %}
             */
            type: Twig.logic.type.if_,
            regex: /^if\s+([\s\S]+)$/,
            next: [
                Twig.logic.type.else_,
                Twig.logic.type.elseif,
                Twig.logic.type.endif
            ],
            open: true,
            compile: function (token) {
                var expression = token.match[1];
                // Compile the expression.
                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;
                delete token.match;
                return token;
            },
            parse: function (token, context, chain) {
                var output = '',
                    // Parse the expression
                    result = Twig.expression.parse.apply(this, [token.stack, context]);

                // Start a new logic chain
                chain = true;

                if (result) {
                    chain = false;
                    // parse if output
                    output = Twig.parse.apply(this, [token.output, context]);
                }
                return {
                    chain: chain,
                    output: output
                };
            }
        },
        {
            /**
             * Else if type logic tokens.
             *
             *  Format: {% elseif expression %}
             */
            type: Twig.logic.type.elseif,
            regex: /^elseif\s+([^\s].*)$/,
            next: [
                Twig.logic.type.else_,
                Twig.logic.type.elseif,
                Twig.logic.type.endif
            ],
            open: false,
            compile: function (token) {
                var expression = token.match[1];
                // Compile the expression.
                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;
                delete token.match;
                return token;
            },
            parse: function (token, context, chain) {
                var output = '';

                if (chain && Twig.expression.parse.apply(this, [token.stack, context]) === true) {
                    chain = false;
                    // parse if output
                    output = Twig.parse.apply(this, [token.output, context]);
                }

                return {
                    chain: chain,
                    output: output
                };
            }
        },
        {
            /**
             * Else if type logic tokens.
             *
             *  Format: {% elseif expression %}
             */
            type: Twig.logic.type.else_,
            regex: /^else$/,
            next: [
                Twig.logic.type.endif,
                Twig.logic.type.endfor
            ],
            open: false,
            parse: function (token, context, chain) {
                var output = '';
                if (chain) {
                    output = Twig.parse.apply(this, [token.output, context]);
                }
                return {
                    chain: chain,
                    output: output
                };
            }
        },
        {
            /**
             * End if type logic tokens.
             *
             *  Format: {% endif %}
             */
            type: Twig.logic.type.endif,
            regex: /^endif$/,
            next: [ ],
            open: false
        },
        {
            /**
             * For type logic tokens.
             *
             *  Format: {% for expression %}
             */
            type: Twig.logic.type.for_,
            regex: /^for\s+([a-zA-Z0-9_,\s]+)\s+in\s+([^\s].*?)(?:\s+if\s+([^\s].*))?$/,
            next: [
                Twig.logic.type.else_,
                Twig.logic.type.endfor
            ],
            open: true,
            compile: function (token) {
                var key_value = token.match[1],
                    expression = token.match[2],
                    conditional = token.match[3],
                    kv_split = null;

                token.key_var = null;
                token.value_var = null;

                if (key_value.indexOf(",") >= 0) {
                    kv_split = key_value.split(',');
                    if (kv_split.length === 2) {
                        token.key_var = kv_split[0].trim();
                        token.value_var = kv_split[1].trim();
                    } else {
                        throw new Twig.Error("Invalid expression in for loop: " + key_value);
                    }
                } else {
                    token.value_var = key_value;
                }

                // Valid expressions for a for loop
                //   for item     in expression
                //   for key,item in expression

                // Compile the expression.
                token.expression = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;

                // Compile the conditional (if available)
                if (conditional) {
                    token.conditional = Twig.expression.compile.apply(this, [{
                        type:  Twig.expression.type.expression,
                        value: conditional
                    }]).stack;
                }

                delete token.match;
                return token;
            },
            parse: function (token, context, continue_chain) {
                // Parse expression
                var result = Twig.expression.parse.apply(this, [token.expression, context]),
                    output = [],
                    len,
                    index = 0,
                    keyset,
                    that = this,
                    conditional = token.conditional,
                    buildLoop = function(index, len) {
                        var isConditional = conditional !== undefined;
                        return {
                            index: index+1,
                            index0: index,
                            revindex: isConditional?undefined:len-index,
                            revindex0: isConditional?undefined:len-index-1,
                            first: (index === 0),
                            last: isConditional?undefined:(index === len-1),
                            length: isConditional?undefined:len,
                            parent: context
                        };
                    },
                    // run once for each iteration of the loop
                    loop = function(key, value) {
                        var inner_context = Twig.ChildContext(context);

                        inner_context[token.value_var] = value;

                        if (token.key_var) {
                            inner_context[token.key_var] = key;
                        }

                        // Loop object
                        inner_context.loop = buildLoop(index, len);

                        if (conditional === undefined ||
                            Twig.expression.parse.apply(that, [conditional, inner_context]))
                        {
                            output.push(Twig.parse.apply(that, [token.output, inner_context]));
                            index += 1;
                        }

                        // Delete loop-related variables from the context
                        delete inner_context['loop'];
                        delete inner_context[token.value_var];
                        delete inner_context[token.key_var];

                        // Merge in values that exist in context but have changed
                        // in inner_context.
                        Twig.merge(context, inner_context, true);
                    };


                if (Twig.lib.is('Array', result)) {
                    len = result.length;
                    Twig.forEach(result, function (value) {
                        var key = index;

                        loop(key, value);
                    });
                } else if (Twig.lib.is('Object', result)) {
                    if (result._keys !== undefined) {
                        keyset = result._keys;
                    } else {
                        keyset = Object.keys(result);
                    }
                    len = keyset.length;
                    Twig.forEach(keyset, function(key) {
                        // Ignore the _keys property, it's internal to twig.js
                        if (key === "_keys") return;

                        loop(key,  result[key]);
                    });
                }

                // Only allow else statements if no output was generated
                continue_chain = (output.length === 0);

                return {
                    chain: continue_chain,
                    output: Twig.output.apply(this, [output])
                };
            }
        },
        {
            /**
             * End if type logic tokens.
             *
             *  Format: {% endif %}
             */
            type: Twig.logic.type.endfor,
            regex: /^endfor$/,
            next: [ ],
            open: false
        },
        {
            /**
             * Set type logic tokens.
             *
             *  Format: {% set key = expression %}
             */
            type: Twig.logic.type.set,
            regex: /^set\s+([a-zA-Z0-9_,\s]+)\s*=\s*([\s\S]+)$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var key = token.match[1].trim(),
                    expression = token.match[2],
                    // Compile the expression.
                    expression_stack  = Twig.expression.compile.apply(this, [{
                        type:  Twig.expression.type.expression,
                        value: expression
                    }]).stack;

                token.key = key;
                token.expression = expression_stack;

                delete token.match;
                return token;
            },
            parse: function (token, context, continue_chain) {
                var value = Twig.expression.parse.apply(this, [token.expression, context]),
                    key = token.key;

                context[key] = value;

                return {
                    chain: continue_chain,
                    context: context
                };
            }
        },
        {
            /**
             * Set capture type logic tokens.
             *
             *  Format: {% set key %}
             */
            type: Twig.logic.type.setcapture,
            regex: /^set\s+([a-zA-Z0-9_,\s]+)$/,
            next: [
                Twig.logic.type.endset
            ],
            open: true,
            compile: function (token) {
                var key = token.match[1].trim();

                token.key = key;

                delete token.match;
                return token;
            },
            parse: function (token, context, continue_chain) {

                var value = Twig.parse.apply(this, [token.output, context]),
                    key = token.key;

                // set on both the global and local context
                this.context[key] = value;
                context[key] = value;

                return {
                    chain: continue_chain,
                    context: context
                };
            }
        },
        {
            /**
             * End set type block logic tokens.
             *
             *  Format: {% endset %}
             */
            type: Twig.logic.type.endset,
            regex: /^endset$/,
            next: [ ],
            open: false
        },
        {
            /**
             * Filter logic tokens.
             *
             *  Format: {% filter upper %} or {% filter lower|escape %}
             */
            type: Twig.logic.type.filter,
            regex: /^filter\s+(.+)$/,
            next: [
                Twig.logic.type.endfilter
            ],
            open: true,
            compile: function (token) {
                var expression = "|" + token.match[1].trim();
                // Compile the expression.
                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;
                delete token.match;
                return token;
            },
            parse: function (token, context, chain) {
                var unfiltered = Twig.parse.apply(this, [token.output, context]),
                    stack = [{
                        type: Twig.expression.type.string,
                        value: unfiltered
                    }].concat(token.stack);

                var output = Twig.expression.parse.apply(this, [stack, context]);

                return {
                    chain: chain,
                    output: output
                };
            }
        },
        {
            /**
             * End filter logic tokens.
             *
             *  Format: {% endfilter %}
             */
            type: Twig.logic.type.endfilter,
            regex: /^endfilter$/,
            next: [ ],
            open: false
        },
        {
            /**
             * Block logic tokens.
             *
             *  Format: {% block title %}
             */
            type: Twig.logic.type.block,
            regex: /^block\s+([a-zA-Z0-9_]+)$/,
            next: [
                Twig.logic.type.endblock
            ],
            open: true,
            compile: function (token) {
                token.block = token.match[1].trim();
                delete token.match;
                return token;
            },
            parse: function (token, context, chain) {
                var block_output = "",
                    output = "",
                    isImported = this.importedBlocks.indexOf(token.block) > -1,
                    hasParent = this.blocks[token.block] && this.blocks[token.block].indexOf(Twig.placeholders.parent) > -1;

                // Don't override previous blocks unless they're imported with "use"
                // Loops should be exempted as well.
                if (this.blocks[token.block] === undefined || isImported || hasParent || context.loop || token.overwrite) {
                    block_output = Twig.expression.parse.apply(this, [{
                        type: Twig.expression.type.string,
                        value: Twig.parse.apply(this, [token.output, context])
                    }, context]);

                    if (isImported) {
                        // once the block is overridden, remove it from the list of imported blocks
                        this.importedBlocks.splice(this.importedBlocks.indexOf(token.block), 1);
                    }

                    if (hasParent) {
                        this.blocks[token.block] = Twig.Markup(this.blocks[token.block].replace(Twig.placeholders.parent, block_output));
                    } else {
                        this.blocks[token.block] = block_output;
                    }

                    this.originalBlockTokens[token.block] = {
                        type: token.type,
                        block: token.block,
                        output: token.output,
                        overwrite: true
                    };
                }

                // Check if a child block has been set from a template extending this one.
                if (this.child.blocks[token.block]) {
                    output = this.child.blocks[token.block];
                } else {
                    output = this.blocks[token.block];
                }

                return {
                    chain: chain,
                    output: output
                };
            }
        },
        {
            /**
             * End block logic tokens.
             *
             *  Format: {% endblock %}
             */
            type: Twig.logic.type.endblock,
            regex: /^endblock(?:\s+([a-zA-Z0-9_]+))?$/,
            next: [ ],
            open: false
        },
        {
            /**
             * Block logic tokens.
             *
             *  Format: {% extends "template.twig" %}
             */
            type: Twig.logic.type.extends_,
            regex: /^extends\s+(.+)$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var expression = token.match[1].trim();
                delete token.match;

                token.stack   = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;

                return token;
            },
            parse: function (token, context, chain) {
                // Resolve filename
                var file = Twig.expression.parse.apply(this, [token.stack, context]);

                // Set parent template
                this.extend = file;

                return {
                    chain: chain,
                    output: ''
                };
            }
        },
        {
            /**
             * Block logic tokens.
             *
             *  Format: {% use "template.twig" %}
             */
            type: Twig.logic.type.use,
            regex: /^use\s+(.+)$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var expression = token.match[1].trim();
                delete token.match;

                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;

                return token;
            },
            parse: function (token, context, chain) {
                // Resolve filename
                var file = Twig.expression.parse.apply(this, [token.stack, context]);

                // Import blocks
                this.importBlocks(file);

                return {
                    chain: chain,
                    output: ''
                };
            }
        },
        {
            /**
             * Block logic tokens.
             *
             *  Format: {% includes "template.twig" [with {some: 'values'} only] %}
             */
            type: Twig.logic.type.include,
            regex: /^include\s+(ignore missing\s+)?(.+?)\s*(?:with\s+([\S\s]+?))?\s*(only)?$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var match = token.match,
                    includeMissing = match[1] !== undefined,
                    expression = match[2].trim(),
                    withContext = match[3],
                    only = ((match[4] !== undefined) && match[4].length);

                delete token.match;

                token.only = only;
                token.includeMissing = includeMissing;

                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;

                if (withContext !== undefined) {
                    token.withStack = Twig.expression.compile.apply(this, [{
                        type:  Twig.expression.type.expression,
                        value: withContext.trim()
                    }]).stack;
                }

                return token;
            },
            parse: function (token, context, chain) {
                // Resolve filename
                var innerContext = {},
                    withContext,
                    i,
                    template;

                if (!token.only) {
                    innerContext = Twig.ChildContext(context);
                }

                if (token.withStack !== undefined) {
                    withContext = Twig.expression.parse.apply(this, [token.withStack, context]);

                    for (i in withContext) {
                        if (withContext.hasOwnProperty(i))
                            innerContext[i] = withContext[i];
                    }
                }

                var file = Twig.expression.parse.apply(this, [token.stack, innerContext]);

                if (file instanceof Twig.Template) {
                    template = file;
                } else {
                    // Import file
                    template = this.importFile(file);
                }

                return {
                    chain: chain,
                    output: template.render(innerContext)
                };
            }
        },
        {
            type: Twig.logic.type.spaceless,
            regex: /^spaceless$/,
            next: [
                Twig.logic.type.endspaceless
            ],
            open: true,

            // Parse the html and return it without any spaces between tags
            parse: function (token, context, chain) {
                var // Parse the output without any filter
                    unfiltered = Twig.parse.apply(this, [token.output, context]),
                    // A regular expression to find closing and opening tags with spaces between them
                    rBetweenTagSpaces = />\s+</g,
                    // Replace all space between closing and opening html tags
                    output = unfiltered.replace(rBetweenTagSpaces,'><').trim();

                return {
                    chain: chain,
                    output: output
                };
            }
        },

        // Add the {% endspaceless %} token
        {
            type: Twig.logic.type.endspaceless,
            regex: /^endspaceless$/,
            next: [ ],
            open: false
        },
        {
            /**
             * Macro logic tokens.
             *
             * Format: {% maro input(name, value, type, size) %}
             *
             */
            type: Twig.logic.type.macro,
            regex: /^macro\s+([a-zA-Z0-9_]+)\s*\(\s*((?:[a-zA-Z0-9_]+(?:,\s*)?)*)\s*\)$/,
            next: [
                Twig.logic.type.endmacro
            ],
            open: true,
            compile: function (token) {
                var macroName = token.match[1],
                    parameters = token.match[2].split(/[\s,]+/);

                //TODO: Clean up duplicate check
                for (var i=0; i<parameters.length; i++) {
                    for (var j=0; j<parameters.length; j++){
                        if (parameters[i] === parameters[j] && i !== j) {
                            throw new Twig.Error("Duplicate arguments for parameter: "+ parameters[i]);
                        }
                    }
                }

                token.macroName = macroName;
                token.parameters = parameters;

                delete token.match;
                return token;
            },
            parse: function (token, context, chain) {
                var template = this;
                this.macros[token.macroName] = function() {
                    // Pass global context and other macros
                    var macroContext = {
                        _self: template.macros
                    }
                    // Add parameters from context to macroContext
                    for (var i=0; i<token.parameters.length; i++) {
                        var prop = token.parameters[i];
                        if(typeof arguments[i] !== 'undefined') {
                            macroContext[prop] = arguments[i];
                        } else {
                            macroContext[prop] = undefined;
                        }
                    }
                    // Render
                    return Twig.parse.apply(template, [token.output, macroContext])
                };

                return {
                    chain: chain,
                    output: ''
                };

            }
        },
        {
            /**
             * End macro logic tokens.
             *
             * Format: {% endmacro %}
             */
             type: Twig.logic.type.endmacro,
             regex: /^endmacro$/,
             next: [ ],
             open: false
        },
        {
            /*
            * import logic tokens.
            *
            * Format: {% import "template.twig" as form %}
            */
            type: Twig.logic.type.import_,
            regex: /^import\s+(.+)\s+as\s+([a-zA-Z0-9_]+)$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var expression = token.match[1].trim(),
                    contextName = token.match[2].trim();
                delete token.match;

                token.expression = expression;
                token.contextName = contextName;

                token.stack = Twig.expression.compile.apply(this, [{
                    type: Twig.expression.type.expression,
                    value: expression
                }]).stack;

                return token;
            },
            parse: function (token, context, chain) {
                if (token.expression !== "_self") {
                    var file = Twig.expression.parse.apply(this, [token.stack, context]);
                    var template = this.importFile(file || token.expression);
                    context[token.contextName] = template.render({}, {output: 'macros'});
                }
                else {
                    context[token.contextName] = this.macros;
                }

                return {
                    chain: chain,
                    output: ''
                }

            }
        },
        {
            /*
            * from logic tokens.
            *
            * Format: {% from "template.twig" import func as form %}
            */
            type: Twig.logic.type.from,
            regex: /^from\s+(.+)\s+import\s+([a-zA-Z0-9_, ]+)$/,
            next: [ ],
            open: true,
            compile: function (token) {
                var expression = token.match[1].trim(),
                    macroExpressions = token.match[2].trim().split(/[ ,]+/),
                    macroNames = {};

                for (var i=0; i<macroExpressions.length; i++) {
                    var res = macroExpressions[i];

                    // match function as variable
                    var macroMatch = res.match(/^([a-zA-Z0-9_]+)\s+(.+)\s+as\s+([a-zA-Z0-9_]+)$/);
                    if (macroMatch) {
                        macroNames[macroMatch[1].trim()] = macroMatch[2].trim();
                    }
                    else if (res.match(/^([a-zA-Z0-9_]+)$/)) {
                        macroNames[res] = res;
                    }
                    else {
                        // ignore import
                    }

                }

                delete token.match;

                token.expression = expression;
                token.macroNames = macroNames;

                token.stack = Twig.expression.compile.apply(this, [{
                    type: Twig.expression.type.expression,
                    value: expression
                }]).stack;

                return token;
            },
            parse: function (token, context, chain) {
                var macros;

                if (token.expression !== "_self") {
                    var file = Twig.expression.parse.apply(this, [token.stack, context]);
                    var template = this.importFile(file || token.expression);
                    macros = template.render({}, {output: 'macros'});
                }
                else {
                    macros = this.macros;
                }

                for (var macroName in token.macroNames) {
                    if (macros.hasOwnProperty(macroName)) {
                        context[token.macroNames[macroName]] = macros[macroName];
                    }
                }

                return {
                    chain: chain,
                    output: ''
                }

            }
        },
        {
            /**
             * The embed tag combines the behaviour of include and extends.
             * It allows you to include another template's contents, just like include does.
             *
             *  Format: {% embed "template.twig" [with {some: 'values'} only] %}
             */
            type: Twig.logic.type.embed,
            regex: /^embed\s+(ignore missing\s+)?(.+?)\s*(?:with\s+([\S\s]+?))?\s*(only)?$/,
            next: [
                Twig.logic.type.endembed
            ],
            open: true,
            compile: function (token) {
                var match = token.match,
                    includeMissing = match[1] !== undefined,
                    expression = match[2].trim(),
                    withContext = match[3],
                    only = ((match[4] !== undefined) && match[4].length);

                delete token.match;

                token.only = only;
                token.includeMissing = includeMissing;

                token.stack = Twig.expression.compile.apply(this, [{
                    type:  Twig.expression.type.expression,
                    value: expression
                }]).stack;

                if (withContext !== undefined) {
                    token.withStack = Twig.expression.compile.apply(this, [{
                        type:  Twig.expression.type.expression,
                        value: withContext.trim()
                    }]).stack;
                }

                return token;
            },
            parse: function (token, context, chain) {
                // Resolve filename
                var innerContext = {},
                    withContext,
                    i,
                    template;

                if (!token.only) {
                    for (i in context) {
                        if (context.hasOwnProperty(i))
                            innerContext[i] = context[i];
                    }
                }

                if (token.withStack !== undefined) {
                    withContext = Twig.expression.parse.apply(this, [token.withStack, context]);

                    for (i in withContext) {
                        if (withContext.hasOwnProperty(i))
                            innerContext[i] = withContext[i];
                    }
                }

                var file = Twig.expression.parse.apply(this, [token.stack, innerContext]);

                if (file instanceof Twig.Template) {
                    template = file;
                } else {
                    // Import file
                    template = this.importFile(file);
                }

                // reset previous blocks
                this.blocks = {};

                // parse tokens. output will be not used
                var output = Twig.parse.apply(this, [token.output, innerContext]);

                // render tempalte with blocks defined in embed block
                return {
                    chain: chain,
                    output: template.render(innerContext, {'blocks':this.blocks})
                };
            }
        },
        /* Add the {% endembed %} token
         *
         */
        {
            type: Twig.logic.type.endembed,
            regex: /^endembed$/,
            next: [ ],
            open: false
        }

    ];


    /**
     * Registry for logic handlers.
     */
    Twig.logic.handler = {};

    /**
     * Define a new token type, available at Twig.logic.type.{type}
     */
    Twig.logic.extendType = function (type, value) {
        value = value || ("Twig.logic.type" + type);
        Twig.logic.type[type] = value;
    };

    /**
     * Extend the logic parsing functionality with a new token definition.
     *
     * // Define a new tag
     * Twig.logic.extend({
     *     type: Twig.logic.type.{type},
     *     // The pattern to match for this token
     *     regex: ...,
     *     // What token types can follow this token, leave blank if any.
     *     next: [ ... ]
     *     // Create and return compiled version of the token
     *     compile: function(token) { ... }
     *     // Parse the compiled token with the context provided by the render call
     *     //   and whether this token chain is complete.
     *     parse: function(token, context, chain) { ... }
     * });
     *
     * @param {Object} definition The new logic expression.
     */
    Twig.logic.extend = function (definition) {

        if (!definition.type) {
            throw new Twig.Error("Unable to extend logic definition. No type provided for " + definition);
        } else {
            Twig.logic.extendType(definition.type);
        }
        Twig.logic.handler[definition.type] = definition;
    };

    // Extend with built-in expressions
    while (Twig.logic.definitions.length > 0) {
        Twig.logic.extend(Twig.logic.definitions.shift());
    }

    /**
     * Compile a logic token into an object ready for parsing.
     *
     * @param {Object} raw_token An uncompiled logic token.
     *
     * @return {Object} A compiled logic token, ready for parsing.
     */
    Twig.logic.compile = function (raw_token) {
        var expression = raw_token.value.trim(),
            token = Twig.logic.tokenize.apply(this, [expression]),
            token_template = Twig.logic.handler[token.type];

        // Check if the token needs compiling
        if (token_template.compile) {
            token = token_template.compile.apply(this, [token]);
            Twig.log.trace("Twig.logic.compile: ", "Compiled logic token to ", token);
        }

        return token;
    };

    /**
     * Tokenize logic expressions. This function matches token expressions against regular
     * expressions provided in token definitions provided with Twig.logic.extend.
     *
     * @param {string} expression the logic token expression to tokenize
     *                (i.e. what's between {% and %})
     *
     * @return {Object} The matched token with type set to the token type and match to the regex match.
     */
    Twig.logic.tokenize = function (expression) {
        var token = {},
            token_template_type = null,
            token_type = null,
            token_regex = null,
            regex_array = null,
            regex = null,
            match = null;

        // Ignore whitespace around expressions.
        expression = expression.trim();

        for (token_template_type in Twig.logic.handler) {
            if (Twig.logic.handler.hasOwnProperty(token_template_type)) {
                // Get the type and regex for this template type
                token_type = Twig.logic.handler[token_template_type].type;
                token_regex = Twig.logic.handler[token_template_type].regex;

                // Handle multiple regular expressions per type.
                regex_array = [];
                if (token_regex instanceof Array) {
                    regex_array = token_regex;
                } else {
                    regex_array.push(token_regex);
                }

                // Check regular expressions in the order they were specified in the definition.
                while (regex_array.length > 0) {
                    regex = regex_array.shift();
                    match = regex.exec(expression.trim());
                    if (match !== null) {
                        token.type  = token_type;
                        token.match = match;
                        Twig.log.trace("Twig.logic.tokenize: ", "Matched a ", token_type, " regular expression of ", match);
                        return token;
                    }
                }
            }
        }

        // No regex matches
        throw new Twig.Error("Unable to parse '" + expression.trim() + "'");
    };

    /**
     * Parse a logic token within a given context.
     *
     * What are logic chains?
     *      Logic chains represent a series of tokens that are connected,
     *          for example:
     *          {% if ... %} {% else %} {% endif %}
     *
     *      The chain parameter is used to signify if a chain is open of closed.
     *      open:
     *          More tokens in this chain should be parsed.
     *      closed:
     *          This token chain has completed parsing and any additional
     *          tokens (else, elseif, etc...) should be ignored.
     *
     * @param {Object} token The compiled token.
     * @param {Object} context The render context.
     * @param {boolean} chain Is this an open logic chain. If false, that means a
     *                        chain is closed and no further cases should be parsed.
     */
    Twig.logic.parse = function (token, context, chain) {
        var output = '',
            token_template;

        context = context || { };

        Twig.log.debug("Twig.logic.parse: ", "Parsing logic token ", token);

        token_template = Twig.logic.handler[token.type];

        if (token_template.parse) {
            output = token_template.parse.apply(this, [token, context, chain]);
        }
        return output;
    };

    return Twig;

})(Twig || { });
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.expression.js
//
// This file handles tokenizing, compiling and parsing expressions.
var Twig = (function (Twig) {
    "use strict";

    /**
     * Namespace for expression handling.
     */
    Twig.expression = { };

    /**
     * Reserved word that can't be used as variable names.
     */
    Twig.expression.reservedWords = [
        "true", "false", "null", "TRUE", "FALSE", "NULL", "_context"
    ];

    /**
     * The type of tokens used in expressions.
     */
    Twig.expression.type = {
        comma:      'Twig.expression.type.comma',
        operator: {
            unary:  'Twig.expression.type.operator.unary',
            binary: 'Twig.expression.type.operator.binary'
        },
        string:     'Twig.expression.type.string',
        bool:       'Twig.expression.type.bool',
        array: {
            start:  'Twig.expression.type.array.start',
            end:    'Twig.expression.type.array.end'
        },
        object: {
            start:  'Twig.expression.type.object.start',
            end:    'Twig.expression.type.object.end'
        },
        parameter: {
            start:  'Twig.expression.type.parameter.start',
            end:    'Twig.expression.type.parameter.end'
        },
        key: {
            period:   'Twig.expression.type.key.period',
            brackets: 'Twig.expression.type.key.brackets'
        },
        filter:     'Twig.expression.type.filter',
        _function:  'Twig.expression.type._function',
        variable:   'Twig.expression.type.variable',
        number:     'Twig.expression.type.number',
        _null:     'Twig.expression.type.null',
        context:    'Twig.expression.type.context',
        test:       'Twig.expression.type.test'
    };

    Twig.expression.set = {
        // What can follow an expression (in general)
        operations: [
            Twig.expression.type.filter,
            Twig.expression.type.operator.unary,
            Twig.expression.type.operator.binary,
            Twig.expression.type.array.end,
            Twig.expression.type.object.end,
            Twig.expression.type.parameter.end,
            Twig.expression.type.comma,
            Twig.expression.type.test
        ],
        expressions: [
            Twig.expression.type._function,
            Twig.expression.type.bool,
            Twig.expression.type.string,
            Twig.expression.type.variable,
            Twig.expression.type.number,
            Twig.expression.type._null,
            Twig.expression.type.context,
            Twig.expression.type.parameter.start,
            Twig.expression.type.array.start,
            Twig.expression.type.object.start
        ]
    };

    // Most expressions allow a '.' or '[' after them, so we provide a convenience set
    Twig.expression.set.operations_extended = Twig.expression.set.operations.concat([
                    Twig.expression.type.key.period,
                    Twig.expression.type.key.brackets]);

    // Some commonly used compile and parse functions.
    Twig.expression.fn = {
        compile: {
            push: function(token, stack, output) {
                output.push(token);
            },
            push_both: function(token, stack, output) {
                output.push(token);
                stack.push(token);
            }
        },
        parse: {
            push: function(token, stack, context) {
                stack.push(token);
            },
            push_value: function(token, stack, context) {
                stack.push(token.value);
            }
        }
    };

    // The regular expressions and compile/parse logic used to match tokens in expressions.
    //
    // Properties:
    //
    //      type:  The type of expression this matches
    //
    //      regex: One or more regular expressions that matche the format of the token.
    //
    //      next:  Valid tokens that can occur next in the expression.
    //
    // Functions:
    //
    //      compile: A function that compiles the raw regular expression match into a token.
    //
    //      parse:   A function that parses the compiled token into output.
    //
    Twig.expression.definitions = [
        {
            type: Twig.expression.type.test,
            regex: /^is\s+(not)?\s*([a-zA-Z_][a-zA-Z0-9_]*)/,
            next: Twig.expression.set.operations.concat([Twig.expression.type.parameter.start]),
            compile: function(token, stack, output) {
                token.filter   = token.match[2];
                token.modifier = token.match[1];
                delete token.match;
                delete token.value;
                output.push(token);
            },
            parse: function(token, stack, context) {
                var value = stack.pop(),
                    params = token.params && Twig.expression.parse.apply(this, [token.params, context]),
                    result = Twig.test(token.filter, value, params);

                if (token.modifier == 'not') {
                    stack.push(!result);
                } else {
                    stack.push(result);
                }
            }
        },
        {
            type: Twig.expression.type.comma,
            // Match a comma
            regex: /^,/,
            next: Twig.expression.set.expressions.concat([Twig.expression.type.array.end, Twig.expression.type.object.end]),
            compile: function(token, stack, output) {
                var i = stack.length - 1,
                    stack_token;

                delete token.match;
                delete token.value;

                // pop tokens off the stack until the start of the object
                for(;i >= 0; i--) {
                    stack_token = stack.pop();
                    if (stack_token.type === Twig.expression.type.object.start
                            || stack_token.type === Twig.expression.type.parameter.start
                            || stack_token.type === Twig.expression.type.array.start) {
                        stack.push(stack_token);
                        break;
                    }
                    output.push(stack_token);
                }
                output.push(token);
            }
        },
        {
            type: Twig.expression.type.operator.binary,
            // Match any of +, *, /, -, %, ~, <, <=, >, >=, !=, ==, **, ?, :, and, or, not
            regex: /(^[\+\-~%\?\:]|^[!=]==?|^[!<>]=?|^\*\*?|^\/\/?|^and\s+|^or\s+|^in\s+|^not in\s+|^\.\.)/,
            next: Twig.expression.set.expressions.concat([Twig.expression.type.operator.unary]),
            compile: function(token, stack, output) {
                delete token.match;

                token.value = token.value.trim();
                var value = token.value,
                    operator = Twig.expression.operator.lookup(value, token);

                Twig.log.trace("Twig.expression.compile: ", "Operator: ", operator, " from ", value);

                while (stack.length > 0 &&
                       (stack[stack.length-1].type == Twig.expression.type.operator.unary || stack[stack.length-1].type == Twig.expression.type.operator.binary) &&
                            (
                                (operator.associativity === Twig.expression.operator.leftToRight &&
                                 operator.precidence    >= stack[stack.length-1].precidence) ||

                                (operator.associativity === Twig.expression.operator.rightToLeft &&
                                 operator.precidence    >  stack[stack.length-1].precidence)
                            )
                       ) {
                     var temp = stack.pop();
                     output.push(temp);
                }

                if (value === ":") {
                    // Check if this is a ternary or object key being set
                    if (stack[stack.length - 1] && stack[stack.length-1].value === "?") {
                        // Continue as normal for a ternary
                    } else {
                        // This is not a ternary so we push the token to the output where it can be handled
                        //   when the assocated object is closed.
                        var key_token = output.pop();

                        if (key_token.type === Twig.expression.type.string ||
                                key_token.type === Twig.expression.type.variable ||
                                key_token.type === Twig.expression.type.number) {
                            token.key = key_token.value;

                        } else {
                            throw new Twig.Error("Unexpected value before ':' of " + key_token.type + " = " + key_token.value);
                        }

                        output.push(token);
                        return;
                    }
                } else {
                    stack.push(operator);
                }
            },
            parse: function(token, stack, context) {
                if (token.key) {
                    // handle ternary ':' operator
                    stack.push(token);
                } else {
                    Twig.expression.operator.parse(token.value, stack);
                }
            }
        },
        {
            type: Twig.expression.type.operator.unary,
            // Match any of not
            regex: /(^not\s+)/,
            next: Twig.expression.set.expressions,
            compile: function(token, stack, output) {
                delete token.match;

                token.value = token.value.trim();
                var value = token.value,
                    operator = Twig.expression.operator.lookup(value, token);

                Twig.log.trace("Twig.expression.compile: ", "Operator: ", operator, " from ", value);

                while (stack.length > 0 &&
                       (stack[stack.length-1].type == Twig.expression.type.operator.unary || stack[stack.length-1].type == Twig.expression.type.operator.binary) &&
                            (
                                (operator.associativity === Twig.expression.operator.leftToRight &&
                                 operator.precidence    >= stack[stack.length-1].precidence) ||

                                (operator.associativity === Twig.expression.operator.rightToLeft &&
                                 operator.precidence    >  stack[stack.length-1].precidence)
                            )
                       ) {
                     var temp = stack.pop();
                     output.push(temp);
                }

                stack.push(operator);
            },
            parse: function(token, stack, context) {
                Twig.expression.operator.parse(token.value, stack);
            }
        },
        {
            /**
             * Match a string. This is anything between a pair of single or double quotes.
             */
            type: Twig.expression.type.string,
            // See: http://blog.stevenlevithan.com/archives/match-quoted-string
            regex: /^(["'])(?:(?=(\\?))\2[\s\S])*?\1/,
            next: Twig.expression.set.operations,
            compile: function(token, stack, output) {
                var value = token.value;
                delete token.match

                // Remove the quotes from the string
                if (value.substring(0, 1) === '"') {
                    value = value.replace('\\"', '"');
                } else {
                    value = value.replace("\\'", "'");
                }
                token.value = value.substring(1, value.length-1).replace( /\\n/g, "\n" ).replace( /\\r/g, "\r" );
                Twig.log.trace("Twig.expression.compile: ", "String value: ", token.value);
                output.push(token);
            },
            parse: Twig.expression.fn.parse.push_value
        },
        {
            /**
             * Match a parameter set start.
             */
            type: Twig.expression.type.parameter.start,
            regex: /^\(/,
            next: Twig.expression.set.expressions.concat([Twig.expression.type.parameter.end]),
            compile: Twig.expression.fn.compile.push_both,
            parse: Twig.expression.fn.parse.push
        },
        {
            /**
             * Match a parameter set end.
             */
            type: Twig.expression.type.parameter.end,
            regex: /^\)/,
            next: Twig.expression.set.operations_extended,
            compile: function(token, stack, output) {
                var stack_token,
                    end_token = token;

                stack_token = stack.pop();
                while(stack.length > 0 && stack_token.type != Twig.expression.type.parameter.start) {
                    output.push(stack_token);
                    stack_token = stack.pop();
                }

                // Move contents of parens into preceding filter
                var param_stack = [];
                while(token.type !== Twig.expression.type.parameter.start) {
                    // Add token to arguments stack
                    param_stack.unshift(token);
                    token = output.pop();
                }
                param_stack.unshift(token);

                var is_expression = false;

                // Get the token preceding the parameters
                token = output[output.length-1];

                if (token === undefined ||
                    (token.type !== Twig.expression.type._function &&
                    token.type !== Twig.expression.type.filter &&
                    token.type !== Twig.expression.type.test &&
                    token.type !== Twig.expression.type.key.brackets &&
                    token.type !== Twig.expression.type.key.period)) {

                    end_token.expression = true;

                    // remove start and end token from stack
                    param_stack.pop();
                    param_stack.shift();

                    end_token.params = param_stack;

                    output.push(end_token);

                } else {
                    end_token.expression = false;
                    token.params = param_stack;
                }
            },
            parse: function(token, stack, context) {
                var new_array = [],
                    array_ended = false,
                    value = null;

                if (token.expression) {
                    value = Twig.expression.parse.apply(this, [token.params, context])
                    stack.push(value);

                } else {

                    while (stack.length > 0) {
                        value = stack.pop();
                        // Push values into the array until the start of the array
                        if (value && value.type && value.type == Twig.expression.type.parameter.start) {
                            array_ended = true;
                            break;
                        }
                        new_array.unshift(value);
                    }

                    if (!array_ended) {
                        throw new Twig.Error("Expected end of parameter set.");
                    }

                    stack.push(new_array);
                }
            }
        },
        {
            /**
             * Match an array start.
             */
            type: Twig.expression.type.array.start,
            regex: /^\[/,
            next: Twig.expression.set.expressions.concat([Twig.expression.type.array.end]),
            compile: Twig.expression.fn.compile.push_both,
            parse: Twig.expression.fn.parse.push
        },
        {
            /**
             * Match an array end.
             */
            type: Twig.expression.type.array.end,
            regex: /^\]/,
            next: Twig.expression.set.operations_extended,
            compile: function(token, stack, output) {
                var i = stack.length - 1,
                    stack_token;
                // pop tokens off the stack until the start of the object
                for(;i >= 0; i--) {
                    stack_token = stack.pop();
                    if (stack_token.type === Twig.expression.type.array.start) {
                        break;
                    }
                    output.push(stack_token);
                }
                output.push(token);
            },
            parse: function(token, stack, context) {
                var new_array = [],
                    array_ended = false,
                    value = null;

                while (stack.length > 0) {
                    value = stack.pop();
                    // Push values into the array until the start of the array
                    if (value.type && value.type == Twig.expression.type.array.start) {
                        array_ended = true;
                        break;
                    }
                    new_array.unshift(value);
                }
                if (!array_ended) {
                    throw new Twig.Error("Expected end of array.");
                }

                stack.push(new_array);
            }
        },
        // Token that represents the start of a hash map '}'
        //
        // Hash maps take the form:
        //    { "key": 'value', "another_key": item }
        //
        // Keys must be quoted (either single or double) and values can be any expression.
        {
            type: Twig.expression.type.object.start,
            regex: /^\{/,
            next: Twig.expression.set.expressions.concat([Twig.expression.type.object.end]),
            compile: Twig.expression.fn.compile.push_both,
            parse: Twig.expression.fn.parse.push
        },

        // Token that represents the end of a Hash Map '}'
        //
        // This is where the logic for building the internal
        // representation of a hash map is defined.
        {
            type: Twig.expression.type.object.end,
            regex: /^\}/,
            next: Twig.expression.set.operations_extended,
            compile: function(token, stack, output) {
                var i = stack.length-1,
                    stack_token;

                // pop tokens off the stack until the start of the object
                for(;i >= 0; i--) {
                    stack_token = stack.pop();
                    if (stack_token && stack_token.type === Twig.expression.type.object.start) {
                        break;
                    }
                    output.push(stack_token);
                }
                output.push(token);
            },
            parse: function(end_token, stack, context) {
                var new_object = {},
                    object_ended = false,
                    token = null,
                    token_key = null,
                    has_value = false,
                    value = null;

                while (stack.length > 0) {
                    token = stack.pop();
                    // Push values into the array until the start of the object
                    if (token && token.type && token.type === Twig.expression.type.object.start) {
                        object_ended = true;
                        break;
                    }
                    if (token && token.type && (token.type === Twig.expression.type.operator.binary || token.type === Twig.expression.type.operator.unary) && token.key) {
                        if (!has_value) {
                            throw new Twig.Error("Missing value for key '" + token.key + "' in object definition.");
                        }
                        new_object[token.key] = value;

                        // Preserve the order that elements are added to the map
                        // This is necessary since JavaScript objects don't
                        // guarantee the order of keys
                        if (new_object._keys === undefined) new_object._keys = [];
                        new_object._keys.unshift(token.key);

                        // reset value check
                        value = null;
                        has_value = false;

                    } else {
                        has_value = true;
                        value = token;
                    }
                }
                if (!object_ended) {
                    throw new Twig.Error("Unexpected end of object.");
                }

                stack.push(new_object);
            }
        },

        // Token representing a filter
        //
        // Filters can follow any expression and take the form:
        //    expression|filter(optional, args)
        //
        // Filter parsing is done in the Twig.filters namespace.
        {
            type: Twig.expression.type.filter,
            // match a | then a letter or _, then any number of letters, numbers, _ or -
            regex: /^\|\s?([a-zA-Z_][a-zA-Z0-9_\-]*)/,
            next: Twig.expression.set.operations_extended.concat([
                    Twig.expression.type.parameter.start]),
            compile: function(token, stack, output) {
                token.value = token.match[1];
                output.push(token);
            },
            parse: function(token, stack, context) {
                var input = stack.pop(),
                    params = token.params && Twig.expression.parse.apply(this, [token.params, context]);

                stack.push(Twig.filter.apply(this, [token.value, input, params]));
            }
        },
        {
            type: Twig.expression.type._function,
            // match any letter or _, then any number of letters, numbers, _ or - followed by (
            regex: /^([a-zA-Z_][a-zA-Z0-9_]*)\s*\(/,
            next: Twig.expression.type.parameter.start,
            transform: function(match, tokens) {
                return '(';
            },
            compile: function(token, stack, output) {
                var fn = token.match[1];
                token.fn = fn;
                // cleanup token
                delete token.match;
                delete token.value;

                output.push(token);
            },
            parse: function(token, stack, context) {
                var params = token.params && Twig.expression.parse.apply(this, [token.params, context]),
                    fn     = token.fn,
                    value;

                if (Twig.functions[fn]) {
                    // Get the function from the built-in functions
                    value = Twig.functions[fn].apply(this, params);

                } else if (typeof context[fn] == 'function') {
                    // Get the function from the user/context defined functions
                    value = context[fn].apply(context, params);

                } else {
                    throw new Twig.Error(fn + ' function does not exist and is not defined in the context');
                }

                stack.push(value);
            }
        },

        // Token representing a variable.
        //
        // Variables can contain letters, numbers, underscores and
        // dashes, but must start with a letter or underscore.
        //
        // Variables are retrieved from the render context and take
        // the value of 'undefined' if the given variable doesn't
        // exist in the context.
        {
            type: Twig.expression.type.variable,
            // match any letter or _, then any number of letters, numbers, _ or -
            regex: /^[a-zA-Z_][a-zA-Z0-9_]*/,
            next: Twig.expression.set.operations_extended.concat([
                    Twig.expression.type.parameter.start]),
            compile: Twig.expression.fn.compile.push,
            validate: function(match, tokens) {
                return (Twig.indexOf(Twig.expression.reservedWords, match[0]) < 0);
            },
            parse: function(token, stack, context) {
                // Get the variable from the context
                var value = Twig.expression.resolve(context[token.value], context);
                stack.push(value);
            }
        },
        {
            type: Twig.expression.type.key.period,
            regex: /^\.([a-zA-Z0-9_]+)/,
            next: Twig.expression.set.operations_extended.concat([
                    Twig.expression.type.parameter.start]),
            compile: function(token, stack, output) {
                token.key = token.match[1];
                delete token.match;
                delete token.value;

                output.push(token);
            },
            parse: function(token, stack, context) {
                var params = token.params && Twig.expression.parse.apply(this, [token.params, context]),
                    key = token.key,
                    object = stack.pop(),
                    value;

                if (object === null || object === undefined) {
                    if (this.options.strict_variables) {
                        throw new Twig.Error("Can't access a key " + key + " on an null or undefined object.");
                    } else {
                        return null;
                    }
                }

                var capitalize = function(value) {return value.substr(0, 1).toUpperCase() + value.substr(1);};

                // Get the variable from the context
                if (typeof object === 'object' && key in object) {
                    value = object[key];
                } else if (object["get"+capitalize(key)] !== undefined) {
                    value = object["get"+capitalize(key)];
                } else if (object["is"+capitalize(key)] !== undefined) {
                    value = object["is"+capitalize(key)];
                } else {
                    value = null;
                }
                stack.push(Twig.expression.resolve(value, object, params));
            }
        },
        {
            type: Twig.expression.type.key.brackets,
            regex: /^\[([^\]]*)\]/,
            next: Twig.expression.set.operations_extended.concat([
                    Twig.expression.type.parameter.start]),
            compile: function(token, stack, output) {
                var match = token.match[1];
                delete token.value;
                delete token.match;

                // The expression stack for the key
                token.stack = Twig.expression.compile({
                    value: match
                }).stack;

                output.push(token);
            },
            parse: function(token, stack, context) {
                // Evaluate key
                var params = token.params && Twig.expression.parse.apply(this, [token.params, context]),
                    key = Twig.expression.parse.apply(this, [token.stack, context]),
                    object = stack.pop(),
                    value;

                if (object === null || object === undefined) {
                    if (this.options.strict_variables) {
                        throw new Twig.Error("Can't access a key " + key + " on an null or undefined object.");
                    } else {
                        return null;
                    }
                }

                // Get the variable from the context
                if (typeof object === 'object' && key in object) {
                    value = object[key];
                } else {
                    value = null;
                }
                stack.push(Twig.expression.resolve(value, object, params));
            }
        },
        {
            /**
             * Match a null value.
             */
            type: Twig.expression.type._null,
            // match a number
            regex: /^(null|NULL|none|NONE)/,
            next: Twig.expression.set.operations,
            compile: function(token, stack, output) {
                delete token.match;
                token.value = null;
                output.push(token);
            },
            parse: Twig.expression.fn.parse.push_value
        },
        {
            /**
             * Match the context
             */
            type: Twig.expression.type.context,
            regex: /^_context/,
            next: Twig.expression.set.operations_extended.concat([
                    Twig.expression.type.parameter.start]),
            compile: Twig.expression.fn.compile.push,
            parse: function(token, stack, context) {
                stack.push(context);
            }
        },
        {
            /**
             * Match a number (integer or decimal)
             */
            type: Twig.expression.type.number,
            // match a number
            regex: /^\-?\d+(\.\d+)?/,
            next: Twig.expression.set.operations,
            compile: function(token, stack, output) {
                token.value = Number(token.value);
                output.push(token);
            },
            parse: Twig.expression.fn.parse.push_value
        },
        {
            /**
             * Match a boolean
             */
            type: Twig.expression.type.bool,
            regex: /^(true|TRUE|false|FALSE)/,
            next: Twig.expression.set.operations,
            compile: function(token, stack, output) {
                token.value = (token.match[0].toLowerCase( ) === "true");
                delete token.match;
                output.push(token);
            },
            parse: Twig.expression.fn.parse.push_value
        }
    ];

    /**
     * Resolve a context value.
     *
     * If the value is a function, it is executed with a context parameter.
     *
     * @param {string} key The context object key.
     * @param {Object} context The render context.
     */
    Twig.expression.resolve = function(value, context, params) {
        if (typeof value == 'function') {
            return value.apply(context, params || []);
        } else {
            return value;
        }
    };

    /**
     * Registry for logic handlers.
     */
    Twig.expression.handler = {};

    /**
     * Define a new expression type, available at Twig.logic.type.{type}
     *
     * @param {string} type The name of the new type.
     */
    Twig.expression.extendType = function (type) {
        Twig.expression.type[type] = "Twig.expression.type." + type;
    };

    /**
     * Extend the expression parsing functionality with a new definition.
     *
     * Token definitions follow this format:
     *  {
     *      type:     One of Twig.expression.type.[type], either pre-defined or added using
     *                    Twig.expression.extendType
     *
     *      next:     Array of types from Twig.expression.type that can follow this token,
     *
     *      regex:    A regex or array of regex's that should match the token.
     *
     *      compile: function(token, stack, output) called when this token is being compiled.
     *                   Should return an object with stack and output set.
     *
     *      parse:   function(token, stack, context) called when this token is being parsed.
     *                   Should return an object with stack and context set.
     *  }
     *
     * @param {Object} definition A token definition.
     */
    Twig.expression.extend = function (definition) {
        if (!definition.type) {
            throw new Twig.Error("Unable to extend logic definition. No type provided for " + definition);
        }
        Twig.expression.handler[definition.type] = definition;
    };

    // Extend with built-in expressions
    while (Twig.expression.definitions.length > 0) {
        Twig.expression.extend(Twig.expression.definitions.shift());
    }

    /**
     * Break an expression into tokens defined in Twig.expression.definitions.
     *
     * @param {string} expression The string to tokenize.
     *
     * @return {Array} An array of tokens.
     */
    Twig.expression.tokenize = function (expression) {
        var tokens = [],
            // Keep an offset of the location in the expression for error messages.
            exp_offset = 0,
            // The valid next tokens of the previous token
            next = null,
            // Match information
            type, regex, regex_array,
            // The possible next token for the match
            token_next,
            // Has a match been found from the definitions
            match_found, invalid_matches = [], match_function;

        match_function = function () {
            var match = Array.prototype.slice.apply(arguments),
                string = match.pop(),
                offset = match.pop();

            Twig.log.trace("Twig.expression.tokenize",
                           "Matched a ", type, " regular expression of ", match);

            if (next && Twig.indexOf(next, type) < 0) {
                invalid_matches.push(
                    type + " cannot follow a " + tokens[tokens.length - 1].type +
                           " at template:" + exp_offset + " near '" + match[0].substring(0, 20) +
                           "...'"
                );
                // Not a match, don't change the expression
                return match[0];
            }

            // Validate the token if a validation function is provided
            if (Twig.expression.handler[type].validate &&
                    !Twig.expression.handler[type].validate(match, tokens)) {
                return match[0];
            }

            invalid_matches = [];

            tokens.push({
                type:  type,
                value: match[0],
                match: match
            });

            match_found = true;
            next = token_next;
            exp_offset += match[0].length;

            // Does the token need to return output back to the expression string
            // e.g. a function match of cycle( might return the '(' back to the expression
            // This allows look-ahead to differentiate between token types (e.g. functions and variable names)
            if (Twig.expression.handler[type].transform) {
                return Twig.expression.handler[type].transform(match, tokens);
            }
            return '';
        };

        Twig.log.debug("Twig.expression.tokenize", "Tokenizing expression ", expression);

        while (expression.length > 0) {
            expression = expression.trim();
            for (type in Twig.expression.handler) {
                if (Twig.expression.handler.hasOwnProperty(type)) {
                    token_next = Twig.expression.handler[type].next;
                    regex = Twig.expression.handler[type].regex;
                    // Twig.log.trace("Checking type ", type, " on ", expression);
                    if (regex instanceof Array) {
                        regex_array = regex;
                    } else {
                        regex_array = [regex];
                    }

                    match_found = false;
                    while (regex_array.length > 0) {
                        regex = regex_array.pop();
                        expression = expression.replace(regex, match_function);
                    }
                    // An expression token has been matched. Break the for loop and start trying to
                    //  match the next template (if expression isn't empty.)
                    if (match_found) {
                        break;
                    }
                }
            }
            if (!match_found) {
                if (invalid_matches.length > 0) {
                    throw new Twig.Error(invalid_matches.join(" OR "));
                } else {
                    throw new Twig.Error("Unable to parse '" + expression + "' at template position" + exp_offset);
                }
            }
        }

        Twig.log.trace("Twig.expression.tokenize", "Tokenized to ", tokens);
        return tokens;
    };

    /**
     * Compile an expression token.
     *
     * @param {Object} raw_token The uncompiled token.
     *
     * @return {Object} The compiled token.
     */
    Twig.expression.compile = function (raw_token) {
        var expression = raw_token.value,
            // Tokenize expression
            tokens = Twig.expression.tokenize(expression),
            token = null,
            output = [],
            stack = [],
            token_template = null;

        Twig.log.trace("Twig.expression.compile: ", "Compiling ", expression);

        // Push tokens into RPN stack using the Sunting-yard algorithm
        // See http://en.wikipedia.org/wiki/Shunting_yard_algorithm

        while (tokens.length > 0) {
            token = tokens.shift();
            token_template = Twig.expression.handler[token.type];

            Twig.log.trace("Twig.expression.compile: ", "Compiling ", token);

            // Compile the template
            token_template.compile && token_template.compile(token, stack, output);

            Twig.log.trace("Twig.expression.compile: ", "Stack is", stack);
            Twig.log.trace("Twig.expression.compile: ", "Output is", output);
        }

        while(stack.length > 0) {
            output.push(stack.pop());
        }

        Twig.log.trace("Twig.expression.compile: ", "Final output is", output);

        raw_token.stack = output;
        delete raw_token.value;

        return raw_token;
    };


    /**
     * Parse an RPN expression stack within a context.
     *
     * @param {Array} tokens An array of compiled expression tokens.
     * @param {Object} context The render context to parse the tokens with.
     *
     * @return {Object} The result of parsing all the tokens. The result
     *                  can be anything, String, Array, Object, etc... based on
     *                  the given expression.
     */
    Twig.expression.parse = function (tokens, context) {
        var that = this;

        // If the token isn't an array, make it one.
        if (!(tokens instanceof Array)) {
            tokens = [tokens];
        }

        // The output stack
        var stack = [],
            token_template = null;

        Twig.forEach(tokens, function (token) {
            token_template = Twig.expression.handler[token.type];

            token_template.parse && token_template.parse.apply(that, [token, stack, context]);
        });

        // Pop the final value off the stack
        return stack.pop();
    };

    return Twig;

})( Twig || { } );
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.expression.operator.js
//
// This file handles operator lookups and parsing.
var Twig = (function (Twig) {
    "use strict";

    /**
     * Operator associativity constants.
     */
    Twig.expression.operator = {
        leftToRight: 'leftToRight',
        rightToLeft: 'rightToLeft'
    };

    var containment = function(a, b) {
        if (b.indexOf !== undefined) {
            // String
            return a === b || a !== '' && b.indexOf(a) > -1;

        } else {
            var el;
            for (el in b) {
                if (b.hasOwnProperty(el) && b[el] === a) {
                    return true;
                }
            }
            return false;
        }
    };

    /**
     * Get the precidence and associativity of an operator. These follow the order that C/C++ use.
     * See http://en.wikipedia.org/wiki/Operators_in_C_and_C++ for the table of values.
     */
    Twig.expression.operator.lookup = function (operator, token) {
        switch (operator) {
            case "..":
            case 'not in':
            case 'in':
                token.precidence = 20;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case ',':
                token.precidence = 18;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            // Ternary
            case '?':
            case ':':
                token.precidence = 16;
                token.associativity = Twig.expression.operator.rightToLeft;
                break;

            case 'or':
                token.precidence = 14;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case 'and':
                token.precidence = 13;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case '==':
            case '!=':
                token.precidence = 9;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case '<':
            case '<=':
            case '>':
            case '>=':
                token.precidence = 8;
                token.associativity = Twig.expression.operator.leftToRight;
                break;


            case '~': // String concatination
            case '+':
            case '-':
                token.precidence = 6;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case '//':
            case '**':
            case '*':
            case '/':
            case '%':
                token.precidence = 5;
                token.associativity = Twig.expression.operator.leftToRight;
                break;

            case 'not':
                token.precidence = 3;
                token.associativity = Twig.expression.operator.rightToLeft;
                break;

            default:
                throw new Twig.Error(operator + " is an unknown operator.");
        }
        token.operator = operator;
        return token;
    };

    /**
     * Handle operations on the RPN stack.
     *
     * Returns the updated stack.
     */
    Twig.expression.operator.parse = function (operator, stack) {
        Twig.log.trace("Twig.expression.operator.parse: ", "Handling ", operator);
        var a, b, c;
        switch (operator) {
            case ':':
                // Ignore
                break;

            case '?':
                c = stack.pop(); // false expr
                b = stack.pop(); // true expr
                a = stack.pop(); // conditional
                if (a) {
                    stack.push(b);
                } else {
                    stack.push(c);
                }
                break;

            case '+':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(a + b);
                break;

            case '-':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(a - b);
                break;

            case '*':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(a * b);
                break;

            case '/':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(a / b);
                break;

            case '//':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(parseInt(a / b));
                break;

            case '%':
                b = parseFloat(stack.pop());
                a = parseFloat(stack.pop());
                stack.push(a % b);
                break;

            case '~':
                b = stack.pop();
                a = stack.pop();
                stack.push( (a != null ? a.toString() : "")
                          + (b != null ? b.toString() : "") );
                break;

            case 'not':
            case '!':
                stack.push(!stack.pop());
                break;

            case '<':
                b = stack.pop();
                a = stack.pop();
                stack.push(a < b);
                break;

            case '<=':
                b = stack.pop();
                a = stack.pop();
                stack.push(a <= b);
                break;

            case '>':
                b = stack.pop();
                a = stack.pop();
                stack.push(a > b);
                break;

            case '>=':
                b = stack.pop();
                a = stack.pop();
                stack.push(a >= b);
                break;

            case '===':
                b = stack.pop();
                a = stack.pop();
                stack.push(a === b);
                break;

            case '==':
                b = stack.pop();
                a = stack.pop();
                stack.push(a == b);
                break;

            case '!==':
                b = stack.pop();
                a = stack.pop();
                stack.push(a !== b);
                break;

            case '!=':
                b = stack.pop();
                a = stack.pop();
                stack.push(a != b);
                break;

            case 'or':
                b = stack.pop();
                a = stack.pop();
                stack.push(a || b);
                break;

            case 'and':
                b = stack.pop();
                a = stack.pop();
                stack.push(a && b);
                break;

            case '**':
                b = stack.pop();
                a = stack.pop();
                stack.push(Math.pow(a, b));
                break;


            case 'not in':
                b = stack.pop();
                a = stack.pop();
                stack.push( !containment(a, b) );
                break;

            case 'in':
                b = stack.pop();
                a = stack.pop();
                stack.push( containment(a, b) );
                break;

            case '..':
                b = stack.pop();
                a = stack.pop();
                stack.push( Twig.functions.range(a, b) );
                break;

            default:
                throw new Twig.Error(operator + " is an unknown operator.");
        }
    };

    return Twig;

})( Twig || { } );
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.filters.js
//
// This file handles parsing filters.
var Twig = (function (Twig) {

    // Determine object type
    function is(type, obj) {
        var clas = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && clas === type;
    }

    Twig.filters = {
        // String Filters
        upper:  function(value) {
            if ( typeof value !== "string" ) {
               return value;
            }

            return value.toUpperCase();
        },
        lower: function(value) {
            if ( typeof value !== "string" ) {
               return value;
            }

            return value.toLowerCase();
        },
        capitalize: function(value) {
            if ( typeof value !== "string" ) {
                 return value;
            }

            return value.substr(0, 1).toUpperCase() + value.toLowerCase().substr(1);
        },
        title: function(value) {
            if ( typeof value !== "string" ) {
               return value;
            }

            return value.toLowerCase().replace( /(^|\s)([a-z])/g , function(m, p1, p2){
                return p1 + p2.toUpperCase();
            });
        },
        length: function(value) {
            if (Twig.lib.is("Array", value) || typeof value === "string") {
                return value.length;
            } else if (Twig.lib.is("Object", value)) {
                if (value._keys === undefined) {
                    return Object.keys(value).length;
                } else {
                    return value._keys.length;
                }
            } else {
                return 0;
            }
        },

        // Array/Object Filters
        reverse: function(value) {
            if (is("Array", value)) {
                return value.reverse();
            } else if (is("String", value)) {
                return value.split("").reverse().join("");
            } else if (is("Object", value)) {
                var keys = value._keys || Object.keys(value).reverse();
                value._keys = keys;
                return value;
            }
        },
        sort: function(value) {
            if (is("Array", value)) {
                return value.sort();
            } else if (is('Object', value)) {
                // Sorting objects isn't obvious since the order of
                // returned keys isn't guaranteedin JavaScript.
                // Because of this we use a "hidden" key called _keys to
                // store the keys in the order we want to return them.

                delete value._keys;
                var keys = Object.keys(value),
                    sorted_keys = keys.sort(function(a, b) {
                        return value[a] > value[b];
                    });
                value._keys = sorted_keys;
                return value;
            }
        },
        keys: function(value) {
            if (value === undefined || value === null){
                return;
           }

            var keyset = value._keys || Object.keys(value),
                output = [];

            Twig.forEach(keyset, function(key) {
                if (key === "_keys") return; // Ignore the _keys property
                if (value.hasOwnProperty(key)) {
                    output.push(key);
                }
            });
            return output;
        },
        url_encode: function(value) {
            if (value === undefined || value === null){
                return;
            }

            return encodeURIComponent(value);
        },
        join: function(value, params) {
            if (value === undefined || value === null){
                return;
            }

            var join_str = "",
                output = [],
                keyset = null;

            if (params && params[0]) {
                join_str = params[0];
            }
            if (is("Array", value)) {
                output = value;
            } else {
                keyset = value._keys || Object.keys(value);
                Twig.forEach(keyset, function(key) {
                    if (key === "_keys") return; // Ignore the _keys property
                    if (value.hasOwnProperty(key)) {
                        output.push(value[key]);
                    }
                });
            }
            return output.join(join_str);
        },
        "default": function(value, params) {
            if (params === undefined || params.length !== 1) {
                throw new Twig.Error("default filter expects one argument");
            }
            if (value === undefined || value === null || value === '' ) {
                return params[0];
            } else {
                return value;
            }
        },
        json_encode: function(value) {
            if (value && value.hasOwnProperty( "_keys" ) ) {
                delete value._keys;
            }
            if(value === undefined || value === null) {
                return "null";
            }
            return JSON.stringify(value);
        },
        merge: function(value, params) {
            var obj = [],
                arr_index = 0,
                keyset = [];

            // Check to see if all the objects being merged are arrays
            if (!is("Array", value)) {
                // Create obj as an Object
                obj = { };
            } else {
                Twig.forEach(params, function(param) {
                    if (!is("Array", param)) {
                        obj = { };
                    }
                });
            }
            if (!is("Array", obj)) {
                obj._keys = [];
            }

            if (is("Array", value)) {
                Twig.forEach(value, function(val) {
                    if (obj._keys) obj._keys.push(arr_index);
                    obj[arr_index] = val;
                    arr_index++;
                });
            } else {
                keyset = value._keys || Object.keys(value);
                Twig.forEach(keyset, function(key) {
                    obj[key] = value[key];
                    obj._keys.push(key);

                    // Handle edge case where a number index in an object is greater than
                    //   the array counter. In such a case, the array counter is increased
                    //   one past the index.
                    //
                    // Example {{ ["a", "b"]|merge({"4":"value"}, ["c", "d"])
                    // Without this, d would have an index of "4" and overwrite the value
                    //   of "value"
                    var int_key = parseInt(key, 10);
                    if (!isNaN(int_key) && int_key >= arr_index) {
                        arr_index = int_key + 1;
                    }
                });
            }

            // mixin the merge arrays
            Twig.forEach(params, function(param) {
                if (is("Array", param)) {
                    Twig.forEach(param, function(val) {
                        if (obj._keys) obj._keys.push(arr_index);
                        obj[arr_index] = val;
                        arr_index++;
                    });
                } else {
                    keyset = param._keys || Object.keys(param);
                    Twig.forEach(keyset, function(key) {
                        if (!obj[key]) obj._keys.push(key);
                        obj[key] = param[key];

                        var int_key = parseInt(key, 10);
                        if (!isNaN(int_key) && int_key >= arr_index) {
                            arr_index = int_key + 1;
                        }
                    });
                }
            });
            if (params.length === 0) {
                throw new Twig.Error("Filter merge expects at least one parameter");
            }

            return obj;
        },
        date: function(value, params) {
            var date = Twig.functions.date(value);
            var format = params && params.length ? params[0] : 'F j, Y H:i';
            return Twig.lib.formatDate(date, format);
        },

        date_modify: function(value, params) {
            if (value === undefined || value === null) {
                return;
            }
            if (params === undefined || params.length !== 1) {
                throw new Twig.Error("date_modify filter expects 1 argument");
            }

            var modifyText = params[0], time;

            if (Twig.lib.is("Date", value)) {
                time = Twig.lib.strtotime(modifyText, value.getTime() / 1000);
            }
            if (Twig.lib.is("String", value)) {
                time = Twig.lib.strtotime(modifyText, Twig.lib.strtotime(value));
            }
            if (Twig.lib.is("Number", value)) {
                time = Twig.lib.strtotime(modifyText, value);
            }

            return new Date(time * 1000);
        },

        replace: function(value, params) {
            if (value === undefined||value === null){
                return;
            }

            var pairs = params[0],
                tag;
            for (tag in pairs) {
                if (pairs.hasOwnProperty(tag) && tag !== "_keys") {
                    value = Twig.lib.replaceAll(value, tag, pairs[tag]);
                }
            }
            return value;
        },

        format: function(value, params) {
            if (value === undefined || value === null){
                return;
            }

            return Twig.lib.vsprintf(value, params);
        },

        striptags: function(value) {
            if (value === undefined || value === null){
                return;
            }

            return Twig.lib.strip_tags(value);
        },

        escape: function(value) {
            if (value === undefined|| value === null){
                return;
            }
            var raw_value = value.toString().replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#039;");
            return Twig.Markup(raw_value);
        },

        /* Alias of escape */
        "e": function(value) {
            return Twig.filters.escape(value);
        },

        nl2br: function(value) {
            if (value === undefined || value === null){
                return;
            }
            var linebreak_tag = "BACKSLASH_n_replace",
                br = "<br />" + linebreak_tag;

            value = Twig.filters.escape(value)
                        .replace(/\r\n/g, br)
                        .replace(/\r/g, br)
                        .replace(/\n/g, br);

            value = Twig.lib.replaceAll(value, linebreak_tag, "\n");

            return Twig.Markup(value);
        },

        /**
         * Adapted from: http://phpjs.org/functions/number_format:481
         */
        number_format: function(value, params) {
            var number = value,
                decimals = (params && params[0]) ? params[0] : undefined,
                dec      = (params && params[1] !== undefined) ? params[1] : ".",
                sep      = (params && params[2] !== undefined) ? params[2] : ",";

            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },

        trim: function(value, params) {
            if (value === undefined|| value === null){
                return;
            }

            var str = Twig.filters.escape( '' + value ),
                whitespace;
            if ( params && params[0] ) {
                whitespace = '' + params[0];
            } else {
                whitespace = ' \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000';
            }
            for (var i = 0; i < str.length; i++) {
                if (whitespace.indexOf(str.charAt(i)) === -1) {
                    str = str.substring(i);
                    break;
                }
            }
            for (i = str.length - 1; i >= 0; i--) {
                if (whitespace.indexOf(str.charAt(i)) === -1) {
                    str = str.substring(0, i + 1);
                    break;
                }
            }
            return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
        },

        truncate: function (value, params) {
            var length = 30,
                preserve = false,
                separator = '...';

            value =  value + '';
            if (params) {
                if (params[0]) {
                    length = params[0];
                }
                if (params[1]) {
                    preserve = params[1];
                }
                if (params[2]) {
                    separator = params[2];
                }
            }

            if (value.length > length) {

                if (preserve) {
                    length = value.indexOf(' ', length);
                    if (length === -1) {
                        return value;
                    }
                }

                value =  value.substr(0, length) + separator;
            }

            return value;
        },

        slice: function(value, params) {
            if (value === undefined || value === null) {
                return;
            }
            if (params === undefined || params.length < 1) {
                throw new Twig.Error("slice filter expects at least 1 argument");
            }

            // default to start of string
            var start = params[0] || 0;
            // default to length of string
            var length = params.length > 1 ? params[1] : value.length;
            // handle negative start values
            var startIndex = start >= 0 ? start : Math.max( value.length + start, 0 );

            if (Twig.lib.is("Array", value)) {
                var output = [];
                for (var i = startIndex; i < startIndex + length && i < value.length; i++) {
                    output.push(value[i]);
                }
                return output;
            } else if (Twig.lib.is("String", value)) {
                return value.substr(startIndex, length);
            } else {
                throw new Twig.Error("slice filter expects value to be an array or string");
            }
        },

        abs: function(value) {
            if (value === undefined || value === null) {
                return;
            }

            return Math.abs(value);
        },

        first: function(value) {
            if (is("Array", value)) {
                return value[0];
            } else if (is("Object", value)) {
                if ('_keys' in value) {
                    return value[value._keys[0]];
                }
            } else if ( typeof value === "string" ) {
                return value.substr(0, 1);
            }

            return;
        },

        split: function(value, params) {
            if (value === undefined || value === null) {
                return;
            }
            if (params === undefined || params.length < 1 || params.length > 2) {
                throw new Twig.Error("split filter expects 1 or 2 argument");
            }
            if (Twig.lib.is("String", value)) {
                var delimiter = params[0],
                    limit = params[1],
                    split = value.split(delimiter);

                if (limit === undefined) {

                    return split;

                } else if (limit < 0) {

                    return value.split(delimiter, split.length + limit);

                } else {

                    var limitedSplit = [];

                    if (delimiter == '') {
                        // empty delimiter
                        // "aabbcc"|split('', 2)
                        //     -> ['aa', 'bb', 'cc']

                        while(split.length > 0) {
                            var temp = "";
                            for (var i=0; i<limit && split.length > 0; i++) {
                                temp += split.shift();
                            }
                            limitedSplit.push(temp);
                        }

                    } else {
                        // non-empty delimiter
                        // "one,two,three,four,five"|split(',', 3)
                        //     -> ['one', 'two', 'three,four,five']

                        for (var i=0; i<limit-1 && split.length > 0; i++) {
                            limitedSplit.push(split.shift());
                        }

                        if (split.length > 0) {
                            limitedSplit.push(split.join(delimiter));
                        }
                    }

                    return limitedSplit;
                }

            } else {
                throw new Twig.Error("split filter expects value to be a string");
            }
        },
        last: function(value) {
            if (Twig.lib.is('Object', value)) {
                var keys;

                if (value._keys === undefined) {
                    keys = Object.keys(value);
                } else {
                    keys = value._keys;
                }

                return value[keys[keys.length - 1]];
            }

            // string|array
            return value[value.length - 1];
        },
        raw: function(value) {
            return Twig.Markup(value);
        },
        batch: function(items, params) {
            var size = params.shift(),
                fill = params.shift(),
                result,
                last,
                missing;

            if (!Twig.lib.is("Array", items)) {
                throw new Twig.Error("batch filter expects items to be an array");
            }

            if (!Twig.lib.is("Number", size)) {
                throw new Twig.Error("batch filter expects size to be a number");
            }

            size = Math.ceil(size);

            result = Twig.lib.chunkArray(items, size);

            if (fill && items.length % size != 0) {
                last = result.pop();
                missing = size - last.length;

                while (missing--) {
                    last.push(fill);
                }

                result.push(last);
            }

            return result;
        },
        round: function(value, params) {
            params = params || [];

            var precision = params.length > 0 ? params[0] : 0,
                method = params.length > 1 ? params[1] : "common";

            value = parseFloat(value);

            if(precision && !Twig.lib.is("Number", precision)) {
                throw new Twig.Error("round filter expects precision to be a number");
            }

            if (method === "common") {
                return Twig.lib.round(value, precision);
            }

            if(!Twig.lib.is("Function", Math[method])) {
                throw new Twig.Error("round filter expects method to be 'floor', 'ceil', or 'common'");
            }

            return Math[method](value * Math.pow(10, precision)) / Math.pow(10, precision);
        }
    };

    Twig.filter = function(filter, value, params) {
        if (!Twig.filters[filter]) {
            throw "Unable to find filter " + filter;
        }
        return Twig.filters[filter].apply(this, [value, params]);
    };

    Twig.filter.extend = function(filter, definition) {
        Twig.filters[filter] = definition;
    };

    return Twig;

})(Twig || { });
//     Twig.js
//                   2012 Hadrien Lanneau
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.functions.js
//
// This file handles parsing filters.
var Twig = (function (Twig) {

    // Determine object type
    function is(type, obj) {
        var clas = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && clas === type;
    }

    Twig.functions = {
        //  attribute, block, constant, date, dump, parent, random,.

        // Range function from http://phpjs.org/functions/range:499
        // Used under an MIT License
        range: function (low, high, step) {
            // http://kevin.vanzonneveld.net
            // +   original by: Waldo Malqui Silva
            // *     example 1: range ( 0, 12 );
            // *     returns 1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            // *     example 2: range( 0, 100, 10 );
            // *     returns 2: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            // *     example 3: range( 'a', 'i' );
            // *     returns 3: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i']
            // *     example 4: range( 'c', 'a' );
            // *     returns 4: ['c', 'b', 'a']
            var matrix = [];
            var inival, endval, plus;
            var walker = step || 1;
            var chars = false;

            if (!isNaN(low) && !isNaN(high)) {
                inival = parseInt(low, 10);
                endval = parseInt(high, 10);
            } else if (isNaN(low) && isNaN(high)) {
                chars = true;
                inival = low.charCodeAt(0);
                endval = high.charCodeAt(0);
            } else {
                inival = (isNaN(low) ? 0 : low);
                endval = (isNaN(high) ? 0 : high);
            }

            plus = ((inival > endval) ? false : true);
            if (plus) {
                while (inival <= endval) {
                    matrix.push(((chars) ? String.fromCharCode(inival) : inival));
                    inival += walker;
                }
            } else {
                while (inival >= endval) {
                    matrix.push(((chars) ? String.fromCharCode(inival) : inival));
                    inival -= walker;
                }
            }

            return matrix;
        },
        cycle: function(arr, i) {
            var pos = i % arr.length;
            return arr[pos];
        },
        dump: function() {
            var EOL = '\n',
                indentChar = '  ',
                indentTimes = 0,
                out = '',
                args = Array.prototype.slice.call(arguments),
                indent = function(times) {
                    var ind  = '';
                    while (times > 0) {
                        times--;
                        ind += indentChar;
                    }
                    return ind;
                },
                displayVar = function(variable) {
                    out += indent(indentTimes);
                    if (typeof(variable) === 'object') {
                        dumpVar(variable);
                    } else if (typeof(variable) === 'function') {
                        out += 'function()' + EOL;
                    } else if (typeof(variable) === 'string') {
                        out += 'string(' + variable.length + ') "' + variable + '"' + EOL;
                    } else if (typeof(variable) === 'number') {
                        out += 'number(' + variable + ')' + EOL;
                    } else if (typeof(variable) === 'boolean') {
                        out += 'bool(' + variable + ')' + EOL;
                    }
                },
                dumpVar = function(variable) {
                    var i;
                    if (variable === null) {
                        out += 'NULL' + EOL;
                    } else if (variable === undefined) {
                        out += 'undefined' + EOL;
                    } else if (typeof variable === 'object') {
                        out += indent(indentTimes) + typeof(variable);
                        indentTimes++;
                        out += '(' + (function(obj) {
                            var size = 0, key;
                            for (key in obj) {
                                if (obj.hasOwnProperty(key)) {
                                    size++;
                                }
                            }
                            return size;
                        })(variable) + ') {' + EOL;
                        for (i in variable) {
                            out += indent(indentTimes) + '[' + i + ']=> ' + EOL;
                            displayVar(variable[i]);
                        }
                        indentTimes--;
                        out += indent(indentTimes) + '}' + EOL;
                    } else {
                        displayVar(variable);
                    }
                };

            // handle no argument case by dumping the entire render context
            if (args.length == 0) args.push(this.context);

            Twig.forEach(args, function(variable) {
                dumpVar(variable);
            });

            return out;
        },
        date: function(date, time) {
            var dateObj;
            if (date === undefined) {
                dateObj = new Date();
            } else if (Twig.lib.is("Date", date)) {
                dateObj = date;
            } else if (Twig.lib.is("String", date)) {
                dateObj = new Date(Twig.lib.strtotime(date) * 1000);
            } else if (Twig.lib.is("Number", date)) {
                // timestamp
                dateObj = new Date(date * 1000);
            } else {
                throw new Twig.Error("Unable to parse date " + date);
            }
            return dateObj;
        },
        block: function(block) {
            if (this.originalBlockTokens[block]) {
                return Twig.logic.parse.apply(this, [this.originalBlockTokens[block], this.context]).output;
            } else {
                return this.blocks[block];
            }
        },
        parent: function() {
            // Add a placeholder
            return Twig.placeholders.parent;
        },
        attribute: function(object, method, params) {
            if (Twig.lib.is('Object', object)) {
                if (object.hasOwnProperty(method)) {
                    if (typeof object[method] === "function") {
                        return object[method].apply(undefined, params);
                    }
                    else {
                        return object[method];
                    }
                }
            }
            // Array will return element 0-index
            return object[method] || undefined;
        },
        template_from_string: function(template) {
            if (template === undefined) {
                template = '';
            }
            return new Twig.Template({
                options: this.options,
                data: template
            });
        },
        random: function(value) {
            var LIMIT_INT31 = 0x80000000;

            function getRandomNumber(n) {
                var random = Math.floor(Math.random() * LIMIT_INT31);
                var limits = [0, n];
                var min = Math.min.apply(null, limits),
                    max = Math.max.apply(null, limits);
                return min + Math.floor((max - min + 1) * random / LIMIT_INT31);
            }

            if(Twig.lib.is("Number", value)) {
                return getRandomNumber(value);
            }

            if(Twig.lib.is("String", value)) {
                return value.charAt(getRandomNumber(value.length-1));
            }

            if(Twig.lib.is("Array", value)) {
                return value[getRandomNumber(value.length-1)];
            }

            if(Twig.lib.is("Object", value)) {
                var keys = Object.keys(value);
                return value[keys[getRandomNumber(keys.length-1)]];
            }

            return getRandomNumber(LIMIT_INT31-1);
        }
    };

    Twig._function = function(_function, value, params) {
        if (!Twig.functions[_function]) {
            throw "Unable to find function " + _function;
        }
        return Twig.functions[_function](value, params);
    };

    Twig._function.extend = function(_function, definition) {
        Twig.functions[_function] = definition;
    };

    return Twig;

})(Twig || { });
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.tests.js
//
// This file handles expression tests. (is empty, is not defined, etc...)
var Twig = (function (Twig) {
    "use strict";
    Twig.tests = {
        empty: function(value) {
            if (value === null || value === undefined) return true;
            // Handler numbers
            if (typeof value === "number") return false; // numbers are never "empty"
            // Handle strings and arrays
            if (value.length && value.length > 0) return false;
            // Handle objects
            for (var key in value) {
                if (value.hasOwnProperty(key)) return false;
            }
            return true;
        },
        odd: function(value) {
            return value % 2 === 1;
        },
        even: function(value) {
            return value % 2 === 0;
        },
        divisibleby: function(value, params) {
            return value % params[0] === 0;
        },
        defined: function(value) {
            return value !== undefined;
        },
        none: function(value) {
            return value === null;
        },
        'null': function(value) {
            return this.none(value); // Alias of none
        },
        sameas: function(value, params) {
            return value === params[0];
        },
        iterable: function(value) {
            return value && (Twig.lib.is("Array", value) || Twig.lib.is("Object", value));
        },
        numeric: function(value) {
            if(typeof value === 'number'){
                return true;
            }
            return value.match(/^[0-9]+$/) != null;
        }
        /*
        constant ?
         */
    };

    Twig.test = function(test, value, params) {
        if (!Twig.tests[test]) {
            throw "Test " + test + " is not defined.";
        }
        return Twig.tests[test](value, params);
    };

    Twig.test.extend = function(test, definition) {
        Twig.tests[test] = definition;
    };

    return Twig;
})( Twig || { } );
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.exports.js
//
// This file provides extension points and other hooks into the twig functionality.

var Twig = (function (Twig) {
    "use strict";
    Twig.exports = {
        VERSION: Twig.VERSION
    };

    /**
     * Create and compile a twig.js template.
     *
     * @param {Object} param Paramteres for creating a Twig template.
     *
     * @return {Twig.Template} A Twig template ready for rendering.
     */
    Twig.exports.twig = function twig(params) {
        'use strict';
        var id = params.id,
            options = {
                strict_variables: params.strict_variables || false,
                // TODO: turn autoscape on in the next major version
                autoescape: params.autoescape != null && params.autoescape || false,
                allowInlineIncludes: params.allowInlineIncludes || false,
                rethrow: params.rethrow || false
            };

        if (id) {
            Twig.validateId(id);
        }

        if (params.debug !== undefined) {
            Twig.debug = params.debug;
        }
        if (params.trace !== undefined) {
            Twig.trace = params.trace;
        }

        if (params.data !== undefined) {
            return new Twig.Template({
                data: params.data,
                module: params.module,
                id:   id,
                options: options
            });

        } else if (params.ref !== undefined) {
            if (params.id !== undefined) {
                throw new Twig.Error("Both ref and id cannot be set on a twig.js template.");
            }
            return Twig.Templates.load(params.ref);

        } else if (params.href !== undefined) {
            return Twig.Templates.loadRemote(params.href, {
                id: id,
                method: 'ajax',
                base: params.base,
                module: params.module,
                precompiled: params.precompiled,
                async: params.async,
                options: options

            }, params.load, params.error);

        } else if (params.path !== undefined) {
            return Twig.Templates.loadRemote(params.path, {
                id: id,
                method: 'fs',
                base: params.base,
                module: params.module,
                precompiled: params.precompiled,
                async: params.async,
                options: options

            }, params.load, params.error);
        }
    };

    // Extend Twig with a new filter.
    Twig.exports.extendFilter = function(filter, definition) {
        Twig.filter.extend(filter, definition);
    };

    // Extend Twig with a new function.
    Twig.exports.extendFunction = function(fn, definition) {
        Twig._function.extend(fn, definition);
    };

    // Extend Twig with a new test.
    Twig.exports.extendTest = function(test, definition) {
        Twig.test.extend(test, definition);
    };

    // Extend Twig with a new definition.
    Twig.exports.extendTag = function(definition) {
        Twig.logic.extend(definition);
    };

    // Provide an environment for extending Twig core.
    // Calls fn with the internal Twig object.
    Twig.exports.extend = function(fn) {
        fn(Twig);
    };


    /**
     * Provide an extension for use with express 2.
     *
     * @param {string} markup The template markup.
     * @param {array} options The express options.
     *
     * @return {string} The rendered template.
     */
    Twig.exports.compile = function(markup, options) {
        var id = options.filename,
            path = options.filename,
            template;

        // Try to load the template from the cache
        template = new Twig.Template({
            data: markup,
            path: path,
            id: id,
            options: options.settings['twig options']
        }); // Twig.Templates.load(id) ||

        return function(context) {
            return template.render(context);
        };
    };

    /**
     * Provide an extension for use with express 3.
     *
     * @param {string} path The location of the template file on disk.
     * @param {Object|Function} The options or callback.
     * @param {Function} fn callback.
     */

    Twig.exports.renderFile = function(path, options, fn) {
        // handle callback in options
        if ('function' == typeof options) {
            fn = options;
            options = {};
        }

        options = options || {};

        var params = {
                path: path,
                base: options.settings['views'],
                load: function(template) {
                    // render and return template
                    fn(null, template.render(options));
                }
            };

        // mixin any options provided to the express app.
        var view_options = options.settings['twig options'];

        if (view_options) {
            for (var option in view_options) if (view_options.hasOwnProperty(option)) {
                params[option] = view_options[option];
            }
        }

        Twig.exports.twig(params);
    };

    // Express 3 handler
    Twig.exports.__express = Twig.exports.renderFile;

    /**
     * Shoud Twig.js cache templates.
     * Disable during development to see changes to templates without
     * reloading, and disable in production to improve performance.
     *
     * @param {boolean} cache
     */
    Twig.exports.cache = function(cache) {
        Twig.cache = cache;
    }

    return Twig;
}) (Twig || { });

//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.compiler.js
//
// This file handles compiling templates into JS
var Twig = (function (Twig) {
    /**
     * Namespace for compilation.
     */
    Twig.compiler = {
        module: {}
    };

    // Compile a Twig Template to output.
    Twig.compiler.compile = function(template, options) {
        // Get tokens
        var tokens = JSON.stringify(template.tokens)
            , id = template.id
            , output;

        if (options.module) {
            if (Twig.compiler.module[options.module] === undefined) {
                throw new Twig.Error("Unable to find module type " + options.module);
            }
            output = Twig.compiler.module[options.module](id, tokens, options.twig);
        } else {
            output = Twig.compiler.wrap(id, tokens);
        }
        return output;
    };

    Twig.compiler.module = {
        amd: function(id, tokens, pathToTwig) {
            return 'define(["' + pathToTwig + '"], function (Twig) {\n\tvar twig, templates;\ntwig = Twig.twig;\ntemplates = ' + Twig.compiler.wrap(id, tokens) + '\n\treturn templates;\n});';
        }
        , node: function(id, tokens) {
            return 'var twig = require("twig").twig;\n'
                + 'exports.template = ' + Twig.compiler.wrap(id, tokens)
        }
        , cjs2: function(id, tokens, pathToTwig) {
            return 'module.declare([{ twig: "' + pathToTwig + '" }], function (require, exports, module) {\n'
                        + '\tvar twig = require("twig").twig;\n'
                        + '\texports.template = ' + Twig.compiler.wrap(id, tokens)
                    + '\n});'
        }
    };

    Twig.compiler.wrap = function(id, tokens) {
        return 'twig({id:"'+id.replace('"', '\\"')+'", data:'+tokens+', precompiled: true});\n';
    };

    return Twig;
})(Twig || {});
//     Twig.js
//     Available under the BSD 2-Clause License
//     https://github.com/justjohn/twig.js

// ## twig.module.js
// Provide a CommonJS/AMD/Node module export.

if (typeof module !== 'undefined' && module.declare) {
    // Provide a CommonJS Modules/2.0 draft 8 module
    module.declare([], function(require, exports, module) {
        // Add exports from the Twig exports
        for (key in Twig.exports) {
            if (Twig.exports.hasOwnProperty(key)) {
                exports[key] = Twig.exports[key];
            }
        }
    });
} else if (typeof define == 'function' && define.amd) {
    define(function() {
        return Twig.exports;
    });
} else if (typeof module !== 'undefined' && module.exports) {
    // Provide a CommonJS Modules/1.1 module
    module.exports = Twig.exports;
} else {
    // Export for browser use
    window.twig = Twig.exports.twig;
    window.Twig = Twig.exports;
}

; /** ----------------- **/ 
 /**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/**
 * Owl carousel
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
;(function($, window, document, undefined) {

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Proxied event handlers.
		 * @protected
		 */
		this._handlers = {};

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from being retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Widths of all items.
		 */
		this._widths = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		/**
		 * Current state information for the drag operation.
		 * @todo #261
		 * @protected
		 */
		this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {
				start: null,
				current: null
			},
			direction: null
		};

		/**
		 * Current state information and their tags.
		 * @type {Object}
		 * @protected
		 */
		this._states = {
			current: {},
			tags: {
				'initializing': [ 'busy' ],
				'animating': [ 'busy' ],
				'dragging': [ 'interacting' ]
			}
		};

		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
			this._handlers[handler] = $.proxy(this[handler], this);
		}, this));

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Workers, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,
		rewind: false,
		checkVisibility: true,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,

		fallbackEasing: 'swing',
		slideTransition: '',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		refreshClass: 'owl-refresh',
		loadedClass: 'owl-loaded',
		loadingClass: 'owl-loading',
		rtlClass: 'owl-rtl',
		responsiveClass: 'owl-responsive',
		dragClass: 'owl-drag',
		itemClass: 'owl-item',
		stageClass: 'owl-stage',
		stageOuterClass: 'owl-stage-outer',
		grabClass: 'owl-grab'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Enumeration for types.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Type = {
		Event: 'event',
		State: 'state'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * List of workers involved in the update process.
	 */
	Owl.Workers = [ {
		filter: [ 'width', 'settings' ],
		run: function() {
			this._width = this.$element.width();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			this.$stage.children('.cloned').remove();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var margin = this.settings.margin || '',
				grid = !this.settings.autoWidth,
				rtl = this.settings.rtl,
				css = {
					'width': 'auto',
					'margin-left': rtl ? margin : '',
					'margin-right': rtl ? '' : margin
				};

			!grid && this.$stage.children().css(css);

			cache.css = css;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
				merge = null,
				iterator = this._items.length,
				grid = !this.settings.autoWidth,
				widths = [];

			cache.items = {
				merge: false,
				width: width
			};

			while (iterator--) {
				merge = this._mergers[iterator];
				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

				cache.items.merge = merge > 1 || cache.items.merge;

				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
			}

			this._widths = widths;
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var clones = [],
				items = this._items,
				settings = this.settings,
				// TODO: Should be computed from number of min width items in stage
				view = Math.max(settings.items * 2, 4),
				size = Math.ceil(items.length / 2) * 2,
				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
				append = '',
				prepend = '';

			repeat /= 2;

			while (repeat > 0) {
				// Switch to only using appended clones
				clones.push(this.normalize(clones.length / 2, true));
				append = append + items[clones[clones.length - 1]][0].outerHTML;
				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
				repeat -= 1;
			}

			this._clones = clones;

			$(append).addClass('cloned').appendTo(this.$stage);
			$(prepend).addClass('cloned').prependTo(this.$stage);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				size = this._clones.length + this._items.length,
				iterator = -1,
				previous = 0,
				current = 0,
				coordinates = [];

			while (++iterator < size) {
				previous = coordinates[iterator - 1] || 0;
				current = this._widths[this.relative(iterator)] + this.settings.margin;
				coordinates.push(previous + current * rtl);
			}

			this._coordinates = coordinates;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var padding = this.settings.stagePadding,
				coordinates = this._coordinates,
				css = {
					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
					'padding-left': padding || '',
					'padding-right': padding || ''
				};

			this.$stage.css(css);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var iterator = this._coordinates.length,
				grid = !this.settings.autoWidth,
				items = this.$stage.children();

			if (grid && cache.items.merge) {
				while (iterator--) {
					cache.css.width = this._widths[this.relative(iterator)];
					items.eq(iterator).css(cache.css);
				}
			} else if (grid) {
				cache.css.width = cache.items.width;
				items.css(cache.css);
			}
		}
	}, {
		filter: [ 'items' ],
		run: function() {
			this._coordinates.length < 1 && this.$stage.removeAttr('style');
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
			this.reset(cache.current);
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.active').removeClass('active');
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

			this.$stage.children('.center').removeClass('center');
			if (this.settings.center) {
				this.$stage.children().eq(this.current()).addClass('center');
			}
		}
	} ];

	/**
	 * Create the stage DOM element
	 */
	Owl.prototype.initializeStage = function() {
		this.$stage = this.$element.find('.' + this.settings.stageClass);

		// if the stage is already in the DOM, grab it and skip stage initialization
		if (this.$stage.length) {
			return;
		}

		this.$element.addClass(this.options.loadingClass);

		// create stage
		this.$stage = $('<' + this.settings.stageElement + '>', {
			"class": this.settings.stageClass
		}).wrap( $( '<div/>', {
			"class": this.settings.stageOuterClass
		}));

		// append stage
		this.$element.append(this.$stage.parent());
	};

	/**
	 * Create item DOM elements
	 */
	Owl.prototype.initializeItems = function() {
		var $items = this.$element.find('.owl-item');

		// if the items are already in the DOM, grab them and skip item initialization
		if ($items.length) {
			this._items = $items.get().map(function(item) {
				return $(item);
			});

			this._mergers = this._items.map(function() {
				return 1;
			});

			this.refresh();

			return;
		}

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// check visibility
		if (this.isVisible()) {
			// update view
			this.refresh();
		} else {
			// invalidate width
			this.invalidate('width');
		}

		this.$element
			.removeClass(this.options.loadingClass)
			.addClass(this.options.loadedClass);
	};

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.enter('initializing');
		this.trigger('initialize');

		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

		if (this.settings.autoWidth && !this.is('pre-loading')) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
			}
		}

		this.initializeStage();
		this.initializeItems();

		// register event handlers
		this.registerEventHandlers();

		this.leave('initializing');
		this.trigger('initialized');
	};

	/**
	 * @returns {Boolean} visibility of $element
	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
	 */
	Owl.prototype.isVisible = function() {
		return this.settings.checkVisibility
			? this.$element.is(':visible')
			: true;
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			if (typeof settings.stagePadding === 'function') {
				settings.stagePadding = settings.stagePadding();
			}
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class',
					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
				);
			}
		}

		this.trigger('change', { property: { name: 'settings', value: settings } });
		this._breakpoint = match;
		this.settings = settings;
		this.invalidate('settings');
		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.options.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};

		!this.is('valid') && this.enter('valid');
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		this.enter('refreshing');
		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		this.$element.addClass(this.options.refreshClass);

		this.update();

		this.$element.removeClass(this.options.refreshClass);

		this.leave('refreshing');
		this.trigger('refreshed');
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (!this.isVisible()) {
			return false;
		}

		this.enter('resizing');

		if (this.trigger('resize').isDefaultPrevented()) {
			this.leave('resizing');
			return false;
		}

		this.invalidate('width');

		this.refresh();

		this.leave('resizing');
		this.trigger('resized');
	};

	/**
	 * Registers event handlers.
	 * @todo Check `msPointerEnabled`
	 * @todo #261
	 * @protected
	 */
	Owl.prototype.registerEventHandlers = function() {
		if ($.support.transition) {
			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
		}

		if (this.settings.responsive !== false) {
			this.on(window, 'resize', this._handlers.onThrottledResize);
		}

		if (this.settings.mouseDrag) {
			this.$element.addClass(this.options.dragClass);
			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
		}

		if (this.settings.touchDrag){
			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
		}
	};

	/**
	 * Handles `touchstart` and `mousedown` events.
	 * @todo Horizontal swipe threshold as option
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var stage = null;

		if (event.which === 3) {
			return;
		}

		if ($.support.transform) {
			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
			stage = {
				x: stage[stage.length === 16 ? 12 : 4],
				y: stage[stage.length === 16 ? 13 : 5]
			};
		} else {
			stage = this.$stage.position();
			stage = {
				x: this.settings.rtl ?
					stage.left + this.$stage.width() - this.width() + this.settings.margin :
					stage.left,
				y: stage.top
			};
		}

		if (this.is('animating')) {
			$.support.transform ? this.animate(stage.x) : this.$stage.stop()
			this.invalidate('position');
		}

		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

		this.speed(0);

		this._drag.time = new Date().getTime();
		this._drag.target = $(event.target);
		this._drag.stage.start = stage;
		this._drag.stage.current = stage;
		this._drag.pointer = this.pointer(event);

		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event));

			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
				return;
			}

			event.preventDefault();

			this.enter('dragging');
			this.trigger('drag');
		}, this));
	};

	/**
	 * Handles the `touchmove` and `mousemove` events.
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var minimum = null,
			maximum = null,
			pull = null,
			delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this.difference(this._drag.stage.start, delta);

		if (!this.is('dragging')) {
			return;
		}

		event.preventDefault();

		if (this.settings.loop) {
			minimum = this.coordinates(this.minimum());
			maximum = this.coordinates(this.maximum() + 1) - minimum;
			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
		} else {
			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
		}

		this._drag.stage.current = stage;

		this.animate(stage.x);
	};

	/**
	 * Handles the `touchend` and `mouseup` events.
	 * @todo #261
	 * @todo Threshold for click event
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragEnd = function(event) {
		var delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this._drag.stage.current,
			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

		$(document).off('.owl.core');

		this.$element.removeClass(this.options.grabClass);

		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
			this.invalidate('position');
			this.update();

			this._drag.direction = direction;

			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
				this._drag.target.one('click.owl.core', function() { return false; });
			}
		}

		if (!this.is('dragging')) {
			return;
		}

		this.leave('dragging');
		this.trigger('dragged');
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate, direction) {
		var position = -1,
			pull = 30,
			width = this.width(),
			coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				// on a left pull, check on current index
				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
					position = index;
				// on a right pull, check on previous index
				// to do so, subtract width from value and set position = index + 1
				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
					position = index + 1;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
					position = direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @todo #270
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		var animate = this.speed() > 0;

		this.is('animating') && this.onTransitionEnd();

		if (animate) {
			this.enter('animating');
			this.trigger('translate');
		}

		if ($.support.transform3d && $.support.transition) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
				transition: (this.speed() / 1000) + 's' + (
					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
				)
			});
		} else if (animate) {
			this.$stage.animate({
				left: coordinate + 'px'
			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
		} else {
			this.$stage.css({
				left: coordinate + 'px'
			});
		}
	};

	/**
	 * Checks whether the carousel is in a specific state or not.
	 * @param {String} state - The state to check.
	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	 */
	Owl.prototype.is = function(state) {
		return this._states.current[state] && this._states.current[state] > 0;
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} [part] - The part to invalidate.
	 * @returns {Array.<String>} - The invalidated parts.
	 */
	Owl.prototype.invalidate = function(part) {
		if ($.type(part) === 'string') {
			this._invalidated[part] = true;
			this.is('valid') && this.leave('valid');
		}
		return $.map(this._invalidated, function(v, i) { return i });
	};

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position of an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = this._items.length,
			m = relative ? 0 : this._clones.length;

		if (!this.isNumeric(position) || n < 1) {
			position = undefined;
		} else if (position < 0 || position >= n + m) {
			position = ((position - m / 2) % n + n) % n + m / 2;
		}

		return position;
	};

	/**
	 * Converts an absolute position of an item into a relative one.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position -= this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var settings = this.settings,
			maximum = this._coordinates.length,
			iterator,
			reciprocalItemsWidth,
			elementWidth;

		if (settings.loop) {
			maximum = this._clones.length / 2 + this._items.length - 1;
		} else if (settings.autoWidth || settings.merge) {
			iterator = this._items.length;
			if (iterator) {
				reciprocalItemsWidth = this._items[--iterator].width();
				elementWidth = this.$element.width();
				while (iterator--) {
					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
					if (reciprocalItemsWidth > elementWidth) {
						break;
					}
				}
			}
			maximum = iterator + 1;
		} else if (settings.center) {
			maximum = this._items.length - 1;
		} else {
			maximum = this._items.length - settings.items;
		}

		if (relative) {
			maximum -= this._clones.length / 2;
		}

		return Math.max(maximum, 0);
	};

	/**
	 * Gets the minimum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		return relative ? 0 : this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var multiplier = 1,
			newPosition = position - 1,
			coordinate;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			if (this.settings.rtl) {
				multiplier = -1;
				newPosition = position + 1;
			}

			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
		} else {
			coordinate = this._coordinates[newPosition] || 0;
		}

		coordinate = Math.ceil(coordinate);

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}

		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		var current = this.current(),
			revert = null,
			distance = position - this.relative(current),
			direction = (distance > 0) - (distance < 0),
			items = this._items.length,
			minimum = this.minimum(),
			maximum = this.maximum();

		if (this.settings.loop) {
			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
				distance += direction * -1 * items;
			}

			position = current + distance;
			revert = ((position - minimum) % items + items) % items + minimum;

			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
				current = revert - distance;
				position = revert;
				this.reset(current);
			}
		} else if (this.settings.rewind) {
			maximum += 1;
			position = (position % maximum + maximum) % maximum;
		} else {
			position = Math.max(minimum, Math.min(maximum, position));
		}

		this.speed(this.duration(current, position, speed));
		this.current(position);

		if (this.isVisible()) {
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onTransitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.leave('animating');
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			console.warn('Can not detect viewport width.');
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		var current = this.relative(this._current);

		position = position === undefined ? this._items.length : this.normalize(position, true);
		content = content instanceof jQuery ? content : $(content);

		this.trigger('add', { content: content, position: position });

		content = this.prepare(content);

		if (this._items.length === 0 || position === this._items.length) {
			this._items.length === 0 && this.$stage.append(content);
			this._items.length !== 0 && this._items[position - 1].after(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this._items[current] && this.reset(this._items[current].index());

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Preloads images with auto width.
	 * @todo Replace by a more generic approach
	 * @protected
	 */
	Owl.prototype.preloadAutoWidthImages = function(images) {
		images.each($.proxy(function(i, element) {
			this.enter('pre-loading');
			element = $(element);
			$(new Image()).one('load', $.proxy(function(e) {
				element.attr('src', e.target.src);
				element.css('opacity', 1);
				this.leave('pre-loading');
				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
		}, this));
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		this.$element.off('.owl.core');
		this.$stage.off('.owl.core');
		$(document).off('.owl.core');

		if (this.settings.responsive !== false) {
			window.clearTimeout(this.resizeTimer);
			this.off(window, 'resize', this._handlers.onThrottledResize);
		}

		for (var i in this._plugins) {
			this._plugins[i].destroy();
		}

		this.$stage.children('.cloned').remove();

		this.$stage.unwrap();
		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();
		this.$stage.remove();
		this.$element
			.removeClass(this.options.refreshClass)
			.removeClass(this.options.loadingClass)
			.removeClass(this.options.loadedClass)
			.removeClass(this.options.rtlClass)
			.removeClass(this.options.dragClass)
			.removeClass(this.options.grabClass)
			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
			.removeData('owl.carousel');
		this._items = [];
		this._clones = [];
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers a public event.
	 * @todo Remove `status`, `relatedTarget` should be used instead.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=carousel] - The event namespace.
	 * @param {String} [state] - The state which is associated with the event.
	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.register({ type: Owl.Type.Event, name: name });
			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].call(this, event);
			}
		}

		return event;
	};

	/**
	 * Enters a state.
	 * @param name - The state name.
	 */
	Owl.prototype.enter = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			if (this._states.current[name] === undefined) {
				this._states.current[name] = 0;
			}

			this._states.current[name]++;
		}, this));
	};

	/**
	 * Leaves a state.
	 * @param name - The state name.
	 */
	Owl.prototype.leave = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			this._states.current[name]--;
		}, this));
	};

	/**
	 * Registers an event or state.
	 * @public
	 * @param {Object} object - The event or state to register.
	 */
	Owl.prototype.register = function(object) {
		if (object.type === Owl.Type.Event) {
			if (!$.event.special[object.name]) {
				$.event.special[object.name] = {};
			}

			if (!$.event.special[object.name].owl) {
				var _default = $.event.special[object.name]._default;
				$.event.special[object.name]._default = function(e) {
					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
						return _default.apply(this, arguments);
					}
					return e.namespace && e.namespace.indexOf('owl') > -1;
				};
				$.event.special[object.name].owl = true;
			}
		} else if (object.type === Owl.Type.State) {
			if (!this._states.tags[object.name]) {
				this._states.tags[object.name] = object.tags;
			} else {
				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
			}

			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
				return $.inArray(tag, this._states.tags[object.name]) === i;
			}, this));
		}
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	};

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	};

	/**
	 * Gets unified pointer coordinates from event.
	 * @todo #261
	 * @protected
	 * @param {Event} - The `mousedown` or `touchstart` event.
	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	 */
	Owl.prototype.pointer = function(event) {
		var result = { x: null, y: null };

		event = event.originalEvent || event || window.event;

		event = event.touches && event.touches.length ?
			event.touches[0] : event.changedTouches && event.changedTouches.length ?
				event.changedTouches[0] : event;

		if (event.pageX) {
			result.x = event.pageX;
			result.y = event.pageY;
		} else {
			result.x = event.clientX;
			result.y = event.clientY;
		}

		return result;
	};

	/**
	 * Determines if the input is a Number or something that can be coerced to a Number
	 * @protected
	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	 */
	Owl.prototype.isNumeric = function(number) {
		return !isNaN(parseFloat(number));
	};

	/**
	 * Gets the difference of two vectors.
	 * @todo #261
	 * @protected
	 * @param {Object} - The first vector.
	 * @param {Object} - The second vector.
	 * @returns {Object} - The difference.
	 */
	Owl.prototype.difference = function(first, second) {
		return {
			x: first.x - second.x,
			y: first.y - second.y
		};
	};

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @todo Navigation plugin `next` and `prev`
	 * @public
	 */
	$.fn.owlCarousel = function(option) {
		var args = Array.prototype.slice.call(arguments, 1);

		return this.each(function() {
			var $this = $(this),
				data = $this.data('owl.carousel');

			if (!data) {
				data = new Owl(this, typeof option == 'object' && option);
				$this.data('owl.carousel', data);

				$.each([
					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
				], function(i, event) {
					data.register({ type: Owl.Type.Event, name: event });
					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
						if (e.namespace && e.relatedTarget !== this) {
							this.suppress([ event ]);
							data[event].apply(this, [].slice.call(arguments, 1));
							this.release([ event ]);
						}
					}, data));
				});
			}

			if (typeof option == 'string' && option.charAt(0) !== '_') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || window.jQuery, window, document);

/**
 * AutoRefresh Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto refresh plugin.
	 * @class The Auto Refresh Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoRefresh = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Refresh interval.
		 * @protected
		 * @type {number}
		 */
		this._interval = null;

		/**
		 * Whether the element is currently visible or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._visible = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoRefresh) {
					this.watch();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoRefresh.Defaults = {
		autoRefresh: true,
		autoRefreshInterval: 500
	};

	/**
	 * Watches the element.
	 */
	AutoRefresh.prototype.watch = function() {
		if (this._interval) {
			return;
		}

		this._visible = this._core.isVisible();
		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	};

	/**
	 * Refreshes the element.
	 */
	AutoRefresh.prototype.refresh = function() {
		if (this._core.isVisible() === this._visible) {
			return;
		}

		this._visible = !this._visible;

		this._core.$element.toggleClass('owl-hidden', !this._visible);

		this._visible && (this._core.invalidate('width') && this._core.refresh());
	};

	/**
	 * Destroys the plugin.
	 */
	AutoRefresh.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this._interval);

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

})(window.Zepto || window.jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);
					//TODO: Need documentation for this new option
					if (settings.lazyLoadEager > 0) {
						n += settings.lazyLoadEager;
						// If the carousel is looping also preload images that are to the "left"
						if (settings.loop) {
              position -= settings.lazyLoadEager;
              n++;
            }
					}

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position)), load);
						position++;
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false,
		lazyLoadEager: 0
	};

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
            } else if ($element.is('source')) {
                $element.one('load.owl.lazy', $.proxy(function() {
                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
                }, this)).attr('srcset', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url("' + url + '")',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || window.jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		this._previousHeight = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
		this._intervalId = null;
		var refThis = this;

		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
		// and have been made compatible with the latest jQuery version
		if(this._core.options.autoHeight) {
			$(window).on('load', function() {
				if (refThis._core.settings.autoHeight) {
					refThis.update();
				}
			});
		}

		// Autoresize the height of the carousel when window is resized
		// When carousel has images, the height is dependent on the width
		// and should also change on resize
		if(this._core.options.autoHeight) {
			$(window).resize(function() {
				if (refThis._core.settings.autoHeight) {
					if (refThis._intervalId != null) {
						clearTimeout(refThis._intervalId);
					}

					refThis._intervalId = setTimeout(function() {
						refThis.update();
					}, 250);
				}
			});
		}

	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			lazyLoadEnabled = this._core.settings.lazyLoad,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
			maxheight = this._previousHeight;
		}

		this._previousHeight = maxheight;

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] !== 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || window.jQuery, window, document);

/**
 * Video Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * All event handlers.
		 * @todo The cloned content removale is too late
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
				}
			}, this),
			'resize.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.is('resizing')) {
					this._core.$stage.find('.cloned .owl-video-frame').remove();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position' && this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				var $element = $(e.content).find('.owl-video');

				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {
			var type = (function() {
					if (target.attr('data-vimeo-id')) {
						return 'vimeo';
					} else if (target.attr('data-vzaar-id')) {
						return 'vzaar'
					} else {
						return 'youtube';
					}
				})(),
				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
				width = target.attr('data-width') || this._core.settings.videoWidth,
				height = target.attr('data-height') || this._core.settings.videoHeight,
				url = target.attr('href');

		if (url) {

			/*
					Parses the id's out of the following urls (and probably more):
					https://www.youtube.com/watch?v=:id
					https://youtu.be/:id
					https://vimeo.com/:id
					https://vimeo.com/channels/:channel/:id
					https://vimeo.com/groups/:group/videos/:id
					https://app.vzaar.com/videos/:id

					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
			*/

			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else if (id[3].indexOf('vzaar') > -1) {
				type = 'vzaar';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {
		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = $('<div/>',{
						"class": 'owl-video-tn ' + lazyClass,
						"srcType": path
					});
				} else {
					tnLink = $( '<div/>', {
						"class": "owl-video-tn",
						"style": 'opacity:1;background-image:url(' + path + ')'
					});
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap( $( '<div/>', {
			"class": "owl-video-wrapper",
			"style": dimensions
		}));

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		} else if (video.type === 'vzaar') {
			$.ajax({
				type: 'GET',
				url: '//vzaar.com/api/videos/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data.framegrab_url;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
		this._core.leave('playing');
		this._core.trigger('stopped', null, 'video');
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} event - The event arguments.
	 */
	Video.prototype.play = function(event) {
		var target = $(event.target),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html,
			iframe;

		if (this._playing) {
			return;
		}

		this._core.enter('playing');
		this._core.trigger('play', null, 'video');

		item = this._core.items(this._core.relative(item.index()));

		this._core.reset(item.index());

		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
		html.attr( 'height', height );
		html.attr( 'width', width );
		if (video.type === 'youtube') {
			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
		} else if (video.type === 'vimeo') {
			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
		} else if (video.type === 'vzaar') {
			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
		}

		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));

		this._playing = item.addClass('owl-video-playing');
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {
		var element = document.fullscreenElement || document.mozFullScreenElement ||
				document.webkitFullscreenElement;

		return element && $(element).parent().hasClass('owl-video-frame');
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || window.jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this.swapping = e.type == 'translated';
				}
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1) {
			return;
		}

		if (!$.support.animation || !$.support.transition) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.one($.support.animation.end, clear)
				.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing);
		}

		if (incoming) {
			next.one($.support.animation.end, clear)
				.addClass('animated owl-animated-in')
				.addClass(incoming);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.onTransitionEnd();
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || window.jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author Artus Kolanowski
 * @author David Deutsch
 * @author Tom De Caluwé
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * The autoplay timeout id.
		 * @type {Number}
		 */
		this._call = null;

		/**
		 * Depending on the state of the plugin, this variable contains either
		 * the start time of the timer or the current timer value if it's
		 * paused. Since we start in a paused state we initialize the timer
		 * value.
		 * @type {Number}
		 */
		this._time = 0;

		/**
		 * Stores the timeout currently used.
		 * @type {Number}
		 */
		this._timeout = 0;

		/**
		 * Indicates whenever the autoplay is paused.
		 * @type {Boolean}
		 */
		this._paused = true;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'settings') {
					if (this._core.settings.autoplay) {
						this.play();
					} else {
						this.stop();
					}
				} else if (e.namespace && e.property.name === 'position' && this._paused) {
					// Reset the timer. This code is triggered when the position
					// of the carousel was changed through user interaction.
					this._time = 0;
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoplay) {
					this.play();
				}
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				if (e.namespace) {
					this.play(t, s);
				}
			}, this),
			'stop.owl.autoplay': $.proxy(function(e) {
				if (e.namespace) {
					this.stop();
				}
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.play();
				}
			}, this),
			'touchstart.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'touchend.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause) {
					this.play();
				}
			}, this)
		};

		// register event handlers
		this._core.$element.on(this._handlers);

		// set default options
		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * Transition to the next slide and set a timeout for the next transition.
	 * @private
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype._next = function(speed) {
		this._call = window.setTimeout(
			$.proxy(this._next, this, speed),
			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
		);

		if (this._core.is('interacting') || document.hidden) {
			return;
		}
		this._core.next(speed || this._core.settings.autoplaySpeed);
	}

	/**
	 * Reads the current timer value when the timer is playing.
	 * @public
	 */
	Autoplay.prototype.read = function() {
		return new Date().getTime() - this._time;
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		var elapsed;

		if (!this._core.is('rotating')) {
			this._core.enter('rotating');
		}

		timeout = timeout || this._core.settings.autoplayTimeout;

		// Calculate the elapsed time since the last transition. If the carousel
		// wasn't playing this calculation will yield zero.
		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);

		if (this._paused) {
			// Start the clock.
			this._time = this.read();
			this._paused = false;
		} else {
			// Clear the active timeout to allow replacement.
			window.clearTimeout(this._call);
		}

		// Adjust the origin of the timer to match the new timeout value.
		this._time += this.read() % timeout - elapsed;

		this._timeout = timeout;
		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		if (this._core.is('rotating')) {
			// Reset the clock.
			this._time = 0;
			this._paused = true;

			window.clearTimeout(this._call);
			this._core.leave('rotating');
		}
	};

	/**
	 * Pauses the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		if (this._core.is('rotating') && !this._paused) {
			// Pause the clock.
			this._time = this.read();
			this._paused = true;

			window.clearTimeout(this._call);
		}
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		this.stop();

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || window.jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
				}
			}, this),
			'added.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, this._templates.pop());
				}
			}, this),
			'remove.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && !this._initialized) {
					this._core.trigger('initialize', null, 'navigation');
					this.initialize();
					this.update();
					this.draw();
					this._initialized = true;
					this._core.trigger('initialized', null, 'navigation');
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._initialized) {
					this._core.trigger('refresh', null, 'navigation');
					this.update();
					this.draw();
					this._core.trigger('refreshed', null, 'navigation');
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navText: [
			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
		],
		navSpeed: false,
		navElement: 'button type="button" role="presentation"',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [
			'owl-prev',
			'owl-next'
		],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotsData: false,
		dotsSpeed: false,
		dotsContainer: false
	};

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var override,
			settings = this._core.settings;

		// create DOM structure for relative navigation
		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$previous = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[0])
			.html(settings.navText[0])
			.prependTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.prev(settings.navSpeed);
			}, this));
		this._controls.$next = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[1])
			.html(settings.navText[1])
			.appendTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.next(settings.navSpeed);
			}, this));

		// create DOM structure for absolute navigation
		if (!settings.dotsData) {
			this._templates = [ $('<button role="button">')
				.addClass(settings.dotClass)
				.append($('<span>'))
				.prop('outerHTML') ];
		}

		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$absolute)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, settings.dotsSpeed);
		}, this));

		/*$el.on('focusin', function() {
			$(document).off(".carousel");

			$(document).on('keydown.carousel', function(e) {
				if(e.keyCode == 37) {
					$el.trigger('prev.owl')
				}
				if(e.keyCode == 39) {
					$el.trigger('next.owl')
				}
			});
		});*/

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	};

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override, settings;
		settings = this._core.settings;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			if (control === '$relative' && settings.navContainer) {
				this._controls[control].html('');
			} else {
				this._controls[control].remove();
			}
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			maximum = this._core.maximum(true),
			settings = this._core.settings,
			size = settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items;

		if (settings.slideBy !== 'page') {
			settings.slideBy = Math.min(settings.slideBy, settings.items);
		}

		if (settings.dots || settings.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: Math.min(maximum, i - lower),
						end: i - lower + size - 1
					});
					if (Math.min(maximum, i - lower) === maximum) {
						break;
					}
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	};

	/**
	 * Draws the user interface.
	 * @todo The option `dotsData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference,
			settings = this._core.settings,
			disabled = this._core.items().length <= settings.items,
			index = this._core.relative(this._core.current()),
			loop = settings.loop || settings.rewind;

		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

		if (settings.nav) {
			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
		}

		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

		if (settings.dots) {
			difference = this._pages.length - this._controls.$absolute.children().length;

			if (settings.dotsData && difference !== 0) {
				this._controls.$absolute.html(this._templates.join(''));
			} else if (difference > 0) {
				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
			} else if (difference < 0) {
				this._controls.$absolute.children().slice(difference).remove();
			}

			this._controls.$absolute.find('.active').removeClass('active');
			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}
	};

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items)
		};
	};

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var current = this._core.relative(this._core.current());
		return $.grep(this._pages, $.proxy(function(page, index) {
			return page.start <= current && page.end >= current;
		}, this)).pop();
	};

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			settings = this._core.settings;

		if (settings.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += settings.slideBy : position -= settings.slideBy;
		}

		return position;
	};

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	};

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	};

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard && this._pages.length) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || window.jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash index for the items.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

					if (!hash) {
						return;
					}

					this._hashes[hash] = e.content;
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position') {
					var current = this._core.items(this._core.relative(this._core.current())),
						hash = $.map(this._hashes, function(item, hash) {
							return item === current ? hash : null;
						}).join();

					if (!hash || window.location.hash.slice(1) === hash) {
						return;
					}

					window.location.hash = hash;
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]);

			if (position === undefined || position === this._core.current()) {
				return;
			}

			this._core.to(this._core.relative(position), false, true);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || window.jQuery, window, document);

/**
 * Support Plugin
 *
 * @version 2.3.4
 * @author Vivid Planet Software GmbH
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	var style = $('<support>').get(0).style,
		prefixes = 'Webkit Moz O ms'.split(' '),
		events = {
			transition: {
				end: {
					WebkitTransition: 'webkitTransitionEnd',
					MozTransition: 'transitionend',
					OTransition: 'oTransitionEnd',
					transition: 'transitionend'
				}
			},
			animation: {
				end: {
					WebkitAnimation: 'webkitAnimationEnd',
					MozAnimation: 'animationend',
					OAnimation: 'oAnimationEnd',
					animation: 'animationend'
				}
			}
		},
		tests = {
			csstransforms: function() {
				return !!test('transform');
			},
			csstransforms3d: function() {
				return !!test('perspective');
			},
			csstransitions: function() {
				return !!test('transition');
			},
			cssanimations: function() {
				return !!test('animation');
			}
		};

	function test(property, prefixed) {
		var result = false,
			upper = property.charAt(0).toUpperCase() + property.slice(1);

		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
			if (style[property] !== undefined) {
				result = prefixed ? property : true;
				return false;
			}
		});

		return result;
	}

	function prefixed(property) {
		return test(property, true);
	}

	if (tests.csstransitions()) {
		/* jshint -W053 */
		$.support.transition = new String(prefixed('transition'))
		$.support.transition.end = events.transition.end[ $.support.transition ];
	}

	if (tests.cssanimations()) {
		/* jshint -W053 */
		$.support.animation = new String(prefixed('animation'))
		$.support.animation.end = events.animation.end[ $.support.animation ];
	}

	if (tests.csstransforms()) {
		/* jshint -W053 */
		$.support.transform = new String(prefixed('transform'));
		$.support.transform3d = tests.csstransforms3d();
	}

})(window.Zepto || window.jQuery, window, document);
; /** ----------------- **/ 
 /*! Idle.Js, copyright 2017-08-02, Shawn Mclean*/
(function(){var a;document.addEventListener||(document.attachEvent?document.addEventListener=function(a,b,c){return document.attachEvent("on"+a,b,c)}:document.addEventListener=function(){return{}}),document.removeEventListener||(document.detachEvent?document.removeEventListener=function(a,b){return document.detachEvent("on"+a,b)}:document.removeEventListener=function(){return{}}),a={},a=function(){function a(a){var b,c;a&&(this.awayTimeout=parseInt(a.awayTimeout,10),this.onAway=a.onAway,this.onAwayBack=a.onAwayBack,this.onVisible=a.onVisible,this.onHidden=a.onHidden),c=this,b=function(){return c.onActive()},window.addEventListener("click",b),window.addEventListener("mousemove",b),window.addEventListener("mouseenter",b),window.addEventListener("keydown",b),window.addEventListener("scroll",b),window.addEventListener("mousewheel",b),window.addEventListener("touchmove",b),window.addEventListener("touchstart",b)}return a.isAway=!1,a.awayTimeout=3e3,a.awayTimestamp=0,a.awayTimer=null,a.onAway=null,a.onAwayBack=null,a.onVisible=null,a.onHidden=null,a.prototype.onActive=function(){return this.awayTimestamp=(new Date).getTime()+this.awayTimeout,this.isAway&&(this.onAwayBack&&this.onAwayBack(),this.start()),this.isAway=!1,!0},a.prototype.start=function(){var a;return this.listener||(this.listener=function(){return a.handleVisibilityChange()},document.addEventListener("visibilitychange",this.listener,!1),document.addEventListener("webkitvisibilitychange",this.listener,!1),document.addEventListener("msvisibilitychange",this.listener,!1)),this.awayTimestamp=(new Date).getTime()+this.awayTimeout,null!==this.awayTimer&&clearTimeout(this.awayTimer),a=this,this.awayTimer=setTimeout(function(){return a.checkAway()},this.awayTimeout+100),this},a.prototype.stop=function(){return null!==this.awayTimer&&clearTimeout(this.awayTimer),null!==this.listener&&(document.removeEventListener("visibilitychange",this.listener),document.removeEventListener("webkitvisibilitychange",this.listener),document.removeEventListener("msvisibilitychange",this.listener),this.listener=null),this},a.prototype.setAwayTimeout=function(a){return this.awayTimeout=parseInt(a,10),this},a.prototype.checkAway=function(){var a,b;return b=(new Date).getTime(),b<this.awayTimestamp?(this.isAway=!1,a=this,void(this.awayTimer=setTimeout(function(){return a.checkAway()},this.awayTimestamp-b+100))):(null!==this.awayTimer&&clearTimeout(this.awayTimer),this.isAway=!0,this.onAway?this.onAway():void 0)},a.prototype.handleVisibilityChange=function(){if(document.hidden||document.msHidden||document.webkitHidden){if(this.onHidden)return this.onHidden()}else if(this.onVisible)return this.onVisible()},a}(),"function"==typeof define&&define.amd?define([],a):"object"==typeof exports?module.exports=a:window.Idle=a}).call(this);; /** ----------------- **/ 
 var Validator = {

    validateElements: function ($container, applyClass) {
        var isValid = true;
        if (applyClass == undefined) {
            applyClass = true;
        }
        $container.find('input, select, textarea').removeClass('is-invalid');
        $container.find('input, select, textarea').each(function (index, element) {
            var $element = $(element);
            if ($element.attr('id') === 'account_form_address' && Config.WHITE_LABEL_REGULATIONS.reg_disable_address) {
                $element.removeClass('is-invalid');
                return;
            }
            if ($element.attr('id') === 'account_form_city' && Config.WHITE_LABEL_REGULATIONS.reg_disable_city) {
                $element.removeClass('is-invalid');
                return;
            }
            if ($element.attr('id') === 'account_form_zipcode' && Config.WHITE_LABEL_REGULATIONS.reg_disable_zip_code) {
                $element.removeClass('is-invalid');
                return;
            }
            if ($element.attr('required') === 'required') {
                if (['reg_form_fname', 'reg_form_lname'].indexOf($element.attr('id')) !== -1){
                    if(Config.DISABLE_REGISTRATION_SPECIAL_CHARS){
                        isValid = Validator.checkRestrictedCharsNames($element);
                        return;
                    }
                }
                if (['reg_form_zipcode'].indexOf($element.attr('id')) !== -1){
                    isValid = Validator.validateZipCode($element);
                    return;
                }
                if (['reg_form_address'].indexOf($element.attr('id')) !== -1){
                    if(Config.DISABLE_REGISTRATION_SPECIAL_CHARS){
                        isValid = Validator.checkRestrictedCharsAddress($element);
                        return;
                    }
                }
                if ($element.hasClass('phone-validation-group')) {
                    var validPhone = Validator.validatePhoneGroup($element);
                    if (!validPhone) {
                        isValid = false;
                        return;
                    }
                }
                if ($element.attr('id') === 'reg_form_bsn'){
                    Validator.validateGroup($element);
                    var validBsn = Validator.validateBsn();
                    if(!validBsn){
                        isValid = false;
                        return;
                    }
                    return;
                }
                if ($element.attr('id') === 'reg_form_cnp'){
                    isValid = Validator.validateCnp();
                    return;
                }
                if ($element.attr('id') === 'reg_form_cpr'){
                    Validator.validateGroup($element);
                    var validCpr = Validator.validateCpr();
                    if(!validCpr){
                        isValid = false;
                        return;
                    }
                    return;
                }
                if ($element.attr('id') === 'reg_form_spn'){
                    Validator.validateGroup($element);
                    var validCpr = Validator.validateSpn();
                    if(!validCpr){
                        isValid = false;
                        return;
                    }
                    return;
                }
                if ($element.attr('id') === 'reg_form_address_nr'){
                    var regex = new RegExp(/^[0-9A-Za-z\-]+$/);
                    if(regex.test($element.val())){
                        return $element.removeClass('is-invalid');
                    } else {
                        isValid = false;
                        return $element.addClass('is-invalid');
                    }
                }

                if ($element.attr('id') === 'reg_form_document_id' || $element.attr('id') === 'reg_form_document_number'){
                    var validDocumentNumber = Validator.validateDocumentNumber(true);
                    if(!validDocumentNumber){
                        isValid = false;
                        return;
                    }
                    return;
                }

                if (!$element[0].checkValidity()) {
                    isValid = false;
                    if (applyClass) {
                        $element.addClass('is-invalid');
                    }
                } else {
                    $element.removeClass('is-invalid');
                }

                if ($element.hasClass('grouped-input')) {
                    Validator.validateGroup($element);
                }
            }

        });

        return isValid;
    },
    initSelfValidation: function ($container) {
        $container.find('input:not(#reg_form_password):not(#reg_form_confirm_password):not(.phone-validation-group), select, textarea').each(function (index, element) {
            var $element = $(element);
            $(element).on('change', function () {
                if($element.attr('id') === 'reg_form_cnp'){
                    return;
                }
                if ($element.attr('required') == 'required') {
                    if (!$element[0].checkValidity()) {
                        $element.addClass('is-invalid');
                    } else {
                        if (['reg_form_fname', 'reg_form_lname'].indexOf($element.attr('id')) !== -1){
                            if(Config.DISABLE_REGISTRATION_SPECIAL_CHARS){
                                Validator.checkRestrictedCharsNames($element);
                                return
                            }
                        }
                        if (['reg_form_address'].indexOf($element.attr('id')) !== -1){
                            if(Config.DISABLE_REGISTRATION_SPECIAL_CHARS){
                                Validator.checkRestrictedCharsAddress($element);
                                return
                            }
                        }
                        if ($element.attr('id') === 'reg_form_cpr'){
                            Validator.validateGroup($element);
                            return;
                        }
                        if ($element.attr('id') === 'reg_form_address_nr'){
                            var regex = new RegExp(/^[0-9A-Za-z\-]+$/);
                            if(regex.test($element.val())){
                                return $element.removeClass('is-invalid');
                            } else {
                                return $element.addClass('is-invalid');
                            }
                        }
                        $element.removeClass('is-invalid');
                        if ($element.attr('type') == 'radio') {
                            var groupName = $element.attr('name');
                            $container.find('input[name="' + groupName + '"]').removeClass('is-invalid')
                        }
                    }

                    if ($element.hasClass('grouped-input')) {
                        Validator.validateGroup($element);
                    }
                }
            });
        });

    },
    validateGroup: function ($element) {
        var $formGroup = $element.closest('.form-group'),
            isGroupValid = true,
            $errorMessage = $formGroup.find('.invalid-feedback');
        $formGroup.find('.grouped-input').each(function (index, groupElement) {
            if (!$(groupElement)[0].checkValidity()) {
                isGroupValid = false;
            }
            if (groupElement.id === 'reg_form_cpr'){
                isGroupValid = Validator.validateCpr();
            }
            if (groupElement.id === 'reg_form_bsn') {
                isGroupValid = Validator.validateBsn();
            }
            if (groupElement.id === 'reg_form_spn'){
                isGroupValid = Validator.validateSpn();
            }
        });

        if ($element.hasClass('date-select')) {
            isGroupValid = Validator.checkDate($element);
        }

        if (isGroupValid) {
            $errorMessage.removeClass('d-block');
        } else {
            $errorMessage.addClass('d-block');
        }
    },
    checkDate: function ($element) {

        var $formGroup = $element.closest('.form-group'),
            day = $formGroup.find('#reg_form_birthday_day').val(),
            month = $formGroup.find('#reg_form_birthday_month').val(),
            year = $formGroup.find('#reg_form_birthday_year').val();

        if (year < 1000 || year > 3000 || month == 0 || month > 12) {
            return false;
        }

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
            monthLength[1] = 29;
        }

        if($element.attr('id') === 'reg_form_cnp' && day && month && year && Config.WHITE_LABEL_REGULATIONS.reg_cnp && !BaseConfig.get('IS_SIMPLE_REGISTRATION')){
            var $cnpInput = $('#reg_form_cnp');
            var cnpYearCode = Validator.cnpHelpers.getYear(Number($cnpInput.val()[0]), $cnpInput.val().slice(1,3));
            var cnpMonthCode = Number($cnpInput.val().slice(3, 5));
            var cnpDayCode = Number($cnpInput.val().slice(5, 7));

            if($cnpInput.val().length === 0){
                return;
            }
            if(cnpYearCode !== Number(year) || cnpMonthCode !== Number(month) || cnpDayCode !== Number(day)){
                $cnpInput.next().text(translation('_localizer.REGISTER.cnp_not_match_form_birthday'));
                $cnpInput.addClass('is-invalid');
            } else {
                $cnpInput.removeClass('is-invalid');
            }
        }

        var hasCpr = Config.WHITE_LABEL_REGULATIONS.reg_cpr && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasCpr){
            $("#reg_form_cpr_bd").val(day.padStart(2, '0') + month.padStart(2, '0') + year.slice(2));
            $("input[name=\"reg_form[cpr]\"]").val($("#reg_form_cpr_bd").val() + $("#reg_form_cpr").val());
        }
        var hasSpn = Config.WHITE_LABEL_REGULATIONS.reg_spn && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasSpn){
            $("#reg_form_spn_bd").val(year.slice(2) + month.padStart(2, '0') + day.padStart(2, '0'));
            $("input[name=\"reg_form[spn]\"]").val($("#reg_form_spn_bd").val() + $("#reg_form_spn").val());
        }

        return day > 0 && day <= monthLength[month - 1];
    },
    validatePhoneGroup: function ($element) {

        var $formGroup = $element.closest('.form-group');
        var $selectPrefix = $formGroup.find('select');
        var $phoneInput = $formGroup.find('input.phone-validation-group');
        var $helpMessage = $formGroup.find('.help-message');
        if (!$selectPrefix[0].checkValidity()) {
            $phoneInput.addClass('is-invalid');
            $formGroup.find('.invalid-feedback').text($selectPrefix.attr('required-message'));
            $helpMessage.addClass('d-none');
            return false;
        } else {
            if (!$phoneInput[0].checkValidity()) {
                $phoneInput.addClass('is-invalid');
                $formGroup.find('.invalid-feedback').text($phoneInput.attr('required-message'));
                $helpMessage.addClass('d-none');
                return false;
            }
            var isoCode = $formGroup.find('.phone-prefix-select :selected').attr('data-iso');
            var parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString($phoneInput.val(), isoCode);
            if (!parsedPhoneNumber || !parsedPhoneNumber.country || !parsedPhoneNumber.isValid() || (isoCode.toLowerCase() !== parsedPhoneNumber.country.toLowerCase())) {
                if (parsedPhoneNumber && parsedPhoneNumber.country && isoCode.toLowerCase() !== parsedPhoneNumber.country.toLowerCase()) {
                    $formGroup.find('.invalid-feedback').text(translation('REGISTER.number_does_not_match_selected_country'));
                } else {
                    $formGroup.find('.invalid-feedback').text(translation('REGISTER.please_valid_cell_phone'));
                }
                $phoneInput.addClass('is-invalid');
                $helpMessage.addClass('d-none');
                return false;
            }
        }

        $phoneInput.removeClass('is-invalid');
        $helpMessage.removeClass('d-none');
        return true;
    },
    initPhonePrefix: function () {
        var $phonePrefixContainer = $('.phone-prefix-container');
        var $phoneFormGroup = $phonePrefixContainer.closest('.form-group');
        var $phonePrefixInput = $phonePrefixContainer.find('.phone-prefix-hidden-input');
        var $phoneHiddenInput = $phonePrefixContainer.find('.phone-number-hidden-input');
        var $phonePrefixLabel = $phonePrefixContainer.find('.phone-prefix-label');
        var $phonePrefixCountryContainer = $phonePrefixContainer.find('.phone-prefix-country-container');
        var $phonePrefixSelect = $phonePrefixContainer.find('.phone-prefix-select');
        var $phoneInput = $phoneFormGroup.find('.reg-form-cell-phone');
        var $helpMessage = $phoneFormGroup.find('.help-message');
        var $phonePrefixValue = $phonePrefixContainer.find('.phone-prefix-value');
        var $phonePrefixFlagIcon = $phonePrefixContainer.find('.flag-icon');
        var selectedCountryCode = '';
        $phonePrefixSelect.on('change', function (e) {
            selectCountry(e);
            $phoneInput.trigger('input').removeClass('is-invalid');
        });
        $phoneInput.on('input', function () {
            var value = $(this).val();
            var asYouType = new libphonenumber.AsYouType(selectedCountryCode);
            var phoneNumber = asYouType.input(value);
            var parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString(phoneNumber, selectedCountryCode);
            if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
                var $matchedCountry = $phonePrefixSelect.find('option[data-iso="'+ parsedPhoneNumber.country +'"]');
                if(!$matchedCountry.length){
                    return;
                }
                var actualPhoneNumber = parsedPhoneNumber.nationalNumber;
                $matchedCountry.prop('selected',true);
                $(this).val(phoneNumber); // Display formatted number to user
                $phoneInput.removeClass('is-invalid');
                selectCountry();
                $phoneHiddenInput.val(actualPhoneNumber); //Used to submit actual number to server
            }
        })
        function selectCountry(e){
            $phonePrefixLabel.addClass('d-none');
            $phonePrefixCountryContainer.addClass('d-flex').removeClass('d-none');
            var $selectedOption = e ? $(e.currentTarget).find(':selected') : $phonePrefixSelect.find(':selected');
            var selectedPrefix = $selectedOption.attr('value');
            $phonePrefixInput.val(selectedPrefix);
            selectedCountryCode = $selectedOption.attr('data-iso');
            if(!selectedCountryCode) {
                return
            }
            $phonePrefixValue.text(selectedPrefix);
            addCountryFlag($phonePrefixFlagIcon, selectedCountryCode.toLowerCase())
            $phonePrefixFlagIcon.attr('class', 'flag-icon flag-icon-sm ' + selectedCountryCode.toLowerCase());

            var phoneNumberExample = libphonenumber.getExampleNumber(selectedCountryCode, libphonenumberExamples);
            var prefix = '+' + phoneNumberExample.countryCallingCode;

            var formattedPhone = phoneNumberExample.formatInternational();
            var phoneHint = prefix + formattedPhone.split(prefix)[1].replace(/\d/g, "X");

            $helpMessage.text(translation('REGISTER.phone_number_example') + ' ' + phoneHint).removeClass('d-none');
        }

        function addCountryFlag(elements, iconName) {
            const defaultIconName = 'default'
            var cdnPath = window.BaseConfig.get('CDN_ASSETS_PATH') || window.Config.CDN_ADDRESS
            Array.from(elements).forEach(element => {
                element.style.backgroundImage = 'url(' + cdnPath + '/wl_common_assets/language_flags/' + (iconName || defaultIconName) + '.svg)'
            })
        }
    },
    initCnpValidations: function (){
        var $cnpInput = $('#reg_form_cnp');

        $cnpInput.on('blur', function (){
            var value = $(this).val();
            if (value.length !== 13){
                $cnpInput.addClass('is-invalid');
                $cnpInput.next().text(translation('_localizer.REGISTER.please_cnp'));
            }
        });
        $cnpInput.on('input', function (){
            var value = $(this).val();
            value = parseInt(value.replace(/[^\d]/g, ''));
            if(isNaN(value)){
                $(this).val('');
                return;
            } else {
                value = String(value);
                $(this).val(value);
            }
            Validator.validateCnp();
        });
    },
    initSpnValidations: function (){
        var $spnInput = $('#reg_form_spn');

        $spnInput.on('blur', function (){
            var value = $(this).val();
            if (value.length !== 4){
                $spnInput.addClass('is-invalid');
                $spnInput.next().text(translation('_localizer.REGISTER.please_spn'));
            }
            Validator.validateGroup($spnInput);
        });
        $spnInput.on('input', function (){
            var value = $(this).val();
            value = parseInt(value.replace(/[^\d]/g, ''));
            if(isNaN(value)){
                $(this).val('');
                return;
            } else {
                value = String(value);
                $(this).val(value);
            }
            Validator.validateSpn();
        });
    },
    validateCnp: function (){
        var $cnpInput = $('#reg_form_cnp');
        var value = $cnpInput.val();

        if (value.length === 13){
            var cnpGenderCode = Number(value.slice(0, 1));
            var cnpYearCode = value.slice(1, 3);
            var cnpMonthCode = Number(value.slice(3, 5));
            var cnpDayCode = value.slice(5, 7);
            var today = new Date;
            var cnpYear = Validator.cnpHelpers.getYear(cnpGenderCode, cnpYearCode);
            var birthdayFromCnp = new Date(cnpYear, cnpMonthCode-1, cnpDayCode);
            var $genderInput = $('input[name="reg_form[gender]"]:checked').val();

            if([1,3,5,7].indexOf(cnpGenderCode) !== -1 && ($genderInput === 'female' || BaseConfig.get('MEMBER_GENDER') === 'female')){
                $cnpInput.addClass('is-invalid');
                $cnpInput.next().text(translation('_localizer.REGISTER.cnp_not_match_form_gender'));
                return false;
            }
            if([2,4,6,8].indexOf(cnpGenderCode) !== -1 && ($genderInput === 'male' || BaseConfig.get('MEMBER_GENDER') === 'male')){
                $cnpInput.addClass('is-invalid');
                $cnpInput.next().text(translation('_localizer.REGISTER.cnp_not_match_form_gender'));
                return false;
            }
            if(dateUtil(today.getTime()).diff(birthdayFromCnp.getTime(), 'years') < 18){
                $cnpInput.addClass('is-invalid');
                $cnpInput.next().text(translation('_localizer.REGISTER.please_cnp'));
                return false;
            }
            if(Validator.cnpHelpers.calculateHash(value) !== Number(value[12])){
                $cnpInput.addClass('is-invalid');
                $cnpInput.next().text(translation('_localizer.REGISTER.please_cnp'));
                return false;
            }
            $cnpInput.removeClass('is-invalid');
            return true;
        } else {
            $cnpInput.addClass('is-invalid');
            $cnpInput.next().text(translation('_localizer.REGISTER.please_cnp'));
            return false;
        }
    },
    cnpHelpers: {
        getYear: function(gender, yearCode){
            var year =  Number(yearCode[0]) * 10 + Number(yearCode[1]);

            switch (gender){
                case 1:
                case 2:
                    // romanian citizen born between 1900.01.01 and 1999.12.31
                    year = year + 1900;
                    break;
                case 3:
                case 4:
                    // romanian citizen born between 2000.01.01 and 2099.12.31
                    year = year + 1800;
                    break;
                case 5:
                case 6:
                    // romanian citizen born between 2000.01.01 and 2099.12.31
                    year = year + 2000;
                    break;
                case 7:
                case 8:
                case 9:
                    // foreign citizenship
                    year = year + 2000;
                    if(year > ((new Date).getFullYear() - 14) ){
                        year -= 100;
                    }
                    break;
                default:
                    year = 0;
            }
            return year;
        },
        calculateHash: function(cnp){
            var hashSum = 0;
            var controlKey = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];

            for(var i = 0; i < 12; i++){
                hashSum += cnp[i] * controlKey[i];
            }

            hashSum = hashSum % 11;

            if(hashSum === 10){
                hashSum = 1;
            }

            return hashSum;
        },
        getGender: function (cnp){
            var gender = cnp.slice(0,1);
            if(["1","2","3","4","5","6"].indexOf(gender) !== -1){
                if(gender % 2 === 0){
                    return 'female';
                }
                return 'male';
            }
        }
    },
    cprHelpers: {
        getGender: function (cpr){
            var cprGender = cpr.slice(cpr.length -1);
            if(cprGender % 2 === 0){
                return 'female';
            }
            return 'male';
        },
    },
    spnHelpers: {
        getGender: function (spn){
            var spnGender = spn.charAt(2);
            if(spnGender % 2 === 0){
                return 'female';
            }
            return 'male';
        },
    },
    initGenderValidation: function (){
        var $genderInput = $('input[name="reg_form[gender]"]');
        var $cnpInput = $('#reg_form_cnp');
        var $cprInput = $('#reg_form_cpr');
        var $spnInput = $('#reg_form_spn');

        $genderInput.on("change", function (){
            var registrationGender = $(this).val();

            if($cnpInput.length){
                var cnpGender = Validator.cnpHelpers.getGender($cnpInput.val());
                if(!$cnpInput.val().length){
                    return;
                }

                if(cnpGender === registrationGender){
                    $cnpInput.removeClass('is-invalid');
                } else {
                    $cnpInput.addClass('is-invalid');
                    $cnpInput.next().text(translation('_localizer.REGISTER.cnp_not_match_form_gender'));
                }
            }

            if($cprInput.length){
                var cprGender = Validator.cprHelpers.getGender($cprInput.val());
                if(!$cprInput.val().length){
                    return;
                }

                Validator.validateGroup($cprInput);
                if(cprGender !== registrationGender){
                    $cprInput.parent().next().text(translation('_localizer.REGISTER.cpr_not_match_form_gender'));
                }
            }

            if($spnInput.length){
                var spnGender = Validator.spnHelpers.getGender($spnInput.val());
                if(!$spnInput.val().length){
                    return;
                }

                Validator.validateGroup($spnInput);
                if(spnGender !== registrationGender){
                    $spnInput.parent().next().text(translation('_localizer.REGISTER.spn_not_match_form_gender'));
                }
            }

        });
    },
    validateRestrictedCharsName: function (value){
        var regex = new RegExp("^[A-Za-z\\s]+$");
        if(Config.ALLOW_CYRILLIC_ON_REGISTER_FORM){
            regex = new RegExp("^[A-Za-zа-яА-Я\\s]+$")
        }
        return regex.test(value);
    },
    validateRestrictedCharsAddress: function (value){
        var regex = new RegExp("^[A-Za-z0-9\\s]+$");
        if(Config.ALLOW_CYRILLIC_ON_REGISTER_FORM){
            regex = new RegExp("^[A-Za-zа-яА-Я0-9\\s]+$");
        }
        return regex.test(value);
    },
    checkRestrictedCharsNames: function ($el){
        var namesMap = {
            reg_form_fname: 'first_name',
            reg_form_lname: 'last_name',
        }
        var value = $el.val().trim();
        if(value.length > 0 && !Validator.validateRestrictedCharsName(value)){
            $el.addClass('is-invalid').next().text(translation('_localizer.REGISTER.names_special_chars_not_allowed'));
        } else if($el.val().trim().length < 2){
            $el.addClass('is-invalid').next().text(translation('_localizer.REGISTER.please_' + namesMap[$el.attr('id')]));
        } else {
            $el.removeClass('is-invalid').next().text(translation('_localizer.REGISTER.please_' + namesMap[$el.attr('id')]));
            return true;
        }
        return false;
    },
    checkRestrictedCharsAddress: function ($el){
        if(!Validator.validateRestrictedCharsAddress($el.val())){
            $el.addClass('is-invalid').next().text(translation('_localizer.REGISTER.address_special_chars_not_allowed'));
        } else {
            $el.removeClass('is-invalid').next().text(translation('_localizer.REGISTER.please_address'));
            return true;
        }
        return false;
    },
    initBsnValidations: function (){
        var $bsnInput = $('#reg_form_bsn');

        $bsnInput.on('blur', function (){
            var value = $(this).val();
            if (value !== "" && value.length !== 9){
                $bsnInput.addClass('is-invalid');
                $bsnInput.parent().next().text(translation('_localizer.REGISTER.please_bsn'));
            } else {
                $bsnInput.removeClass('is-invalid');
            }
            Validator.validateGroup($bsnInput);
        });
        $bsnInput.on('input', function (){
            var value = $(this).val();
            value = parseInt(value.replace(/[^\d]/g, ''));
            if(isNaN(value)){
                $(this).val('');
                return;
            } else {
                value = String(value);
                $(this).val(value);
            }
        });
    },
    validateBsn: function () {
        var $bsnInput = $('#reg_form_bsn');
        var value = $bsnInput.val();
        if (value === '' || (!isNaN(value) && value.length === 9)) {
            $bsnInput.removeClass('is-invalid');
            return true;
        } else {
            $bsnInput.addClass('is-invalid');
            $bsnInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.please_bsn'));
            return false;
        }
    },
    initCprValidations: function (){
        var $cprInput = $('#reg_form_cpr');

        $cprInput.on('blur', function (){
            var value = $(this).val();
            if (value.length !== 4){
                $cprInput.addClass('is-invalid');
                $cprInput.parent().next().text(translation('_localizer.REGISTER.please_cpr'));
            }
            Validator.validateGroup($cprInput);
        });
        $cprInput.on('input', function (){
            var value = $(this).val();
            value = parseInt(value.replace(/[^\d]/g, ''));
            if(isNaN(value)){
                $(this).val('');
                return;
            } else {
                value = String(value);
                $(this).val(value);
            }

        });
    },
    validateCpr: function (){
        var $cprInput = $('#reg_form_cpr');
        var value = $cprInput.val();
        var cprGenderCode = Number(value.slice(value.length - 1));
        var $genderInput = $('input[name="reg_form[gender]"]:checked').val();
        $("input[name=\"reg_form[cpr]\"]").val($("#reg_form_cpr_bd").val() + value);
        if (value.length === 4){

            if([1,3,5,7,9].indexOf(cprGenderCode) !== -1 && ($genderInput === 'female' || BaseConfig.get('MEMBER_GENDER') === 'female')){
                $cprInput.addClass('is-invalid');
                $cprInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.cpr_not_match_form_gender'));
                return false;
            }
            if([2,4,6,8].indexOf(cprGenderCode) !== -1 && ($genderInput === 'male' || BaseConfig.get('MEMBER_GENDER') === 'male')){
                $cprInput.addClass('is-invalid');
                $cprInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.cpr_not_match_form_gender'));
                return false;
            }
            $cprInput.removeClass('is-invalid');
            return true;
        } else {
            $cprInput.addClass('is-invalid');
            $cprInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.please_cpr'));
            return false;
        }
    },
    validateSpn: function (){
        var $spnInput = $('#reg_form_spn');
        var value = $spnInput.val();
        var spnGenderCode = Number(value.charAt(2));
        var $genderInput = $('input[name="reg_form[gender]"]:checked').val();
        $("input[name=\"reg_form[spn]\"]").val($("#reg_form_spn_bd").val() + value);
        if (value.length === 4){

            if([1,3,5,7,9].indexOf(spnGenderCode) !== -1 && ($genderInput === 'female' || BaseConfig.get('MEMBER_GENDER') === 'female')){
                $spnInput.addClass('is-invalid');
                $spnInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.spn_not_match_form_gender'));
                return false;
            }
            if([2,4,6,8].indexOf(spnGenderCode) !== -1 && ($genderInput === 'male' || BaseConfig.get('MEMBER_GENDER') === 'male')){
                $spnInput.addClass('is-invalid');
                $spnInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.spn_not_match_form_gender'));
                return false;
            }
            $spnInput.removeClass('is-invalid');
            return true;
        } else {
            $spnInput.addClass('is-invalid');
            $spnInput.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.please_spn'));
            return false;
        }
    },
    documentValidationRequirements: {
        'cc': /^\d{9,10}$/g,
        'ce': /^\d{9}$/g,
        'dni': /^\d{8,9}$/g,
        'pass': /^\d{12}$/g,
        'ecu_pass': /^\d{9,10}001$/g,
        'cpf': /^\d{3}\.\d{3}\.\d{3}-\d{2}$|^\d{11}$/g,
        'cnpj': /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/g,
        'id': /^[A-Za-z0-9]{8,9}$/g,
        'run': /^[0-9]{8}[0-9kK]?$/g,
        'rut': /^[0-9]{8}[0-9kK]?$/g,
        'ruc': /^[0-9\-.]{11}$/g,
        'ecu_ruc': /^\d{9,10}001$/g,
    },
    idDocument: function () {
        return {
            getNumberEl: function () {
                return $('#reg_form_document_number')
            },
            getTypeEl: function () {
                return $('#reg_form_document_id')
            },
            getLengthHint: function () {
                return translation('_localizer.REGISTER.document_' + this.getTypeEl().val()) + ' ' + translation('_localizer.REGISTER.document_length_hint_' + this.getTypeEl().val())
            },
            getError: function () {
                $('#documentHint').hide();
                this.getNumberEl().addClass('is-invalid');
                this.getNumberEl().closest(".form-group").find(".invalid-feedback").text(this.getLengthHint());
                return false
            },
            showHint: function (){
                $('#documentHint').fadeIn(50).text(this.getLengthHint());
            }
        }
    },
    initDocumentIdValidations: function (){
        var $documentNumberInput = Validator.idDocument().getNumberEl();
        var $documentIdType = Validator.idDocument().getTypeEl();

        $documentNumberInput.on('blur', function (){
            var value = $(this).val();
            if(value.length === 0){
                $('#documentHint').hide();
                return Validator.idDocument().getError();
            }
            Validator.validateDocumentNumber();
        });
        $documentNumberInput.on('input', function (){
            var value = $(this).val();

            value = String(value);
            $(this).val(value);
            if($(this).hasClass('is-invalid')){
                $(this).removeClass('is-invalid')
                Validator.idDocument().showHint();
            }
        });
        $documentIdType.on('change', function () {
            Validator.validateDocumentNumber();
        });
    },
    validateDocumentNumber: function (forceValidateNumber) {
        var $documentNumberInput = Validator.idDocument().getNumberEl();
        var $documentTypeSelect = Validator.idDocument().getTypeEl();
        var documentIdType = $documentTypeSelect.val();
        var documentValidationRegex = Validator.documentValidationRequirements[documentIdType];

        if (!documentIdType){
            $documentTypeSelect.addClass('is-invalid');
            $documentTypeSelect.closest(".form-group").find(".invalid-feedback").text(translation('_localizer.REGISTER.please_document_id'));
            $documentNumberInput.removeClass('is-invalid')
            $('#documentHint').hide();
            return false
        } else {
            $documentNumberInput.removeAttr('disabled');
        }
        if(!$('#documentHint:visible').length && !$documentNumberInput.hasClass('is-invalid')){
            Validator.idDocument().showHint();
            return false
        }
        if(!$documentNumberInput.val().length && !forceValidateNumber){
            $documentNumberInput.removeClass('is-invalid')
            Validator.idDocument().showHint();
            return false
        }
        if (documentValidationRegex && !$documentNumberInput.val().match(documentValidationRegex)){
            return Validator.idDocument().getError();
        }
        $documentNumberInput.removeClass('is-invalid');
        Validator.idDocument().showHint();
        return true
    },
    validateZipCode: function (zipcode) {
        var isCanadaZip = Config.WHITE_LABEL_REGULATIONS.igo_logo_ontario;
        if (isCanadaZip && zipcode) {
            // only CPC compliant ZIP codes valid for Canada
            var canadaZipRegex = new RegExp(/^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/);
            if (!canadaZipRegex.test(zipcode.val()) || zipcode.val().match('H0H 0H0')) {
                zipcode.next('.invalid-feedback').text(translation('_localizer.REGISTER.please_zip_code'));
                if (zipcode.val().length) {
                    zipcode.next('.invalid-feedback').text(translation('REGISTER.please_valid_zip_code'));
                }
                zipcode.addClass('is-invalid');
                return false;
            }
            zipcode.removeClass('is-invalid');
        }
        // TODO other (US probably) ZIPs if needed
        return true;
    }
};
; /** ----------------- **/ 
 // IE repeat polyfill
if (!String.prototype.repeat) {
    String.prototype.repeat = function(count) {
        'use strict';
        if (this == null) {
            throw new TypeError('can\'t convert ' + this + ' to object');
        }
        var str = '' + this;
        count = +count;
        if (count != count) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }
        if (count == Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }
        count = Math.floor(count);
        if (str.length == 0 || count == 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var rpt = '';
        for (var i = 0; i < count; i++) {
            rpt += str;
        }
        return rpt;
    }
}

//IE padStart polyfill
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}

//IE startsWith polyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}; /** ----------------- **/ 
 //Something else to be figured out

var Locale = {
	CONFIRM_MODAL : {
						title: "Are you sure?",
						body: "Are you sure you want to continue?",
						success: "Yes",
						cancel: "No"
	},
	TOASTR : {
				success: {
						body: "Action successful!",
						title: "Success"
					},
				error : {
						body: "Action failure!",
						title: "Error"
				},
				warning : {
					body: "Action interupted!",
					title: "Warning"
				},
				info : {
					body: "",
					title: "Info"
				}
	}
};

/*
* Global method for handling AJAX requests
* ver: 1.10
*
* Changes
* ver: 1.01
* requestData is sent as object. No duplicated keys anymore.
* updateTarget implemented
* loadAction implemented
*
* ver: 1.02
* changes in loadAction operations
* added onBeforeConfirm
* added onConfirmCancel
* added onWarning
* added onInfo
* added on_customstatus
* fix in onAfterSend execution
* confrimText now can be function returning object containing {body:'body', title:'title', success:'success', cancel:'cancel'}
* onComplete receives as parameters callback, settingsCopy, response, status
* added 'modal' to the options
*
* ver: 1.03
* Bug fixes and improvements
*
* ver: 1.04
* Bug fixes
* Added onParserError, onTimeOut, onAbort, onNotModified events
*
* ver: 1.04.1
* Bug fixes for multiselects
*
* * ver: 1.04.2
* Bug fixes for toastr settings
*
* * ver: 1.05
* Fixed event calling for onConfirm
* Improved serialization of elements. Added better way to handle complex naming and deep nested arrays in the names
*
* * ver: 1.06
* Added requestIdent to settings - random generated string with length of 24 characters
* Used to identify specific request and its elements.
* Implemented to loaders to allow request specific loaders removal with the idea of multiple nested request(based on response)
* will have their own loaders not removed from the main request.
*
* * ver: 1.07
* Fixed: Issue with toast dependency
*
* Added:
* - confirmSerialize boolean default false: If you use custom modal for confirmation window you will be able to serialize the
* 	body of that modal and sent it with the reset of the parameters
*
* Changed:
* - confirmText : the body variable now can be an object with key:value elements. In this case the script will look in the
* 	modal body element for DOM element with class of "key-text" and will replace their text with the value. This means that
* 	if you use custom modal you will have better control over the content.
* 	If the body is string it will look now for DOM element with class "body-text" in the body of the modal. Changes to the default
* 	confirmation modal have been applied so previous implementations of the script will work correctly.
* 	NOTE: There rest of the confrimText key elements "title", "success" and "cancel" are not effected by those changes.
*
* * ver: 1.08
*
* Added:
* 	- ability to use "_dymmy_" as method parameter. In such case the work flow will be the same to the point where AJAX need be sent.
* 	Instead of AJAX request to the server the script will try to execute onDummy function if one is supplied in the settings.
* 	This is done so the validation/confirmation and automatic toastr messages can be used without atually sending any request to the server.
*
* * ver: 1.08.1
*
* Changed:
* -confirmation body now can contain html tags. Note: The body is still considered to be <p></p> so use appropriate tags in there
*
* * ver: 1.09
*
* Added:
*  When elements are serialized the names of those elements are checked and if "__uid__" key word is found will be changed with unique
*  id key starting from 0 and going 1 up with every element. Should not be mistaken with "__index__" that serves as iterator for
*  multi value select fields.
*  Note: Should be used only once per name of element. Only the first occurrence will be changed.
*
*  * ver: 1.10
*
* Added:
* 	With each request system_data parameter is sent also. system_data contains current page url under "current_url" key and
* 	dispatcher parameters under "dispatcher_params" key
*/

/*
 * TODO:
 * make changes on updateTarget functionality
 *
 *
 *
 *
 *
 *
 *
 * Options
 * 	validate function(settingsCopy) : Executed before everything else, needs to return true in order for execution to continue
 *  onValidationError function(settingsCopy) : Executed if validate return false
 *  confirm boolean : Throws confirmation. Executed after validation
 *  confrimText object/function : Should be/return object {body:'body', title:'title', success:'success', cancel:'cancel'}
 *  onBeforeConfirm function(settingsCopy) : Executed before confirm window is thrown
 *	onConfirm function(settingsCopy) : Executed after confirmation is successful before onBeforeSend
 *	onConfirmClose function(settingsCopy) : Executed when confirmation is closed. NOTE: If confirmation is successful confirmStatus : true will be added to seetingsCopy
 * 	onBeforeSend function(settingsCopy) : Executed before AJAX is sent, after validation and confirmation
 *	onAfterSend function(settingsCopy) : Executed after AJAX is sent. NOTE: Does not wait for the AJAX to finish
 *	onSuccess function(callback, settingsCopy) : Executed if AJAX request is successful and server returns in the JSON "status":"success"
 *	onError function(callback, settingsCopy) : Executed if AJAX is successful and server returns in the JSON "status":"error"
 *	onWarning function(callback, settingsCopy) : Execited if AJAX returns "status":"warning"
 *	onInfo function(callback, settingsCopy) : executed if AJAX returns "status":"warning"
 *	on_customstatus function(callback, settingsCopy) : executed when AJAX returns status different then "success","error","warning","info".
 *													 NOTE: Any toastr messages need to be processed in the on_customstatus handler
 *	onComplete function(callback, settingsCopy, response, status) : Executed on successful AJAX request, no matter of the "status" returned
 *	onFailure function(settingsCopy, response) : Executed if AJAX request status is error
 *	onParserError function(settingsCopy, response) : Executed if server returns wront data format
 *	onTimeOut function(settingsCopy, response) : Executed if AJAX request times out
 *	onAbort function(settingsCopy, response) : Executed if AJAX is aborted
 *	onNotModified function(settingsCopy, response) : Executed is returned status is 304
 *	onFinish function(settingsCopy, response, status) : Executed no matter the outcome of the AJAX request
 *  onDummy function(settingsCopy) : executed instead of AJAX request if "_dymmy_" is the name of the method supplied
 *	toastr boolean true : Throws toastr messages based on the "status" and "toastr" objects in the returned JSON.
 * 	loadAction string/array/function(settingsCopy, direction) : disables specific elements while the AJAX is executed
 * 		loadAction string parameters
 * 			'origin' 	: disables the first element in the object chain
 * 			'last'		: disables the last element in the object chain
 * 			'parents'	: disables all top parents elements in the object chain
 * 			'screen' 	: disables the entire screen
 *  updateTarget object : object that contains {'selector' : 'partial name'} pairs. Those pairs will be serialized and sent with the request.
 * 						Expected return should be JSON updateTarget containing pairs {'selector' : 'html'}. If updateTarget is returned those
 * 						pairs will be updated with $.fn.html() e.g. $(selector).html(html);.
 * 						NOTE: Sript will check only if updateTarget is returned, NOT if it is requested -
 * 						updateTarget can be returned without requesting it within the options and it will be updated!
 * 	modal string/object : points to the modal that confirmation will open. Selector or jQuery object. Default "#confirm-modal'.
 * 						If modal can`t be located browser confirmation window will be open.
 *
 * Parameters returned with the events
 * 	@callback object : build from the JSON returned. IF the reposnse is not JSON callback is an empty object
 * 	@settinsCopy object :copy of the AJAX settings
 *	@response object : contains the entire response
 *	@status string : the status of the AJAX
 */

(function($)
	{

			function addBaseUrlPrefixToRequestUrl(url)
			{

				if(url.startsWith('/gateway/') || url.includes('getBaseConfig') || typeof window.BaseConfig === 'undefined') {
					return url;
				}

				var IS_SERVED_FROM_APPLICATION_PREFIX = Boolean(window.BaseConfig.get('APPLICATION_PREFIX'));

				var basePrefix = '/' + window.BaseConfig.get('APPLICATION_PREFIX'),
					normalizedUrl;

				if(!IS_SERVED_FROM_APPLICATION_PREFIX || typeof url !== 'string')
				{
					return url;
				}

				if(url.indexOf('://') > -1 || url.indexOf('//') === 0 || url.indexOf(basePrefix) === 0)
				{
					return url;
				}

				normalizedUrl = url.charAt(0) === '/' ? url : '/' + url;
				return basePrefix + normalizedUrl;
			}

			//START ajaxRequest
			var ajaxRequest = function(action, options)
			{
				if(action && typeof action === 'string') // continue if action is supplied
				{
					var defaults 	= 	{
											request:
											{
												type: "json",
												method: "POST",
												url: Config.AJAX_URL + '/' + action,
												async: true
											},
											loadAction: false,
											keepLoader: false,
											confirm : false,
											modal : "#confirm-modal",
											confirmText : false,
											validate: true,
											toastr: true,
											alert: false,
											requestIdent : generateKey(24),
                                            addSystemData: true,
										},
						$action 	= action,
						options	 	= options || {},
						settings 	= $.extend(true, {}, defaults, options),
						settingsCopy,
						origin 	 	= this,
						system 		= settings.addSystemData ? {"system_data":{"current_url": window.location.href, "dispatcher_params": Config.DISPATCHER_PARAMS}} : {},
						requestData = buildRequestData(action, options.updateTarget, origin.requestData, system, options.extraData, settings.addSystemData),
						objChain	= origin.objChain || [];


					typeof origin === 'object' && origin.length > 0 ? objChain.push(origin) : '';

					$.extend(settings,{objChain: objChain},{requestData: requestData});
					settingsCopy = $.extend({},settings);

					//Validate the request in some manner
					if(!execute(settings.validate, settingsCopy))
					{
						execute(settings.onValidationError, settingsCopy);
						return;
					}

					//Checks if Confirmations is needed
					if(typeof settings.confirm === 'boolean' && settings.confirm == true)
					{
						var modal 	= $(settings.modal),
							texts 	= {
									body: 		'',
									title: 		'Are you sure?',
									success: 	'Yes',
									cancel: 	'No'
								};

							if(typeof Locale !== 'undefined' && Locale.CONFIRM_MODAL)
							{
								$.extend(texts, Locale.CONFIRM_MODAL);
							}
							if(typeof settings.confirmText !== 'undefined')
							{
								if(typeof settings.confirmText === 'object' && !settings.confirmText.length)
								{
									$.extend(texts, settings.confirmText);
								}
								else if(typeof settings.confirmText === 'function')
								{
									var confirmTexts = execute(settings.confirmText);

									if(typeof confirmTexts === 'object' && !confirmTexts.length)
									{
										$.extend(texts, confirmTexts);
									}

								}
							}

						execute(settings.onBeforeConfirm, settingsCopy); //Any action before confirmation

						if(modal.length > 0) //if modal is found
						{
							var body 	= typeof texts.body === "object" ? texts.body : checkTexts(texts.body),
								title 	= checkTexts(texts.title, 'Are you sure?'),
								success = checkTexts(texts.success, 'Yes'),
								cancel 	= checkTexts(texts.cancel, 'No');
							modal.find("h4.modal-title").text(title);

							if(typeof body === "object"){
								$.each(body, function(key, value){
									modal.find("." + key + "-text").html(value);
								});
							}else{
								modal.find("div.modal-body p.body-text").html(body);
							}

							modal.find("button.btn-cancel").text(cancel);
							modal.find("button.btn-success").text(success)
								.off("click")
								.on("click",
									function()
									{
										//Serialize the modal body
										if(settings.confirmSerialize){
											var data = getElement(modal.find("div.modal-body")).requestData;
											$.extend(true, settings.requestData, data);
										}
										execute(settings.onConfirm, settingsCopy);
										execute(settings.onBeforeSend, settingsCopy);
										executeAjax();
										$.extend(settingsCopy, {confirmStatus: true});
									}
								);
							modal.off("hide.bs.modal").on("hide.bs.modal", function(e){
								execute(settings.onConfirmClose, settingsCopy);
							});
							modal.modal();
						}
						else //else throw normal confirmation window
						{
							var conf = confirm(checkTexts(texts.body, 'Are you sure?'));
							if(conf == true)
							{
								$.extend(settingsCopy, {confirmStatus: true});
								execute(settings.onConfirm, settingsCopy);
								execute(settings.onConfirmClose, settingsCopy);
								executeAjax();
							}
							else
							{
								execute(settings.onConfirmClose, settingsCopy);
							}
						}
					}
					else
					{
						executeAjax();
					}


				}
				else
				{
					return false;
				}

				//Execute AJAX request
				function executeAjax()
				{
					execute(settings.onBeforeSend, settingsCopy);
					settings.loadAction ? manageLoaders('add') : '';
					settings.alert ? clearAlerts(settings.alert) : '';

					if($action === '_dummy_')
					{
						execute(settings.onDummy, settingsCopy);
						settings.loadAction ? manageLoaders('remove') : '';
					}
					else
					{
						$.ajax(
								{
									dataType: settings.request.type,
									type: settings.request.method,
									url: addBaseUrlPrefixToRequestUrl(settings.request.url),
									async: settings.request.async,
									data: requestData,
									complete: function(response,status)
									{
										var texts = {
												success: 	{
													body:	'',
													title:	''
												},
												error: 		{
													body: 	'',
													title: 	''
												}
										},
										callback = {};

										if(typeof Locale !== 'undefined' && Locale.TOASTR)
										{
											$.extend(texts, Locale.TOASTR);
										}

										if(status == "success")
										{
											try
											{
												if(response.responseText != '')
												{
													var callback = $.parseJSON(response.responseText);
												}
												else
												{
													var callback = false;
												}
											}
											catch(e)
											{
												var callback = false;
											}

											if(callback)
											{
												if(callback.status === 'success') // Execute onSuccess
												{
													execute(settings.onSuccess, callback, settingsCopy);
													callback.updateTarget ? updateTargets(callback.updateTarget) : ""; //if partials are returned update the dom
												}
												else if(callback.status === 'error')
												{
													execute(settings.onError, callback, settingsCopy); // Execute onError
												}
												else if(callback.status === 'warning')
												{
													execute(settings.onWarning, callback, settingsCopy); // Execute onWarning
												}
												else if(callback.status === 'info')
												{
													execute(settings.onInfo, callback, settingsCopy); // Execute onInfo
												}
												else if(callback.status)
												{
													execute(settings["on_" + callback.status], callback, settingsCopy); // Execute custom status handler
													var notConventional = true;
												}

												//Throw toastr notification if there is a callback.status
												if(settings.toastr && callback.status && !notConventional)
												{
													callback.toastr ? $.extend(texts[callback.status], callback.toastr) : '';
													//setup toastr body and title
													var body	= checkTexts(texts[callback.status] ? texts[callback.status].body : '', ''),
													title 	= checkTexts(texts[callback.status] ? texts[callback.status].title : '', callback.status);

													execute(window['toastr'][callback.status],body, title);
												}

                                                //Throw alert notification if there is a callback.status
                                                if(settings.alert && callback.status) {
													renderAlert(settings.alert, callback);
                                                }
											}

											execute(settings.onComplete, callback, settingsCopy, response, status); //Execute onComplete
										}
										else if(status === "error")
										{
											execute(settings.onFailure, settingsCopy, response); //Execute onFailure

											//Throw toastr notification
											if(settings.toastr)
											{
												var body 	= checkTexts(texts["error"].body, '');
												title 	= checkTexts(texts["error"].title, 'Error');

												execute(window['toastr']["error"],body, title);
											}
										}
										else if(status === "parsererror")
										{
											execute(settings.onParserError, settingsCopy, response);
										}
										else if(status === "timeout")
										{
											execute(settings.onTimeOut, settingsCopy, response);
										}
										else if(status === "abort")
										{
											execute(settings.onAbort, settingsCopy, response);
										}
										else if(status === "notmodified")
										{
											execute(settings.onNotModified, settingsCopy, response);
										}

										execute(settings.onFinish, settingsCopy, response, status); //Execute onFinish

										if((status == "success" && callback && callback.status == 'success') && settings.keepLoader) {
											return;
										}

                                        if(status == "success" && !callback && settings.keepLoader) {
											return;
                                        }

                                        settings.loadAction ? manageLoaders('remove') : '';
									}
								}
						);
					}

					//Execute afterSend
					execute(settings.onAfterSend, settingsCopy);
				}

				/*
				 * Manage loaders
				 * @direction string : 'add' or 'remove' specific loader class
				 */
				function
				manageLoaders(direction)
				{
					var action = settings.loadAction;

					if(typeof action === 'string')
					{
						if(action === 'origin')
						{
							settings.loadAction = objChain[0];
							manageLoaders(direction);
						}
						else if(action === 'parents')
						{
							settings.loadAction = getParents(objChain);
							manageLoaders(direction);
						}
						else if(action === 'last')
						{
							settings.loadAction = objChain[objChain.length - 1];
							manageLoaders(direction);
						}
						else if(action === 'screen')
						{
							$("body").append("<div class='global-disable request-loader-" + settings.requestIdent + "'></div>");
							var global = $("body").find(".global-disable").height($(window).height()).width($(window).width());
							settings.loadAction = global;
							manageLoaders(direction);
						}
						else
						{
							settings.loadAction = false;
						}
					}
					else if(typeof action === 'object')
					{
						if(direction === 'add') {
							$.each(action,
								function() {
									$(this).addClass('view-loader loader-center');
								}
							);
						} else {
                            $.each(action,
                                function() {
                                    $(this).removeClass('view-loader loader-center');
                                }
                            );
						}
					}
					else if(typeof action === 'function')
					{
						execute(action, settingsCopy, direction);
					}
				}

				//Check for parents relations and return only top level elements
				//TODO: Extensive testing
				function getParents(chain)
				{
					var parents = $.merge([], chain),
						i = 0,
						len = chain.length;

					if(len > 1)
					{
						//Loop and compare each element against every other element off the array
						//All child elements are discarded

						//Theoretical
						//Double while using single array length value
						while(i < len)
						{
							var x = 0;

							while(x < len)
							{
								if(x != i)
								{
									if(parents[x].has(parents[i]).length > 0) //parent relation
									{
										parents.splice(i, 1); //remove matched element
										len--; //reduce the length of the array
										i--; //recude i so we dont skip element of the array
										break; //we found match to our condition so we continue to the next element
									}
								}
								x++;
							}
							i++;
						}
					}
					return parents;
				}

				//Build the request data
				function buildRequestData(action, options, partials, origin, system, addSystemData)
				{
					var method =  addSystemData ? {'method':action} : {},
						data = {};

					//Loop and merge all parts of the request
					$.each([origin, options, partials, method, system],
						function(dummy, value)
						{
							typeof value === 'object' ? $.extend(true, data, value) : '';
						}
					);

					return data;
				}

				//Check if function exists and execute it
				function execute(f)
				{
					if(f && typeof f === 'function')
					{
						var args = Array.prototype.slice.call(arguments);
							args = args.slice(1);
						return args.length > 1 ? f.apply(this,args) : f(args[0]);
					}
					else if(typeof f === 'boolean')
					{
						return f;
					}
					else
					{
						return false;
					}
				}

				//Checks if argumets are strings and returns the first one
				function checkTexts()
				{
					var returnText = '',
						args = arguments,
						l = args.length,
						i = 0;

					while(i < l && returnText === '')
					{
						typeof args[i] === 'string' ? returnText = args[i] : '';
						i++;
					}

					return returnText;
				}

				//Update partials
				function updateTargets(callback)
				{
					if(callback)
					{
						$.each(callback,
							function(key, value)
							{
								$(key).html(value);
							}
						);
					}
				}

                /*
                 * Render Alerts
                 */
                function renderAlert(options, response) {

                    var defaults = {
							dismissible: false
                        },
                        newOptions = options || {},
                        settings = $.extend(true, {}, defaults, newOptions),
                        statuses = {
                        	success: 'alert-success',
                            error: 'alert-danger'
                    	},
						dismissibleClasses = settings.dismissible ? ' alert-dismissible fade show' : '',
                    	closeBtn = settings.dismissible ? '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' : '',
						additionalClasses = settings.className ? ' ' + settings.className : '',
						message = getMessage(response, settings);

                    	if(message){
                            var alert = '<div class="alert ' + statuses[response.status] + dismissibleClasses + additionalClasses + '" role="alert">' + message + closeBtn + '</div>';
                            settings.$el.prepend(alert);
						}

                }
                /*
                 * Get Alert message
                 */
                function getMessage(response, settings){
                   	var message = false;

                    if (response.status == 'success') {
                        if(settings.successMessage) {
                            message = settings.successMessage;
                        } else if(settings.responseSuccessMessageKey){
                        	message = response[settings.responseSuccessMessageKey];
                        } else if(response.message) {
							message = response.message;
						} else if(response.success && typeof response.success === 'string') {
                            message = response.success;
						}
                    } else if (response.status == 'error') {
                        if(settings.errorMessage) {
                            message = settings.errorMessage;
                        } else if(settings.responseErrorMessageKey) {
                            message = response[settings.responseErrorMessageKey];
                        } else if(response.message){
                            message = response.message;
                        } else if(response.error && typeof response.error === 'string') {
                            message = response.error;
                        } else if(response.errors && typeof response.errors === 'string') {
                            message = response.errors;
                        }
					}

                    return message;
				}

				/*
				 * Clear Alerts
				 */
				function clearAlerts(options) {
					options.$el.find('.alert').remove();
				}
			},
			//END ajaxRequest

			//START getElement
			/*
			 * Returns data from given element mathing the selector and allows for chaining objects
			 *  @selector string not requred: element selector for jQuery to build object with
			 *  @customAttr string/array/object not required: points which data-attributes of the supplied element to be added in the requestData.
			 *
			 * If object can`t be created with the selector the function returns blank object that contains the requestData
			 * and objChain from the previous elements of the chain.
			 *
			 * Returns jQuery object with 2 additional properties:
			 * @requestData object - object made from serialization of all fields and data-attributes of this element.
			 *						 Inherits requestData of previous objects in the chain if any
			 * @objChain array - array that contains all real(not empty, functions or window) objects prior to the current element
			 *
			 * Acceptable values for customAttr
			 * string 							-> "foo"
			 * array of strings 				-> ["foo", "bar"]
			 * object where values are strings 	-> {foo: "bar", bar: "foo"}
			 *
			 * NOT acceptable
			 * mixed array of objects and strings 		-> ["foo", {doh: "bar"}] 	// only the string parameters will be serialized
			 * object with values other then strings 	-> {foo: "bar", bar: {a: "b"}} // only the first key with string values will be processed
			 *
			 * Selector cases:
			 * If the selector leads to more then 1 object,
			 * e.g. many inputs with class .my-input all those object will be serialized
			 * If the selector looks for element with id, the first found element will be serialized,
			 * e.g. more than 1 input with id="my-input" only the first one will be serialized
			 *
			 */
			getElement = function(selector, customAttr)
			{
				var origin = this,
					element = $(selector),
					serializedData = {},
					data,
					objChain = [];

					//Serialize the current element
					if(element)
					{
						if(!element.is(":input"))
						{
							element.find(":input").each(
								function()
								{
									$.extend(true, serializedData, serializeObject($(this)));
								}
							);
						}
						else
						{
							$.extend(true, serializedData, serializeObject(element));
						}

					}

					//Merge requestData from the previous element in the chain if there is any
					if(origin.requestData)
					{
						data = $.extend(true, origin.requestData, serializedData);
					}
					else
					{
						data = serializedData;
					}

					//If attr is supplied check for those attributes and add the to the requestData
					if(customAttr)
					{
						var tempData = {};

						if(typeof customAttr === 'string') //if single string
						{
							tempData[customAttr] = element.attr("data-"+customAttr);
						}
						else if(typeof customAttr === 'object')
						{
							if(customAttr.length) //if Array
							{
								for(var key in customAttr)
								{
									//Only elements with string values will get checked
									//Use value as variable name
									typeof customAttr[key] === 'string' ? tempData[customAttr[key]] = element.attr("data-"+customAttr[key]) : '';
								}
							}
							else // if Object
							{
								for(var key in customAttr)
								{
									//Only elements with string values will get checked
									//Use the key as variable name
									typeof customAttr[key] === 'string' ? tempData[key] = element.attr("data-"+customAttr[key]) : '';
								}
							}
						}

						data = $.extend(true, data, tempData);
					}

					//Extend the element with the request data
					$.extend(element, {requestData: data});

					//Create or update objChain
					if(origin.objChain)
					{
						objChain = origin.objChain;
					}

					//Add the origin object in the object chain if it is not an empty object or the window
					typeof origin === 'object' && origin instanceof jQuery && origin.length > 0 ? objChain.push(origin) : '';
					$.extend(element, {objChain: objChain});

				Unique.getIterator().wipeStorage();
				return element;
			}
			//End getElement
		if(typeof $.ajaxRequest === 'undefined')
		{
			$.extend($, {
				ajaxRequest : ajaxRequest
			});
			$.extend($.fn, {
				ajaxRequest : ajaxRequest
			});

		}

		if(typeof $.getElement === 'undefined')
		{
			$.extend($, {
				getElement	: getElement
			});
			$.extend($.fn, {
				getElement	: getElement,
				getForm : function(customAttr)
				{
					return this.getElement(this.parents("form"), customAttr);
				}
			});

			//Shorthand methods for getElement
			$.each(
				{
					getForm 	: "form", 	// get parent form
					getTable 	: "table",	// get parent table
					getRow 		: "tr",		//get parent row
					getBox 		: ".box"	//get first parent with class .box
				},
				function(name, value)
				{
					$.fn[name] = function(customAttr)
					{
						return this.getElement(this.parents(value), customAttr);
					}
				}
			);
		}
	}
)(jQuery);

ajaxRequest = $.ajaxRequest;
getElement = $.getElement;


// Serialize objects.
// DEPRECATED
/*
function serializeObject(target)
{
	var results = target.serializeArray(),
		i = 0,
		data = {};

	if(results.length > 0)
	{
		$.each(results ,
			function()
			{
				var element = $(this)[0],
					name = element.name.replace("[]", "[" + i + "]"),
					obj = {};

				obj[name] = element.value;
				$.extend(true, data, obj);
				i++;
			}
		);
	}

	return data;
}
*/

function serializeObject(target)
{
	var results = target.serializeArray(),
		i = 0,
		data = {};

	if(results.length > 1)
	{
		var o 	 = {};

		$.each(results ,
			function()
			{
				var element = $(this)[0];

				o[i] = element.value;
				i++;
			}
		);

		data = buildObjectFromArrayValue(nameToArray(formatName(results[0].name), "[", "]"), o);
	}
	else if(results.length == 1)
	{
		data = buildObjectFromArrayValue(nameToArray(formatName(results[0].name), "[", "]"), results[0].value);
	}

	return data;
}


/**
 * Creates unique ids based on strings
 */

var Unique = (function(){

	var instance;

	function initialize(){
		var storage = {};

		return {
			wipeStorage: function(){
				storage = {};
			},
			getUnique: function(name){
				//trace(storage[name]);
				if(storage[name] != undefined){
					storage[name] = parseInt(storage[name]) + 1;
				}
				else{
					storage[name] = 0;
				}
				return storage[name];
			}
		}
	}

	return {
		//Creates new BetSlip or returns instance of the BetSlip if already created
		getIterator: function(){
			if(!instance){
				instance = initialize();
				//instance.init();
			}
			return instance;
		}
	}
}());

/**
 * Creates unique iteration keys on the first "__uid__" key met using Unique
 * @param value
 * @returns
 */
function formatName(value){
	var name = value;
	var uniqueId = "__uid__";

	if(name.indexOf(uniqueId) >= 0)
	{
		name = name.replace(uniqueId, Unique.getIterator().getUnique(name));
	}

	return name;
}



/** Turns string to array using open and close characters and
 * adding everything betwen them to the array
 *
 * @param name - String to be turned to array
 * @param open - start of the cut
 * @param close - end of the cut
 * @returns {Array} - array witch values are the cuted pieces of the string
 */
function nameToArray(name, open, close){
	var arr = [];
	loopName(name, open, close);

	function loopName(name, open, close){
		  var openIndex = name.indexOf(open),
		      closeIndex  = name.indexOf(close),
		      index,
		      item 	 = '';

		  if(name.length === 0){
		    return;
		  }

		  if(openIndex < 0 && closeIndex < 0){
		    arr.push(name);
		    return;
		  }

		  index = (openIndex >= 0 && openIndex < closeIndex) ? openIndex : closeIndex;
		  item = name.substr(0, index);
	      item.length > 0 ? arr.push(item) : '';
	      loopName(name.substr(index + 1), open, close);
	}

	return arr;
}

/** Builds object from array and given value.
 * 	The purpose of this function is to build and return object
 * 	where the most bottom element will have the value
 *  If one of the parameters is "__index__" the iteration will be at that position
 *
 * @param array - array of elements to be build object from
 * @param val - value to be added at the bottom object
 * @returns object -
 */
function buildObjectFromArrayValue(array, val)
{

	var iteratorKey = "__index__",
		a= array,
		v = val,
		o;

	if(a.indexOf(iteratorKey) >= 0){

		var before = a.slice(0, a.indexOf(iteratorKey)),
			after = a.slice(a.indexOf(iteratorKey) + 1),
			after_arr = [];

		if(typeof val === 'object'){
			$.each(val, function(key, value){
				after_arr.push(buildObject(after, value));
			});
		}else{
			after_arr.push(buildObject(after, val));
		}


		o = buildObject(before, after_arr);

	}else{
		o = buildObject(a, v)
	}

	return o;

	function buildObject(array, val){
		var n = array.reverse(),
		f = {},
		c = {};
		$.each(n, function(key, value){

			if(key == 0){
				c[value] = val;
			}
			else{
				f = c;
				c = {};
				c[value] = f;
			}

		});
		return c;
	}
}

function generateKey(l)
{
    var key = '',
        rand, i,
        len = l || 12,
        symbols = 'abcdefghklmnpqrstuvwxyzABCDEFGHKLMNPQRSTUVWXYZ0123456789';

    for(i = 1; i < len; i++)
    {
        rand = Math.floor(Math.random() * symbols.length + 1);
        key += symbols.charAt(rand);
    }

    return key;
}

; /** ----------------- **/ 
 var BaseConfig = (function () {
	var config = null;
	var instance;

	function parseBaseConfigData(encodedData) {
		return JSON.parse(window.atob(encodedData));
	}

	function requestConfig(options) {
        var baseConfigUrl = window.location.href.includes('/gateway') ? "/gateway" : "" ;
		var normalizedOptions = options || {};

		$.ajaxRequest("getBaseConfig", {
			toastr: false,
			request: {
				async: Boolean(normalizedOptions.async),
				//TODO think of a way that can access this endpoint from the plugin without to use locale_short as a prefix
				url: baseConfigUrl + "/" + Config.LOCALE_SHORT + "/base-config/operation/getBaseConfig",
				method: "GET",
			},
			addSystemData: false,
			extraData: { is_logged: window.Config.USER_LOGGED_IN ? 1 : 0 },
			onSuccess: normalizedOptions.onSuccess || function () {},
			onError: normalizedOptions.onError || function () {}
		});
	}

	function requestConfigSync() {
		requestConfig({
			async: false,
			onSuccess: function (response) {
				config = parseBaseConfigData(response.data);
			},
			onError: function (error) {
				console.log(error);
			}
		});
	}

	function getInjectedConfigHash(keepInDom) {
		var element = document.getElementById("base-config-payload");

		if (!element) {
			return "";
		}

		var raw = (typeof element.textContent === "string" ? element.textContent : "").replace(/^\s+|\s+$/g, "");

		if (!keepInDom && element.parentNode) {
			element.parentNode.removeChild(element);
		}

		return raw;
	}

	function getSsrOptions(rawSettings) {
		var isObjectSettings = Boolean(rawSettings) && typeof rawSettings === "object" && !Array.isArray(rawSettings);

		return {
			enabled: Boolean(rawSettings),
			debug: isObjectSettings && rawSettings.debug === true
		};
	}

	function validateInjectedConfigInDebugMode(injectedConfig) {
		requestConfig({
			async: true,
			onSuccess: function (response) {
				var requestedConfig = parseBaseConfigData(response.data);
				console.log("[BaseConfig][SSR Debug] Injected payload object:", injectedConfig);
				console.log("[BaseConfig][SSR Debug] Request payload object:", requestedConfig);
			},
			onError: function (error) {
				console.warn("Unable to fetch BaseConfig request in SSR debug mode.", error);
			}
		});
	}

	return {
		init: function () {
			if(!instance) {
				instance = this;
				var ssrOptions = getSsrOptions(window.Config.BASE_CONFIG_SSR);
				var injectedConfigHash = getInjectedConfigHash(ssrOptions.debug);

				if (!ssrOptions.enabled) {
					requestConfigSync();
				} else if (injectedConfigHash) {
					config = parseBaseConfigData(injectedConfigHash);

					if (ssrOptions.debug) {
						validateInjectedConfigInDebugMode(config);
					}
				} else {
					requestConfigSync();
				}
			}
			return instance;
		},
		get: function (key) {
			if(!config) {
				throw new Error('No existing config!');
			}
			return config[key];
		},
		set: function (key, val) {
			config[key] = val
		},
		isValid: function() {
			return Boolean(config)
		}
	};
})();

BaseConfig.init();
; /** ----------------- **/ 
 (
// this additional function is present just to avoid instant invocation of the ajax
// we don't need this ajax call just after load, but 15s later
function startKeepAlive() {

	function keepAlive()
	{
		if (typeof Config === 'object' && typeof jQuery === 'function' && Config.USER_LOGGED_IN !== '')
		{
			if (window.BLOCK_KEEP_ALIVE)
			{
				return;
			}

			window.BLOCK_KEEP_ALIVE = true;

			jQuery.ajax(Config.AJAX_URL+'/hb' , {
				type: 'post',
				data: {
					method: 'hb'
				}
			})
			.done(function(data)
			{
				// All this for some JSON validation :( phew..
				var parsed = null;
				try {
					parsed = jQuery.parseJSON(data);
				}
				catch (err)
				{
					trace('KeepAlive request failed! (2)');
					return;
				}
				if (!parsed)
				{
					trace('KeepAlive request failed! (1)');
					return;
				}

				if (typeof parsed.status === 'boolean' && parsed.status === false && parsed.error === 'not_logged_in')
				{
					trace('You was logged out from the system!');
					if (window.WebPage) {
						window.WebPage.sendMessage({
							type: 'USER_LOGGED_IN',
							payload: false,
						});
					}

					var vueStore = null;
					if (
						$('#appComponents')[0] &&
						$('#appComponents')[0].__vueParentComponent &&
						$('#appComponents')[0].__vueParentComponent.appContext
					) {
						vueStore = $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store
					}
					if (
						vueStore &&
						vueStore.state.application.cashierModalOpened &&
						window.ErrorTracker &&
						typeof window.ErrorTracker.trackError === 'function'
					) {
						window.ErrorTracker.trackError(
							new Error('Page reloaded while the cashier modal is open'),
							{tag: {error_type: 'cashier reload - user logged out'}}
						)
					}

					if (
						vueStore &&
						vueStore.state.application.cashierModalOpened &&
						window.UILogger
					) {
						var cashierIntent = vueStore.state.cashier.cashierMethod || '';
						window.UILogger.logEvent(window.UILogger.eventNames.Application.page_reload_during_user_activity, {
							context: 'cashier modal opened',
							reload_reason: 'user logged out',
							member_id: window.BaseConfig.get('MEMBER_ID') || '',
							provider: Config.CASHIER ? Config.CASHIER : '',
							intent: cashierIntent,
						});
					}

					window.location.reload();
					return;
				}

				if (typeof parsed.status !== 'boolean' || parsed.status !== true)
				{
					trace('KeepAlive request failed! (0)');
				}
			})
			.fail(function()
			{

			})
			.always(function()
			{
				window.BLOCK_KEEP_ALIVE = false;
				setTimeout(keepAlive, 15000);
			});
		}
	}
	setTimeout(keepAlive, 15000);
})();

$(function () {
	if (parseInt(BaseConfig.get('FORCED_SESSION_EXPIRATION')) === 1 && parseInt(Config.USER_TYPE) === 0)
	{
		window.LAST_KEEP_ALIVE = Math.floor(Date.now() / 1000);

		$(document).on('click', function (event) {
			if (event.hasOwnProperty('originalEvent')) {
				if (window.LAST_KEEP_ALIVE < Math.floor((Date.now() - 30000) / 1000)) {
					jQuery.ajax(Config.AJAX_URL + '/click', {
						type: 'post',
						data: {
							method: 'click'
						}
					}).always(function () {
						window.LAST_KEEP_ALIVE = Math.floor(Date.now() / 1000);
					});
				}
			}
		})
	}
});
; /** ----------------- **/ 
 /* HELPER FUNCTIONS OF ANY KIND */

/* Simple debug function that will log the data sent or will alert it if the console log is not defined */
function trace() {
    // return false;
    var now = new Date(),
        args = Array.prototype.slice.call(arguments)
    now = '[' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + ':' + now.getMilliseconds() + '] '
    args.unshift(now)

    if ('console' in window) {
        if (console.log) {
            if (console.log.apply) {
                console.log.apply(console, args)
            }
            else {
                console.log(args)
            }
        }
        else {
            alert(args)
        }
    }
}

function trace_extended() {
    var now = new Date(),
        args = Array.prototype.slice.call(arguments)

    now = '[' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + ':' + now.getMilliseconds() + '] '
    args.unshift(now)

    if (console.log) {
        console.group()
        //console.timeStamp.apply(console,args);
        console.log.apply(console, args)
        console.trace()
        console.log(arguments)
        //console.log(arguments.callee.caller);
        console.groupEnd()
    } else {
        alert(args)
    }
}

function getVueGlobalProperty(propertyName) {
    var appComponents = document.getElementById('appComponents')
    return appComponents && appComponents.__vueParentComponent && appComponents.__vueParentComponent.appContext.config.globalProperties[propertyName] || null
}

function getBvModal() {
    return getVueGlobalProperty('$bvModal')
}

function getStore() {
    return getVueGlobalProperty('$store')
}

function showLoginModal(bvModal) {
    window.$('#login-guest-modal').modal('show')
    window.$('#register-user-modal').modal('hide')
    bvModal.hide('registrationModal')
    if (window.BaseConfig.get('VUE_LOGIN_ENABLED')) {
        bvModal.show('loginModal')
    }
}

function hideLoginModal(bvModal) {
    window.$('#login-guest-modal').modal('hide')
    if (window.BaseConfig.get('VUE_LOGIN_ENABLED')) {
        bvModal.hide('loginModal')
    }
}

function getTrackingParams(trackingParams) {
    if (typeof trackingParams !== 'string') {
        return {}
    }

    try {
        const parsedTrackingParams = JSON.parse(trackingParams)
        return parsedTrackingParams && typeof parsedTrackingParams === 'object' ? parsedTrackingParams : {}
    } catch (e) {
        return {}
    }
}

function showRegistrationModal(bvModal, source, trackingParams) {
    window.$('#login-guest-modal').modal('hide')
    if (!getStore().state.application.registrationConfig) {
        bvModal.show('unexpectedErrorModal')
        return;
    }
    bvModal.show('registrationModal')
    window.$('#register-user-modal').modal('hide')
    if (source === 'registerButton') {
        const parsedTrackingParams = getTrackingParams(trackingParams)
        window.trackRegEvent('reg_registration_opened', parsedTrackingParams)
    }
}

function isInReactNativeAuthModal() {
    try {
        return !!(
            document &&
            document.documentElement &&
            document.documentElement.classList &&
            document.documentElement.classList.contains('external-modal-registration')
        )
    } catch (e) {
        return false
    }
}

function openModalScreen(name, source, trackingParams) {
    if ((window.ReactNativeWebView || window.Config.PLUGIN_MODE) && window.WebPage && !isInReactNativeAuthModal()) {
        window.WebPage.sendMessage({
            type: 'NAVIGATE_TO_SCREEN',
            payload: {
                name: name,
            },
        })
    } else {
        window.__PROMPT_AUTH_MODAL__(name, source, trackingParams)
    }
}

function __PROMPT_AUTH_MODAL__(name, source, trackingParams) {
    const bvModal = getBvModal()
    if (name === 'Login') {
        showLoginModal(bvModal)
    }
    if (name === 'SignUp') {
        signUpModalHandler(source, bvModal, trackingParams)
    }
}

function __HIDE_AUTH_MODAL__(name) {
    //Patch for native apps
    const bvModal = getBvModal()
    if (name === 'Login') {
        hideLoginModal(bvModal)
    }
}

async function signUpModalHandler(source = 'unspecified', bvModal, trackingParams) {
    var store = getStore()

    // Sanity check for store
    if (!store) {
        return // Exit the function early if store is null
    }

    function openRegistrationModal(source, isNewRegistrationForm, trackingParams) {
        const variant = isNewRegistrationForm ? 'B' : 'A'
        trackUserInteraction('open', 'registrationModal', variant)
        if (typeof window.trackRegEvent !== 'undefined') {
            if (getParameterByName('register') === 'true') {
                if (window.Config.USER_LOGGED_IN === '') {
                    window.trackRegEvent('reg_registration_opened', { "triggeredFrom": "register_deeplink" })
                }
                var siteUrl = new URL(window.location)
                siteUrl.searchParams.delete('register')
                window.history.replaceState(null, '', siteUrl)
            }
            if (source === 'cms-carousel' && window.Config.USER_LOGGED_IN === '') {
                window.trackRegEvent('reg_registration_opened', { "triggeredFrom": "carousel_button" })
            }
        }
        if (isNewRegistrationForm) {
            showRegistrationModal(bvModal, source, trackingParams)
        } else {
            if (source === 'registerButton') {
                const parsedTrackingParams = getTrackingParams(trackingParams)
                window.trackRegEvent('reg_registration_opened', parsedTrackingParams)
            }
            window.$('#register-user-modal').modal('show')
            window.$('#login-guest-modal').modal('hide')
        }
    }

    await waitUntilRegistrationConfigResponse(store).finally(() => {
        var hasRegistrationConfig = !!store.state.application.registrationConfig
        openRegistrationModal(source, window.Config.IS_CUSTOMIZABLE_REG_FORM, trackingParams)
    })
}

window.getRegistrationConfigStarted = typeof window.getRegistrationConfigStarted === 'undefined' ? false : window.getRegistrationConfigStarted;
console.log('getRegistrationConfigStarted INITIAL VALUE', window.getRegistrationConfigStarted);
var safeTimeout = 20;
setTimeout(() => {
    window.getRegistrationConfigStarted = true;
    console.log(`getRegistrationConfigStarted safely set to true after ${safeTimeout} seconds`, window.getRegistrationConfigStarted);
}, safeTimeout * 1000);
function waitUntilRegistrationConfigResponse(store) {
    window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')
    return new Promise(function (resolve, reject) {
        var timeInterval
        var checkConfig = function () {
            var isLoading = store.state.network.activeActions.some(function (action) {
                return action.name === 'GET_REGISTRATION_CONFIG'
            })

            if (!isLoading && window.getRegistrationConfigStarted) {
                console.log('Registration config response received and getRegistrationConfigStarted is true');
                clearInterval(timeInterval)
                window.getBodyClassList().remove('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')
                resolve()
            }
        }

        checkConfig()
        timeInterval = setInterval(checkConfig, 100)
    })
}

// Google auth helpers
// TODO check can we remove this
var googleClient
var googleAccessToken

function initGoogleClient() {
    // Skip initialization in React Native apps
    if (window.ReactNativeWebView) {
        return
    }
    // Vue login/registration modals handle Google auth via @/api/social-auth/google.js
    if (window.BaseConfig.get('VUE_LOGIN_ENABLED')) {
        return
    }
    var scope = 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'
    googleClient = google.accounts.oauth2.initTokenClient({
        client_id: window.BaseConfig.get('GOOGLE_CLIENT_ID'),
        scope: scope,
        ux_mode: 'popup',
        callback: (response) => {
            if (response && response.access_token) {
                google.accounts.id.initialize({
                    client_id: window.BaseConfig.get('GOOGLE_CLIENT_ID'),
                    scope: scope,
                    callback: (response) => {
                        googleAccessToken = response.credential
                    },
                })
                google.accounts.id.prompt()
            }
        },
    })
}
function getToken() {
    googleClient.requestAccessToken()
}

function trackUserInteraction(interaction, component, variant = 'A') {
    var appElement = document.getElementById('appComponents')
    if (!appElement || !appElement.__vueParentComponent) {
        return
    }
    var appInstance = appElement.__vueParentComponent
    var router = appInstance.appContext.config.globalProperties.$router

    if (router.currentRoute.value.name === 'Register') {
        return
    }

    var store = getStore()
    store.dispatch('shared/TRACK_USER_INTERACTION', {
        params: {
            interaction: interaction,
            component: component,
            variant: variant,
        },
    })
}

function handlePayNPlayOptionsCashierModal(e) {
    const payNPlayComposable = window.payNPlayComposable
    if (!payNPlayComposable ||
        !payNPlayComposable.enabledProvider ||
        !payNPlayComposable.isDepositButtonEnabled ||
        !e.relatedTarget ||
        !e.relatedTarget.getAttribute ||
        e.relatedTarget.getAttribute('data-cashier-method') !== 'deposit'
    ) return false
    const forceShow = e.relatedTarget && e.relatedTarget.hasAttribute && e.relatedTarget.hasAttribute('data-show-default-deposit-despite-pay-n-play');
    return Boolean(payNPlayComposable.renderPayNPlayModalConditions.some(condition => !!condition) && !forceShow);
}
; /** ----------------- **/ 
 $(function(){
    var i = 1;
        for (i=1; i<= 25; i++){
            $('#timeOffsetMenu ul li:nth-child('+i+') a').attr('id', 'gmt'+i);
        }

    var childCounter = 1,
        gm_c = -12;

    for (gm_c = -12; gm_c<=12; gm_c++){
        $('#timeOffsetMenu ul li:nth-child('+childCounter+') a').html('<div class="digital"><span class="hr"></span><span class="minute"></span> <span class="period">GMT '+gm_c+'</span></div>');
        childCounter++;
    }


    $('#timeOffsetMenu').on('mouseenter', function(){

    var idCounter = 1,
        iGC = 1,
        gmc_c = -12;

        for (iGC = 1; iGC<=25; iGC++){
            $('#gmt'+idCounter+'').jClocksGMT({offset: gmc_c, digital: true, hour24: true});
            //console.info(gmc_c);
            idCounter++;
            gmc_c++;
            // console.log('1')
        }
    })
}); /** ----------------- **/ 
 /********************************************************************************************************
 *          GMT-12   Eniwetok
 *          GMT-11   Samoa
 *          GMT-10   Hawaii
 *          GMT-9    Alaska
 *          GMT-8    PST, Pacific US
 *          GMT-7    MST, Mountain US
 *          GMT-6    CST, Central US
 *          GMT-5    EST, Eastern US
 *          GMT-4    Atlantic, Canada
 *          GMT-3    Brazilia, Buenos Aries
 *          GMT-2    Mid-Atlantic
 *          GMT-1    Cape Verdes
 *          GMT 0    Greenwich Mean Time, Dublin
 *          GMT+1    Berlin, Rome
 *          GMT+2    Israel, Cairo
 *          GMT+3    Moscow, Kuwait
 *          GMT+4    Abu Dhabi, Muscat
 *          GMT+5    Islamabad, Karachi
 *          GMT+6    Almaty, Dhaka
 *          GMT+7    Bangkok, Jakarta
 *          GMT+8    Hong Kong, Beijing
 *          GMT+9    Tokyo, Osaka
 *          GMT+10   Sydney, Melbourne, Guam
 *          GMT+11   Magadan, Soloman Is.
 *          GMT+12   Fiji, Wellington, Auckland
 *
 ********************************************************************************************************/

 (function($) {

    $.fn.extend({
        
        jClocksGMT: function(options) {
            
            var defaults = {
                offset: '0', // default gmt offset
                angleSec: 0,
                angleMin: 0,
                angleHour: 0,
                hour24: true,
                digital: true,
                analog: false
            }
            
            var options = $.extend(defaults, options);
            
            return this.each(function(){
                var offset = options.offset;
                var id = $(this).attr('id');
                //console.warn(offset);
                var nOffset = offset;
                
                // initial hand rotation
             

                // check if daylight saving time is in effect
                Date.prototype.stdTimezoneOffset = function() {
                    var jan = new Date(this.getFullYear(), 0, 1),
                        janUTC = jan.getTime() + (jan.getTimezoneOffset() * 60000),
                        janOffset = new Date(janUTC + (3600000 * options.offset)),
                        jul = new Date(this.getFullYear(), 6, 1),
                        julUTC = jul.getTime() + (jul.getTimezoneOffset() * 60000),
                        julOffset = new Date(julUTC + (3600000 * options.offset));
                    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
                    //return Math.max(janOffset, julOffset);
                }
                Date.prototype.dst = function() {
                    if( parseFloat(options.offset) <= -4 && parseFloat(options.offset) >= -10 ) {
                        var dCheck = new Date,
                            utcCheck = dCheck.getTime() + (dCheck.getTimezoneOffset() * 60000),
                        newCheck = new Date(utcCheck + (3600000 * options.offset));
                        return this.getTimezoneOffset() < this.stdTimezoneOffset();
                        //return newCheck.getTimezoneOffset() < this.stdTimezoneOffset();
                    }
                }
                // create new date object
                var dateCheck = new Date;

                if( dateCheck.dst() ) {
                   offset = parseFloat(offset) + 1;
                };
                
                setInterval(function () {
                    // create new date object
                    var d = new Date,                   
                        utc = d.getTime() + (d.getTimezoneOffset() * 60000),
                        nd = new Date(utc + (3600000 * nOffset)),                   
                        s = nd.getSeconds(),
                        m = nd.getMinutes(),
                        hh = nd.getHours(),
                        h = hh;

                        //console.log(nOffset);
                    
                    // format for 12 hour
                    if(!options.hour24) {
                        var dd = "AM";
                        if( h >= 12) {
                            h = hh-12;
                            dd = "PM";
                        }
                        if( h == 0 ) {
                            h = 12;
                        }
                    } 
                    // console.log(offset);

                    
                    // display digital clock if enabled
                    if(options.digital) {
                        $('#' + id + ' .digital .hr').html(h < 10 ? "0" + h + ':' : h + ':');
                        $('#' + id + ' .digital .minute').html(m < 10 ? "0" + m : m);
                        if(!options.hour24) {
                            $('#' + id + ' .digital .period').html(dd);
                        }
                    }
                }, 1000);
            });
        }
    });
})(jQuery);; /** ----------------- **/ 
 var AuthToken = function (token, exp, service) {
	this.token = token;
	this.exp = Number(exp) * 1000;
	this.createdAt = new Date().getTime();
	this.service = service;
	this.threshold = Math.max(10, Number(exp) / 6) * 1000;
};

AuthToken.prototype.refresh = function (token, exp) {
	this.token = token;
	this.exp = exp ? Number(exp) * 1000 : this.exp;
	this.createdAt = new Date().getTime();
};

AuthToken.prototype.get = function (callback) {
	var $this = this;

	if ((($this.createdAt + $this.exp - $this.threshold) > new Date().getTime()) && $this.token)
	{
		return callback(null, $this.token);
	}

	var url = "/" + Config.LOCALE_SHORT + "/auth/operation";

	var serviceMap = {
		"lc": "getLcToken",
		"odds": "getOddsToken",
		"mt": "getMemberToken",
		"bt": "getBonusToken"
	}
	var method = serviceMap[this.service];

	ajaxRequest(method, {
		"toastr": false,
		"request": {
			"url": url + "/" + method
		},
		"onComplete": function (data) {
			if (data && data.status == 'success')
			{
				$this.refresh(data.token, data.exp);

				return callback(null, $this.token);
			}

			console.log(data);

			callback(data && data.errors ? data.errors : 'cannot get token');
		}
	});
};

var lct = new AuthToken(null, BaseConfig.get('LIVE_CENTER_EXP'), "lc");
var ost = new AuthToken(Config.ODDS_SERVICE_TOKEN, Config.ODDS_SERVICE_EXP, "odds");

var memberSocketToken = null;
var memberToken = null;
var bonusToken = null;

if(BaseConfig.get('MEMBER_SOCKET')){
	memberToken = new AuthToken(memberSocketToken, BaseConfig.get('MEMBER_SOCKET').exp, 'mt')
}

if(Config.BONUS_SOCKET) {
	bonusToken = new AuthToken(null, Config.BONUS_SOCKET.exp, 'bt')
}
; /** ----------------- **/ 
 var constants = function (constant) {
    /*KYC trigger constants*/
    this.UPON_WITHDRAW_INITIATION = 'upon_withdraw_initiation';

    return this[constant]
}
; /** ----------------- **/ 
 $(function () {

    if (Config.CONTROLLER == 'my' && (Config.ACTION == 'deposit' || Config.ACTION == 'withdraw')) {
        if (typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN) {
            console.log("_smartico: SUSPEND_POPUPS");
            _smartico.suspendPopups(true);
        }
    }

    if (Config.CONTROLLER == 'my' && Config.ACTION == 'withdraw') {
        return
    }

    // Added logic for trustly third party deposits with APP
    if (Config.IS_MOBILE) {
        var searchUrl = window.location.search;
        var depositParam = getParameterByName('d-type', searchUrl);
        if (depositParam == 'trustly') {
            trustlyThirdPartyPosMessageListener();
        }
    }

    isDirectaDepositBankTransfer();

    hasAvailablePaymentMethods();

    manageReadOnlyFields($('#use-member-data'));

    $(document).on('change', '#use-member-data', function () {
        manageReadOnlyFields($(this));
    });

    $(document).on('click', '.quick-deposit-item', function () {
        updateDepositAmount($(this));
    });

    $(document).on('input', '.payment-form-amount', function () {
        var $amountInput = $(this);
        var amount = $amountInput.val();
        var $paymentFormContainer = $amountInput.closest('.payment-form-body');
        $paymentFormContainer.find('.quick-deposit-item').removeClass('selected');
        $paymentFormContainer.find('.quick-deposit-item[data-deposit-value="' + amount + '"]').addClass('selected');
    });

    if (Config.ACTION === 'afterPayment' && getParameterByName('internal_payment_number')) {
        //If we are on the afterPayment page
        var processingApproved = getParameterByName('processingApproved') ? true : false;
        checkDepositStatusUpdate($('.member-details'), getParameterByName('internal_payment_number'), false, processingApproved)
    } else {
        //If we are on any page except the afterPayment page
        if (typeof zE === 'function') {
            var pendingPayments = localStorage.getItem("pendingPayments") ? JSON.parse(localStorage.getItem("pendingPayments")) : {};

            if (Object.keys(pendingPayments).length) {
                var firstAvailablePayment = pendingPayments[Object.keys(pendingPayments)[0]];
                checkFirstPendingDepositStatusUpdate(firstAvailablePayment);
            }
        }
    }

    $(document).on('click', '.copy-qr-address', function (e) {
        var $textContainer = $(".payment-qr-deposit-address-value");
        var $button = $(e.currentTarget);

        $button.removeClass('btn-success').addClass('btn-outline-success').text($button.attr('data-label'))
        CopyToClipboard($textContainer);
    });

    DepositFormValidator();

    if (hasDepositWithdrawKycConditions() && !Config.FORCE_UPLOAD_DOCUMENT.length) {
        var paymentId = getFirstPaymentId();
        if (paymentId) {
            checkKycDepositStatusUpdate(paymentId);
        }
    }
});

function checkKycDepositStatusUpdate(paymentId) {
    $.ajax({
        url: "/" + Config.LOCALE_SHORT + "/my/operation/afterPayment",
        data: {
            paymentId: paymentId
        },
        dataType: 'json',
        method: "GET",
        success: function (response) {
            if (response.data.paymentStatus === 'approved' || response.data.paymentStatus === 'authorized') {
                document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/GET_MEMBER_KYC_CONDITIONS');
                deletePaymentId(paymentId);
                return;
            }
            setTimeout(function () {
                checkKycDepositStatusUpdate(paymentId);
            }, 3000);
        },
        error: function () {
            console.log('KycDepositStatusUpdate error')
        }
    });
}

function isDirectaDepositBankTransfer() {
    var searchUrl = window.location.search;
    var depositMethodParam = getParameterByName('d-method', searchUrl);
    if (depositMethodParam == 'bt') {
        $('.directa-bank-transfer-message').removeClass('d-none');
    } else {
        $('.directa-bank-transfer-message').addClass('d-none');
    }
}

function trustlyThirdPartyPosMessageListener() {
    window.addEventListener('message', function (event) {

        // Ensure that the origin of the message is Trustly
        if (event.origin != 'https://trustly.com') {
            return;
        }

        var data = JSON.parse(event.data);
        if (data.method == 'OPEN_APP') {
            location.assign(data.appURL);
        }
    }, false);
}

function hasAvailablePaymentMethods() {
    var $noAvailablePaymentMethodsModal = $('#noAvailablePaymentMethodsModal'),
        $confirmBtn = $noAvailablePaymentMethodsModal.find('.btn');

    $noAvailablePaymentMethodsModal.modal('show');
    $confirmBtn.on('click', function () {
        window.location = '/' + Config.LOCALE_SHORT + '/' + Config.CONTROLLER + '/account';
    });
}

function updateDepositAmount($quickDepositItem) {
    var depositAmount = $quickDepositItem.attr('data-deposit-value'),
        bcode = $quickDepositItem.attr('data-bcode'),
        $amountField = $quickDepositItem.closest('.validate-form').find('#amount'),
        bcodeField = $quickDepositItem.closest('.validate-form').find('#bonus_code');

    if (!Config.IS_MOBILE) {
        $($amountField).focus();
    }

    $amountField.val(depositAmount).trigger('input');

    if (bcode) {
        bcodeField.val(bcode);
    }

    $('.quick-deposit-item').removeClass('selected');
    $quickDepositItem.addClass('selected');
}

function trackPaymentForZendesk(dataUrl) {
    if (typeof zE === 'function') {
        var param = getParameterByName("internal_payment_number", dataUrl);

        if (param) {
            trackPendingPayment(param);
        }
    }
}

function trackPendingPayment(paymentId) {
    var pendingPayments = localStorage.getItem("pendingPayments") ? JSON.parse(localStorage.getItem("pendingPayments")) : {};
    if (!pendingPayments[paymentId]) {
        pendingPayments[paymentId] = { id: paymentId, time: dateUtil() };
        localStorage.setItem("pendingPayments", JSON.stringify(pendingPayments));
    }
}

function untrackPendingPayment(paymentId) {
    var pendingPayments = JSON.parse(localStorage.getItem("pendingPayments"));
    if (pendingPayments) {
        delete pendingPayments[paymentId];
        localStorage.setItem("pendingPayments", JSON.stringify(pendingPayments));
    }
}

var DepositFormValidator = function (options, $formHolder, $form) {

    var validator = this,
        enterPressed = false,
        currentUrl = window.location.href,
        $formContainer = $formHolder ? $formHolder : $('.payment-provider-container'),
        $guideContainer = $formHolder ? $formHolder.parent().find('.payment-guide-container') : $('.payment-provider-container').parent().find('.payment-guide-container'),
        $validateForm = $form ? $form : $formContainer.find('.validate-form'),
        paymentMethod = $validateForm.attr('data-payment-method'),
        paymentGuide = $validateForm.attr('data-payment-guide'),
        paymentHandler = $validateForm.attr('data-payment-handler'),
        providerPopup = null,
        defaults = {
            ajaxUrl: Config.AJAX_URL
        };

    var isModalView = $formContainer.attr('data-payment-modal');

    validator.settings = {};

    var init = function () {
        validator.settings = $.extend({}, defaults, options);

        $validateForm.on('submit', function (e) {

            e.preventDefault();
            e.stopPropagation();

            if ($validateForm[0].checkValidity() !== false) {
                if (typeof paymentGuide !== 'undefined' && typeof paymentMethod !== 'undefined' && paymentGuide === paymentMethod) {
                    showPaymentGuide(e);
                } else {
                    if (typeof paymentHandler !== 'undefined' && paymentHandler === 'popup') {
                        if (!Config.IS_MOBILE) {
                            providerPopup = PopupCenter('', '', '1150', '900', true, true);
                        } else {
                            providerPopup = PopupCenter('', true);
                        }
                    }

                    const paymentMethod = $(this).closest('form').attr('data-payment-method')
                    window.UILogger.logEvent(window.UILogger.eventNames.Payment.select_submit_button, {
                        paymentMethod: paymentMethod ? paymentMethod : "unknown",
                    })

                    submitForm(e);
                }
            }

            $validateForm.addClass('was-validated');

        });
    };

    var showPaymentGuide = function (e) {
        var $confirmGuide = $guideContainer.find('.guide-confirm-button');
        $formContainer.addClass('d-none');
        $guideContainer.removeClass('d-none');

        $confirmGuide.on('click', function () {
            hidePaymentGuide(e);

            if (typeof paymentHandler !== 'undefined' && paymentHandler === 'popup') {
                if (!Config.IS_MOBILE) {
                    providerPopup = PopupCenter('', '', '1150', '900', true, true);
                } else {
                    providerPopup = PopupCenter('', true);
                }
            }
        });
    };

    var hidePaymentGuide = function (e) {
        $formContainer.removeClass('d-none');
        $guideContainer.addClass('d-none');
        submitForm(e);
    };

    var submitForm = function (e) {

        if (enterPressed == true) {
            return;
        }
        if (!e.which) {
            enterPressed = true;
        }

        var data = $validateForm.serializeArray();

        switch (true) {
            case $validateForm.hasClass('provider-skrill'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-onetap'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-onetap' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-rapid'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'rapid' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-pago-facil'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'pago-facil' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-rapi-pago'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'rapi-pago' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-provincia-pagos'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'provincia-pagos' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-santander-rio'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'santander-rio' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-itau'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'itau' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-banco-de-brasil'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'banco-de-brasil' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bradesco'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bradesco' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-hsbc'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'hsbc' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-caixa'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'caixa' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-santander'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'santander' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-boleto'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'boleto' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-servipag'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'servipag' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-webpay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'webpay' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-banco-de-chile'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'banco-de-chile' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bancolombia'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bancolombia' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-pse'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'pse' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-efecty'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'efecty' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-davivienda'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'davivienda' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-almacenes-exito'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'almacenes-exito' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-carulla'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'carulla' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-empresa-de-energia-de-quindio'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'empresa-de-energia-de-quindio' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-surtimax'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'surtimax' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bancomer'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bancomer' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-banamex'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'banamex' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': '' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-oxxo'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'oxxo' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-banorte'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'banorte' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-spei'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'spei' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-pago-efectivo'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'pago-efectivo' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-western-union'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'western-union' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-scotiabank'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'scotiabank' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-interbank'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'interbank' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bbva'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bbva' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bcp'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bcp' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-redpagos'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'redpagos' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-santander-cash'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'santander-cash' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-neteller'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'neteller' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-paysafecard'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'paysafecard' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-wirecard'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });

                    var $termUrl = $('#TermUrl');

                    if ($termUrl.length > 0) {
                        //                        $termUrl.val($termUrl.data('value') + '&requestUrl=' + encodeURIComponent(currentUrl));
                        $termUrl.val($termUrl.val() + '&requestUrl=' + encodeURIComponent(currentUrl));
                    }
                }
                break;

            case $validateForm.hasClass('provider-banktransfer'):
                data.push({ 'name': 'method', 'value': 'makeBankDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-safecharge'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-unionpay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'unionpay' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-online-bank-transfer'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'online-bank-transfer' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-ecopayz'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'ecopayz' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-sofort'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'sofort' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-fortmatic'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'fortmatic' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-jeton-checkout'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'jeton-checkout' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-jeton-qr'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'jeton-qr' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-jeton-go'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'jeton-go' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-cryptopay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-paykasa'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'paykasa' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bestpay-instant-qr'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bestpay-instant-qr' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bestpay-community-bank'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bestpay-community-bank' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bestpay-cryptopay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bestpay-cryptopay' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-bestpay-redeem-voucher'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'bestpay-redeem-voucher' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-trustly'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'trustly' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-trustly-guest'):
                data.push({ 'name': 'method', 'value': 'makeGuestDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'trustly-guest' });
                data.push({ 'name': 'payment-provider', 'value': 'trustly' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-accentpay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-pradexx'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-rbk-money'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-muchbetter'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-macropay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-mtn'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-directa'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-real-deposits'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-spectrocoin'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-solidpayments'):
            case $validateForm.hasClass('provider-cashu'):
            case $validateForm.hasClass('provider-payop'):
            case $validateForm.hasClass('provider-hexopay'):

                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-paymero'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-zimpler-guest'):
                data.push({ 'name': 'method', 'value': 'makeGuestDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'zimpler-guest' });
                data.push({ 'name': 'payment-provider', 'value': 'zimpler' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-zimpler'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'zimpler' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }

            case $validateForm.hasClass('provider-gate2way'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-astropay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-paysafecard'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-paysafecard' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-giropay'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-giropay' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-online-banking'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-online-banking' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-cash-payment'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-cash-payment' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-pix'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-pix' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-boleto'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-boleto' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-skrill-mach'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': 'skrill-mach' });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-ipp'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;

            case $validateForm.hasClass('provider-volt'):
                data.push({ 'name': 'method', 'value': 'makeDeposit' });
                data.push({ 'name': 'payment-method', 'value': $validateForm.data('payment-method') });
                if (isModalView) {
                    data.push({ 'name': 'requestUrl', 'value': currentUrl });
                }
                break;
        }

        displayFormLoader($formContainer, true);
        var method = null;
        data.forEach(function (d) {
            if (d.name == 'method') {
                method = d.value;
            }
        });
        var depositAmount = _.findWhere(data, { name: "amount" }).value;

        $.ajax(
            validator.settings.ajaxUrl + '/' + method, {
            'data': $.param(data),
            'type': 'POST',
            'dataType': 'json'
        }
        )
            /**
             * @param {object} data
             * @param {string} data.status
             * @param {string} data.error
             * @param {string} data.iframeUrl
             * @param {string} data.redirectUrl
             * @param {string} data.returnUrl
             */
            .done(function (data) {

                if (typeof data.status === 'undefined') {
                    if (typeof paymentHandler !== 'undefined' && paymentHandler === 'popup') {
                        providerPopup.close();
                    }

                    paymentShowError(translation('unknown_error'));
                    return;
                }

                if (data.status === 'error') {
                    if (typeof paymentHandler !== 'undefined' && paymentHandler === 'popup') {
                        providerPopup.close();
                    }

                    paymentHideError();
                    if (data.handling) {
                        if (data.handling === 'ask_leave') {
                            var $modal = $('#depositLeaveCampaignModal');
                            $modal.attr('data-campaign-id', data.campaign_id);
                            $modal.find('.marketing-message-campaign-info').append(data.error);
                            $modal.modal('show');
                            return;
                        } else if (data.handling === 'ask_deposit_without_bonus_code') {
                            var modalMsg = '<p class="text-center mb-0 modal-resp-msg">' + data.error + '</p>',
                                $modal = $('#depositWithoutBonusCodeModal');

                            $modal.find('.modal-resp-msg').remove();
                            $modal.find('.modal-body').prepend(modalMsg);
                            $modal.modal('show');

                            return;
                        } else if (data.handling === 'ask_confirm_amount') {
                            var modalMsg = '<p class="text-center mb-0 modal-resp-msg">' + data.error + '</p>',
                                $modal = $('#depositConfirmAmountModal');
                            $modal.find('.modal-resp-msg').remove();
                            $modal.find('.modal-body').prepend(modalMsg);
                            $modal.modal('show');

                            return;
                        }
                    }

                    zendeskDepositAssistance();

                    paymentShowError(data.error);
                    return;
                }

                if (typeof data.action === 'undefined') {
                    if (typeof paymentHandler !== 'undefined' && paymentHandler === 'popup') {
                        providerPopup.close();
                    }

                    paymentShowError(translation('unknown_error'));
                    return;
                }

                switch (data.action) {
                    case 'iframe':

                        if ($validateForm.data("payment-method") != "sc-interac") {
                            trackPaymentForZendesk(data.iframeUrl);
                        }

                        paymentHideError();
                        if (isModalView || !Config.IS_MOBILE) {
                            $formContainer.addClass('d-none');
                        }

                        var $iframeContainer = $formContainer.next();
                        var $depositIFrame = $iframeContainer.find('#iframe-payment');

                        if (isModalView) {
                            listenForFrameLocationChange($depositIFrame);
                        }

                        if (data.hasOwnProperty('pareq')) {
                            var $depositIFrameForm = $('#credit-card-secure-form');
                            $('#PaReq').val(data.pareq);

                            if (data.hasOwnProperty('paymentId')) {
                                $('#MD').val(data.paymentId);
                            }

                            setIframeFormAction($depositIFrameForm, $iframeContainer, $depositIFrame, data.iframeUrl);

                        } else if ($('form.provider-unionpay').length > 0) {
                            var $depositIFrameForm = $('form#unionpay-token-form');
                            $('input#token').val(data.token);

                            setIframeFormAction($depositIFrameForm, $iframeContainer, $depositIFrame, data.iframeUrl);

                        } else if ($('form.provider-online-bank-transfer').length > 0) {
                            var $depositIFrameForm = $('form#online-bank-transfer-token-form');
                            $('input#token').val(data.token);

                            setIframeFormAction($depositIFrameForm, $iframeContainer, $depositIFrame, data.iframeUrl);

                        } else if ($('form.provider-trustly-guest').length > 0) {
                            var $depositGuestModal = $('#depositGuestModal');
                            if (Config.IS_MOBILE) {
                                if ($depositGuestModal) {
                                    $depositGuestModal.modal('hide');
                                }
                                window.open(data.iframeUrl, '_blank');
                            } else {
                                displayIframe($iframeContainer, $depositIFrame, data.iframeUrl);
                                $depositGuestModal.find('.close').addClass('d-none');
                                $depositGuestModal.find('.modal-nav').addClass('d-none');
                            }
                        } else if ($('form.provider-trustly').length > 0 && Config.IS_MOBILE) {
                            var iframeUrl = data.iframeUrl + '&NotifyParent=1';
                            displayIframe($iframeContainer, $depositIFrame, iframeUrl);
                        } else {
                            displayIframe($iframeContainer, $depositIFrame, data.iframeUrl);
                        }


                        break;
                    case 'redirect':
                        paymentHideError();
                        $validateForm.hide();

                        if ($validateForm.data("payment-method") != "sc-interac") {
                            trackPaymentForZendesk(data.redirectUrl);
                        }

                        window.location.href = data.redirectUrl;
                        break;

                    case 'callback':
                        paymentHideError();
                        $validateForm.hide();

                        if (typeof depositCallback === 'function') {
                            depositCallback(data);
                        }
                        break;

                    case 'qr':
                        paymentHideError();
                        $('.payment-qr-container').removeClass('d-none');
                        if (isModalView || !Config.IS_MOBILE) {
                            $formContainer.addClass('d-none');
                        }
                        $('.payment-qr-deposit-amount-value').text(depositAmount)

                        if (data.status == 'success') {
                            $('.payment-qr-inner').addClass('d-flex');
                            $('.payment-provider-container').addClass('d-none');

                            var $image = $('<img/>', {
                                src: 'data:image/png;base64, ' + data.qr,
                                alt: 'QR image'
                            });

                            $('.payment-qr-image').removeClass('d-none').html($image);
                            checkDepositStatusUpdate($formContainer, data.paymentId, data, true);

                        } else {
                            $('.payment-qr-inner').removeClass('d-flex');
                            $('.payment-provider-container').removeClass('d-none');
                        }
                        break;

                    case 'qr2':
                        paymentHideError();
                        $('.payment-qr-container').removeClass('d-none');
                        if (isModalView || !Config.IS_MOBILE) {
                            $formContainer.addClass('d-none');
                        }
                        $('.payment-qr-deposit-amount-value').text(depositAmount)

                        if (data.status == 'success') {
                            $('.payment-qr-inner').addClass('d-flex');
                            $('.payment-provider-container').addClass('d-none');

                            var $image = $('<img/>', {
                                src: data.qr,
                                alt: 'QR image'
                            });

                            startQRTimer();
                            $('.payment-qr-image').removeClass('d-none').html($image);
                            $('.payment-qr-deposit-address-value').val(data.depositAddress);
                            var transactionAmount = getParameterByName('amount', data.qr);
                            if (transactionAmount) {
                                $('.payment-qr-deposit-btc-amount').removeClass('d-none')
                                $('.payment-qr-deposit-btc-amount-value').text(transactionAmount);
                            }
                            checkDepositStatusUpdate($formContainer, data.paymentId, data, true);
                        } else {
                            $('.payment-qr-inner').removeClass('d-flex');
                            $('.payment-provider-container').removeClass('d-none');
                        }
                        break;

                    case 'popup':
                        if ($('form.provider-cryptopay').length > 0) {
                            var widget = new CryptopayWidget({
                                widgetKey: BaseConfig.get('CRYPTOPAY_WIDGET_KEY'),
                                accounts: [data.currencyTo],
                                embedded: 'true',
                                elId: 'cryptopay-container',
                                styleOptions: {
                                    //closeButtons: 'false'
                                }
                            });

                            widget.pay({
                                amount: data.amount,
                                currency: data.currencyFrom,
                                customId: data.paymentId,
                                onOpen: function () {
                                    $('.payment-provider-container').addClass('d-none');
                                },
                                onClose: function () {
                                    $('.payment-provider-container').removeClass('d-none');
                                }
                            });

                            break;
                        }

                        if ($('form.provider-rbk-money').length > 0) {
                            const checkout = RbkmoneyCheckout.configure({
                                invoiceID: data.invoiceId,
                                invoiceAccessToken: data.invoiceAccessToken,
                                initialPaymentMethod: 'bankCard',
                                wallets: false,
                                terminals: false,
                                applePay: false,
                                googlePay: false,
                                samsungPay: false,
                                MobileCommerce: false,
                                opened: function () {
                                    $('.payment-provider-container').addClass('d-none');
                                },
                                closed: function () {
                                    $('.payment-provider-container').removeClass('d-none');
                                },
                                finished: function () {
                                    $('.payment-provider-container').removeClass('d-none');
                                }
                            });

                            window.addEventListener('popstate', function () {
                                checkout.close();
                            });

                            checkout.open();
                            break;
                        }

                        providerPopup.location.href = data.iframeUrl;
                        providerPopup.focus();
                        break;

                    default:
                        paymentShowError(translation('unknown_error'));
                        return;
                }
            }
            )
            .fail(function () {
                paymentShowError(translation('unknown_error'));
            })
            .always(function () {
                enterPressed = false;
                displayFormLoader($formContainer, false);
            });
    };


    var displayFormLoader = function ($formContainer, showLoader) {
        var $loaderElement = $formContainer;
        var isModalView = $formContainer.attr('data-payment-modal');

        if (isModalView && Config.IS_MOBILE) {
            $loaderElement = $formContainer.closest('.modal-body');
        }
        if (showLoader) {
            if (isModalView) {
                $loaderElement.addClass('loader-circle-box-content loader-white loader-center');
            } else {
                $loaderElement.addClass('view-loader loader-center');
            }
        } else {
            if (isModalView) {
                $loaderElement.removeClass('loader-circle-box-content loader-white loader-center');
            } else {
                $loaderElement.removeClass('view-loader loader-center');
            }
        }

    };

    var setIframeFormAction = function ($depositIFrameForm, $iframeContainer, $depositIFrame, iframeUrl) {
        $depositIFrameForm.attr('action', iframeUrl);
        $depositIFrameForm.submit();
        displayIframe($iframeContainer, $depositIFrame)
    };


    var displayIframe = function ($iframeContainer, $depositIFrame, iframeUrl) {
        if (iframeUrl) {
            $depositIFrame.attr('src', iframeUrl);
        }
        if (Config.IS_MOBILE) {
            if (!isModalView) {
                $("#payment-provider-modal").modal('show');
            } else {
                $iframeContainer.removeClass('d-none').addClass('d-flex');
            }
        } else {
            $iframeContainer.removeClass('d-none');
        }
    };

    var listenForFrameLocationChange = function ($iframeEl) {
        var iframeWindow = $iframeEl[0].contentWindow;
        var baseUrl = Config.BASE_URL;

        if (typeof frameLocationListener === 'undefined') {
            var frameLocationListener = setInterval(
                function () {
                    try {
                        if (iframeWindow.location.href.indexOf(baseUrl) !== -1) {
                            $iframeEl.stop();
                            clearInterval(frameLocationListener);
                            window.location.href = iframeWindow.location.href;
                        }
                    }
                    catch (e) { }
                }, 200
            );
        }
    };

    var paymentShowError = function (error) {
        $formContainer.find('.error-container').removeClass('d-none').append('<div class="alert alert-danger alert-sm text-center" role="alert">' + error + '</div>');
    };

    var paymentHideError = function () {
        $formContainer.find('.error-container').empty().addClass('d-none');
    };

    window.scanQRValidityInterval = null;

    var startQRTimer = function () {
        $('.payment-qr-deposit-valid-value').text('');
        clearInterval(window.scanQRValidityInterval);
        var periodTime = dateUtil(new Date()).add(15, 'm').valueOf();
        $('.payment-qr-time-remaining-container').removeClass('d-none').addClass('d-flex');
        window.scanQRValidityInterval = setInterval(function () {
            var timeRemaining = periodTime - dateUtil().valueOf(new Date());
            var timeHumanReadable = GetHumanReadableTime(timeRemaining);
            $('.payment-qr-deposit-valid-value').text(timeHumanReadable);
            if (timeRemaining <= 0) {
                $('.payment-qr-deposit-valid-value').text('');
                clearInterval(window.scanQRValidityInterval);
                $('.payment-qr-time-remaining-container').addClass('d-none').removeClass('d-flex');
                $('.payment-qr-inner').remove();
                $('.payment-qr-deposit-expired').removeClass('d-none');
            }
        }, 1000)
    }

    init();
};

function checkDepositStatusUpdate($depositContainer, paymentId, afterPaymentData, processingApproved) {

    var $depositSummaryContent = $depositContainer.find('.deposit-summary-content');
    var currentStatus = $depositSummaryContent.attr('current-status');
    if (hasDepositWithdrawKycConditions() && !Config.FORCE_UPLOAD_DOCUMENT.length) {
        savePaymentId(paymentId);
    }
    if (((currentStatus === 'pending' || currentStatus === 'processing') && $depositSummaryContent.is(':visible')) || afterPaymentData) {
        $.ajax({
            url: "/" + Config.LOCALE_SHORT + "/my/operation/afterPayment",
            data: {
                paymentId: paymentId
            },
            dataType: 'json',
            method: "GET",
            success: function (response) {
                if (!afterPaymentData && processingApproved) {
                    response.data.paymentStatus = 'approved'
                }
                if (response.data.paymentStatus !== 'pending' && response.data.paymentStatus !== 'processing') {
                    if (response.data.paymentProvider != "sc-interac") {
                        if (response.data.paymentStatus !== 'approved' && response.data.paymentStatus !== 'authorized') {
                            sendTagAndUntrackPayment(paymentId);

                        }
                        if (response.data.paymentStatus === 'approved' || response.data.paymentStatus === 'authorized') {
                            if (typeof zE === 'function') {
                                window.ZendeskCommunicator.removeTags('deposit_assistance');
                                untrackPendingPayment(paymentId);
                            }
                            if (true) {
                                // if user documents are not approved
                                $('document-warning').addClass('d-flex');
                            }
                        }
                    }

                    $depositContainer.find('.current-status-pending').removeClass('d-flex').addClass('d-none');
                    var $updatedStatus = $depositContainer.find('.updated-status[statuses*="' + response.data.paymentStatus + '"]');
                    $updatedStatus.removeClass('d-none');
                    Mediator.getMediator().trigger("UserBalance_forceUpdate");
                    if (BaseConfig.get('IS_CASINO_MODE') && document.querySelectorAll(".cl-header-user-login")[0]) {
                        document.querySelectorAll(".cl-header-user-login")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
                    }
                    if (hasDepositWithdrawKycConditions() && !Config.FORCE_UPLOAD_DOCUMENT.length) {
                        if (response.data.paymentStatus === 'approved' || response.data.paymentStatus === 'authorized') {
                            document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/GET_MEMBER_KYC_CONDITIONS');
                        }
                    }
                    return;
                }
                if (response.data.paymentStatus !== 'pending' && afterPaymentData) {
                    var isModalView = $depositContainer.attr('data-payment-modal');
                    clearInterval(window.scanQRValidityInterval);
                    if (isModalView) {
                        reactOnPaymentMethodResponse($depositContainer.closest('.modal'), {
                            internal_payment_number: afterPaymentData.paymentId,
                            type: 'deposit',
                            'returned-payment-status': response.data.paymentStatus
                        }, processingApproved);
                    } else {
                        var afterPaymentURL = Config.LOCALE_URL
                            + '/my/after-payment?internal_payment_number=' + afterPaymentData.paymentId
                            + '&returned-payment-status=' + response.data.paymentStatus
                            + '&processingApproved=' + processingApproved;
                        window.location.href = afterPaymentURL;
                    }
                    return;
                }
                if (response.data.paymentStatus === 'pending' && typeof zE === 'function') {
                    if (response.data.paymentProvider != "sc-interac") {
                        trackPendingPayment(paymentId);
                        var payment = JSON.parse(localStorage.getItem("pendingPayments"))[paymentId];
                        var secondsFromNow = dateUtil().diff(payment.time, 'seconds');
                        if (secondsFromNow > 60) {
                            sendTagAndUntrackPayment(payment.id);
                        }
                    }
                }
                setTimeout(function () {
                    checkDepositStatusUpdate($depositContainer, paymentId, afterPaymentData, processingApproved)
                }, 3000);
            },
            error: function () {
                console.log('error')
            }
        })
    }
}

function sendTagAndUntrackPayment(paymentId) {
    if (typeof zE !== 'undefined') {
        zendeskDepositAssistance();
        untrackPendingPayment(paymentId);
    }
}
function zendeskDepositAssistance() {
    if (typeof zE !== 'undefined' && Config.ZD_DEPOSIT_ASSISTANCE) {
        var tags = JSON.parse(window.localStorage.getItem("zEchatTags"));
        if (!tags) {
            window.localStorage.setItem("zEchatTags", '[]');
            tags = JSON.parse(window.localStorage.getItem("zEchatTags"));
        }
        if (tags.indexOf("deposit_assistance") === -1 && window.ZendeskCommunicator && typeof window.ZendeskCommunicator.addTags === 'function') {
            window.ZendeskCommunicator.addTags('deposit_assistance');
            tags.push('deposit_assistance');
            window.localStorage.setItem("zEchatTags", JSON.stringify(tags));
        }
    }
}
function checkFirstPendingDepositStatusUpdate(payment) {
    $.ajax({
        url: "/" + Config.LOCALE_SHORT + "/my/operation/afterPayment",
        data: {
            paymentId: payment.id
        },
        dataType: 'json',
        method: "GET",
        success: function (response) {
            if (response.data.paymentProvider != "sc-interac") {
                if (response.data.paymentStatus === 'pending') {
                    var secondsFromNow = dateUtil().diff(payment.time, 'seconds');
                    if (secondsFromNow > 60) {
                        sendTagAndUntrackPayment(payment.id);
                        return;
                    }
                }
                if (response.data.paymentStatus != 'pending' && response.data.paymentStatus != 'approved' && response.data.paymentStatus != 'authorized') {
                    sendTagAndUntrackPayment(payment.id);
                    return;
                }
                if ((response.data.paymentStatus === 'approved' || response.data.paymentStatus === 'authorized') && typeof zE === 'function') {
                    window.ZendeskCommunicator.removeTags('deposit_assistance');
                    untrackPendingPayment(payment.id);
                    return;
                }
                setTimeout(function () {
                    checkFirstPendingDepositStatusUpdate(payment)
                }, 10000);
            }
        },
        error: function () {
            console.log('checkFirstPendingDepositStatusUpdate error')
        }
    })
}
function hasDepositWithdrawKycConditions() {
    if (
        Config.KYC_CONDITIONS.deposit_amount ||
        Config.KYC_CONDITIONS.deposits_number ||
        Config.KYC_CONDITIONS.withdraw_amount ||
        Config.KYC_CONDITIONS.withdraw_number ||
        Config.KYC_CONDITIONS.pending_withdraw_amount ||
        Config.KYC_CONDITIONS.pending_withdraw_number
    ) {
        return true;
    }
    return false;
}
function savePaymentId(id) {
    var pendingTransactions = JSON.parse(localStorage.getItem('pendingTransactions')) || [];
    if (pendingTransactions.indexOf(id) === -1) {
        pendingTransactions.push(id);
        localStorage.setItem('pendingTransactions', JSON.stringify(pendingTransactions));
    }
}
function getFirstPaymentId() {
    var pendingTransactions = JSON.parse(localStorage.getItem('pendingTransactions'));
    if (pendingTransactions) {
        return pendingTransactions[0];
    }
    return false;
}
function deletePaymentId(id) {
    var pendingTransactions = JSON.parse(localStorage.getItem('pendingTransactions'));
    pendingTransactions.splice(pendingTransactions.indexOf(id), 1);
    if (!pendingTransactions.length) {
        return localStorage.removeItem('pendingTransactions');
    }
    localStorage.setItem('pendingTransactions', JSON.stringify(pendingTransactions));
}

var MemberPermissions = function () {
    var permissions = null;
    var retryCount = 0;
    var trackError = false;

    var requestPermissions = function () {
        ajaxRequest('getMemberPermissions', {
            request: {
                url: "/" + Config.LOCALE_SHORT + "/responsible-gaming/operation/memberPermissions",
                async: false,
            },
            toastr: false,
            onSuccess: function (response) {
                if (response.data) {
                    retryCount = 0;
                    trackError = false;
                    sessionStorage.removeItem('memberPermissionsErrorReload');
                    permissions = Object.assign({}, response.data);
                    document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_MEMBER_PERMISSIONS', permissions)
                }
            },
            onFinish: function (data, response, status) {
                if (status === 'error' || !response.responseText) {
                    permissions = null;
                    trackError = true;
                    if (retryCount < 4) {
                        retryCount++;
                        requestPermissions();
                    }
                }
            },
        });
    }

    var trackResponseError = function () {
        if (window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
            if (sessionStorage.getItem('memberPermissionsErrorReload')) {
                window.ErrorTracker.trackError(new Error('Cannot get member permissions after reload'), { error_type: 'member permissions error' })
            } else {
                window.ErrorTracker.trackError(new Error('Cannot get member permissions after retry'), { error_type: 'member permissions error' })
            }
        }
    }

    var getMemberPermissions = function () {
        requestPermissions();
        retryCount = 0;

        if (trackError) {
            trackError = false;
            trackResponseError();
        }

        return permissions
    }

    return {
        getMemberPermissions
    }
}; /** ----------------- **/ 
 $(function(){
    if(Config.PLUGIN_MODE) {
        return;
    }
    localStorage.removeItem("depositBonusCode");
    if(Config.USER_LOGGED_IN != 1){
        return;
    }
    var $depositModal = $('#depositModal');
    getDepositMethods($depositModal);

    $depositModal.on('hidden.bs.modal', function (e) {
        window.VueEventBus && window.VueEventBus.$emit('hidden_deposit_modal', 'depositModal');
        if (window.WebPage && window.ReactNativeWebView) {
            window.WebPage.sendMessage({
                type: 'SET_DEPOSIT_MODAL_OPENED',
                payload: false
            });
        }
        localStorage.removeItem("depositBonusCode");
        if(Config.USER_IDLE){
            window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
            window.location.reload();
        }else{
            clearCashierModal($depositModal);
            displayPaymentMethodsList($depositModal, true);
        }

        if ($('#game-frame').hasClass('visible') && !$('#game-frame').hasClass('campaign-promotion')) {
            hideChatWidget();
        }

        if(typeof _smartico !== 'undefined' &&
            Config.USER_LOGGED_IN &&
            !$('#game-frame').hasClass('visible') &&
            (Config.ACTION !== 'deposit' && Config.ACTION !== 'withdraw')
        ){
            console.log("_smartico: RELEASE_POPUPS");
            _smartico.suspendPopups(false);
        }
    });

    $(document).on('click', '.header-deposit-button', function(e){
        localStorage.removeItem('featuredDepositUrl');
    })

    $(document).on('click', '.featured-deposit-method', function(){
        var featuredDepositUrl = $(this).attr('data-featured-deposit-url');
        if(Config.FEATURED_DEPOSIT_METHOD.quick_deposit === 'finrax'){
            return;
        }
        if(featuredDepositUrl){
            localStorage.setItem('featuredDepositUrl', featuredDepositUrl);
        }
    });

    $depositModal.on('show.bs.modal', function(e) {
        if (window.handlePayNPlayOptionsCashierModal(e)) {
            e.preventDefault();
            window.payNPlayComposable && window.payNPlayComposable.setShowDepositOptionModal(true);
            var $modal = $(this);

            // Fully reset the modal
            $modal.removeClass('show');
            $modal.css('display', 'none');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            // Reset Bootstrap data
            var modalInstance = $modal.data('bs.modal');
            if (modalInstance) {
                modalInstance._isShown = false;
                modalInstance._isTransitioning = false;
            }
            return;
        }
        window.VueEventBus && window.VueEventBus.$emit('shown_deposit_modal', 'depositModal');
        if (window.WebPage && window.ReactNativeWebView) {
            window.WebPage.sendMessage({
                type: 'SET_DEPOSIT_MODAL_OPENED',
                payload: true
            });
        }

        var verifyAccountModal = document.getElementById("verify-account-modal");
        if(verifyAccountModal){
            if(Config.FORCE_UPLOAD_DOCUMENT.poa){
                e.stopPropagation();
                e.preventDefault();
                verifyAccountModal.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_VERIFY_ACCOUNT_CURRENT_DOCUMENT_TYPE', 'poa');
                return false;
            }
        }

        if(typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN){
            console.log("_smartico: SUSPEND_POPUPS");
            _smartico.suspendPopups(true);
        }

        if ($('#game-frame').hasClass('visible') && !$('#game-frame').hasClass('campaign-promotion')) {
            showChatWidget();
        }

        if(e.relatedTarget && $(e.relatedTarget).attr('data-featured-deposit-url')) {
            displayFeaturedPaymentMethod($depositModal);
            return;
        }
        if($depositModal.find('.payment-method-item').length == 1 && Config.CASHIER === 'default') {
            var $paymentMethodsList = $depositModal.find('#paymentMethodsList');
            var url = $depositModal.find('.payment-method').attr("href");

            $paymentMethodsList.addClass('d-none');
            getDepositMethodForm($depositModal, url, true);
        }
    });

    $depositModal.on('shown.bs.modal', function () {
        if ($('#completeRegisterModal').length && $('#completeRegisterModal').hasClass('show')) {
            $('#completeRegisterModal, #depositModal').attr('tabindex', '');
        }
    })

    $depositModal.find('#depositModalBack').on("click", function(e){
        displayPaymentMethodsList($depositModal, true);
        renderPaymentStatusResponse($depositModal, "");
    });

    $(document).on("click", "#depositModal .payment-method", function(e){
        e.preventDefault();
        $('#depositModal').scrollTop(0);
        var url = $(this).attr("href");
        getDepositMethodForm($depositModal, url);
    });
});

function isDirectaDepositModalBankTransfer(searchUrl) {
    var depositMethodParam = getParameterByName('d-method', searchUrl);
    if(depositMethodParam == 'bt' ) {
        $('.directa-bank-transfer-message').removeClass('d-none');
    } else {
        $('.directa-bank-transfer-message').addClass('d-none');
    }
}

//Open Deposit Modal
function getDepositMethods($depositModal) {
    var lang = Config.LOCALE_SHORT;
    var errorHtml = generateErrorHtml('error_request');

    toggleCashierModalLoader($depositModal, true);

    $.ajax({
        url: "/" + lang + "/my/deposit-methods",
        dataType: "html",
        method: "GET",
        success: function(data) {
            if(data) {
                if($(data).find('.payment-method-item').length == 1 && Config.CASHIER === 'default') {
                    var url = $(data).find('.payment-method').attr("href");
                    $depositModal.find('#paymentMethodsList').addClass('d-none');
                    getDepositMethodForm($depositModal, url, true);
                }

                var hasFeaturedDeposit = 0;
                if(Config.FEATURED_DEPOSIT_METHOD && Config.FEATURED_DEPOSIT_METHOD.quick_deposit){
                    hasFeaturedDeposit = $(data).find('.payment-method').filter('.deposit-' + Config.FEATURED_DEPOSIT_METHOD.method).length;
                    if(hasFeaturedDeposit){
                        var $featuredDeposit = $('.featured-deposit-method');
                        if(Config.IS_MOBILE){
                            $featuredDeposit = $('.featured-deposit-col')
                            $featuredDeposit.removeClass('d-none')
                        }else{
                            $featuredDeposit.removeClass('d-none').addClass('d-flex')
                        }
                    }
                }
                renderPaymentMethodsList($depositModal, data);
            } else {
                renderPaymentMethodsList($depositModal, errorHtml);
            }
        },
        error: function() {
            renderPaymentMethodsList($depositModal, errorHtml);
        }
    }).always(function(data) {
        if($(data).find('.payment-method-item').length == 1) {
            return
        }

        toggleCashierModalLoader($depositModal, false);
    });
}

function renderPaymentMethodsList($depositModal, html){
    $depositModal.find('#paymentMethodsList').html(html);
    displayFeaturedPaymentMethod($depositModal);
}

function displayFeaturedPaymentMethod($depositModal){
    //send to the end of the callstack so localStorage is updated
    setTimeout(function(){
        var featuredDepositUrl = localStorage.getItem('featuredDepositUrl');
        if(featuredDepositUrl){
    var $paymentMethodsList = $depositModal.find('#paymentMethodsList');
    $paymentMethodsList.addClass('d-none');
    getDepositMethodForm($depositModal, featuredDepositUrl, true);
            localStorage.removeItem('featuredDepositUrl');
        }
    })
}

function getDepositMethodForm($depositModal, url, disableBackToList) {

    var errorHtml = generateErrorHtml('error_request');

    toggleCashierModalLoader($depositModal, true);

    $.ajax({
        url: url,
        dataType: "html",
        method: "GET",
        success: function(data) {
            if(data) {
                renderPaymentMethodForm($depositModal, data);
                isDirectaDepositModalBankTransfer(url);
                if($(data).find('#depositModalConversionFeeInfo').length) {
                    initConversionFeeCalculator($('#depositModalConversionFeeInfo'));
                    initConversionFeeUpdater($('#depositModalConversionFeeInfo'), true);
                }
                detectHashChange($depositModal);
            } else {
                renderPaymentMethodForm($depositModal, errorHtml);
                zendeskDepositAssistance();
            }
        },
        error: function() {
            renderPaymentMethodForm($depositModal, errorHtml);
            zendeskDepositAssistance();
        }
    }).always(function(){
        displayPaymentMethodsList($depositModal, false, disableBackToList);
        toggleCashierModalLoader($depositModal, false);
    });
}

function renderPaymentMethodForm($depositModal, html){
    $depositModal.find('#paymentFormContainer').html(html);
    if(Config.QUICK_DEPOSIT){
        var bonusCode = localStorage.getItem("depositBonusCode");
        if(bonusCode){
            $depositModal.find('#bonus_code').val(bonusCode);
        }
    }
}

function displayPaymentMethodsList($displayModal, display, disableBackToList){
    var $paymentMethodsList = $displayModal.find('#paymentMethodsList'),
        $paymentFormContainer = $displayModal.find('#paymentFormContainer'),
        $backButton = $displayModal.find('#depositModalBack');

    if(display){
        $paymentMethodsList.removeClass('d-none');
        $paymentFormContainer.addClass('d-none');
        $backButton.addClass('d-none');
    }else {
        $paymentMethodsList.addClass('d-none');
        $paymentFormContainer.removeClass('d-none');
        if(!disableBackToList) {
            $backButton.removeClass('d-none');
        }
    }
}
; /** ----------------- **/ 
 function isEpsCashierV2Active($modal) {
    return Config.CASHIER === 'eps' && $modal.hasClass('cashier-smartpayz-v2')
}

function getActiveCouponRoot($modal) {
    if (Config.CASHIER !== 'eps') {
        return $modal
    }

    return isEpsCashierV2Active($modal)
        ? $modal.find('#cashier-coupon-code-v2-wrapper')
        : $modal.find('#cashier-coupon-code-v1-wrapper')
}

function hasActiveDepositCouponCodes() {
    var appComponents = document.getElementById('appComponents')
    var store = appComponents && appComponents.__vueParentComponent
        && appComponents.__vueParentComponent.appContext.config.globalProperties.$store

    return Boolean(store && store.state.user.activeCouponCodes && store.state.user.activeCouponCodes.length)
}

function applyEpsCashierTheme(theme) {
    var $cashierModal = $('#cashierModal')
    var $cashierThemeToggle = $cashierModal.find('#cashier-theme-toggle')
    var isDark = theme === 'dark'
    $cashierModal.toggleClass('dark-scheme', isDark)
    $cashierThemeToggle.prop('checked', isDark)
    localStorage.setItem('EPS_cashier_v2_theme', theme)
    window.VueEventBus && window.VueEventBus.$emit('eps-cashier-theme-changed')
    var frame = document.getElementById('cashierFrame')
    if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ type: 'SET_THEME_MODE', payload: theme }, '*')
    }
}

function bindCashierThemeToggle() {
    var $cashierThemeToggle = $('#cashierModal').find('#cashier-theme-toggle')
    if (!$cashierThemeToggle.length || $cashierThemeToggle.data('eps-theme-bound')) {
        return
    }
    $cashierThemeToggle.data('eps-theme-bound', true)
    $cashierThemeToggle.on('change', function () {
        applyEpsCashierTheme($cashierThemeToggle.prop('checked') ? 'dark' : 'light')
    })
}

function bindEpsV2CouponHandlers() {
    var $cashierModal = $('#cashierModal')
    if (!$cashierModal.length || $cashierModal.data('eps-coupon-bound') || !isEpsCashierV2Active($cashierModal)) {
        return
    }

    var $couponRoot = getActiveCouponRoot($cashierModal)
    var $cashierCouponCodeForm = $couponRoot.find('#cashierCouponCodeForm')
    var $cashierCouponCodeLink = $couponRoot.find('.cashier-coupon-code-link')
    var submitButton = $cashierCouponCodeForm.find('.form-submit-button')

    if (!$cashierCouponCodeForm.length) {
        return
    }

    $cashierModal.data('eps-coupon-bound', true)

    $cashierCouponCodeForm.find('input[name="code"]').on('input', function () {
        var couponCode = $cashierCouponCodeForm.find('input[name="code"]').val()
        couponCode && couponCode.length > 1
            ? submitButton.removeClass('disabled loader-circle-inline-full loader-left').removeAttr('disabled')
            : submitButton.addClass('disabled loader-circle-inline-full loader-left').attr('disabled', true)
    })

    $cashierCouponCodeLink.on('click', function () {
        $(this).hide()
        $couponRoot.find('.cashier-coupon-code-activation-form .form-control').val('')
        $couponRoot.find('#cashierCouponCodeFormWrapper').show()
    })
}

function clearEpsCouponHandlersBinding() {
    $('#cashierModal').data('eps-coupon-bound', false)
}

function normalizeEpsStoreTheme(theme) {
    if (theme === 'dark') {
        return 'dark'
    }
    if (theme === 'light' || theme === 'default' || theme) {
        return 'light'
    }
    return null
}

function getCashierEpsStoreTheme() {
    var appComponents = document.getElementById('appComponents')
    var store = appComponents && appComponents.__vueParentComponent
        && appComponents.__vueParentComponent.appContext.config.globalProperties.$store

    return store && store.state.cashier.epsDefaultTheme
}

function resolveEpsCashierTheme() {
    var userTheme = localStorage.getItem('EPS_cashier_v2_theme')
    if (userTheme === 'dark' || userTheme === 'light') {
        return userTheme
    }

    var storeTheme = normalizeEpsStoreTheme(getCashierEpsStoreTheme())
    if (storeTheme) {
        return storeTheme
    }

    return normalizeEpsStoreTheme(BaseConfig.get('EPS_DEFAULT_THEME')) || 'light'
}

function syncEpsCouponActivationUiOnVersionSwitch($modal) {
    if (Config.CASHIER !== 'eps' || !$modal || !$modal.length) {
        return
    }

    var $couponRoot = getActiveCouponRoot($modal)

    if (isEpsCashierV2Active($modal)) {
        $couponRoot.find('.cashier-coupon-code-link').show()
        $couponRoot.find('#cashierCouponCodeFormWrapper').hide()
    }

    $modal.attr('data-activated-coupon', false)
    toggleCashierModalCouponActivationLink($modal)
}

window.applyEpsCashierTheme = applyEpsCashierTheme
window.bindEpsCashierThemeToggle = bindCashierThemeToggle
window.bindEpsV2CouponHandlers = bindEpsV2CouponHandlers
window.clearEpsCouponHandlersBinding = clearEpsCouponHandlersBinding
window.syncEpsCouponActivationUiOnVersionSwitch = syncEpsCouponActivationUiOnVersionSwitch

$(function(){
    if(Config.USER_LOGGED_IN != 1){
        return;
    }

    var memberPermissions = MemberPermissions();
    var $cashierModal = $('#cashierModal');
    var isCuracaoLicense = BaseConfig.get('LICENSE') && (BaseConfig.get('LICENSE').curacao || BaseConfig.get('LICENSE').curacao_seal);
    var cashierMaintenance = false;
    var preventCashierHiddenByCloseIcon = false;
    var cashierLogTimeout;

    function setCashierModalAfterRegistration(value) {
        if ($cashierModal[0]) {
            $cashierModal[0].__epsCashierAfterRegistration = value;
        }
    }

    function clearEpsCashierModalAnalyticsSession() {
        setCashierModalAfterRegistration(undefined)
    }

    function clearEpsCashierQuickDepositBootstrap() {
        if (typeof window !== 'undefined') {
            window.EpsCashierQuickDepositBootstrap = false
        }
    }

    function getCashierModalAfterRegistration() {
        return Boolean($cashierModal[0] && $cashierModal[0].__epsCashierAfterRegistration === true)
    }

    function openWithdrawalCashierAfterFeeCheck() {
        $cashierModal.data('withdrawal_fee_checked', true);
        $cashierModal.data('cashier_method', 'withdrawal');
        $cashierModal.modal('show');
    }

    function resetCashierOpenedState() {
        if (window.WebPage && window.ReactNativeWebView) {
            window.WebPage.sendMessage({
                type: 'SET_DEPOSIT_MODAL_OPENED',
                payload: false
            });
        }

        if(document.getElementById('appComponents')){
            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_CASHIER_MODAL_OPENED', false);
        }
    }

    function shouldRunWithdrawalFeeCheck(cashierMethod, withdrawalFeeChecked) {
        return Config.CASHIER === 'eps'
            && cashierMethod === 'withdrawal'
            && BaseConfig.get('WITHDRAWAL_FEE_ENABLED') === '1'
            && !withdrawalFeeChecked
            && window.withdrawalFeeCheck
            && typeof window.withdrawalFeeCheck === 'function';
    }

    if (isEpsCashierV2Active($cashierModal)) {
        applyEpsCashierTheme(resolveEpsCashierTheme())
        bindCashierThemeToggle()
        bindEpsV2CouponHandlers()
    }

    $cashierModal.on('show.bs.modal', function (e) {
        if (window.handlePayNPlayOptionsCashierModal(e)) { // TODO: doubled logic
            e.preventDefault();
            window.payNPlayComposable && window.payNPlayComposable.setShowDepositOptionModal(true);
            var $modal = $(this);

            // Fully reset the modal
            $modal.removeClass('show');
            $modal.css('display', 'none');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            // Reset Bootstrap data
            var modalInstance = $modal.data('bs.modal');
            if (modalInstance) {
                modalInstance._isShown = false;
                modalInstance._isTransitioning = false;
            }
            return;
        }
        if (window.WebPage && window.ReactNativeWebView) {
            window.WebPage.sendMessage({
                type: 'SET_DEPOSIT_MODAL_OPENED',
                payload: true
            });
        }

        if (cashierLogTimeout) {
            clearTimeout(cashierLogTimeout);
        }

        if(document.getElementById('appComponents')){
            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_CASHIER_MODAL_OPENED', true);
        }

        var $targetEl = e.relatedTarget ? $(e.relatedTarget) : undefined;
        var cashierMethod = $(this).data('cashier_method');
        var withdrawalFeeChecked = Boolean($(this).data('withdrawal_fee_checked'));

        if (!cashierMethod) {
            cashierMethod = $targetEl ? $targetEl.attr('data-cashier-method') : 'deposit';
        }
        else {
            $(this).removeData('cashier_method');
        }

        if (withdrawalFeeChecked) {
            $(this).removeData('withdrawal_fee_checked');
        }

        setCashierModalAfterRegistration(
            cashierMethod === 'deposit' && window.EpsCashierQuickDepositBootstrap === true
        );

        if (
            window.localStorage.getItem('MGA_LIMITS_LINK')
            && cashierMethod === 'deposit'
            && BaseConfig.get('ENABLE_DEPOSIT_LIMIT_IN_CASHIER') !== '1'
        ) {
            $('.mga-container').removeClass('d-none');
        }

        if(cashierMethod === 'withdrawal' && window.preventCashierModal()){
            return e.preventDefault();
        }
        if(cashierMethod === 'withdrawal' && !getSelectedPixKey()) {
            e.preventDefault();
            var appComponents = document.querySelector('#appComponents')
            if(
                appComponents &&
                appComponents.__vueParentComponent &&
                appComponents.__vueParentComponent.appContext.config.globalProperties.$bvModal
            ){
                var bvModal = appComponents.__vueParentComponent.appContext.config.globalProperties.$bvModal;
                    bvModal.show('pixKeyWithdrawalModal')
            }
            $cashierModal.trigger('hide.bs.modal');
            $cashierModal.trigger('hidden.bs.modal');
            return;
        }
        if(Number(BaseConfig.get('CUSTOM_PERSONAL_DETAILS_FLOW')) && $('#completeRegisterModal').length){
            var $completeRegisterModal = $('#completeRegisterModal');
            $completeRegisterModal.find('.complete-register-information').text(translation('PAYMENTS.complete_profile_before_' + cashierMethod))
            $('#completeRegisterModal').modal('show');
            var paymentIQCashierContainer = document.getElementById("paymentIQCashierContainer");
            if(paymentIQCashierContainer){
                paymentIQCashierContainer.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_HAS_PAYMENT_IQ_PERSONAL_DATA', false);
            }
            return e.preventDefault();
        }

        if (shouldRunWithdrawalFeeCheck(cashierMethod, withdrawalFeeChecked)) {
            e.preventDefault();
            window.withdrawalFeeCheck({
                onContinue: openWithdrawalCashierAfterFeeCheck,
                onCancel: resetCashierOpenedState,
            });
            return;
        }

        displayCashierModalTitle(cashierMethod, $cashierModal);

        if(cashierMethod === 'withdrawal'){
            $('.deposit-info-box').addClass('d-none');
            window.VueEventBus.$emit('hide-coupon-codes');
        }

        if (isEpsCashierV2Active($cashierModal)) {
            var $couponRoot = getActiveCouponRoot($cashierModal);
            const $cashierCouponCodeHolder = $couponRoot.find('.cashier-coupon-code-holder');
            const $cashierCouponCodeLink = $couponRoot.find('.cashier-coupon-code-link');
            const submitButton = $couponRoot.find('#cashierCouponCodeForm .form-submit-button');
            const isNewLayout = BaseConfig.get('IS_NEW_LAYOUT')

            if (cashierMethod === 'withdrawal') {
                if (isNewLayout) {
                    $cashierCouponCodeHolder.show()
                    $cashierCouponCodeLink.hide()
                } else {
                    $cashierCouponCodeHolder.hide()
                }
            } else {
                $cashierCouponCodeHolder.show()
            }

            submitButton.addClass('disabled loader-circle-inline-full loader-left').attr('disabled', true);
        }

        var permissions = memberPermissions.getMemberPermissions();

        if(!permissions && !isCuracaoLicense) {
            $('#paymentError').removeClass('d-none')
        } else if (permissions && permissions[cashierMethod] === false) {
            $('#paymentPermission').removeClass('d-none').find('.' + cashierMethod + '-not-allowed').removeClass('d-none')
        } else {
            $('#paymentPermission').addClass('d-none').find('.' + cashierMethod + '-not-allowed').addClass('d-none')
            $('#paymentError').addClass('d-none')
            if(Config.CASHIER === 'praxis') {
                document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.dispatch('application/GET_CASHIER_MAINTENANCE');
                window.cashierEl = $targetEl;
                window.cashierModal = $cashierModal;
                //loadCashier($targetEl, $cashierModal);
                updateVueApplicationStoreCashierMethod($targetEl, cashierMethod);
            }

            if(Config.LOAD_VUE_CASHIER_CONTAINER) {
                document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/GET_PENDING_WITHDRAWALS');
                updateVueApplicationStoreCashierMethod($targetEl, cashierMethod);
            }
            // Pre-populate bonus code
            if(getParameterByName("bcode")) {
                //DEP-4237
                var $couponRoot = getActiveCouponRoot($cashierModal);
                $couponRoot.find('#cashierCouponCodeForm input[name="code"]').val(getParameterByName("bcode")).trigger('input');
            }
        }

        if(typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN){
            console.log("_smartico: SUSPEND_POPUPS");
            _smartico.suspendPopups(true);
        }

        if (window.popupChannelSuppressPopups) {
            window.popupChannelSuppressPopups();
        }

        if ($('.visible').not('.campaign-promotion').is('#game-frame, #vue-game-frame')) {
            showChatWidget();
        }

        if (window.VueEventBus) {
            window.VueEventBus.$on('cashier-um', function() {
                cashierMaintenance = true;
            })
        }

        hideActivateCouponCodeInCashier();
        if (permissions && permissions[cashierMethod] === true && cashierMethod === 'deposit' && Config.USER_STATUS !== 'suspended') {
            Mediator.getMediator().trigger('GetCouponCodes')
            Mediator.getMediator().on('ActivatedCouponCode', function () {
                if (cashierMaintenance === false) {
                    hideActivateCouponCodeInCashier();
                    toggleCashierModalActivatedCouponCode($cashierModal);
                }
            });
            Mediator.getMediator().on('ShowCashierActivateCouponCodeForm', function () {
                if (cashierMaintenance === false) {
                    if (hasActiveDepositCouponCodes()) {
                        hideActivateCouponCodeInCashier();
                        toggleCashierModalActivatedCouponCode($cashierModal);
                        return;
                    }
                    $cashierModal.attr('data-activated-coupon', false);
                    toggleCashierModalCouponActivationLink($cashierModal);
                    if (Config.CASHIER === 'praxis') {
                        $('#cashierModal').find('#cashierCouponCodeFormWrapper').collapse('show');
                    } else if (!isEpsCashierV2Active($cashierModal)) {
                        toggleCashierCouponCodeForm($cashierModal);
                    }
                }
            });
            if (hasActiveDepositCouponCodes()) {
                hideActivateCouponCodeInCashier();
                toggleCashierModalActivatedCouponCode($cashierModal);
            }
        }
    });

    $cashierModal.on('shown.bs.modal', function () {
        if (typeof window.startCashierModalHeartbeat === 'function') {
            window.startCashierModalHeartbeat();
        }
        if (isEpsCashierV2Active($cashierModal)) {
            applyEpsCashierTheme(resolveEpsCashierTheme())
        }

        window.dispatchEvent(new CustomEvent('cashier-modal-opened'));
        window.VueEventBus && window.VueEventBus.$emit('shown_cashier_modal', 'cashierModal');
        if ($('#completeRegisterModal').length && $('#completeRegisterModal').hasClass('show')) {
            $('#completeRegisterModal, #cashierModal').attr('tabindex', '');
        }

        const cashierIntent = $('#appComponents')[0] && $('#appComponents')[0].__vueParentComponent && $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store.state.cashier.cashierMethod || '';
        const afterRegistration = getCashierModalAfterRegistration();

        window.UILogger && window.UILogger.logEvent(window.UILogger.eventNames.Payment.cashier__show_deposit_modal, {
            member_id: window.BaseConfig.get('MEMBER_ID') || '',
            provider: Config.CASHIER ? Config.CASHIER : '',
            intent: cashierIntent,
            first_time_deposit: window.Config.IS_DEPOSITED === '0',
            after_registration: afterRegistration,
        })

        if (window.Config.IS_MOBILE) {
            $("#cashierModal button.close").addClass('d-none');
            setTimeout(function () {
                $("#cashierModal button.close").removeClass("d-none");
            }, 3000);
        }
    })

    $cashierModal.on('hide.bs.modal', function (e) {
        if (preventCashierHiddenByCloseIcon) {
            e.preventDefault()

            setTimeout(function () {  // 500ms timeout for iframe to send a log event
                preventCashierHiddenByCloseIcon = false;
                $cashierModal.modal('hide');
            }, 500);
        }
    })

    $cashierModal.on('hidden.bs.modal', function (e) {
        if (typeof window.stopCashierModalHeartbeat === 'function') {
            window.stopCashierModalHeartbeat();
        }
        const afterRegistration = getCashierModalAfterRegistration();

        window.dispatchEvent(new CustomEvent('cashier-modal-closed'));

        window.VueEventBus && window.VueEventBus.$emit('hidden_cashier_modal', 'cashierModal');

        if (window.popupChannelReleasePopups) {
            window.popupChannelReleasePopups();
        }

        Mediator.getMediator().off('ShowCashierActivateCouponCodeForm')
        Mediator.getMediator().off('ActivatedCouponCode')
        Mediator.getMediator().trigger('UserBalance_forceUpdate')

        if (window.WebPage && window.ReactNativeWebView) {
            window.WebPage.sendMessage({
                type: 'SET_DEPOSIT_MODAL_OPENED',
                payload: false
            });
        }

        const cashierIntent = $('#appComponents')[0] && $('#appComponents')[0].__vueParentComponent && $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store.state.cashier.cashierMethod || '';

        window.UILogger && window.UILogger.logEvent(window.UILogger.eventNames.Payment.cashier__hide_deposit_modal, {
            member_id: window.BaseConfig.get('MEMBER_ID') || '',
            intent: cashierIntent,
            first_time_deposit: window.Config.IS_DEPOSITED === '0',
            after_registration: afterRegistration,
        })

        clearEpsCashierQuickDepositBootstrap();
        clearEpsCashierModalAnalyticsSession();
        cashierMaintenance = false;

        if(document.getElementById('appComponents')){
            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_CASHIER_MODAL_OPENED', false);
        }

        $('.deposit-info-box').removeClass('d-none');
        $('.payment-info').addClass('d-none');
        $('#paymentError').addClass('d-none')
        if(Config.CASHIER === 'praxis') {
            if (Config.USER_IDLE) {
                window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                window.location.reload();
            } else {
                clearCashierModal($cashierModal);
            }
            if(Config.CASHIER_UM){
                window.VueEventBus.$emit('destroyCountdown')
            }
        }

        if(Config.LOAD_VUE_CASHIER_CONTAINER) {
            cashierLogTimeout = setTimeout(() => updateVueApplicationStoreCashierMethod(), 300);
        }

        if(hasDepositWithdrawKycConditions() && !Config.FORCE_UPLOAD_DOCUMENT.length){
            setTimeout(function (){
                document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/GET_MEMBER_KYC_CONDITIONS');
            }, 2000);
        }

        clearCashierCouponCodeForm(true, true);
        toggleCashierModalActivatedCouponCode($cashierModal, 'hide');

        if (BaseConfig.get('SHOW_DEPOSIT_MESSAGE_FOR_SPECIAL_METHODS')) {
            toggleCashierDepositMessageForSpecialMethods($cashierModal, 'hide');
        }

        if(typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN && !$('#game-frame').hasClass('visible')){
            console.log("_smartico: RELEASE_POPUPS");
            _smartico.suspendPopups(false);
        }

        if ($('.visible').not('.campaign-promotion').is('#game-frame, #vue-game-frame')) {
            hideChatWidget();
        }
        $('.mga-container').addClass('d-none')
        if (window.localStorage.getItem('MGA_LIMITS_LINK')){
            window.localStorage.removeItem('MGA_LIMITS_LINK')
        }
        if(Config.WHITE_LABEL_REGULATIONS.enable_pix_keys_for_cashier){
            document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit('cashier/SET_WITHDRAW_PIX_KEY', '')
        }
        if(BaseConfig.get('BIOMETRIC_CONFIG') && BaseConfig.get('BIOMETRIC_CONFIG').upon_withdrawal_request){
            window.clearFacialCheckCall()
        }
    });

    $cashierModal.on('click', 'button.close', function () {
        var cashierFrame = document.getElementById('cashierFrame');

        if (cashierFrame) {
            preventCashierHiddenByCloseIcon = true;
            //TODO deprecate CASHIER_MODAL_CLOSED, remove timeout
            cashierFrame.contentWindow.postMessage({type: 'CASHIER_MODAL_CLOSED'}, '*')
        }
        if(window.VueEventBus) {
            window.VueEventBus.$emit('CASHIER_MANUAL_CLOSE');
        }
    });

    $cashierModal.on('submit', '#cashierCouponCodeForm', function(e){
        e.preventDefault();

        var $cashierCouponCodeForm = $(this);
        var $couponRoot = getActiveCouponRoot($cashierModal);

        if (!$couponRoot.length || !$.contains($couponRoot[0], this)) {
            return;
        }

        var $cashierCouponCodeContainer = $couponRoot.find('.cashier-coupon-code-container');
        var formIsValid = Validator.validateElements($cashierCouponCodeForm);
        if(!formIsValid) {
            return;
        }

        $couponRoot.find('.cashier-coupon-code-container .alert-coupon-activation').alert('close');
        $couponRoot.find('.cashier-coupon-code-container .cashier-coupon-code-activation-form').removeClass('errored');

        var $element = $cashierCouponCodeForm.find('.form-submit-button');
        var couponCode = $cashierCouponCodeForm.find('input[name="code"]').val();

        activateCouponCode($element, couponCode, 'alert', $cashierCouponCodeContainer, clearCashierCouponCodeForm);
    });

    if(Config.QUICK_DEPOSIT && Config.CASHIER === 'praxis') {
        initListenForCashierMessage($cashierModal);
    }
});

function loadCashier($targetEl, $cashierModal) {
    var currentUrl = window.location.href;
    var cashier = Config.CASHIER;
    var cashierMethod = $targetEl ? $targetEl.attr('data-cashier-method') : 'deposit';
    var cashierAction = cashierMethod === 'withdrawal' ? cashier + 'Withdrawal' : cashier + 'Deposit';
    var ajaxUrl = '/'+ Config.LOCALE_SHORT + '/my/operation/' + cashierAction;
    var errorHtml = generateErrorHtml('error_request');

    toggleCashierModalLoader($cashierModal, true);
    var data = {
        modalView: 1,
        requestUrl: currentUrl
    };
    var featuredDepositMap = {
        finrax: 'altcrypto',
    };
    if( (Config.FEATURED_DEPOSIT_METHOD && Config.FEATURED_DEPOSIT_METHOD.quick_deposit) && ($targetEl && $targetEl.data("featuredDepositUrl")) ){
        data.externalMethod = featuredDepositMap[Config.FEATURED_DEPOSIT_METHOD.quick_deposit];
    }
    if (cashier === 'praxis') {
        data.screen_height = window.innerHeight
        data.screen_width = window.innerWidth
    }
    $.ajax({
        url: ajaxUrl,
        data: data,
        dataType: "json",
        method: "GET",
        success: function(response) {
            if(response && response.status === 'success') {
                renderCashier($cashierModal, response.data);
                if(cashierMethod === 'deposit') {
                    if($cashierModal.attr('data-activated-coupon') === "true") {
                        toggleCashierModalActivatedCouponCode($cashierModal);
                    } else {
                        toggleCashierModalCouponActivationLink($cashierModal);
                        toggleCashierCouponCodeForm($cashierModal);
                    }
                    if (BaseConfig.get('SHOW_DEPOSIT_MESSAGE_FOR_SPECIAL_METHODS') && response.data && response.data.show_deposit_message_for_special_methods) {
                        toggleCashierDepositMessageForSpecialMethods($cashierModal, 'show');
                    }
                }
            } else {
                if(response.error) {
                    errorHtml = generateErrorHtml(undefined, response.error);
                }
                if (response.status === 'error' && cashierMethod === 'withdrawal' && response.error_type === 'withdrawal_minimum_threshold_amount') {
                    var store = document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store;
                    store.commit('cashier/SET_WITHDRAWAL_THRESHOLD_TEXT', response.error_msg);
                }

                clearCashierModal($cashierModal);
                renderPaymentStatusResponse($cashierModal, errorHtml);
                zendeskDepositAssistance();
                clearCashierCouponCodeForm(true, true);
                toggleCashierModalActivatedCouponCode($cashierModal, 'hide');
            }
        },
        error: function() {
            clearCashierModal($cashierModal);
            renderPaymentStatusResponse($cashierModal, errorHtml);
            zendeskDepositAssistance();
            clearCashierCouponCodeForm(true, true);
            toggleCashierModalActivatedCouponCode($cashierModal, 'hide');
        }
    }).always(function() {
        toggleCashierModalLoader($cashierModal, false);
    });
}

function hideCashierModal() {
    $('#cashierModal').modal('hide')
}

function renderCashier($cashierModal, data) {
    var $cashierFrame = $cashierModal.find("#cashierFrame");
    if(data.redirect_url === $cashierFrame.attr('src')){
        $cashierFrame.removeClass('d-none');
        return;
    }
    $cashierFrame.removeClass('d-none').attr('src', data.redirect_url);
}

function displayCashierModalTitle(cashierMethod, $cashierModal) {
    var title = translation('HEADER.deposit');

    if(cashierMethod === 'withdrawal') {
        title = translation('HEADER.withdraw');
    } else if(cashierMethod === 'transactions') {
        title = translation('HEADER.transactions');
    }
    var $cashierModalEl = $cashierModal || $('#cashierModal');
    $cashierModalEl.find('.modal-title').text(title);
}

function initListenForCashierMessage($cashierModal) {
    window.addEventListener("message", function(e) {
        //TODO Refactor this check depending on prod implementation
        if (e.origin.indexOf('praxis') !== -1) {
            reactOnCashierMessage($cashierModal, e.data);
        }
    }, false);
}

function reactOnCashierMessage($modal, msg) {
    if(typeof msg === 'number') {
        document.getElementById('cashierFrame').height = msg;
    } else {
        var message = JSON.parse(msg);

        if(message.action === 'close') {
            $modal.modal('hide');
        }

        if(message.type === 'deposit-approved') {
            Mediator.getMediator().trigger("UserBalance_forceUpdate");
            if(BaseConfig.get('IS_CASINO_MODE') && document.querySelectorAll(".cl-header-user-login")[0]){
                document.querySelectorAll(".cl-header-user-login")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
            }

            if (typeof zE === 'function') {
                window.ZendeskCommunicator.removeTags('deposit_assistance');
            }

            var gtmDepositTrack = 'depositcofirm';
            if(!Config.IS_DEPOSITED){
                gtmDepositTrack = 'firstdepositcofirm';
            }
            setGtmDataLayer({
                'accountId': BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '',
                'currency': Config.CURRENCY_CODE
            }, gtmDepositTrack);
        }

        if(message.type === 'deposit-pending') {
            //Handle Pending Deposit Status
        }

        if(message.type === 'deposit-rejected') {
            zendeskDepositAssistance();
        }
    }
}

function hideActivateCouponCodeInCashier() {
    var $cashierModal = Config.CASHIER === 'default' ? $('#depositModal') : $('#cashierModal');

    $cashierModal.attr('data-activated-coupon', true);
    toggleCashierModalCouponActivationLink($cashierModal, 'hide');
    toggleCashierCouponCodeForm($cashierModal, 'hide');
}

function getActivatedCouponMount($couponRoot) {
    var $vueCoupons = $couponRoot.find('#deposit-modal-active-coupons-container')

    if ($vueCoupons.length) {
        return $vueCoupons
    }

    return $couponRoot.find('#cashierActivatedCouponCodeWrapper')
}

function toggleCashierModalActivatedCouponCode($modal, action) {
    var $couponRoot = getActiveCouponRoot($modal)
    var $activatedMount = getActivatedCouponMount($couponRoot)

    if (!$activatedMount.length) {
        return
    }

    if(typeof action !== 'undefined' && action === 'hide') {
        window.VueEventBus.$emit('hide-coupon-codes')
        if ($activatedMount.is('#cashierActivatedCouponCodeWrapper')) {
            $activatedMount.collapse('hide')
        } else {
            $activatedMount.hide()
        }
    } else {
        hideActivateCouponCodeInCashier()
        window.VueEventBus.$emit('show-coupon-codes')
        if (isEpsCashierV2Active($modal)) {
            $couponRoot.find('.cashier-coupon-code-link').hide()
        }
        if ($activatedMount.is('#cashierActivatedCouponCodeWrapper')) {
            $activatedMount.collapse('show')
        } else {
            $activatedMount.show()
        }
    }
}

function toggleCashierModalCouponActivationLink($modal, action) {
    var $couponRoot = getActiveCouponRoot($modal);
    var $couponWrapper = $couponRoot.find('#cashierCouponCodeFormWrapper')
    var $couponActivationLink = Config.CASHIER === 'eps'
        ? $modal.find('#cashier-coupon-v1-header-link-wrapper .modal-header-link')
        : $modal.find('.modal-header-link')
    var $cashierCouponCodeLink = $couponRoot.find('.cashier-coupon-code-link')

    if (typeof action !== 'undefined' && action === 'hide') {
        $couponActivationLink.addClass('d-none')
        if (isEpsCashierV2Active($modal)) $cashierCouponCodeLink.hide()
    } else {
        $couponActivationLink.removeClass('d-none')
        if (isEpsCashierV2Active($modal) && $couponWrapper.css('display') === 'none') {
            if (getParameterByName("bcode")) {
                $couponWrapper.find('input[name="code"]').val(getParameterByName("bcode"))
                    .end()
                    .show()
                    .collapse('show');
                $cashierCouponCodeLink.hide();
            } else {
                $cashierCouponCodeLink.show();
            }
        }
    }
}

function toggleCashierCouponCodeForm($modal, action, hideCouponLink) {
    var $couponRoot = getActiveCouponRoot($modal);
    var $couponWrapper = $couponRoot.find('#cashierCouponCodeFormWrapper')

    // Default to 'show' if action is undefined
    var collapseAction = action === 'hide' ? 'hide' : 'show'

    if(collapseAction === 'hide' && isEpsCashierV2Active($modal)) {
        $couponWrapper.hide()
        if (hideCouponLink) $couponRoot.find('.cashier-coupon-code-link').hide()
    }

    // If collapsing or expanding, queue the action
    if ($couponWrapper.hasClass('collapsing') && action) {
        $couponWrapper.one('hidden.bs.collapse shown.bs.collapse', () => {
            $couponWrapper.collapse(collapseAction)
        })
        return
    }

    // Perform the action immediately if no transition is in progress
    $couponWrapper.collapse(collapseAction)
}

function toggleCashierDepositMessageForSpecialMethods($modal, action) {
    if(typeof action !== 'undefined' && action === 'hide') {
        $modal.find('#specialMethodsMessage').addClass('d-none');
    } else {
        $modal.find('#specialMethodsMessage').removeClass('d-none');
    }
}

function clearCashierCouponCodeForm(noDelay, switchToLink) {
    var $cashierModal = $('#cashierModal');
    var $couponRoot = getActiveCouponRoot($cashierModal);

    $couponRoot.find('#cashierCouponCodeForm').find('input').val('');
    toggleCashierModalCouponActivationLink($cashierModal, 'hide');
    if (switchToLink) {
        toggleCashierCouponCodeForm($cashierModal, 'hide');

        if (isEpsCashierV2Active($cashierModal)) $couponRoot.find('.cashier-coupon-code-link').show();
    }

    if (noDelay) {
        $couponRoot.find('.cashier-coupon-code-container .alert-coupon-activation').alert('close');
        $couponRoot.find('.cashier-coupon-code-container .cashier-coupon-code-activation-form').removeClass('errored');
    } else {
        setTimeout(function () {
            $couponRoot.find('.cashier-coupon-code-container .alert-coupon-activation').alert('close');
            $couponRoot.find('.cashier-coupon-code-container .cashier-coupon-code-activation-form').removeClass('errored');
        }, 3000)
    }
}

function updateVueApplicationStoreCashierMethod($element, intent) {
    var cashierMethod = null

    if ($element && $element.attr('data-cashier-method')) {
        cashierMethod = $element.attr('data-cashier-method');
    }

    if (cashierMethod === null && intent) {
        cashierMethod = intent;
    }

    if ($('#cashierContainer')[0]) {
        $('#cashierContainer')[0].__vueParentComponent.appContext.config.globalProperties.$store.commit('cashier/SET_CASHIER_METHOD', cashierMethod);
    }

    if (document.getElementById('appComponents') && document.getElementById('appComponents').__vueParentComponent && cashierMethod) {
        document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('cashier/SET_CASHIER_METHOD', cashierMethod);
    }

}

function preventCashierModal(noTrackBalance) {
    //pass true for noTrackBalance in cases when we need to prevent paymentsNotAllowed modal or withdrawNotAllowed modal and show KYC
    //noTrackBalance should not be passed in cases when the user have payments and withdraw allowed
    //isKycUser stands for required KYC documents
    var $vueApp = document.querySelector('#appComponents')
    var memberKycStatus =
        ($vueApp &&
        $vueApp.__vueParentComponent &&
        $vueApp.__vueParentComponent.appContext.config.globalProperties) ? $vueApp.__vueParentComponent.appContext.config.globalProperties.$store.state.user.accountStatuses.kyc_status : Config.MEMBER_KYC_STATUS
    console.log($vueApp &&
    $vueApp.__vueParentComponent &&
    $vueApp.__vueParentComponent.appContext.config.globalProperties ? 'memberKycStatus from vuex' : 'memberKycStatus from Config', memberKycStatus)

    var kycBehaviorMap = {
        isKycUser: ["fully-verified", "old-member"].indexOf(memberKycStatus) === -1 && !!Config.USER_LOGGED_IN,
        showKycOnWithdraw: (BaseConfig.get('KYC_SETTINGS') && BaseConfig.get('KYC_SETTINGS').enable_kyc_upon_withdraw === '1') || (BaseConfig.get('MEMBER_SETTINGS') && BaseConfig.get('MEMBER_SETTINGS').kyc_trigger_on === constants('UPON_WITHDRAW_INITIATION')),
    }
    var appComponents = document.querySelector('#appComponents')
    if(
        (parseFloat(Config.USER_BALANCE) !== 0 || noTrackBalance) &&
        kycBehaviorMap.isKycUser &&
        kycBehaviorMap.showKycOnWithdraw &&
        Config.KYC_CONFIG
    ){
        var accepted_statuses = {
            id: ['verified', 'unhandled'],
            poa: ['verified', 'unhandled', 'pending'],
            pm: ['verified', 'unhandled', 'pending']

        }

        var verification = ""
        if (BaseConfig.get('USE_NEW_KYC_LOGIC') === '0'){
            var docsOrder = ['id', 'poa', 'pm', 'email', 'phone'];
            docsOrder.forEach(function(item) {
                if(Config.KYC_CONFIG[item]){
                    if(verification === "" && (Config.KYC_CONFIG[item] instanceof Array && !Config.KYC_CONFIG[item].length) && Config.KYC_CONFIG[item] !== 'verified'){
                        verification = item;
                    }
                }
            });
        } else {
            verification = ['id', 'poa', 'pm', 'email', 'phone'].find(function(item){
                if (!Config.KYC_CONFIG[item]) {
                    return false
                }
                var isEmptyArray = Config.KYC_CONFIG[item] instanceof Array && !Config.KYC_CONFIG[item].length
                var hasPaymentRecords = item === 'pm' && Config.KYC_CONFIG[item] instanceof Array && Config.KYC_CONFIG[item].length
                var paymentDocumentStatusNotAccepted = false
                var nonPaymentItemDocumentStatusNotAccepted = item !== 'pm' && accepted_statuses[item] && accepted_statuses[item].indexOf(Config.KYC_CONFIG[item].back_office_verification_status) === -1
                if(hasPaymentRecords){
                    paymentDocumentStatusNotAccepted = Config.KYC_CONFIG[item].some(function(pm){
                        if (!pm.paymentInfo || (pm.paymentInfo && accepted_statuses.pm.indexOf(pm.paymentInfo.back_office_verification_status) === -1)) {
                            var submittedPaymentAccountIds = document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.state.user.submittedPayments
                            if (!submittedPaymentAccountIds || submittedPaymentAccountIds.length === 0) {
                                return true
                            }

                            var hasNonSubmittedPaymentAccountIds = pm.paymentAccountIds.find(account => {
                                return submittedPaymentAccountIds.indexOf(account) === -1
                            })

                            return Boolean(hasNonSubmittedPaymentAccountIds)
                        }
                    })
                }
                return (isEmptyArray || paymentDocumentStatusNotAccepted || nonPaymentItemDocumentStatusNotAccepted)
            })
        }

        if(verification){
            document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit("user/SET_VERIFY_ACCOUNT_CURRENT_DOCUMENT_TYPE", verification);
            return true;
        }
    }
    if(["fully-verified"].indexOf(Config.MEMBER_KYC_STATUS) === -1 && !!Config.USER_LOGGED_IN && BaseConfig.get('NO_KYC_CLIENT_WITHDRAW_RULE') === '1'){
        if(
            appComponents &&
            appComponents.__vueParentComponent &&
            appComponents.__vueParentComponent.appContext.config.globalProperties.$bvModal
        ){
            var bvModal = appComponents.__vueParentComponent.appContext.config.globalProperties.$bvModal;
                bvModal.show('accountVerificationNeeded')
                return true
        }
    }
    if (
        appComponents &&
        appComponents.__vueParentComponent &&
        appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.user.cryptoUserWithNotVerifiedEmail
    ) {
        appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_DISPLAY_EMAIL_VERIFICATION_MODAL', true);
        return true;
    }
    return false;
}

// Activate Coupon Code
function activateCouponCode($element, couponCode, notification, $notificationTarget, callback) {
    var ajaxUrl = '/'+ Config.LOCALE_SHORT + '/activate-coupon/operation/activateCoupon';
    var $cashierModal = $('#cashierModal');
    var isEpsV2CouponForm = isEpsCashierV2Active($cashierModal) && $element.closest('#cashierCouponCodeForm').length;
    var errorMsg = translation('DEPOSIT_MODAL.error_request');
    var data = {
        code: couponCode
    };

    if(notification === 'alert' || notification === 'silent') {
        data['isRead'] = 1;
    }

    $.ajax({
        url: ajaxUrl,
        data: data,
        dataType: "json",
        method: "GET",
        beforeSend: function() {
            $element.addClass('disabled loader-circle-inline-full loader-left').attr('disabled', true);
        },
        success: function(response) {
            if(notification === 'popup') {
                if (response.status === 'success') {
                    var sportsbookIframeConfig = BaseConfig.get('SPORTSBOOK_IFRAME');
                    var isInternalProvider = sportsbookIframeConfig && sportsbookIframeConfig.provider === 'INTERNAL';
                    var triggerHeaderIndicatorsAfterCoupon = function () {
                        Mediator.getMediator().trigger('HeaderIndicators_forceUpdate', {
                            activate_coupon: 1,
                        });
                    };
                    if (isInternalProvider) {
                        console.log('HeaderIndicators_forceUpdate (activate_coupon) invocation scheduled for after 2 seconds');
                        setTimeout(triggerHeaderIndicatorsAfterCoupon, 2000);
                    } else {
                        triggerHeaderIndicatorsAfterCoupon();
                    }
                } else {
                    renderCouponCodeActivationErrorModal(response.error);
                }
            } else if(notification === 'alert') {
                renderCouponCodeActivationAlert($notificationTarget, response);

                if(response.status === 'success' && typeof callback === 'function') {
                    callback(false, false);
                }
            } else if(notification === 'silent') {
                if (response.status === 'success' && typeof callback === 'function') {
                    callback(false, false);
                } else {
                    renderCouponCodeActivationErrorModal(response.error);
                    $element.removeClass('disabled loader-circle-inline-full loader-left').removeAttr('disabled');
                }
            }

            if(Config.CASHIER === 'praxis') {
                Mediator.getMediator().trigger('GetCouponCodes')
                if (response.status === 'success') {
                    $('#cashierModal').find('#cashierCouponCodeFormWrapper').collapse('hide')
                }
            }

            var vueApp = $('#appComponents')[0]
            if(vueApp.__vueParentComponent.appContext.config.globalProperties.$route.name === "Campaigns"){
                vueApp.__vueParentComponent.appContext.config.globalProperties.$store.dispatch('campaigns/GET_MEMBER_COUPONS');
            }

            if(Config.LOAD_VUE_CASHIER_CONTAINER) {
                var $cashierContainer = $('#cashierContainer')[0];
                $cashierContainer.__vueParentComponent.appContext.config.globalProperties.$eventBus.$emit('update-user-active-coupon-codes');
            }
        },
        error: function() {
            renderCouponCodeActivationErrorModal(errorMsg);
            if (isEpsV2CouponForm) $element.removeClass('disabled loader-circle-inline-full loader-left').removeAttr('disabled');
        }
    }).always(function() {
        if(!(isEpsV2CouponForm && $element.parent('#cashierCouponCodeForm').length)) {
            $element.removeClass('disabled loader-circle-inline-full loader-left').removeAttr('disabled');
        }
    });
}

function renderCouponCodeActivationErrorModal(msg) {
    var $modal = $('#modalNotification');

    $modal.find('.modal-notification-message-content').html(msg);
    $modal.modal('show');

    $modal.on('hidden.bs.modal', function() {
        $modal.find('.modal-notification-message-content').html('');
    })
}

function renderCouponCodeActivationAlert($target, data) {
    var $cashierModal = $('#cashierModal');
    var $cashierCouponCodeInput = getActiveCouponRoot($cashierModal).find('.cashier-coupon-code-activation-form');
    var alertMsg = data.status === 'success' ? data.success : data.error;
    var alertType = data.status === 'success' ? 'alert-success' : 'alert-danger';
    var alertHtml = '<div class="alert ' + alertType + ' alert-dismissible alert-coupon-activation fade show" role="alert">';
    alertHtml += alertMsg;
    alertHtml += '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
    alertHtml += '</div>';

    isEpsCashierV2Active($cashierModal)
        ? $target.append(alertHtml)
        : $target.prepend(alertHtml);
    if (data.status !== 'success') $cashierCouponCodeInput.addClass('errored');
}

function getSelectedPixKey() {
    var pixRegulationEnabled = Config.WHITE_LABEL_REGULATIONS.enable_pix_keys_for_cashier;
    var vueApp = $('#appComponents')[0];
    var pixKeyPreference = vueApp.__vueParentComponent.appContext.config.globalProperties.$store.state.cashier.withdrawPixKey;

    if (!pixRegulationEnabled) {
        return true
    }
    // check store
    return pixKeyPreference !== '';
}
; /** ----------------- **/ 
 window.__INITIALIZE_ZENDESK__ = function(callback) {
    //TODO we can use util function for loading script presented in modern bundle
    if(!window.BaseConfig.get('ZENDESK_API_KEY') || !window.Config.HAS_LIVE_CHAT) {
        return
    }
    if(document.getElementById('ze-snippet')){
        callback()
        return
    }
    var script = document.createElement("script");
    script.onload = function(){
        initZdChatPopup(callback)
    };
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + BaseConfig.get('ZENDESK_API_KEY');
    script.id = "ze-snippet";
    document.body.appendChild(script)
}
//Load always for desktop
$(function() {
    if(!Config.IS_MOBILE || Config.USER_LOGGED_IN) {
        window.__INITIALIZE_ZENDESK__()
    }
})

function initZdChatPopup(callback) {
    if(typeof zE !== 'undefined') {

        var zdLocale = initZendeskLocaleAndDepartments().locale;
        zE(function() {

            zendeskWidgetType = zE.prototype.constructor.widget
            window.ZendeskCommunicator = new ZendeskCommunicator();
            setZendeskLocaleTags();
            if (Config.IS_MOBILE) {
                window.__UPDATE_ZENDESK_WIDGET__('hide');
            }
            window.ZendeskCommunicator.setLocale(zdLocale);
            var identify = {};
            if (window.BaseConfig && BaseConfig.get('MEMBER_NAME')) {
                identify.name = BaseConfig.get('MEMBER_NAME');
            }
            if (window.BaseConfig && BaseConfig.get('MEMBER_EMAIL')) {
                identify.email = BaseConfig.get('MEMBER_EMAIL');
            }
            if (Object.keys(identify).length && zendeskWidgetType === 'classic') {
                zE.identify(identify);
            }

            if (zendeskWidgetType === 'classic') {
                zE('webWidget:on', 'chat:end', function () {
                    window.ZendeskCommunicator.removeTags('deposit_assistance');
                });
            }

            if(Config.USER_LOGGED_IN === "1" && BaseConfig.get('MEMBER_ZD_TOKEN') && zendeskWidgetType === 'messenger') {
                zE("messenger", "loginUser", function (callback) {
                    callback(BaseConfig.get('MEMBER_ZD_TOKEN'));
                })
            }

            var tags = JSON.parse(window.localStorage.getItem("zEchatTags"));
            if (tags && tags.length) {
                window.ZendeskCommunicator.addTags(tags)
            }
            if (Config.USER_LOGGED_IN === "") {
                if (tags) {
                    window.ZendeskCommunicator.removeTags(tags);

                    window.localStorage.removeItem("pendingPayments");
                    window.localStorage.removeItem("zEchatTags");
                }
            }
            // setTimeout(function () {
            //     $('.live-chat-popup').removeClass('d-none').addClass('d-flex');
            // }, 2000);
            window.ZendeskCommunicator.listenEvent('open', function (number) {
                var uiLoggerSent = window.localStorage.getItem('UiLoggerSent');
                if (!uiLoggerSent) {
                    window.UILogger.logEvent(window.UILogger.eventNames.LiveChat.open);
                }
                window.localStorage.removeItem('UiLoggerSent');
                if (zendeskWidgetType === 'messenger') {
                    window.localStorage.setItem('zendeskChatOpened', true);
                }
                if (Config.IS_MOBILE && document.getElementById('launcher')) {
                    document.getElementById('launcher').parentElement.classList.remove('d-none');
                }
            })
            window.ZendeskCommunicator.listenEvent('unreadMessages', function (number) {
                if (Config.IS_MOBILE && number > 0) {
                    window.__UPDATE_ZENDESK_WIDGET__('show');
                    if (document.getElementById('launcher')) {
                        document.getElementById('launcher').parentElement.classList.remove('d-none');
                    }
                }
                if (Config.IS_MOBILE && number === 0 && !window.localStorage.getItem('zendeskChatOpened') && zendeskWidgetType === 'messenger') {
                    window.__UPDATE_ZENDESK_WIDGET__('hide');
                }
                if (zendeskWidgetType === 'classic') {
                    window.__UPDATE_ZENDESK_WIDGET__('open');
                }
            });
            if (Config.IS_MOBILE) {
                window.ZendeskCommunicator.listenEvent('close', function () {
                    window.localStorage.removeItem('zendeskChatOpened');
                    window.__UPDATE_ZENDESK_WIDGET__('hide');
                    if (document.getElementById('launcher')) {
                        document.getElementById('launcher').parentElement.classList.add('d-none');
                    }
                });
            }
            if (zendeskWidgetType === 'classic') {
                zE('webWidget:on', 'chat:start', function () {
                    updateDepartment()
                    window.UILogger.logEvent(window.UILogger.eventNames.LiveChat.start);
                });
                zE('webWidget:on', 'chat:end', function () {
                    window.ZendeskCommunicator.removeTags('deposit_assistance');
                });
            }
            if (Config.ACTION === 'play') {
                window.__UPDATE_ZENDESK_WIDGET__('hide');
            }
            var tags = JSON.parse(window.localStorage.getItem("zEchatTags"));
            if (tags && tags.length) {
                window.ZendeskCommunicator.addTags(tags)
            }
            if (Config.USER_LOGGED_IN === "") {
                if (tags) {
                    window.ZendeskCommunicator.removeTags(tags);

                    window.localStorage.removeItem("pendingPayments");
                    window.localStorage.removeItem("zEchatTags");
                }
            }
            if (callback) {
                callback()
            }
        });

        if (Config.ACTION !== 'afterPayment') {
            var pendingPayments = localStorage.getItem("pendingPayments") ? JSON.parse(localStorage.getItem("pendingPayments")) : {};

            if (Object.keys(pendingPayments).length) {
                var firstAvailablePayment = pendingPayments[Object.keys(pendingPayments)[0]];
                checkFirstPendingDepositStatusUpdate(firstAvailablePayment);
            }
        }
    }

}
$(document).on('click', '.live-chat-popup', function (e) {
    e.preventDefault();
    window.__SHOW_ZENDESK_WIDGET__()
    return false;
});

window.__SHOW_ZENDESK_WIDGET__ = function () {

    if (window.ChatWidget) {
        var proactiveActive =
            (typeof window.ChatWidget.getActiveSession === 'function' && window.ChatWidget.getActiveSession()) ||
            window.ChatWidget.chatOpened === true ||
            window.ChatWidget.hasActiveSession === true;
        if (proactiveActive) {
            window.ChatWidget.show();
            window.ChatWidget.open();
            if (!window.ChatWidget.chatOpened && typeof window.ChatWidget.chatButtonHandler === 'function') {
                window.ChatWidget.chatButtonHandler();
            }
            return;
        }
    }

    if(!window.BaseConfig.get('ZENDESK_API_KEY') || !window.Config.HAS_LIVE_CHAT) {
        return
    }

    if(Config.IS_MOBILE){
        window.__INITIALIZE_ZENDESK__(function() {
            setTimeout(function() {
                window.__UPDATE_ZENDESK_WIDGET__('show');
                window.__UPDATE_ZENDESK_WIDGET__('open');
                window.ZendeskCommunicator.listenEvent('close', function () {
                    window.__UPDATE_ZENDESK_WIDGET__('hide');
                });
            }, 100)
        })
    } else {
        window.__UPDATE_ZENDESK_WIDGET__('open');
    }
}

window.__UPDATE_ZENDESK_WIDGET__ = function (method) {
    if (window.ZendeskCommunicator && typeof window.ZendeskCommunicator.updateWebWidget === 'function') {
        window.ZendeskCommunicator.updateWebWidget(method);
    }
}


function zEGetDepartment(){
    var selectedDepartment = '';
    if(!window.BaseConfig) {
        return selectedDepartment
    }
    switch (Object.keys(BaseConfig.get('LICENSE'))[0]) {
        case 'curacao':
            selectedDepartment = 'TC'
            break
        case 'curacao_seal':
            selectedDepartment = 'TC'
            break
        case 'mga':
            selectedDepartment = 'TM'
            break
    }
    return selectedDepartment
}
function updateDepartment(){
    if(Config.ZENDESK_ROUTING && zendeskWidgetType === 'classic') {
        zE('webWidget', 'updateSettings', {
            webWidget: {
                chat: {
                    departments: {
                        enabled: [''],
                        select: zEGetDepartment()
                    }
                }
            }
        });
    }
}
function setZendeskLocaleTags() {
    var lastLocale = localStorage.getItem('locale');
    if(lastLocale && lastLocale !== Config.LOCALE_SHORT){
        window.ZendeskCommunicator.removeTags('locale_' + lastLocale);
        if(localeGroups[lastLocale]){
            window.ZendeskCommunicator.removeTags('locale_group_' + localeGroups[lastLocale]);

        }
        if(localeGroups[Config.LOCALE_SHORT]){
            window.ZendeskCommunicator.addTags('locale_group_' + localeGroups[Config.LOCALE_SHORT])
        }
    }
    localStorage.setItem('locale', Config.LOCALE_SHORT);

    if (newVipAccountManager || currentVipAccountManager){
        if ('sales_' + newVipAccountManager !== currentVipAccountManager) {
            window.ZendeskCommunicator.removeTags(currentVipAccountManager);
        }
    }

}
function initZendeskLocaleAndDepartments() {
    var locale = Config.LOCALE_SHORT;
    var topTitleMap = {
        "en-UK": 'Chat with us',
        // Arabic
        "ar-AE": 'دردش معنا',
        // Chinese (Simplified)
        "zh-ZH": '与我们交谈',
        // Chinese (Traditional)
        "zh-TW": '和我們聊聊',
        // 	Finnish (Finland)
        "fi-FI": 'Chattaa kanssamme',
        // French (France)
        "fr-FR": 'Discuter avec nous',
        // French Canadian
        "fr-CA": 'Clavardez avec nous',
        "de-DE": 'Chat mit uns',
        // Greek (Greece)
        "el-EL": 'Συνομιλήστε μαζί μας',
        // Indonesian (Indonesia)
        "id-ID": 'Bicara dengan kami',
        "it-IT": 'Chatta con noi',
        // Japanese (Japan)
        "ja-JP": 'チャットでお問い合わせ',
        // Korean (Korea)
        "ko-KR": '저희와 채팅하세요',
        // Norwegian (Nynorsk) (Norway)
        "no": 'Chat med oss',
        // Portuguese (Portugal)
        "pt-PT": 'Converse com a gente',
        // Romanian (Romania)
        "ro-RO": 'Discută cu noi pe chat',
        // Russian (Russia)
        "ru-RU": 'Чат с нами',
        // Spanish (Spain)
        "es-ES": 'Chatea con nosotros',
        // Swedish (Sweden)
        "sv-SE": 'Chatta med oss',
        // Thai (Thailand)
        "th-TH": 'พูดคุยกับเรา',
        // Turkish (Turkey)
        "tr-TR": 'Bizimle konuşun',
        // Hungarian
        "hu": 'Chatelj velünk'
    }
    var greetingMap = {
        "en-UK": 'To help serve you faster please ensure you select the correct category',
        // Arabic
        "ar-AE": 'لمساعدتنا في خدمتك بشكل أسرع، يُرجى التأكد من تحديد الفئة الصحيحة',
        // Chinese (Simplified)
        "zh-ZH": '为了更快地为您服务，请确保选择正确的类别',
        // Chinese (Traditional)
        "zh-TW": '請選擇正確的類別來讓我們更快地為您服務',
        // 	Finnish (Finland)
        "fi-FI": 'Valitse oikea luokka, niin voimme auttaa sinua nopeammin.',
        // French (France)
        "fr-FR": 'Pour vous servir plus rapidement, veuillez vous assurer de sélectionner la bonne catégorie',
        // French Canadian
        "fr-CA": 'Pour accélérer le processus, assurez-vous de choisir la bonne catégorie',
        "de-DE": 'Um Ihnen einen schnelleren Service zu ermöglichen, stellen Sie bitte sicher, dass Sie die richtige Kategorie ausgewählt haben.',
        // Greek (Greece)
        "el-EL": 'Για να σας εξυπηρετήσουμε πιο γρήγορα, βεβαιωθείτε ότι έχετε επιλέξει τη σωστή κατηγορία',
        // Indonesian (Indonesia)
        "id-ID": 'Untuk proses yang lebih cepat, silakan pilih kategori yang paling sesuai',
        "it-IT": 'Per aiutarti a servirti più velocemente, assicurati di selezionare la categoria corretta',
        // Japanese (Japan)
        "ja-JP": 'より迅速な対応ができるよう、正しいカテゴリを選択してください。',
        // Korean (Korea)
        "ko-KR": '더욱 신속하게 도움을 받기 위해 올바른 카테고리를 선택해 주세요',
        // Norwegian (Nynorsk) (Norway)
        "no": 'Det er viktig at du velger riktig kategori, sånn at vi kan hjelpe deg raskere',
        // Portuguese (Portugal)
        "pt-PT": 'Para ajudar você mais rápido, certifique-se de escolher a categoria correta',
        // Romanian (Romania)
        "ro-RO": 'Pentru a ne ajuta să îţi răspundem mai repede solicitării, asigură-te că ai selectat categoria corectă',
        // Russian (Russia)
        "ru-RU": 'Выберите категорию, чтобы мы могли быстрее помочь вам',
        // Spanish (Spain)
        "es-ES": 'Para poder ayudarte más rápido, asegúrate de seleccionar la categoría correcta',
        // Swedish (Sweden)
        "sv-SE": 'Välj rätt kategori för att vi ska kunna ge dig snabbare hjälp.',
        // Thai (Thailand)
        "th-TH": 'เพื่อให้เราสามารถช่วยท่านได้เร็วขึ้น กรุณาเลือกหมวดหมู่ที่ถูกต้อง',
        // Turkish (Turkey)
        "tr-TR": 'Size daha hızlı yardımcı olabilmemiz için doğru kategoriyi seçtiğinizden emin olun.',
        // Hungarian
        "hu": 'Annak érdekében, hogy gyorsabban tudjunk segíteni, kérjük, ellenőrizd, hogy a helyes kategóriát választottad-e ki'
    }
    var displayTitleMap = {
        "en-UK": 'Customer Support',
        // Arabic
        "ar-AE": 'دعم العملاء',
        // Chinese (Simplified)
        "zh-ZH": '客户服务',
        // Chinese (Traditional)
        "zh-TW": '客服支援',
        // 	Finnish (Finland)
        "fi-FI": 'Asiakastuki',
        // French (France)
        "fr-FR": 'Service client',
        // French Canadian
        "fr-CA": 'Soutien à la clientèle',
        "de-DE": 'Kundendienst',
        // Greek (Greece)
        "el-EL": 'Υποστήριξη πελατών',
        // Indonesian (Indonesia)
        "id-ID": 'Dukungan Pelanggan',
        "it-IT": 'Servizio Clienti',
        // Japanese (Japan)
        "ja-JP": 'カスタマーサポート',
        // Korean (Korea)
        "ko-KR": '고객 지원',
        // Norwegian (Nynorsk) (Norway)
        "no": 'Kundestøtte',
        // Portuguese (Portugal)
        "pt-PT": 'Suporte ao Cliente',
        // Romanian (Romania)
        "ro-RO": 'Serviciul Clienţi',
        // Russian (Russia)
        "ru-RU": 'Поддержка клиентов',
        // Spanish (Spain)
        "es-ES": 'Atención al cliente',
        // Swedish (Sweden)
        "sv-SE": 'Kundtjänst',
        // Thai (Thailand)
        "th-TH": 'สนับสนุนลูกค้า',
        // Turkish (Turkey)
        "tr-TR": 'Müşteri Destek',
        // Hungarian
        "hu": 'Ügyfélszolgálat'
    }
    var titleByLineMap = {
        "en-UK": 'Here to help!',
        // Arabic
        "ar-AE": 'هنا لمساعدتك!',
        // Chinese (Simplified)
        "zh-ZH": '随时为您提供帮助！',
        // Chinese (Traditional)
        "zh-TW": '為您服務！',
        // 	Finnish (Finland)
        "fi-FI": 'Me autamme!',
        // French (France)
        "fr-FR": 'Ici pour vous aider!',
        // French Canadian
        "fr-CA": 'Nous sommes là pour vous aider!',
        "de-DE": 'Hier um Ihnen zu helfen!',
        // Greek (Greece)
        "el-EL": 'Είμαστε εδώ για να βοηθήσουμε!',
        // Indonesian (Indonesia)
        "id-ID": 'Kami siap membantu!',
        "it-IT": 'In cosa possiamo assisterLa?',
        // Japanese (Japan)
        "ja-JP": 'サポートいたします！',
        // Korean (Korea)
        "ko-KR": '저희가 도와드릴게요!',
        // Norwegian (Nynorsk) (Norway)
        "no": 'Vi er her for å hjelpe!',
        // Portuguese (Portugal)
        "pt-PT": 'Estamos aqui pra ajudar!',
        // Romanian (Romania)
        "ro-RO": 'Suntem aici să te ajutăm!',
        // Russian (Russia)
        "ru-RU": 'Готовоы помочь!',
        // Spanish (Spain)
        "es-ES": '¡Estamos aquí para ayudarte!',
        // Swedish (Sweden)
        "sv-SE": 'Här för att hjälpa!',
        // Thai (Thailand)
        "th-TH": 'เราพร้อมช่วยเหลือ!',
        // Turkish (Turkey)
        "tr-TR": 'Yardıma hazırız!',
        // Hungarian
        "hu": 'Itt vagyunk, hogy segítsünk!'
    }
    var zendeskLocaleMap = {
        uk: 'en-UK',
        en: 'en-UK',
        ar: 'ar-AE',
        zh: 'zh-ZH',
        zhh: 'zh-TW',
        fi: 'fi-FI',
        fr: 'fr-FR',
        ca: 'en-CA',
        caf: 'fr-CA',
        de: 'de-DE',
        el: 'el-EL',
        id: 'id-ID',
        it: 'it-IT',
        ja: 'ja-JP',
        ko: 'ko-KR',
        nn: 'no',
        pt: 'pt-PT',
        br: 'pt-PT',
        ro: 'ro-RO',
        ru: 'ru-RU',
        es: 'es-ES',
        sv: 'sv-SE',
        th: 'th-TH',
        tr: 'tr-TR',
        heb: 'he',
        hu: 'hu',
        gsw: "de-DE",
        fsw: "fr-FR",
    }
    var topTitle = topTitleMap['en-UK'];
    var greeting = greetingMap['en-UK'];
    var displayTitle = displayTitleMap['en-UK'];
    var titleByLine = titleByLineMap['en-UK'];

    if(zendeskLocaleMap[locale]) {
        locale = zendeskLocaleMap[locale];
        if(topTitleMap[locale]) {
            topTitle = topTitleMap[locale];
        }

        if(greetingMap[locale]) {
            greeting = greetingMap[locale];
        }

        if(displayTitleMap[locale] && titleByLineMap[locale]) {
            displayTitle = displayTitleMap[locale];
            titleByLine = titleByLineMap[locale];
        }
    }
    if(typeof window.zESettings !== 'undefined') {
        if(zESettings.webWidget.chat) {
            zESettings.webWidget.chat.title = { '*': topTitle }
        } else {
            zESettings.webWidget.chat = {
                title: { '*': topTitle }
            }
        }
        zESettings.webWidget.chat.prechatForm = {
            greeting: {'*': greeting },
        }
        zESettings.webWidget.chat.departments = {
            enabled: [''],
        }
        zESettings.webWidget.chat.concierge = {
            name: displayTitle,
            title: { '*': titleByLine },
        }
    }

    return {
        locale: locale,
    };
}
; /** ----------------- **/ 
 function setGtmDataLayer(data, track) {

    window.dataLayer = window.dataLayer || [];

    if (track == "registration") {
        window.dataLayer.push({
            'event': 'registration',
            'user_id': data.member_id,
            'user_name': data.user_name,
            'registration_status': data.status,
            'is_affiliate_registration': is_affiliate_registration(),
            'affid': Config.AFFILIATES_EXTERNAL_ID,
            'btag': Config.AFFILIATES_CODE,
        });
    }

    if (track == "deposit") {
        window.dataLayer.push({
            'event': 'deposit',
            'deposit_amount': data.deposit_amount,
            'deposit_currency': data.deposit_currency,
            'deposit_status': data.deposit_status,
            'first_deposit' : data.first_deposit,
            'user_name' : data.user_name,
        });
    }

    if (track == "regstart") {
        window.dataLayer.push({
            'event': 'regstart',
        });
    }

    if (track == "loggedin") {
        window.dataLayer.push({
            'event': 'loggedin',
            'user_id': data.member_id,
        });
    }

    if (track == "betconfirm") {
        window.dataLayer.push({
            'event': 'betconfirm',
            'accountId': data.accountId,
            'value': data.value,
            'currency': data.currency
        });
    }

    if (track == "cookie_consent") {
        window.dataLayer.push({
            'event': 'cookie_consent',
        });
    }

    if (track == "self-exclusion") {
        window.dataLayer.push({
            'event': 'self-exclusion',
        });
    }

    if (track == "sport_selected") {
        window.dataLayer.push(function () {
            this.reset();
        })
        window.dataLayer.push({
            'event': 'sport_selected',
            'sport': data.sport
        });
    }

    if (track == "sport_betslip_added") {
        window.dataLayer.push(function () {
            this.reset();
        })
        window.dataLayer.push({
            'event': 'sport_betslip_added',
            'sport': data.sport,
            'match_details': data.match_details
        });
    }

    if (track == "sport_bet_placed") {
        window.dataLayer.push(function () {
            this.reset();
        })
        window.dataLayer.push({
            'event': 'sport_bet_placed',
            'user_id': data.user_id,
            'sport': data.sport,
            'match_details': data.match_details,
            'bet_type': data.bet_type,
            'total_stake': data.total_stake,
            'max_winnings': data.max_winnings,
            'currency': data.currency,
        });
    }

    if (track == "first_time_deposit") {
        window.dataLayer.push({
            'event': 'first_time_deposit',
            'affid': Config.AFFILIATES_EXTERNAL_ID,
            'btag': Config.AFFILIATES_CODE,
            'afp': Config.AFFILIATES_PROGRAM,
            'pixel': Config.TRACKING_PIXEL,
        });
    }
}

function is_affiliate_registration() {
    if (Config.AFFILIATES_CODE && Config.AFF_BTAGS) {
        for (var i = 0; i < Config.AFF_BTAGS.length; i++) {
            if (Config.AFFILIATES_CODE.slice(0, Config.AFF_BTAGS[i].length) === Config.AFF_BTAGS[i]) {
                return 1;
            }
        }
    }
    return 0;
}; /** ----------------- **/ 
 if(Config.TRAFFIC_JUNKY_BASE_URL) {
    function trafficJunkyPixel(id) {
        var cti_id = id;
        var randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
        var trafficJunkyBaseUrl = JSON.parse(Config.TRAFFIC_JUNKY_BASE_URL);

        function getPixelImage() {
            return '<img id="1000202851_cpa_testing"\n' +
                '                         src=' + trafficJunkyBaseUrl + randomNumber + '&cti=' + cti_id + '&ctv=0&ctd=Registration"\n' +
                '                         style="display:none; visibility: hidden;"\n' +
                '                         width="0"\n' +
                '                         height="0"\n' +
                '                    />';
        }

        return getPixelImage();
    }
}; /** ----------------- **/ 
 window.fbAsyncInit = function () {
    FB.init({
        appId: BaseConfig.get('FB_APP_ID'),
        cookie: true,
        xfbml: true,
        version: 'v8.0',
    })
}

$(function () {
    var $registerModal = $('#register-user-modal'),
        $registerModalBody = $registerModal.find('.modal-body'),
        $registerModalClose = $('#register-user-modal .close'),
        $backButton = $registerModal.find('.modal-nav'),
        $registerForm = $('#register-user-form'),
        $completeRegisterModal = $('#completeRegisterModal'),
        $stepsContainer = $registerModal.find('.registration-steps-container'),
        $stepOne = $registerForm.find('.step-section-1'),
        $stepOneButton = $stepsContainer.find('.registration-step-1'),
        $stepTwoButton = $stepsContainer.find('.registration-step-2'),
        $stepThreeButton = $stepsContainer.find('.registration-step-3'),
        $stepTwo = $registerForm.find('.step-section-2'),
        $stepThree = $registerForm.find('.step-section-3'),
        $stepFour = $registerForm.find('.step-section-4'),
        $stepFive = $registerForm.find('.step-section-5'),
        $socialLogins = $registerModal.find('.social-login-wrapper'),
        $nextButton = $stepOne.find('#next-registration-step'),
        $acceptTermsAndPolicyLinks = $registerForm.find('.info-link'),
        $registerButton = $('#submit-reg-form'),
        $showPassword = $('.icon-toggle'),
        $couponCode = $registerModal.find('#reg_form_coupon_code'),
        $newsletterFooterCheckbox = $registerModal.find('.newsletter-footer'),
        $authActionModalToggle = $registerModal.find('.auth-action-modal-toggle'),
        $authActionModalBtnLogin = $authActionModalToggle.find('.auth-action-modal-btn'),
        $sendOtp = $('#send_otp'),
        $appComponents = document.getElementById('appComponents'),
        registerLoading = false,
        $unexpectedErrorModal = $('#unexpectedErrorModal'),
        $couponCodeContainer = $('.register-coupon-code-container'),
        $couponCodeToggle = $('.coupon-code-toggle'),
        $zipCode = $('#reg_form_zipcode'),
        registerConfigurationErrorCount = 0,
        preselectedCountryIso = '',
        preselectedCountryTitle = ''

    initRegisterConfiguration()
    updateLegacyUsernameFields()

    $registerForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($registerForm.attr('data-step') === '2' && Validator.validateElements($stepTwo)) {
                return goToStepEmploymentDetails()
            }
            if ($registerForm.attr('data-step') === 'employment-details') {
                Mediator.getMediator().trigger('Save_Employment_Details')
                var $employmentsDetailsForm = $('#employmentDetails')[0].__vueParentComponent.ctx.v$.form
                if ($employmentsDetailsForm.$invalid) {
                    return $employmentsDetailsForm.$touch()
                }
            }
        }
        if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
            if (['employment-details', '2'].indexOf($registerForm.attr('data-step')) !== -1 && Validator.validateElements($stepTwo)) {
                return goToStepSummary()
            }
        }
        onSubmitHandler()
    })

    $nextButton.on('click', function () {
        submitStepOne()
    })

    $stepOne.find('input[type=text], input[type=email], input[type=password]').on('keypress', function (e) {
        onStepOneSubmit(e)
    })

    $stepTwo.find('input[type=text], input[type=radio], input[type=checkbox], select').on('keypress', function (e) {
        onStepTwoSubmit(e)
    })

    $zipCode.on('blur', function (e) {
        formatCanadianZipCode(e)
    })

    $zipCode.on('keypress', function (e) {
        formatCanadianZipCode(e)
    })

    $stepOneButton.on('click', function () {
        var $confirmationStep = Config.WHITE_LABEL_REGULATIONS.registration_summary ? $registerForm.find('.step-section-5') : $registerForm.find('.step-section-3')
        if ($stepOneButton.hasClass('filled-in') && $confirmationStep.hasClass('d-none')) {
            goToStepOne()
            $registerForm.attr('data-step', 1)
            $stepsContainer.attr('data-step', 1)
        }
    })

    $stepTwoButton.on('click', function () {
        if ($stepTwoButton.hasClass('filled-in') && $stepOne.hasClass('d-none')) {
            goToStepTwo()
            $registerForm.attr('data-step', 2)
            $stepsContainer.attr('data-step', 2)
        }
    })

    $stepThreeButton.on('click', function () {
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($stepThreeButton.hasClass('filled-in') && $stepTwo.hasClass('d-none')) {
                goToStepEmploymentDetails()
                $registerForm.attr('data-step', 'employment-details')
                $stepsContainer.attr('data-step', 'employment-details')
            }
        } else if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
            if ($stepThreeButton.hasClass('filled-in') && $stepTwo.hasClass('d-none')) {
                goToStepSummary()
                $registerForm.attr('data-step', 'account-summary')
                $stepsContainer.attr('data-step', 'account-summary')
            }
        }
    })

    $authActionModalBtnLogin.on('click', function (e) {
        e.stopPropagation()
        $('.modal').modal('hide')
        window.openModalScreen('Login')
    })

    // Listen for events from Vue component
    if ($appComponents && $appComponents.__vueParentComponent) {
        var emitter = $appComponents.__vueParentComponent.appContext.config.globalProperties.$eventBus

        // Handle modal opened event - track initial step
        emitter.$on('legacy-modal-opened', function (data) {
            // Don't track if we're already on step 2 or higher (tracking is handled by goToStepTwo/etc)
            var currentStep = $registerForm.attr('data-step')
            if (currentStep === '2' || currentStep === 'employment-details') {
                return
            }

            var isNewLayoutDesktop = BaseConfig.get('IS_NEW_LAYOUT') && !Config.IS_MOBILE
            var stepNumber = (isNewLayoutDesktop || !data.showOffers) ? 1 : 0
            trackRegEvent('reg_registration_step', { step_number: stepNumber })
        })

        // Handle offers toggle - track step changes during navigation
        emitter.$on('legacy-toggle-offers', function (data) {
            if (data.shouldTrack) {
                var stepNumber = data.showOffers ? 0 : 1
                trackRegEvent('reg_registration_step', { step_number: stepNumber })
            }
        })
    }

    $registerModal.on('shown.bs.modal', function (data) {
        // trackRegEvent("reg_registration_opened");
        trackUserInteraction('open', 'registrationModal')

        var emitter = $appComponents.__vueParentComponent.appContext.config.globalProperties.$eventBus
        emitter.$emit('legacy_modal_shown')

        var stepsCount = $stepsContainer.find('.registration-step').length
        setGtmDataLayer([], 'regstart')

        var dataStep = $registerForm.attr('data-step')

        if (dataStep === '2') {
            goToStepTwo()
            return
        }
        if (dataStep === 'employment-details') {
            trackRegEvent('reg_registration_step', { step_number: 3 })
            return
        }
        if (Config.IS_MOBILE && dataStep == stepsCount) {
            return
        }

        if (data.relatedTarget && !data.relatedTarget.vueRegistration) {
            goToStepOne()
        }

        var registrationPromotionOffers = getRegistrationOfferData().registrationPromotionOffers
        var hasOffers = registrationPromotionOffers && !registrationPromotionOffers.error && Object.keys(registrationPromotionOffers).length > 0

        if (!hasOffers) {
            trackRegEvent('reg_registration_step', { step_number: 1 })
        }
    })

    $registerModal.on('hide.bs.modal', function () {
        goToStepOne()
        toggleLoginAfterSuccess(false)
        if (!Config.IS_MOBILE && Config.USER_IDLE) {
            window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')
            window.location.reload()
        }
        if (document.getElementById('appComponents')) {
            var registrationFormView = $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.application.registrationFormView
            if (registrationFormView === 'success') {
                goToPromotionSelection()
                $registerForm.attr('data-step', 1)
            }
            $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_REGISTRATION_FORM_VIEW', 'form')
            $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_REGISTRATION_SUCCESS_VIEW', 'default')
        }
    })

    $registerModalClose.on('click', function () {
        $registerModal.modal('hide')
        handleExitIntentOffers()
        trackOffersGA('close_registration')
        var currentStep = parseInt($registerForm.attr('data-step'))
        if (currentStep) {
            trackUserInteraction('close', 'registrationModal')
        }
        $('.confirmation-container').removeClass('active')
    })

    function handleExitIntentOffers() {
        if ($appComponents && $appComponents.__vueParentComponent && $appComponents.__vueParentComponent.appContext) {
            var exitIntentOffers = getRegistrationOfferData().registrationExitIntentOffers
            var isAutoLoginDisabled = window.BaseConfig.get('DISABLE_AUTO_LOGIN_REGISTRATION') === '1'

            if (exitIntentOffers && exitIntentOffers.length > 0) {
                if (isAutoLoginDisabled && $('.confirmation-container').hasClass('active')) return
                window.setExitIntentTypeExported('registrationModal')
                setTimeout(function () {
                    window.getBvModal().show('registrationExitModal')
                }, 500)
            }
        }
    }

    $registerModal.find('#reg_form_newsletter_footer').change(function () {
        var isChecked = $(this).is(':checked')
        $('#reg_form_newsletter').prop('checked', isChecked)
    })

    $registerForm.find('#reg_form_password').on('focus', function () {
        if (!$(this).hasClass('is-invalid') && $(this).val().length == 0) {
            $('.form-help').fadeIn(50)
        }
    })

    if (Config.DISABLE_REGISTRATION_SPECIAL_CHARS && !Config.USER_LOGGED_IN) {
        window.attachSpecialCharHandlers('register', $registerForm)
    }
    $registerForm.find('#reg_form_password').on('keyup', function () {
        var value = $(this).val(),
            minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3' : '8'),
            isSimplePassword = BaseConfig.get('IS_SIMPLE_PASSWORD'),
            re = new RegExp('^(?!(.)+\\1\\1)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W])(?!.*[\\s])[\\w\\W]{8,}$')

        if ($(this).hasClass('is-invalid') || (re.test(value) && !isSimplePassword) || (value.length >= minLength && isSimplePassword)) {
            $('.form-help').fadeOut(50)
        }
    })

    $registerForm.find('#reg_form_password').on('change', function () {
        var $passwordInput = $(this),
            value = $passwordInput.val(),
            minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3' : '8'),
            errorSimple = translation('REGISTER.password_simple_requirements'),
            errorMedium = translation('_localizer.REGISTER.password_medium_requirements'),
            errorComplex = translation('REGISTER.password_complex_requirements'),
            re = new RegExp("^(?!(.)+\\1\\1)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W])(?!.*[\\s])[\\w\\W]{8,}$"),
            reMedium = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W])(?=\\S+$).{8,32}$"),
            fieldId = Config.IS_MOBILE ? 'reg_form_confirm_password' : 'register-form-confirm-password',
            $confirmPasswordInput = $registerForm.find('#' + fieldId),
            isSimplePassword = BaseConfig.get('IS_SIMPLE_PASSWORD'),
            isMediumPassword = BaseConfig.get('IS_MEDIUM_PASSWORD');

        if (isMediumPassword === "1" && isSimplePassword === "0") {
            if (!reMedium.test(value)) {
                $passwordInput[0].setCustomValidity(errorMedium);
                $passwordInput.addClass('is-invalid');
            } else {
                $passwordInput[0].setCustomValidity('');
                $passwordInput.removeClass('is-invalid');
            }
        } else {
            if (!re.test(value) && !isSimplePassword) {
                $passwordInput[0].setCustomValidity(errorComplex);
                $passwordInput.addClass('is-invalid');
            } else if (value.length < minLength && isSimplePassword) {
                $passwordInput[0].setCustomValidity(errorSimple);
                $passwordInput.addClass('is-invalid');
                $('.form-help').fadeOut(50);
            } else {
                $passwordInput[0].setCustomValidity('');
                $passwordInput.removeClass('is-invalid');
            }
        }

        $confirmPasswordInput.val(value)
    })

    var urlPath = window.location.pathname

    // Function to check registrationConfig and present Loader until we have response
    function checkRegistrationConfig(attempts, source) {
        var vuex = getStore()

        if (!vuex) {
            hideLoaderOverlay() // Ensure loader is hidden
            return
        }

        if (vuex.state.application.registrationConfig && Object.keys(vuex.state.application.registrationConfig).length > 0 || attempts >= 3) {
            hideLoaderOverlay()
            if (window.ReactNativeAppConfig && window.ReactNativeAppConfig.externalModalRegistrationEnabled) {
                window.openModalScreen('SignUp', source)
            } else {
                window.__PROMPT_AUTH_MODAL__('SignUp', source)
            }
        } else {
            setTimeout(() => checkRegistrationConfig(attempts + 1, source), 300)
        }
    }

    if (/index\/register/.test(urlPath) && !Config.SEND_EMAIL_REGISTRATION) {
        // Add initial loader to body
        window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')
        checkRegistrationConfig(0, 'index/register')
    }

    function applyCpfPlaceholderAndLabelToVerifyModalUsernameField() {
        // TODO Delete when CFT-30137 is implemented
        var $verifyEmailModal = $('#verify-email-modal');
        var $usernameInputField = $verifyEmailModal.find('#resend-token-form_username');
        if (!$usernameInputField.length) return;

        var cpfText = translation('REGISTER.cpf_placeholder');
        $usernameInputField.attr('placeholder', cpfText);
        $usernameInputField.closest('.form-group').find('label').text(cpfText);
    }

    function applyCpfPlaceholderAndLabelToRecoverPasswordUsernameField() {
        // TODO Delete when CFT-30137 is implemented
        // Handles the username field inside the create-new-password modal
        var $recoverPasswordModal = $('#create-new-password-modal');
        var $usernameInputField = $recoverPasswordModal.find('#password_reset_username');
        if (!$usernameInputField.length) return;

        var cpfText = translation('REGISTER.cpf_placeholder');
        $usernameInputField.attr('placeholder', cpfText);
        // Prefer explicit label-for targeting for robustness
        var $label = $recoverPasswordModal.find('label[for="password_reset_username"]');
        if ($label.length) {
            $label.text(cpfText);
        } else {
            // Fallback to closest form-group search
            $usernameInputField.closest('.form-group').find('label').text(cpfText);
        }
    }

    function pollRegConfigForCpf(currentAttemptNumber, source) {
        // TODO delete once CFT-30137 is implemented
        var maximumNumberOfAttempts = 3;
        if (currentAttemptNumber >= maximumNumberOfAttempts) {
            return;
        }

        var vuexStore = getStore();
        if (!vuexStore) {
            setTimeout(function () {
                return pollRegConfigForCpf(currentAttemptNumber + 1, source);
            }, 300);
            return;
        }

        var registrationConfiguration = vuexStore.state.application.registrationConfig;

        if (registrationConfiguration && Object.keys(registrationConfiguration).length > 0) {
            var registrationSteps = Array.isArray(registrationConfiguration.steps) ? registrationConfiguration.steps : [];

            var hasCpfFieldInRegistrationConfiguration = registrationSteps.some(function (registrationStep) {
                var registrationStepFields = Array.isArray(registrationStep.fields) ? registrationStep.fields : [];
                return registrationStepFields.some(function (registrationField) {
                    var fieldName = registrationField && registrationField.name;
                    return typeof fieldName === 'string' && fieldName.toLowerCase() === 'cpf';
                });
            });

            if (hasCpfFieldInRegistrationConfiguration) {
                setTimeout(function () {
                    // Apply on verify-email modal and recovery create-new-password modal
                    applyCpfPlaceholderAndLabelToVerifyModalUsernameField();
                    applyCpfPlaceholderAndLabelToRecoverPasswordUsernameField();
                }, 300);
            }
        } else {
            setTimeout(function () {
                return pollRegConfigForCpf(currentAttemptNumber + 1, source);
            }, 300);
        }
    }

    var recoveryCreateNewPassword = /recovery\/create-new-password/;
    var indexVerify = /index\/verify/;

    if (indexVerify.test(urlPath) || recoveryCreateNewPassword.test(urlPath)) {
        // TODO delete once CFT-30137 is implemented
        pollRegConfigForCpf(0, Config.LOCALE_SHORT + '/index/verify');
    }

    if (Config.IS_MOBILE) {
        //We had this reg_form_confirm_password handler for mobile
        $registerForm.find('#reg_form_confirm_password').on('input', function () {
            var $confirmPasswordInput = $(this),
                value = $confirmPasswordInput.val(),
                minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3' : '8'),
                errorMessage = $confirmPasswordInput.attr('required-message'),
                errorMatching = translation('REGISTER.confirm_password_not_match')
            if (value.length < minLength) {
                errorMessage = translation('REGISTER.password_at_least') + ' ' + minLength + ' ' + translation('REGISTER.password_characters')
                $confirmPasswordInput[0].setCustomValidity(errorMessage)
                $confirmPasswordInput.next().text(errorMessage)
                $confirmPasswordInput.addClass('is-invalid')
            } else {
                if ($registerForm.find('#reg_form_password').val() !== value) {
                    $confirmPasswordInput[0].setCustomValidity(errorMatching)
                    $confirmPasswordInput.next().text(errorMatching)
                    $confirmPasswordInput.addClass('is-invalid')
                } else {
                    $confirmPasswordInput[0].setCustomValidity('')
                    $confirmPasswordInput.removeClass('is-invalid')
                }
            }
        })

        $registerForm.find('#reg_form_email').on('input', function (e) {
            e.target.value = e.target.value.trim()
        })
    } else {
        //We had this reg_form_confirm_password handler for desktop
        $registerForm.find('#reg_form_confirm_password').on('change', function () {
            var $confirmPasswordInput = $(this),
                $hiddenInput = $confirmPasswordInput.closest('.form-group').find('.hidden-password-field'),
                value = $hiddenInput.val(),
                minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3' : '8'),
                errorMessage = $confirmPasswordInput.attr('required-message'),
                errorMatching = translation('REGISTER.confirm_password_not_match'),
                passwordAtLeast = translation('REGISTER.password_at_least'),
                passwordCharacters = translation('REGISTER.password_characters')

            if (value.length < minLength) {
                errorMessage = passwordAtLeast + ' ' + minLength + ' ' + passwordCharacters
                $confirmPasswordInput[0].setCustomValidity(errorMessage)
                $confirmPasswordInput.next().text(errorMessage)
                $confirmPasswordInput.addClass('is-invalid')
            } else {
                if ($registerForm.find('#register-form-password').val() !== value) {
                    $confirmPasswordInput[0].setCustomValidity(errorMatching)
                    $confirmPasswordInput.next().text(errorMatching)
                    $confirmPasswordInput.addClass('is-invalid')
                } else {
                    $confirmPasswordInput[0].setCustomValidity('')
                    $confirmPasswordInput.removeClass('is-invalid')
                }
            }
        })
    }

    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('keypress', function (e) {
        if (['reg_form_fname', 'reg_form_lname'].indexOf($(e.currentTarget).attr('id')) !== -1 && Config.DISABLE_REGISTRATION_SPECIAL_CHARS) {
            return
        }

        var regex = new RegExp('^[a-z A-Z_\u00C0-\u017F\'\.\b-]+$')
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
        if (regex.test(str) || Config.ALLOW_CYRILLIC_ON_REGISTER_FORM) {
            return true
        }

        e.preventDefault()
        return false
    })

    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('input', function (e) {
        var $input = $(e.currentTarget),
            value = $input.val(),
            cyrillicRegex = new RegExp('[а-яА-Я0-9]+$')

        if (!Config.ALLOW_CYRILLIC_ON_REGISTER_FORM && cyrillicRegex.test(value)) {
            $input.val('')
            return false
        }
        value = value.replace(/\s\s+/g, ' ')
        $input.val(value)
    })

    $registerForm.find('#reg_form_address').on('input', function (e) {
        var $input = $(e.currentTarget),
            value = $input.val(),
            cyrillicRegex = new RegExp('[а-яА-Я]')

        if (!Config.ALLOW_CYRILLIC_ON_REGISTER_FORM && cyrillicRegex.test(value)) {
            $input.val('')
        }
    })

    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('change', function (e) {
        var $input = $(e.currentTarget),
            value = $input.val()
        value = value.trim()
        $input.val(value)
    })

    $backButton.on('click', function () {
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($registerForm.attr('data-step') === 'employment-details') {
                goToStepTwo()
                $registerForm.attr('data-step', 2)
                $stepsContainer.attr('data-step', 2)
                return
            }
        }

        var registrationSelectedPromotion = getRegistrationOfferData().registrationSelectedPromotion
        registrationSelectedPromotion = registrationSelectedPromotion ? Object.keys(registrationSelectedPromotion) : []

        var currentRegStep = Number($registerForm.attr('data-step'))
        var currentStepsContainerStep = Number($stepsContainer.attr('data-step'))
        if (isNaN(currentStepsContainerStep)) {
            currentStepsContainerStep = 1
        }

        if (registrationSelectedPromotion.length > 0) {
            if (currentRegStep < 2 && currentStepsContainerStep < 2) {
                goToPromotionSelection()
                return
            }
        }

        goToStepOne()
        $registerForm.attr('data-step', 1)
        $stepsContainer.attr('data-step', 1)
        trackRegEvent('reg_registration_step', { step_number: 1 })
    })

    $showPassword.on('click', function () {
        var input = $registerForm.find('#reg_form_password'),
            type = input.attr('type')

        if ($(this).hasClass('enabled')) {
            $(this).removeClass('enabled')
        } else {
            $(this).addClass('enabled')
        }

        input.attr('type', type == 'text' ? 'password' : 'text')
    })

    if (Config.USER_LOGGED_IN !== '1') {
        $registerForm.find('#reg_form_country_id').on('change', function () {
            preselectPhonePrefix($registerForm)
            preselectCurrency($registerForm, undefined, true)
            if (Config.WHITE_LABEL_REGULATIONS.reg_state) {
                preselectStateField($registerForm)
            }
        })
    } else if (Config.USER_LOGGED_IN === '1' && $completeRegisterModal.length) {
        $completeRegisterModal.find('#reg_form_country_id').on('change', function () {
            preselectPhonePrefix($completeRegisterModal)
            preselectCurrency($completeRegisterModal)
            preselectStateField($completeRegisterModal)
        })
    }

    $couponCode.on('input', function (e) {
        var $input = $(e.currentTarget),
            value = $input.val()
        $(this).removeClass('is-invalid')
        $('input[name="reg_form[coupon_code]"]').val(value)
    })

    $sendOtp.on('click', function () {
        if (Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.send_one_time_password) {
            grecaptcha.ready(function () {
                grecaptcha.execute(Config.RECAPTCHA_KEY, { action: 'send_one_time_password' }).then(function (token) {
                    sendOtp({
                        recaptcha_token: token,
                        action: 'send_one_time_password',
                    })
                })
            })
        } else {
            sendOtp()
        }
    })

    $(document).on('click', '.btn-social-login', function (e) {
        var $clickedEl = $(e.currentTarget),
            socialButtonAction = $clickedEl.attr('data-action')

        // Vue login/registration modals handle social auth via SocialAuth.vue components
        if ($clickedEl.closest('#loginModal, #registrationModal').length) {
            return
        }

        switch (socialButtonAction) {
            case 'apple-auth':
                if (window.WebPage && window.ReactNativeWebView) {
                    window.WebPage.sendMessage({
                        type: 'INIT_APPLE_AUTH',
                        payload: true
                    });

                    return;
                }

                appleAuth()
                break

            case 'facebook-auth':
                facebookAuth()
                break

            case 'google-auth':
                if (window.WebPage && window.ReactNativeWebView) {
                    window.WebPage.sendMessage({
                        type: 'INIT_GOOGLE_LOGIN',
                        payload: true
                    });

                    return;
                }

                googleAuth()
                break
        }
    })

    if (Config.USER_LOGGED_IN === '1') {
        initLogoutHandler()
    }

    Validator.initSelfValidation($registerForm)

    Mediator.getMediator().on('Confirm_Summary_Step', function () {
        onSubmitHandler()
    })

    Mediator.getMediator().on('Confirm_Employment_Details', function (target, additionalDataModal) {
        if ($appComponents && !additionalDataModal.source) {
            if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
                goToStepSummary()
            } else {
                onSubmitHandler()
            }
        }
    })

    function onStepOneSubmit(e) {
        if (e.key === 'Enter' || e.key == 13) {
            $(e.currentTarget).blur()
            submitStepOne()
        }
    }

    function onStepTwoSubmit(e) {
        if (e.key === 'Enter' || e.key == 13) {
            e.preventDefault()
            e.stopPropagation()

            if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data && Validator.validateElements($stepTwo)) {
                goToStepEmploymentDetails()
                return
            }
            if (Config.WHITE_LABEL_REGULATIONS.registration_summary && Validator.validateElements($stepTwo)) {
                goToStepSummary()
                return
            }

            onSubmitHandler()
        }
    }

    function submitStepOne() {
        if (Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.register_1st_step) {
            grecaptcha.ready(function () {
                grecaptcha.execute(Config.RECAPTCHA_KEY, { action: 'register_1st_step' }).then(function (token) {
                    firstStepValidate({
                        recaptcha_token: token,
                        action: 'register_1st_step',
                    })
                })
            })
        } else {
            firstStepValidate()
        }
    }

    function goToPromotionSelection() {
        $backButton.addClass('d-none');
        $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_SELECTED_PROMOTION', null)
        $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/EDIT_REGISTRATION_SELECTED_PROMOTION', true)
    }

    function goToStepOne() {
        var registrationPromotionOffers = getRegistrationOfferData().registrationPromotionOffers
        var payNPlayWidgetTNC = $registerModal.find('.pay-n-play-widget-t-n-c')

        $stepOne.removeClass('d-none')
        $socialLogins.removeClass('d-none')
        $stepTwo.addClass('d-none')
        $authActionModalToggle.removeClass('d-none')
        if (payNPlayWidgetTNC) payNPlayWidgetTNC.removeClass('d-none')
        $stepsContainer.find('.registration-step-2').removeClass('active filled-in')
        $stepsContainer.find('.registration-step-1').removeClass('filled-in').addClass('active')

        if (registrationPromotionOffers) {
            $registerModalBody.addClass('with-promo')
        } else {
            $backButton.addClass('d-none')
        }

        if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
            if ($registerForm.attr('data-step') === 'account-summary') {
                $stepsContainer.find('.registration-step-3').removeClass('active filled-in')
                $stepsContainer.find('.registration-step-4').removeClass('active filled-in')
                $stepThree.addClass('d-none')
                $stepFour.addClass('d-none')
            }
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($registerForm.attr('data-step') === 'employment-details') {
                $stepsContainer.find('.registration-step-3').removeClass('active filled-in')
                $stepsContainer.find('.registration-step-4').removeClass('active filled-in')
                if ($appComponents) {
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/REGISTRATION_EMPLOYMENT_DETAILS_STEP', false)
                }
                $stepThree.addClass('d-none')
                $stepFour.addClass('d-none')
            }
        }

        if ($newsletterFooterCheckbox.length) {
            $newsletterFooterCheckbox.removeClass('d-block').addClass('d-none')
        }
    }

    function goToStepTwo(resetErrors = true) {
        var payNPlayWidgetTNC = $registerModal.find('.pay-n-play-widget-t-n-c')

        if (resetErrors) {
            $registerForm.find('.is-invalid').removeClass('is-invalid')
            $registerForm.find('.form-group .invalid-feedback').removeClass('d-block')
        }
        $stepOne.addClass('d-none')
        $socialLogins.addClass('d-none')
        $stepTwo.removeClass('d-none')
        $backButton.removeClass('d-none')
        $authActionModalToggle.addClass('d-none')
        if (payNPlayWidgetTNC) payNPlayWidgetTNC.addClass('d-none')
        $stepsContainer.find('.registration-step-1').removeClass('active').addClass('filled-in')
        $stepsContainer.find('.registration-step-2').removeClass('filled-in').addClass('active')
        $registerModalBody.removeClass('with-promo')

        if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
            if ($registerForm.attr('data-step') === 'account-summary') {
                $stepsContainer.find('.registration-step-3').removeClass('active filled-in')
                $stepsContainer.find('.registration-step-4').removeClass('active filled-in')
                $stepThree.addClass('d-none')
                $stepFour.addClass('d-none')
            }
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($registerForm.attr('data-step') === 'employment-details') {
                $stepsContainer.find('.registration-step-3').removeClass('active filled-in')
                $stepsContainer.find('.registration-step-4').removeClass('active filled-in')
                if ($appComponents) {
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/REGISTRATION_EMPLOYMENT_DETAILS_STEP', false)
                }
                $stepThree.addClass('d-none')
                $stepFour.addClass('d-none')
            }
        }

        if ($newsletterFooterCheckbox.length && !BaseConfig.get('HIDE_SEND_NEWSLETTER_AND_SMS_VISIBILITY')) {
            $newsletterFooterCheckbox.removeClass('d-none').addClass('d-block')
        }

        if (window.WebPage && window.ReactNativeWebView) {
            changeTermsAndPolicyLinksClasses()
        }
        trackRegEvent('reg_registration_step', { step_number: 2 })
    }

    function goToStepSummary() {
        var registrationSummaryData = getAccountData()
        if ($appComponents) {
            $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_REGISTRATION_SUMMARY_DATA', registrationSummaryData)
        }

        if ($registerForm.attr('data-step') === 'employment-details') {
            if ($appComponents) {
                $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/REGISTRATION_EMPLOYMENT_DETAILS_STEP', false)
            }
            $stepsContainer.find('.registration-step-3').removeClass('active')
            $stepThree.addClass('d-none')
            $stepFour.removeClass('d-none')
            $stepsContainer.find('.registration-step-3').removeClass('active').addClass('filled-in')
            $stepsContainer.find('.registration-step-4').addClass('active').removeClass('filled-in')
            trackRegEvent('reg_registration_step', { step_number: 4 })
        } else {
            $stepThree.removeClass('d-none')
            $stepTwo.addClass('d-none')
            $stepsContainer.find('.registration-step-2').removeClass('active').addClass('filled-in')
            $stepsContainer.find('.registration-step-3').addClass('active').removeClass('filled-in')
            trackRegEvent('reg_registration_step', { step_number: 3 })
        }
        $registerForm.attr('data-step', 'account-summary')
        $stepsContainer.attr('data-step', 'account-summary')
        $registerModalBody.removeClass('with-promo')
    }

    function goToStepEmploymentDetails() {
        $stepTwo.addClass('d-none')
        $stepFour.addClass('d-none')
        $stepThree.removeClass('d-none')
        $stepsContainer.find('.registration-step-2').removeClass('active').addClass('filled-in')
        $stepsContainer.find('.registration-step-3').removeClass('filled-in').addClass('active')
        $stepsContainer.find('.registration-step-4').removeClass('active')
        $registerForm.attr('data-step', 'employment-details')
        $stepsContainer.attr('data-step', 'employment-details')
        $registerModalBody.removeClass('with-promo')
        Mediator.getMediator().trigger('Display_Employment_Details')
        trackRegEvent('reg_registration_step', { step_number: 3 })
    }

    function goToStepConfirmation() {
        $backButton.addClass('d-none')
        $registerModalClose.addClass('d-none')
        $registerModal.find('.modal-title-sign').addClass('d-none')
        $registerModal.find('.modal-title-welcome').removeClass('d-none')
        $couponCodeContainer.collapse('hide')

        if ($newsletterFooterCheckbox.length) {
            $newsletterFooterCheckbox.removeClass('d-block').addClass('d-none')
        }

        if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
            $stepFour.addClass('d-none')
            $stepFive.removeClass('d-none')
            $stepsContainer.find('.registration-step-4').removeClass('active').addClass('filled-in')
            $stepsContainer.find('.registration-step-5').addClass('filled-in')
            return
        }

        $stepTwo.addClass('d-none')
        $stepThree.removeClass('d-none')
        $stepsContainer.find('.registration-step-2').removeClass('active').addClass('filled-in')
        $stepsContainer.find('.registration-step-3').addClass('filled-in')
        $registerModalBody.removeClass('with-promo')
    }

    function selectConfirmPasswordValue() {
        var fieldId = Config.IS_MOBILE ? 'reg_form_confirm_password' : 'register-form-confirm-password'
        var $confirmPasswordInput = $registerForm.find('#' + fieldId)
        var $passwordInput = $registerForm.find('#reg_form_password')
        $confirmPasswordInput.val($passwordInput.val())
    }

    function firstStepValidate(recaptchaParams) {
        if (registerLoading) {
            return
        }
        registerLoading = true
        selectConfirmPasswordValue()
        var form = getElement($registerForm)
        if (recaptchaParams) {
            form.requestData['recaptcha_token'] = recaptchaParams.recaptcha_token
            form.requestData['action'] = recaptchaParams.action
        }
        form.ajaxRequest('firstStepValidation', {
            request: {
                url: '/' + Config.LOCALE_SHORT + '/index/operation/firstStepValidation',
            },
            loadAction: $registerModalBody,
            toastr: false,
            validate: function () {
                return Validator.validateElements($stepOne)
            },
            onValidationError: function () {
                registerLoading = false
            },
            onSuccess: function (response) {
                goToStepTwo()
                $registerForm.attr('data-step', 2)
                $stepsContainer.attr('data-step', 2)
                if (window.UILogger) {
                    window.UILogger.logEvent(window.UILogger.eventNames.Auth.select_register_form_submit_button, {
                        value: 'Next',
                    })
                }
            },
            onError: function (errData) {
                var errors = errData.error

                window.trackRegisterFormStepError(errors, 1)

                var hasStepOneErrors = Object.keys(errors).some(function (error) {
                    return $registerForm.find('#reg_form_' + error).closest('.step-section-1').length
                })

                var hasStepTwoErrors = Object.keys(errors).some(function (error) {
                    return $registerForm.find('#reg_form_' + error).closest('.step-section-2').length
                })

                $registerForm.find('.is-invalid').removeClass('is-invalid')
                for (var error in errors) {
                    $registerForm.find('#reg_form_' + error).addClass('is-invalid').closest('.form-group').find('.invalid-feedback').text(errors[error])
                }

                if (hasStepTwoErrors && !hasStepOneErrors) {
                    goToStepTwo(false)
                    $registerForm.attr('data-step', 2)
                    $stepsContainer.attr('data-step', 2)
                }
            },
            onFinish: function () {
                registerLoading = false
            },
        })
    }

    function onSubmitHandler() {
        if (Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.register_final_step) {
            grecaptcha.ready(function () {
                grecaptcha.execute(Config.RECAPTCHA_KEY, { action: 'register_final_step' }).then(function (token) {
                    registerHandler({
                        recaptcha_token: token,
                        action: 'register_final_step',
                    })
                })
            })
        } else {
            registerHandler()
        }
    }

    function getRegistrationOfferData() {
        var registrationFormData = $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.application.registrationFormData
        var registrationPromotionOffers = registrationFormData ? registrationFormData.registrationOffers : null
        var registrationSelectedPromotion = $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.promotions.registrationSelectedPromotion
        var registrationManualSelectedPromotionCode = $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.promotions.registrationManualSelectedPromotionCode
        var registrationExitIntentOffers = registrationPromotionOffers ? registrationPromotionOffers.exitIntentOffers : []

        return {
            registrationPromotionOffers: registrationPromotionOffers,
            registrationSelectedPromotion: registrationSelectedPromotion,
            registrationManualSelectedPromotionCode: registrationManualSelectedPromotionCode,
            registrationExitIntentOffers: registrationExitIntentOffers,
        }
    }

    function getOfferDataForSocialLogins() {
        var offerData = {}
        var registrationSelectedPromotion = getRegistrationOfferData().registrationSelectedPromotion
        if (registrationSelectedPromotion) {
            offerData.registration_offers_info = {
                member_choice_reg_offer_type: registrationSelectedPromotion.promotionType,
                member_choice_reg_offer_id: registrationSelectedPromotion.id,
            }

            if (registrationSelectedPromotion.promotionType === 'bonusRegistrationOffers' || registrationSelectedPromotion.promotionType === 'affiliateRegistrationOffer') {
                offerData.coupon_code = registrationSelectedPromotion.code
            }

            if (registrationSelectedPromotion.promotionType === 'manualCodeActivation') {
                offerData.coupon_code = getRegistrationOfferData().registrationManualSelectedPromotionCode
            }
        }

        return offerData
    }
    var seonSessionPending = false;
    function registerHandler(recaptchaParams) {
        if (registerLoading) {
            return
        }
        var disabledFields = $registerForm.find(':input:disabled').prop('disabled', false)
        registerLoading = true
        var form = getElement($registerForm)
        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            if ($appComponents) {
                var regEmploymentData = $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.state.user.registrationEmploymentData
            }
            form.requestData['reg_form_additional'] = regEmploymentData

            delete form.requestData.jobTitle
            delete form.requestData.typeOfBusiness
        }
        if (recaptchaParams) {
            form.requestData['recaptcha_token'] = recaptchaParams.recaptcha_token
            form.requestData['action'] = recaptchaParams.action
        }
        if (window.ReactNativeWebView && window.ReactNativeWebViewOS) {
            form.requestData['registration_platform'] = 'native_application'
            form.requestData['registration_os'] = window.ReactNativeWebViewOS
        }

        var registrationPromotionOffers = getRegistrationOfferData().registrationPromotionOffers
        var registrationSelectedPromotion = getRegistrationOfferData().registrationSelectedPromotion
        var registrationManualSelectedPromotionCode = getRegistrationOfferData().registrationManualSelectedPromotionCode
        var registrationSelectedPromotionKeys = registrationSelectedPromotion ? Object.keys(registrationSelectedPromotion) : []

        if (registrationSelectedPromotionKeys.length > 0) {
            form.requestData['registration_offers_info'] = {
                'member_choice_reg_offer_type': registrationSelectedPromotion.promotionType,
                'member_choice_reg_offer_id': registrationSelectedPromotion.id,
            }

            if (
                registrationSelectedPromotion.promotionType === 'bonusRegistrationOffers' ||
                registrationSelectedPromotion.promotionType === 'affiliateRegistrationOffer' ||
                registrationSelectedPromotion.promotionType === 'exitIntentOffers'
            ) {
                form.requestData.reg_form.coupon_code = registrationSelectedPromotion.code
            }

            if (registrationManualSelectedPromotionCode && registrationSelectedPromotion.promotionType === 'manualCodeActivation') {
                form.requestData.reg_form.coupon_code = registrationManualSelectedPromotionCode
            }
        }
        if (window.seon) {
            if (!seonSessionPending) {
                window.getSeonSessionId();
                seonSessionPending = true;
            }
            if (window.seonSessionId) {
                form.requestData['seon_session_id'] = window.seonSessionId;
                seonSessionPending = false;
            } else {
                registerLoading = false;
                setTimeout(function () {
                    registerHandler(recaptchaParams);
                }, 1000)
                return
            }
        }

        form.ajaxRequest('register', {
            request: {
                url: '/' + Config.LOCALE_SHORT + '/index/operation/register',
            },
            extraData: {
                system_data: {
                    product_type: localStorage.getItem('productType'),
                },
            },
            loadAction: $registerForm,
            toastr: false,
            validate: function () {
                return Validator.validateElements($registerForm)
            },
            onValidationError: function () {
                if (disabledFields.length) {
                    disabledFields.prop('disabled', true)
                }
                registerLoading = false
            },
            onError: function (response) {
                if (disabledFields.length) {
                    disabledFields.prop('disabled', true)
                }
                if (response.error) {
                    if (Config.WHITE_LABEL_REGULATIONS.registration_summary || (Config.WHITE_LABEL_REGULATIONS.reg_additional_data)) {
                        goToStepTwo()
                        $registerForm.attr('data-step', 2)
                        $stepsContainer.attr('data-step', 2)
                    }
                    //hide the loading box
                    if (response.error.password) {
                        goToStepOne()
                    }
                    var errors = response.error
                    var currentStep = $registerForm.attr('data-step') || 1

                    window.trackRegisterFormStepError(errors, currentStep)

                    $registerForm.find('.is-invalid').removeClass('is-invalid')
                    for (var error in errors) {
                        if (error == 'birthday_year') {
                            var birthdayFields = ['birthday_day', 'birthday_month', 'birthday_year']
                            birthdayFields.forEach(function (field) {
                                $registerForm.find('#reg_form_' + field).addClass('is-invalid')
                            })
                            $registerForm.find('#reg_form_' + error).closest('.form-group').find('.invalid-feedback').addClass('d-block').text(errors[error])
                        } else if (error === 'coupon_code') {
                            if (registrationPromotionOffers) {
                                $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_MANUAL_SELECTED_PROMOTION_CODE', { 'error': errors[error] })
                                goToPromotionSelection()
                            }
                            $couponCodeContainer.find('#reg_form_' + error).addClass('is-invalid').next().text(errors[error])
                            $couponCode.focus()
                        } else if (['spn', 'cpr'].indexOf(error) !== -1) {
                            $registerForm.find('#reg_form_' + error).addClass('is-invalid').closest('.form-group').find('.invalid-feedback').addClass('d-block').text(errors[error])
                        } else {
                            $registerForm.find('#reg_form_' + error).addClass('is-invalid').next().text(errors[error])
                        }
                    }
                    if (response.error && response.error.ip) {
                        $('.popup-registration-content').find('.error-general').text(response.error.error_msg).removeClass('d-none').addClass('d-block')
                        $registerModal.scrollTop(0)
                    } else {
                        $registerForm.closest('.popup-registration-content').find('.error-general').text('').removeClass('d-block').addClass('d-none')
                    }
                } else {
                    console.log('Error!')
                }
            },

            onSuccess: function (data) {
                window.localStorage.removeItem('gamificationPopup')
                window.sessionStorage.setItem('REGISTER_SUCCESS', true)
                window.localStorage.setItem('MGA_LIMITS_LINK', true)
                trackOffersGA('success_registration', 'Email')
                trackRegEvent('reg_account_created', { member_id: data.member_id, sign_up_method: 'email' })

                $registerForm.closest('.popup-registration-content').find('.error-general').text('').removeClass('d-block').addClass('d-none')

                var shouldRedirect = true
                if (Config.IS_MOBILE && window.WebPage) {
                    if (window.ReactNativeWebView) {
                        Cookies.set('quick_deposit', true)
                        shouldRedirect = false
                    }
                    if (data.auto_login) {
                        setTimeout(function () {
                            window.WebPage.sendMessage({
                                type: 'SET_USER_CREDENTIALS',
                                payload: {
                                    username: $registerForm.find('#reg_form_username').val(),
                                    password: $registerForm.find('#reg_form_password').val(),
                                },
                            })
                        }, typeof BaseConfig.get('REFRESH_TIMEOUT') !== 'undefined' ? BaseConfig.get('REFRESH_TIMEOUT') : 3000)
                    }
                }
                // Adding TrafficJunky pixel tracking image
                if (Config.TRAFFIC_JUNKY_BASE_URL) {
                    $stepThree.append(trafficJunkyPixel(data.member_id))
                    if (BaseConfig.get('INDIA_REGISTRATION')) {
                        $registerForm.append(trafficJunkyPixel(data.member_id))
                    }
                }

                setGtmDataLayer(data, 'registration')

                if (Config.IS_MOBILE) {
                    window.UILogger.logEvent(window.UILogger.eventNames.Auth.register, {
                        method: 'Registration Form',
                        user_id: data.member_id,
                    })

                    if (window.WebPage) {
                        window.WebPage.sendMessage({
                            type: 'LOG_EVENT',
                            payload: {
                                eventName: 'af_complete_registration',
                                eventValues: {
                                    af_registration_method: 'email',
                                },
                            },
                        })
                    }
                } else {
                    window.UILogger.logEvent(window.UILogger.eventNames.Auth.register, {
                        user_id: data.member_id,
                    })
                }

                if (typeof window.isRegisterFromPromotionGetBonusNowBtn !== 'undefined' && window.isRegisterFromPromotionGetBonusNowBtn) {
                    var couponCode = $('.promotionCtaGetBonusNow').data('code')
                    activateCouponCode($(this), couponCode, 'alert')
                    window.isRegisterFromPromotionGetBonusNowBtn = false
                }

                if (Config.WHITE_LABEL_REGULATIONS.registration_summary) {
                    $stepsContainer.find('.registration-step-4').removeClass('active').addClass('filled-in')
                    $stepsContainer.find('.registration-step-5').addClass('filled-in')
                } else {
                    $stepsContainer.find('.registration-step-2').removeClass('active').addClass('filled-in')
                }

                if (document.getElementById('appComponents')) {
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_REGISTRATION_FORM_VIEW', 'success')
                }

                if (data.demo_register) {
                    if (document.getElementById('appComponents')) {
                        $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_REGISTRATION_SUCCESS_VIEW', 'demo_register')
                    }
                    toggleLoginAfterSuccess(true, true)
                    return
                }

                if (data.auto_login && shouldRedirect) {
                    trackRegEvent('reg_player_is_logged_in', { member_id: data.member_id })
                    handleRegisterRedirect(data, typeof BaseConfig.get('REFRESH_TIMEOUT') !== 'undefined' ? BaseConfig.get('REFRESH_TIMEOUT') : 3000)
                }

                if (!data.auto_login) {
                    toggleLoginAfterSuccess()
                }

                try {
                    if (typeof $solitics !== 'undefined' && data.member_id) {
                        var loginDetails = {
                            memberId: data.member_id,
                            email: $registerForm.find('#reg_form_email').val(),
                            brand: BaseConfig.get('SOLITICS').brand,
                            popUpToken: BaseConfig.get('SOLITICS').popup_token,
                        }
                        $solitics.loginSuccess(loginDetails)
                        $solitics.emit('onRegisterSuccess', null, null)
                    }
                    if (typeof _smartico !== 'undefined' && data.member_id && data.retentionAllowed) {
                        _smartico.identify(data.member_id)
                        _smartico.login(Config.LOCALE_SHORT)
                        _smartico.changeLanguage(Config.LOCALE_SHORT_ALIAS ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT)
                    }
                } catch (e) {
                    console.log(e)
                }

                if (data.has_affiliates && data.affiliate_code != null && data.affiliate_code != '') {
                    //Set Affiliates (Income Access) iframe property
                    $('<iframe>', {
                        style: 'display:none',
                        src: data.affiliates_traceback_domain + '/Processing/Pixels/Registration.ashx?PlayerID=' + data.white_label_id + data.white_label_id + data.member_id + '&' + data.affiliate_campaign_type,
                    }).appendTo('body')
                }

                /**
                 * If there is Home Page Tracker Template ID,
                 * send Template Tracker data to Google Analytics.
                 */
                if (!!BaseConfig.get('GOOGLE_ANALYTICS_TRACKER_1') && typeof data.member_home_page_template_id !== 'undefined' && data.member_home_page_template_id !== null) {
                    sendTemplateTrackerDataToGoogleAnalytics(data.member_home_page_template_id, data.member_id)
                }

                if (data && !data.agentRegistration && !Config.WHITE_LABEL_REGULATIONS.deposit_limit_welcome && !BaseConfig.get('INDIA_REGISTRATION') && data.auto_login && shouldRedirect) {
                    if (!data.referrer) {
                        data.referrer = '/'
                    }
                    $registerForm.find('#register-complete-button').on('click', function () {
                        handleRegisterRedirect(data)
                    })

                    var time = 15,
                        $counter = $registerForm.find('.redirect-counter'),
                        redirectTimer = setInterval(function () {
                            time--
                            if (time <= 0) {
                                handleRegisterRedirect(data)
                                clearInterval(redirectTimer)
                            }
                            $counter.text(time)
                        }, 1000)
                }
                if (Config.WHITE_LABEL_REGULATIONS.deposit_limit_welcome) {
                    // Store Member id to eventually use it if user submits a deposit limit after the registration
                    BaseConfig.set('MEMBER_ID', data.member_id)
                    localStorage.setItem('depositLimitWelcomeModal' + data.member_id, 1)
                }
                if (Config.WHITE_LABEL_REGULATIONS.fully_verified_notification) {
                    localStorage.setItem('fullyVerifiedNotification' + data.member_id, 0)
                }
                if (Config.WHITE_LABEL_REGULATIONS.deposit_loss_limit_welcome) {
                    localStorage.setItem('depositLossLimitWelcome' + data.member_id, 0)

                    if (window.WebPage && window.ReactNativeWebView) {
                        const cookieName = 'redirectToResponsibleGamingForceLogin'
                        const cookieValue = 'true'
                        document.cookie = `${cookieName}=${cookieValue}; path=/; Secure; SameSite=Lax`
                    }
                }
                if (BaseConfig.get('INDIA_REGISTRATION') && data.auto_login && shouldRedirect) {
                    handleRegisterRedirect(data)
                }
            },
            onFinish: function () {
                registerLoading = false
            },
            onFailure: function (data) {
                onRegistrationErrorHandler(data)
            },
            onAbort: function (data) {
                onRegistrationErrorHandler(data)
            },

        })
    }

    function onRegistrationErrorHandler(err) {
        $registerModal.modal('hide')
        var currentStep = $registerForm.attr('data-step') || 1
        window.trackRegisterFormStepError(err, currentStep)
        window.VueEventBus.$emit('show_modal', 'unexpectedErrorModal')
        registerLoading = false
        const user = { email: $registerForm.find('#reg_form_email').val() }
        const tag = { error_type: 'registration failed' }
        window.ErrorTracker.trackError(err, { user, tag })
    }

    // Initializes Apple Sign In SDK and triggers the sign-in popup.
    // On success, extracts the id_token from Apple's response and
    // delegates to proceedWithAppleLogin (mirrors the Google flow).
    function appleAuth() {
        window.AppleID.auth.init({
            clientId: window.BaseConfig.get('APPLE_SERVICE_ID'),
            scope: 'name email',
            redirectURI: window.location.origin + '/auth/apple/callback',
            usePopup: true,
        })

        window.AppleID.auth.signIn().then(function (result) {
            sendAppleAuthToken(result)
        }).catch(function (error) {
            console.error('[AppleAuth] signIn error:', error)
        })
    }

    // Builds the request payload with Apple's id_token, attaches
    // offer data and SEON session ID (same pattern as sendGoogleAuthToken).
    function sendAppleAuthToken(token) {
        var $authModal = $('.user-account-modal.show')
        var $errorContainer = $authModal.find('.error-container')
        var authModalType = $authModal.attr('id')
        var event = authModalType === 'register-user-modal' ? 'register' : 'login'
        var extraData = token
        extraData.system_data = {
            product_type: localStorage.getItem('productType'),
        }

        if (event === 'register') {
            var offerData = getOfferDataForSocialLogins()
            if (Object.keys(offerData).length) {
                extraData.registration_offers_info = offerData.registration_offers_info
                if (offerData.coupon_code) {
                    extraData.coupon_code = offerData.coupon_code
                }
            }
        }

        if (window.Config.IS_SEON_ENABLED && typeof window.getSeonSessionId === 'function') {
            window.getSeonSessionId().then(function (sessionId) {
                if (sessionId) {
                    extraData['seon_session_id'] = sessionId;
                }
                proceedWithAppleLogin(extraData, $authModal, $errorContainer, event);
            }).catch(function (error) {
                console.error('Error getting SEON session ID for Apple auth:', error);
                proceedWithAppleLogin(extraData, $authModal, $errorContainer, event);
            });
            return;
        }

        proceedWithAppleLogin(extraData, $authModal, $errorContainer, event);
    }

    // Sends the 'appleLogin' AJAX request to the backend.
    // Handles success (Solitics, Smartico, GTM, analytics, reload)
    // and error (IP block, coupon code) — same pattern as proceedWithGoogleLogin.
    function proceedWithAppleLogin(extraData, $authModal, $errorContainer, event) {
        ajaxRequest('appleLogin', {
            toastr: false,
            extraData: extraData,
            alert: {
                $el: $errorContainer,
                dismissible: false,
                className: 'alert-sm text-center',
            },
            onBeforeSend: function () {
                hideUserAccountModals()
                showLoaderOverlay()
            },
            onError: function (response) {
                if (response.error && response.error.ip) {
                    $errorContainer.html('<div class="alert alert-danger alert-sm text-center error-general" role="alert">' + response.error.error_msg + '</div>')
                }
                if (response.error && response.error.coupon_code) {
                    $registerModal.modal('show');
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_SELECTED_PROMOTION', null)
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/EDIT_REGISTRATION_SELECTED_PROMOTION', true)
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_MANUAL_SELECTED_PROMOTION_CODE', { 'error': response.error.coupon_code })
                }
                hideLoaderOverlay()
                $authModal.modal('show')
            },
            onSuccess: function (response) {
                const memberId = response.member_id ? response.member_id : response.userid
                try {
                    if (typeof $solitics !== 'undefined') {
                        var loginDetails = {
                            memberId,
                            email: response.email,
                            brand: BaseConfig.get('SOLITICS').brand,
                            popupToken: BaseConfig.get('SOLITICS').popup_token,
                        }
                        $solitics.loginSuccess(loginDetails)
                        if (BaseConfig.get('MEMBER_EMAIL') != $solitics.solitics_configuration.email) {
                            localStorage.removeItem('SOLITICS_CONFIGURATION')
                        }
                    }
                    if (typeof _smartico !== 'undefined') {
                        _smartico.identify(response.member_id ? response.member_id : response.userid.slice(2))
                        _smartico.login(Config.LOCALE_SHORT)
                        _smartico.changeLanguage(Config.LOCALE_SHORT_ALIAS ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT)
                    }
                } catch (e) {
                    console.log(e)
                }

                setGtmDataLayer({
                    'member_id': response.userid,
                }, 'loggedin')

                window.UILogger.logEvent(window.UILogger.eventNames.Auth[`${event}`], {
                    method: 'Apple',
                })
                if (event === 'register') {
                    trackOffersGA('success_registration', 'Apple')
                    trackRegEvent('reg_account_created', { member_id: memberId, sign_up_method: 'apple' })
                }

                var redirect_url = sessionStorage.getItem('LOGIN_REDIRECT_URL') || response.referrer
                sessionStorage.removeItem('LOGIN_REDIRECT_URL')
                if (typeof chrome === 'undefined') {
                    setTimeout(function () {
                        changePage()
                    }, 1000)
                } else {
                    changePage()
                }

                function changePage() {
                    // @window-location-ignore
                    window.location.href === redirect_url
                        // @window-location-ignore
                        ? window.location.reload()
                        // @window-location-ignore
                        : window.location.href = redirect_url || window.location.href
                }
            },
        })
    }

    function facebookAuth() {
        var $authModal = $('.user-account-modal.show')
        var $errorContainer = $authModal.find('.error-container')
        var authModalType = $authModal.attr('id')
        var event = authModalType === 'register-user-modal' ? 'register' : 'login'
        var extraData = {
            system_data: {
                product_type: localStorage.getItem('productType'),
            },
        }

        if (event === 'register') {
            var offerData = getOfferDataForSocialLogins()
            if (Object.keys(offerData).length) {
                extraData.registration_offers_info = offerData.registration_offers_info
                if (offerData.coupon_code) {
                    extraData.coupon_code = offerData.coupon_code
                }
            }
        }

        // Wait for SEON session ID if enabled
        if (window.Config.IS_SEON_ENABLED && typeof window.getSeonSessionId === 'function') {
            window.getSeonSessionId().then(function (sessionId) {
                if (sessionId) {
                    extraData['seon_session_id'] = sessionId;
                }
                proceedWithFacebookLogin(extraData, $authModal, $errorContainer, event);
            }).catch(function (error) {
                console.error('Error getting SEON session ID for Facebook auth:', error);
                proceedWithFacebookLogin(extraData, $authModal, $errorContainer, event);
            });
            return;
        }

        proceedWithFacebookLogin(extraData, $authModal, $errorContainer, event);
    }

    function proceedWithFacebookLogin(extraData, $authModal, $errorContainer, event) {
        FB.login(function (response) {
            if (response.status === 'connected') {
                if (response.authResponse) {
                    ajaxRequest('fbLogin', {
                        toastr: false,
                        alert: {
                            $el: $errorContainer,
                            dismissible: false,
                            className: 'alert-sm text-center',
                        },
                        extraData: extraData,
                        onBeforeSend: function () {
                            hideUserAccountModals()
                            showLoaderOverlay()
                        },
                        onError: function (response) {
                            if (response.error && response.error.ip) {
                                $errorContainer.html('<div class="alert alert-danger alert-sm text-center error-general" role="alert">' + response.error.error_msg + '</div>')
                            }
                            if (response.error && response.error.coupon_code) {
                                $registerModal.modal('show')
                                $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_SELECTED_PROMOTION', null)
                                $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/EDIT_REGISTRATION_SELECTED_PROMOTION', true)
                                $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_MANUAL_SELECTED_PROMOTION_CODE', { 'error': response.error.coupon_code })
                            }
                            hideLoaderOverlay()
                            $authModal.modal('show')
                        },
                        onSuccess: function (response) {
                            const memberId = response.member_id ? response.member_id : response.userid
                            try {
                                if (typeof $solitics !== 'undefined') {
                                    var loginDetails = {
                                        memberId,
                                        email: response.email,
                                        brand: BaseConfig.get('SOLITICS').brand,
                                        popupToken: BaseConfig.get('SOLITICS').popup_token,
                                    }
                                    $solitics.loginSuccess(loginDetails)
                                    if (BaseConfig.get('MEMBER_EMAIL') != $solitics.solitics_configuration.email) {
                                        localStorage.removeItem('SOLITICS_CONFIGURATION')
                                    }
                                }
                                if (typeof _smartico !== 'undefined') {
                                    _smartico.identify(response.member_id ? response.member_id : response.userid.slice(2))
                                    _smartico.login(Config.LOCALE_SHORT)
                                    _smartico.changeLanguage(Config.LOCALE_SHORT_ALIAS ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT)
                                }
                            } catch (e) {
                                console.log(e)
                            }

                            setGtmDataLayer({
                                'member_id': response.userid,
                            }, 'loggedin')

                            window.UILogger.logEvent(window.UILogger.eventNames.Auth[`${event}`], {
                                method: 'Facebook',
                            })
                            if (event === 'register') {
                                trackOffersGA('success_registration', 'Facebook')
                                trackRegEvent('reg_account_created', { member_id: memberId, sign_up_method: 'facebook' })
                            }

                            window.location.reload()
                        },
                    })
                } else {
                    // Error occurred
                }
            } else {
                // Error occurred
            }
        },
            {
                scope: 'email',
            })
    }

    function googleAuth() {
        getToken()
        var checkForToken = setInterval(function () {
            if (googleAccessToken) {
                clearInterval(checkForToken)
                sendGoogleAuthToken(googleAccessToken)
            }
        }, 200)
    }

    function sendGoogleAuthToken(token) {
        var $authModal = $('.user-account-modal.show')
        var $errorContainer = $authModal.find('.error-container')
        var authModalType = $authModal.attr('id')
        var event = authModalType === 'register-user-modal' ? 'register' : 'login'
        var extraData = {
            id_token: token,
            system_data: {
                product_type: localStorage.getItem('productType'),
            },
        }

        if (event === 'register') {
            var offerData = getOfferDataForSocialLogins()
            if (Object.keys(offerData).length) {
                extraData.registration_offers_info = offerData.registration_offers_info
                if (offerData.coupon_code) {
                    extraData.coupon_code = offerData.coupon_code
                }
            }
        }

        // Wait for SEON session ID if enabled
        if (window.Config.IS_SEON_ENABLED && typeof window.getSeonSessionId === 'function') {
            window.getSeonSessionId().then(function (sessionId) {
                if (sessionId) {
                    extraData['seon_session_id'] = sessionId;
                }
                proceedWithGoogleLogin(extraData, $authModal, $errorContainer, event);
            }).catch(function (error) {
                console.error('Error getting SEON session ID for Google auth:', error);
                proceedWithGoogleLogin(extraData, $authModal, $errorContainer, event);
            });
            return;
        }

        proceedWithGoogleLogin(extraData, $authModal, $errorContainer, event);
    }

    function proceedWithGoogleLogin(extraData, $authModal, $errorContainer, event) {
        ajaxRequest('googleLogin', {
            toastr: false,
            extraData: extraData,
            alert: {
                $el: $errorContainer,
                dismissible: false,
                className: 'alert-sm text-center',
            },
            onBeforeSend: function () {
                hideUserAccountModals()
                showLoaderOverlay()
            },
            onError: function (response) {
                if (response.error && response.error.ip) {
                    $errorContainer.html('<div class="alert alert-danger alert-sm text-center error-general" role="alert">' + response.error.error_msg + '</div>')
                }
                if (response.error && response.error.coupon_code) {
                    $registerModal.modal('show');
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_SELECTED_PROMOTION', null)
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/EDIT_REGISTRATION_SELECTED_PROMOTION', true)
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.commit('promotions/SET_REGISTRATION_MANUAL_SELECTED_PROMOTION_CODE', { 'error': response.error.coupon_code })
                }
                hideLoaderOverlay()
                $authModal.modal('show')
            },
            onSuccess: function (response) {
                const memberId = response.member_id ? response.member_id : response.userid
                try {
                    if (typeof $solitics !== 'undefined') {
                        var loginDetails = {
                            memberId,
                            email: response.email,
                            brand: BaseConfig.get('SOLITICS').brand,
                            popupToken: BaseConfig.get('SOLITICS').popup_token,
                        }
                        $solitics.loginSuccess(loginDetails)
                        if (BaseConfig.get('MEMBER_EMAIL') != $solitics.solitics_configuration.email) {
                            localStorage.removeItem('SOLITICS_CONFIGURATION')
                        }
                    }
                    if (typeof _smartico !== 'undefined') {
                        _smartico.identify(response.member_id ? response.member_id : response.userid.slice(2))
                        _smartico.login(Config.LOCALE_SHORT)
                        _smartico.changeLanguage(Config.LOCALE_SHORT_ALIAS ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT)
                    }
                } catch (e) {
                    console.log(e)
                }

                setGtmDataLayer({
                    'member_id': response.userid,
                }, 'loggedin')

                window.UILogger.logEvent(window.UILogger.eventNames.Auth[`${event}`], {
                    method: 'Google',
                })
                if (event === 'register') {
                    trackOffersGA('success_registration', 'Google')
                    trackRegEvent('reg_account_created', { member_id: memberId, sign_up_method: 'google' })
                }

                var redirect_url = sessionStorage.getItem('LOGIN_REDIRECT_URL') || response.referrer
                sessionStorage.removeItem('LOGIN_REDIRECT_URL')
                if (typeof chrome === 'undefined') {
                    setTimeout(function () {
                        changePage()
                    }, 1000)
                } else {
                    changePage()
                }

                function changePage() {
                    // @window-location-ignore
                    window.location.href === redirect_url
                        // @window-location-ignore
                        ? window.location.reload()
                        // @window-location-ignore
                        : window.location = redirect_url
                }
            },
        })
    }

    function hideUserAccountModals() {
        $registerModal.modal('hide')
        $('#login-guest-modal').modal('hide')
    }

    function showLoaderOverlay(autoHide) {
        window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')

        if (typeof autoHide !== 'undefined' && autoHide === true) {
            setTimeout(function () {
                hideLoaderOverlay();
            }, 5000)
        }
    }

    function hideLoaderOverlay() {
        window.getBodyClassList().remove('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content')
    }

    function sendOtp(recaptchaParams) {
        var $formElement = $('.phone-group-row')
        var $form = getElement('.phone-group-row')
        var btnLabel = $sendOtp.text()

        if (recaptchaParams) {
            $form.requestData['recaptcha_token'] = recaptchaParams.recaptcha_token
            $form.requestData['action'] = recaptchaParams.action
        }

        $form.ajaxRequest('sendOneTimePassword', {
            'toastr': false,
            request: {
                url: '/' + Config.LOCALE_SHORT + '/index/operation/sendOneTimePassword',
            },
            'onAfterSend': function () {
                $sendOtp.html('&nbsp;').addClass('loader-center loader-primary loader-circle-inline-full disabled')
            },
            'onError': function (response) {
                var errors = response.error

                $formElement.find('#reg_form_cell_phone').parent().find('.success-message').addClass('d-none')
                $formElement.find('.is-invalid').removeClass('is-invalid')

                for (var error in errors) {
                    $formElement.find('#reg_form_cell_phone').addClass('is-invalid').next().text(errors[error])
                }
            },
            'onSuccess': function (response) {
                if (response.data.code_sent) {
                    $formElement.find('#reg_form_cell_phone').removeClass('is-invalid')
                    $formElement.find('#reg_form_cell_phone').parent().find('.success-message').removeClass('d-none').text(response.data.message)
                }
            },
            'onFinish': function () {
                $sendOtp.text(btnLabel).removeClass('loader-center loader-primary loader-circle-inline-full disabled')
            },
        })
    }

    function getAccountData() {
        var summary = []
        var birthdayData = []
        var birthdayItem = {}
        var birthDayFields = ['reg_form_birthday_day', 'reg_form_birthday_month', 'reg_form_birthday_year']
        var vuex = getStore()

        document.querySelectorAll('#register-user-form input').forEach(function (input) {
            var item = {
                key: input.id,
                title: input.title,
                value: input.value,
            }
            if (input.id === 'reg_form_maiden_name' && input.value === '') {
                item.value = getSummaryValueByKey(summary, 'reg_form_lname')
            }
            if (input.id === 'reg_form_cell_phone' && input.value != '') {
                item.value = '+' + getSummaryValueByKey(summary, 'reg_form_phone_prefix') + ' ' + input.value
            }
            summary.push(item)
        })
        document.querySelectorAll('#register-user-form select').forEach(function (select) {
            if (birthDayFields.indexOf(select.id) != -1) {
                birthdayData.push(select.value)
                birthdayItem = generateSummaryItem('reg_form_birthday', '_localizer.REGISTER.placeholder_birthday', birthdayData.join('/'))
            }

            var registrationFormData = vuex.state.application.registrationFormData

            if (select.id === 'reg_form_country_id') {
                var availableCountries = registrationFormData ? registrationFormData.availableCountries : [];
                var countriesItem = generateSummaryItem('reg_form_country', '_localizer.REGISTER.country', getSummaryValueByKey(availableCountries, select.value))
                summary.push(countriesItem)
            }
            if (select.id === 'reg_form_currency_id') {
                var availableCurrencies = registrationFormData ? registrationFormData.availableCurrencies : [];
                var currencyItem = generateSummaryItem('reg_form_currency', '_localizer.REGISTER.currency', getSummaryValueByKey(availableCurrencies, select.value))
                summary.push(currencyItem)
            }
            if (select.id === 'reg_form_security_question') {
                var securityAnswerField = document.getElementById('reg_form_security_answer')
                var securityAnswer = generateSummaryItem('reg_form_security_answer', '_localizer.REGISTER.please_security_answer', securityAnswerField.value)
                var securityQuestion = generateSummaryItem('reg_form_security_question', '_localizer.REGISTER.placeholder_security_question', Config.REG_FORM_DATA.securityQuestions[select.value])
                summary.push(securityQuestion)
                summary.push(securityAnswer)
            }
        })

        var genderItem = generateSummaryItem('reg_form_gender', '_localizer.REGISTER.placeholder_gender', $('input[name="reg_form[gender]"]:checked').val())
        summary.push(birthdayItem, genderItem)

        if (Config.WHITE_LABEL_REGULATIONS.reg_additional_data) {
            summary = summary.concat(vuex.state.user.employmentSummaryData)
        }
        return summary.filter(function (item) {
            return item.title != ''
        })
    }

    function getSummaryValueByKey(object, key) {
        var value = ''
        object.map(function (item) {
            if (item.key === key) {
                value = item.value
            } else {
                item.id === key ? value = item.title : ''
            }
        })
        return value
    }

    function generateSummaryItem(key, title, value) {
        return item = {
            key: key,
            title: translation(title),
            value: value,
        }
    }

    function getSuccessScreenHeight(demo_register = false) {
        var $desktopSelector = Config.PHONE_NUMBER_REGISTRATION ? $registerModal.find('.tab-pane.active .confirmation-container') : $('.confirmation-container')
        var modalBodyHeight = Config.IS_MOBILE ? $registerModal.find('.modal-body')[0].offsetHeight : $desktopSelector[0].offsetHeight
        if (demo_register) {
            modalBodyHeight = $registerModal.find('.modal-body')[0].offsetHeight - $registerModal.find('.modal-header')[0].offsetHeight
            if ($appComponents && $appComponents.__vueParentComponent) {
                var registrationFormData = vuex.state.application.registrationFormData
                var registrationPromotionOffers = registrationFormData ? registrationFormData.registrationOffers : {};
                if (registrationPromotionOffers && !registrationPromotionOffers.error && Object.keys(registrationPromotionOffers).length) {
                    modalBodyHeight = modalBodyHeight - $registerModal.find('.registration-offers-container')[0].offsetHeight
                }
            }
        }
        return modalBodyHeight
    }

    function toggleLoginAfterSuccess(show = true, demo_register = false) {
        var stepsCount = $('.step-section').length
        var payNPlayWidgetTNC = $registerModal.find('.pay-n-play-widget-t-n-c')

        if (Config.PHONE_NUMBER_REGISTRATION) {
            stepsCount = $registerModal.find('.tab-pane.active .step-section').length
        }

        if (show) {
            $('.step-section').each(function (i, el) {
                if (i < stepsCount) {
                    $(el).addClass('d-none')
                }
            })
            $registerModal.find('.modal-title-sign').addClass('d-none')
            $registerModal.find('.modal-nav').addClass('d-none')
            $registerModal.find('.modal-title-welcome').addClass('d-none')
            $registerModal.find('.step-section-' + stepsCount).removeClass('d-none')
            $registerModal.find('.step-section-' + stepsCount).addClass('active')
            $couponCodeContainer.collapse('hide')
            $couponCodeToggle.addClass('d-none')
            $stepsContainer.addClass('d-none')
            $('.redirect-counter-container').addClass('d-none')
            $('#register-complete-button').addClass('d-none')
            $registerForm.addClass('d-flex align-items-center justify-content-center')
            $socialLogins.addClass('d-none')
            $authActionModalToggle.addClass('d-none')
            if (payNPlayWidgetTNC) payNPlayWidgetTNC.addClass('d-none')
            $('.confirmation-icon-container').removeClass('d-none')
            $('.login-action-caption').removeClass('d-none')
            $('.login-action-btn-container').removeClass('d-none').addClass('d-flex')
            if (demo_register) {
                $registerModal.find('.step-section-' + stepsCount).addClass('d-none')
                if (!Config.IS_MOBILE) {
                    return
                }
            }
            $registerForm.height(getSuccessScreenHeight(demo_register))
        } else {
            $stepOne.removeClass('d-none')
            $('.step-section').each(function (i, el) {
                if (i > 0 && i < stepsCount) {
                    $(el).addClass('d-none')
                }
            })
            $registerModal.find('.modal-title-sign').removeClass('d-none')
            $registerModal.find('.step-section-' + stepsCount).addClass('d-none')
            $couponCodeContainer.collapse('hide')
            $couponCodeToggle.removeClass('d-none')
            $stepsContainer.removeClass('d-none')
            $('.redirect-counter-container').removeClass('d-none')
            $('#register-complete-button').removeClass('d-none')
            $registerForm.removeAttr('style')
            $registerForm.removeClass('d-flex align-items-center justify-content-center')
            $socialLogins.removeClass('d-none')
            $authActionModalToggle.removeClass('d-none')
            if (payNPlayWidgetTNC) payNPlayWidgetTNC.removeClass('d-none')
            $('.confirmation-icon-container').addClass('d-none')
            $('.login-action-caption').addClass('d-none')
            $('.login-action-btn-container').removeClass('d-flex').addClass('d-none')
        }
    }

    function sendTemplateTrackerDataToGoogleAnalytics(templateId, memberId) {
        // Setting the custom Template Tracker dimensions.
        ga('set', 'dimension1', templateId)
        ga('set', 'dimension2', memberId)

        /**
         * Sending an 'Event' hit.
         * The custom dimensions will be sent together with the 'Event' hit to Google Analytics.
         */
        ga('send', 'event', 'HomePageTemplateTracking', 'saveTemplateDataOnMemberRegistration')
    }

    function initLogoutHandler() {
        $('.logoutButton').click(function (e) {
            var $el = $(this)
            e.preventDefault()

            // Remove deposit pay and play modal flag on logout
            window.sessionStorage.removeItem('DEPOSIT_PAY_AND_PLAY_OPTIONS_MODAL_AFTER_LOGIN_IS_SHOWN')

            if (window.WebPage) {
                window.WebPage.sendMessage({
                    type: 'USER_LOGOUT',
                    payload: true,
                })
            }

            try {
                if (typeof _smartico !== 'undefined') {
                    _smartico.logout()
                }
                if (typeof $solitics !== 'undefined') {
                    $solitics.onLogout()
                }
                if (typeof FB !== 'undefined') {
                    FB.getLoginStatus(function (response) {
                        if (response.status === 'connected') {
                            FB.logout()
                        }
                    })
                }
            } catch (e) {
                console.log(e)
            }

            setTimeout(function () {
                // @window-location-ignore
                window.location = $el.attr('href')
            }, 1000)
        })
    }

    function setRegistrationConfig(data) {
        Config.REG_FORM_DATA = data,
            Config.IS_REGISTER_ALLOWED = data.isRegisterAllowed,
            preselectedCountryIso = data.preselect.country_iso,
            preselectedCountryTitle = data.preselect.country_title

        if (!data.isRegisterAllowed) {
            if (window.VueEventBus) {
                window.VueEventBus.$emit('init-registration-restricted-access');
            }
            disableRegistration();
        }
        Validator.initPhonePrefix()
        if (Config.WHITE_LABEL_REGULATIONS.reg_bsn && !BaseConfig.get('IS_SIMPLE_REGISTRATION')) {
            Validator.initBsnValidations()
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_cnp && !BaseConfig.get('IS_SIMPLE_REGISTRATION')) {
            Validator.initCnpValidations()
            Validator.initGenderValidation()
        }
        var hasCpr = Config.WHITE_LABEL_REGULATIONS.reg_cpr && !BaseConfig.get('IS_SIMPLE_REGISTRATION')
        if (hasCpr) {
            Validator.initCprValidations()
            Validator.initGenderValidation()
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_spn && !BaseConfig.get('IS_SIMPLE_REGISTRATION')) {
            Validator.initSpnValidations()
            Validator.initGenderValidation()
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_document_types && Config.WHITE_LABEL_REGULATIONS.reg_document_types.length) {
            Validator.initDocumentIdValidations()
        }
        setRegistrationFormVars(data)
        toggleStateDropdownMenu()
        initRegisterModal()
    }

    function retryFetchRegisterConfig() {
        //TODO move that in vue and add global option for retry in network-client.js
        if (registerConfigurationErrorCount < 5) {
            registerConfigurationErrorCount = registerConfigurationErrorCount + 1
            if (document.getElementById('appComponents') && document.getElementById('appComponents').__vueParentComponent) {
                document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.dispatch('application/GET_REGISTRATION_FORM_VARS')
            }
        }
    }

    var setRegistrationFormVars = function (data) {
        var availableCountries = data.availableCountries,
            availableCurrencies = data.availableCurrencies,
            availableStates = data.availableStates,
            phonePrefixes = data.phonePrefix,
            preselect = data.preselect,
            isRegisterAllowed = data.isRegisterAllowed,
            securityQuestions = data.securityQuestions

        var $phoneNumberContainer = $('.phone-prefix-select').closest('.phone-prefix-container')
        var hiddenPhoneNumberField = $phoneNumberContainer.find('.phone-prefix-hidden-input')
        var prefixDefaultValue = hiddenPhoneNumberField.length && hiddenPhoneNumberField.val().length ? hiddenPhoneNumberField.val() : null

        if (BaseConfig.get('INDIA_REGISTRATION')) {
            $('.india_country_id').val(availableCountries[0].id)
            $('.india_currency_id').val(preselect.currency)
        }

        if (BaseConfig.get('CELL_PHONE_ADDITIONAL_PREFIXES') && Config.USER_LOGGED_IN === '1') {
            for (var country in BaseConfig.get('CELL_PHONE_ADDITIONAL_PREFIXES')) {
                var additionalCountry = BaseConfig.get('CELL_PHONE_ADDITIONAL_PREFIXES')[country]
                additionalCountry.title = additionalCountry['title_' + Config.LOCALE_SHORT.toLowerCase()] ? additionalCountry['title_' + Config.LOCALE_SHORT.toLowerCase()] : additionalCountry['title_en']
                availableCountries.push(additionalCountry)
            }
        }

        for (var key in availableCountries) {
            var self = availableCountries[key]
            if (self.iso2_alpha !== 'AX') {
                $('.reg-form-country-id').append('<option data-iso="' + self.iso2_alpha + '" value="' + self.id + '" ' + (preselect.country == self.id ? 'selected' : '') + '>' + self.title + '</option>')
                if (BaseConfig.get('INDIA_REGISTRATION') && preselect.country == self.id) {
                    $('.india_country_id').val(preselect.country)
                }
            }
        }

        if (Config.WHITE_LABEL_REGULATIONS.reg_state) {
            var stateDropdownMenu = $('#register-user-form').find('#reg_form_state_id')
            var availableStatesCountryIds = []

            availableStates.forEach(function (state) {
                if (availableStatesCountryIds.indexOf(state.country_id) === -1) {
                    availableStatesCountryIds.push(state.country_id)
                }
            })

            if (availableStates.length > 0 && availableStatesCountryIds.indexOf(preselect.country.toString()) !== -1) {
                stateDropdownMenu.find('option + option').remove()
                appendDropdownOptions(availableStates, stateDropdownMenu, 'country_subdivision_id', 'title')
            }
        }

        if (Config.WHITE_LABEL_REGULATIONS.reg_pob) {
            for (var key in data.countriesList) {
                var self = data.countriesList[key]
                if (self.iso2_alpha !== 'AX') {
                    $('#reg_form_place_of_birth').append('<option data-iso="' + self.iso2_alpha + '" value="' + self.id + '" ' + (preselect.country == self.id ? 'selected' : '') + '>' + self.title + '</option>')
                }
            }
        }

        if (Config.WHITE_LABEL_REGULATIONS.reg_nationality) {
            for (var key in data.nationalitiesList) {
                var self = data.nationalitiesList[key]
                $('#reg_form_nationality').append('<option value="' + self.id + '">' + self.title + '</option>')
            }
        }
        if (Config.ACTION === 'personalDetails') {
            if (Config.WHITE_LABEL_REGULATIONS.reg_pob) {
                var $accountFormPlaceOfBirth = $('#account_form_place_of_birth')
                var placeOfBirth = $.grep(data.countriesList, function (value, key) {
                    return value.id === $accountFormPlaceOfBirth.closest('div[data-preselect-id]').data('preselect-id').toString()
                })
                if (placeOfBirth.length) {
                    $accountFormPlaceOfBirth.val(placeOfBirth[0].title)
                }
            }
            if (Config.WHITE_LABEL_REGULATIONS.reg_nationality) {
                var $accountFormNationality = $('#account_form_nationality')
                var nationality = $.grep(data.nationalitiesList, function (value, key) {
                    return value.id === $accountFormNationality.closest('div[data-preselect-id]').data('preselect-id').toString()
                })
                if (nationality.length) {
                    $accountFormNationality.val(nationality[0].title)
                }
            }
        }

        for (var key in availableCurrencies) {
            var self = availableCurrencies[key]
            $('.reg-form-currency-id').append('<option value="' + self.id + '" ' + (preselect.currency == self.id ? 'selected' : '') + '>' + self.title + '</option>')
        }

        for (var key in phonePrefixes) {
            var phonePrefix = phonePrefixes[key]
            if (phonePrefix == prefixDefaultValue) {
                preselect.country_iso = key.toLowerCase()
            }
            var matchedCountry = _.findWhere(data.availableCountries, { iso2_alpha: key })
            if (matchedCountry && key !== 'AX') {
                $('.phone-prefix-select:not(.vue-component)').append('<option data-phone-prefix="' + phonePrefix + '" data-iso="' + key + '" value="' + phonePrefix + '" ' + (preselect.country_iso == key.toLowerCase() ? 'selected' : '') + '>' + matchedCountry.title + '</option>')
                if (preselect.country_iso == key.toLowerCase()) {
                    $('.phone-prefix-container').find('.phone-prefix-select').trigger('change')
                }
            } else {
                // console.log('skipping: ', phonePrefix, key)
            }
        }

        if (!BaseConfig.get('IS_SIMPLE_REGISTRATION') || Config.BLOCK_TEMPORARY_DE && Config.LOCALE_SHORT === 'deu') {
            for (var key in securityQuestions) {
                $('#reg_form_security_question').append('<option value="' + key + '">' + securityQuestions[key] + '</option>')
            }
        }

        var $completeRegisterModal = $('#completeRegisterModal')
        var $registerForm = $('#register-user-form')
        var $registerPhoneNumberForm = $('#register-phone-number-user-form')
        var $loginPhoneNumberForm = $('#login-modal-phone-number-form')
        var memberIsoCode = BaseConfig.get('MEMBER_COUNTRY_ISO_CODE')

        if ($completeRegisterModal.length) {
            if (availableCountries.length === 1) {
                preselectSingleAvailableCountry($completeRegisterModal)
            }
            preselectPhonePrefix($completeRegisterModal, memberIsoCode)
            setTimeout(function () {
                preselectCurrency($completeRegisterModal, memberIsoCode)
            }, 500)
        }

        if (Config.USER_LOGGED_IN !== '1' && isRegisterAllowed === 1 && !Config.PLUGIN_MODE) {
            if (Config.WHITE_LABEL_REGULATIONS.reg_state) {
                preselectStateField($registerForm, preselect.country)
            }

            availableCountries.length === 1
                ? preselectSingleAvailableCountry($registerForm, true)
                : $registerForm.find('#reg_form_country_id').closest('.col').removeClass('d-none')

            if (Config.PHONE_NUMBER_REGISTRATION) {
                preselectPhonePrefix($registerPhoneNumberForm, preselect.country_iso)
                preselectPhonePrefix($loginPhoneNumberForm, preselect.country_iso)
            }

            preselectPhonePrefix($registerForm, preselect.country_iso)
            setTimeout(function () {
                preselectCurrency($registerForm, preselect.country_iso, true)
            }, 500)
        }
    }

    var disableRegistration = function () {
        var $registrationBox = $('.popup-registration-box');
        var $loginActionToggle = $registrationBox.parent().find('.auth-action-modal-toggle');
        var $couponActivationCodeToggle = $('.modal-header .coupon-code-toggle');
        var $registrationModalTitle = $registerModal.find('.modal-title');

        $couponActivationCodeToggle.remove();
        $registrationModalTitle.empty();
        $couponCodeContainer.remove();
        $socialLogins.remove();
        $registrationBox.remove();
        $loginActionToggle.remove();
    };

    function initRegisterConfiguration() {
        if ((Config.ACTION === 'error' && Config.CONTROLLER === 'index') || ((Config.USER_LOGGED_IN == 1) && Cookies.get('av') == 'undefined')) {
            return
        }
        if (Config.WHITE_LABEL_REGULATIONS.reg_document_types && Config.WHITE_LABEL_REGULATIONS.reg_document_types.length > 0) {
            var regDocsAvailable = Validator.documentValidationRequirements
            for (var docType of Config.WHITE_LABEL_REGULATIONS.reg_document_types) {
                if (regDocsAvailable[docType]) {
                    $('#reg_form_document_id').append('<option value="' + docType + '">' + translation('_localizer.REGISTER.document_' + docType) + '</option>')
                }
            }
        }

        Mediator.getMediator().on('registerConfigurationSuccess', function (target, data) {
            setRegistrationConfig(data)
        })
        Mediator.getMediator().on('registerConfigurationRetry', function () {
            setTimeout(function () {
                retryFetchRegisterConfig()
            }, 200)
        })
    }

    function initRegisterModal() {
        if (Config.USER_LOGGED_IN === '1') {
            return
        }
        if (getParameterByName('register') == 'true') {
            // Initial check if we have registrationConfig for the new registration form
            checkRegistrationConfig(0, 'register=true')

            var couponCode = getParameterByName('coupon')
            if (couponCode) {
                $couponCodeContainer.collapse('toggle')
                $couponCodeContainer.find('input').val(couponCode)
                $('input[name="reg_form[coupon_code]"]').val(couponCode)
            }
        }
    }

    function changeTermsAndPolicyLinksClasses() {
        $acceptTermsAndPolicyLinks.removeClass('help-popup').addClass('webview-modal-external-link')
    }
})

function isPageGuestOnly() {
    if (
        Config.IS_LANDING_PAGE
        || window.location.href.indexOf('auth/login') !== -1
        || window.location.href.indexOf('index/register') !== -1
    ) {
        return true
    }
    return false
}

function handleRegisterRedirect(data, delay) {
    window.VueEventBus.$emit('successful-registration')

    var timeOutDelay = delay ? delay : 0
    window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center')
    $('.modal').modal('hide')
    if (Config.QUICK_DEPOSIT == 1 && data.referrer.indexOf('deposit') !== -1 && Config.SHOW_AGE_VERIFICATION_POPUP === 0) {
        var currentLocation = window.location.href
        var reloadParam = '?quick_deposit=true'

        if (currentLocation.substring(currentLocation.length - 1) === '/') {
            currentLocation = currentLocation.replace(/.$/, '')
        }
        if (isPageGuestOnly()) {
            if (Config.CASINO_ORIENTED_SPORTSBOOK) {
                currentLocation += ''
            } else {
                currentLocation = window.location.origin + (Config.LAST_VIEW === 'asian' ? Config.ASIAN_URL : Config.EURO_URL)
                currentLocation = currentLocation.slice(0, currentLocation.indexOf('?'))
            }
        }
        if (currentLocation.indexOf('?') !== -1) {
            reloadParam = '&quick_deposit=true'
        }

        if (Config.WHITE_LABEL_REGULATIONS.require_sess_deposit_maxbal_limits) {
            //deposit should not be triggered after registration if require_sess_deposit_maxbal_limits regulation is ON
            reloadParam = ''
        }
        if (Config.WHITE_LABEL_REGULATIONS.deposit_loss_limit_welcome) {
            reloadParam = ''
            currentLocation = Config.LOCALE_URL + '/my/responsible-gaming'
        }

        if (BaseConfig.get('DISABLE_DEPOSIT_AFTER_REG')) {
            reloadParam = ''
        }
        sessionStorage.setItem('__SUCCESSFULL_REGISTRATION_REDIRECT__', 'true')
        setTimeout(function () {
            // @window-location-ignore
            window.location.href = currentLocation + reloadParam
        }, timeOutDelay)
    } else {
        var redirectUrl = Config.SHOW_AGE_VERIFICATION_POPUP == 1 ? '/' : data.referrer
        setTimeout(function () {
            // @window-location-ignore
            window.location = redirectUrl
        }, timeOutDelay)
    }
}

function preselectSingleAvailableCountry(el, isRegisterForm) {
    if (!document.getElementById('appComponents') || !document.getElementById('appComponents').__vueParentComponent) {
        return
    }
    var vuex = document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store;
    var registrationFormData = vuex.state.application.registrationFormData;
    var availableCountries = registrationFormData ? registrationFormData.availableCountries : []
    if (availableCountries.length === 1) {
        el.find('#reg_form_country_id').prop("selectedIndex", 1).prop('disabled', true).trigger('change');

        if (window.BaseConfig.get('HIDE_REG_FORM_CURRENCY_AND_COUNTRY') && isRegisterForm) {
            el.find('#reg_form_country_id').closest('.col').addClass('d-none')
        }
    }
}

function preselectPhonePrefix(el, preselectedIsoCode) {
    var phonePrefixSelect = el.find('.phone-prefix-select')
    var isoCode = preselectedIsoCode ? preselectedIsoCode.toUpperCase() : el.find('#reg_form_country_id :selected').attr('data-iso')
    phonePrefixSelect.find('[data-iso=' + isoCode + ']').prop('selected', true).trigger('change')
    if (phonePrefixSelect && phonePrefixSelect[0] && phonePrefixSelect[0].length === 2) {
        phonePrefixSelect.prop('disabled', true).css('cursor', 'default').addClass('.custom-select:disabled')
    }
}

function preselectCurrency(el, preselectedIsoCode, isRegisterForm) {
    if (!document.getElementById('appComponents') || !document.getElementById('appComponents').__vueParentComponent) {
        return
    }
    var vuex = document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store;
    var registrationFormData = vuex.state.application.registrationFormData;
    var availableCurrencies = registrationFormData ? registrationFormData.availableCurrencies : []
    var availableCountries = registrationFormData ? registrationFormData.availableCountries : []
    var isoCode = preselectedIsoCode ? preselectedIsoCode.toUpperCase() : el.find('#reg_form_country_id :selected').attr('data-iso');
    var selectedCountry = availableCountries.find(function (country) { return country.iso2_alpha === isoCode });
    if (selectedCountry) {
        var preselectCurrencyObject = availableCurrencies.find(function (currency) { return currency.code === selectedCountry.default_currency });
    }
    var simplifiedCurrenciesList = availableCurrencies.filter(function (currency) { return currency.is_part_of_player_available_currencies });
    var defaultCurrencyObject = availableCurrencies.find(function (currency) { return currency.code === Config.DEFAULT_CURRENCY_CODE });
    var currencyObject = preselectCurrencyObject ? preselectCurrencyObject : defaultCurrencyObject;
    var currenciesList = availableCurrencies;
    var regFormCurrencyId = el.find('.reg-form-currency-id');

    regFormCurrencyId.empty()
    regFormCurrencyId.append('<option disabled="true" value="0">' + translation('_localizer.REGISTER.currency') + '</option>')

    if (simplifiedCurrenciesList.length && currencyObject) {
        if (simplifiedCurrenciesList.find(function (item) { return item.id === currencyObject.id }) === undefined) {
            simplifiedCurrenciesList.push(currencyObject)
        }
        currenciesList = simplifiedCurrenciesList
    }

    for (var key in currenciesList) {
        var self = currenciesList[key]
        regFormCurrencyId.append('<option value="' + self.id + '" ' + '>' + self.title + '</option>')
    }

    var selectedCurrencyId = 0

    if (currencyObject) {
        selectedCurrencyId = currencyObject.id
    }

    const currencyCol = el.find('#reg_form_currency_id').closest('.col');
    const countryCol = el.find('#reg_form_country_id').closest('.col');
    const currencyAndCountryRow = currencyCol.closest('.row');

    if (currenciesList.length === 1) {
        selectedCurrencyId = currenciesList[0].id
        regFormCurrencyId.prop('disabled', true)

        if (window.BaseConfig.get('HIDE_REG_FORM_CURRENCY_AND_COUNTRY') && isRegisterForm) {
            currencyCol.addClass('d-none');

            if (countryCol.hasClass('d-none')) {
                currencyAndCountryRow.addClass('d-none');
            }
        }
    } else {
        regFormCurrencyId.removeAttr('disabled')
        if (isRegisterForm) {
            currencyCol.removeClass('d-none')
            currencyAndCountryRow.removeClass('d-none')
        }
    }

    regFormCurrencyId.val(selectedCurrencyId).trigger('change')
}
function trackOffersGA(action, method) {
    var registrationFormData = document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.state.application.registrationFormData
    var registrationPromotionOffers = registrationFormData ? registrationFormData.registrationOffers : {};
    var seeOffers = registrationPromotionOffers && Object.keys(registrationPromotionOffers).length ? 'see_offers_' : 'no_offers_'
    var interact = seeOffers === 'no_offers_' ? '' : sessionStorage.getItem('REGISTRATION_OFFERS_INTERACTION') === 'true' ? 'interact_' : 'no_interact_'
    var closeRegistration = action === 'close_registration' ? 'no_' : ''
    var interactionCounter = parseInt(sessionStorage.getItem('REGISTRATION_OFFERS_INTERACTION_COUNTER'))

    var eventParams = {}
    if (method) {
        eventParams.method = method
    }
    if (interactionCounter) {
        eventParams.interactionCounter = interactionCounter
    }
    window.UILogger.logEvent(window.UILogger.eventNames.OffersEvents[seeOffers + interact + closeRegistration + 'register'],
        eventParams
    )
}

function formatCanadianZipCode(element) {
    var zip = element.target
    if (zip.id === 'reg_form_zipcode' && Config.WHITE_LABEL_REGULATIONS.igo_logo_ontario) {
        zip.value = zip.value.toUpperCase().substring(0, 7)
        zip.value = zip.value.replace(/\s\s+/g, ' ')
        zip.value = zip.value.replace(/[^a-z0-9\s]/gi, '')
        var firstHalfLenght = zip.value.length <= 6 && zip.value.includes(' ') ? 2 : 3

        if (zip.value.length === 3) {
            if (element.originalEvent.key && element.originalEvent.key.length === 1) {
                zip.value = zip.value + ' ' + element.originalEvent.key
            } else {
                zip.value = zip.value + ' '
            }
            element.preventDefault()
        }

        if (zip.value.length > 3 && zip.value[3] !== ' ') {
            zip.value = zip.value.trim()
            zip.value = zip.value.substring(0, firstHalfLenght) + ' ' + zip.value.substring(3, 6)
        }
    }
}

function getCountriesThatRequireStates() {
    var countriesRequireStateIds = []
    var countriesRequireState = Config.WHITE_LABEL_REGULATIONS.countries_require_state || false

    if (countriesRequireState.length > 0) {
        countriesRequireState.forEach(function (country) {
            if (countriesRequireStateIds.indexOf(country.id) === -1) {
                countriesRequireStateIds.push(country.id)
            }
        })
    }

    return countriesRequireStateIds
}

function appendDropdownOptions(options, targetElement, optionValueKey, optionTextKey) {
    optionValueKey = optionValueKey || 'value'
    optionTextKey = optionTextKey || 'title'

    $.each(options, function (key, value) {
        $(targetElement).append(
            $('<option></option>', {
                value: value[optionValueKey],
                text: value[optionTextKey],
            })
        )
    })
}

function toggleStateDropdownMenu() {
    var $registerForm = $('#register-user-form')
    var selectedCountryId = $registerForm.find('#reg_form_country_id :selected').attr('value')
    var availableStates = Config.REG_FORM_DATA.availableStates
    var requiredCountryIsSelected = getCountriesThatRequireStates().indexOf(selectedCountryId) !== -1

    if (requiredCountryIsSelected || (availableStates.length > 0 && requiredCountryIsSelected)) {
        $registerForm.find('.state-menu-row').removeClass('d-none')
        if (availableStates.length > 1) {
            $registerForm.find('#reg_form_state_id').removeAttr('disabled')
        }
        return
    }

    $registerForm.find('.state-menu-row').addClass('d-none')
    $registerForm.find('#reg_form_state_id').attr('disabled', true)
}

function preselectStateField(el, preselectedCountryId) {
    var selectedCountryId = preselectedCountryId ? preselectedCountryId.toString() : el.find('#reg_form_country_id :selected').val()
    var stateDropdownMenu = el.find('#reg_form_state_id')
    var stateMenuRow = el.find('.state-menu-row')
    var availableStates = Config.REG_FORM_DATA.availableStates

    var availableStatesForCountry = availableStates.filter(function (state) {
        return state.country_id === selectedCountryId
    })

    // Hide menu if there are no available states
    if (!availableStatesForCountry.length) {
        stateMenuRow.addClass('d-none')
        stateDropdownMenu.attr('disabled', true)
        return
    }

    // Clear state menu dropdown
    stateMenuRow.removeClass('d-none')
    stateDropdownMenu.find('option + option').remove()
    stateDropdownMenu.removeAttr('disabled')

    // Preselect single available state
    if (availableStatesForCountry.length === 1) {
        appendDropdownOptions(availableStatesForCountry, stateDropdownMenu, 'country_subdivision_id', 'title')
        stateDropdownMenu.prop('selectedIndex', 1)
        stateDropdownMenu.prop('disabled', true)
        return
    }

    appendDropdownOptions(availableStatesForCountry, stateDropdownMenu, 'country_subdivision_id', 'title')
}

window.attachSpecialCharHandlers = function (formScope, form) {
    var fieldName = formScope === 'register' ? 'reg_form_' : 'account_form_',
        hintInputIds = _.map(['fname', 'lname', 'address'], function (id) {
            return fieldName + id
        }),
        hintInputSelectors = _.map(hintInputIds, function (id) {
            return '#' + id
        })

    _.each(hintInputSelectors, function (item, index) {
        $(item).on('focus input', function (event) {
            var id = $(this).attr('id'),
                isAddressField = id.endsWith('address'),
                $fieldFormHelp = $(this).closest('.form-group').find('.form-help'),
                validator = isAddressField ? Validator.validateRestrictedCharsAddress : Validator.validateRestrictedCharsName

            if (event.type === 'focus' && ($(this).val() === '' || !validator($(this).val()))) {
                $fieldFormHelp.fadeIn(50)
            }
            if (event.type === 'input' && validator($(this).val())) {
                $fieldFormHelp.fadeOut(50)
            }
            if (event.type === 'input' && !validator($(this).val())) {
                $fieldFormHelp.fadeIn(50)
            }
        })
    })
}

function updateLegacyUsernameFields() {
    var MAX_POLL_ATTEMPTS = 10;
    var POLL_INTERVAL_MS = 1000;
    var MODAL_UPDATE_DELAY_MS = 100;

    var attempts = 0;
    var labelText = translation('REGISTER.username_or_email');
    var placeholderText = translation('REGISTER.username_or_email_please');
    var requiredMessageText = translation('REGISTER.username_or_email_required');

    function updateFieldAndLabel(input, newName, oldIdPart, newIdPart) {
        var oldId = input.id;
        input.name = newName;
        input.id = input.id.replace(oldIdPart, newIdPart);
        input.setAttribute('placeholder', placeholderText);
        input.setAttribute('required-message', requiredMessageText);
        input.setAttribute('data-username-updated', 'true');

        var label = document.querySelector('label[for="' + oldId + '"]');
        if (label) {
            label.setAttribute('for', input.id);
            label.textContent = labelText;
        }

        var invalidFeedback = input.parentElement.querySelector('.invalid-feedback');
        if (invalidFeedback) {
            invalidFeedback.textContent = requiredMessageText;
        }
    }

    function updateUsernameFields() {
        // LOGIN MODAL: Only update placeholder, label, and validation message
        document.querySelectorAll('input[name="login_form[username]"]').forEach(function (input) {
            input.setAttribute('placeholder', placeholderText);
            input.setAttribute('required-message', requiredMessageText);

            var label = document.querySelector('label[for="' + input.id + '"]');
            if (label) label.textContent = labelText;

            var invalidFeedback = input.parentElement.querySelector('.invalid-feedback');
            if (invalidFeedback) invalidFeedback.textContent = requiredMessageText;
        });

        // FORGOT PASSWORD MODAL: Transform username or email field
        var forgottenPasswordModal = document.querySelector('#forgot-password-modal');
        if (!forgottenPasswordModal) return;

        var usernameInput = forgottenPasswordModal.querySelector('input[name="username"]:not([data-username-updated])');
        var emailInput = forgottenPasswordModal.querySelector('input[name="email"]:not([data-username-updated])');

        if (usernameInput) {
            updateFieldAndLabel(usernameInput, 'username_or_email', 'username', 'username_or_email');
            // Hide email field and remove from form submission
            if (emailInput) {
                emailInput.removeAttribute('name');
                emailInput.disabled = true;
                var emailGroup = emailInput.closest('.form-group');
                if (emailGroup) emailGroup.classList.add('d-none');
            }
        } else if (emailInput) {
            emailInput.type = 'text';
            updateFieldAndLabel(emailInput, 'username_or_email', 'email', 'username_or_email');
        }
    }

    var checkInterval = setInterval(function () {
        try {
            var appComponents = document.getElementById('appComponents');
            if (!appComponents || !appComponents.__vueParentComponent) return;

            var store = appComponents.__vueParentComponent.appContext.config.globalProperties.$store;
            var regConfig = store && store.state && store.state.application && store.state.application.registrationConfig;

            if (regConfig && regConfig.general_settings) {
                var useEmailAsUsername = regConfig.general_settings.use_email_as_username_for_login;

                if (useEmailAsUsername) {
                    updateUsernameFields();
                    $('#forgot-password-modal, #login-guest-modal').on('shown.bs.modal', function () {
                        setTimeout(updateUsernameFields, MODAL_UPDATE_DELAY_MS);
                    });
                }

                clearInterval(checkInterval);
            }
            // If regConfig not loaded yet, keep polling
        } catch (error) {
            // Store not ready
        }

        if (++attempts >= MAX_POLL_ATTEMPTS) {
            clearInterval(checkInterval);
        }
    }, POLL_INTERVAL_MS);
}
; /** ----------------- **/ 
 $(function () {

    if(Config.PLUGIN_MODE) {
        return
    }
    initializePhoneForm($('#register-user-modal'), $('#register-phone-number-user-form'), 'register');
    initializePhoneForm($('#login-guest-modal'), $('#login-modal-phone-number-form'), 'login');

    function initializePhoneForm($userModal, $phoneForm, type){
        var $userModalClose = $userModal.find('.close');
        var $socialLoginSection = $userModal.find('.social-login-wrapper');

        var $registerWithEmail = $userModal.find('#register-email-user-form');
        var $registerWithEmailBtn = $userModal.find('#register-email-user-form .modal-submit-button');

        var $navPhoneRegisterTab = $userModal.find('#nav-phone-register-tab');
        var $navEmailRegisterTab = $userModal.find('#nav-email-register-tab');
        var $navBackButton = $userModal.find('.modal-nav');
        var $navPhoneLoginTab = $userModal.find('#nav-phone-login-tab');
        var $navUsernameLoginTab = $userModal.find('#nav-username-login-tab');

        var $stepsContainer = $phoneForm.prev();
        var $stepOne = $phoneForm.find('.step-section-1');
        var $stepTwo = $phoneForm.find('.step-section-2');
        var $stepThree = $phoneForm.find('.step-section-3');
        var $enterCodeButton = $phoneForm.find('.enter-code-button');
        var $sendPhoneButton = $phoneForm.find('.send-phone-button');
        var $smsCodeInputs = $phoneForm.find('.sms-code-digit');
        var $sendNewCode = $phoneForm.find('.send-new-code-button');
        var $createNewAccountButton = $phoneForm.find('#create-new-account-button');
        var $validateCodeButton = $phoneForm.find('.validate-code-button');
        var $errorContainer = type === 'register' ? $phoneForm.find('.error-container') : $phoneForm.prev();
        var $usernameErrorContainer = $('#nav-username-login').find('.error-container');

        var $linkExistingAccountForm = $phoneForm.closest('.modal-body').find('.link-existing-account-to-phone');
        var $linkExistingAccountFormButton = $linkExistingAccountForm.find('.link-existing-account-to-phone-button');
        var $couponCode = $userModal.find('#reg_form_coupon_code');

        if (localStorage.getItem('phoneData')) {
            $enterCodeButton.removeClass('d-none');
        }

        var smsCodeSubmitCount = 0;

        var urlPath = window.location.pathname;
        if(/index\/register/.test(urlPath) && Config.PHONE_NUMBER_REGISTRATION && $userModal.attr('id') !== 'login-guest-modal') {
            $userModal.modal('show');
        }

        $stepOne.find('input[type=text], select').on('keypress', function (e) {
            onSendPhone(e);
        });

        $stepTwo.find('input[type=text]').on('keypress', function (e) {
            onCodeValidation(e);
        });

        $userModal.on('hide.bs.modal', function () {
            resetState();

            if(Config.USER_IDLE){
                window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                window.location.reload();
            }
        });

        $userModalClose.on('click', function () {
            $userModal.modal('hide');
        });

        Validator.initSelfValidation($phoneForm);

        function onSendPhone(e) {
            if (e.key === 'Enter'){
                e.preventDefault();

                if(Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.auth_by_phone){
                    grecaptcha.ready(function (){
                        grecaptcha.execute(Config.RECAPTCHA_KEY, {action: 'auth_by_phone'}).then(function (token){
                            sendPhoneNumber($phoneForm, {
                                recaptcha_token: token,
                                action: 'auth_by_phone'
                            });
                        });
                    });
                } else {
                    sendPhoneNumber($phoneForm);
                }
            }
        }

        function onCodeValidation(e) {
            if (e.key === 'Enter'){

                checkAndSubmitCode();
            }
        }

        $enterCodeButton.on('click', function () {
            goToStepTwo();
        });

        $sendPhoneButton.on('click', function () {
            if(Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.auth_by_phone){
                grecaptcha.ready(function (){
                    grecaptcha.execute(Config.RECAPTCHA_KEY, {action: 'auth_by_phone'}).then(function (token){
                        sendPhoneNumber($phoneForm, {
                            recaptcha_token: token,
                            action: 'auth_by_phone'
                        });
                    });
                });
            } else {
                sendPhoneNumber($phoneForm);
            }
        });

        $smsCodeInputs.on('keydown', function(e){
            smsKeyDownHandler(e, $phoneForm);
        });

        $smsCodeInputs.on('input', function(e){
            smsInputHandler(e, $phoneForm);
        });

        $smsCodeInputs.on('paste', function (e) {
            onPasteHandler(e);
        });

        $smsCodeInputs.on('focus', function(e){
            addFocusClass(e, $phoneForm);
        });

        $smsCodeInputs.on('blur', function(e){
            removeFocusClass(e, $phoneForm);
        });

        $sendNewCode.on('click', function () {
            goBackToStepOne();
        });

        $couponCode.on('input', function () {
            $(this).removeClass('is-invalid');
        });

        $createNewAccountButton.on('click', function () {
            var phoneData = getPhoneData();
            var smsCode = getSmsCode();
            var formattedPhone = getFormattedPhone(phoneData.cellPhone);
            var currencyId = getCurrencyId();

            submitPhoneRegister(phoneData.phonePrefix, formattedPhone, smsCode, currencyId);
        });

        $validateCodeButton.on('click', function () {
            checkAndSubmitCode();
        });

        $registerWithEmailBtn.on('click', function () {
            registerWithEmail();
        });

        $linkExistingAccountFormButton.on('click', function () {
            linkToExistingAccount();
        });

        $navPhoneRegisterTab.on('shown.bs.tab', function () {
            $navBackButton.addClass('d-none');
        });

        $navEmailRegisterTab.on('shown.bs.tab', function () {
            var isStepTwoActive = $('#nav-email-register').find('.registration-step-2').hasClass('active');
            if (isStepTwoActive){
                $navBackButton.removeClass('d-none');
            }
        });

        $navPhoneLoginTab.on('shown.bs.tab', function () {
            $errorContainer.empty();
        });

        $navUsernameLoginTab.on('shown.bs.tab', function () {
            $usernameErrorContainer.empty();
        });

        function getPhoneData() {
            var phonePrefix = $phoneForm.find('.phone-prefix-select').val();
            var cellPhone = $phoneForm.find('.reg-form-cell-phone').val();

            if (localStorage.getItem('phoneData')) {
                phonePrefix = JSON.parse(localStorage.getItem('phoneData')).phonePrefix;
                cellPhone = JSON.parse(localStorage.getItem('phoneData')).cellPhone;
            }

            return {
                phonePrefix: phonePrefix,
                cellPhone: cellPhone,
            }
        }

        function resetState() {
            $userModal.find('.reg-form-cell-phone').val('');
            $errorContainer.empty();
            $phoneForm.removeClass('d-none');
            $linkExistingAccountForm.addClass('d-none');
            goBackToStepOne();
        }

        function checkAndSubmitCode() {
            var phoneData = getPhoneData();

            var smsCode = getSmsCode();
            var couponCode = getCouponCode();

            if(phoneData.phonePrefix && phoneData.cellPhone && smsCode.length === 6) {
                var formattedPhone = getFormattedPhone(phoneData.cellPhone);
                smsCodeSubmitCount++;

                if(type == 'login') {
                    submitPhoneRegister(phoneData.phonePrefix, formattedPhone, smsCode, '');
                } else {
                    submitSmsCode(phoneData.phonePrefix, formattedPhone, smsCode, couponCode);
                }
            }
        }

        function onPasteHandler(e) {
            e.preventDefault();

            var pastedValue = e.originalEvent.clipboardData.getData('text');

            if(isNumber(pastedValue) && pastedValue.length === 6){
                for (var i = 0; i < 6; i++) {
                    var currentDigit = i + 1;
                    var currentDigitClass = '.digit-' + currentDigit;
                    $phoneForm.find(currentDigitClass).val(pastedValue[i]);
                }

                $phoneForm.find('.digit-6').focus();
                checkAndSubmitCode();
            }
        }

        function isNumber(val) {
            var numPattern = /^\d+$/;

            return numPattern.test(val);
        }

        function getSmsCode() {
            var smsCode = '';

            for(var i = 1; i < 7; i++){
                var currentDigitSelector = '.digit-' + i;
                var value = $phoneForm.find(currentDigitSelector).val();

                if(value.length > 0){
                    smsCode += $phoneForm.find(currentDigitSelector).val();
                }
            }

            return smsCode;
        }

        function getCouponCode() {
            return $couponCode.val();
        }

        function getCurrencyId() {
            return $phoneForm.find('#reg_form_currency_id').val();
        }

        function smsKeyDownHandler(event, $phoneForm) {
            var key = event.key;
            var digitNumberClassName = event.target.classList[1];
            var digitNumber = parseInt(digitNumberClassName.split('-')[1]);
            var currentDigitSelector = '.digit-' + digitNumber;
            var prevDigitNumber = digitNumber - 1;
            var prevDigitSelector = '.digit-' + prevDigitNumber;

            if(key === 'Backspace' || key === 'Delete'){
                event.preventDefault();

                if(event.target.value.length > 0) {
                    $phoneForm.find(currentDigitSelector).val('');
                } else {
                    $phoneForm.find(prevDigitSelector).focus();
                    $phoneForm.find(prevDigitSelector).val('');
                }
            }else if(isNumber(key) && event.target.value){
                event.preventDefault();
                $(event.currentTarget).val(key);
            } else if(!isNumber(key) && key.length === 1) {
                event.preventDefault();
            }
        }

        function smsInputHandler(event, $phoneForm) {
            var key = event.target.value;
            var digitNumberClassName = event.target.classList[1];
            var digitNumber = parseInt(digitNumberClassName.split('-')[1]);
            var nextDigitNumber = digitNumber + 1;
            var prevDigitNumber = digitNumber - 1;
            var nextDigitSelector = '.digit-' + nextDigitNumber;
            var prevDigitSelector = '.digit-' + prevDigitNumber;

            if(isNumber(key)){
                event.preventDefault();

                $(event.currentTarget).val(event.target.value);

                if(event.target.className.includes('digit-6') && smsCodeSubmitCount === 0){
                    checkAndSubmitCode();
                }

                $phoneForm.find(nextDigitSelector).focus();
            } else if(key === 'Backspace' || key === 'Delete'){
                event.preventDefault();

                if(digitNumberClassName === 'digit-6' && event.target.value.length > 0) {
                    event.target.value = '';
                } else {
                    event.target.value = '';
                    $phoneForm.find(prevDigitSelector).focus();
                    $phoneForm.find(prevDigitSelector).val('');
                }
            }
        }

        function addFocusClass(event, $phoneForm) {
            var currentDigit = '.' + event.target.classList[1];
            $phoneForm.find(currentDigit).addClass('focused');
        }

        function removeFocusClass(event, $phoneForm) {
            var currentDigit = '.' + event.target.classList[1];
            $phoneForm.find(currentDigit).removeClass('focused');
        }

        function sendPhoneNumber($phoneForm, recaptchaParams) {
            var phonePrefix = $phoneForm.find('input[name="reg_form[phone_prefix]"]').val();
            var cellPhone = $phoneForm.find('input[name="reg_form[cell_phone]"]').val();
            var formattedPhone = getFormattedPhone(cellPhone);
            var extraData = {
                'reg_form[phone_prefix]': phonePrefix,
                'reg_form[cell_phone]': formattedPhone
            };
            if(recaptchaParams){
                extraData.recaptcha_token = recaptchaParams.recaptcha_token;
                extraData.action = recaptchaParams.action;
            }

            ajaxRequest('sendPhoneNumber', {
                extraData: extraData,
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/authphone/operation/send"
                },
                loadAction: $phoneForm,
                toastr: false,
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                validate: function () {
                    return Validator.validateElements($stepOne);
                },
                onError: function (response) {
                    if (response.error) {
                        console.log(response.error);
                    } else {
                        console.log('Error!');
                    }
                },
                onSuccess: function (response) {
                    if(response.action === 'nextStep') {
                        var phoneData = {
                            phonePrefix: phonePrefix,
                            cellPhone: cellPhone
                        };

                        localStorage.setItem('phoneData', JSON.stringify(phoneData));
                        goToStepTwo();
                        $phoneForm.attr('data-step', 2);
                    }
                }
            });
        }

        function submitSmsCode(phonePrefix, cellPhone, smsCode, couponCode) {
            $phoneForm.find('.sms-code-digit').removeClass('focused');
            $phoneForm.find('.sms-full-code').val(smsCode);

            ajaxRequest('validateSmsCode', {
                extraData: {
                    'reg_form[phone_prefix]': phonePrefix,
                    'reg_form[cell_phone]': cellPhone,
                    'reg_form[sms_code]' : smsCode,
                    'reg_form[coupon_code]' : couponCode
                },
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/authphone/operation/verify"
                },
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                loadAction: $phoneForm,
                toastr: false,
                onError: function (response) {
                    if (response.error) {
                        console.log(response.error);
                    } else {
                        console.log('Error!');
                    }
                },
                onSuccess: function (response) {
                    if(type === 'login' || response.action === 'login') {
                        $phoneForm.closest('.modal').modal('hide');
                        window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                        window.location.reload();
                    } else if(response.action === 'nextStep') {
                        goToStepThree();
                        $phoneForm.attr('data-step', 3);
                        preselectCurrency($phoneForm);
                    }
                }
            });
        }

        function submitPhoneRegister(phonePrefix, cellPhone, smsCode, currencyId) {
            var submitData = {
                'reg_form[phone_prefix]': phonePrefix,
                'reg_form[cell_phone]': cellPhone,
                'reg_form[sms_code]': smsCode,
                'reg_form[country_id]': 35,
                system_data: {
                    product_type: localStorage.getItem('productType')
                }
            }
            if(window.ReactNativeWebView && window.ReactNativeWebViewOS){
                submitData['registration_platform'] = 'native_application';
                submitData['registration_os'] = window.ReactNativeWebViewOS;
            }
            if(type === 'register'){
                submitData['reg_form[currency_id]'] = currencyId;
            }
            ajaxRequest('createNewAccount', {
                extraData: submitData,
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/authphone/operation/registration"
                },
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                loadAction: $phoneForm,
                toastr: false,
                validate: function () {
                    return Validator.validateElements($stepThree);
                },
                onError: function (response) {
                    if (response.error) {
                        console.log(response.error);
                        if (response.error === 'coupon_code') {
                            $couponCode.focus();
                        }
                    } else {
                        console.log('Error!');
                    }
                },
                onSuccess: function (data) {
                    trackOffersGA('success_register', 'Phone')
                    if(data.action && data.action === 'linkAccount'){
                        $phoneForm.addClass('d-none');
                        $linkExistingAccountForm.removeClass('d-none');
                        return;
                    }
                    handleRegisterRedirect(data);
                }
            });
        }

        function registerWithEmail() {
            var email = $userModal.find('#register-email-user-form #reg_form_email').val();
            var password = $userModal.find('#register-email-user-form #reg_form_password').val();

            ajaxRequest('registerWithEmail', {
                extraData: {
                    'reg_form[email]' : email,
                    'reg_form[password]': password,
                    system_data: {
                        product_type: localStorage.getItem('productType')
                    },
                },
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/authphone/operation/registration"
                },
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                toastr: false,
                validate: function () {
                    return Validator.validateElements($registerWithEmail);
                },
                onError: function (response) {
                    if (response.error) {
                        console.log(response.error);
                    } else {
                        console.log('Error!');
                    }
                },
                onSuccess: function () {
                    $phoneForm.closest('.modal').modal('hide');
                    window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                    window.location.reload();
                }
            });
        }

        function linkToExistingAccount(){
            getElement($linkExistingAccountForm).ajaxRequest('linkAccount', {
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/authphone/operation/linkAccount"
                },
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                loadAction: $userModal.find('.modal-body'),
                toastr: false,
                validate: function () {
                    return Validator.validateElements($linkExistingAccountForm);
                },
                onSuccess: function (response) {
                    if(response.action === 'login'){
                        $phoneForm.closest('.modal').modal('hide');
                        window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                        window.location.reload();
                    }
                },
                onError: function (errData) {
                    console.log(errData)
                }
            });
        }

        function getFormattedPhone(phone) {
            var index = 0;
            while(phone[index] === '0'){
                phone = phone.substr(1, phone.length);
            }
            var phoneNoSpaces = phone.replace(/ /g, '');

            return phoneNoSpaces;
        }

        function goBackToStepOne() {
            $phoneForm.find('.code-instructions').children().remove('span');
            $stepTwo.addClass('d-none');
            $errorContainer.empty();
            $stepOne.removeClass('d-none');
            $stepsContainer.find('.registration-step-2').removeClass('active');
            $stepsContainer.find('.registration-step-1').removeClass('filled-in').addClass('active');
            $socialLoginSection.removeClass('d-none');
            $phoneForm.find('.reg-form-cell-phone').select();
            smsCodeSubmitCount = 0;
        }

        function goToStepTwo() {
            $stepOne.addClass('d-none');
            $phoneForm.find('.sms-code-digit').val('');
            $stepTwo.removeClass('d-none');
            $stepsContainer.find('.registration-step-1').removeClass('active').addClass('filled-in');
            $stepsContainer.find('.registration-step-2').addClass('active');
            $phoneForm.find('.digit-1').focus();
            $socialLoginSection.addClass('d-none');
            var phoneData = getPhoneData();

            var formattedPhone = getFormattedPhone(phoneData.cellPhone);
            $phoneForm.find('.code-instructions').append('<span> +' + phoneData.phonePrefix + ' ' + formattedPhone + '.</span>');
        }


        function goToStepThree() {
            $stepTwo.addClass('d-none');
            $stepThree.removeClass('d-none');
            $stepsContainer.find('.registration-step-2').removeClass('active').addClass('filled-in');
            $stepsContainer.find('.registration-step-3').addClass('active');
            $('.register-coupon-code-container').collapse('hide');
            // $userModalClose.addClass('d-none');
        }
    }
});
; /** ----------------- **/ 
 $(function () {

    var formSubmitAllowed = true;
    var enterFormSubmitAllowed = true;
    var loginAfterReactivation = false;
    var $loginModal = $('#login-guest-modal'),
        $loginModalBody = $loginModal.find('.modal-body'),
        $loginFormModal = $loginModal.find('#login-modal-form'),
        $errorContainer = $loginModal.find('.error-container'),
        $closeButton = $loginModal.find('.modal-header button.close'),
        $accountReactivationBackButton = $loginModal.find('.account-reactivation-back'),
        $loginModalTitle = $('#login-guest-modal .modal-title'),
        $loginWithDiffAccount = $loginFormModal.find('#login-with-different-account');

    if ($loginModal.hasClass('auto-show')) {
        $loginModal.modal('show');

        $('#register-user-modal, #forgot-password-modal').on('hidden.bs.modal', function (e) {
            $('#login-guest-modal').modal('show');
        })
    }

    if (window.BaseConfig.get('IS_NEW_LAYOUT')) {
        $loginModalBody.addClass('with-banner');
    }

    $loginFormModal.find('input[type=text], input[type=email], input[type=password]').on('keypress', function (e) {
        if (e.key === 'Enter' || e.key == 13) {
            e.preventDefault();
            if (enterFormSubmitAllowed) {
                enterFormSubmitAllowed = false;
                onLoginSubmitHandler(e);
            }
        }
    });

    $loginFormModal.find('input[type=text], input[type=email], input[type=password]').on('keyup', function (e) {
        if (e.key === 'Enter' || e.key == 13) {
            enterFormSubmitAllowed = true;
        }
    });


    if (window.localStorage.getItem('user-username') && window.BaseConfig.get('SHOW_WELCOME_MESSAGE') && !window.Config.PLUGIN_MODE) {
        $loginFormModal.find('label[for="login_form\\[username\\]"]').addClass('d-none');
        $loginFormModal.find('#login_form\\[username\\]').addClass('d-none');
        $loginFormModal.find('#login-existing-user').html(localStorage.getItem('user-username'));
        $loginFormModal.find('#welcome-back-container').addClass('d-flex flex-column');
        $loginWithDiffAccount.addClass('d-block');
    }

    if ($loginWithDiffAccount && window.BaseConfig.get('SHOW_WELCOME_MESSAGE') && !window.Config.PLUGIN_MODE) {
        $loginWithDiffAccount.on('click', function (e) {
            e.preventDefault();
            window.localStorage.removeItem('user-username');
            $loginFormModal.find('#welcome-back-container').removeClass('d-flex flex-column');
            $loginFormModal.find('label[for="login_form\\[username\\]"]').removeClass('d-none');
            $loginFormModal.find('#login_form\\[username\\]').removeClass('d-none');
            $loginWithDiffAccount.removeClass('d-block');
        });
    }

    // Auto Focus Username
    $loginModal.on('shown.bs.modal', function () {
        $(this).find('#login_form\\[username\\]').focus();
        $(this).find('.error-container').empty();
    });
    $loginModal.on('hidden.bs.modal', function () {
        // clear store data for active game if user clicks close on a login prompted for a non-demo game
        document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit('casino/SET_ACTIVE_CASINO_GAME_DATA', null);
        if (window.BaseConfig.get('BIOMETRIC_CONFIG') && window.BaseConfig.get('BIOMETRIC_CONFIG').biometrics_authentication === '1') {
            window.clearFacialCheckCall()
        }
        $loginModalBody.removeClass('view-loader loader-center');
        if (!window.Config.PLUGIN_MODE) resetReactivation()
    })

    function resetReactivation() {
        loginAfterReactivation = false;
        document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_REACTIVATION_ACCOUNT_POSSIBILITY', false)
        document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_SELF_EXCLUDED_ACCOUNT_REACTIVATION_POSSIBILITY', false)
        document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_SUCCESSFUL_ACCOUNT_REACTIVATION', false)
        $loginModal.removeClass('account-reactivation')
        $errorContainer.removeClass('d-none');
        $accountReactivationBackButton.removeClass('d-none');
        $closeButton.removeClass('d-none');
    }

    if (!window.Config.PLUGIN_MODE) {
        $accountReactivationBackButton.on('click', resetReactivation)
    }

    // Login Validation
    $loginFormModal.on('submit', function (e) {
        onLoginSubmitHandler(e);
    });
    function onLoginSubmitHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        if (window.localStorage.getItem('user-username') && window.BaseConfig.get('SHOW_WELCOME_MESSAGE') && !window.Config.PLUGIN_MODE) {
            $loginFormModal.find('#login_form\\[username\\]').val(window.localStorage.getItem('user-username'));
        }
        $loginFormModal.find('#login-modal-password-input').trigger('keyup');
        if (!formSubmitAllowed) {
            return;
        }

        if (window.Config.RECAPTCHA_CONFIG && window.Config.RECAPTCHA_CONFIG.login) {
            grecaptcha.ready(function () {
                grecaptcha.execute(window.Config.RECAPTCHA_KEY, { action: 'login' }).then(function (token) {
                    loginHandler({
                        recaptcha_token: token,
                        action: 'login'
                    });
                });
            });
        } else {
            loginHandler();
        }

        $loginFormModal.addClass('was-validated');
    }
    function onLoginSuccessCallback(response) {
        if (response.data && response.data.biometric_needed) {
            var additionalData = response.data.biometric_additional ? response.data.biometric_additional : {}
            if (response.data.provider && response.data.provider === 'okto') {
                if (response.data.biometric_id) {
                    Object.assign(additionalData, { provider: 'okto', biometric_id: response.data.biometric_id });
                } else {
                    if (window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
                        window.ErrorTracker.trackError('Okto verification. Error message: biometric_id is not provided');
                    }
                    return;
                }
            }
            window.getBiometricVerificationServiceFlow('login', loginHandlerCallback, additionalData)
        } else {
            if (response.message === 'recovery_password_sent') {
                $loginModalBody.removeClass("view-loader loader-center");
                $('#login-guest-modal').modal('hide');
                Mediator.getMediator().trigger("UserLogin_ForcePasswordReset");
                return;
            }
            if (response.two_factor_auth) {
                $loginModalBody.removeClass("view-loader loader-center");
                toggleLoginAuthForm('two_factor_code');
                $("#login-form-auth-code").attr({
                    'data-identifier': response.identifier,
                    'data-member_id': response.member_id,
                });
                var twoFactorForm = document.getElementById('twoFactorAuthenticationCode');
                if (twoFactorForm) {
                    twoFactorForm.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_TWO_FACTOR_RESPONSE', response);
                }

                return null;
            }

            if (window.BaseConfig.get('SHOW_WELCOME_MESSAGE') && !window.Config.PLUGIN_MODE) {
                const usernameValue = document.querySelector('#login_form\\[username\\]').value;
                window.localStorage.setItem("user-username", usernameValue);
            }

            window.sessionStorage.setItem('LOGIN_SUCCESS', true)
            window.localStorage.setItem("kycModalAlreadyDisplayedAfterLogin", "false");
            window.localStorage.setItem("sowSofModalAlreadyDisplayedAfterLogin", "false");
            window.localStorage.removeItem('last_login_modal_dismissed');
            if (window.Config.WHITE_LABEL_REGULATIONS.last_login_datetime || window.Config.WHITE_LABEL_REGULATIONS.last_login_datetime_and_responsible_gaming_link) {
                window.localStorage.setItem('last_login_modal_dismissed', false);
            }
            var dataLoginReferer = $loginFormModal.attr("data-login-referer");
            if (dataLoginReferer !== undefined && dataLoginReferer == "gamePlay" && window.Config.CURRENT_ACTION != "play") {
                var activeCasinoGameData = document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.state.casino.activeCasinoGameData;
                window.localStorage.setItem('activeGameData', JSON.stringify(activeCasinoGameData));
                window.localStorage.setItem("loginReferer", "gamePlay");

                if ($loginFormModal.attr("game-lobby-url") !== undefined) {
                    var gameLobbyUrl = $loginFormModal.attr("game-lobby-url");
                    window.localStorage.setItem('gameLobbyUrl', gameLobbyUrl);
                    $("#gameLobbyUrl").attr("href", gameLobbyUrl);
                }
            }
            window.localStorage.removeItem("forceUploadDocumentModalDismissed");

            if (!response.referrer) {
                response.referrer = "/";
            }
            try {
                if (typeof $solitics !== "undefined") {
                    var loginDetails = {
                        memberId: response.userid,
                        email: response.email,
                        brand: window.BaseConfig.get('SOLITICS').brand,
                        popupToken: window.BaseConfig.get('SOLITICS').popup_token,
                    }
                    $solitics.loginSuccess(loginDetails);
                }
                if (typeof _smartico !== "undefined" && response.userid && response.retentionAllowed) {
                    _smartico.identify(response.userid.slice(2));
                    _smartico.login(window.Config.LOCALE_SHORT);
                    _smartico.changeLanguage(window.Config.LOCALE_SHORT_ALIAS ? window.Config.LOCALE_SHORT_ALIAS : window.Config.LOCALE_SHORT);
                }
            } catch (e) {
                console.log(e);
            }

            if (window.Config.WHITE_LABEL_REGULATIONS.show_responsible_gaming_links) {
                response.referrer = '/my/responsible-gaming';
            }

            // Check if login were performed during event creation
            if (sessionStorage.getItem('myEvents')) {
                var event = JSON.parse(sessionStorage.getItem('myEvents'));
                var eventSportKey = event.selectedEventA ? event.selectedEventA.sport_key : null;

                // If login were performed during event creation we should appear on the same place
                // Otherwise we should discard the creation
                if (!eventSportKey || response.referrer.indexOf(eventSportKey) === -1) {
                    sessionStorage.removeItem('myEvents');
                }
            }

            if (response.userid) {
                var match = response.userid.match(/\d+/);
                var memberId = match ? match[0] : response.userid;

                setGtmDataLayer({
                    "member_id": memberId,
                }, "loggedin");

                window.UILogger.logEvent(window.UILogger.eventNames.Auth.login, {
                    method: 'Email',
                    user_id: memberId,
                })
            }

            var redirect_url = sessionStorage.getItem('LOGIN_REDIRECT_URL') || response.referrer
            sessionStorage.removeItem('LOGIN_REDIRECT_URL')
            if (typeof chrome === "undefined") {
                setTimeout(function () {
                    changePage();
                }, 1000);
            } else {
                changePage();
            }

            function changePage() {
                window.location.href === redirect_url
                    ? window.location.reload()
                    : window.location = redirect_url
            }
        }
    }
    function onLoginErrorCallback(response) {
        // Reset form validation on unsuccessful login
        $loginFormModal.removeClass('was-validated');
        // Check response.data.info.length to ensure it's panic self exclude (1 day)
        if (response.data.type === "account_excluded" && response.data.info.length) {
            if ($('#selfExcludeTimer')[0]) {
                var timestamp = response.data.info;
                $('#login-guest-modal').modal('hide');
                $('#selfExcludeTimer')[0].__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_SELF_EXCLUDE_TIME_END', timestamp);
            }
        }

        if (!window.Config.PLUGIN_MODE && (response.data.type === "account_closed" || response.data.type === "account_deactivated" || response.data.type === "self_excluded_account")) {
            var form = getElement($loginFormModal);

            if (!loginAfterReactivation && form && form.requestData && form.requestData.login_form) {
                if (form.requestData.login_form.username && form.requestData.login_form.password) {
                    document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/CHECK_SELF_REACTIVATION', {
                        formData: {
                            username: form.requestData.login_form.username,
                            password: form.requestData.login_form.password,
                        }
                    });
                }
            }
        }
        if (typeof response.data.reload != "undefined" && response.data.reload == true) {
            window.location.reload();
        }
    }
    function loginHandlerCallback() {
        $loginFormModal.removeClass('was-validated');
        $loginModalBody.removeClass('view-loader loader-center');
        loginHandler();
    }
    window.loginModalHandlerCallback = function (response, success) {
        $loginModal.modal('show');
        success ? onLoginSuccessCallback(response) : onLoginErrorCallback(response);
    }
    var seonSessionPending = false;
    function loginHandler(recaptchaParams) {
        var form = getElement($loginFormModal);
        if (recaptchaParams) {
            form.requestData['recaptcha_token'] = recaptchaParams.recaptcha_token;
            form.requestData['action'] = recaptchaParams.action;
        }
        if (window.Config.IS_SEON_ENABLED) {
            if (!seonSessionPending) {
                $loginModalBody.addClass('view-loader loader-center');

                formSubmitAllowed = false;
                enterFormSubmitAllowed = false;
                seonSessionPending = true;
                window.getSeonSessionId().then(function (sessionId) {
                    form.requestData['seon_session_id'] = sessionId;
                    seonSessionPending = false;
                    $loginModalBody.removeClass('view-loader loader-center');
                    formSubmitAllowed = true;
                    enterFormSubmitAllowed = true;
                    proceedWithLogin();
                }).catch(function (error) {
                    $loginModalBody.removeClass('view-loader loader-center');
                    console.warn('Seon session ID retrieval failed:', error);
                    seonSessionPending = false;
                    formSubmitAllowed = true;
                    enterFormSubmitAllowed = true;
                    proceedWithLogin();
                });
                return;
            } else {
                setTimeout(function () {
                    loginHandler(recaptchaParams);
                }, 1000)
                return
            }
        } else {
            proceedWithLogin();
        }

        function proceedWithLogin() {
            form.ajaxRequest("login", {
                toastr: false,
                loadAction: $loginModalBody,
                keepLoader: true,
                alert: {
                    $el: $errorContainer,
                    dismissible: false,
                    className: 'alert-sm text-center'
                },
                validate: function () {
                    return $loginFormModal[0].checkValidity();
                },
                onBeforeSend: function () {
                    formSubmitAllowed = false;
                },

                onError: function (response) {
                    onLoginErrorCallback(response);
                },
                onSuccess: function (response) {
                    onLoginSuccessCallback(response)
                },
                onFinish: function () {
                    formSubmitAllowed = true;
                    if (!window.Config.PLUGIN_MODE && loginAfterReactivation) {
                        resetReactivation()
                    }
                },
            });
        }
    }
    window.toggleLoginAuthForm = function (section) {
        var $formsContainer = $('.forms-overflow-container');

        if (section === 'login') {
            $formsContainer.removeClass('two-factor-code-section');
            $formsContainer.removeClass('two-factor-recover-section');
            $loginModalTitle.find('.login-title').show();
            $loginModalTitle.find('.auth-title').hide();
            $('.social-login-wrapper').show();
        } else if (section === 'two_factor_code') {
            $formsContainer.addClass('two-factor-code-section');
            $formsContainer.removeClass('two-factor-recover-section');
            $loginModalTitle.find('.login-title').hide();
            $loginModalTitle.find('.auth-title').text(translation("LOGIN.auth_title"));
            $loginModalTitle.find('.auth-title').show();
            $('.social-login-wrapper').hide();
        } else if (section === 'two_factor_restore') {
            $formsContainer.removeClass('two-factor-code-section');
            $formsContainer.addClass('two-factor-recover-section');
            $loginModalTitle.find('.auth-title').text(translation("LOGIN.auth_recover_title"));
        }
    }
    if (window.VueEventBus && !window.Config.PLUGIN_MODE) {
        window.VueEventBus.$on('trigger-reactivation-login-account', function () {
            $loginModal.addClass('account-reactivation');
        })
        window.VueEventBus.$on('account-reactivation-dispatched', function () {
            $loginModalBody.addClass("view-loader loader-center");
        })
        window.VueEventBus.$on('trigger-reactivation-account-success', function () {
            $errorContainer.addClass('d-none');
            $accountReactivationBackButton.addClass('d-none');
            $closeButton.addClass('d-none');
            $loginModalBody.removeClass("view-loader loader-center");
        })
        window.VueEventBus.$on('trigger-reactivation-account-error', function () {
            $errorContainer.empty();
            $loginModalBody.removeClass("view-loader loader-center");
            resetReactivation();
        })
        window.VueEventBus.$on('trigger-login-after-reactivation', function (e) {
            loginAfterReactivation = true
            loginHandler();
        })

        window.VueEventBus.$on('trigger-self-excluded-reactivation', function () {
            var form = getElement($loginFormModal);

            document.getElementById("appComponents").__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/REACTIVATE_SELF_EXCLUDED_ACCOUNT', {
                formData: {
                    username: form.requestData.login_form.username,
                    password: form.requestData.login_form.password,
                },
            });
        })
    }
})
; /** ----------------- **/ 
 $(function() {

    var $changePasswordForm = $('#changePasswordForm'),
        $changePasswordFormHolder = $changePasswordForm.parent('.personal-details'),
        $alertTarget = $('.alert-wrapper'),
        passwordAtLeastTranslation = translation('REGISTER.password_at_least'),
        passwordCharactersTranslation = translation('REGISTER.password_characters');

    Validator.initSelfValidation($changePasswordForm);

    $changePasswordForm.on('submit', function (e) {

        e.preventDefault();
        e.stopPropagation();

        getElement($changePasswordForm).ajaxRequest('updateSettings', {
            extraData: {
                type: 'change_password'
            },
            loadAction: $changePasswordFormHolder,
            onError: function (errData) {
                var errors = errData.error;
                $changePasswordForm.find('.is-invalid').removeClass('is-invalid');
                for (var error in errors) {
                    $changePasswordForm.find('#account_form_' + error).addClass('is-invalid').next().text(errors[error]);
                }
            },
            onSuccess: function () {
                $changePasswordForm.find('.form-control').val('');
            },
            validate: function () {
                return Validator.validateElements($changePasswordForm);
            },
            alert: {
                $el: $alertTarget,
                successMessage: translation('FORMS.password_successfully_changed'),
            },
            toastr: false
        });
    });

    $changePasswordForm.find('#account_form_password').on('change', function () {

        var $passwordInput = $(this),
            value = $passwordInput.val(),
            minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3':'8'),
            errorSymbols = translation('REGISTER.password_complex_requirements'),
            errorMessage = $passwordInput.attr('required-message'),
            re = new RegExp("^(?!(.)+\\1\\1)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W])(?!.*[\\s])[\\w\\W]{8,}$"),
            $confirmPasswordInput = $changePasswordForm.find('#account_form_password_confirm'),
            isSimplePassword = BaseConfig.get('IS_SIMPLE_PASSWORD');

        if (value.length < minLength) {
            errorMessage = passwordAtLeastTranslation + ' ' + minLength + ' ' + passwordCharactersTranslation;
            $passwordInput[0].setCustomValidity(errorMessage);
            $passwordInput.next().text(errorMessage);
            $passwordInput.addClass('is-invalid');
        } else {
            if (!re.test(value) && !isSimplePassword) {
                $passwordInput[0].setCustomValidity(errorSymbols);
                $passwordInput.next().text(errorSymbols);
                $passwordInput.addClass('is-invalid');
            } else {
                $passwordInput[0].setCustomValidity('');
                $passwordInput.removeClass('is-invalid');
            }
        }

        if($confirmPasswordInput.val().length){
            $changePasswordForm.find('#account_form_password_confirm').trigger('change');
        }
    });

    // Seems repeating logic can
    $changePasswordForm.find('#account_form_password_confirm').on('change', function(){
        var $confirmPasswordInput = $(this),
            value = $confirmPasswordInput.val(),
            minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3':'8'),
            errorMessage = $confirmPasswordInput.attr('required-message'),
            errorMatching = translation('REGISTER.confirm_password_not_match');

        if(value.length < minLength){
            errorMessage = passwordAtLeastTranslation + minLength + passwordCharactersTranslation;
            $confirmPasswordInput[0].setCustomValidity(errorMessage);
            $confirmPasswordInput.next().text(errorMessage);
            $confirmPasswordInput.addClass('is-invalid');
        } else {
            if($changePasswordForm.find('#account_form_password').val() !== value) {
                $confirmPasswordInput[0].setCustomValidity(errorMatching);
                $confirmPasswordInput.next().text(errorMatching);
                $confirmPasswordInput.addClass('is-invalid');
            }else{
                $confirmPasswordInput[0].setCustomValidity('');
                $confirmPasswordInput.removeClass('is-invalid');
            }
        }
    });

});; /** ----------------- **/ 
 $(function () {
    var $forgotPasswordModal = $('#forgot-password-modal'),
        $forgotPasswordForm = $forgotPasswordModal.find('#forgot-password-form'),
        $forgotPasswordDetails = $forgotPasswordModal.find('.forgot-password-details'),
        $errorContainer = $forgotPasswordForm.find('.error-container'),
        $successContainer = $forgotPasswordModal.find('.success-submit-form'),
        $recoveryBanContainer = $forgotPasswordModal.find('.recovery-banned-form'),
        $alreadyCustomerContainer = $forgotPasswordModal.find('.auth-action-modal-toggle'),
        formSubmitted = false

    var urlPath = window.location.pathname

    if (/recovery\/forgotten-password/.test(urlPath) && !BaseConfig.get('VUE_LOGIN_ENABLED')) {
        $forgotPasswordModal.modal('show')
    }

    Validator.initSelfValidation($forgotPasswordForm)

    $forgotPasswordModal.on('shown.bs.modal', function () {
        resetForm()
        // Hide close button and show "already a customer" if on /index/register route
        var currentPath = window.location.pathname
        var isIndexRegisterRoute = /\/index\/register/.test(currentPath)

        if (isIndexRegisterRoute) {
            $forgotPasswordModal.find('.close').addClass('d-none')
            $alreadyCustomerContainer.removeClass('d-none').addClass('d-flex')
        } else {
            $forgotPasswordModal.find('.close').removeClass('d-none')
            $alreadyCustomerContainer.addClass('d-none').removeClass('d-flex')
        }
    })

    $forgotPasswordModal.on('hide.bs.modal', function () {
        if (BaseConfig.get('BIOMETRIC_CONFIG') && BaseConfig.get('BIOMETRIC_CONFIG').upon_forgotten_password === '1'){
            window.clearFacialCheckCall()
        }
    })

    $forgotPasswordForm.on('submit', function (e) {
        formSubmitted = false
        e.preventDefault()
        e.stopPropagation()
        if (Config.RECAPTCHA_CONFIG && Config.RECAPTCHA_CONFIG.forgotten_password){
            grecaptcha.ready(function (){
                grecaptcha.execute(Config.RECAPTCHA_KEY, { action: 'forgotten_password' }).then(function (token){
                    forgotPasswordHandler({
                        recaptcha_token: token,
                        action: 'forgotten_password',
                    })
                })
            })
        } else {
            forgotPasswordHandler()
        }
    })

    function createNewPasswordCallback() {
        $forgotPasswordForm.trigger('submit')
    }

    function forgotPasswordHandler(recaptchaParams) {
        var form = getElement($forgotPasswordForm)
        if (recaptchaParams){
            form.requestData['recaptcha_token'] = recaptchaParams.recaptcha_token
            form.requestData['action'] = recaptchaParams.action
        }
        form.ajaxRequest('forgottenPassword', {
            request: {
                url: '/' + Config.LOCALE_SHORT + '/recovery/operation/forgottenPassword',
            },
            loadAction: $forgotPasswordForm,
            alert: {
                $el: $errorContainer,
                dismissible: false,
                className: 'alert-md',
            },
            toastr: false,
            validate: function () {
                return Validator.validateElements($forgotPasswordForm)
            },
            onSuccess: function (response) {
                if (response.data && response.data.biometric_needed){
                    if (response.data.provider && response.data.provider === 'okto') {
                        if (response.data.biometric_id) {
                            window.getBiometricVerificationServiceFlow('forgotten-password', () => {}, { provider: 'okto', biometric_id: response.data.biometric_id })
                        } else {
                            if (window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
                                window.ErrorTracker.trackError('Okto verification. Error message: biometric_id is not provided')
                            }
                            return
                        }
                    }
                    window.getBiometricVerificationServiceFlow('forgotten-password', createNewPasswordCallback)
                } else {
                    showSuccess(response)
                    window.UILogger.logEvent('select_recover_button', {
                        value: 'Successful submitted',
                    })
                }
            },
        })
    }

    function showSuccess(data) {
        if (typeof data !== 'undefined') {
            if (typeof data.recovery_allowed !== 'undefined' && data.recovery_allowed === false) {
                formSubmitted = true
                $forgotPasswordForm.addClass('d-none')
                $forgotPasswordDetails.addClass('d-none')
                $recoveryBanContainer.removeClass('d-none')
            } else {
                formSubmitted = true
                $forgotPasswordForm.addClass('d-none')
                $forgotPasswordDetails.addClass('d-none')
                $successContainer.removeClass('d-none')
            }
        }
    }
    window.forgottenPasswordModalHandlerCallback = function(response) {
        $forgotPasswordModal.modal('show')
        showSuccess(response)
    }

    function resetForm() {
        if (formSubmitted){
            $forgotPasswordForm.removeClass('d-none')
            $forgotPasswordDetails.removeClass('d-none')
            $successContainer.addClass('d-none')
            $recoveryBanContainer.addClass('d-none')
            $forgotPasswordForm.find('input, select').each(function(index, element) {
                $(element).val('')
            })
        }
    }
})
; /** ----------------- **/ 
 $(function () {
    if(Config.PLUGIN_MODE) {
        return
    }
    var $completeRegisterModal = $('#completeRegisterModal'),
        $completeRegisterForm = $('#complete-register-form'),
        $cashierModal = Config.CASHIER === 'default' ? $('#depositModal') : $('#cashierModal'),
        userId = BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '';

    if(userId !== '' && $completeRegisterModal.length){
        checkAgeVerification();
        if (BaseConfig.get('INDIA_REGISTRATION')) {
            checkMissingDetailsCookie('india_reg');
        }
    }

    if($completeRegisterForm.data('form-type')=== 'regulations_form'){
        var hasBsn = Config.WHITE_LABEL_REGULATIONS.reg_bsn && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasBsn){
            Validator.initBsnValidations();
        }
        var hasCnp = Config.WHITE_LABEL_REGULATIONS.reg_cnp && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasCnp) {
            Validator.initCnpValidations();
        }
        var hasCpr = Config.WHITE_LABEL_REGULATIONS.reg_cpr && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasCpr){
            Validator.initCprValidations();
        }
        var hasSpn = Config.WHITE_LABEL_REGULATIONS.reg_spn && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(hasSpn){
            Validator.initSpnValidations();
        }
        if(Config.WHITE_LABEL_REGULATIONS.reg_document_types && Config.WHITE_LABEL_REGULATIONS.reg_document_types.length){
            Validator.initDocumentIdValidations();
        }
    }

    if (Config.WHITE_LABEL_REGULATIONS.reg_state) {
        getStateOptions()
    }

    $completeRegisterModal.find('button[data-dismiss="modal"]').click(function () {
        if (BaseConfig.get('INDIA_REGISTRATION') && !Cookies.get('india_reg_missing_details')) {
            setMissingDetailsCookie('india_reg', 2)
        }
    });

    $completeRegisterForm.on('submit', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var formType = $(this).data('form-type');
        var extraData = false;
        var hasCpr = Config.WHITE_LABEL_REGULATIONS.reg_cpr && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        var hasSpn = Config.WHITE_LABEL_REGULATIONS.reg_spn && !BaseConfig.get('IS_SIMPLE_REGISTRATION');
        if(formType === 'regulations_form'){
            extraData = {
                type: 'regulations_form'
            };

            if(hasCpr) {
                var cprInput = $("input[name=\"reg_form[cpr]\"]");
                cprInput.val($("#reg_form_cpr_bd").val() + $("input[name=\"reg_form[cpr_hash]\"]").val());
            }
            if(hasSpn) {
                var spnInput = $("input[name=\"reg_form[spn]\"]");
                spnInput.val($("#reg_form_spn_bd").val() + $("input[name=\"reg_form[spn_hash]\"]").val());
            }
        }
        getElement($completeRegisterForm).ajaxRequest('completeRegistration', {
            request: {
                url: "/" + Config.LOCALE_SHORT + "/my/operation/completeRegistration"
            },
            extraData: extraData,
            loadAction: $completeRegisterForm,
            toastr: false,
            validate: function () {

                var isValid = Validator.validateElements($completeRegisterForm);
                if (formType !== 'regulations_form') {
                    var isoCode = $completeRegisterForm.find('.phone-prefix-select :selected').attr('data-iso');
                    var $inputPhoneNumber = $completeRegisterForm.find('.reg-form-cell-phone');
                    var phoneNumber = $inputPhoneNumber.val();

                    var parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString(phoneNumber, isoCode);

                    if (parsedPhoneNumber) {
                        if (!parsedPhoneNumber.isValid()) {
                            isValid = false;
                            $inputPhoneNumber.next().text(translation('REGISTER.please_valid_cell_phone'));
                            $inputPhoneNumber.addClass('is-invalid');
                        } else {
                            $inputPhoneNumber.removeClass('is-invalid');
                        }
                    } else {
                        $inputPhoneNumber.addClass('is-invalid');
                    }
                } else {
                    if($completeRegisterForm.find('#reg_form_cnp').length){
                        isValid = Validator.validateCnp();
                    }
                }
                return isValid;
            },
            onSuccess: function (data) {
                setAgeVerificationCookie();
                removeMissingDetailsCookie('india_reg');
                window.localStorage.removeItem("complete-register-information");
                $completeRegisterModal.find('.modal-content').addClass('view-loader loader-center');

                setTimeout(function() {
                    $completeRegisterModal.modal('hide');
                    if (formType === 'regulations_form' && !Number(BaseConfig.get('CUSTOM_PERSONAL_DETAILS_FLOW'))) {
                        window.location.reload();
                    } else {
                        Mediator.getMediator().trigger('UserBalance_forceUpdate');
                        var $appComponents = document.getElementById('appComponents');
                        var requestedCurrencyId = getElement($completeRegisterForm).requestData.reg_form.currency_id;
                        var selectedCurrencyCode = _.find(Config.REG_FORM_DATA.availableCurrencies, function (currency) {
                            return currency.id === requestedCurrencyId;
                        });
                        if ($appComponents) {
                            $appComponents.__vueParentComponent.appContext.config.globalProperties.$store.dispatch('user/GET_MEMBER_BALANCE');
                            if (selectedCurrencyCode) {
                                if (window.Config.CURRENCY_CODE !== selectedCurrencyCode.code) {
                                    window.VueEventBus.$emit('reconnect-player-socket');
                                }
                            } else {
                                console.warn('selectedCurrencyCode lookup miss for currency_id:', requestedCurrencyId);
                                if (window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
                                    window.ErrorTracker.trackError(
                                        new Error('selectedCurrencyCode lookup miss'),
                                        { currency_id: requestedCurrencyId }
                                    );
                                }
                            }
                        }
                        if (Config.ACTION != 'updateGuestMember') {
                            $completeRegisterModal.remove();
                            var paymentIQCashierContainer = document.getElementById("paymentIQCashierContainer");
                            if (paymentIQCashierContainer) {
                                paymentIQCashierContainer.__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_HAS_PAYMENT_IQ_PERSONAL_DATA', true);
                            }
                            $cashierModal.modal('show');
                        }
                    }
                }, 1000);
            },
            onError: function (errData) {
                var errors = errData.error;
                $completeRegisterModal.find('.is-invalid').removeClass('is-invalid');
                for (var error in errors) {
                    if (error == 'birthday') {
                        var birthdayFields = ['birthday_day', 'birthday_month', 'birthday_year'];
                        birthdayFields.forEach(function(field){
                            $completeRegisterModal.find('#reg_form_' + field).addClass('is-invalid');
                        });
                        $completeRegisterModal.find('#reg_form_birthday_month').closest('.form-group').find('.invalid-feedback').addClass('d-block').text(errors[error]);
                    }
                    $completeRegisterModal.find('#reg_form_' + error).addClass('is-invalid').closest('.form-group').find('.invalid-feedback').text(errors[error]);
                }
            }
        });
    });

    function getStateOptions() {
        var countriesRequireStateIso = [];
        var getRegulations = Config.WHITE_LABEL_REGULATIONS;
        var countriesRequireState = getRegulations.countries_require_state;
        var memberCountryIso = BaseConfig.get('MEMBER_COUNTRY_ISO_CODE') ? BaseConfig.get('MEMBER_COUNTRY_ISO_CODE').toUpperCase() : '';
        var stateDropdownMenu = $completeRegisterForm.find('#reg_form_state_id');

        countriesRequireState.forEach(function(country) {countriesRequireStateIso.push(country.iso2_alpha)})
        var memberCountryIndex = countriesRequireStateIso.indexOf(memberCountryIso)

        if (getRegulations.reg_state && memberCountryIndex !== -1) {
            $completeRegisterForm.find('.state-menu-row').removeClass('d-none');
            $completeRegisterForm.find('#reg_form_state_id').removeAttr('disabled');

            $completeRegisterForm.ajaxRequest('getCountryStatesOperation', {
                request: {
                    url: "/" + Config.LOCALE_SHORT + "/settings/operation/getCountryStates"
                },
                extraData: { 'country_id': countriesRequireState[memberCountryIndex].id},
                toastr: false,
                onSuccess: function (response) {
                    if (response.status === 'success' && response.data.length > 0) {
                        stateDropdownMenu.find('option + option').remove();
                        appendDropdownOptions(response.data, stateDropdownMenu, 'country_subdivision_id', 'title')
                        stateDropdownMenu.attr('disabled', false);
                    } else {
                        stateDropdownMenu.attr('disabled', true);
                    }
                },
                onError: function (response) {
                    console.error(response.error);
                    stateDropdownMenu.attr('disabled', true);
                }
            })
        }
    }

    function checkAgeVerification() {
        var avCookie = Cookies.get('av');

        if(typeof avCookie !== 'undefined' && avCookie === userId + '=av' && !(Config.WHITE_LABEL_REGULATIONS.reg_fields && $completeRegisterForm.length)) {
            return;
        } else {
            if(userId !== '' && !Number(BaseConfig.get('CUSTOM_PERSONAL_DETAILS_FLOW'))){
                $completeRegisterModal.modal('show');
            }
        }
    }

    function setAgeVerificationCookie() {
        var name = 'av',
            value = userId + '=av';

        Cookies.set(name, value, {
            expires: 365,
            domain: '.' + Config.BASE_URL
        });
    }

    function checkMissingDetailsCookie(name) {
        var missingDetailsCookie = Cookies.get(name + '_missing_details');

        if (missingDetailsCookie) {
            $completeRegisterModal.modal('hide');
            $completeRegisterModal.remove();
            return
        }
        $completeRegisterModal.modal('show');
    }

    function removeMissingDetailsCookie(name) {
        Cookies.remove(name + '_missing_details', { path: '/' , domain: document.domain});
    }

    function setMissingDetailsCookie(name, daysRange) {
        var cookieName = name + '_missing_details',
            value = userId + '=' + name + '_missing_details';

        Cookies.set(cookieName, value, {
            expires: daysRange,
            domain: '.' + Config.BASE_URL
        });
    }
});
; /** ----------------- **/ 
 $(function(){

    if(Config.USER_LOGGED_IN == 1){
        return;
    }

    var $depositGuestModal = $('#depositGuestModal'),
        $quickDepositModal = $('#quickDepositModal'),
        $loginGuestModal = $('#loginGuestModal');


    $(document).on('click','.provider-trustly-guest .btn',function(){
        var isValidEmail = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
            emailVal = $('.provider-trustly-guest').find('#email_address').val(),
            amount =  parseFloat($('.provider-trustly-guest').find('#amount').val()),
            minDepositVal = parseFloat($depositGuestModal.find('.min-amount-value').data('limit-min')),
            maxDepositVal = parseFloat($depositGuestModal.find('.max-amount-value').data('limit-max'));

        if(isValidEmail.test(emailVal) && amount) {
            if(!minDepositVal && !maxDepositVal) {
                $depositGuestModal.find('.close').addClass('d-none');
                $depositGuestModal.find('.modal-nav').addClass('d-none');
            }
        }
    });

    $(document).on('click','#loginGuestButton',function(){
        $loginGuestModal.find('.close').addClass('d-none');
        $loginGuestModal.find('.modal-nav').addClass('d-none');
    });

    $(document).on('click', '#quickDepositButton', function () {
        $quickDepositModal.modal('show');
    });

    $quickDepositModal.on('hidden.bs.modal', function (e) {
        generateLoginGuestError($quickDepositModal, '', false);
    });

    $loginGuestModal.on('hidden.bs.modal', function (e) {
        generateLoginGuestError($loginGuestModal, '', false);
    });

    $loginGuestModal.find('#loginGuestModalBack').on("click", function(e){
        generateLoginGuestError($loginGuestModal, '', false);
        displayGuestModals($loginGuestModal, false);
    });

    $(document).on('click', '#loginGuestButton', function () {
        toggleQuickDepositModalLoader($quickDepositModal, true);
        getLoginGuestMode($loginGuestModal);
    });

    // DepostiGuestModal

    $(document).on('click', '.deposit-guest-button', function () {
        toggleQuickDepositModalLoader($quickDepositModal, true);
        var depositType = $(this).attr('data-deposit'),
        isKeepPlaying = $(this).attr('data-keep-playing');

        getDepositGuestMethods($depositGuestModal, depositType, isKeepPlaying);
    });

    $depositGuestModal.on('hidden.bs.modal', function (e) {
        generateLoginGuestError($depositGuestModal, '', false);
    });


    $depositGuestModal.find('#depositGuestModalBack').on("click", function(e){
        var $paymentProviderContainer = $depositGuestModal.find('.payment-provider-container'),
            $paymentIframeContainer = $depositGuestModal.find('.payment-iframe-container');

        generateLoginGuestError($depositGuestModal, '', false);

        if($depositGuestModal.find('.payment-provider-container').hasClass('d-none')) {
            $paymentIframeContainer.addClass('d-none');
            $paymentProviderContainer.removeClass('d-none');
        } else {
            displayGuestModals($depositGuestModal, false);
        }
    });

    if(Config.IS_MOBILE) {
        detectUrlHasHashAndGdidParamter();
    }

    detectUrlHashChange();
    getFastDepositMethodUrl();

    function generateErrorMessage(errorKey, translationKey){
        var errorMsg = 'JS.' + translationKey + '.' + errorKey;

        if(TRANSLATIONS && TRANSLATIONS.translationKey && TRANSLATIONS.translationKey[errorKey]) {
            errorMsg = TRANSLATIONS.translationKey[errorKey];
        }

        return errorMsg;
    }

    function getDepositGuestMethods($depositGuestModal, depositType, isKeepPlaying) {

        var $quickDepositModal = $('#quickDepositModal'),
            errorKey = generateErrorMessage('error_request', 'DEPOSIT_GUEST_MODAL'),
            depositType = depositType;
            url = '/'+ Config.LOCALE_SHORT + '/my/guest-deposit';

        $.ajax({
            url: url,
            data: {
                'd-type': depositType + '-guest',
                'modalView': 1
            },
            dataType: "html",
            method: "GET",
            success: function(data) {
                var isContainStatusError = /("status":"error")/.test(data);

                if(isContainStatusError) {
                    var resData = JSON.parse(data);
                    generateLoginGuestError($quickDepositModal, resData, true);
                } else  {
                    renderGuestDepositMethodForm($depositGuestModal, data, isKeepPlaying);
                    $quickDepositModal.find('.alert-container').empty();
                    displayGuestModals($depositGuestModal, true);
                    detectUrlHashChange($depositGuestModal);
                }
            },
            error: function(res) {
                generateRequestError($quickDepositModal, res.error ? res.error : errorKey, $quickDepositModal);
            },
            failure: function () {
                generateRequestError($quickDepositModal, errorKey, $quickDepositModal);
            }
        }).always(function() {
            toggleQuickDepositModalLoader($quickDepositModal, false);
        });
    }

    function renderGuestDepositMethodForm($modal, data, isKeepPlaying){
        var $modalActions = $modal.find('#deposit-guest-actions');
        var submitTitle = translation('HEADER.keep_playing');
        var productType = localStorage.getItem('productType');
        var modalTitle = productType === 'casino' ? translation('HEADER.keep_playing_casino') : translation('HEADER.keep_playing_sport');

        if (isKeepPlaying) {
            $modalActions.removeClass('d-none');
        } else {
            $modalActions.addClass('d-none');
            submitTitle = translation('HEADER.play_now');
        }

        $modal.find('#paymentFormContainer').html(data);
        $modal.find('.form-submit-button').text(submitTitle);
        $modal.find('h4').text(modalTitle);
    }


    function getLoginGuestMode($loginGuestModal) {

        var $quickDepositModal = $('#quickDepositModal'),
            errorKey = generateErrorMessage('error_request', 'LOGIN_GUEST_MODAL');

        $.ajaxRequest('makeGuestDeposit', {
            toastr: false,
            extraData: {
                'payment-method': 'trustly-guest',
                'payment-provider': 'trustly',
                'requestUrl': window.location.href,
                'modalView': 1
            },
            onSuccess: function(data) {
                if(data) {
                    if(Config.IS_MOBILE) {
                        $quickDepositModal.modal('hide');
                        window.open(data.iframeUrl, '_blank')
                    } else {
                        renderLoginGuestForm($loginGuestModal, data);
                    }
                }
            },
            onError: function(res) {
                generateRequestError($quickDepositModal, res.error ? res.error : errorKey, $quickDepositModal);
            },
            onFailure: function (res) {
                generateRequestError($quickDepositModal, res.error ? res.error : errorKey, $quickDepositModal);
            },
            onComplete: function () {
                toggleQuickDepositModalLoader($quickDepositModal, false);
            }
        });
    }

    function generateRequestError($quickDepositModal, error, $loaderContent) {
        var data = {
            error: error
        };
        generateLoginGuestError($quickDepositModal, data, true);
        toggleQuickDepositModalLoader($loaderContent, false);
    }

    function renderLoginGuestForm($modal, data){
        var $paymentIframeContainer = $modal.find('.payment-iframe-container');


        if(data.status == 'success') {
            $paymentIframeContainer.removeClass('d-none');
            $modal.find('#iframe-payment').attr('src', data.iframeUrl);
        }

        if(data.status == 'error') {
            $paymentIframeContainer.addClass('d-none');
            generateLoginGuestError($modal, data, true);
        }

        displayGuestModals($modal, true);
    }

    function generateLoginGuestError($modal, data, display) {
        var $alertContainer = $modal.find('.alert-container'),
            $backButtonModal = $modal.find('.modal-nav'),
            $closeButtonModal = $modal.find('.close');

        $alertContainer.empty();

        if(display && data) {
            if($closeButtonModal.hasClass('d-none') && $backButtonModal.hasClass('d-none')) {
                $closeButtonModal.removeClass('d-none');
                $backButtonModal.removeClass('d-none');
            }
            $alertContainer.removeClass('d-none').append(data.error);
        } else {
            $alertContainer.addClass('d-none');
        }
    }

    function displayGuestModals($modal, display) {
        var $quickDepositModal = $('#quickDepositModal');

        if(display) {
            $quickDepositModal.modal('hide');
            $modal.modal('show');
        } else {
            $modal.modal('hide');
            $quickDepositModal.modal('show');
        }

    }

    function toggleQuickDepositModalLoader($modal, state) {
        var $modalContent = $modal.find('.modal-content');
        if(!state) {
            $modalContent.removeClass('view-loader loader-center white-loader');
        } else {
            $modalContent.addClass('view-loader loader-center white-loader');
        }
    }

    /* DETECT URL HASHCHANGE */
    function detectUrlHashChange() {
        $(window).on('hashchange', function() {
            var paymentData = getPaymentDataFromUrl();
            sanitizeUrlChange();
            reactOnGuestPaymentMethodResponse(paymentData);
        });
    }

    function sanitizeUrlChange() {
        history.replaceState("", document.title, window.location.pathname);
    }

    function reactOnGuestPaymentMethodResponse(paymentDataObj) {

        if(Object.keys(paymentDataObj).length == 0) {
            return;
        }

        var $loginGuestModal = $('#loginGuestModal'),
            $depositGuestModal = $('#depositGuestModal'),
            lang = Config.LOCALE_SHORT,
            data = {
                gdid: paymentDataObj.gdid,
                status: paymentDataObj.status,
                modalView: 1
            };

        $.ajax({
            url: "/" + lang + "/index/guest-response",
            data: data,
            dataType: "json",
            method: "GET",
            beforeSend: function() {
                renderGuestDepositMethodForm($depositGuestModal, '');
            },
            success: function(response) {
                if(!response.redirectUrl) {
                    if($('#loginGuestModal').hasClass('show')) {
                        renderLoginGuestForm($loginGuestModal, response, true);
                    } else {
                        renderLoginGuestForm($depositGuestModal, response, true);
                    }
                } else {
                    if(Config.IS_MOBILE) {
                        $depositGuestModal.modal('show');
                        $depositGuestModal.find('.close').addClass('d-none');
                        $depositGuestModal.find('.modal-nav').addClass('d-none');
                    }
                    renderGuestDepositMethodForm($depositGuestModal, response.content);
                    $('.continue-guest-button').on('click', function () {
                        window.location.href = response.redirectUrl;
                    });
                }
                if(typeof checkDepositStatusUpdate === 'function'){
                    checkDepositStatusUpdate($depositGuestModal, data.gdid);
                }
            },
            error: function() {
                console.log('error request');
            },
            failure: function () {
                console.log('failure request');
            }
        });
    }

    /*DETECT IF URL HAS HASH AND GDID parameter */
    function detectUrlHasHashAndGdidParamter() {
        var paymentData = getPaymentDataFromUrl();
        reactOnGuestPaymentMethodResponse(paymentData);
    }

    function getPaymentDataFromUrl() {
        var urlHash = window.location.hash.substring(1);
        var delimiter = /[&=#]/g;
        var paymentDataArray = urlHash.split(delimiter);

        var paymentDataObj = {};

        for (var i = 0; i < paymentDataArray.length; i += 2) {
            if(paymentDataArray[i].length != 0) {
                paymentDataObj[paymentDataArray[i]] = paymentDataArray[i + 1];
            }
        }

        return paymentDataObj;
    }

    function getFastDepositMethodUrl(){
        if(getParameterByName('fast_deposit') == 'true') {
            getDepositGuestMethods($depositGuestModal, 'zimpler');
        }
    }
});; /** ----------------- **/ 
 $(function () {

    var $depositLeaveCampaignModal = $('#depositLeaveCampaignModal'),
        $formContainer = $('.payment-provider-container'),
        $responseMessageContainer = $depositLeaveCampaignModal.find('.response-message-container'),
        $confirmLeaveBtn = $depositLeaveCampaignModal.find('.confirmLeaveBtn'),
        $responseMessageContent = $responseMessageContainer.find('.response-message-content'),
        $marketingMessageContainer = $depositLeaveCampaignModal.find('.marketing-message-container'),
        $confirmMessageBtn = $depositLeaveCampaignModal.find('.confirmMessageBtn'),
        $marketingMessageInfo = $depositLeaveCampaignModal.find('.marketing-message-campaign-info');

    $(document).on('click', '.depositWithoutBonusCodeBtn', function(){
        var $validateFormContainer = $('.payment-provider-container').find('.validate-form');

        $validateFormContainer.find('#bonus_code').val('');
        $depositLeaveCampaignModal.modal('hide');
        $validateFormContainer.submit();
    });

    $depositLeaveCampaignModal.on('hidden.bs.modal', function () {
        $marketingMessageContainer.removeClass('d-none');
        $responseMessageContainer.removeClass('d-block');
        $responseMessageContent.empty();
        $marketingMessageInfo.empty();
    });

    $confirmMessageBtn.on('click', function () {
        $depositLeaveCampaignModal.modal('hide');
    });

    $confirmLeaveBtn.on('click', function(){
        var campaignId = $depositLeaveCampaignModal.attr('data-campaign-id');
        var $validateForm = $('.payment-provider-container').find('.validate-form');
        $.ajaxRequest('leaveCampaign', {
            toastr: false,
            "request": {
                'url': '/' + Config.LOCALE_SHORT + '/my/operation/leaveCampaign'
            },
            loadAction: $formContainer,
            extraData: {
                'cid': campaignId
            },
            onSuccess: function(data) {
                responseMessageHandler(data);
                $validateForm.submit();
            },
            onError: function (data) {
                responseMessageHandler(data);
            }
        });
    });

    function responseMessageHandler(data) {
        var message = data.message;
        $marketingMessageContainer.addClass('d-none');
        $responseMessageContainer.addClass('d-block');
        $responseMessageContent.append(message);
    }
});
; /** ----------------- **/ 
 $(function () {
    $(document).on('click', '.continueWithoutBonusCodeBtn', function(){
        var $formContainer = $('.payment-provider-container'),
            $validateForm = $formContainer.find('.validate-form');

        $validateForm.find('#bonus_code').val('');
        $('#depositWithoutBonusCodeModal').modal('hide');
        $validateForm.submit();
    });

    $('#depositWithoutBonusCodeModal').on('hidden.bs.modal', function () {
        $('#depositWithoutBonusCodeModal .modal-resp-msg').remove();
    });
});
; /** ----------------- **/ 
 $(function () {
    $(document).on('click', '.confirmDepositAmountBtn', function(){
        var $formContainer = $('.payment-provider-container'),
            $validateForm = $formContainer.find('.validate-form');

        $validateForm.prepend('<input type="hidden" name="amount_confirmed" value="1">');
        $validateForm.find('#bonus_code').val('');
        $('#depositConfirmAmountModal').modal('hide');
        $validateForm.submit();

    });

    $('#depositWithoutBonusCodeModal').on('hidden.bs.modal', function () {
        $('#depositWithoutBonusCodeModal .modal-resp-msg').remove();
    });

});; /** ----------------- **/ 
 $(function () {
    var $createNewPasswordModal = $('#create-new-password-modal'),
        $createNewPasswordForm = $createNewPasswordModal.find('#recover-password-form'),
        $errorContainer = $createNewPasswordForm.find('.error-container'),
        $successContainer = $createNewPasswordModal.find('.success-submit-form'),
        redirectUrl = $createNewPasswordForm.attr('data-redirect-url'),
        errorSimple = translation('REGISTER.password_simple_requirements'),
        errorMedium = translation('_localizer.REGISTER.password_medium_requirements'),
        errorComplex = translation('REGISTER.password_complex_requirements')

    var urlPath = window.location.pathname,
        hasNotMemberId = $('.forgotten-password').attr('data-member-id')

    if (/recovery\/create-new-password/.test(urlPath)) {
        if (!hasNotMemberId) {
            $createNewPasswordModal.modal('show')
        } else {
            if (!BaseConfig.get('VUE_LOGIN_ENABLED')) {
                $('#forgot-password-modal').modal('show')
            }
        }
    }

    Validator.initSelfValidation($createNewPasswordForm)

    $createNewPasswordForm.find('#password_reset_password').on('change', function () {
        var $passwordInput = $(this),
            value = $passwordInput.val(),
            minLength = Number(BaseConfig.get('IS_SIMPLE_PASSWORD') ? '3' : '8'),
            re = new RegExp('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W])(?!.*[\\s])[\\w\\W]{8,}$'),
            reMedium = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W])(?=\\S+$).{8,32}$'),
            isSimplePassword = BaseConfig.get('IS_SIMPLE_PASSWORD'),
            isMediumPassword = BaseConfig.get('IS_MEDIUM_PASSWORD')

        if (isMediumPassword === '1' && isSimplePassword === '0') {
            // Validate against medium requirements
            if (!reMedium.test(value)) {
                $passwordInput[0].setCustomValidity(errorMedium)
                $passwordInput.addClass('is-invalid')
            } else {
                $passwordInput[0].setCustomValidity('')
                $passwordInput.removeClass('is-invalid')
            }
        } else if (!re.test(value) && !isSimplePassword) {
            $passwordInput[0].setCustomValidity(errorComplex)
            $passwordInput.addClass('is-invalid')
        } else if (value.length < minLength && isSimplePassword){
            $passwordInput[0].setCustomValidity(errorSimple)
            $passwordInput.addClass('is-invalid')
        } else {
            $passwordInput[0].setCustomValidity('')
            $passwordInput.removeClass('is-invalid')
        }
        checkPasswordMatching()
    })

    $createNewPasswordForm.find('#password_reset_confirm_password').on('change', function() {
        checkPasswordMatching()
    })

    var checkPasswordMatching = function(){
        var $passwordInput = $createNewPasswordForm.find('#password_reset_password'),
            $confirmPasswordInput = $createNewPasswordForm.find('#password_reset_confirm_password'),
            errorMatching = translation('REGISTER.confirm_password_not_match')

        if ($passwordInput.val() !== $confirmPasswordInput.val()) {
            $confirmPasswordInput[0].setCustomValidity(errorMatching)
            $confirmPasswordInput.next().text(errorMatching)
            $confirmPasswordInput.addClass('is-invalid')
        } else {
            $confirmPasswordInput[0].setCustomValidity('')
            $confirmPasswordInput.removeClass('is-invalid')
        }
    }

    $createNewPasswordForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        var form = $(this)

        getElement(form).ajaxRequest('createNewPassword', {
            request: {
                url: '/' + Config.LOCALE_SHORT + '/recovery/operation/createNewPassword',
            },
            loadAction: $createNewPasswordForm,
            alert: {
                $el: $errorContainer,
                className: 'alert-sm',
            },
            toastr: false,
            validate: function () {
                return Validator.validateElements($createNewPasswordForm)
            },
            onSuccess: function () {
                $createNewPasswordForm.addClass('d-none')
                $successContainer.removeClass('d-none')
                setTimeout(function () {
                    window.location = redirectUrl
                }, 2500)
                window.UILogger.logEvent('select_create_new_password_button', {
                    value: 'Successful logged user',
                })
            },
            onError: function (data) {
                console.log(data)
            },
        })
    })
})
; /** ----------------- **/ 
 $(function () {
    if(Config.SHOW_AGE_VERIFICATION_POPUP == 0) {
        return;
    }

    var $verifyAgeModal = $('#verifyAgeModal');
    var $verifyAgeForm = $('#verify-age-form');
    var $depositModal = $('#depositModal');
    var $errorContainer = $verifyAgeModal.find('.error-container');

    $verifyAgeModal.modal('show');

    $verifyAgeForm.on('submit', function (e) {

        e.preventDefault();
        e.stopPropagation();

        getElement($verifyAgeForm).ajaxRequest('completeRegistration', {
            request: {
                url: "/" + Config.LOCALE_SHORT + "/my/operation/completeRegistration"
            },
            extraData: {
                type: 'verify_age'
            },
            loadAction: $verifyAgeForm,
            toastr: false,
            validate: function () {
                return  Validator.validateElements($verifyAgeForm);
            },
            onSuccess: function () {
                $verifyAgeModal.find('.modal-content').addClass('view-loader loader-center');
                $errorContainer.find('.alert').addClass('d-none');
                setTimeout(function() {
                    $verifyAgeModal.modal('hide');
                    if(Config.ACTION != 'updateGuestMember') {
                        $depositModal.modal('show');
                    }
                }, 1000);
            },
            onError: function (errors) {
                var errorMessage = errors.error && errors.error.birthday_year ? errors.error.birthday_year : errors[0];
                $errorContainer.find('.alert').removeClass('d-none').text(errorMessage);
            }
        });
    });
});; /** ----------------- **/ 
 var ISO3CountryMap = ['WLS','SCT', 'NIR', 'NIK'];; /** ----------------- **/ 
 var ResultMarketsTitlesMap = {
    sports: {
        soccer: {
            marketKeys: ["total_goals", "multi_range_home", "multi_range_away", "home_team_score", "away_team_score", "home_total_goals", "away_total_goals"],
            singularKey: "goal",
            pluralKey: "goals"
        },
        icehockey: {
            marketKeys: ["total_goals", "race_to", "both_teams_to_score_at_least", "home_team_score", "away_team_score"],
            singularKey: "goal",
            pluralKey: "goals"
        },
        tennis: {
            marketKeys: ["total_goals"],
            pluralKey: "sets"
        },
        volleyball: {
            marketKeys: ["total_goals"],
            pluralKey: "sets"
        }
    },
    getTranslatedMarketKey: function(sportKey, marketKey, lineKey) {
        var mobileTitle = TRANSLATIONS.MARKETS[lineKey] || lineKey;

        if(ResultMarketsTitlesMap.sports[sportKey] && ResultMarketsTitlesMap.sports[sportKey].marketKeys.indexOf(marketKey) !== -1) {
            if(lineKey === '1' && ResultMarketsTitlesMap.sports[sportKey].singularKey) {
                var singularKey =  ResultMarketsTitlesMap.sports[sportKey].singularKey;
                mobileTitle = lineKey.replace('p', '+') + ' ' + (TRANSLATIONS.MARKETS[singularKey] ? TRANSLATIONS.MARKETS[singularKey] : 'JS.MARKETS.' + singularKey);
            }
            if(lineKey !== '1' && ResultMarketsTitlesMap.sports[sportKey].pluralKey) {
                var pluralKey = ResultMarketsTitlesMap.sports[sportKey].pluralKey;
                mobileTitle = lineKey.replace('p', '+') + ' ' + (TRANSLATIONS.MARKETS[pluralKey] ? TRANSLATIONS.MARKETS[pluralKey] : 'JS.MARKETS.' + pluralKey);
            }
        }

        return mobileTitle;
    },
};; /** ----------------- **/ 
 Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
}

var SocketFilters = function () {

    var filters = this;
    var liveMarketTypeIds = ['1', '2', '3', '39', '4', '9', '11', '13', '14', '21', '22', '23', '24', '40', '99', '172', '173', '174', '175', '176', '177', '178', '179', '180', '181', '182', '183', '184', '185', '186', '187', '188'];

    var getSearchEvents = function(eventsObject) {

        var events = [];
        for(var k in eventsObject){
            if(k !== '0'){
                events.push(k);
            }
        }
        return events;
    };

    var getFavoriteEvents = function(){
        var events = [];
        for(var event in FAVORITES.events){
            events.push(event)
        }
        return events;
    };

    var getDateFormatted = function(date){

        var dateFormatted = [
                date.getFullYear(),
                (date.getMonth()+1).padLeft(),
                date.getDate().padLeft(),
                ].join('-')+
            ' ' +
            [ date.getHours().padLeft(),
                date.getMinutes().padLeft(),
                date.getSeconds().padLeft()].join(':');

        return dateFormatted;

    };

    var getDateFormattedMoment = function (date) {
        // TODO isUTC was removed, needed to check
        if (dateUtil.isDateUtil(date)) {
            return date.locale('en').format('YYYY-MM-DD HH:mm:ss');
        }
        return console.error('Enter a valid date object.');
    };

    filters.getUpdateVueOddsFilters = function (filters, method, initial, subscription) {

        var socketFilters = {
            is_main_gp: 1,
            type: filters.type,
            index:filters.option_index_lte,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: filters.asian_selection,
            time_range: filters.time_range,
        };

        if(filters.is_esport !== undefined){
            socketFilters.is_esport = filters.is_esport
        }
        if(initial || initial === undefined){
            socketFilters.init = 1;
        }else{
            delete socketFilters.init;
        }


        if(filters.forceInit){
            socketFilters.init = 1;
        }

        if(filters.event_id && filters.event_id.length){
            socketFilters.event_id = filters.event_id;
        }

        if(filters.market_types_sports_main && filters.market_selection !== 'correct_score'){
            socketFilters.is_main_mt = filters.market_types_sports_main
        }

        if(filters.market_type_id){
            socketFilters.market_type_id = [filters.market_type_id]
        }

        if(filters.leagues){
            for(var k in filters.leagues){
                socketFilters.league_id = _.union(socketFilters.league_id, filters.leagues[k])
            }
        }

        var sports = [];
        if(filters.sport_id){
            for(var i = 0; i < filters.sport_id.length; i++){
                sports.push(filters.sport_id[i].toString())
            }
        }

        socketFilters.sport_id = sports

        if(socketFilters.sport_id.length == 0 || socketFilters.sport_id.indexOf('0') !== -1){
        // if(socketFilters.sport_id.length == 0 ){
            delete socketFilters.sport_id;
        }
        if(filters.asian_selection == 'outright' || filters.market_selection == 'outright'){
            // Subscribe with invalid sport in order not to get any results
            socketFilters.sport_id = ['0'];
            delete socketFilters.event_state;
        }

        if(filters.asian_selection === 'today' || filters.state == 'today'){
            socketFilters.time_range = 'today';
            socketFilters.hour_range_only_not_top = Config.COUNTRY_ISO ? Config.COUNTRY_ISO: '-';
            delete socketFilters.event_state
        }

        if(filters.asian_selection == 'early'){
            if(filters.time_range && filters.time_range != 'all' && filters.time_range != 'later'){
                var dateRange = getTimeRangeFilters(filters.time_range);
                socketFilters.from  = dateRange.from;
                socketFilters.to  = dateRange.to;
            }
            if(filters.time_range == 'later'){
                socketFilters.time_range = ['later']
            }else{
                delete socketFilters.time_range
            }
        }

        if(filters.state == 'live' || filters.state == 'early'){
            socketFilters.event_state = filters.state;
        }

        if(socketFilters.event_state == 'live'){
            delete socketFilters.time_range
        }
        if(typeof socketFilters.time_range == 'string'){
            socketFilters.time_range = [socketFilters.time_range]
        }

        if(filters.asian_selection === 'custom'){
            delete socketFilters.search;
            delete socketFilters.sport_id;
            delete socketFilters.event_state;
            delete socketFilters.sports;
            delete socketFilters.sports_game_periods_main;
            delete socketFilters.leagues;
            delete socketFilters.time_range;
            socketFilters.event_id = filters.event_id ? filters.event_id : getSearchEvents(filters.events_refresh);
        }

        return socketFilters;
    };

    filters.getAsiaLiveFilters = function (filters, method, initial, subscription) {

        var socketFilters = {
            is_main_gp: 1,
            type: 'odds',
            index:filters.option_index_lte,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: filters.asian_selection,
            time_range: filters.time_range
        };

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }else{
            delete socketFilters.init;
        }


        if(filters.forceInit){
            socketFilters.init = 1;
        }
        if(!subscription){
            socketFilters.type = 'events';
        }
        if(subscription && subscription.sortedEvents == undefined){
            socketFilters.type = 'events';
        }else{
            if(filters.event_id && filters.event_id.length){
                socketFilters.event_id = filters.event_id;
            }
        }
        if(filters.market_types_sports_main && filters.market_selection !== 'correct_score' && filters.market_selection !== 'total_goal' && filters.market_selection !== 'odd_even' ){
            socketFilters.is_main_mt = filters.market_types_sports_main
        }

        if(filters.market_type_id){
            socketFilters.market_type_id = [filters.market_type_id]
        }

        if(filters.leagues){
            for(var k in filters.leagues){
                socketFilters.league_id = _.union(socketFilters.league_id, filters.leagues[k])
            }
        }
        if(getParameterByName('leagues')){
            socketFilters.league_id = getParameterByName('leagues').split(',')
        }

        if(filters.time_range == 'all'){
            var timeRanges = [];
            for(var k in getDateFilters()){
                timeRanges.push(k)
            }
            socketFilters.time_range = timeRanges;
        }


        var hourRange =_.findWhere(getHourFilters(), {key: filters.hour_range})

        if(hourRange){
            if(hourRange.from){
                socketFilters.from = hourRange.from
            }
            if(hourRange.to){
                socketFilters.to = hourRange.to
            }
        }

        if(filters.time_range == -1){
            socketFilters.time_range = ''
        }
        if(filters.asian_selection !== 'live' && filters.sport_id){
            var sports = [];
            for(var i = 0; i < filters.sport_id.length; i++){
                sports.push(filters.sport_id[i].toString())
            }
            socketFilters.sport_id = sports
            if(socketFilters.sport_id.length == 0 || socketFilters.sport_id.indexOf('0') !== -1){
                delete socketFilters.sport_id;
            }
        }

        if(filters.asian_selection === 'today' || filters.state == 'today'){
            socketFilters.time_range = 'today';
            socketFilters.hour_range_only_not_top = Config.COUNTRY_ISO ? Config.COUNTRY_ISO: '-';
            delete socketFilters.event_state
        }

        if(filters.asian_selection === 'tomorrow'){
            delete socketFilters.event_state
        }


        if(typeof socketFilters.time_range == 'string'){
            socketFilters.time_range = [socketFilters.time_range]
        }


        //TODO check if we can subscribe for two rooms at start

        // if(method == 'updateOdds' && filters.asian_selection == 'combo'){
        //     if(!_.size(filters.leagues)){
                // socketFilters.league_id = [];
        //     }
        // }

        if(filters.asian_selection == 'combo'){
            socketFilters.supports_combo = 1;
            socketFilters.mode = 'combo';
            delete socketFilters.event_state
        }else{
            if(socketFilters.sport_id && socketFilters.sport_id.length == 0){
                delete socketFilters.sport_id;
            }
        }

        if(method === 'getAdditionalSports'){
            delete socketFilters.league_id;
            socketFilters.sport_id = filters.sports.slice(0);
        }

        if(filters.state == 'live' || filters.state == 'early'){
            socketFilters.event_state = filters.state;
        }
        if(filters.asian_selection === 'live'){
            delete socketFilters.sport_id;
        }

        if(filters.asian_selection === 'favorites'){
            delete socketFilters.sport_id;
            delete socketFilters.event_state;
            var favEvents = getFavoriteEvents();
            socketFilters.event_id = favEvents;
        }

        if(filters.asian_selection === 'custom'){
            delete socketFilters.search;
            delete socketFilters.sport_id;
            delete socketFilters.event_state;
            delete socketFilters.sports;
            delete socketFilters.sports_game_periods_main;
            delete socketFilters.leagues;
            delete socketFilters.time_range;
            socketFilters.type = 'odds';
            socketFilters.event_id = getSearchEvents(filters.events_refresh);
        }

        if(socketFilters.event_state == 'live'){
            delete socketFilters.time_range
        }
        return socketFilters;

    };

    filters.getEuroEventFilters = function(filters, method, initial, subscription){

        var events = [];

        if (Array.isArray(filters.viewParams.event_id)) {
            events = filters.viewParams.event_id.slice(0);
        } else {
            events = [filters.viewParams.event_id.toString()]
        }

        var socketFilters = {
            event_id: events,
            type: 'odds',
            init: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        if(initial === undefined){
            socketFilters.init = 1;
        }else{
            socketFilters.init = initial;
        }

        return socketFilters
    };

    filters.getSelectedEventFilters = function(filters, method, initial, subscription){

        var events = [];

        if (Array.isArray(filters.event_id)) {
            events = filters.event_id.slice(0);
        } else {
            events = [filters.event_id.toString()]
        }

        var socketFilters = {
            event_id: events,
            type: 'odds',
            init: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        if(filters.index !== undefined) {
            socketFilters.index = filters.index
        }
        if(filters.is_ft !== undefined) {
            socketFilters.is_ft = filters.is_ft
        }
        if(filters.is_main_le !== undefined) {
            socketFilters.is_main_le = filters.is_main_le
        }

        if(filters.supports_bet_builder !== undefined) {
            socketFilters.supports_bet_builder = filters.supports_bet_builder;
        }

        return socketFilters
    };

    var getMarketTypesLiveMobile = function () {

        var marketData = getCategories();
        var marketTypeIds = [];
        for (var k in marketData) {
            var sportMarkets = marketData[k].markets;
            for (var i = 0; i < sportMarkets.length; i++) {
                var market = sportMarkets[i];
                if (marketTypeIds.indexOf(market.market_type_id) === -1) {
                    marketTypeIds.push(market.market_type_id)
                }
            }
        }
        return marketTypeIds;
    }

    filters.getEuroLiveSportsFilters = function(filters, method, initial, subscription){
        if(typeof getOddsServiceFilters == 'function'){
            var socketFiltersData = getOddsServiceFilters();
        }
        var socketFilters = {
            event_state: 'live',
            type: 'events',
            init: 1,
            index: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            is_main_le: 1,
        };

        if(socketFiltersData){
            if(socketFiltersData.market_type_id){
                socketFilters.market_type_id = [];
                for(var i = 0; i < socketFiltersData.market_type_id.length; i ++){
                    socketFilters.market_type_id.push(socketFiltersData.market_type_id[i].toString())
                }
            }
            if(socketFiltersData.is_ft_or_fh){
                socketFilters.is_ft_or_fh = socketFiltersData.is_ft_or_fh;
            }
        }

        if(Config.IS_MOBILE){
            if(typeof getCategories == 'function'){
                socketFilters.market_type_id = getMarketTypesLiveMobile();
            }
            socketFilters.index = 1;

            if(Config.LAST_VIEW == 'asian'){
                delete socketFilters.market_type_id;
                delete socketFilters.is_main_le;
                socketFilters.is_main_gp = 1;
                socketFilters.is_main_mt = 1;
            }else{
                socketFilters.is_main = 1;
                socketFilters.is_ft = 1;
            }

        }

        return socketFilters
    };

    filters.getESportsDataFilters = function(filters, method, initial, subscription){
        var socketFilters = {
            type: filters.type,
            index: 1,
            is_esport: 1,
            init: 1,
            market_type_id: ["1", "2", "3", "24"],
            // is_ft: 1,
            // is_main_le: 1,
            // time_range: ['today'],
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        // var dateRange = getTimeRangeFilters('today');
        // socketFilters.from  = dateRange.from;
        // socketFilters.to  = dateRange.to;

        if(filters.event_state){
            socketFilters.event_state = filters.event_state;
        }

        if(filters.type === 'events'){
            delete socketFilters.market_type_id
        }

        return socketFilters;
    };
    filters.getEuroLiveFilters = function(filters, method, initial, subscription){
        var socketFilters = {
            is_ft_or_fh: 1,
            index: 1,
            market_type_id: liveMarketTypeIds,
            is_main_le: 1,
            event_state: 'live',
            type: filters.type ? filters.type : 'odds',
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };
        if(filters.events){
            socketFilters.event_id = filters.events;
        }

        if(filters.league_id){
            socketFilters.league_id = filters.league_id;
        }

        if(filters.sport_id && filters.sport_id.length){
            socketFilters.sport_id = filters.sport_id.slice(0);
        }

        if(initial === undefined){
            socketFilters.init = 1;
        }else{
            socketFilters.init = initial;
        }

        if(filters.activeSportKey){
            if(subscription.activeSportKey && (subscription.activeSportKey != filters.activeSportKey)){
               // subscription.adapter.clearPreviousSport(subscription, filters.activeSportKey);
            }
            subscription.activeSportKey = filters.activeSportKey;
        }

        if(filters.market_type_id){
            socketFilters.market_type_id = filters.market_type_id;
            socketFilters.is_main = 1;
        }

        if(!socketFilters.market_type_id.length){
            delete socketFilters.market_type_id
        }
        return socketFilters;
    };

    filters.getEuroEnSportFilters = function (filters, method, initial, adapter) {

        var socketFilters = {
            type: filters.type ? filters.type : 'events',
            is_main_le: 1,
            index: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: filters.event_state ? filters.event_state : 'early'
        };

        if (filters.event_state == 'all') {
            delete socketFilters.event_state
        }

        if (filters.locale){
            socketFilters.locale = filters.locale;
        }

        if (filters.market_type_id && filters.market_type_id.length){
            var marketTypeIds = getMarketTypeIds(filters, adapter);
            socketFilters.market_type_id = marketTypeIds;
        }

        if (filters.league_id && filters.league_id.length){
            socketFilters.league_id = filters.league_id.slice(0);
        }

        if (initial || initial === undefined){
            socketFilters.init = 1;
        }

        return socketFilters;
    };

    filters.getEuroSportFilters = function (filters, method, initial, adapter) {

        var socketFilters = {
            type: filters.type ? filters.type : 'odds',
            is_main_le: 1,
            index: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: filters.event_state ? filters.event_state : 'early'
        };

        if(filters.is_ft_or_fh) {
            socketFilters.is_ft_or_fh = filters.is_ft_or_fh;
        }else{
            socketFilters.is_ft = 1;
        }
        if(filters.events){
            socketFilters.event_id = filters.events;
        }

        if(filters.event_state == 'all') {
            delete socketFilters.event_state
        }

        if(filters.sport_id){
            socketFilters.sport_id = [filters.sport_id.toString()];
        }

        if(filters.locale){
            socketFilters.locale = filters.locale;
        }

        if(filters.time_range && filters.time_range != 'all'){
            var dateRange = getTimeRangeFilters(filters.time_range, filters.startTimeRangeFromToday);
            socketFilters.from  = dateRange.from;
            socketFilters.to  = dateRange.to;
        }
        if(filters.market_type_id && filters.market_type_id.length){
            var marketTypeIds = getMarketTypeIds(filters, adapter);
            socketFilters.market_type_id = marketTypeIds;
        }

        if(filters.market_type_combination && filters.market_type_combination.length) {
            socketFilters.market_type_combination = filters.market_type_combination;
        }

        if(filters.is_ml) {
            socketFilters.is_ml =  1;
        }
        if(filters.is_main) {
            socketFilters.is_main = 1;
        }

        if(filters.league_id && filters.league_id.length){
            socketFilters.league_id = filters.league_id.slice(0);
        }

        if(filters.time_range == 'all'){
            delete socketFilters.time_range
        }

        if(filters.hour_range == 'next24'){
            var currentDate = new Date(Number(Config.SERVER_TIME));
            currentDate.setHours(currentDate.getHours() - Number(sportSettings.timeOffset));
            socketFilters.from = getDateFormatted(currentDate);
            currentDate.setHours(currentDate.getHours() + 24);
            socketFilters.to = getDateFormatted(currentDate);
        }

        if (filters.supports_bet_builder == 1) {
            socketFilters.supports_bet_builder = filters.supports_bet_builder;
        }

        if (filters.supports_my_events == 1) {
            socketFilters.supports_my_events = 1;
        }

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        if(filters.market_type_filters_by_sport !== 1 && filters.time_range == 'today' && Config.IS_MOBILE){
            delete socketFilters.market_type_id;
        }

        return socketFilters;

    };

    var getTimeRangeFilters = function(timeRange, startTimeRangeFromToday){
        var rangeOffsets = {
            today: 0,
            tomorrow: 24,
            after_2_days: 48,
            after_3_days: 72
        };
        var timeRangeData = {
            from: 0,
            to: 0
        };

        var fromDate = dateUtil.utc().utcOffset(Number(sportSettings.timeOffset)).startOf('day');

        if(!startTimeRangeFromToday){
            fromDate = fromDate.add(rangeOffsets[timeRange], 'hours');
        }

        timeRangeData.from = getDateFormattedMoment(fromDate.subtract(Number(sportSettings.timeOffset), 'hours'));

        var toDate = dateUtil
            .utc()
            .utcOffset(Number(sportSettings.timeOffset))
            .endOf('day')
            .add(rangeOffsets[timeRange], 'hours')
            .subtract(Number(sportSettings.timeOffset), 'hours');
        timeRangeData.to = getDateFormattedMoment(toDate);

        return timeRangeData;
    };

    var getMarketTypeIds = function (filters, adapter){

        var marketTypeIds = filters.market_type_id.slice(0);


        var index = marketTypeIds.indexOf('goalscorer');
        if (index !== -1) {
            marketTypeIds.splice(index, 1);
            marketTypeIds = marketTypeIds.concat(['26', '27', '28']);
        }

        var outrightIndex = marketTypeIds.indexOf('outright');

        //TODO A Temp Solution for the Competition page
        if (!adapter) {
            return marketTypeIds
        }

        if (outrightIndex !== -1) {
            marketTypeIds.splice(outrightIndex, 1);
            adapter.settings.outright = true;
        }else {
            adapter.settings.outright = false;
        }

        return marketTypeIds;
    };

    //TODO add the rest filter cases
    filters.getEuroLeagueFilters = function (filters, method, initial, adapter) {

        var socketFilters = {
            is_ft: 1,
            type: 'odds',
            is_main_le: 1,
            index: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: 'early',
            league_id: filters.league_id,
        };

        if(filters.market_type_id){
            var marketTypeIds = getMarketTypeIds(filters, adapter);
            socketFilters.market_type_id = marketTypeIds;
        }
        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        return socketFilters;

    };

    filters.getSportNavigationLiveFilters = function(filters, method, initial){
        var socketFilters = {
            is_ft_or_fh: 1,
            type: 'odds',
            is_main_le: 1,
            index: 1,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
            event_state: 'live',
            market_type_id: liveMarketTypeIds,
        };

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        return socketFilters;
    };

    filters.getVueEuroHomeFilters = function (filters, method, initial) {
        var socketFilters = {
            is_ft: 1,
            // is_ml: 1,
            type: filters.type,
            is_main_le: 1,
            is_main: 1,
            index: 1,
            init: 1,
            event_id: filters.events,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        return socketFilters;

    };
    filters.getSocketKeepAliveFilters = function () {
        // Subscribe with invalid sport ['0'] in order not to get any results
        // used as keep alive subscription in order to not get disconnected from the socket
        var socketFilters = {
            type: "events",
            index: 1,
            init: 1,
            sport_id: ['0'],
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        return socketFilters;

    };
    filters.getEuroHomeFilters = function (filters, method, initial) {

        var unifiedEvents = [];

        if(Config.ACTION == 'search'){
            unifiedEvents = getSearchEvents(filters.searchEvents);
        }else{
            for(var k in filters){
                if(k != 'sport_id' && k != 'events'){
                    unifiedEvents = _.union(unifiedEvents, filters[k].events.map(function(event) {
                        return event.event_id
                    }))
                }
            }
        }


        var socketFilters = {
            is_ft: 1,
            is_ml: 1,
            type: 'odds',
            is_main_le: 1,
            is_main: 1,
            index: 1,
            event_id: unifiedEvents,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        if(filters.eventNode == 'last_minute'){
            socketFilters.event_state = 'early';
        }
        if(filters.eventNode == 'live_betting'){
            socketFilters.event_state = 'live';
        }


        if(filters.hour_range == 'next12'){

            var currentDate = new Date(Number(Config.SERVER_TIME));
            var dateFrom = getDateFormatted(currentDate);
            socketFilters.from = dateFrom;
            currentDate.setHours(currentDate.getHours() + 12 + Number(sportSettings.timeOffset));
            var dateTo = getDateFormatted(currentDate);
            socketFilters.to = dateTo;

        }

        if(filters.sport_id){
            socketFilters.sport_id = filters.sport_id;
        }

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        if(filters.league_id && filters.league_id.length){
            socketFilters.league_id = filters.league_id.slice(0);
        }

        if(filters.events == false){
            delete socketFilters.event_id;
        }else{
            delete socketFilters.league_id;
        }

        return socketFilters;

    };

    filters.getNextRacesFilters = function (filters, method, initial) {

        var eventList = [];

        if(filters.events){
            eventList = filters.events.slice(0);
        }else{
            for(var k in filters){
                eventList = filters[k].events.slice(0);
            }
        }

        var socketFilters = {
            type: 'odds',
            market_type_id: ['81', '137', '365', '367'],
            index: 1,
            event_id: eventList,
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE
        };

        if(filters.sport_id){
            socketFilters.sport_id = filters.sport_id;
        }

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        if(filters.league_id && filters.league_id.length){
            socketFilters.league_id = filters.league_id.slice(0);
        }

        return socketFilters;

    };

    filters.getEuroEventRacingFilters = function (filters, method, initial) {

        var socketFilters = {
            type: 'odds',
            event_id: [filters.event_id],
            odds_format: Config.ODD_FORMAT,
            locale: Config.LOCALE_ALIAS ? Config.LOCALE_ALIAS : Config.LOCALE,
        };

        if(initial || initial === undefined){
            socketFilters.init = 1;
        }

        return socketFilters;

    };

};
; /** ----------------- **/ 
 var TranslationsMap = {
    translatedTitles: function(keyTitle, homeTeam, awayTeam, marketKey, key, currentTitle, sportKey, marketMap){

        //TODO to be refactored

        // Hotfix for sports that do not have home or away
        var sportsWithNoHomeAndAway = ['esports', 'tennis', 'tabletennis', 'snooker', 'darts', 'boxing', 'golf'];

        // Added to prevent missing over/under titles, when we have title with over/under and spread
        var hasOverUnderKeyTitle = /over|under/;
        if(sportsWithNoHomeAndAway.indexOf(sportKey) !== -1 && !hasOverUnderKeyTitle.test(keyTitle) && !marketMap.useHomeAndAway){
            if((keyTitle && keyTitle.indexOf('home') !== -1 && keyTitle.indexOf('away') === -1) || (key && key.indexOf('home') !== -1 && key.indexOf('away') === -1)){
                return homeTeam
            }
            if((keyTitle && keyTitle.indexOf('away') !== -1 && keyTitle.indexOf('home') === -1) || (key && key.indexOf('away') !== -1 && key.indexOf('home') === -1)){
                return awayTeam
            }
        }


        var drawTitle = TRANSLATIONS.MARKETS['draw'] || 'JS.MARKETS.draw',
            tieTitle = TRANSLATIONS.MARKETS['tie'] || 'JS.MARKETS.tie',
            overTitle = TRANSLATIONS.MARKETS['over'] || 'JS.MARKETS.over',
            underTitle = TRANSLATIONS.MARKETS['under'] || 'JS.MARKETS.under',
            overShortTitle = TRANSLATIONS.MARKETS['over_short'] || 'JS.MARKETS.over_short',
            underShortTitle = TRANSLATIONS.MARKETS['under_short'] || 'JS.MARKETS.under_short',
            yesTitle = TRANSLATIONS.MARKETS['yes'] || 'JS.MARKETS.yes',
            noTitle = TRANSLATIONS.MARKETS['no'] || 'JS.MARKETS.no',
            orTitle = TRANSLATIONS.MARKETS['or'] || 'JS.MARKETS.or',
            htTitle = TRANSLATIONS.h_time || 'JS.h_time',
            ftTitle = TRANSLATIONS.MARKETS['ft'] || 'JS.MARKETS.ft',
            homeAwaySign = TRANSLATIONS.MARKETS['home_away_sign'] || 'JS.MARKETS.home_away_sign',
            homeDrawSign = TRANSLATIONS.MARKETS['home_draw_sign'] || 'JS.MARKETS.home_draw_sign',
            drawAwaySign = TRANSLATIONS.MARKETS['draw_away_sign'] || 'JS.MARKETS.draw_away_sign',
            homeTitle = TRANSLATIONS.MARKETS['home_title'] || 'JS.MARKETS.home_title',
            awayTitle = TRANSLATIONS.MARKETS['away_title'] || 'JS.MARKETS.away_title',
            spaceSeparator = ' ',
            dashSeparator = ' - ',
            slashSeparator = ' / ',
            andSeparator = ' & ';

        var homeTitleOrHomeTeam = Config.IS_MOBILE ? homeTitle : homeTeam;
        var awayTitleOrAwayTeam = Config.IS_MOBILE ? awayTitle : awayTeam;
        var digitUnderscoreDigitReplaceSign = {
            totals_by_range: '-'
        }

        var translatedKeysMap = {
            home: homeTeam,
            away: awayTeam,
            draw: drawTitle,
            tie: tieTitle,
            over: overTitle,
            under: underTitle,
            home_team_name: homeTeam,
            away_team_name: awayTeam,
            home_team_name_over: homeTeam + spaceSeparator + overTitle,
            home_team_name_and_over: homeTeam + andSeparator + overTitle,
            home_team_name_under: homeTeam + spaceSeparator + underTitle,
            home_team_name_and_under: homeTeam + andSeparator + underTitle,
            away_team_name_over: awayTeam + spaceSeparator + overTitle,
            away_team_name_and_over: awayTeam + andSeparator + overTitle,
            away_team_name_under: awayTeam + spaceSeparator + underTitle,
            away_team_name_and_under: awayTeam + andSeparator + underTitle,
            home_team_name_yes: homeTeam + spaceSeparator + yesTitle,
            home_team_name_and_yes: homeTeam + andSeparator + yesTitle,
            home_team_name_no: homeTeam + spaceSeparator + noTitle,
            home_team_name_and_no: homeTeam + andSeparator + noTitle,
            away_team_name_yes: awayTeam + spaceSeparator + yesTitle,
            away_team_name_and_yes: awayTeam + andSeparator + yesTitle,
            away_team_name_no: awayTeam + spaceSeparator + noTitle,
            away_team_name_and_no: awayTeam + andSeparator + noTitle,
            home_team_name_home_team_name:  homeTeam + dashSeparator + homeTeam,
            home_team_name_away_team_name: homeTeam + dashSeparator + awayTeam,
            away_team_name_away_team_name: awayTeam + dashSeparator + awayTeam,
            away_team_name_home_team_name: awayTeam + dashSeparator + homeTeam,
            away_team_name_draw: awayTeam + dashSeparator + drawTitle,
            away_team_name_tie: awayTeam + dashSeparator + tieTitle,
            draw_and_over: drawTitle + andSeparator + overTitle,
            draw_and_under: drawTitle + andSeparator + underTitle,
            draw_and_yes: drawTitle + andSeparator + yesTitle,
            draw_and_no: drawTitle + andSeparator + noTitle,
            tie_tie: tieTitle + dashSeparator + tieTitle,
            tie_home_team_name: tieTitle + dashSeparator + homeTeam,
            tie_away_team_name: tieTitle + dashSeparator + awayTeam,
            home_team_name_draw: homeTeam + spaceSeparator + drawTitle,
            home_team_name_tie: homeTeam + dashSeparator + tieTitle,
            home_team_name_or_draw: homeTeam + spaceSeparator + orTitle + spaceSeparator + drawTitle,
            draw_or_away_team_name: drawTitle + spaceSeparator + orTitle + spaceSeparator + awayTeam,
            home_team_name_or_away_team_name: homeTeam + spaceSeparator + orTitle + spaceSeparator + awayTeam,
            yes_and_over: yesTitle + andSeparator + overShortTitle,
            yes_and_under: yesTitle + andSeparator + underShortTitle,
            no_and_over: noTitle + andSeparator + overShortTitle,
            no_and_under: noTitle + andSeparator + underShortTitle,
            home_over: homeTeam + spaceSeparator + overTitle,
            home_under: homeTeam + spaceSeparator + underTitle,
            away_over: awayTeam + spaceSeparator + overTitle,
            away_under: awayTeam + spaceSeparator + underTitle,
            home_home: homeTeam + slashSeparator + homeTeam,
            home_away: homeTeam + slashSeparator + awayTeam,
            away_away: awayTeam + slashSeparator + awayTeam,
            away_home: awayTeam + slashSeparator + homeTeam,
            home_draw: homeTeam + slashSeparator + drawTitle,
            away_draw: awayTeam + slashSeparator + drawTitle,
            draw_home: drawTitle + slashSeparator + homeTeam,
            draw_draw: drawTitle + slashSeparator + drawTitle,
            draw_away: drawTitle + slashSeparator + awayTeam,
            x2: drawAwaySign,
            x2_and_over: drawAwaySign + andSeparator + overShortTitle,
            x2_and_under: drawAwaySign + andSeparator + underShortTitle,
            x2_and_no: drawAwaySign + andSeparator + noTitle,
            x2_and_yes: drawAwaySign + andSeparator + yesTitle,
            ht_home_or_ft_away:  homeTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + awayTeam + spaceSeparator + ftTitle,
            ht_home_or_ft_draw: homeTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + drawTitle + spaceSeparator + ftTitle,
            ht_home_or_ft_home: homeTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + homeTeam + spaceSeparator + ftTitle,
            ht_draw_or_ft_away: drawTitle + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + awayTeam + spaceSeparator + ftTitle,
            ht_draw_or_ft_draw: drawTitle + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + drawTitle + spaceSeparator + ftTitle,
            ht_draw_or_ft_home: drawTitle + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + homeTeam + spaceSeparator + ftTitle,
            ht_away_or_ft_away: awayTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + awayTeam + spaceSeparator + ftTitle,
            ht_away_or_ft_draw: awayTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + drawTitle + spaceSeparator + ftTitle,
            ht_away_or_ft_home: awayTeam + spaceSeparator + htTitle + spaceSeparator + orTitle + spaceSeparator + homeTeam + spaceSeparator + ftTitle,
            '1x': homeDrawSign,
            '12': homeAwaySign,
            '12_and_over': homeAwaySign + andSeparator + overShortTitle,
            '12_and_under': homeAwaySign + andSeparator + underShortTitle,
            '12_and_no': homeAwaySign + andSeparator + noTitle,
            '12_and_yes': homeAwaySign + andSeparator + yesTitle,
            '1x_and_no': homeDrawSign + andSeparator + noTitle,
            '1x_and_yes': homeDrawSign + andSeparator + yesTitle,
            '1x_and_over': homeDrawSign + andSeparator + overShortTitle,
            '1x_and_under': homeDrawSign + andSeparator + underShortTitle,
            homeUnderscoreDigit: homeTitleOrHomeTeam + ' ' + key.replace('home_', '').replace('p', '+'),
            awayUnderscoreDigit: awayTitleOrAwayTeam + ' ' + key.replace('away_', '').replace('p', '+'),
            homeUnderscore: homeTitleOrHomeTeam + ' ' + (TRANSLATIONS.MARKETS[key.replace('home_', '')] || key.replace('home_', '')),
            awayUnderscore: awayTitleOrAwayTeam + ' ' + (TRANSLATIONS.MARKETS[key.replace('away_', '')] || key.replace('away_', '')),
            overUnderscoreDigit: overTitle + ' ' + key.replace('over_', '').replace('p', '+'),
            underUnderscoreDigit: underTitle + ' ' + key.replace('under_', '').replace('p', '+'),
            digitUnderscoreDigit: TRANSLATIONS.MARKETS[key.replace(/_/g, '')] || key.replace(/_/g, digitUnderscoreDigitReplaceSign[marketKey] || ''),
            nOrMore: key.replace('_or_more', ' ' + TRANSLATIONS.MARKETS['or_more']),
            home_team_name_clean: homeTeam + ' ' + TRANSLATIONS.MARKETS['clean'],
            home_team_name_no_clean: homeTeam + ' ' + TRANSLATIONS.MARKETS['no_clean'],
            away_team_name_clean: awayTeam + ' ' + TRANSLATIONS.MARKETS['clean'],
            away_team_name_no_clean: awayTeam + ' ' + TRANSLATIONS.MARKETS['no_clean'],
            first_5_innings: TRANSLATIONS.MARKETS['first_5_innings'] || 'JS.MARKETS.first_5_innings',
            rest_of_game: TRANSLATIONS.MARKETS['rest_of_game'] || 'JS.MARKETS.rest_of_game',
            reg_time: TRANSLATIONS.MARKETS['reg_time'] || 'JS.MARKETS.reg_time',
            overtime: TRANSLATIONS.MARKETS['overtime'] || 'JS.MARKETS.overtime',
            shootout: TRANSLATIONS.MARKETS['shootout'] || 'JS.MARKETS.shootout',
            any_other: TRANSLATIONS.MARKETS['any_other'] || 'JS.MARKETS.any_other',
            nthPeriod: key.replace('_period', ' ') + (TRANSLATIONS.MARKETS['period'] || 'JS.MARKETS.period'),
        };

        var regexPatterns = {
            homeUnderscoreDigit: /^home_\d/,
            awayUnderscoreDigit: /^away_\d/,
            homeUnderscore: /^home_/,
            awayUnderscore: /^away_/,
            overUnderscoreDigit: /^over_\d/,
            underUnderscoreDigit: /^under_\d/,
            digitUnderscoreDigit: /^[0-9]+_[0-9]+$/,
            nOrMore: /\d+_or_more$/,
            nthPeriod: /^\d+(st|nd|rd|th)_period$/,
        };

        if(keyTitle && marketMap.replaceAllTitleKeyMatches) {
            return keyTitle.split('-').map( function(currentKey) {
                if (translatedKeysMap.hasOwnProperty(currentKey)) {
                    return translatedKeysMap[currentKey]
                }
            }).filter(function(k) { return k }).join(' - ')
        }

        if(translatedKeysMap.hasOwnProperty(keyTitle)) {
            return translatedKeysMap[keyTitle];
        } else {
            var title = '';
            var skipMarkets = ['x12orbtsorou', 'x12orbts', 'x12orou', 'btsorou', 'first_colored_ball', 'last_colored_ball', 'method_of_first_basket', 'method_of_last_basket'];
            if(skipMarkets.indexOf(marketKey) != -1) {
                title = TRANSLATIONS.MARKETS[key] || 'JS.MARKETS.' + key;
            } else {
                if (currentTitle) {
                    // there is a title already
                    // first goal method needs a different type of translation
                    if (marketKey == 'f_goal_method' && TRANSLATIONS.MARKETS[key] && !Config.IS_MOBILE) {
                        title = TRANSLATIONS.MARKETS[key];
                    } else {
                        title =  currentTitle;
                    }
                } else {
                    for(var pattern in regexPatterns) {
                        if(pattern == 'digitUnderscoreDigit') {
                            var digitUnderscoreDigit = key.match(regexPatterns[pattern]);
                            if(digitUnderscoreDigit && digitUnderscoreDigit[0] == key){
                                return translatedKeysMap[pattern];
                            }
                        }
                        if(regexPatterns[pattern].test(key)) {
                            return translatedKeysMap[pattern];
                        }
                    }
                    var shortKeys = ['home_sign', 'draw_sign', 'away_sign', 'over_short', 'under_short'];
                    if(shortKeys.indexOf(keyTitle) !== -1){
                        title = TRANSLATIONS.MARKETS[keyTitle] || 'JS.MARKETS.' + keyTitle;
                    } else if (marketMap && marketMap.translationKeySuffix && (!marketMap.translationKeySuffixSkipKeys || (marketMap.translationKeySuffixSkipKeys && marketMap.translationKeySuffixSkipKeys.indexOf(key) === -1))) {
                        title = TRANSLATIONS.MARKETS[keyTitle] || 'JS.MARKETS.' + keyTitle;
                    } else {
                        title = ResultMarketsTitlesMap.getTranslatedMarketKey(sportKey, marketKey, key);
                    }
                }
            }
            return title;
        }
    },
};; /** ----------------- **/ 
 /**
 *
 * TIME WORKER CORE MODULE
 * var exampleTimeWorker = new TimeWorker('1s', function(){ console.log('test'); }); // defines timeHandle for each seccond
 * exampleTimeWorker.start();//start the process
 * exampleTimeWorker.pause();//pause the process
 * exampleTimeWorker.resume();//resume the process
 **/

var TimeWorker = function(expression, callback, beforeCallback, afterCallback)
 {
	 this.expression = expression;
	 this.interval = this.buildTime();

	 this.callback = callback;

	 if(beforeCallback)
	 {
		this.beforeCallback = beforeCallback;
	 }

	 if(afterCallback)
	 {
		this.afterCallback = afterCallback;
	 }
 };

 TimeWorker.prototype.wait 				= false;
 TimeWorker.prototype.inProcess 		= false;
 TimeWorker.prototype.interval 			= 0;
 TimeWorker.prototype.expression 		= false;
 TimeWorker.prototype.timeHandle 		= false;

 TimeWorker.prototype.beforeCallback 	= function(){};
 TimeWorker.prototype.callback 			= function(){};
 TimeWorker.prototype.afterCallback 	= function(){};

 TimeWorker.prototype.start 			= function()
 {

	 if(this.timeHandle)
	 {
		 clearTimeout(this.timeHandle);
	 }

	 if(this.wait)
	 {
		 return false;
	 }

	if(!this.inProcess)
	{
		this.inProcess = true;
		this.beforeCallback();
		this.callback();
		this.afterCallback();
		this.inProcess = false;
		$instance = this;
		this.timeHandle = setTimeout(function(){$instance.start()}, this.interval)
	}
 };

 TimeWorker.prototype.pause = function()
 {
	 this.wait = true;
 };

 TimeWorker.prototype.resume = function()
 {
	if(this.wait)
	{
		this.wait = false;
		this.start();
	}
 };
 // 1y 1m 1w 1d 1h 1i 1s 1u 
 //to be executed after one week one month one week 1 day 1 hour 1 minute 1 second 1 millisecond
 TimeWorker.prototype.exactTime = 
 {
	'u' : function(arg){ return arg; }, // millisecond
	's' : function(arg){ return arg * 1000; }, // second
	'i' : function(arg){ return arg * 60 * 1000; }, // minute
	'h' : function(arg){ return arg * 60 * 60 * 1000; }, // hour
	'd' : function(arg){ return arg * 24 * 60 * 60 * 1000; }, // day
	'w' : function(arg){ return arg * 7 * 24 * 60 * 60 * 1000; }, // week
	'm' : function(arg){ return arg * 4 * 7 * 24 * 60 * 60 * 1000; }, // month
	'y' : function(arg){ return arg * 12 * 4 * 7 * 24 * 60 * 60 * 1000; }// year
};

TimeWorker.prototype.buildTime = function()
{
	expression = this.expression
	time =  0;
	buffer =  '';

	this.expression = this.expression.toString().replace(' ', '');

	for(i in expression)
	{
		if(expression[i] in this.exactTime)
		{
			buffer = this.exactTime[expression[i]](buffer);
			time += Number(buffer)
			buffer = '';
		}
		else if(!isNaN(Number(expression[i])))
		{
			buffer += expression[i]
		}
	}
	return time;
};; /** ----------------- **/ 
 /**
 * Formating methods
 */

function commaDelimiterFormat(number) {
	var hasDot = /\./.test(number);
	if(number && hasDot && BaseConfig.get('IS_BETSLIP_COMMA_VISIBLE')) {
		number = number.toString();
		return number.replace('.', ',');
	}
	return number;
}
function showCurrencyCodeFormat(value, betCurrency, showCurrencyCode) {
	// Check if current bet is made with ROBET currency
	if(!betCurrency && Config.SPORT_WALLET_INFO && Config.SPORT_WALLET_INFO.currency_code){
		betCurrency = Config.SPORT_WALLET_INFO.currency_code;
	}

    if((Config.BETSLIP_SHOW_CURRENCY_SYMBOL || showCurrencyCode) && digitsOnly(value)) {
        return currencyFormat(value, betCurrency);
    }

    return value;
}

function currencyFormat(value, betCurrency) {
	if(value === '' || value === '-' || typeof value === 'undefined') {
		return '-'
	}

	value = /,/.test(value) ? value.replace(',', '.') : value;

	var numberLocale = Config.LOCALE.replace('_', '-');
	var currency = betCurrency ? betCurrency : Config.USER_LOGGED_IN ? Config.CURRENCY_CODE : Config.DEFAULT_CURRENCY_CODE;
	var currencyLocaleMap = {
		GBP: 'en-UK',
		ZAR: 'en-ZA',
		MXN: 'en-US',
	}

	if(currencyLocaleMap[currency]){
		numberLocale = currencyLocaleMap[currency]
	}

	// Sweep Stakes Coins that are not real currencies - skip the rest of the code if we have a match
	var sweepStakeCoins = ['GC','SC','GC2','SC2'];
	var sweepStakeDisplayCurrency = {
		GC: 'GC',
		SC: 'SC',
		GC2: 'GC',
		SC2: 'SC',
	};

	if(sweepStakeCoins.includes(currency)) {
		var formatValue = new Intl.NumberFormat(numberLocale).format(value);
		return formatValue + ' ' + sweepStakeDisplayCurrency[currency];
	}

	var result = value + ' ' + currency;

    try {
        result = new Intl.NumberFormat(numberLocale, {
            style: 'currency',
            currency: currency
        }).format(value);
    } catch(err) {
        console.log('cannot format currency', currency)
    }

	return result
}

function formatWinings(value){
	if((value - Math.round(value)) == 0 && BaseConfig.get('IS_DECIMAL_STAKE_ALLOWED') == '0'){
		value = Math.round(value);
	}
	return value;
}

function truncateDecimals(value, decimals) {
	const parts = value.toString().split(".");
    if (parts.length === 1) return parts[0];
    return Number(parts[0] + "." + (parts[1].substring(0, decimals).padEnd(decimals, "0")));
}

function digitsOnly(value){
    if (typeof value != 'string') {
        value = value.toString()
    }
	return parseInt(value.replace(/[^\d]/g, ''))
}

function formatMoneyInput(money, isFreeBet) {
	money =  /,/.test(money) ? money.replace(',', '.') : money;
	if (Config && BaseConfig.get('IS_DECIMAL_STAKE_ALLOWED') == 1 && money != '' || isFreeBet) {
		return money;
	}

	return parseInt(digitsOnly(money));
}

function findMarket(id){
	var markets_list = getMarketsList();
	var market = "market not found";
	_.each(markets_list, function(value){
		value.id == id ? market = value : "";
	});
	return market;
}

//REMOVE LATER ON
function getRandom(val){
	return Math.round((Math.random()*val) *100)/100;
}


function CALCBETS(forcedOddFormat) {
	if (Config.ODD_FORMAT == 'malay' && typeof forcedOddFormat !== 'string') {
		forcedOddFormat = 'decimal';
	}
	var oddFormat = typeof forcedOddFormat === 'string' ? forcedOddFormat : Config.ODD_FORMAT;
	return {
		fromStake: function(stake, odd, includeStake)
		{
			if(oddFormat == 'american' && odd < 2)
			{
				odd = Math.round(-100 / (odd - (includeStake ? 0 : 1)));
				return parseInt((-100*( stake/(odd)))*100)/100;
			}
			if(oddFormat == 'malay' && odd > 2)
			{
				var malayOdd = Math.round(-1000 / (odd - (includeStake ? 0 : 1))) / 1000;
				if (malayOdd == 0) {
					malayOdd = -0.001;
				}
				return stake / Math.abs(malayOdd);
			}
			return stake*(odd - (includeStake ? 0 : 1));
		},
		fromWin: function(stake, odd)
		{
			// fix for american negative
			if(oddFormat == 'american' && odd < 2)
			{
				odd = Math.round(-100 / (odd - 1));
				return (((odd)/100*-1*stake)*100)/100;
			}
			if(oddFormat == 'malay' && odd > 2)
			{
				var malayOdd = Math.round(-1000 / (odd - 1)) / 1000;
				if (malayOdd == 0) {
					malayOdd = -0.001;
				}
				return stake * Math.abs(malayOdd);
			}
			return stake/(odd-1);
		}
	}
}

function calculateSelectionsStakesAndReturns(selections, stake, stakeType) {
	var calculatedSelectionsStakesAndReturns = [];

	var getStake = function(index) {
		if(index > 0 && stakeType === 'multiply') {
			return calculatedSelectionsStakesAndReturns[index - 1].potential_returns;
		}

		return stake;
	}

	var getSelectionOdd = function(index) {
		var selectionOdd = selections[index].single_odd;
		var selectionOddDecimal = selections[index].single_odd_decimal;
		if (Config.ODD_FORMAT === 'fractional') {
			selectionOddDecimal = window.oddsConvert.convert(Config.ODD_FORMAT, 'decimal', selectionOdd, 2);
		}
		return selectionOddDecimal;
	}

	var calculatePotentialReturns = function(index) {
		return window.CALCBETS().fromStake(getStake(index), getSelectionOdd(index), true);
	}

	var calculatePotentialWin = function(index) {
		return window.CALCBETS().fromStake(getStake(index), getSelectionOdd(index), false);
	}

	if(stake) {
		for(var i = 0; i < selections.length; i++) {
			calculatedSelectionsStakesAndReturns.push({
				id: selections[i].id,
				stake: getStake(i),
				potential_win: calculatePotentialWin(i).toString(),
				potential_returns: calculatePotentialReturns(i).toString(),
			});
		}
	}

	return calculatedSelectionsStakesAndReturns;
}; /** ----------------- **/ 
 		/**
		 * CHRON
		 */

		var Chron = (function(){
			var instance;

			function initialize(){
				var clock;

				clock = new TimeWorker('1s', timeIsUp);
				clock.start();

				function timeIsUp(){
					Mediator.getMediator().trigger("Chron_onTime");
				}

			}
			return {
				getChron: function(){
					if(!instance){
						instance = initialize();
					}
					return instance;
				}
			}
		}());; /** ----------------- **/ 
 /**
		 * Dispatcher - controls comunication with the server via AJAX calls
		 *
		 * Dispatcher event list
		 * Listen for:
		 * Dispatcher_requestData - use it to request data from the server.
		 * 	Example : obj.trigger("Dispatcher_requestData", method, filters);
		 * 		@method string required - the name of the operation you are looking
		 * 		@filters object optional - any key:value parameters/filters that need be sent to the server
		 *
		 * Triggers:
		 * Dispatcher_returnData - listen for this event after data request. NOTE: Triggers the event for the object that have
		 * requested the data only.
		 * 	Example: obj.on("Dispatcher_returnData", obj.handleData);
		 * 		Returns the data as second parameter in object fromat
		 * 		handleData(caller, data){
		 * 			//do something with the data
		 * 		}
		 * 	NOTE: Will return false as data if no method is supplyed with Dispatcher_requestData
		 *
		 * Dispatcher_returnError - listen for this event to catch any errors with the data requested. NOTE: Triggers the event for the object that have
		 * requested the data only.
		 * 		Returns reason for the error as second parameter
		 * 		onError(caller, reason){
		 * 			alert(reason);
		 * 		}
		 */
		var Dispatcher = (
			function()
			{
				var instance;

				function addBaseUrlPrefixToRequestUrl(url)
				{
                    if(typeof window.BaseConfig === 'undefined') {
                        return url
                    }
                    var IS_SERVED_FROM_APPLICATION_PREFIX = Boolean(window.BaseConfig.get('APPLICATION_PREFIX'));

                    var basePrefix = '/' + window.BaseConfig.get('APPLICATION_PREFIX'),
                        normalizedUrl;

                    if(!IS_SERVED_FROM_APPLICATION_PREFIX || typeof url !== 'string')
                    {
                        return url;
                    }

                    if(url.indexOf('://') > -1 || url.indexOf('//') === 0 || url.indexOf(basePrefix) === 0)
                    {
                        return url;
                    }

					normalizedUrl = url.charAt(0) === '/' ? url : '/' + url;
					return basePrefix + normalizedUrl;
				}

				function initialize()
				{
					$this = {
						requestData: function(caller, method, filters, url)
						{
							var $this = this;

							//Check if Operation is defined
							if(!method)
							{
								trace("Unable to send AJAX Request. Operation is missing!")
								return caller.trigger('Dispatcher_returnData', false);
							}

							//Do some request with ajax or any other method
							//TODO: Make the light ajaxRequest version
							var filters = filters || {};
							var ajax_data = $.extend({}, filters, {'method': method});

							var ajaxDataParams = {};

							var paramsForUrl = {
//								'method': 1,
								'sport_id': 1,
								'asian_selection': 1,
								'hour_range': 1,
								'time_range': 1,
								'search': 1,
								'event_id': 1,
								'selection': 1,
								'league_id': 1,
                                'activate_coupon': 1,
							};

							for (var field in ajax_data)
							{
								if ((typeof field === 'string') && paramsForUrl[field])
								{
									ajaxDataParams[field] = ajax_data[field];
								}
								else if (field === 'viewParams')
								{
									for (var innerField in ajax_data[field])
									{
										if ((typeof innerField === 'string') && paramsForUrl[innerField])
										{
											ajaxDataParams[innerField] = ajax_data[field][innerField];
										}
									}
								}
							}

							var ajaxDataParamsEncoded = decodeURIComponent($.param( ajaxDataParams ));

							// console.warn(ajax_data);
							// console.info(ajaxDataParamsEncoded);
							//Send AJAX request
							$.ajax(
								{
									dataType: 'json',
									type: 'POST',
									url: addBaseUrlPrefixToRequestUrl(url || (Config.AJAX_URL + '/' + method)) + (ajaxDataParamsEncoded ? ('?' + ajaxDataParamsEncoded) : ''),
									async: true,
									data: ajax_data,
									complete: function(response, status)
									{
										var serverTime = response ? response.getResponseHeader('X-Response-Server-Time') : null;

										if (serverTime != null)
										{
											// we have the server time
											caller.trigger("Server_time", serverTime);
										}

										//if request have passed
										if(status == 'success')
										{
											var callback = false;

											//try to parse the respose to object
											try
											{
												if(response.responseText != '')
												{
													//process the JSON returned from the server
													callback = $.parseJSON(response.responseText);

													if(callback.status == "refresh"){
														window.location.reload();
													}
												}
											}
											//throw error that response is somehow malformed
											catch(e)
											{
												$this.returnError(caller, "Data returned from the server is not JSON or malformed!");
											}

											$this.returnData(caller, callback, method);
										}
										//else throw error for ajax failure
										else
										{
											$this.returnError(caller, "Something went wrong with the AJAX! Error: " + status, method);
										}

										$this.returnRequestComplete(caller, response, status, method);
									}
								}
							);


							//$this.returnData(caller, "some data");


						},
						//Shortcut function for throwing Dispatcher_returnData
						returnData: function(caller, data, method){
							//trace("trigger return data");
							caller.trigger("Dispatcher_returnData_" + method, data);
						},
						//Shortcut function for throwing Dispatcher_returnError
						returnError: function(caller, reason, method){
							caller.trigger("Dispatcher_returnError_" + method, reason);
						},
						returnRequestComplete: function(caller, response, status, method){
							caller.trigger("Dispatcher_returnRequestComplete_" + method, status, response);
						}
					}

					//add mediator events to the Dispatcher
					Mediator.getMediator().installTo($this);
					//add listener for Dispatcher_requestData
					$this.on("Dispatcher_requestData", $this.requestData);
				}

				//Public
				return {
					//Creates or returns instance of the Dispatcher
					getDispatcher: function(){
						if(!instance){
							instance = initialize();
						}
						return instance;
					}
				}
			}()
		);
; /** ----------------- **/ 
 /**
* Request Collector
*/
var RequestCollector = (function(){
			var instance;

			function initialize()
			{
				var requestList = {};
				var passiveList = {};


				Mediator.getMediator().on("Chron_onTime", processRequests);


				function processRequests(){
					//trace("process requests ");
					_.each(getActiveRequests(), function(value, key){
						if(value.intervalLeft() == 0){

							value.executeRequest();

							if(!value.isRepeatable())
							{
								passiveList[key] = value;
								delete requestList[key];
							}
						}
						else
						{
							value.updateTempInterval(value.intervalLeft() - 1);
						}

						value.notify();
					});
				}

				function getActiveRequests(){
					var list = {};
					_.each(requestList, function(value, key){
						if(value.getStatus() == "active"){
							list[key] = value;
						}
						else if(value.getStatus() == "destroy"){
							delete requestList[key];
						}
					});
					return list;
				}


				var request = function(args){
					var defaults = {
						name			: "",
						caller 			: false,
						method 			: false,
						filters			: {},
						interval		: 0,
						repeat			: false,
						callback		: false,
						notifyOnTimeTick: false,
						status			: "active",
						resetOnResponse	: true,
						persistent		: true,
						beforeExecute   : '',
						is_private		: true,
						error_handler	: false,
						url				: false
					};

					var settings = _.extend(defaults, args);

					if(!settings.caller){
						trace("Caller need to be defined");
						return false;
					}
					if(!settings.method){
						trace("Method need to be defined");
						return false;
					}

					if(!settings.callback && typeof callback != "function"){
						trace("Callback is not defined or function!");
						// it should let the request pass even without a callback
						// return false;
					}

					settings.id = _.uniqueId("request_");
					settings.temp = settings.interval;
					//settings.caller.on("Dispatcher_returnData_" + settings.method, settings.callback, settings.is_private);
					//settings.caller.on("Dispatcher_returnError_" + settings.method, settings.error_handler, settings.is_private);



					var $this =
					{
							getInterval: function(){
								return settings.interval;
							},
							setInterval: function(interval){
								settings.interval = interval;
							},
							//resets the temporary interval to general
							resetInterval: function(){
								settings.temp = settings.interval;
							},
							//return the temporary interval state
							intervalLeft: function(){
								return settings.temp;
							},
							//update temporary interval after change
							updateTempInterval: function(temp){
								settings.temp = temp;
							},
							//returns if the request is repeatable
							isRepeatable: function(){
								return settings.repeat;
							},
							getFilters: function(){
								return settings.filters;
							},
							//update request filters
							updateFilters: function(filters){
								settings.filters = filters;
							},
							//execute the request
							executeRequest: function()
							{
								this.beforeExecute();
								var filters;
								if(typeof settings.filters == 'function')
								{
									//trace("execute function for filters");
									filters = settings.filters();
									//trace(filters);
								}
								else
								{
									//trace("use filters as they are");
									filters = settings.filters;
								}

								if(settings.oddsService === 'push')
								{
									console.warn('PushSocket is deprecated; falling back to HTTP polling for', settings.method);
								}

								this.trigger("Dispatcher_requestData",
										settings.method,
										filters,
										settings.url);

								if(settings.resetOnResponse)
								{
									this.stop();
									this.trigger("Request_onExecute");
								}
								else
								{
									this.resetInterval();
								}
							},
							successHandler: function(caller, data)
							{
								if(settings.callback){
                                    settings.callback.apply(settings.caller, [caller, data]);
                                }
							},
							errorHandler: function(caller, data){
								if(typeof settings.error_handler == 'function'){
									settings.error_handler.apply(settings.caller, [caller, data]);
								}
								else
								{
									var name = settings.name == "" ? settings.caller.viewName : settings.name;

									trace(name, ": Something went wrong with the request!");
									trace("ErrorData: ", data);
								}

								if(!settings.persistent){
									this.stop();
								}
							},
							completeHandler: function(caller, status, response)
							{
								if(status == "success" || settings.persistent)
								{
									this.start();
								}
								this.trigger("Request_onComplete");
							},
							getId: function(){
								return settings.id;
							},
							notify: function(){
								if(typeof settings.notifyOnTimeTick == 'function'){
									settings.notifyOnTimeTick(settings.caller);
								}
							},
							getSettings: function(){
								return settings;
							},
							stop: function(){
								settings.status = "stop";
							},
							pause: function(){
								settings.status = "pause";
							},
							start: function(){
								if(settings.status == "stop"){
									this.resetInterval();
								}
								if(settings.status != 'inactive'){
                                    settings.status = "active";
                                }
							},
							getStatus: function(){
								return settings.status;
							},
							beforeExecute: function(){
								if(typeof settings.beforeExecute == 'function'){
									return settings.beforeExecute(this);
								}
								return true;
							},
							destroy: function(){
								this.off();
								this.stop();
								settings.status = "destroy";
								return false;
							}
					};

					Mediator.getMediator().installTo($this);

					$this.on("Dispatcher_returnData_" + settings.method, $this.successHandler, settings.is_private);
					$this.on("Dispatcher_returnError_" + settings.method, $this.errorHandler, settings.is_private);
					$this.on("Dispatcher_returnRequestComplete_" + settings.method, $this.completeHandler, settings.is_private);

					return $this;
				};

				return {
					addRequest: function(settings){
						var req = request(settings);
						if(req){
							requestList[req.getId()] = req;
						}
						return req;
					},
					removeRequest: function(request){
						if(request){
							delete requestList[request.getId()];
						}
					},
					getList: function(){
						return requestList;
					},
					getPassive: function(){
						return passiveList;
					}
				}
			}

			return {
				getCollector: function(){
					if(!instance){
						instance = initialize();
					}
					return instance;
				}
			}
		}());; /** ----------------- **/ 
 /**
 * Common before initialize model behaviours. Same as behaviours but called before beforeInitialize method of view
 *
 */


function getBeforeInitializeBehaviours() {
    return {

        asiaMarketDataFormat: {
            asiaMarketDataFormatterMap: {
                winning_margin: 'asiaWinningMarginMarket'
            },
            asiaMarketDataFormat: function() {
                var marketKey = this.model.get("market_key") ? this.model.get("market_key") : this.model.parent.get("market_key");

                if(typeof this.asiaMarketDataFormatterMap[marketKey] !== 'undefined') {
                    var marketDataHandler = this.asiaMarketDataFormatterMap[marketKey];
                    this[marketDataHandler]();
                }
            },
            asiaWinningMarginMarket: function() {
                var sortedSelections = this.getSortedAsiaWinningMarginSelections(),
                    allKeys = this.getAsiaWinningMarginKeys(sortedSelections),
                    linesLength = Math.max(allKeys.home.length, allKeys.draw.length, allKeys.away.length),
                    allTitles = this.getAsiaWinningMarginTitles(sortedSelections);

                for(var k in allKeys){
                    for (var i = linesLength - allKeys[k].length; (i <  linesLength && i != 0); i--){
                        allKeys[k].push('');
                    }
                }

                this.model.set({
                    linesLength: linesLength,
                    allKeys: allKeys,
                    allTitles: allTitles
                });
            },
            getSortedAsiaWinningMarginSelections: function() {
                var selections = [];

                for (var selection in this.model.attributes) {
                    if (this.model.attributes[selection].id) {
                        var selectionData = {
                            key: selection,
                            odd: this.model.attributes[selection]['non'],
                        };
                        selections.push(selectionData);
                    }
                }

                return selections;
            },
            getAsiaWinningMarginKeys: function(sortedSelections) {
                var allKeys = {
                    home: [],
                    draw: [],
                    away: []
                };

                _.each(sortedSelections, function(selection){
                    if(selection.key.indexOf('home') !== -1) {
                        allKeys.home.push(selection.key);
                    } else if(selection.key.indexOf('draw') !== -1) {
                        allKeys.draw.push(selection.key);
                    } else if(selection.key.indexOf('away') !== -1) {
                        allKeys.away.push(selection.key);
                    }
                });

                allKeys['draw'].reverse();

                return allKeys;
            },
            getAsiaWinningMarginTitles: function(selections) {
                var $this = this,
                    allTitles = {};

                _.each(selections, function(selection){
                    allTitles[selection.key] = $this.getAsiaMarketTitle(selection.key);
                });

                return allTitles;
            },
            getAsiaMarketTitle: function(key) {
                var title = '';

                if (/^home_\d/.test(key)) {
                    title = TRANSLATIONS.MARKETS['home'] + ' ' + key.replace('home_', '').replace('p', '+');
                } else if (/^away_\d/.test(key)) {
                    title = TRANSLATIONS.MARKETS['away'] + ' ' + key.replace('away_', '').replace('p', '+');
                } else {
                    title = TRANSLATIONS.MARKETS[key] || key;
                }

                return title;
            }
        },
        asianGetLeagueIndex: {
            getLeagueIndex: function(leagueModel){
                var sportModels = leagueModel.getParent('GameMode').childList.models,
                    sportIndex = _.findIndex(sportModels, function(model) {
                        return model.id === leagueModel.get('sport_key')
                    }, this);

                var previousSportLeaguesCount = 0;
                for(var i = 0; i < sportIndex; i++){
                    previousSportLeaguesCount += sportModels[i].childList.length;
                }

                var currentSportModels = leagueModel.getParent('Sport').childList.models,
                    currentSportLeagueIndex = _.findIndex(currentSportModels, function(model) {
                        return model.id === leagueModel.id
                    }, this);

                var leagueIndex = previousSportLeaguesCount + currentSportLeagueIndex;

                return leagueIndex;
            },
            getLeagueByIndex: function(model, leagueIndex){
                var sportModels = model.getParent('GameMode').childList.models;
                var matchedLeague = null;
                var currentLeagueIndex = 0;
                for(var i = 0; i < sportModels.length; i++){
                    currentLeagueIndex += sportModels[i].childList.length;
                    if(currentLeagueIndex < leagueIndex){
                        continue
                    }else{
                        var indexTracker = leagueIndex - (currentLeagueIndex - sportModels[i].childList.length);
                        matchedLeague = sportModels[i].childList.models[indexTracker];
                        break;
                    }
                }

                return matchedLeague;

            }
        },
        currencyFullTitle:{
            getCurrencyTitle: function(currencyCode){
                var currencyTitle = currencyCode;
                if(TRANSLATIONS.WALLET && TRANSLATIONS.WALLET[currencyCode + '_title']){
                    currencyTitle = TRANSLATIONS.WALLET[currencyCode + '_title']
                }
                return currencyTitle;
            }
        },
    }
}
; /** ----------------- **/ 
 /**
 * Common initialize model behaviours. Used for comparators
 *
 */

function getModelInitializeBehaviours() {
    return {

        orderComparator: {
            orderComparator: function(){
                this.childList.comparator = function(child) {
                    return Number(child.get('order'));
                };
            },
        },
        reverseOrderComparator: {
            reverseOrderComparator: function(){
                this.childList.comparator = function (a, b) {
                    if (a.get('order') > b.get('order')) {
                        return -1;
                    }

                    if (b.get('order') > a.get('order')) {
                        return 1;
                    }

                    return b.childList.length > a.childList.length ? 1 : -1;
                };
            }
        },
        orderByTitle: {
            orderByTitle: function (){
                this.childList.comparator = function (a, b) {
                    var aName = a.get("title"),
                        bName = b.get("title");

                    if(aName < bName) {
                        return -1
                    }
                    if(aName > bName) {
                        return 1;
                    }

                    return 0;
                };
            }
        }
    }
}; /** ----------------- **/ 
 /**
 * Behaviours are common functionality that can be shared in multiple views
 * It is applyed to the view before the specific implementation so they can be overwriten there
 * Any given view can have multiple Behaviours applyed. The will be added in order of appearance in the
 * behaviour array so the later ones will overwrite the former
 *
 * Bahaviour can have a method called exactly as the bahaviour and this method will be executed
 * before "afterInitilize" method is called in the view
 *
 *
 * fix: 1.01
 */


function getBehaviours() {
    return {

        /**
         * Common behaviour for all euro odds
         */
        "euroOdd": {
            euroOdd: function () {
                this.on("BetSlip_oddRemoved", this.checkForRemove);
                this.on("BetSlip_oddAdded", this.checkForAdd);

                this.pushEvents({
                    "click": "clicked"
                });

                this.model.status = 0;
                this.timers = {};

                //select the odd if in the betslip already
                var initBets = typeof window["getBetSlipData"] == 'function' ? window["getBetSlipData"]() : {};
                if (initBets.odds[this.model.id]) {
                    this.checkForAdd(this, {"oddID": this.model.id});
                }

                this.checkIsBetAllowed();

                if (Config.ODD_FORMAT == 'malay') {
                    if (Number(this.model.get('display_odd')) < 0) {
                        this.$el.parent().find('.odd').addClass('negative-color-odd');
                    } else {
                        this.$el.parent().find('.odd').removeClass('negative-color-odd');
                    }
                }


            },
            clicked: function (e) {
                e.stopPropagation();
                if (this.model.status == 0 && this.model.get("display_odd") != '') {
                    this.checkForAdd(this, {"oddID": this.model.id});
                    if (this.model.get("is_bet_allowed") == 1) {
                        var data = {"action": "add", "oddID": this.model.id, "oddValue": this.model.get("display_odd")};
                        var ccu = this.model.getParent("CCU");
                        if (ccu && ccu.view && ccu.view.filters && ccu.view.filters.viewParams && ccu.view.filters.viewParams.teaser_id) {
                            data['teaser_id'] = ccu.view.filters.viewParams.teaser_id;
                        }
                        if (this.model.get("line_data")) {
                            data["lineData"] = this.model.get("line_data");
                        }
                        this.sendSelectionToParent();
                        this.trigger("BetSlip_addOdd", data);
                    }
                }
                else {
                    this.trigger("BetSlip_removeOdd", {"action": "remove", "oddID": this.model.id});
                }
            },
            sendSelectionToParent: function () {
                if(!Config.PLUGIN_MODE) {
                    return;
                }

                var message = {
                    type: 'ADD_SELECTION',
                    payload: {
                        userLogged: !!Config.USER_LOGGED_IN,
                        selection: {
                            odd: this.model.get("odd"),
                            id: this.model.get("id"),
                            key: this.model.get("key"),
                        }
                    },
                };

                if (window.WebPage) {
                    window.WebPage.sendMessage(message);
                }
            },
            evaluateOdd: function (value, prev_value, element, key, $this) {

                if ($this.model.get("is_bet_allowed") == 1) {

                    if (!element.hasClass('odd-holder')) {
                        element = element.find('.odd-holder');
                    }

                    element.removeClass("up").removeClass("down");

                    if(value && prev_value){
                        if (prev_value < value) {
                            element.addClass("up");
                        }
                        else if (prev_value > value) {
                            element.addClass("down");
                        }
                        if ($this.timers[key]) {
                            $this.timers[key].time = 7;
                        }
                        else {
                            $this.timers[key] = {
                                "time": 7,
                                "arguments": [element],
                                "callback": function (target) {
                                    target.removeClass("up").removeClass("down");
                                }
                            }
                            $this.controlChron("start");
                        }
                    }

                }
                if (Config.ODD_FORMAT == 'malay') {
                    if (Number($this.model.get('display_odd')) < 0) {
                        $this.$el.parent().find('.odd').addClass('negative-color-odd');
                    } else {
                        $this.$el.parent().find('.odd').removeClass('negative-color-odd');
                    }
                }
            },
            addToDom: function () {
                this.renderOdd();
            },
            moveEl: function () {
                this.renderOdd();
            },
            renderOdd: function () {
                var target = $(this.targetEl).find(".pos-" + this.model.get("key")),
                    elem = this.render().$el;

                //TODO check what is strictPosition
                if (target.length && !this.strictPosition) {
                    target.html(elem);
                } else if (this.strictPosition) {
                    $(this.targetEl).append(elem);
                }

                var spreadTarget = $(this.targetEl).find(".spread-" + this.model.get("key"));
                if (spreadTarget.length && !this.strictPosition) {
                    target.text(this.model.get('spread'));
                }
            },
            isBetAllowedOnChange: function (value, prev_value, element, key, $this) {
                $this.checkIsBetAllowed();
            },
            checkIsBetAllowed: function(){
                if(this.model.get('is_bet_allowed')){
                    this.$el.removeClass('bet-disabled')
                }else{
                    this.$el.addClass('bet-disabled')
                }
            },
            checkForRemove: function (caller, data) {
                if (this.model.id == data.oddID || data.oddID == -1) {
                    this.model.status = 0;
                    if (this.$el.hasClass('odd-holder')) {
                        this.$el.removeClass("selected");
                    } else {
                        this.$el.find(".odd-holder").removeClass("selected");
                    }
                }
            },
            checkForAdd: function (caller, data) {
                if (this.model.id == data.oddID) {
                    this.model.status = 1;
                    if (this.$el.hasClass('odd-holder')) {
                        if(Config.LAST_VIEW === 'asian'){
                            this.$el.closest(".market-holder").find(".odd-holder").removeClass("selected");
                        }
                        this.$el.addClass("selected");
                    } else {
                        this.$el.find(".odd-holder").addClass("selected");
                    }
                }
            },
            createComponents: function () {
                this.pushComponents({
                    'odd': {"elem": this.$el, "action": this.evaluateOdd},
                    is_bet_allowed: {
                        callback: this.isBetAllowedOnChange
                    }
                });

            },
            updateOdd: function (value, prev_value, element, key, $this) {
                if ($this.model.get("is_bet_allowed") == 1) {
                    element.text(value);
                }
            },
            /**
             * Trigger specific error for all parent models views
             */
            onBetSlipActionError: function (caller, data) {
                if (data.id == this.model.id) {
                    var action = typeof data.action !== "undefined" ? data.action : "default";
                    var parents = this.model.getParents();
                    _.each(parents, function (model, k) {
                        delete parents[k];
                        model.view.trigger("OddError_BetSlipError_" + action);
                    });
                }
            }
        },
        /**
         * Small behaviour allowing reordering of element based on order parameter
         * after new elements are inserted
         */
        "childReorder": {
            childReorder: function () {
                this.reorderOnAdd = true;
                this.pushComponents({
                    order: {
                        callback: this.changeViewOrder
                    }
                });
            },
            reorderChilds: function () {
                this.model.childList.each(function (value) {
                    if (!value.view) {
                        return;
                    }
                    if (value.view.moveEl) {
                        value.view.moveEl();
                    } else {
                        if (typeof value.view.targetEl === "string") {
                            $(value.view.targetEl).append(value.view.$el);
                        } else {
                            value.view.targetEl.append(value.view.$el);
                        }
                    }
                });
            },
            changeViewOrder: function(value, prev_value, element, key, $this){
                if($this.model.parent && $this.model.parent.view && $this.model.parent.view.reorderChilds){
                    $this.model.parent.childList.sort();
                    $this.model.parent.view.reorderChilds();
                }
            }
        },
        /**
         * Helper for updating content
         */
        "pageUpdateHelper":
            {
                updateContent: function (caller, data) {
                    if (data.status == "success") {
                        var start = new Date().getTime();
                        this.model.getParent("CCU").content(data.data);
                        this.afterUpdate();

                    }
                },
                generateFilters: function () {
                    this.filters.containers = JSON.stringify(this.recurseKids(this.model.getParent("CCU").childList));
                    return this.filters;
                },
                recurseKids: function (kids) { // add updatable stuff
                    var view = this;
                    var content = {};

                    kids.each(function (value) {

                        if (value.childList.length > 0) {
                            content[value.id] = view.recurseKids(value.childList);
                        }
                        else {
                            content[value.id] = '';
                        }
                    });

                    return content;
                },
                afterUpdate: function () {
                }
            },

        /**
         *
         */
        "forceRefreshHelper":
            {
                forceRefreshHelper: function () {
                    this.pushEvents({
                        "click .btnRefresh": "forceUpdate"
                    });
                    this.refreshButton = this.$el.find(".btnRefresh .count");
                },
                forceUpdate: function () {
                    if (this.updater) {
                        this.updater.executeRequest();
                        this.updater.resetInterval();
                        this.updateTimer(this);
                    }
                },
                updateTimer: function (caller) {
                    caller.refreshButton.text(caller.updater.intervalLeft());
                },
            },


        /**
         * A helper to handle a collection of checkboxes
         */
        "checkboxContainer":
            {
                sendTimeHandler: false,
                sendTimeout: 1000,
                checkboxModelName: false,
                assureConsistentAllCheck: function () {
                    var all = this.findAllCheck();

                    if (!all) {
                        return;
                    }

                    var $this = this;

                    var counts = this.model.childList.countBy(function (model) {
                        return model.get("is_active") === 1 && (!$this.checkboxModelName || $this.checkboxModelName === model.modelName);
                    });
                    var checksCounts = this.model.childList.countBy(function (model) {
                        return !$this.checkboxModelName || $this.checkboxModelName === model.modelName;
                    });

                    // remove the counts of the things that are not checks
                    counts["false"] = (counts["false"] ? counts["false"] : 0) - (checksCounts["false"] ? checksCounts["false"] : 0);

                    counts[all.get("is_active") ? "true" : "false"] = counts[all.get("is_active") ? "true" : "false"] - 1;

                    all.set("is_active", counts["false"] ? 0 : 1);


                    //TODO Check Logic because of numeric calls
                    $(all.view.$el).find("input[type='checkbox']").prop("checked", all.get("is_active"));
                },
                findAllCheck: function () {
                    return this.model.childList.findWhere({"key": "all"});
                },
                send: function () {
                },
                sendWithTimeHandler: function () {
                    var $this = this;

                    if (typeof $this.sendTimeHandler !== "undefined" && $this.sendTimeHandler) {
                        clearTimeout($this.sendTimeHandler);
                    }

                    $this.sendTimeHandler = setTimeout(function () {
                        $this.send();
                    }, $this.sendTimeout);
                },
                toggleCheckbox: function (model) {
                    if (model === this.findAllCheck()) {
                        this.toggleAll(model);
                    }
                    else {
                        this.toggleOne(model);
                    }
                },
                toggleAll: function (model) {
                    var value = model.get("is_active") ? 0 : 1;
                    var checkedEl = model.id;

                    var $this = this;

                    this.model.childList.each(function (check) {
                        if (!$this.checkboxModelName || $this.checkboxModelName === check.modelName) {
                            check.set("is_active", value);

                            if (checkedEl != check.id) {
                                $(check.view.$el).find("input[type='checkbox']").prop("checked", value);
                            }
                        }
                    });
                    this.afterToggle();
                },
                toggleOne: function (model) {
                    model.set("is_active", model.get("is_active") ? 0 : 1);

                    this.assureConsistentAllCheck();
                    this.afterToggle();
                },
                afterToggle: function () {
                    this.sendWithTimeHandler();
                }
            },

        /**
         * A helper to handle a collection of checkboxes
         */
        "checkboxDropdown": {
            handleCheckboxDropdownClick: function (e) {
                $(e.target).find("label").click();
            }
        },


        /**
         * Lazy Scrolling
         */
        lazyScroll:
            {
                lazyScroll: function () {
                    this.attachScrollEvent();
                },
                attachScrollEvent: function () {
                    var offsetElement = '#footer';
                    var view = this;
                    var $win = $(this.targetEl).closest('.scrollable-box');
                    $win.on('scroll', _.throttle(function () {
                        view.onScroll($win, offsetElement);
                    }, 50));
                },

                show: function (count) {
                    this.$el.find('.' + this.lazyShowElement + ':lt(' + count + ')').removeClass('d-none');
                },
                onScroll: function ($container, offsetElement) {

                    if (!this.lazyShowElement) {
                        return;
                    }

                    var offsetHeight = 0;
                    if (offsetElement && $(offsetElement).length) {
                        offsetHeight = $(offsetElement).outerHeight();
                    }

                    var isDown = false;
                    if ($container[0].scrollHeight - $container.scrollTop() <= $container.outerHeight() + offsetHeight) {
                        isDown = true;
                    }

                    if (isDown && this.lazyShowElement) {
                        var dataIncrement = 2,
                            $matchingElements = $container.find('.' + this.lazyShowElement + '.d-none' + ':lt(' + dataIncrement + ')');
                        $matchingElements.removeClass('d-none');
                    }

                }
            },
        euroStatistic: {
            euroStatistic: function () {
                this.pushEvents({
                    "click .open-statistics": "openStatisticsWindow"
                });
                this.pushComponents({
                    statistic: {
                        callback: this.updateStatisticsHref
                    }
                });

                if (this.model.get('statistic')) {
                    this.setStatisticsHref();
                }
            },
            updateStatisticsHref: function (value, prev_value, element, key, $this) {
                if (value) {
                    $this.setStatisticsHref();
                } else {
                    $this.$el.find('.open-statistics').addClass('disabled');
                }
            },
            setStatisticsHref: function () {
                if (window.BaseConfig.get('CONFIGURE_STATISTIC_URL')) {
                    var $openStatistics = this.$el.find('.open-statistics');
                    $openStatistics.removeClass('disabled');
                    var locale = Config.LOCALE_SHORT_ALIAS !== '' ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT;

                    if ($('#appComponents')[0]) {
                        var getStatisticsAllowedLanguages = $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store.getters['application/getStatisticsAllowedLanguages'];

                        locale = getStatisticsAllowedLanguages[locale] ? getStatisticsAllowedLanguages[locale] : 'en'
                    } else {
                        locale = 'en'
                    }

                    var statisticsHref = window.BaseConfig.get('CONFIGURE_STATISTIC_URL') + '/' + locale + '/event/' + this.model.get('sport_key') + '/' + this.model.get('statistic') + '/h2h';
                    this.model.set('statisticsHref', statisticsHref);
                    var vsTitle = TRANSLATIONS.vs ? TRANSLATIONS.vs : 'JS.vs';
                    var webviewModalExternalTitle = this.model.get('home_team') + ' ' + vsTitle + ' ' + this.model.get('away_team');
                        $openStatistics.attr({
                        href: statisticsHref,
                        'webview-modal-external-title': webviewModalExternalTitle
                    });
                }
            },
            openStatisticsWindow: function (e) {
                if(window.getBodyClassList().contains('webview')){
                    return;
                }
                e.preventDefault();
                if(!this.model.get('statistic')){
                    return;
                }
                window.VueEventBus.$emit('open-statistics-modal', this.model.get('statisticsHref'));
            }
        },

        'liveScores': {
            liveScores: function () {
                this.pushComponents({
                    live_scores: {
                        callback: this.changeLiveScore
                    },
                    points: {
                        callback: this.updatePoints
                    }
                });

                if (this.model.get("live_scores")) {
                    this.parseLiveScores(this.model.get("live_scores"));
                }
                this.on('LiveSocket_tennisPoints' + this.model.get('tracker_id'), this.updateLiveScorePoints);
            },
            changeLiveScore: function (value, prev_value, element, key, $this) {
                $this.parseLiveScores(value);
            },
            updateLiveScorePoints: function(caller, data){
                var points = data._home + ':' + data._away;
                this.model.set('points', points)
            },
            updatePoints: function(value, prev_value, element, key, $this){
                $this.parseLiveScores($this.model.get('live_scores'))
            },
            parseLiveScores: function (liveScores) {
                if (!liveScores || typeof liveScores !== 'string') {
                    this.displayLiveScores();
                    return;
                }

                liveScores = liveScores.split(',');

                var currentSet = Number(String(this.model.get('live_game_period')).replace(/\D/, ''));
                var liveScoresHtml = '';
                var displayShortResult = this.model.get('displayShortResult');
                var shortResultKey = LiveScoresMap.sports[this.model.get('sport_key')].ftKey;
                var shortResultKeyIndex = undefined;
                var hasCyberLeagueFormatRegexExp = /cyber/;
                var leagueFormat = this.model.get('league_format') && !hasCyberLeagueFormatRegexExp.test(this.model.get('league_format')) ? this.model.get('league_format') : 'default';
                var hasLegs = LiveScoresMap.sports[this.model.get('sport_key')].hasLegs;
                if(shortResultKey && displayShortResult){
                    shortResultKeyIndex = Object.keys(LiveScoresMap.sports[this.model.get('sport_key')].liveScores[leagueFormat]).indexOf(shortResultKey);
                }

                for (var i = 0; i < liveScores.length; i++) {
                    // skip the sets score if the sport has legs, show the legs
                    if (i === 0 && (!displayShortResult && shortResultKeyIndex === undefined) && !hasLegs) {
                        continue;
                    }

                    if(displayShortResult && shortResultKeyIndex != undefined){
                        if(shortResultKeyIndex != i){
                            if(i < currentSet){
                                continue
                            }
                        }else{
                            //Skip default result and reset displayShortTitle
                            if(liveScores[i] === '-:-'){
                                displayShortResult = false;
                                continue
                            }
                        }
                    }else{
                        //Skip default result
                        if(liveScores[i] === '-:-'){
                            continue
                        }
                    }
                    // if we don't know the current period, skip all zeroes
                    if ((isNaN(currentSet) || currentSet == 0) && liveScores[i] == '0:0') {
                        continue;
                        // if we know the period, skip bigger periods
                    } else if (i > currentSet) {
                        continue;
                    }

                    liveScoresHtml += this.createSetResult(liveScores[i]);
                }

                var points = this.model.get('points');
                if (points) {
                    liveScoresHtml += this.createSetResult(points);
                }

                this.model.set('live_score_html', liveScoresHtml);
                this.displayLiveScores();
            },
            createSetResult: function (liveScore) {

                var result = liveScore.split(':');
                var $setResult = $('<div/>', {
                    class: 'period-result'
                });

                var $homeResult = $('<span/>', {
                    class: 'score-home live-score-item',
                    text: result[0]
                });
                var $awayResult = $('<span/>', {
                    class: 'score-away live-score-item',
                    text: result[1]
                });

                $setResult.append($homeResult).append($awayResult);
                return $setResult[0].outerHTML;
            },
            displayLiveScores: function() {
                var liveScoresMap = LiveScoresMap.sports[this.model.get('sport_key')];
                var displayLiveScores = (liveScoresMap && liveScoresMap.skipInList != true && this.model.get('live_score_html')) ? true : false;
                this.model.set('displayLiveScores', displayLiveScores);
                if(displayLiveScores) {
                    this.$el.find('.live-score-box').removeClass('d-none').addClass('d-flex');
                    this.$el.find('.event-live-score-box').removeClass('d-none').addClass('d-flex');
                    this.$el.find('.event-score-box').addClass('d-none').removeClass('d-flex');
                    if(liveScoresMap && liveScoresMap.skipInList != true) {
                        this.$el.find('.event-score-box').removeClass('flex-column align-items-end');
                        this.$el.find('.versus').removeClass('d-none');
                    }
                }else {
                    this.$el.find('.live-score-box').addClass('d-none').removeClass('d-flex');
                    this.$el.find('.event-live-score-box').addClass('d-none').removeClass('d-flex');
                    this.$el.find('.event-score-box').removeClass('d-none').addClass('d-flex');
                    if(liveScoresMap && liveScoresMap.skipInList != true) {
                        this.$el.find('.event-score-box').addClass('flex-column align-items-end');
                        this.$el.find('.versus').addClass('d-none');
                    }
                }
            },
        },

        'favLeague': {
            favLeague: function () {
                this.pushEvents({
                    "click .favoritesLeaguesAction": "manageFavoriteLeague"
                });
                this.pushComponents({
                    is_fav: {
                        callback: this.evaluateLeaguesFavoriteStatus
                    }
                });
            },
            manageFavoriteLeague: function (e) {
                e.stopPropagation();
                var leagueID = this.model.get('id').split("_")[0];

                if (this.model.get("is_fav") == 1) {
                    this.removeFavLeague([leagueID]);
                    this.model.set('is_fav', 0);
                    //Update child model - EVENTS
                    this.model.childList.each(function (event) {
                        event.set('is_fav', 0);
                    });

                } else {
                    this.addFavLeague([leagueID]);
                    this.model.set("is_fav", 1);
                }

            },
            evaluateLeaguesFavoriteStatus: function (value, prev_value, element, key, $this) {
                if ($this.model.get("is_fav") == 1) {
                    $this.$el.find(".favoritesGamesAction").addClass("active");
                    $this.$el.find(".favoritesLeaguesAction").addClass("active");
                } else if ($this.model.get("is_fav") == 0) {
                    $this.$el.find(".favoritesLeaguesAction").removeClass("active");
                    $this.$el.find(".favoritesGamesAction").removeClass("active");
                }
            },
            addFavLeague: function (data) {
                this.trigger("Dispatcher_requestData", "manageFavorites", {
                    "action": "addLeague",
                    "ids": data
                });
            },
            removeFavLeague: function (data) {
                this.trigger("Dispatcher_requestData", "manageFavorites", {
                    "action": "removeLeague",
                    "ids": data
                });
            },
        },

        'favEvent': {
            subscriptionsMap: {
                eventLive: 'getSidebarNavigationLive',
                liveCalendar: 'getSidebarNavigationLive',
                multiView: 'getSidebarNavigationLive',
                live: 'getEuroLive'
            },
            favEvent: function () {
                this.pushEvents({
                    "click .favoritesGamesAction": "manageFavoriteEvent"
                });
                this.pushComponents({
                    is_fav: {
                        callback: this.evaluateEventFavoriteStatus
                    }
                });
            },
            manageFavoriteEvent: function (e) {
                e.stopPropagation();
                var eventID = this.model.get("event_id"),
                    //convert to boolean as sometimes is_fav comes with value of 1 or 0
                    isFav = !!this.model.get("is_fav");

                if (isFav) {
                    this.removeFavEvent([eventID]);
                } else {
                    this.addFavEvent([eventID]);
                }

                this.model.set('is_fav', !isFav);


                //TODO this is custom logic for index_home.js but shouldnt be it the same with the rest components?
                var parent = this.model.getParent("League");
                var leagueID = '';
                if (parent === false) {
                    leagueID = this.model.get('league_id')
                } else {
                    leagueID = parent.get('id')
                }
                if (this.subscriptionsMap[Config.ACTION]) {
                    this.trigger('EuroLiveOverview_filterEvents');
                }
            },
            evaluateEventFavoriteStatus: function (value, prev_value, element, key, $this) {
                if ($this.model.get("is_fav")) {
                    $this.$el.find(".favoritesGamesAction").addClass("active");
                } else {
                    $this.$el.find(".favoritesGamesAction").removeClass("active");
                }
            },
            addFavEvent: function (data) {
                this.trigger("Dispatcher_requestData", "manageFavorites", {
                    "action": "addEvent",
                    "ids": data
                });
            },
            removeFavEvent: function (data) {
                this.trigger("Dispatcher_requestData", "manageFavorites", {
                    "action": "removeEvent",
                    "ids": data
                });
            },
        },

        'liveCenter': {
            liveCenter: function () {
                this.pushEvents({
                    "click .live-incidents-icon": "displayLiveCenter",
                    "click .live-stream-icon": "displayLiveStream"
                });

                var eventId = this.model.get('event_id');
                this.on('LiveCenter_LiveIncidentsStart' + eventId, this.setIncidentsIconActive);
                this.on('LiveCenter_LiveIncidentsStop' + eventId, this.setIncidentsIconInactive);
                this.on('LiveCenter_LiveStreamStart' + eventId, this.setLiveStreamIconActive);
                this.on('LiveCenter_LiveStreamStop' + eventId, this.setLiveStreamIconInactive);

                this.pushComponents({
                    has_live_incidents: {
                        callback: this.updateLiveIncidentsIconVisibility
                    },
                    br_match_id: {
                        callback: this.updateBetRadarLiveIncidentsIconVisibility
                    },
                    has_live_streaming: {
                        callback: this.updateLiveStreamIconVisibility
                    },
                });
                if ((this.model.get('has_live_incidents') || (this.model.get('br_match_id') != 0 && this.model.get('br_match_id') !== undefined)) && this.autoPlay) {
                    this.displayLiveCenter();
                }

            },
            updateBetRadarLiveIncidentsIconVisibility: function(value, prev_value, element, key, $this){
                var isVisible = false;
                if(window.BaseConfig.get('BET_RADAR_CONFIG') && window.BaseConfig.get('BET_RADAR_CONFIG').sports_lmt.indexOf($this.model.get('sport_key')) !== -1 && value !== 0 && $this.model.get('event_state') === 'live'){
                    isVisible = true;
                }
                $this.updateLiveIncidentsIconVisibility(isVisible, prev_value, element, key, $this);
            },
            updateLiveIncidentsIconVisibility: function (value, prev_value, element, key, $this) {
                $this.updateLiveCenterIconVisibility('.live-incidents', value);
            },
            updateLiveStreamIconVisibility: function (value, prev_value, element, key, $this) {
                $this.updateLiveCenterIconVisibility('.live-stream', value);
            },
            updateLiveCenterIconVisibility: function (selector, value) {
                if (value) {
                    this.$el.find(selector + '-icon').removeClass('d-none');
                    this.$el.find(selector + '-media-holder').addClass('d-none');
                } else {
                    this.$el.find(selector + '-icon').addClass('d-none');
                    this.$el.find(selector + '-media-holder').removeClass('d-none');
                }
            },
            setIncidentsIconActive: function () {
                this.setLiveCenterIcon('.live-incidents-icon', true);
            },
            setIncidentsIconInactive: function () {
                this.setLiveCenterIcon('.live-incidents-icon', false);
            },
            setLiveStreamIconActive: function () {
                this.setLiveCenterIcon('.live-stream-icon', true);
            },
            setLiveStreamIconInactive: function () {
                this.setLiveCenterIcon('.live-stream-icon', false);
            },
            setLiveCenterIcon: function (selector, active) {
                if (active) {
                    this.$el.find(selector).addClass('active');
                } else {
                    this.$el.find(selector).removeClass('active');
                }
            },

            displayLiveCenter: function (e) {
                var $selected = this.$el.find('.live-incidents-icon'),
                    isActive = $selected.hasClass('active');

                $('.live-incidents-icon:not(.liveIncidentsToggle)').removeClass('active');
                $('.live-stream-icon:not(.liveStreamToggle)').removeClass('active');

                if (isActive) {
                    this.trigger('LiveCenter_LiveIncidentsStop');
                    this.trigger('LiveCenter_LiveIncidentsStop' + this.model.get('event_id'));
                } else {
                    this.trigger('LiveCenter_LiveIncidentsStart', this.getLiveData());
                    this.trigger('LiveCenter_LiveIncidentsStart' + this.model.get('event_id'));
                }
                this.toggleVueLiveCenter(isActive);
            },
            toggleVueLiveCenter: function(isActive) {
                var $vueContent = $('#live-center-wrapper');
                if(!$vueContent.length) {
                    return;
                }
                var $vueStore = $vueContent[0].__vueParentComponent.appContext.config.globalProperties.$store;
                var eventInfo = {};

                if(isActive){
                    $vueStore.commit('shared/SET_LIVE_CENTER_RESIZING', false);
                    $vueStore.commit('shared/SET_LIVE_CENTER_OPENED', false);
                }else{
                    $vueStore.commit('shared/SET_LIVE_STREAM_OPENED', false);
                    $vueStore.commit('shared/SET_LIVE_CENTER_OPENED', true);
                    eventInfo = this.getVueEventInfo();
                }

                $vueStore.commit(`shared/SET_LIVE_CENTER_EVENT`, $vueStore.getters['shared/getSingleEventInfo'](eventInfo));
            },
            getVueEventInfo: function() {
                var eventInfo = this.model.attributes;
                var extractKeys = [
                    'away_team',
                    'away_team_color',
                    'br_match_id',
                    'clock',
                    'event_id',
                    'event_state',
                    'favorite',
                    'has_live_incidents',
                    'has_live_streaming',
                    'home_team',
                    'home_team_color',
                    'iso',
                    'league_format',
                    'league_id',
                    'live_clock_timestamp',
                    'live_game_period',
                    'live_minute',
                    'live_red_cards_away',
                    'live_red_cards_home',
                    'live_score_home',
                    'live_scores',
                    'sport_id',
                    'sport_key',
                    'sport_title',
                    'start_date',
                    'terrain_type',
                    'title',
                    'tracker_id'];
                var vueEventInfo = {};
                extractKeys.forEach( function (key) {
                    if (eventInfo[key]) {
                        if(key === 'away_team' || key === 'home_team'){
                            vueEventInfo[key] = eventInfo[key].replace(/<[^>]*>?/gm, '');
                        }else {
                            vueEventInfo[key] = eventInfo[key];
                        }
                    }else{
                        vueEventInfo[key] = '';
                    }
                });
                return vueEventInfo;
            },
            toggleVueLiveStream: function(isActive) {
                var $vueContent = $('#live-center-wrapper');
                if(!$vueContent.length) {
                    return;
                }
                var $vueStore = $vueContent[0].__vueParentComponent.appContext.config.globalProperties.$store;

                var eventInfo = {};
                if (isActive) {
                    $vueStore.commit(`shared/SET_LIVE_CENTER_RESIZING`, false);
                    $vueStore.commit(`shared/SET_DETACH_LIVE_CENTER`, false);
                    $vueStore.commit(`shared/SET_LIVE_STREAM_OPENED`, false);
                } else {
                    $vueStore.commit(`shared/SET_LIVE_CENTER_EVENT`, {});
                    $vueStore.commit(`shared/SET_LIVE_CENTER_OPENED`, false);
                    $vueStore.commit(`shared/SET_LIVE_STREAM_OPENED`, true);
                    eventInfo = this.getVueEventInfo();
                }
                setTimeout(function() {
                    $vueStore.commit(`shared/SET_LIVE_CENTER_EVENT`, $vueStore.getters['shared/getSingleEventInfo'](eventInfo))
                });
            },
            displayLiveStream: function (e) {
                var $selected = $(e.target),
                    isActive = $selected.hasClass('active');

                $('.live-incidents-icon:not(.liveIncidentsToggle)').removeClass('active');
                $('.live-stream-icon:not(.liveStreamToggle)').removeClass('active');

                if (isActive) {
                    this.trigger('LiveCenter_LiveStreamStop');
                } else {
                    this.trigger('LiveCenter_LiveStreamStart', this.getLiveData());
                    $selected.addClass('active');
                }
                this.toggleVueLiveStream(isActive);
            },
            getLiveData: function () {

                var homeTeam = this.model.get('team_home') ? this.model.get('team_home') : this.model.get('home_team'),
                    awayTeam = this.model.get('team_away') ? this.model.get('team_away') : this.model.get('away_team'),
                    leagueTitle = this.model.get('league_title') ? this.model.get('league_title') : this.model.get('title'),
                    liveGamePeriod = this.model.get('live_game_period') ? this.model.get('live_game_period') : '';

                var liveEventData = {
                    trackerId: this.model.get('tracker_id'),
                    eventId: this.model.get('event_id'),
                    homeTeamTitle: homeTeam ? homeTeam.replace(/<\/?[^>]+(>|$)/g, "") : '',
                    awayTeamTitle: awayTeam ? awayTeam.replace(/<\/?[^>]+(>|$)/g, "") : '',
                    homeTeamColor: this.model.get('home_team_color'),
                    awayTeamColor: this.model.get('away_team_color'),
                    sportTitle: this.model.get('sport_key'),
                    terrainType: this.model.get('terrain_type'),
                    leagueTitle: leagueTitle,
                    liveGamePeriod: liveGamePeriod,
                    has_live_incidents: this.model.get('has_live_incidents'),
                    has_live_streaming: this.model.get('has_live_streaming'),
                };

                return liveEventData;
            }

        },

        'updateFilterCounter': {

            updateFilterCounter: function () {
                if (this.model.id == 'mix_parlay') {
                    this.setComboCounter('early');
                    this.setComboCounter('today');
                } else {
                    this.setSportFilterCounter(this.model.childList.models);
                }
                this.on('Filter_updateSelectedCounter', this.updateCounter);
                this.on('Filter_renderSelectedCounter', this.renderCounter);
                this.on("Filter_setAllSelectCount", this.setAllSelectCount);
                this.pushComponents({
                    selected_leagues_count: {
                        callback: this.updateAllSelectCountHandler
                    }
                });
            },

            updateAllSelectCountHandler: function (value, prev_value, element, key, $this) {
                if (!value) {
                    $this.$el.find('.all-selected-leagues-count').addClass('d-none');
                } else {
                    $this.$el.find('.all-selected-leagues-count').removeClass('d-none');
                }
            },
            setAllSelectCount: function (caller, count) {
                this.model.set('selected_leagues_count', count);
            },

            setComboCounter: function (gameMode) {

                var matchedMode = _.findWhere(this.model.childList.models, {id: gameMode})
                if (!matchedMode) {
                    return;
                }
                var sports = matchedMode.childList.models,
                    selectedCount = 0;

                for (var i = 0; i < sports.length; i++) {
                    var selectedLeagues = _.filter(sports[i].childList.models, function (league) {
                        return league.attributes.is_active
                    });
                    selectedCount += selectedLeagues.length;
                }

                this.setCounter(gameMode, selectedCount);
                this.renderCounter(null, gameMode)
            },

            setSportFilterCounter: function (models) {
                for (var i = 0; i < models.length; i++) {
                    var gameMode = models[i].id;
                    var selectedLeagues = _.filter(models[i].childList.models, function (league) {
                        return league.attributes.is_active
                    });
                    this.setCounter(gameMode, selectedLeagues.length);
                    this.renderCounter(null, gameMode)

                }
            },

            updateCounter: function (caller, data) {
                if (data.value) {
                    this[data.gameMode]++
                } else {
                    this[data.gameMode]--
                }
            },

            renderCounter: function (caller, gameMode) {
                this.$el.find('#tab-' + gameMode).text(this[gameMode]);
            },

            setCounter: function (gameMode, count) {
                this[gameMode] = count;
            }
        },

        clockTimerInterval: {
            clockTimerInterval: function () {
                var view = this;
                this.viewTimers = {};
                this.viewTimers.clockInterval = setInterval(function () {
                    view.trigger('UpdateEventClock_Interval');
                }, 1000)
            }
        },
        clockTimer: {
            clockTimer: function () {

                //TODO maybe there is a better way to stop that soccer behaviour on asian table
                if (this.model.get('sport_key') == 'soccer' && Config.VIEW_NAME == 'asian-view') {
                    return;
                }

                this.clockData = {
                    seconds: 0
                };
                this.model.set('subscribedForClockInterval', false);
                this.pushComponents({
                    clock: {
                        callback: this.reactOnEventUpdate
                    },
                });

                if (this.model.get('clock')) {
                    this.startListenForClock();
                }
            },

            startListenForClock: function () {

                if (!this.model.get('subscribedForClockInterval')) {
                    this.on('UpdateEventClock_Interval', this.handleClock);
                    this.model.set('subscribedForClockInterval', true);
                }
                if (this.model.get('sport_key') == 'soccer') {
                    var periods = ['et1', 'et', 'et2', 'pen'];
                    if(periods.indexOf(this.model.get('live_game_period')) == -1) {
                        this.$el.find('.game-period').addClass('d-none');
                    }
                }
                this.$el.find('.game-timer').removeClass('d-none');
            },
            stopListenForClock: function () {
                this.off('UpdateEventClock_Interval');
                this.model.set('subscribedForClockInterval', false);
                this.$el.find('.game-period').removeClass('d-none');
                this.$el.find('.game-timer').addClass('d-none');
            },
            handleClock: function () {
                var clock = this.model.get('clock');
                var sportKey = this.model.get('sport_key');
                var gamePeriod = this.model.get('live_game_period');

                if (!clock) {
                    return;
                }
                this.clockData.seconds = clock.start_seconds;

                if (clock.is_stopped || (sportKey === 'soccer' && gamePeriod === 'h_time')) {
                    this.updateEventClock(clock.start_seconds, clock.is_stopped, sportKey, gamePeriod);
                } else {
                    var timeNow = Math.floor(Date.now() / 1000) - Config.TIME_DELTA;
                    if (sportKey === 'basketball') {
                        var timeNow = Math.floor(Date.now() / 1000) - Config.TIME_DELTA;
                        this.clockData.seconds = clock.start_seconds - (timeNow - clock.start_timestamp) + 2;
                        if (this.clockData.seconds < 0) {
                            this.clockData.seconds = 0;
                        }
                    } else {
                        this.clockData.seconds = clock.start_seconds + (timeNow - clock.start_timestamp);
                    }
                    this.updateEventClock(this.clockData.seconds, clock.is_stopped, sportKey, gamePeriod);

                }


            },

            reactOnEventUpdate: function (value, prev_value, element, key, $this) {
                if (value) {
                    $this.startListenForClock();
                } else {
                    $this.stopListenForClock();
                }
            },

            updateEventClock: function (secondsReceived, isStopped, sportKey, gamePeriod) {
                var timeString = '',
                    minutes = 0,
                    seconds = 0;
                minutes = (secondsReceived / 60) >> 0;
                seconds = secondsReceived % 60;
                minutes = String(minutes).padStart(2, '0');
                seconds = String(seconds).padStart(2, '0');

                timeString = minutes + ':' + seconds;

                if((sportKey == 'soccer' && isStopped && (timeString == '45:00' || timeString == '40:00')) || (sportKey === 'soccer' && gamePeriod === 'h_time')){
                    var translationKey = gamePeriod === '2h' ? 'ft' : 'LIVE_CENTER.STATISTICS.short_half_time';
                    timeString = translation(translationKey);
                }
                this.model.set('clock_timer', timeString);

            }

        },
        viewLoader: {
            addLoader: function () {
                if(this.model.get('displayLoader') !== false){
                    this.$el.addClass('view-loader');
                }
            },
            removeLoader: function () {
                if(!Config.IS_MOBILE){
                    this.$el.removeClass('view-loader');
                }else{
                    if(!Config.disconnected){
                        this.$el.removeClass('view-loader');
                    }
                }
            }
        },
        VuexSharedUpdate: {
            VuexSharedUpdate: function(){
                this.on('Vuex_shared/ADD_SCOREBOARD_DATA', this.updateLiveScores);
                this.on('Vuex_shared/SET_EVENT_IS_LOADING', this.setEventIsLoading);
                this.on('Dispatcher_returnData_getSelectedEvent', this.setSelectedEvent);
                this.on('ScoreBoardSocket_leaveRoom', this.leaveScoreBoardRoom);
            },
            mutateVuex: function (mutation, value) {
                if ($('#appComponents')[0]) {
                    $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store.commit(mutation, value);
                }
            },
            updateVueOdds: function (caller, response) {
                this.mutateVuex('shared/SET_EVENTS_DATA', response);
            },
            updateLiveScores: function (caller, data) {
                this.mutateVuex('shared/ADD_SCOREBOARD_DATA', data);
            },
            leaveScoreBoardRoom: function(caller, roomId){
                this.mutateVuex('shared/REMOVE_EVENT_SCOREBOARD_DATA', roomId);
            },
            setEventIsLoading: function (caller, isEventLoading) {
                this.mutateVuex('shared/SET_EVENT_IS_LOADING', isEventLoading);
            },
            setSelectedEvent: function (caller, eventData) {
                this.mutateVuex('shared/SET_SELECTED_EVENT', {
                    event: {
                        info: eventData.data.info ? eventData.data.info : {},
                        data: eventData.data.data ? eventData.data.data : {}
                    }
                });
                this.mutateVuex('shared/SET_EVENT_IS_LOADING', false);
            },
        },
        updateZendeskBalanceTags: {
            updateZendeskBalance: function(data){
                if(!Config.CHAT_INIT || typeof zE == 'undefined'){
                    return;
                }

                var currentTags = JSON.parse(localStorage.getItem("zEchatTags"));

                var tags = this.getRegularUserTags(data, currentTags)
                this.updateZendeskUserTags(currentTags, tags.removeTags, tags.addTags)

            },
            getRegularUserTags: function(balanceData, currentTags) {
                var balanceTagsPrefixes = Config.USER_TYPE == '1' ? ['rb_'] : ['rb_', 'svb_', 'cvb_'];
                var balanceKeys = ['balance', 'sport-bonus', 'casino-bonus']
                var matchedBalances = _.values(balanceData).filter(function(balance){
                    return Config.USER_TYPE == '1' ? balance.info.bet_credit_amount : balanceKeys.includes(balance.info.key)
                })
                var newTags = matchedBalances.map(function(balance, index) {
                    var tagPrefix = balanceTagsPrefixes[index]
                    var amount = Config.USER_TYPE == '1' ? balance.info.bet_credit_amount : balance.info.raw_amount;
                    amount = amount.replace(/,/g, '')
                    return tagPrefix + amount
                })

                var previousTags = currentTags.filter(function(tag) {
                    return balanceTagsPrefixes.includes(tag.split('_')[0] + '_')
                })

                var removeTags = previousTags.filter(function(tag) {
                    return !newTags.includes(tag)
                })

                var addTags = newTags.filter(function(tag) {
                    return !previousTags.includes(tag)
                })

                return {
                    removeTags: removeTags,
                    addTags: addTags,
                }
            },
            updateZendeskUserTags: function(currentTags, removeTags, addTags) {
                //Return if there are no changes
                if(!removeTags.length){
                    console.log('no update in balance tags')
                    return
                }

                window.ZendeskCommunicator.removeTags(removeTags);
                setTimeout(function() {
                    window.ZendeskCommunicator.addTags(addTags)
                }, 500)

                var updatedTags = currentTags.map(function(tag) {
                    var removeTagIndex = removeTags.indexOf(tag)
                    if(removeTagIndex !== -1) {
                        return addTags[removeTagIndex]
                    }
                    return tag
                })
                console.log('updatedTags', updatedTags)
                localStorage.setItem("zEchatTags", JSON.stringify(updatedTags));
            },
        },
    }
}
; /** ----------------- **/ 
 var pageComponent = function(settings, initial_data, ccu_info, componentName)
{

    var _models = {};
    var _views = {};
    var _templates = $templates;
    var _beforeInitializeBehaviours = $beforeInitializeBehaviours;
    var _modelInitializeBehaviours = $modelInitializeBehaviours;
    var _behaviours = $behaviours;
    var _firstModel;

    var $this = {};

    $this.ID = _.uniqueId('component_');
    $this.Page = Mediator.getMediator();
    $this.Request = RequestCollector.getCollector();

    function createElements(settings, componentName)
    {
        /** CREATE MODELS
         *
         */
        _.each(settings.models, function(value, key)
        {
            //gc
            delete settings.models[key];

            if(_.isEmpty(_models))
            {
                _firstModel = value.modelName;
            }

            /**
             * BaseList
             * Base model list setup
             */
            var BaseList = Backbone.Collection.extend({
                comparator: "order"
            });



            /**
             * BaseModel
             * Base model for the app. Extends Backbone.Model
             *
             * subModel : reference to CoreModel
             * listModel : reference to BaseList
             * modelView : reference to BaseView
             */
            var BaseModel = Backbone.Model.extend(
                {
                    idAttribute: "id",
                    listModel : BaseList,
                    myView: 'BaseListView',
                    models: _models,
                    views: _views,
                    initialize: function(){
                        this.initModelInitializeBehaviours();
                        //trace("Initialized " + this.modelName);
                    },
                    constructor : function()
                    {
                        this.Page = $this.Page;
                        this.RequestCollector = $this.Request;
                        this.childList = new this.listModel();

                        if(arguments[1])
                        {
                            this.addOptions(arguments[1]);
                        };

                        this.ccu = ccu;

                        Backbone.Model.apply(this, arguments);
                    },
                    content: function(data, depth)
                    {
                        var model = this;

                        if (typeof depth === 'number'){
                            depth++;
                        } else {
                            depth = 1;
                        }

                        if(('current_depth' in model) == false) {
                            this.current_depth = depth;
                        }


                        var size = _.size(data),
                            counter = 0;
                        try
                        {

                            // Sort remove action to be first
                            var contentData = _.sortBy(data, function(item, key) {
                                item.contentKey = key;
                                return item.action !== 'remove';
                            });

                            data = {};

                            for(var k = 0; k < contentData.length; k++){
                                var value = contentData[k],
                                    key = value.contentKey;
                                data[key] = value
                                delete value.contentKey
                            }

                            _.each(data, function(value, key)
                            {

                                counter++;

                                // gc
                                // garbage collecting is like trimming your fingernails, its good for your image and health
                                if(depth == 1)
                                {
                                    delete data[key];
                                }

                                if('action' in value)
                                {
                                    model[value.action](value, key, depth, model);

                                    if(size == counter && depth == 1){
                                        //Move to the end of the call stack
                                        setTimeout(function(){
                                            model.view.trigger(componentName + '_allChildrenInitialized');
                                        })

                                    }

                                    return;
                                }

                                // uncomment for debugging
                                // // default behavior if there is no action in the data container
                                // var message = ["There is no action defined for "];
                                // message.push([model.childModel, "[", key, "]"].join(''));

                                // var parents = model;
                                // while(parents.parent)
                                // {
                                // 	message.push([" >>> ", parents.modelName, "[", parents.id, "]"].join(''));
                                // 	parents = parents.parent;
                                // }
                                // trace(message.join(''));
                            });

                            if(!model.forceOrder){
                                return;
                            }
                            //Experimental order tracking
                            var newChildren = _.filter(this.childList.models, function(child){
                                return child.newlyAdded
                            });

                            if(newChildren.length){
                                for(var i = 0; i < this.childList.models.length; i++){

                                    var childModel = this.childList.models[i];
                                    if(childModel.newlyAdded){
                                        if(model.view){

                                            // if(model.view.renderLimit != undefined) {
                                            //     if(i == model.view.renderLimit){
                                            //         console.log('SKIPPED: ', JSON.stringify(childModel));
                                            //     }
                                            //     if(i <= model.view.renderLimit){
                                            //         model.view.addOne(childModel);
                                            //     }
                                            // }else{
                                                model.view.addOne(childModel)
                                            // }
                                        }
                                        delete childModel.newlyAdded
                                    }
                                }
                            }

                        }
                        catch(e)
                        {
                            console.log('Failed set content');
                            trace(data);
                            console.log(e);
                            console.trace();
                        }

                    },
                    remove: function(data, key)
                    {
                        var model = this.childList.get(key);

                        // Patch for markets that are removed with delay
                        // Case is a market key is removed and comes for insert in a period less that 7 secs
                        if(model && model.get('delayRemove')){
                            model.trigger('delayRemove', model);
                            model.set({
                                removeData:  data,
                            });
                            return;
                        }

                        if(model && model.get('triggerBeforeRemove')){
                            model.trigger('triggerBeforeRemove', model)
                        }
                        this.childList.remove(key);

                        var removeRecursive = function (m) {
                            if (!m) {
                                return;
                            }
                            if (m.view) {
                                m.view.unbind();
                                m.view.undelegateEvents();
                                for(var timer in m.view.viewTimers){
                                    clearTimeout(m.view.viewTimers[timer]);
                                    clearInterval(m.view.viewTimers[timer]);
                                }
                                if(m.view.updater){
                                    m.view.updater.destroy();
                                }
                                    m.view.remove();
                            }
                            m.unbind();
                            m.childList.each(function (ch) {
                                m.childList.remove(key);
                                removeRecursive(ch);
                            });


                        };
                        removeRecursive(model);

                    },
                    removeChildren: function(){
                        for(var i = this.childList.length - 1; i >= 0; --i) {
                            var childModel = this.childList.models[i];
                            this.remove({action: 'remove'}, childModel.id);
                        }
                    },
                    insert: function(data, key, depth, model)
                    {
                        // trace('insert');
                        //trace(key);
                        this.beforeInsert(data, key);

                        // Patch for markets that are removed with delay
                        // Case is a market key is removed and comes for insert in a period less that 7 secs

                        if(this.childList.get(key) && this.childList.get(key).get('delayRemove') && this.view){
                            // this.view.trigger('PageComponent_forceRemove' + this.childList.get(key).cid);
                            var rm = this.childList.get(key),
                                rmData = rm.get('removeData').data;

                            _.each(rmData, function(value, key){
                                rm.remove(value, key);
                            });

                            data.action = 'update';
                            rm.set('delayRemove', false);
                            this.update(data, key, depth);
                            rm.set('delayRemove', true);
                            return;
                        }

                        if((!this.childList.get(key) && _models[this.childModel]))
                        {
                            //console.log(this.childModel);
                            var child = new _models[this.childModel]({id: key});
                            child.set(data.info);

                            child.content(data.data, depth);
                            //
                            // if(depth > 1)
                            // {
                            // 	setTimeout(function (){ child.content(data.data, depth); }, 1);
                            // }
                            // else
                            // {
                            // 	child.content(data.data, depth);
                            // }

                            child.parent = this;
                            child.newlyAdded = true;
                            this.childList.add(child);
                            // return;
                        }
                        // window.lock_threads = false;

                        // uncomment when debugging issues
                        // if(this.childList.get(key))
                        // {
                        // 	var message = "This item is already inserted! ";
                        // 	message += "Insert for " + this.childModel + "[" + key + "]";

                        // 	var parents = this;
                        // 	while(parents.parent)
                        // 	{
                        // 		message += " >>> " + parents.modelName + "[" + parents.id + "]";
                        // 		parents = parents.parent;
                        // 	}
                        // 	trace(message);
                        // 	return;
                        // }

                        // if(!_models[this.childModel])
                        // {
                        // 	trace(this.childModel + " is not defined! Usage attempted in " + this.modelName);
                        // 	return;
                        // }

                        // trace("Something went wrong with insert attempt!");

                    },
                    beforeInsert: function(){},
                    update: function(data, key, depth)
                    {
                        // trace('update');
                        // trace(key);
                        //trace("update", this.modelName);

                        var child = this.childList.get(key);

                        if(child)
                        {

                            if(data.info)
                            {
                                child.set(data.info);
                            }

                            if(data.data)
                            {
                                child.content(data.data, depth);
                            }
                            // return;
                        }
                        // window.lock_threads = false;

                        // uncomment when debugging isses
                        // var message = "You are trying to update something that does not exist! ";
                        // message += "Update for " + this.childModel + "[" + key + "]";

                        // var parents = this;
                        // while(parents.parent){
                        // 	message += " >>> " + parents.modelName + "[" + parents.id + "]";
                        // 	parents = parents.parent;
                        // }
                        // trace(message);
                        // return;
                    },
                    addOptions: function(data)
                    {
                        var model = this;
                        _.each(data,
                            function(value, key)
                            {
                                delete data[key];
                                model[key] = value;
                            }
                        );
                    },
                    addListeners: function(){},

                    /**
                     * Finds parent model based on modelName
                     * Only searches for direct parents
                     * @name string: the modelName of the searched parent
                     */

                    getParent: function(name)
                    {
                        if(!name)
                        {
                            return false;
                        }

                        var model = this;
                        //loop model parent while the modelName is different than name
                        while(model.modelName != name)
                        {
                            if(model.parent)
                            {
                                model = model.parent;
                                continue;
                            }

                            // trace("No such model was found");
                            return false;
                        }

                        return model;
                    },

                    /**
                     * Returns all parent models in array or empty array if no parents
                     */
                    getParents: function()
                    {
                        var parents = [],
                            model 	= this;

                        while(model.parent)
                        {
                            model = model.parent;
                            parents.push(model);
                        }

                        return parents;
                    },
                    initModelInitializeBehaviours: function(){
                        var $this = this;
                        if($this.modelInitializeBehaviours) {
                            _.each($this.modelInitializeBehaviours, function(value, key) {
                                if(typeof $this[value] == 'function') {
                                    $this[value]();
                                }
                            })
                        }
                    }
                });

            _models[value.modelName] = BaseModel.extend(value);

            if(value.modelInitializeBehaviours)
            {
                _.each(value.modelInitializeBehaviours, function(behaviour){

                    if(_modelInitializeBehaviours[behaviour]){
                        _models[value.modelName] = _models[value.modelName].extend(_modelInitializeBehaviours[behaviour]);
                    }

                });
            }
        });


        /**
         * CREATE VIEWS
         */
        if(!settings.views || _.isEmpty(settings.views)){
            settings.views = [{viewName: "BaseListView"}];
        }

        _.each(settings.views, function(value, key)
        {
            delete settings.views[key];

            var view = Backbone.View.extend({
                viewName: "BaseListView",
                holder : null,
                //components: {},
                templates: _templates,
                models: _models,
                views: _views,
                //Add timeouts and intervals within the viewTimers object in order to clear them on view remove and destroy
                viewTimers: {},
                initialize : function(){
                    // trace('initialized');
                    //trace(this.viewName + " View Initialized");


                    this.components = {};
                    this.model.Page.installTo(this);
                    this.RequestCollector = $this.Request;
                    this.initBeforeInitializeBehaviours();
                    this.beforeInitialize();
                    this.makeTargetEl(arguments);
                    this.addToDom();
                    this.setAutoUpdates();
                    this.setInnerTarget();
                    this.addListeners();
                    this.delegateEvents();
                    this.model.view = this;

                    if(this.model.get('createChildren') !== false){
                        if(this.renderLimit != undefined){
                            for(var i = 0; i < this.renderLimit; i++){
                                this.createChildAt(i);
                            }
                        }else{
                            this.initialCreation();
                        }
                    }


                    this.createComponents();
                    this.trackForUpdate();
                    this.initBehaviours();
                    this.afterInitialize();

                    this.viewInitialized = true;
                },
                initBehaviours: function(){
                    var $this = this;
                    if($this.behaviours)
                    {
                        _.each($this.behaviours, function(value, key)
                        {
                            if(typeof $this[value] == 'function')
                            {
                                $this[value]();
                            }
                        })
                    }
                },
                initBeforeInitializeBehaviours: function(){
                    var $this = this;
                    if($this.beforeInitializeBehaviours)
                    {
                        _.each($this.beforeInitializeBehaviours, function(value, key)
                        {
                            if(typeof $this[value] == 'function')
                            {
                                $this[value]();
                            }
                        })
                    }
                },

                addOne: function(model)
                {
                    if(model.get('rendered')){
                        return;
                    }
                    this.beforeChildViewAdd(model);

                    var view = typeof _views[model.modelName + "View"] === "function" ? _views[model.modelName + "View"] : _views['BaseListView'];
                    model.view = new view({model: model, targetEl: this.childTarget});
                    if(this.reorderOnAdd){
                        this.reorderChilds();
                    }

                    this.afterChildViewAdd(model);
                },
                initialCreation: function()
                {
                    var thisView = this;
                    var children = this.model.childList;
                    children.each(function(value, key)
                    {
                        delete children[key];
                        thisView.addOne(value, true);
                    });
                },
                createChildAt: function(index){
                    var children = this.model.childList.models;
                    if(children[index]){
                        this.addOne(children[index], true);
                    }
                },

                destroyView: function(){

                    this.unbind();
                    this.undelegateEvents();
                    // if (this.model != undefined && this.model.unbind != undefined ) {
                    //     this.model.unbind();
                    // }
                    this.model.set('rendered', false);

                    this.$el.remove();

                    for(var timer in this.viewTimers){
                        clearTimeout(this.viewTimers[timer]);
                        clearInterval(this.viewTimers[timer]);
                    }
                    if(this.model.childList.length){
                        for(var i = 0; i < this.model.childList.models.length; i++){
                            var child = this.model.childList.models[i];
                            if(child.view){
                                child.view.destroyView();
                            }
                        }
                    }

                    if(this.updater){
                        this.updater.destroy();
                    }
                    // Move to the end of the call stack
                    var view = this;
                    setTimeout(function(){
                        view.remove();
                    });
                },

                reinitializeChildren: function(callback){
                    this.model.childList.each(function(child) {
                        if(child.view){
                            child.view.reinitializeView();
                        }
                    })
                    setTimeout(function(){
                        if(callback){
                            callback();
                        }
                    })
                },
                reinitializeView: function(callback){
                    if(this.model.get('rendered') == false){
                        return;
                    }
                    this.setRenderedFalse(this.model);
                    this.destroyView();
                    var view = this;
                    setTimeout(function(){
                        view.initialize();
                        if(callback){
                            callback();
                        }
                    });

                },

                setRenderedFalse: function(model){
                    model.childList.each(function(child) {
                        child.set('rendered', false);
                        this.setRenderedFalse(child);
                    }, this)
                },

                reorderChilds: function(){},
                render: function()
                {
                    if(_templates[this.partial])
                    {
                        // trace(this.model.attributes);
                        this.$el = $(_templates[this.partial].render($.extend(true,{},TRANSLATIONS, this.model.attributes)));
                    }
                    return this;
                },

                /** Tack for update functionality
                 * use createComponents to create components that need to be updated
                 *
                 * trackForUpdates will create changes specific for those components
                 * @items - object containing elements for tracking that are not added initialy
                 *
                 * updateComponent is general callback for updates
                 *
                 * Called when some of the attributes of the model are changed.
                 * The method checks in components object in current view for the key of the changed
                 * attribute and if such key exist takes action
                 *
                 * componets - object that contains monitored attributes of the views model
                 * contains objects in a following format {elem: "", action: "", callback: ""}
                 * @elem jQuery object: points to dom element that needs to change
                 *
                 * @action string/function not required: action is function that is executed and suposed to change the elem.
                 * If string the code asumes that this is jQuery method and will try to directly implement it to the elem with argument the new value.
                 * Example: {elem: $(".my-element"), action: "val"}
                 * 	is equal to $(".my-element").val(value);
                 * If function the codes will execute that function with applyed variables
                 * Example: {elem: $(".mu-element"), action: myFunction"}
                 *  is equl to myFunction(new_value, prev_value, element, key, view);
                 *  where
                 *  new_value : the new value of the attribute
                 *  prev_value: the previous value of the attribute
                 *  element : the jQuery element that is suposed to be updated
                 *  key: the key of the attribute changed
                 *  view: reference to the view instance
                 *
                 *  @callback function not required: function that will be executed after the action.
                 *  The function takes new_value, prev_value, element, key, view as arguments. Look at action function for details!
                 */
                trackForUpdate: function(items)
                {
                    var forRegistration = {};

                    if(!items)
                    {
                        if(this.components && !_.isEmpty(this.components))
                        {
                            forRegistration = this.components;
                        }
                    }
                    else
                    {
                        if(_.isObject(items) && !_.isEmpty(items)){
                            forRegistration = items;
                        }
                    }

                    if(_.isEmpty(forRegistration))
                    {
                        return;
                    }


                    // if (!this.eventsChangeList) this.eventsChangeList = [];
                    var $this = this;

                    _.each(forRegistration, function(value, key){
                        // if ($this.eventsChangeList.indexOf(key) == -1) {
                            $this.listenTo($this.model, "change:" + key, $this.updateComponent);
                            // $this.eventsChangeList.push(key);
                        // }
                    });

                },
                updateComponent: function(model, value, options, key){

                    if(this.components[key] == undefined){
                        return;
                    }

                    var element 	= this.components[key].elem,
                        action 		= this.components[key].action,
                        callback 	= this.components[key].callback,
                        prev_value 	= model.previousAttributes()[key];

                    if(typeof action == 'function')
                    {
                        //execute the function
                        action(value, prev_value, element, key, this);
                    }
                    //else if action is string
                    else if(typeof action == 'string') {
                        // No need of try catch
                        var callAction = true;
                        if(action === 'html'){

                            var dataValueAttribute = element.attr('data-value');
                            if (typeof dataValueAttribute !== typeof undefined && dataValueAttribute !== false) {
                                element.attr('data-value', value)
                            }

                            var replaceHtmlValue = element.attr('update-inner');
                            if (typeof replaceHtmlValue !== typeof undefined && replaceHtmlValue != false) {
                                if(replaceHtmlValue == 'false'){
                                    callAction = false;
                                }
                            }

                        }

                        if(callAction){
                            element[action](value);
                        }
                    }

                    //if callback is function
                    if(typeof callback == 'function')
                    {
                        //execute the callback
                        callback(value, prev_value, element, key, this);
                    }

                },
                /**
                 * Populates components with elements based on "data-pca-autoupdate" attribute.
                 * This feature will trigger only if 'autoUpdate' propery of the view is set to true.
                 * NOTE: "pushComponents" will overwrite auto updated components completely
                 *
                 * HTML Example:
                 <div class="my-container">
                 <p data-pca-autoupdate="my_property" >{{ my_property }}</p>
                 </div>
                 */
                setAutoUpdates: function(){
                    if(!this.autoUpdate == true){
                        return;
                    }

                    var $this = this;
                    var elements = this.$el.find("[data-pca-autoupdate]");
                    elements.each(function(){
                        var $currentEl = $(this);
                        var item = $currentEl.attr("data-pca-autoupdate");
                        if(!$this.components.item)
                        {

                            // Added odd-span selector for now if we don't want the up/down class adding as well as the odd-holder functionality
                            // TODO remove that to behaviour as it should not be a part of pageComponent
                            if($currentEl.hasClass('odd-holder') || $currentEl.hasClass('odd-span') || $(this).hasClass('odd-holder-inline')) {

                                if($this.components[item]){
                                    // Allow multiple elements to be auto updated by the same model key
                                    $this.components[item].elem = $this.components[item].elem.add($currentEl);
                                }else {
                                    $this.components[item] =
                                        {

                                            "elem": $currentEl,
                                            action: function (value, prev_value, $elements, key, ths)
                                            {

                                                var currentOddsType = ths.model.getParent('CCU').get('odd_format'),
                                                    newOddsType = Config.ODD_FORMAT;


                                                var $oddHolder = $elements.filter('.odd-holder');
                                                $oddHolder.removeClass("up");
                                                $oddHolder.removeClass("down");
                                                $oddHolder.prop('id', value.id);

                                                $elements.html(ths.beforeUpdateOdd ? ths.beforeUpdateOdd(value.odd) : value.odd);

                                                if(prev_value && prev_value.odd != '' && value.odd != '')
                                                {
                                                    var prevVal = $(prev_value.odd);
                                                    var currVal = $(value.odd);
                                                    var oldOdd = 0;
                                                    var newOdd = 0;


                                                    if(prevVal.length > 1)
                                                    {
                                                        oldOdd = parseFloat(prevVal[1].innerHTML);
                                                    }
                                                    else
                                                    {
                                                        oldOdd = parseFloat(prevVal[0].innerHTML);
                                                    }

                                                    if(currVal.length > 1)
                                                    {
                                                        newOdd = parseFloat(currVal[1].innerHTML);
                                                    }
                                                    else
                                                    {
                                                        newOdd = parseFloat(currVal[0].innerHTML);
                                                    }

                                                    oldOdd = (isNaN(oldOdd) ? 0 : oldOdd);

                                                    newOdd = (isNaN(newOdd) ? 0 : newOdd);

                                                    if(oldOdd != 0 && newOdd != 0 && (newOddsType == currentOddsType))
                                                    {
                                                        // console.info(value.odd.length);
                                                        // console.info(value.odd);

                                                        if(oldOdd > newOdd)
                                                        {
                                                            $oddHolder.addClass("down");
                                                            setTimeout(function(){$oddHolder.removeClass("down");}, 7000);
                                                        }
                                                        else
                                                        {
                                                            $oddHolder.addClass("up");
                                                            setTimeout(function(){$oddHolder.removeClass("up");}, 7000);
                                                        }
                                                    }
                                                }

                                                //TODO do we need that?
                                                if($elements.hasClass("main-odd")) {
                                                    if($elements.parents(".event-column-market").text().trim().length) {
                                                        if(!$elements.parents(".main-market-option").hasClass("d-table-row")) {
                                                            $elements.parents(".main-market-option").removeClass("d-none").addClass("d-table-row");
                                                        }
                                                    } else {
                                                        if(!$elements.parents(".main-market-option").hasClass("main-markets")) {
                                                            $elements.parents(".main-market-option").removeClass("d-table-row").addClass("d-none");
                                                        }
                                                    }
                                                }
                                            }
                                        };
                                }
                                // trace('adding handler for:' + item);

                            }
                            else
                            {
                                if($this.components[item]){
                                    // Allow multiple elements to be auto updated by the same model key
                                    $this.components[item].elem = $this.components[item].elem.add($currentEl);
                                }else {
                                    $this.components[item] = {"elem": $currentEl, "action": "html"};
                                }
                            }

                        }
                    });
                },

                /** executeOnTime
                 * In order to use single timer for all timed events executeOnTime is called on Chron_onTime event
                 * To add this listener check "controlChron" method
                 *
                 * Every time the method is called it checks if the views propery timers is empty or not.
                 * If timers is empty it calls for controlChron("stop") to remove the Chron_onTime listener
                 * If timers is not empty it loops them and takes action
                 * Every time in timers shoul have the following structure
                 * {
						 * 		time: "",
						 * 		arguments: "", //not required
						 * 		callback: ""
						 * }
                 *  @time : Delay in seconds before the callback is called. If set to 0 will trigger execution on next tick.
                 *  @arguments : one or more arguments that will be applyed to the callback when it is called
                 *  @callback function : called when the time is up
                 *
                 *  All timers are ment to be one time only. If you want to update the time property of given timer you can do it
                 *  directly via view.timers[key]
                 *
                 *  After the callback is called the timers is deleted from timers and if you want to use them again you need to recreate them.
                 */
                executeOnTime: function(){
                    //store current view reference
                    var $this = this;

                    //loop all timers for the view
                    _.each($this.timers, function(value, key)
                    {
                        //if time is 0
                        if(value.time == 0)
                        {
                            //check if callback is a function and execute it
                            if(typeof value.callback == 'function')
                            {
                                value.callback.apply($this, value.arguments);
                            }
                            //delete the timer from timers
                            delete $this.timers[key];
                        }
                        //else if time is not 0
                        else
                        {
                            //reduce 1 from the time
                            value.time = value.time - 1;
                        }
                    });

                    //if timers is empty
                    if(_.isEmpty(this.timers))
                    {
                        //remove listener for Chron_onTime
                        this.controlChron("stop");
                    }
                },
                /** controlChron
                 * Adds or Removes event listener for Chron_onTime
                 * @action string : takes "start" or "stop"
                 */
                controlChron: function(action)
                {
                    //if action is start
                    if(action == "start")
                    {
                        //check if the view is not alredy listening for Chron_onTime event
                        if(!this.listenFor("Chron_onTime"))
                        {
                            //if not listening add listener
                            this.on("Chron_onTime", this.executeOnTime);
                        }
                    }
                    //else if action is stop
                    else if(action == "stop")
                    {
                        //check if the view is listening for Chron_onTime event
                        if(this.listenFor("Chron_onTime"))
                        {
                            //if listening remove the listener
                            this.off("Chron_onTime");
                        }
                    }
                },
                beforeInitialize: function(){},
                createComponents: function(){},
                addToDom: function() {
                    if(this.model.get('renderElement') == false || this.model.get('rendered')){
                        return;
                    }
                    var rEl = this.render().$el;
                    if(this.targetEl instanceof jQuery){
                        this.targetEl.append(rEl);
                    }else{
                        $(this.targetEl).append(rEl);
                    }
                    this.model.set('rendered', true);
                },
                makeTargetEl: function(arguments)
                {
                    if(!this.targetEl)
                    {
                        this.targetEl = arguments[0].targetEl
                    }
                },
                setInnerTarget: function(){
                    if(this.innerTarget){
                        if(this.innerTarget === "self")
                        {
                            this.childTarget = this.$el;
                        }
                        else
                        {
                            this.childTarget = this.$el.find(this.innerTarget);
                        }
                    }
                },
                addListeners: function(){
                    if(!this.model.forceOrder){
                        this.listenTo(this.model.childList, "add", this.addOne);
                    }
                    this.listenTo(this.model, "remove", this.remove);
                },
                afterInitialize: function(){},
                pushEvents: function(push){
                    if(!this.events){
                        this.events = {};
                    }
                    _.extend(this.events, push);
                    this.delegateEvents();
                },
                pushComponents: function(push){

                    //trace(push);

                    this.components = $.extend(true, {}, this.components, push);

                    //trace(this.components);
                    this.trackForUpdate(push);
                },
                remove: function(){
                    this.onBeforeRemove();
                    this.$el.remove();
                    this.off();
                    this.stopListening();
                    this.model.set('rendered', false);
                },
                /**
                 * Search and return translation based on key
                 */
                localize: function(key)
                {
                    if(!key){
                        return false;
                    }

                    if(!TRANSLATIONS){
                        return key;
                    }

                    var path = key.split("."),
                        i = 0,
                        value = TRANSLATIONS;

                    for(i in path)
                    {
                        if(value[path[i]])
                        {
                            value = value[path[i]];
                        }
                        else
                        {
                            return 'JS.' + key;
                        }
                    }

                    return value;
                },

                onBeforeRemove: function(){},
                beforeChildViewAdd: function(){},
                afterChildViewAdd: function(){}
            });


            if(!_views["BaseListView"]){
                _views["BaseListView"] = view;
            }
            var check = new recursiveJsonDiff();
            if(check.isObject(value))
            {

                if(value.beforeInitializeBehaviours)
                {
                    _.each(
                        value.beforeInitializeBehaviours,
                        function(value)
                        {

                            //apply first global behaviour
                            if(
                                !check.isUndefined(_beforeInitializeBehaviours)
                                &&	!check.isNull(_beforeInitializeBehaviours)
                            )
                            {
                                if(
                                    !check.isUndefined(_beforeInitializeBehaviours[value])
                                    &&	!check.isNull(_beforeInitializeBehaviours[value])
                                )
                                {
                                    view = view.extend(_beforeInitializeBehaviours[value]);
                                }
                            }

                            //if some local overwrite is there apply it also
                            if(
                                !check.isUndefined(settings['beforeInitializeBehaviours'])
                                &&	!check.isNull(settings['beforeInitializeBehaviours'])
                            )
                            {
                                if(
                                    !check.isUndefined(settings.beforeInitializeBehaviours[value])
                                    &&	!check.isNull(settings.beforeInitializeBehaviours[value])
                                )
                                {
                                    view = view.extend(settings.beforeInitializeBehaviours[value]);
                                }
                            }
                        }
                    );
                }

                if(value.behaviours)
                {
                    _.each(
                        value.behaviours,
                        function(value)
                        {

                            //apply first global behaviour
                            if(
                                !check.isUndefined(_behaviours)
                                &&	!check.isNull(_behaviours)
                            )
                            {
                                if(
                                    !check.isUndefined(_behaviours[value])
                                    &&	!check.isNull(_behaviours[value])
                                )
                                {
                                    view = view.extend(_behaviours[value]);
                                }
                            }

                            //if some local overwrite is there apply it also
                            if(
                                !check.isUndefined(settings['behaviours'])
                                &&	!check.isNull(settings['behaviours'])
                            )
                            {
                                if(
                                    !check.isUndefined(settings.behaviours[value])
                                    &&	!check.isNull(settings.behaviours[value])
                                )
                                {
                                    view = view.extend(settings.behaviours[value]);
                                }
                            }
                        }
                    );
                }
            }
            _views[value.viewName + "View"] = view.extend(value);
        });

    };

    createElements(settings, componentName);
    var data = {};

    if(typeof window[initial_data] == "function"){
        //trace("initialData ", initial_data);
        data = window[initial_data]();
    }

    if(typeof initial_data === 'object'){
        data = initial_data
    }

    //CREATE CCU... uses the first model in the config
    var ccu = new _models[_firstModel]();
    ccu.set(ccu_info);
    if (data === false)
    {
        data = {};
        ccu.set("is_loaded", false);
    }
    else
    {
        ccu.set("is_loaded", true);
    }
    var CCUV;
    if(_views[_firstModel + "View"])
    {
        CCUV = new _views[_firstModel + "View"]({model: ccu});
    }
    else{
        CCUV = new _views['BaseListView']({model: ccu});
    }
    ccu.view = CCUV;
    ccu.view.componentName = componentName;
    if(typeof ccu.transformBeforeContent == 'function' ){
        data = ccu.transformBeforeContent(data);
    }
    ccu.content(data);
    CCUV.trigger(componentName + 'CCU_contentSet');

    return {
        content: function(data)
        {
            ccu.content(data);
        }
    }
}; /** ----------------- **/ 
 		var $templates 	= [],
			$behaviours = [],
            $beforeInitializeBehaviours = [],
        	$modelInitializeBehaviours = [];

		// var garbageCollectTimeout = false;

		var garbageCollect = function () {

			if(typeof(BaseConfig.get('DEBUG_MODE')) != "undefined" && BaseConfig.get('DEBUG_MODE') == true)
			{
				console.log('Skip GC');
				return;
			}

			console.log('GC');
			for (var key in $templates) {
				if (!/betslip/.test(key)) {
					if ($templates[key].tpl) {
						$templates[key].tpl.unset(key);
					}
					$templates[key].tpl = null;
				}
			}

			clearTimeout(garbageCollectTimeout);
			garbageCollectTimeout = false;

			// PARTIALS = null;
			getSidebarNavigation = null;
			getMiniSport = null;
			getCarousel = null;
			getBanners = null;
			getDateTimeMenu = null;
			getEventSlider = null;
			getBetSlipData = null;
			getHeaderIndicators = null;
			getFilterLeagues = null;
			getUserBalance = null;
			getOddTypes = null;
		};

		var render = function (data) {
			if (this.tpl == null) {
				this.tpl = twig({
					'data': this.value,
					'id': this.key,
					'allowInlineIncludes': true,
					'debug' : false
				});
			}

			// if (garbageCollectTimeout === false) {
			// 	garbageCollectTimeout = setTimeout(garbageCollect, 5000);
			// }

			return this.tpl.render(data);
		};

		//Creates and stores templastes via twig.js
		function createTemplates(templates)
		{
			_.each(templates, function(value, key){
				$templates[key] = {'value': value, 'tpl': null, 'key': key, 'render': render};
			});

			window["custom_twig_loader"] = function (key) {
				if (!$templates[key]) {
					return;
				}

				if ($templates[key].tpl == null) {
					$templates[key].tpl = twig({
						'data': $templates[key].value,
						'id': $templates[key].key,
						'allowInlineIncludes': true,
						'debug' : false
					});
				}
			};

			// if (garbageCollectTimeout === false) {
			// 	garbageCollectTimeout = setTimeout(garbageCollect, 5000);
			// }
		}

		function installBehaviours(){

            if(typeof window['getModelInitializeBehaviours'] == 'function'){
                $modelInitializeBehaviours = window['getModelInitializeBehaviours']();
            }

            if(typeof window['getBeforeInitializeBehaviours'] == 'function'){
				$beforeInitializeBehaviours = window['getBeforeInitializeBehaviours']();
            }
			if(typeof window['getBehaviours'] == 'function')
			{

				$behaviours = window['getBehaviours']();

			}
			else
			{
				trace("Warning! : Behavours are not loaded");
			}
		}
		/**
		 * Layout Builder
		 * Creates and changes the layouts
		 */

		var LayoutBuilder =(function(){
			var instance;
			function initialize(){
				//trace("create LayoutBuilder");
				var _page = Mediator.getMediator();
				var $this = {
					CONFIG: CONFIG()
					//DATA: INITIAL() // CHANGE THIS LATER ON

				}


				function backboneLayoutReady(config){
                    if(config.externalScripts){
                        var layoutName = typeof window['GETCURRENTLAYOUT'] == 'function' ? GETCURRENTLAYOUT() : '';
                        Mediator.getMediator().trigger('ExternalScriptsLoaded_' + layoutName);
                        if(typeof window.VueEventBus !== 'undefined'){
                            window.VueEventBus.$emit('backbone-layout-ready')
                        }else {
                            setTimeout(function() {
                                //Give some time for modern bundle to load and fire an error
                                if (window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
                                    window.ErrorTracker.trackError(new Error('App.js not loaded and cannot initialize'))
                                }
                            }, 3000)

                        }
                    }
				}

				/**
				 * Creates page layouts from initial configuration and supplied data
				 */
				function buildLayout(layout, data)
				{
					$builder = {
						data: data,
						//Creates layout type level

						addLevel_layout: function(level, parent){
							var config = level.config;

							//if we have partial
							if(config.partial)
							{
								if($templates[config.partial]){
									//render the partial
									var data = level.data || {};
									var newlevel = $templates[config.partial].render(data);
									//wrap the partial in a div element and cast it to jQuery object
									newlevel = $(newlevel);
									//is parent is supplied
									//TODO: add check for target if needed
									if(parent){
										//find the target in the parent and append the layout there
										//TODO: add other types of action
										$(parent).find(config.target).append(newlevel);
									}
									//else if no parent
									else
									{
										//find the target and append
										$(config.target).append(newlevel);
									}
									//trace(level);
									//return the jQuery object for use in the next tier

									return $(newlevel);
								}
								else
								{
									trace("Partial is missing or partial path is incorrect!");
									return parent;
								}
							}
							//if not partial return the parent
                            return parent;

						},

						//Creates plain type level
						//Plain types are simple prerendered partials that does not have complex functionality
						addLevel_plain: function(level, parent, key){
							//store data
                            if(level.skipBuild) {
                                return false;
                            }

                            var config = level.config,
								data = level.data || {};

							//check if partial exists
							if(config.partial){
								//create new level from partial
								//trace(config.partial);
								var newlevel = $templates[config.partial].render(data);
								//cast it to jQuery
								newlevel = $(newlevel);

								//check if target exists
								if(config.target){
									//find target in parent and append
                                    if(parent) {
                                        $(parent).find(config.target).append(newlevel);
                                    } else {
                                        $('body').find(config.target).append(newlevel);
                                    }
								}
								else
								{
									//else append to parent
									parent.append(newlevel);
								}
								//return the new level
								return newlevel;
							}
							//else if no partial we return
							else if(config.target)
							{
								//return the targeted element in the parent
								if(!parent){
									return false;
								}
								return parent.find(config.target);
							}
							//if no partial or target return the parent
                            backboneLayoutReady(config);
							return parent;
						},

						//Create modules from configuration files using pageComponent
						//TODO: Make me more pshhh (better but i dont know what you mean)...
						addLevel_module: function(level, parent, key){

                            if(level.skipBuild) {
                                return false;
                            }

                            if(typeof window[level.config.settings] == 'function'){
								var settings = window[level.config.settings]();
								//trace(level.config.initialData);

								// Socket patch
								var initialData = level.config.initialData;

								new pageComponent(settings, initialData, level.config.info, level.config.settings);

							}
							else
							{
								//trace("Module settins are missing:" + key);
							}
						}

					};

					//trace(layout);
					//call to build level to start the recursion
					buildLevel(layout);
					//Creates layout level based on type and and call for child level creation if
					//sub levels exist
					//Recursive method
					function buildLevel(level, key, parent){
						if(level){
							//create the current level and store its element
							var _level = $builder['addLevel_' + level.type](level, parent, key);

							//if any sublevels
							if(level.components){
								//loop all sublevels
								$.each(level.components, function(key, value){
									//call buildLevel and supply it with arguments
									//_level been the current level acts as parent for all childs
									buildLevel(value, key, _level);
								});
							}
						}
					}

				}

				//Public access to the LayoutBuilder
				return {
					//method that build layouts
					//TODO: make it dynamic
					build: function(){

						Dispatcher.getDispatcher();
						Chron.getChron();

						//prepare of partials with Twig.js and store them
						if(typeof window['PARTIALS'] == 'function'){
							createTemplates(PARTIALS());
						}
						else {
							return;
						}
						installBehaviours();
						//get current layout configuration
						var currentLayoutName = typeof window['GETCURRENTLAYOUT'] == 'function' ? GETCURRENTLAYOUT() : {}; //make it dependaple on initial state
						var currentLayout = $this.CONFIG.layouts[currentLayoutName];
						var globals = $this.CONFIG.globals;

						//build the layout based on the configuration and the data
						buildLayout(currentLayout, $this.DATA);
						//trace($this.CONFIG.globals);
						for(var key in globals){
							buildLayout(globals[key]);
						}

					},
					//sets some variables to the LayoutBuilder
					set: function(key, value)
					{
						$this[key] = value;
					}
				}
			}

			return {
				getLayoutBuilder: function(){
					if(!instance){
						instance = initialize();
					}
					return instance;
				}
			}
		})();
; /** ----------------- **/ 
 /**
		 * Mediator Core
		 * @returns
		 */

		var Mediator = (function(){
			var instance;

			function initialize()
			{
				//trace("create Mediator");

				//Private
				var $this = {
					info: "Mediator Core",
					//functions
					start: function(){

					},


					//Subscriptions
					events: {},

					//Adds new event listener
					on: function(event, fn, privateEvent){
						//if there is no such event create it
						if(!$this.events[event])
						{
							$this.events[event] = [];
						}

						var privateStatus = privateEvent || false;

						//subscribe the caller to this event
						$this.events[event].push({context: this, callback: fn, privateEvent: privateStatus});

						return this;
					},

					/*	Remove event listener
					 * 	@event string: the event that need be removed from the caller.
					 *  If the event parameter is not defined all events will be remove from that caller.
					 */
					off: function(event){
						//if specific event is defined
						if(event)
						{
							//Check if the event exist
							if(!$this.events[event])
							{
								return false;
							}

							removeListener(event, this);

							return this;
						}
						//else if event is not defined unsubscribe the caller from all events
						else
						{
							//iterate all events
							for(var key in $this.events)
							{
								removeListener(key, this);
							}

							return this;
						}

						//remove specific event listener
						function removeListener(event, what)
						{
							//var i = 0;

							//iterate all subscribers for this event
							// for(i in  $this.events[event])
							// {
							// 	if($this.events[event][i].context == what) //check if subscriber is a match
							// 	{
							// 		$this.events[event].splice(i, 1); //remove the subscriber
							// 	}
							// }
                            $this.events[event] = _.filter($this.events[event], function(view) {
                                return view.context != what;
                            });

							//check if there are subscibers for this event and remove the event if there is none
							if($this.events[event].length == 0)
							{
								delete $this.events[event];
							}
						}

					},

					//Check if some object listen to specific event
					listenFor: function(event)
					{
						if(!$this.events[event])
						{
							return false;
						}
						// trace('listening for: ' + event);
						//set variables
						var i = 0;
						//iterate all subscribers for this event
						for(i in $this.events[event])
						{
							if($this.events[event][i].context == this) //check if subscriber is a match
							{
								return true;
							}
						}

						return false;
					},
					//Fire event listener
					trigger: function(event)
					{
						//check if someone is subscribed to the event
						if(!$this.events[event])
						{
							return false;
						}
						// trace('triggering: ' + event);

						//get the arguments from the trigger call
						var args = Array.prototype.slice.call(arguments, 1);
						//add the caller on first place in the arguments
						args.unshift(this);

						var i = 0;

						//iterate all subscribers to this event and fire the callback
						for(i in $this.events[event])
						{
							if($this.events[event]){
                                var caller = $this.events[event][i];

                                if(
                                    caller
                                    && typeof caller.callback == 'function'
                                    && (
                                        !caller.privateEvent
                                        ||	caller.context == this
                                    )
                                )
                                {
                                    caller.callback.apply(caller.context, args);
                                }
							}

						}

						return this;
					}
				};

				//Public
				return {
					on : $this.on,
					off: $this.off,
					trigger: $this.trigger,
					listenFor: $this.listenFor,

					//Instal on/off/trigger to given object
					installTo: function(obj){
						obj.on = $this.on,
						obj.off = $this.off,
						obj.trigger = $this.trigger,
						obj.listenFor = $this.listenFor
					},

					//for debuging only.. returns full list of events and subscribers
					getEvents: function(){
						return $this.events;
					},

					//add some props to the Mediator
					set: function(key, value){
						$this[key] = value;
					}
				};
			}

			return {
				//returns single instance of the Mediator object
				getMediator: function(){
					if(!instance){
						instance = initialize();
					}
					return instance;
				}
			}

		}());; /** ----------------- **/ 
 /* IE FIXES START HERE */
// indexof workaround
if (!Array.prototype.indexOf)
{
  Array.prototype.indexOf = function(elt /*, from*/)
  {
    var len = this.length >>> 0;

    var from = Number(arguments[1]) || 0;
    from = (from < 0)
         ? Math.ceil(from)
         : Math.floor(from);
    if (from < 0)
      from += len;

    for (; from < len; from++)
    {
      if (from in this &&
          this[from] === elt)
        return from;
    }
    return -1;
  };
}

/* IE FIXES END HERE */

window.lock_threads = false;



var recursiveJsonDiff = function(newData, oldData) 
{
    return this.map(newData, oldData);
};
recursiveJsonDiff.prototype.map = function(newData, oldData)
{

    if (
    			this.isFunction(newData) 
    		||	this.isFunction(oldData)
    )
    {
        throw 'Invalid argument. Function given, object expected.';
    }

    if (
    			this.isValue(newData) 
    		||	this.isValue(oldData)
    )
    {
    	result = this.compareValues(newData, oldData);
    	if (result)
    	{

        	return newData||oldData; //newData || oldData;
    	}
    	return false;
    }

    var diff = false;

    for (var key in newData)
    {
        if (this.isFunction(newData[key])) 
        {
            continue;
        }

        var value2 = undefined;
        
        if (!this.isUndefined(oldData) && !this.isUndefined(oldData[key]))
        {
            value2 = oldData[key];
            delete oldData[key];
        }

        val = this.map(newData[key], value2);
        delete newData[key];

        if(val != false)
        {
        	if(!diff)
        	{
        		diff = {};
        	}
        	diff[key] = val;
        }
    }
    return diff;
};
recursiveJsonDiff.prototype.compareValues = function(value1, value2) 
{
    return value1 != value2;
};
recursiveJsonDiff.prototype.isUndefined = function (obj)
{
    return obj === undefined;
};
recursiveJsonDiff.prototype.isNull = function (obj)
{
    return obj === null;
};
recursiveJsonDiff.prototype.isFunction = function(obj) 
{
	var a = {};
    return a.toString.apply(obj) === '[object Function]';
};
recursiveJsonDiff.prototype.isArray = function(obj) 
{
	var a = {};
	return a.toString.apply(obj) === '[object Array]';
};
recursiveJsonDiff.prototype.isObject =  function(obj) 
{
	var a = {};
    return a.toString.apply(obj) === '[object Object]';
};
recursiveJsonDiff.prototype.isValue = function(obj) 
{
    return !this.isObject(obj) && !this.isArray(obj);
};



/**
 *  PAGE CONTROLLER CORE
 *  ver: 1.10
 *
 *  CID: 1.03
 */
(
	function()
	{
		var layout = false;
		function start(args)
		{
			layout.build();
		}
		$(
			function()
			{
				layout = LayoutBuilder.getLayoutBuilder();
				start();
			}
		);

	}
)(window);; /** ----------------- **/ 
 
function miniSport(){
    return {
        models:
            [
                {
                    modelName: "CCU",
                    childModel: "Sport"
                },
            ],
        views:
            [
                {
                    viewName: "CCU",
                    partial: "common/mini_sport/mini_sport_container",
                    innerTarget: "self",
                    componentName: 'miniSport',
                    beforeInitialize: function(){
                        this.targetEl = this.model.get("targetEl");
                    },
                    afterInitialize: function(){

                        if(typeof window.VueEventBus !== 'undefined'){
                            window.VueEventBus.$emit('mini-sport-ready')
                        }
                    },

                },
            ]
    }
}; /** ----------------- **/ 
 /**
* @TODO: change the interval to be 5 minutes. - done
* @TODO: In addition, trigger request after a bet is placed and after bet is denied.
*/

if (typeof window.balanceUpdater === 'undefined')
{
    window.balanceUpdater = null;
}

function userBalance(){
	return {
		models:
		[
		    {
			    modelName: "CCU",
			    childModel: "Item",

		    },
		    {
			    modelName: "Item"
		    }
		],
		views:
		[
		    {
			    viewName: "CCU",
			    partial: "common/user_balance/user_balance_container",
			    innerTarget: "self",
			    behaviours: ["pageUpdateHelper", "childReorder", "updateZendeskBalanceTags"],
                beforeInitializeBehaviours: ["currencyFullTitle"],
                beforeInitialize: function(){
				    this.targetEl = this.model.get("targetEl");
					window.updateBalanceTimeout = false;
					if(Config.PLUGIN_MODE && !Number(BaseConfig.get('IS_PROMOTIONS_ENABLED')) && !Config.BALANCE_POSITION){
                        this.model.set({
                            renderElement: false,
                        });
                    }
					if(Config.PLUGIN_MODE && Config.BALANCE_POSITION && Config.USER_LOGGED_IN) {
					    this.model.set({
                            balancePosition: Config.BALANCE_POSITION,
                        });
                    }
			    },
			    afterInitialize: function () {
				    /*if (window.WebPage) {
					    window.WebPage.sendMessage({
						    type: 'SET_USER',
						    payload: {
							    username: BaseConfig.get('MEMBER_USERNAME') ? BaseConfig.get('MEMBER_USERNAME') : '',
                                email: BaseConfig.get('MEMBER_EMAIL') ? BaseConfig.get('MEMBER_EMAIL') : '',
							    firstName: BaseConfig.get('MEMBER_FIRST_NAME') ? BaseConfig.get('MEMBER_FIRST_NAME') : '',
							    lastName: BaseConfig.get('MEMBER_LAST_NAME') ? BaseConfig.get('MEMBER_LAST_NAME') : '',
                                memberId: BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '',
                                memberPhone: BaseConfig.get('MEMBER_PHONE') ? BaseConfig.get('MEMBER_PHONE') : '',
							    balance: Config.USER_BALANCE,
							    currencyCode: Config.CURRENCY_CODE,
							    levelId: BaseConfig.get('MEMBER_LEVEL_ID'),
                                status: BaseConfig.get('MEMBER_STATUS') ? BaseConfig.get('MEMBER_STATUS') : '',
							    accountStatus: BaseConfig.get('ACCOUNT_STATUS'),
						    },
					    });
				    }*/
                    if(typeof window.VueEventBus !== 'undefined' && Config.USER_TYPE !== '1'){
                        window.VueEventBus.$emit('user-balance-ready')
                    }

                    var $this = this;
                    // only if logged
                    if (Config.USER_LOGGED_IN == 1 && window.balanceUpdater == null && !Config.CASINO_ORIENTED_SPORTSBOOK)
                    {
                        window.balanceUpdater = this.RequestCollector.addRequest({
                            "caller": this,
                            "method": "getMemberBalance",
                            "interval": 5 * 59,//interval to be 5 minutes
                            "repeat": true,
                            "callback": function (caller, response) {
                                $this.trigger("Balance_contentUpdated", response);
                            }
                        });
                    }
                    if(Config.USER_LOGGED_IN == 1 && BaseConfig.get('WALLETS') && !BaseConfig.get('IS_CASINO_MODE')){
                        this.getAvailableWallets();
                        this.on("UserBalance_setAllActiveBalances", this.setAllActiveBalances);
                    }
                    this.on("UserBalance_forceUpdate", this.forceUpdate);
                    this.on("UserBalance_UpdateAvailableWallets", this.updateAvailableWallets);
                    this.on("Balance_contentUpdated", function (caller, response) {
                        this.updateZendeskBalance(response.data);
                    	if(Config.PLUGIN_MODE){
                            delete response.data[1];
                            delete response.data[3];
						}
                    	this.updateUserGiftsData(response);
						var renderData = this.transformRenderData(response);
                        this.updateContent(this, renderData);
                    });

                    if(window.balanceUpdater){
                        window.balanceUpdater.executeRequest();
                    }

                    this.forceUpdate();
                },
                sessionBalanceItems: function (renderData) {
                    for(var k in renderData.data){
                        if(!this.model.get('balanceInitialized')){
                            renderData.data[k].action = 'insert';
                        }
                        if(renderData.data[k].info && renderData.data[k].info && renderData.data[k].info.initial_balance){
                            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_SESSION_BALANCE_DATA', renderData.data[k].info)
                            delete renderData.data[k];
                        }
                    }
                    return renderData;
                },
                transformRenderData: function(response){
                    var renderData = $.extend(true,{}, response);
                    renderData = this.sessionBalanceItems(renderData);
                    if(!this.model.get('balanceInitialized')){
                        this.model.set({
                            balanceInitialized: true,
                        });
                    }
                    return renderData;
                },
                updateUserGiftsData: function(data) {
                    var mutationsMap = {
                        'free-bet': 'user/SET_USER_FREE_BETS',
                        'free-spins': 'user/SET_USER_FREE_SPINS',
                        'monetary-offers': 'user/SET_USER_MONETARY_OFFERS',
                    };
                    var userGiftsTypes = ['free-bet', 'free-spins', 'monetary-offers'];
                    for(var k in data.data){
                        if(data.data[k].info && userGiftsTypes.indexOf(data.data[k].info.key) !== -1) {
                            var mutationType = mutationsMap[data.data[k].info.key]
                            if ($('.header-user-gifts')[0]) {
                                $('.header-user-gifts')[0].__vueParentComponent.appContext.config.globalProperties.$store.commit(mutationType, data.data[k].info);
                            }
                        }
                    }
                },
				getAvailableWallets: function(){
                    this.availableWallets = this.RequestCollector.addRequest({
                        "caller": this,
                        "method": "getAvailable",
                        "interval": 5 * 59,//interval to be 5 minutes
                        "repeat": true,
                        "callback": function (caller, response) {
                            if(response.status == 'success'){
                                this.trigger('UserBalance_UpdateAvailableWallets', response.data)
                            }
                        },
                        url: '/' + Config.LOCALE_SHORT + '/wallets/operation/getAvailable'
                    });

                    var view = this;
                    setTimeout(function(){
                        view.availableWallets.executeRequest();
                    }, 50)

                },
                updateAvailableWallets: function(caller, wallets){

					for(var walletKey in wallets){
						var matchedWalletModel = this.model.childList.findWhere({id: walletKey});
                        if(!matchedWalletModel && !this.model.childList.length){
                            return;
                        }
						if(!matchedWalletModel){
							var balanceTitle = this.model.childList.findWhere({id: "1"}).get('creditType');
                            var walletBalance = new this.models['Item']({
								id: walletKey,
								creditType: balanceTitle,
								amount: wallets[walletKey].money + ' ' + this.getCurrencyTitle(wallets[walletKey].currency_code),
								order: 0
                            });
                            this.model.childList.add(walletBalance);
                        }else{
                            matchedWalletModel.set('amount', wallets[walletKey].money + ' ' + this.getCurrencyTitle(wallets[walletKey].currency_code))
						}
					}

				},

                setAllActiveBalances: function(caller, value){
                    this.model.childList.each(function(model){
                        model.set('is_active', value);
                    })
                },

			    forceUpdate: function(){
					clearTimeout(window.updateBalanceTimeout);
					window.updateBalanceTimeout = setTimeout(function () {
                        if (window.balanceUpdater){
                            window.balanceUpdater.executeRequest();
                            window.balanceUpdater.resetInterval();
                        }
                    }, 1000, this);

					if(this.availableWallets){
                        this.availableWallets.executeRequest();
					}

                },
		    },
		    {
			    viewName: "Item",
			    partial: "common/user_balance/user_balance_item",
                beforeInitializeBehaviours: ["currencyFullTitle"],
			    autoUpdate: true,
				beforeInitialize: function(){
                    var balanceItemKey = this.model.get('key');
                    var skipRenderElementKeys = ['free-bet', 'free-spins', 'monetary-offers'];

			    	//Login To Take Only Sport Bonus
					if(Config.PLUGIN_MODE && (this.model.id == 1 || this.model.id == 3)){
			    		this.partial = '';
					}

                    if(BaseConfig.get('IS_CASINO_MODE') && this.model.id == 2){
                        this.partial = '';
                    }

                    if(skipRenderElementKeys.indexOf(balanceItemKey) !== -1){
                        this.model.set('renderElement', false);
                    }

					if(BaseConfig.get('WALLETS')){
					    this.model.set('wallets', true);
                        if(this.model.id == 1 && !Config.SPORT_WALLET){
                            this.model.set('is_active', 1);
                        }else if(this.model.id == Config.SPORT_WALLET){

                            var amount = this.model.get("amount");
                            var currentWalletCode = amount.split(' ')[1];
                            if(currentWalletCode){
                                var amount = amount.split(' ')[0] + ' ' + this.getCurrencyTitle(currentWalletCode);
                                this.model.set('amount', amount);
                            }

                            this.model.set('is_active', 1);
                        }else{
                            this.model.set('is_active', 0);
                        }
					}
				},
				afterInitialize: function(){
                    this.pushComponents({
                        is_active: {
                            callback: this.changeActiveBalance
                        }
                    });
                    this.on('UserBalance_setActiveBalance' + this.model.id, this.setActiveBalance);
                },
                setActiveBalance: function(caller, value){
				    this.model.set('is_active', value);
                },
                changeActiveBalance: function(value, prev_value, element, key, $this){
				    if(value){
                        $this.$el.addClass('active');
                    }else{
                        $this.$el.removeClass('active');
                    }
				}
		    }
		]
	}
}; /** ----------------- **/ 
 // since this component is initialized more than 1 time, there is an issue with multiple ajax requests
if (typeof window.balanceUpdater === 'undefined')
{
    window.balanceUpdater = null;
}

function userInfo(){
	return {
		models:
		[
		    {
			    modelName: "CCU",
			    childModel: "Item"
		    },
		    {
			    modelName: "Item"
		    }
		],
		views:
		[
		    {
			    viewName: "CCU",
			    partial: "common/user_info/user_info_container",
			    innerTarget: ".user-info",
			    behaviours: ["pageUpdateHelper"],
			    beforeInitialize: function(){
			    	if(Config.USER_TYPE == "1")
					{
	    			this.targetEl = this.model.get("targetEl");
					}
					// this is a workaround to fix many ajaxes. for some reason the component is initialized 4 times
					window.updateBalanceTimeout = false;
			    },
			    afterInitialize: function () {
                    var $this = this;
                    if(this.$el.parent().attr('id') === 'userInfoContainer'){
                        //If on member/results pages, unwrap the element to fit structure.
                        this.$el.unwrap();
                    }
                    // only if logged
                    if (Config.USER_LOGGED_IN == 1 && window.balanceUpdater == null)
                    {
                        window.balanceUpdater = this.RequestCollector.addRequest({
                            "caller": this,
                            "method": "getMemberBalance",
                            "interval": 5 * 59,//interval to be 5 minutes
                            "repeat": true,
                            "callback": function (caller, response) {
                                $this.trigger("Balance_contentUpdated", response);
                            }
                        });
                    }
                    this.on("UserBalance_forceUpdate", this.forceUpdate);
                    this.on("Balance_contentUpdated", function (caller, response) {
                        var renderData = this.transformRenderData(response);
                        $this.updateContent(this, renderData);
                        if(document.getElementsByClassName("cl-header-user-services").length){
                            document.getElementsByClassName("cl-header-user-services")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
                        }
                    });

                    if(window.balanceUpdater){
                        window.balanceUpdater.executeRequest();
					}

			    },
			    events: {
					'click .username_refresh': 'forceUpdate',
				},
			    forceUpdate: function(){
                    clearTimeout(window.updateBalanceTimeout);
                    window.updateBalanceTimeout = setTimeout(function () {
                        if (window.balanceUpdater){
                            window.balanceUpdater.executeRequest();
                            window.balanceUpdater.resetInterval();
                        }
                    }, 1000, this);
                },
                transformRenderData: function(response){
                    var renderData = $.extend(true,{}, response);

                    if(!this.model.get('userInfoInitialized')){
                        this.model.set({
                            userInfoInitialized: true,
                        });
                        for(var k in renderData.data){
                            renderData.data[k].action = 'insert';
                        }
                    }
                    return renderData;
                },
		    },
		    {
			    viewName: "Item",
			    partial: "common/user_info/user_info_item",
			    autoUpdate: true,
		    }
		]
	}
}
; /** ----------------- **/ 
 function userWallets() {
    return {
        models:
            [
                {
                    modelName: "CCU"
                }
            ],
        views:
            [
                {
                    viewName: "CCU",
                    partial: "common/user_wallets/user_wallets",
                    beforeInitializeBehaviours: ["currencyFullTitle"],
                    events: {
                        "click .wallet-option":	"selectWallet"
                    },
                    beforeInitialize: function () {
                        this.targetEl = this.model.get("targetEl");

                        var currentWalletCode = Config.CURRENCY_CODE;
                        if(Config.SPORT_WALLET_INFO){
                            currentWalletCode = Config.SPORT_WALLET_INFO.currency_code;
                        }
                        this.model.set({
                            defaultCurrencyCode: Config.CURRENCY_CODE,
                            currentWalletCode: currentWalletCode,
                            currentWalletTitle: this.getCurrencyTitle(currentWalletCode)
                        })

                        // Config.SPORT_WALLET
                    },
                    afterInitialize: function () {
                        this.on('UserBalance_UpdateAvailableWallets', this.renderAvailableWallets);

                        this.switchWallet = this.RequestCollector.addRequest({
                            caller: this,
                            status: 'inactive',
                            resetOnResponse: false,
                            method: "switchWallet",
                            filters: {},
                            callback: function (caller, response) {
                                if(response.status == 'success'){
                                    var wallet = this.model.get('currentWallet');
                                    if(wallet == 'default'){
                                        wallet = 1;
                                    }
                                    this.trigger('UserBalance_setAllActiveBalances', 0);
                                    this.trigger('UserBalance_setActiveBalance' + wallet, 1);
                                    setTimeout(function () {
                                        this.location.reload();
                                    }, 500);
                                }
                            },
                            url: '/' + Config.LOCALE_SHORT + '/wallets/operation/switch'
                        });

                    },
                    renderAvailableWallets: function(caller, wallets){
                        var $dropDownMenu = this.$el.find('.dropdown-menu-wallet');
                        if(Config.IS_MOBILE){
                            $dropDownMenu.find('.additional-wallet-option').remove();
                        }
                        for(var wallet in wallets){
                            $dropDownMenu.prepend(this.templates["common/user_wallets/user_wallet_item"].render({
                                currencyCode: wallets[wallet].currency_code,
                                walletCode: wallet,
                                walletTitle: this.getCurrencyTitle(wallets[wallet].currency_code),
                                is_active: this.model.get('currentWalletCode') == wallets[wallet].currency_code ? 1 : 0
                            }));
                        }

                        //Move to the end of the call stack else the event will be removed from mediator trigger list loop
                        //And wont be handled properly when multiple subscriptions
                        var view = this;
                        setTimeout(function(){
                            view.off('UserBalance_UpdateAvailableWallets');
                        });
                    },
                    selectWallet: function(e){
                        var $selectedWallet = $(e.currentTarget);
                        if($selectedWallet.hasClass('active')){
                            return;
                        }
                        var selectedWalletCode = $selectedWallet.attr('data-currency');
                        this.$el.find('.wallet-option').removeClass('active');
                        this.$el.find('.selected-currency-code').text($selectedWallet.text());
                        $selectedWallet.addClass('active');
                        this.model.set('currentWallet', selectedWalletCode);
                        this.switchWallet.updateFilters({
                            wallet: selectedWalletCode
                        });
                        this.switchWallet.executeRequest();
                    }

                },

            ]
    }
}; /** ----------------- **/ 
 function walletTransfer() {
    return {
        models:
            [
                {
                    modelName: "CCU"
                }
            ],
        views:
            [
                {
                    viewName: "CCU",
                    partial: "common/user_wallets/user_wallets_modal",
                    behaviours: ['pageUpdateHelper'],
                    beforeInitializeBehaviours: ["currencyFullTitle"],
                    autoUpdate: true,
                    events: {
                        "click .wallet-option": "selectWallet",
                        "input .buy-input-field": "buyInput",
                        "change .buy-input-field": "buyInputOnChange",
                        "input .sell-input-field": "sellInput",
                        "change .sell-input-field": "sellInputOnChange",
                        "a[data-toggle='tab'] shown.bs.tab": "changeMode",
                        "click .confirm-wallet-transfer": "confirmWalletTransfer",
                    },
                    beforeInitialize: function () {
                        this.targetEl = 'body';
                        this.model.set({
                            defaultCurrencyCode: Config.CURRENCY_CODE,
                            mode: 'default',
                            isMobile: !!Config.IS_MOBILE,
                        });
                    },
                    afterInitialize: function () {
                        var view = this;
                        this.$el.find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                            view.changeMode(e);
                        });

                        this.on('UserBalance_UpdateAvailableWallets', this.setAvailableWallets);
                        this.on('Balance_contentUpdated', this.getUserBalance);
                    },

                    confirmWalletTransfer: function(e){

                        var fromWallet = 'default';
                        var toWallet = this.model.get('wallet');
                        var amount = this.$el.find('.buy-input-field').val();

                        if(this.model.get('mode') == 'wallet'){
                            fromWallet = this.model.get('wallet');
                            toWallet = 'default';
                            amount = this.$el.find('.sell-input-field').val();
                        }

                        if(!amount){
                            return;
                        }

                        var $tabContent = this.$el.find('.tab-content'),
                            $alertTarget = this.$el.find('.error-container'),
                            view = this;
                        $.ajaxRequest('transfer', {
                            toastr: false,
                            request: {
                                url: "/" + Config.LOCALE_SHORT + "/wallets/operation/transfer"
                            },
                            loadAction: $tabContent,
                            alert: {
                                $el: $alertTarget
                            },
                            extraData: {
                                amount: amount,
                                from_wallet: fromWallet,
                                to_wallet: toWallet,
                            },
                            onSuccess: function() {
                                view.trigger('UserBalance_forceUpdate');
                                view.$el.modal('hide');
                                view.$el.find('.form-control').val('').trigger('change');
                            }
                        });
                    },
                    changeMode: function(e){
                        var $selectedTab = $(e.currentTarget);
                        var mode = 'default';
                        if($selectedTab.attr('href') == '#nav-sell'){
                            mode = 'wallet';
                        }
                        this.model.set({
                            mode: mode
                        })
                    },
                    getUserBalance: function(caller, response){
                        if(response.data && response.data[1]){
                            var  defaultBalance = Config.USER_TYPE == '1' ?
                                Number(response.data[1].info.bet_credit_amount.replace(/[^0-9.-]+/g,"")) : Number(response.data[1].info.amount.replace(/[^0-9.-]+/g,""));
                            this.model.set({
                                defaultBalance: defaultBalance
                            })
                        }
                    },
                    convertToDecimal: function(string){
                        return string.replace(/[^\d.]/g, '').replace(/\.([.\d]+)$/, function(m, m1) {
                            return '.' + m1.replace(/\./g, '')
                        });
                    },
                    buyInput: function(e){
                        var $input = $(e.currentTarget);
                        var inputValue = this.convertToDecimal($input.val());

                        if(Number(inputValue)> this.model.get('defaultBalance')){
                            inputValue = this.model.get('defaultBalance');
                        }
                        $input.val(inputValue);
                        this.updateBuyOutputValue(inputValue);
                    },
                    buyInputOnChange: function(e){
                        var $input = $(e.currentTarget);
                        this.buyAmountOnChange($input);

                    },
                    sellInput: function(e){
                        var $input = $(e.currentTarget);
                        var inputValue = this.convertToDecimal($input.val());

                        if(Number(inputValue)> this.model.get('walletBalance')){
                            inputValue = this.model.get('walletBalance');
                        }
                        $input.val(inputValue);
                        this.updateSellOutputValue(inputValue);
                    },
                    updateSellOutputValue: function(inputValue){
                        var $sellOutput = this.$el.find('.sell-output-value');

                        if(!isNaN(parseFloat(inputValue))){
                            var exchangeRate = Number(this.model.get('walletSellExchangeRate'));
                            var calculated = inputValue * exchangeRate;
                            $sellOutput.text(calculated.toFixed(2));
                        }else{
                            //not a valid number
                        }
                    },
                    sellInputOnChange: function(e){
                        var $input = $(e.currentTarget);
                        this.sellAmountOnChange($input);
                    },
                    updateBuyOutputValue: function(inputValue){
                        var $buyOutput = this.$el.find('.buy-output-value');

                        if(!isNaN(parseFloat(inputValue))){
                            var exchangeRate = Number(this.model.get('walletBuyExchangeRate'));
                            var calculated = inputValue * exchangeRate;
                            $buyOutput.text(calculated.toFixed(2));
                        }else{
                            //not a valid number
                        }
                    },
                    sellAmountOnChange: function($input){
                        var inputValue = $input.val();
                        if(inputValue != '.' && inputValue != 0){
                            inputValue = parseFloat(inputValue);
                            this.updateSellOutputValue(inputValue);
                        }else{
                            inputValue = '';
                            this.updateSellOutputValue(0);
                        }
                        $input.val(inputValue);
                    },
                    buyAmountOnChange: function($input){
                        var inputValue = $input.val();
                        if(inputValue != '.' && inputValue != 0){
                            inputValue = parseFloat(inputValue);
                            this.updateBuyOutputValue(inputValue);
                        }else{
                            inputValue = '';
                            this.updateBuyOutputValue(0);
                        }
                        $input.val(inputValue);
                    },
                    setAvailableWallets: function (caller, wallets) {

                        // This needs to be refactored for more than one available wallets
                        for(var k in wallets){
                            this.model.set({
                                walletBuyExchangeRate: parseFloat(wallets[k].currency_rate_buy),
                                walletBuyReverseRate: parseFloat(1 / wallets[k].currency_rate_buy),
                                walletSellExchangeRate: parseFloat(wallets[k].currency_rate_sell),
                                walletSellReverseRate: parseFloat(1 / wallets[k].currency_rate_sell),
                                walletCurrencyCode: wallets[k].currency_code,
                                walletCurrencyTitle: this.getCurrencyTitle(wallets[k].currency_code),
                                walletBalance: wallets[k].money,
                                wallet: k
                            });
                        }
                    }

                },

            ]
    }
}; /** ----------------- **/ 
 function headerIndicators(){
    return {
        models:
            [
                {
                    modelName: "CCU",
                },
            ],
        views:
            [
                {
                    viewName: "CCU",
                    behaviours: ["pageUpdateHelper"],
                    afterInitialize: function () {
                        this.filters = {};
                        var view = this;
                        this.updater = this.RequestCollector.addRequest({
                            "caller": this,
                            "method": "updateHeaderIndicatorsV2",
                            "filters": function (){ return view.generateFilters();},
                            "interval": 30, // requests interval to be 30 seconds
                            "repeat": true,
                            "callback": this.updateContent
                        });

                        setTimeout(function () {
                            view.updater.executeRequest();
                        }, 500);

                        view.on("HeaderIndicators_forceUpdate", this.forceUpdate);

                        window.VueEventBus.$on('successful-registration', function (){
                            if (view.updater) {
                                view.updater.destroy();
                            }
                        });
                    },
                    updateContent: function(caller, data){
                        var messagesData = {};
                        var tickersData = {};
                        if(data.status == "success" && data.data){
                            this.containersData = this.createContainersData(data.data);
                            messagesData['messages'] = Object.assign({}, data.data.messages);
                            tickersData['tickers'] = Object.assign({}, data.data.tickers);

                            this.trigger("updatedHeaderIndicators_messages", messagesData);
                            this.trigger("updatedHeaderIndicators_tickers", tickersData);

                            if(document.getElementById('appComponents') && document.getElementById('appComponents').__vueParentComponent){
                                document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_HEADER_INDICATORS', data.data);
                            }
                        }

                        var customFilters = this.model.get('customFilters');

                        if(!_.isEmpty(customFilters)) {
                            this.clearCustomFilters();
                        }
                    },
                    createContainersData: function(data){
                        var containersData = {};
                        for(var k in data){
                            containersData[k] = ""
                        }
                        return containersData;
                    },
                    generateFilters: function () {
                        this.filters.containers = JSON.stringify(this.containersData);
                        return this.filters;
                    },
                    clearCustomFilters: function() {
                        var customFilters = this.model.get('customFilters');

                        for (var filter in customFilters) {
                            delete this.filters[filter];
                        }

                        this.model.set('customFilters', {});
                    },
                    forceUpdate: function (caller, data) {
                        if(!this.updater){
                            return;
                        }

                        if(data) {
                            this.model.set('customFilters', data);
                            for (var filter in data) {
                                this.filters[filter] = data[filter];
                            }
                        }

                        this.updater.executeRequest();
                    }
                }
            ]
    }
}
; /** ----------------- **/ 
 function serviceMessages(){
    return {
        models:
            [
                {
                    modelName: "CCU",
                    childModel: "Messages",
                },
                {
                    modelName: "Messages",
                    childModel: "Message"
                },
                {
                    modelName: "Message"
                }
            ],
        views:
            [
                {
                    viewName: "CCU",
                    partial: "common/messages/message_inbox_container",
                    innerTarget: "self",
                    beforeInitialize: function() {
                        this.targetEl = this.model.get("targetEl");
                    },
                    afterInitialize: function () {
                        this.on("updatedHeaderIndicators_messages", this.updateContent);
                        this.on("startListenForPrivateMessage", this.addDispatcherListener);
                    },
                    updateContent: function(caller, data){
                        this.model.content(data);
                    },
                    addDispatcherListener: function(caller, redirectHref){
                        this.model.set('redirectHref', redirectHref);
                        this.on("Dispatcher_returnData_markPopUpMarketingPrivateMessageAsSeen", this.privateMessageSeenComplete);
                    },
                    privateMessageSeenComplete: function(){
                        if (typeof window.browserRedirectTo === 'function') {
                            window.browserRedirectTo(this.model.get('redirectHref'))
                        } else {
                            console.error('Cannot use browserRedirectTo, falling back to window.location.href')
                            // @window-location-ignore
                            window.location.href = this.model.get('redirectHref')
                        }
                    }
                },
                {
                    viewName: "Messages",
                    partial: "common/messages/message_inbox_element",
                    autoUpdate: true,
                    beforeInitialize: function(){
                        this.model.set("status", 0);
                        this.model.set("inbox_url", Config.INBOX_URL);
                        if((Config.KYC_CONFIG.sof && Config.KYC_CONFIG.sof !== 'verified') || (Config.KYC_CONFIG.sow && Config.KYC_CONFIG.sow !== 'verified')) {
                            this.model.set("hasCustomNotification", true);
                        }
                    },
                    afterInitialize: function(){
                        this.pushComponents({
                            "count": {"callback": this.evaluateMessageCount}
                        });

                        if(this.model.get("id") != "messages") {
                            this.remove();
                        }

                        this.on("HeaderIndicators_updateCountOnMarkMessageAsRead", this.updateCountOnMarkMessageAsRead);
                        this.evaluateMessageCount(null, null, null, null, this)

                    },
                    evaluateMessageCount: function(value, prev_value, element, key, $this){
                        if((value != "" && value !== null) || $this.model.get("hasCustomNotification")){
                            $this.$el.find(".message-inbox-item").addClass("active");
                        } else {
                            $this.$el.find(".message-inbox-item").removeClass("active");
                        }
                    },
                    updateCountOnMarkMessageAsRead: function (caller, updateCount = 1){
                        this.model.set("count", this.model.get("count") - updateCount);
                    },
                },
                {
                    viewName: "Message",
                    targetEl : "body",
                    events: {
                        'click button[data-dismiss="modal"]' : 'closeMessage',
                        'click .marketing-close-btn': 'closeMarketingPrivateMessage',
                        'click .marketing-redirect-url': 'marketingRedirectUrl',
                    },
                    beforeInitialize: function() {
                        var messageType = this.model.get("type");
                        var modelParent = this.model.parent.get("id");
                        this.model.set('cashier', Config.CASHIER);

                        if(Config.PLUGIN_MODE && Config.IS_POPUP_MESSAGES_DISABLED) {
                            this.closeMessage();
                            return;
                        }

                        if(Config.PLUGIN_MODE && this.model.get("message_data") && this.model.get("message_data")['type'] === "coupon_activated") {
                            this.closeMessage();
                            return;
                        }

                        if(this.model.get("message_data") && (typeof this.model.get("message_data")['type'] !== "undefined") && (this.model.get("message_data")['type'] === "coupon_activated")) {
                            this.model.set('showDepositBtn', true);
                        }

                        //Temp fix for disabling multiple messages piling up one over another
                        if(Config.USER_SESSION_LIMIT_REACHED || Config.USER_STATUS === "suspended" || messageType === 'reality_check') {
                            return;
                        }

                        if (modelParent === 'marketing_private_messages' && messageType !== 'reality_check') {
                            this.model.set({
                                localeShort: Config.LOCALE_SHORT
                            });
                            this.partial = "common/messages/marketing_private_message_modal";
                        } else {
                            this.partial = "common/messages/message_modal";
                        }
                    },
                    afterInitialize: function() {
                        if(typeof window.VueEventBus !== 'undefined' && Config.USER_TYPE !== '1' ){
                            window.VueEventBus.$emit('new-deposit-button', {
                                target: '#userServiceMessageDepositButtonPlaceholder',
                                props: {
                                    customClass: 'btn btn-sm btn-action-submit text-uppercase w-50',
                                    noDefaultClass: true,
                                }
                            })
                        }

                        this.checkForPendingMessages();
                    },
                    closeMessage: function(e){
                        this.trigger('Dispatcher_requestData', 'markPopUpMessageAsSeen', {id:this.model.id});
                        this.model.getParent("Messages").childList.remove(this.model.id);

                        var messages = document.getElementsByClassName('message-item');
                        var view = this;
                        Array.prototype.forEach.call(messages, function(item) {
                            if(item.classList.contains('new') && item.__vueParentComponent && item.__vueParentComponent.ctx._.props.id === view.model.id) {
                                $.ajaxRequest('markAsReadMessage', {
                                    toastr: false,
                                    extraData: {
                                        parent_id: item.__vueParentComponent.ctx._.props.id
                                    },
                                    onSuccess: function() {
                                        item.classList.remove('new');
                                        Mediator.getMediator().trigger("HeaderIndicators_updateCountOnMarkMessageAsRead", this.updateCountOnMarkMessageAsRead);
                                    }
                                });
                            }
                        });

                        this.checkForPendingMessages();
                        this.$el.on('hidden.bs.modal', function () {
                            if($('.modal:visible').length) {
                                window.getBodyClassList().add('modal-open');
                            }
                            view.model.getParent("Messages").childList.remove(view.model.id);
                        });
                    },
                    closeMarketingPrivateMessage: function(){
                        this.trigger('Dispatcher_requestData', 'markPopUpMarketingPrivateMessageAsSeen', {id:this.model.id});
                        this.model.getParent("Messages").childList.remove(this.model.id);
                    },
                    marketingRedirectUrl: function(e){
                        e.preventDefault();
                        this.closeMarketingPrivateMessage();
                        this.trigger('startListenForPrivateMessage', $(e.currentTarget).attr('href'));
                    },
                    checkForPendingMessages: function() {
                        var messagesArray = this.model.getParent("Messages").childList.models,
                            firstMessage = null;

                        firstMessage = messagesArray[0];

                        if(firstMessage && !firstMessage.get("is_shown")) {
                            $('#modal-' + firstMessage.id).modal('show');
                            firstMessage.set("is_shown", true);
                        }
                    },
                }

            ]
    }
}
; /** ----------------- **/ 
 if (Config.USER_LOGGED_IN == 1){
    function searchBox()
    {
        return {
            models: [
                {
                    "modelName": "CCU"
                }
            ],
            views : [
                {
                    "viewName"      : "CCU",
                    "partial"       : "common/search_box/search_box",
					searching: false,
                    events          : {
                        "click button": "performSearch",
                        "enter input" : "performSearch",
                        "input input" : "inputSearch"
                    },
                    beforeInitialize : function ()
                    {
                        this.targetEl = this.model.get("targetEl");
                        this.model.set("viewParams", getViewParams().viewParams);
                        this.on("IndexHome_onUpdateFromOutside", this.saveFilter);
                    },
                    saveFilter : function (caller, data)
                    {
                        this.model.set("viewParams", $.extend({}, data));
                    },
                    afterInitialize : function ()
                    {

                        if (window.location.href.indexOf('search')>=0){

                            if ( $('.search_title_container').length == 0)  {

                                $('.sport-table').before('<div class="search_title_container"><div class="inner_search_container"><i class="icon-search"></i><span class="search_main_title"></span></div></div>');
                                $('.euro-sport-page').before('<div class="search_title_container"><div class="inner_search_container"><i class="icon-search"></i><span class="search_main_title"></span></div></div>');
                            }

                            $('.search_main_title').text(TRANSLATIONS.search_title);
                            $('.sport-filters').hide();

                        }

                    },
                    inputSearch: function(e) {
                        $(e.currentTarget).removeClass('is-invalid');
                    },
                    performSearch : function ()
                    {
                    	if(this.searching){
                    		return;
						}
                        var $input = this.$el.find('input');
                        var searchText = $input.val();
                        var params = this.model.get('viewParams');

                        params.sport_id = [0]; // TODO: This will prevent search only for soccer

                        if (searchText.length >= 3)
                        {
                            $input.removeClass('is-invalid');
                            var searchUrl = '/' + [Config.LOCALE_SHORT, Config.CONTROLLER == 'euro' ? 'euro' : 'sport', 'search'].join('/') + '?search=' + searchText;
                            if(!Config.PLUGIN_MODE){
                                searchUrl = [Config.LOCALE_URL, Config.CONTROLLER_URL, 'search'].join('/') + '?search=' + searchText;
                            }
                            if (typeof window.browserRedirectTo === 'function') {
                                window.browserRedirectTo(searchUrl)
                            } else {
                                console.error('Cannot use browserRedirectTo, falling back to window.location.href')
                                // @window-location-ignore
                                window.location.href = searchUrl
                            }
							this.searching = true;
                        } else {
                            $input.addClass('is-invalid');
                        }
                    }
                }
            ]
        }
    }
}
; /** ----------------- **/ 
 /*
 * Ver 1.03
 *
 * CID: 1.00
 */

function filterLeagues() {
	return {
		models:
				[
					{
						modelName: "CCU",
						beforeInsert: function (data, key) {
							switch (key) {
								case "basic":
									this.childModel = "FilterTypeBasic";
									break;
								case "sport_list":
									this.childModel = "FilterTypeSportList";
									break;
								case "mix_parlay":
									this.childModel = "FilterTypeMixParlay";
									break;
							}
						}
					},
					// Basic filter

					{
						modelName: "FilterTypeBasic",
						childModel: "Sport"
					},
					{
						modelName: "Sport",
						childModel: "Category"
					},
					{
						modelName: "Category",
						childModel: "League",
						forceOrder: true,
						modelInitializeBehaviours: ['orderByTitle']
					},
					{
						modelName: "League"
					},
					// Sport List

					{
						modelName: "FilterTypeSportList",
                        forceOrder: true,
                        modelInitializeBehaviours: ['orderComparator'],
						childModel: "SportOptionFakeUpdate"
					},
					{
						modelName: "SportOptionFakeUpdate"
					},
					// Mix Parlay Filter

					{
						modelName: "FilterTypeMixParlay",
						beforeInsert: function (data, key) {
							if (key.substring(0, 12) === 'sport_option')
							{
								this.childModel = "SportOption";
							}
							else
							{
								this.childModel = "Category_mix_parlay";
							}

						}
					},
					{
						modelName: "SportOption"
					},
					{
						modelName: "Category_mix_parlay",
						childModel: "Sport_mix_parlay"
					},
					{
						modelName: "Sport_mix_parlay",
						childModel: "League"
					},
					{
						modelName: "League"
					}
				],
		views:
				[
					{
						viewName: "CCU",
						partial: "common/filters/filter_container",
						innerTarget: ".sport-filters-content",
						behaviours: ['pageUpdateHelper'],
						beforeInitialize: function () {
							this.targetEl = this.model.get('targetEl');
                        },

    					afterChildViewAdd: function (model)
						{
							model.set("exists", 1);
						},
						afterInitialize: function () {
							this.on("IndexHome_onUpdateFromOutside", this.refreshFilter);
							this.on("LeagueFilters_requestUpdate", this.refreshFilter);
							this.on("Dispatcher_returnData_getFilter", this.updateContent);
							this.on("LeagueFilters_setFilter", this.setFilter);
							this.on("Dispatcher_returnData_setLeagueFilter", this.afterSetFilter);

							this.model.set('viewParams', getViewParams().viewParams);

						},
						afterUpdate: function () {
							this.trigger('LeagueFilters_updateComplete');
						},
						refreshFilter: function (caller, data) {
							var viewParams = $.extend({}, data);
							var filters = {};
							filters.containers = JSON.stringify(this.recurseKids(this.model.childList));
							filters.viewParams = $.extend({}, data);
							// @TODO check if this is ok
							if (typeof filters.viewParams.time_range !== 'undefined')
							{
								filters.viewParams.state = '';
							}
							this.model.set('viewParams', viewParams);
							this.trigger("Dispatcher_requestData", "getFilter", filters);
                    },
						setFilter: function (caller, data)
						{
							this.setFilterActionParams = data;

							this.trigger("Dispatcher_requestData", "setLeagueFilter", data.setFilterParams);
						},
						afterSetFilter: function (caller, data)
						{
							if (!data || !data.status || data.status !== "success")
							{
								console.log(data);

								return;
							}

							if (!this.setFilterActionParams)
							{
								return;
							}

							if (this.setFilterActionParams.redirect) {
								this.trigger("LeagueFilters_hideLeagueFilters", {});

								var setFilterActionParams = this.setFilterActionParams;

								setTimeout(function () {
                                    if (typeof window.browserRedirectTo === 'function') {
                                        window.browserRedirectTo(setFilterActionParams.redirect)
                                    } else {
                                        console.error('Cannot use browserRedirectTo, falling back to window.location.href')
                                        // @window-location-ignore
                                        window.location.href = setFilterActionParams.redirect
                                    }
								}, 400);

								this.setFilterActionParams = null;

								return;
							}

							this.trigger("LeagueFilters_hideLeagueFilters", {});


							if (this.setFilterActionParams.isDayFilterChanged) {
								this.trigger("DayFilter_dateChangeFromOutside", this.setFilterActionParams.viewParams.time_range);
							}

							// if we are not going to refresh the page, we have to set All for hour_range
							if (this.setFilterActionParams.viewParams.hour_range)
							{
								this.setFilterActionParams.viewParams.hour_range = "all";

								this.$el.find("#dropdownFilterHourRangeSorting .filter-option").removeClass("selected");
								this.$el.find("#dropdownFilterHourRangeSorting .filter-option[data-filter-value='all']").addClass("selected");
							}

							this.trigger("LeagueFilters_updateFromLeagueFilters", this.setFilterActionParams.viewParams);

							this.setFilterActionParams = null;
						}
					},
					{
						viewName: "FilterTypeBasic",
						partial: "common/filters/filter_basic_container",
						innerTarget: ".sport-filters-inner-content",
						beforeInitialize: function () {

						}
					},
					{
						viewName: "Sport",
						behaviours: ["childReorder", "updateFilterCounter"],
						partial: "common/filters/sport_container",
                        autoUpdate: true,
						innerTarget: ".modal-content",
						events: {
							"click #dropmodalFilterSelectLeagues .modal-toggle": "requestToggleLeagues",
							"click a.submit-league-filter": "filterByLeague",
							"click a.nav-link": "setActiveTab",
                            'click .filter-select-all-btn' : 'selectAllLeagues',
                            'click .filter-clear-all-btn' : 'clearAllLeagues',
							"click a.close-button": "toggleLeagues",
							"click #dropdownFilterDefaultSorting .filter-option": "changeEventsSorting",
							"click #dropdownFilterHourRangeSorting .filter-option": "changeHourRange",
                            "click #grid-layout-select .filter-option": "changeLayout"
						},

						beforeInitialize: function () {

							this.model.set("leagues_open", 0);
							if (!this.model.has("hide_leagues"))
							{
								this.model.set("hide_leagues", 0);
							}
							var viewParams = this.model.getParent("CCU").get("viewParams");

							this.model.set("hour_ranges", getHourFilters());

							this.model.set("hour_ranges_selection",	viewParams.hour_range);

							this.model.set("sort_by_selection", viewParams.sort_by);

                            this.setCurrentSelectionData(this.model.get("hour_ranges"), this.model.get("hour_ranges_selection"));

                            if(!getViewParams().viewParams.market_type_id){
                                this.model.set('marketType', 'hdp_ou')
                            }
                        },


                        setActiveTab: function(e) {
							var activeKey = $(e.currentTarget).attr('data-key');
                            this.model.childList.each(function(mode) {
                                mode.set('is_active', 0)
                            });
                            var matchedMode = _.findWhere(this.model.childList.models, {id: activeKey});
                            matchedMode.set('is_active', 1);
						},

						afterInitialize: function () {

							this.pushComponents({
								"hide_leagues": {"callback": this.updateSelectButtonVisibility}
							});

							this.updateSelectButtonVisibility(this.model.get("hide_leagues"), null, null, null, this);

							this.on("LeagueFilters_updateLeagueFilters", this.filterByLeague, true);
							this.on("LeagueFilters_hideLeagueFilters", this.hideLeagues);
							this.on("LeagueFilters_updateComplete", this.updateComplete);

                            this.renderCounter(null, 'early');
                            this.renderCounter(null, 'today');

						},


						updateSelectButtonVisibility: function (value, prev_value, element, key, $this) {
							if(value) {
                                $this.$el.find("#dropmodalFilterSelectLeagues").addClass("d-none");
							} else {
                                $this.$el.find("#dropmodalFilterSelectLeagues").removeClass("d-none");
							}
						},
						filterByLeague: function () {
							var $this = this;

							var active_leagues		= {};
							var not_active_leagues	= {};
							this.model.childList.each(function (category) {
								category.childList.each(function (league) {
									if (league.get("is_active") == 1) {
										active_leagues[league.id] = league.id;
									}
									else
									{
										not_active_leagues[league.id] = league.id;
									}
								});
							});
							active_leagues = Object.keys(active_leagues);

							if (_.isEmpty(not_active_leagues))
							{
								active_leagues = [];
							}

							if (active_leagues.length > 10)
							{
								$this.$el.find('.error-message').removeClass('d-none');

								return;
							}

							$this.$el.find('.error-message').addClass('d-none');
							$this.$el.find('.modal').modal('hide');

							var viewParams = this.model.getParent('CCU').get('viewParams');
							var setFilterParams = {
								filter: [
									{
										'sport_id': this.model.id,
										'leagues': active_leagues
									}
								],
								viewParams: viewParams
							};

							var currentSelection			= viewParams.asian_selection;
							var changeDayFilterSelection	= false;
							var redirectTo					= false;

							this.model.childList.each(function (category) {
								var currentTab = category.get('category_id');

								// check if the category is active
								if (!$this.$el.find('a[href="#' + currentTab + '"]').hasClass('active'))
								{
									return;
								}

								// on early tab
								if (currentTab === 'league_filter_early') {
									if (currentSelection === 'today') {
										redirectTo = getUrls()['early'];
									} else if (currentSelection === 'teaser') {
										// do nothing special
									} else if (setFilterParams.filter[0].leagues.length === 0) {
										viewParams.time_range = 'tomorrow';
										changeDayFilterSelection = true;
									} else {
										viewParams.time_range = 'all';
										changeDayFilterSelection = true;
									}
								}
								// on today tab
								else if (currentTab === 'league_filter_today') {
									if (currentSelection === 'early') {
										redirectTo = getUrls()['today'];
									}
								}
							});

							if (redirectTo) {
								redirectTo = redirectTo + (viewParams.sport_id[0] ? ('?' + jQuery.param({'sport_id': viewParams.sport_id[0]})) : '');
							}else {
								this.trigger('Filter_setAllSelectCount', active_leagues.length);
							}

                            this.trigger("IndexHome_setLeagueFilter", setFilterParams.filter);
							this.trigger("LeagueFilters_setFilter", {"setFilterParams": setFilterParams, "viewParams": viewParams, "isDayFilterChanged": changeDayFilterSelection, "redirect": redirectTo});
						},
						requestToggleLeagues: function () {
                            var viewParams = this.model.getParent('CCU').get('viewParams');
                            delete viewParams.hour_range;
                            this.trigger('LeagueFilters_requestUpdate', viewParams);
							this.model.set('leagues_toggle_requested', 1);
                            $('.sport-table').addClass('view-loader');

                        },
						updateComplete: function () {
							if (this.model.get('leagues_toggle_requested')) {
								this.toggleLeagues();
								this.model.set('leagues_toggle_requested', 0);
							}
                            this.setSportFilterCounter(this.model.childList.models);
						},
						toggleLeagues: function () {
							$('#filter-league-modal').modal('show');
                            $('.sport-table').removeClass('view-loader');

                        },

						clearAllLeagues: function () {
							this.setAllCheckboxes(0);
                            this.trigger('Filter_setAllSelectCount', 0);

                        },
                        selectAllLeagues: function () {
                            this.setAllCheckboxes(1);
                        },

                        setAllCheckboxes: function(isActive){

                            this.model.childList.each(function (category) {
                                category.childList.each(function (league) {
									league.set("is_active", isActive);
                                });
                                this.trigger('Filter_renderSelectedCounter', category.id);
                            }, this);

                        },

						// handling of the select box that changes the sorting of the events
						changeEventsSorting: function (e) {
                            var params = this.model.getParent('CCU').get('viewParams'),
								$selectedFilterOption = $(e.target),
								$filter = $selectedFilterOption.parents('.dropdown');

                            if(params.sort_by == $selectedFilterOption.attr('data-filter-value')){
                                return;
                            }
                            params.sort_by = $selectedFilterOption.attr('data-filter-value');

							delete params['bnet'];
							delete params['DELASESS'];

                            this.updateFilterSelection($filter, $selectedFilterOption);
                            this.updateUrl(params);
							this.trigger('Filter_changeEventsSorting', params);
						},
						// handling of the select box that changes the hour
						changeHourRange: function (e) {
							var params = this.model.getParent('CCU').get('viewParams'),
								$selectedFilterOption = $(e.target),
                                $filter = $selectedFilterOption.parents('.dropdown');
							if($selectedFilterOption.hasClass('active')){
								return;
							}
							params.hour_range = $selectedFilterOption.attr('data-filter-value');

							delete params['bnet'];
							delete params['DELASESS'];

							this.updateFilterSelection($filter, $selectedFilterOption);
                            this.updateUrl(params);
                            this.trigger('Filter_changeHourRange', params);
						},

                        updateFilterSelection: function($filter, $selectedEl) {
                            var $filterLabel = $filter.find('.btn-dropdown-label'),
								selectedFilterItemText = $selectedEl.text();

                            $filterLabel.text(selectedFilterItemText);
                            $selectedEl.siblings().removeClass('active');
                            $selectedEl.addClass('active');
                        },

						updateUrl: function(params) {

                        	var urlParams = $.extend(true, {}, params);
                            urlParams.sport_id = urlParams.sport_id.toString();
                            delete urlParams.leagues;
                            delete urlParams.sports;
                            delete urlParams.market_types_sports_main;
                            delete urlParams.option_index_lte;
                            delete urlParams.use_league_filter;
                            delete urlParams.sports_game_periods_main;
                            delete urlParams.asian_selection;

                        	var urlParams = $.param(urlParams),
								urlPath = window.location.pathname;
                            history.replaceState(null, '', urlPath + '?' + urlParams);
						},

						setCurrentSelectionData: function(hourRangesArray, currentSelection) {
							var currentSelectionData = {};

							if(!currentSelection || currentSelection === "") {
								currentSelection = "all";
                                this.model.set("hour_ranges_selection",	"all");
                            }

                            for (var i=0; i < hourRangesArray.length; i++) {
                                if (hourRangesArray[i]['key'] === currentSelection) {
                                    currentSelectionData = hourRangesArray[i];
                                }
                            }

                            if(!_.isEmpty(currentSelectionData)) {
                                this.model.set("current_selection_data", currentSelectionData);
                            } else {
                                this.model.set("current_selection_data", hourRangesArray[0]);
                                this.model.set("hour_ranges_selection",	"all");
                            }
						},
                        changeLayout: function(e){
                            var $selectedFilterOption = $(e.target),
                                $filter = $selectedFilterOption.parents('.dropdown'),
                                selectedValue = $selectedFilterOption.attr('data-filter-value');

                            this.updateFilterSelection($filter, $selectedFilterOption);
                            this.trigger('IndexHome_changeGridLayout', selectedValue);
                        }
					},
					{
						viewName: "Category",
						partial: "common/filters/category_container",
						innerTarget: ".league-category",
						events: {
							"click .select-popular-league": "selectPopularLeagues",
                            "click .select-all-league": "selectAllCategoryLeagues",
						},
						beforeInitialize: function ()
						{
                            this.model.set({
                                category_id: "league_filter_" + this.model.id
                            });

							// handle current tab ( today or early)
							var asian_selection = this.model.getParent('CCU').get('viewParams').asian_selection;

							if (
									(asian_selection === 'today' || asian_selection === 'early') && this.model.id === asian_selection
								||	(asian_selection !== 'today' && asian_selection !== 'early') && this.model.parent.childList.length >= 1 && this.model.parent.childList.first().id === this.model.id
							) {
								this.model.set("is_active", 1);
							}
						},
                        afterInitialize: function () {
                            this.pushComponents({
                                has_promoted: {
                                    callback: this.displayPromotedToggle
                                }
                            });
                        },
                        displayPromotedToggle: function(value, prev_value, element, key, $this) {
                            if(!value){
                                $this.$el.find('.popular-leagues-container').addClass('d-none');
                            }else{
                                $this.$el.find('.popular-leagues-container').removeClass('d-none');
                            }
                        },

                        addToDom: function () {
							$(this.targetEl).find(".tab-content").append(this.render().$el);
							$(this.targetEl).find(".league-filter-main-tabs").append(this.templates["common/filters/category_head"].render(this.model.attributes));
						},

                        selectPopularLeagues: function(e) {
							this.selectAllCategoryLeagues(e, 1);
						},

                        selectAllCategoryLeagues: function (e, isPromoted) {

							if(!isPromoted){
                                isPromoted = 0;
							}

                            e.stopPropagation();
                            var checkAllElements = 1,
                                allFilterElements = this.model.childList,
								matchingLeagues = _.filter(allFilterElements.models, function(element) {
                                    return Number(element.attributes.is_promoted) === isPromoted;
                                });

                            var checkedFilterElements = _.filter(matchingLeagues, function(element) {
                                return element.attributes.is_active === 1;
                            });

                            if(matchingLeagues.length == checkedFilterElements.length) {
                                checkAllElements = 0;
                            }

                            for(var i = 0; i < matchingLeagues.length; i++){
                                matchingLeagues[i].set('is_active', checkAllElements);
							}

                            this.trigger('Filter_renderSelectedCounter', this.model.getParent('Category').id);

						}

					},
					{
						viewName: "League",
						partial: "common/filters/league_container",
						events: {
							'change .custom-control-input': 'toggleLeague'
						},

						beforeInitialize: function(){
							var sportId = this.model.getParent("Sport").get("id");
							var leagueId = this.model.get("id");
							this.model.set("league_regulated", sportSettings.leagueRegulated(sportId, leagueId));
							if(this.model.getParent('Sport_mix_parlay')){
                                this.model.set('category_id', this.model.getParent('Sport_mix_parlay').get('category_id'))
							}else{
                                this.model.set('category_id', this.model.getParent('Category').id)
                            }
						},
						afterInitialize: function () {
							$('#' + this.model.parent.get('category_id') + ' .league-category .is_promoted_league').appendTo('#' + this.model.parent.get('category_id') + ' .popular_leagues_container');

                            this.on('League_updateActiveStatus' + this.model.id, this.updateActiveStatus);
                            this.pushComponents({
                                "is_active": {"callback": this.changeActiveStatus}
                            });

						},

                        toggleLeague: function () {

                            var isSelected = +!this.model.get("is_active");
                            this.model.set("is_active", isSelected);
                            if (this.is_promoted) {
                                this.model.getParent("Sport").view.trigger("LeagueFilters_updateLeagueFilters");
                            }
                            this.trigger('League_updateActiveStatus' + this.model.id, isSelected);
                            this.trigger('Filter_renderSelectedCounter', this.model.get('category_id'));
                        },

                        changeActiveStatus: function (value, prev_value, element, key, $this) {
                            $this.$el.find('input').prop('checked', value);
                            $this.trigger('Filter_updateSelectedCounter', {
                                gameMode: $this.model.get('category_id'),
                                value: value
                            });
                        },
                        //Used to update duplicates in today and early
                        updateActiveStatus: function(caller, isSelected){
                            if(this.model.get('is_active') !== isSelected){
                                this.model.set('is_active', isSelected);
                                this.trigger('Filter_renderSelectedCounter', this.model.get('category_id'));
                            }
                        }

					},
					{
						viewName: "FilterTypeSportList",
						partial: "common/filters/sport_list_filter/container",
						innerTarget: ".sport-select-filter-list",
						behaviours: ["checkboxContainer", "childReorder"],
						sendTimeout: 500,
						afterInitialize: function () {
							this.on("SportListFilter_toggleCheckbox", function (caller, model) { this.toggleCheckbox(model); });
							this.listenTo(this.model.childList, "remove", this.reactOnChildRemove);
							this.assureConsistentAllCheck();
						},
						reactOnChildRemove: function () {
							this.assureConsistentAllCheck();
							this.send();
						},
						send: function () {
							var sportId = [];

							this.model.childList.each(function (sport) {
								if (sport.get("is_active") === 1) {
									sportId.push(sport.get("sport_id"));
								}
							});
							sportId = !_.isEmpty(sportId) ? (_.indexOf(sportId, 0) === -1  ? sportId : [0]) : -1;

							this.trigger("SportListFilter_changed", sportId);
						},
						findAllCheck: function () {
							return this.model.childList.findWhere({'id': '0'});
						}
					},
					{
						viewName: "SportOptionFakeUpdate",
						partial: "common/filters/sport_list_filter/option",
                        behaviours: ["checkboxContainer", "childReorder"],
                        events: {
                            'change .sport-select-filter-checkbox'	:	'updateOptionFilters'
                        },
						beforeInitialize: function(){
                            this.model.set('order', 0);
                            this.model.set('option_id', 'sport_check_' + this.model.id);
                            if(sportSettings.sportRegulated(this.model.get('sport_id'))) {
								this.partial = ''
							}
                        },
						afterInitialize: function(){
                            var matchedSportSetting = _.findWhere(sportSettings.info, {id: this.model.get('sport_id')});
                            if(matchedSportSetting){
                                this.model.set('order', matchedSportSetting.order);
                            }
						},
                        updateOptionFilters: function () {
							this.trigger("SportListFilter_toggleCheckbox", this.model);
						}
					},
					// Mix Parlay Filter Views

					{
						viewName: "FilterTypeMixParlay",
						partial: "common/filters/mix_parlay_filter/filter_type_mix_parlay_container",
						innerTarget: ".sport-filters-inner-content",
						behaviours: ["checkboxContainer", "checkboxDropdown", 'updateFilterCounter'],
						events: {
							'click .modal-toggle' : 'requestShowMixParlayFilter',
							'click .submit-league-filter' : 'sendLeagues',
							'click .filter-select-all-btn' : 'selectAllLeagues',
							'click .filter-clear-all-btn' : 'clearAllLeagues',
							'click #dropdownFilterDefaultSorting .filter-option' : 'changeEventsSorting',
							'click #dropdownFilterHourRangeSorting .filter-option' : 'changeHourRange',
							'click .dropdownSelectFilterItem' : 'handleCheckboxDropdownClick'
						},
						checkboxModelName: 'SportOption',
                        autoUpdate: true,
                        beforeInitialize: function () {

							var viewParams = this.model.getParent("CCU").get("viewParams"),
                                filterEventStateUrlEarly = $('.stateUrlearly').attr('href'),
                                filterEventStateUrlToday = $('.stateUrltoday').attr('href');

							this.model.set("hour_ranges",				getHourFilters());
							this.model.set("hour_ranges_selection",		viewParams.hour_range);
							this.model.set("sort_by_selection",			viewParams.sort_by);
							this.model.set("current_selected_state",	viewParams.state);
							this.model.set("filterEventStateUrlEarly",	filterEventStateUrlEarly);
							this.model.set("filterEventStateUrlToday",	filterEventStateUrlToday);

                            this.setCurrentSelectionData(this.model.get("hour_ranges"), this.model.get("hour_ranges_selection"));
						},
						afterInitialize: function () {
							this.on("LeagueFilters_updateComplete", this.updateComplete);
							this.on("LeagueFilters_toggleCheckbox", function (caller, model) { this.toggleCheckbox(model); });
							this.on("LeagueFilters_hideLeagueFilters", this.hideMixParlayFilter);

							this.assureConsistentAllCheck();
						},
						requestShowMixParlayFilter: function () {
                            var viewParams = this.model.getParent('CCU').get('viewParams');
                            delete viewParams.hour_range;
							this.trigger('LeagueFilters_requestUpdate', viewParams);
							this.model.set('show_filter_requested', 1);
                            $('.sport-table').addClass('view-loader');
						},
						updateComplete: function () {
							if (this.model.get('show_filter_requested'))
							{
								this.showMixParlayFilter();
								this.model.set('show_filter_requested', 0);
							}

							this.assureConsistentAllCheck();
						},

						showMixParlayFilter: function () {
                            $('#filter-league-modal').modal('show');
                            $('.sport-table').removeClass('view-loader');
                        },
						hideMixParlayFilter: function () {
                            $('#filter-league-modal').modal('hide');
						},
						sendLeagues: function () {
							var active_leagues = {};
							var not_active_leagues = {};
							var sportsWithSelectedLeagues = [];
							var filterBySport = {};
							var $this = this;
							this.model.childList.each(function (category) {
								category.childList.each(function (sport) {
									if (typeof filterBySport[sport.id] === 'undefined') {
										filterBySport[sport.id] = {
											sport_id: sport.id,
											active_leagues: {},
											not_active_leagues: {}
										};
									}
									sport.childList.each(function (league) {
										if (league.get("is_active") == 1) {
											active_leagues[league.id] = league.id;
											filterBySport[sport.id].active_leagues[league.id] = league.id;
										}
										else
										{
											not_active_leagues[league.id] = league.id;
											filterBySport[sport.id].not_active_leagues[league.id] = league.id;
										}
									});

								});
							});
							active_leagues = Object.keys(active_leagues);

							_.each(filterBySport, function (val, key) {
//								if (_.isEmpty(val.not_active_leagues)) {
									// filterBySport[key].leagues = [];
//								} else {
									filterBySport[key].leagues = Object.keys(val.active_leagues);

									if (filterBySport[key].leagues.length)
									{
										sportsWithSelectedLeagues.push(key);
									}
//								}
								delete filterBySport[key].active_leagues;
								delete filterBySport[key].not_active_leagues;
							});

							if (_.isEmpty(not_active_leagues))
							{
								active_leagues = [];
							}

							// if nothing selected, clear the filter for all sports
							if (active_leagues.length === 0)
							{
								filterBySport = {};
							}

							if (active_leagues.length > 10) {
								$this.$el.find('.error-message').removeClass('d-none');
								return;
							}

                            this.$el.find('.league-filter-modal').modal('hide');
							$('.sport-table').addClass('view-loader');


							$this.$el.find('.error-message').addClass('d-none');

							var viewParams = this.model.getParent('CCU').get('viewParams');
							var setFilterParams = {
								filter: filterBySport,
								viewParams: viewParams
							};
							var redirectTo = false;

							// change sport_id from leagues filter
							viewParams.sport_id = sportsWithSelectedLeagues;

							// current state (today/early)
							var state = viewParams.state;
							var currentState = null;

							// find current active
							this.model.childList.each(function (category) {
                                var isActive = category.get('is_active'),
									categoryId = category.get('id')
                                if (isActive && (categoryId == 'early' || categoryId == 'today')) {
                                    currentState = category.id;
                                }

							});

							// on early tab
							if (state && currentState !== state) {
								var paramsUrl = {
									'state': currentState,
									'sport_id': viewParams.sport_id ? viewParams.sport_id : [],
									'market_selection': viewParams.market_selection ? viewParams.market_selection : []
								};
								redirectTo = getUrls()['combo'] + '?' + jQuery.param(paramsUrl);
								delete paramsUrl;
							}

                            this.trigger("IndexHome_setLeagueFilter", setFilterParams.filter);

							this.trigger("LeagueFilters_setFilter", {"setFilterParams": setFilterParams, "viewParams": viewParams, "isDayFilterChanged": false, "redirect": redirectTo});
						},

                        selectAllLeagues: function() {
                            this.setAllCheckboxes(1);

                        },
                        clearAllLeagues: function() {
                            this.setAllCheckboxes(0);
                        },
                        setAllCheckboxes: function (isActive) {
							this.model.childList.each(function (gameMode) {
                                gameMode.childList.each(function (sport) {
									sport.childList.each(function (league) {
										league.set("is_active", isActive);
									});
								});
                                this.trigger('Filter_renderSelectedCounter', gameMode.id);
							}, this);

                        },

						send: function () {
							var sportId = [];
							var viewParams = this.model.getParent('CCU').get('viewParams');

							this.model.childList.each(function (option) {
								if (option.modelName === 'SportOption') {
									if (option.get('is_active') === 1) {
										sportId.push(option.get('sport_id'));
									}
								}
							});
							viewParams.sport_id = !_.isEmpty(sportId) ? (_.indexOf(sportId, 0) === -1  ? sportId : 0) : -1;
							if(viewParams.sport_id == 0 ){
                                viewParams.sport_id = _.without(sportId, 0)
                            }
							this.trigger("LeagueFilters_updateFromLeagueFilters", viewParams);
						},
						findAllCheck: function () {
							return this.model.childList.findWhere({'id': 'sport_options_0'});
						},
						// handling of the select box that changes the sorting of the events
						changeEventsSorting: function (e) {
							var params = this.model.getParent('CCU').get('viewParams'),
								$selectedFilterOption = $(e.target),
                                $filter = $selectedFilterOption.parents('.dropdown');

							if(params.sort_by == $selectedFilterOption.attr('data-filter-value')){
								return;
							}

							params.sort_by = $selectedFilterOption.attr('data-filter-value');

							delete params['bnet'];
							delete params['DELASESS'];

                            this.updateFilterSelection($filter, $selectedFilterOption);
                            this.updateUrl(params);
                            this.trigger('Filter_changeEventsSorting', params);
						},
						// handling of the select box that changes the hour
						changeHourRange: function (e) {
							var params = this.model.getParent('CCU').get('viewParams'),
								$selectedFilterOption = $(e.target),
                                $filter = $selectedFilterOption.parents('.dropdown');
                            if($selectedFilterOption.hasClass('active')){
                                return;
                            }
							params.hour_range = $selectedFilterOption.attr('data-filter-value');

							delete params['bnet'];
							delete params['DELASESS'];

							this.updateFilterSelection($filter, $selectedFilterOption);
                            this.updateUrl(params);
                            this.trigger('Filter_changeHourRange', params);
						},

                        updateFilterSelection: function($filter, $selectedEl) {
                            var $filterLabel = $filter.find('.btn-dropdown-label'),
                                selectedFilterItemText = $selectedEl.text();

                            $filterLabel.text(selectedFilterItemText);
                            $selectedEl.siblings().removeClass('active');
                            $selectedEl.addClass('active');
                        },

                        updateUrl: function(params) {
                            var urlParams = $.extend(true, {}, params);
                            urlParams.sport_id = urlParams.sport_id.toString();
                            delete urlParams.leagues;
                            delete urlParams.sports;
                            delete urlParams.market_types_sports_main;
                            delete urlParams.option_index_lte;
                            delete urlParams.use_league_filter;
                            delete urlParams.sports_game_periods_main;
                            delete urlParams.asian_selection;
                            delete urlParams.market_selection;
                            delete urlParams.get_combo;
                            delete urlParams.sport_id;

                            var urlParams = $.param(urlParams),
                                urlPath = window.location.pathname;
                            history.replaceState(null, '', urlPath + '?' + urlParams);
                        },

                        setCurrentSelectionData: function(hourRangesArray, currentSelection) {
                            var currentSelectionData = {};
                            if(!currentSelection || currentSelection === "") {
                            	currentSelection = "all";
                                this.model.set("hour_ranges_selection",	"all");
                            }

                            for (var i=0; i < hourRangesArray.length; i++) {
                                if (hourRangesArray[i]['key'] === currentSelection) {
                                    currentSelectionData = hourRangesArray[i];
                                }
                            }

                            if(!_.isEmpty(currentSelectionData)) {
                                this.model.set("current_selection_data", currentSelectionData);
							} else {
                                this.model.set("current_selection_data", hourRangesArray[0]);
                                this.model.set("hour_ranges_selection",	"all");
							}
                        }
					},
					{
						viewName: "SportOption",
						partial: "common/filters/mix_parlay_filter/options_container",
						events: {
							'click .sportSelectFilterItemLabel'	:	'updateOptionFilters'
						},
						addToDom: function () {
							$(this.targetEl).find("#dropdownSportSelection .dropdown-menu").append(this.render().$el);
						},
						beforeInitialize: function () {
							this.model.set('option_id', this.model.id);
                            this.model.set('is_active', this.model.get('is_selected'));
						},
						afterInitialize: function () {
						},
						updateOptionFilters: function () {
							this.trigger("LeagueFilters_toggleCheckbox", this.model);
						}
					},
					{
						viewName: "Category_mix_parlay",
						partial: "common/filters/mix_parlay_filter/category_mix_parlay_container",
						innerTarget: ".mix-parlay-sport-container",
                        events: {
							'click .tab-item': 'updateCategoryTabItem'
						},
						beforeInitialize: function () {
							this.model.set('category_id', "league_filter_" + this.model.id);

							var asian_selection = this.model.getParent('CCU').get('viewParams').state;

							if (this.model.id === asian_selection) {
								this.model.set("is_active", 1);
							}
							if(asian_selection !== 'early' && this.model.id === 'today'){
                                this.model.set("is_active", 1);
							}

                            if(this.model.childList.length > 0) {
                                this.model.childList.models[0].set("collapsed", 0);
                            }
						},
						afterInitialize: function () {
							this.pushComponents({
								"is_active": {"callback": this.changeActiveStatus}
							});
							this.toggleFirstSport();

						},
						addToDom: function () {
							$(this.targetEl).find(".tab-content").append(this.render().$el);
							$(this.targetEl).find(".league-filter-main-tabs").append(this.templates["common/filters/category_head"].render(this.model.attributes));
						},
						changeActiveStatus: function (value, prev_value, element, key, $this) {
							$this.$el.find("a")[value ? "addClass" : "removeClass"]("active");
						},
						updateCategoryTabItem: function () {
							this.model.set("is_active", this.model.get("is_active") ? 0 : 1);
						},
						toggleFirstSport: function () {
						}
					},
					{
						viewName: "Sport_mix_parlay",
						partial: "common/filters/mix_parlay_filter/sport_mix_parlay_container",
						innerTarget: ".mix-parlay-league-container",
						events: {
							"click .select-all-league": "selectAllLeagueBySport"
						},
						beforeInitialize: function () {
							if (this.model.get('sport_key') === 'horseracing' || this.model.get('sport_key') === 'greyhounds' || this.model.get('sport_key') === 'horse_racing') {
								this.partial = "";
							}
                            this.model.set({
                                category_id: this.model.getParent('Category_mix_parlay').get('id'),
                                sport_id: this.model.get('sport_key') + '-container',
							});
						},
						afterInitialize: function () {

						},
						selectAllLeagueBySport: function(e) {
                            e.stopPropagation();
                            var checkAllElements = 1,
								allFilterElements = this.model.childList.models;

                            var checkedFilterElements = _.filter(allFilterElements, function(element) {
                                return element.attributes.is_active === 1
                            });

                            if(allFilterElements.length == checkedFilterElements.length) {
                                checkAllElements = 0;
                            }

							this.model.childList.each(function (league) {
                                league.set('is_active', checkAllElements);
							});

                            this.trigger('Filter_renderSelectedCounter', this.model.get('category_id'));

                        }
					}
				]
	};
}
; /** ----------------- **/ 
 function dayFilters(){
	return {
	        models:
	        [
	         	{
	         		modelName:"CCU",
	         		childModel: "Day"
	         	},
	         	{
	         		modelName: "Day"
	         	}
	        ],
	        views:
	        [
	         	{
	         		viewName: "CCU",
	         		partial: "common/day_filter/container_checkboxes",
	         		innerTarget: ".dropdown-menu",
	         		behaviours: ["childReorder", "checkboxContainer", "checkboxDropdown"],
                    events: {
                        'click .dropdownSelectFilterItem' : 'handleCheckboxDropdownClick'
                    },
	         		beforeInitialize: function(){
	         			this.targetEl = this.model.get("targetEl");
						this.model.set("viewParams", getViewParams().viewParams);
						this.sendOptionsTimeHandler = false;
	         		},
					afterInitialize: function(){
						this.on("SidebarNavigation_selection", this.sidebarChanged);
						this.on("IndexHome_onUpdateFromOutside", this.saveFilter);
						this.on("DayFilter_toggleCheckbox", function (caller, check) { this.toggleCheckbox(check); });
						this.on("DayFilter_itemInitialized", this.checkFilterVisibility);
						this.changeSelections();
					},
					sidebarChanged: function (caller, data){
						if (typeof data.get_teaser !== "undefined" && data.get_teaser) {
							this.$el.hide();
						} else {
							this.$el.show();
						}
					},
					saveFilter: function (caller, data) {
						this.model.set("viewParams", $.extend({}, data));
						this.changeSelections();
					},
					send: function () {
						var timeRanges = this.model.childList.where({"is_active": 1}).map(function (model) { return model.get("key"); });
						var getViewParam = this.model.getParent("CCU").get("viewParams");

						getViewParam.time_range = !_.isEmpty(timeRanges) ? (_.indexOf(timeRanges, "all") === -1 ? timeRanges : "all") : -1;

						this.trigger("DayFilter_dateChange", getViewParam);
					},
					changeSelections: function() {
						var timeRanges = this.model.get("viewParams").time_range;
						var allNotActive = timeRanges === -1;
						if (!allNotActive)
						{
							timeRanges = _.isEmpty(timeRanges) ? ["tomorrow"] : timeRanges;
							timeRanges = Array.isArray(timeRanges) ? timeRanges : [timeRanges];
						}

						this.model.childList.each(function (model) {
							model.set("is_active", !allNotActive && (_.indexOf(timeRanges, model.get("key")) !== -1 || _.indexOf(timeRanges, "all") !== -1) ? 1 : 0);
						});

						this.assureConsistentAllCheck();
					},
                    checkFilterVisibility: function() {
                        if(this.model.childList.length != 0) {
                            this.$el.removeClass("d-none");
                        }
                    }
	         	},
	         	{
	         		viewName: "Day",
	         		partial: "common/day_filter/day",
	         		events: {
						"click .day-filter-label": "toggleCheckbox"
					},
					afterInitialize: function() {
                        this.trigger("DayFilter_itemInitialized");
					},
					toggleCheckbox: function() {
						this.trigger("DayFilter_toggleCheckbox", this.model);
					}
				}
	        ]
	};
}; /** ----------------- **/ 
 if (Config.USER_LOGGED_IN == 1){	
	function favoritesEvents(){
		return {
			models: 
			[
			 	{
			 		modelName: "CCU"
			 	}
			],
			views: 
			[
			 	{
			 		viewName: "CCU",
			 		partial: "common/favorites_events/main",
			 		autoUpdate: true,
			 		beforeInitialize: function(){
			 			this.targetEl = this.model.get("targetEl");
			 			this.model.set("url", Config.FAVORITES_BASE_URL);
			 			//this.model.set("count", 0);
			 		},
			 		events: {
			 			"click .showFavorites": "showFavorites"
			 		},
			 		afterInitialize: function(){
			 			this.on("Dispatcher_returnData_manageFavorites", this.afterUpdate);
			 			this.on("FavoritesEvents_addLeague", this.addLeague);
			 			this.on("FavoritesEvents_removeLeague", this.removeLeague);
			 			this.on("FavoritesEvents_addEvent", this.addEvent);
			 			this.on("FavoritesEvents_removeEvent", this.removeEvent);
			 			
			 			//this.trigger("Dispatcher_requestData", "manageFavorites", {"action": "get_count"});
			 		},
			 		afterUpdate: function(caller, data, url){
			 			/*if(data.data.count > 0)
			 			{
			 				this.$el.addClass("active");
			 				this.$el.find('a').attr("href", this.model.get("url"));			 					
			 			}
			 			else
			 			{
			 				this.$el.removeClass("active");
			 				this.$el.find('a').attr("href", 'javascript:;');	
			 			}

			 			if(data.data.count == 0 && window.location.href.indexOf('favorites')>=0) {
			 				setTimeout("window.location='/"+Config.LOCALE_SHORT+"/sport/today'",3000);
			 			}

			 			this.model.set("count", data.data.count);*/
			 		},
			 		addLeague: function(caller, data){
			 			this.trigger("Dispatcher_requestData", "manageFavorites", {
			 				"action": "addLeague",
			 				"ids": data
			 			});
			 		},
			 		removeLeague: function(caller, data){
			 			this.trigger("Dispatcher_requestData", "manageFavorites", {
			 				"action": "removeLeague",
			 				"ids": data
			 			});
			 		},
			 		
			 		addEvent: function(caller, data){
			 			this.trigger("Dispatcher_requestData", "manageFavorites", {
			 				"action": "addEvent",
			 				"ids": data
			 			});
			 		},
			 		removeEvent: function(caller, data){
			 			this.trigger("Dispatcher_requestData", "manageFavorites", {
			 				"action": "removeEvent",
			 				"ids": data
			 			});
			 		},
			 		showFavorites: function(){
			 			//trace("show favorites");
			 		}
			 	}
			]
		};
	}
}; /** ----------------- **/ 
 /*
 * Ver 1.00
 *
 */

function teasers() {

	return {
		models: [
			{
				modelName: 'CCU',
				childModel: 'Teasers'
			},
			{
				modelName: 'Teasers',
				childModel: 'Games'
			},
			{
				modelName: 'Games',
				childModel: 'Points'
			},
			{
				modelName: 'Points'
			}
		],
		views: [
			{
				viewName: 'CCU',
                partial: 'common/teasers/teasers-box',
                innerTarget: '.teaser-options-content',
				behaviours: ['pageUpdateHelper'],
				beforeInitialize: function () {
					this.targetEl = this.model.get('targetEl');
				},
				afterInitialize: function () {
					var viewParams = getViewParams().viewParams;
					this.model.set('viewParams', viewParams);
					this.on('IndexHome_onUpdateFromOutside', this.saveFilter);
					this.on('SidebarNavigation_selection', this.refreshFilter);
					this.on('Dispatcher_returnData_getTeasers', this.updateContent);
				},
				refreshFilter: function (caller, data) {
					var filters = {};
						filters.containers = JSON.stringify(this.recurseKids(this.model.childList));
						filters.viewParams = $.extend({}, data);

					if (typeof filters.viewParams.get_teaser === 'undefined' || !filters.viewParams.get_teaser) {

						var removes = {};
						this.model.childList.each(function (model) { removes[model.id] = {'action': 'remove'}; });
						this.updateContent(this, {'status': 'success', 'data': removes});
						this.$el.addClass("d-none");
					} else {
						this.trigger('Dispatcher_requestData', 'getTeasers', filters);
						this.$el.removeClass("d-none");
					}
				},
				saveFilter: function (caller, data) {
					var viewParams = $.extend({}, data);

					this.model.set('viewParams', viewParams);
				}
			},
			{
				viewName: 'Teasers',
				partial: 'common/teasers/teasers-container',
				innerTarget: '.teaser-options-container'
			},
			{
				viewName: 'Games',
				partial: 'common/teasers/points-container',
				innerTarget: '.teasers-points-list',
				beforeInitialize: function () {
					this.model.set('category_id', 'games_' + this.model.id);

					var active = this.model.getParent('Teasers').childList.countBy(function (model) { return model.get('is_active') === 1; });

					if (typeof active['true'] === 'undefined' || !active['true']) {
						var firstGames	= this.model.getParent('Teasers').childList.first();
						if (firstGames) {
							firstGames.set('is_active', 1);
						}
						if (this.model.get('is_active') === 1) {
							var activePoints = this.model.childList.countBy(function (model) { return model.get('is_active') === 1; });
							if (typeof activePoints['true'] === 'undefined' || !activePoints['true']) {
								if (this.model.childList.first()) {
									this.model.childList.first().set('is_active', 1);
								}
							}
						}
					}
				},
				addToDom: function () {
					$(this.targetEl).find('.teasers-games-tab-content').append(this.render().$el);
					$(this.targetEl).find('.teaser-games-tabs').append(this.templates['common/teasers/game'].render(this.model.attributes));
				},
				onBeforeRemove: function () {
					$(this.targetEl).find('.teaser-games-tabs').find('.teaser-games-nav-item[data-category-id=' + this.model.get('category_id') + ']').remove();
				},
				afterInitialize: function () {
					this.on('IndexHome_eventsCount', this.checkForDisable);
				},
				checkForDisable: function (caller, eventsOnScreen) {
					var action = this.model.get('selections') > eventsOnScreen ? 'addClass' : 'removeClass';
					if (action === 'removeClass' && $(this.targetEl).find('.teaser-games-nav-item[data-category-id=' + this.model.get('category_id') + '] .teaser-games-nav-link.active').length || action !== 'removeClass') {
						this.$el[action]("d-none");
					}
					$(this.targetEl).find('.teaser-games-tabs').find('.teaser-games-nav-item[data-category-id=' + this.model.get('category_id') + ']')[action]("d-none");
				}
			},
			{
				viewName: 'Points',
				partial: 'common/teasers/points',
				events: {
					"click .teaser-points-item": "updateOddsWithPoints"
				},
				beforeInitialize: function () {
				},
				afterInitialize: function () {
					var teasersLi = $('.teasers-points-list').find('.teaser-points-item');
					teasersLi.click(function(){
						teasersLi.removeClass('active');
						$(this).addClass('active');
					});
					if (this.model.get('is_active')) {
                        var $this = this;
						teasersLi.addClass('active');
						// we can't use this method before the index_home is initialized. wait a little and check
						setTimeout(function () { $this.updateOddsWithPoints(); }, 1000);
					}
				},
				updateOddsWithPoints: function () {
					var viewParams = this.model.getParent('CCU').get('viewParams');
					viewParams.teaser_id = this.model.get('teaser_id');
					this.trigger('Teasers_updateOdds', viewParams);
					this.trigger('Dispatcher_requestData', 'setTeaserInBetSlip', {'teaser_id': this.model.get('teaser_id')}, '/' + Config.LOCALE_SHORT + '/betslip/operation/setTeaserInBetSlip');
				}
			}
		]
	};
}

function getTeasersDummy() {

	return {
		'teasers': {
			'data': {
				'game_option_1': {
					'info': {
						'id': 1,
						'title': '2 games'
					},
					'data': {
						'point_option_1': {
							'info': {

								'title': '+4 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_2': {
							'info': {

								'title': '+5 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_3': {
							'info': {

								'title': '+5 points | 2.00'
							},
							'action': 'insert'
						}

					},
					'action': 'insert'
				},
				'game_option_2': {
					'info': {
						'id': 2,
						'title': '3 games'
					},
					'data': {
						'point_option_1': {
							'info': {

								'title': '+8 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_2': {
							'info': {

								'title': '+11 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_3': {
							'info': {

								'title': '+15 points | 2.00'
							},
							'action': 'insert'
						}

					},
					'action': 'insert'
				},
				'game_option_3': {
					'info': {

						'title': '4 games'
					},
					'data': {
						'point_option_1': {
							'info': {

								'title': '+24 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_2': {
							'info': {

								'title': '+25 points | 2.00'
							},
							'action': 'insert'
						},
						'point_option_3': {
							'info': {

								'title': '+35 points | 2.00'
							},
							'action': 'insert'
						}

					},
					'action': 'insert'
				},
				'game_option_4': {
					'info': {
						'id': 4,
						'title': '5 games'
					},
					'action': 'insert'
				},
				'game_option_5': {
					'info': {
						'id': 5,
						'title': 'specials'
					},
					'action': 'insert'
				}
			},
			'action': 'insert'
		}
	};
}

; /** ----------------- **/ 
 /* Ver 1.00
 */

function filterTeasers() {

	return {
		models: [
			{
				modelName: 'CCU',
				childModel: 'TeasersFilter'
			},
			{
				modelName: 'TeasersFilter',
				childModel: 'Date'
			},
			{
				modelName: 'Date'
			}
		],
		views: [
			{
				viewName: 'CCU',
                partial: 'common/filters_teasers/filters_teasers_box',
                innerTarget: '.teaser-filter-content',
				beforeInitialize: function () {
					this.targetEl = this.model.get('targetEl');
					this.model.set('viewParams', getViewParams().viewParams);
					this.determineVisibleStatus();
				},
				afterInitialize: function () {
					this.on('IndexHome_onUpdateFromOutside', this.saveFilter);
					this.pushComponents({
						'is_visible': {'callback': this.changeVisibleStatus}
					});
				},
				saveFilter: function (caller, data) {
					this.model.set('viewParams', $.extend({}, data));
					this.determineVisibleStatus();
				},
				determineVisibleStatus: function () {
					this.model.set('is_visible', this.model.get('viewParams').get_teaser ? 1 : 0);
				},
				changeVisibleStatus: function (value, prev_value, element, key, $this) {
					$this.model.childList.each(function (model) {
						model.set('is_visible', value);
					});
				}
			},
			{
				viewName: 'TeasersFilter',
				partial: 'common/filters_teasers/filters_teasers_container',
				innerTarget: '.teaser-filter-list',
				behaviours: ['checkboxContainer'],
				beforeInitialize: function () {
					this.model.set('is_visible', this.model.parent.get('is_visible'));
				},
				afterInitialize: function () {
					this.pushComponents({
						'is_visible': {'callback': this.changeVisibleStatus}
					});
					this.on('FilterTeasers_toggleCheckbox', function (caller, check) { this.toggleCheckbox(check); });
				},
				send: function () {
					var timeRanges = this.model.childList.where({'is_active': 1}).map(function (model) { return model.get('key'); });
					var getViewParam = this.model.getParent('CCU').get('viewParams');

					getViewParam.time_range = !_.isEmpty(timeRanges) ? (_.indexOf(timeRanges, 'all') === -1 ? timeRanges : 'all') : -1;
					getViewParam.event_ids = [];

					this.trigger('FilterTeasers_dayChange', getViewParam);
				},
				changeVisibleStatus: function (value, prev_value, element, key, $this) {
					$this.$el[!value ? 'addClass' : 'removeClass']('d-none');
					// if showing, reset the filter
					if (value) {
						$this.model.childList.each(function (model) { model.set('is_active', 1); });
					}
				}
			},
			{
				viewName: 'Date',
				partial: 'common/filters_teasers/date',
				events: {
					'click .teaser-filter-label': 'toggleCheckbox'
				},
				beforeInitialize: function() {
					this.model.set('is_active', 1);
					this.model.set('date_id', this.model.id + '_date_option');
				},
				afterInitialize: function() {
					this.pushComponents({
						'is_active': {'callback': this.changeActiveStatus}
					});
				},
				changeActiveStatus: function(value, prev_value, element, key, $this) {
					if(value === 1) {
                        $this.$el.find('.teaser-filter-checkbox').prop('checked', true);
					} else {
                        $this.$el.find('.teaser-filter-checkbox').prop('checked', false);
					}
				},
				toggleCheckbox: function(e) {
					e.preventDefault(); //TODO rework the whole functionality for check/uncheck checkboxes so that it can use in-built browser behaviour
					this.trigger('FilterTeasers_toggleCheckbox', this.model);
				}
			}
		]
	};
}

function getFilterTeasersDummy() {
	return {
			'teasers_filters' : {
				data : {
					'all_date_option' : {
						'info': {
							'title': 'all'
						},
						'action':'insert'
					},
					'date_option_1' : {
						'info': {
							'title': '11/5 Tommorow'
						},
						'action':'insert'
					},
					'date_option_2' : {
						'info': {
							'title': '12/1 Monday'
						},
						'action':'insert'
					},
					'date_option_3' : {
						'info': {
							'title': '12/2 Tuesday'
						},
						'action':'insert'
					},
					'date_option_4' : {
						'info': {
							'title': 'Later'
						},
						'action':'insert'
					}
				},
				'action':'insert'
			}

	};
}


; /** ----------------- **/ 
 function footer(){
    return {
        models:
            [
                {
                    modelName: "CCU"
                }
            ],
        views:
            [
                {
                    viewName: "CCU",
                    partial: "common/general/footer",
                    beforeInitialize: function() {
                        var $this = this;
                        this.targetEl = this.model.get("targetEl");
                        this.model.set("cmsFooter", Config.CMS_FOOTER);
                        this.model.set('helpMenu', CMS.helpMenu);

                        //Patch for async components as backbone footer element comes from vue component
                        //If targetEl is not presented listen for RENDER_LEGACY_DESKTOP_FOOTER
                        this.model.set('reinitializeView', Boolean(!$(this.targetEl).length))
                        if(this.model.get('reinitializeView')) {
                            this.on('RENDER_LEGACY_DESKTOP_FOOTER', function() {
                                $this.reinitializeView();
                            });
                        }


                        var sportLinks = [
                            {
                                sport_id: 1,
                                sport_key: 'soccer'
                            },
                            {
                                sport_id: 3,
                                sport_key: 'basketball'
                            },
                            {
                                sport_id: 2,
                                sport_key: 'tennis'
                            },
                            {
                                sport_id: 4,
                                sport_key: 'volleyball'
                            },
                        ]
                        if(Config.WHITE_LABEL_REGULATIONS.block_sport) {
                            sportLinks = sportLinks.filter(function(sport) {
                                return Config.WHITE_LABEL_REGULATIONS.block_sport.indexOf(sport.sport_id.toString()) == -1
                            })
                        }
                        this.model.set('sportLinks', sportLinks)

                        if(BaseConfig.get('HIDE_SPORTS_AND_LEAGUES_BY_LANGUAGE') && BaseConfig.get('HIDE_SPORTS_AND_LEAGUES_BY_LANGUAGE')['languages'].indexOf(Config.LOCALE_SHORT) !== -1) {
                            this.model.set({
                                hideAffiliateLinkByLanguage: true,
                            })
                        }

                        if (['casino', 'my', 'promotions', 'bingo', 'gamification'].includes(Config.CONTROLLER) && Config.ACTION !== 'home' || Config.ACTION == 'christmas') {
                            this.targetEl = '#footer-wrapper';
                        }

                        var footerPaymentMethods = [];

                        var trustlyKey = this.getTrustlyKey();
                        var defaultPaymentProviders = [
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "skrill",
                                active: this.checkProviderStatus("skrill"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "visa",
                                active: this.checkProviderStatus("visa"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "mastercard",
                                active: this.checkProviderStatus("mastercard"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "neteller",
                                active: this.checkProviderStatus("neteller"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "ecopayz",
                                active: this.checkProviderStatus("ecopayz"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "qiwi",
                                active: this.checkProviderStatus("qiwi"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "webmoney",
                                active: this.checkProviderStatus("webmoney"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "klarna",
                                active: this.checkProviderStatus("klarna"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "rapid",
                                active: this.checkProviderStatus("rapid"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: trustlyKey,
                                active: this.checkProviderStatus(trustlyKey),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "paysafecard",
                                active: this.checkProviderStatus("paysafecard"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "mifinity",
                                active: this.checkProviderStatus("mifinity"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "jcb",
                                active: this.checkProviderStatus("jcb"),
                            },
                            {
                                url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                key: "discover",
                                active: this.checkProviderStatus("discover"),
                            },
                        ];

                        var customProviders = Config.CUSTOM_PROVIDERS ? JSON.parse(Config.CUSTOM_PROVIDERS) : '';
                        if(customProviders && customProviders.paymentProviders) {
                            customProviders.paymentProviders.forEach(function (provider) {
                                var providerKey = provider == "trustly" ? trustlyKey : provider;
                                footerPaymentMethods.push(
                                    {
                                        url: Config.CASHIER === 'default' ? Config.LOCALE_URL + '/my/cashier' : undefined,
                                        key: providerKey,
                                        active: $this.checkProviderStatus(providerKey),
                                    }
                                )
                            });
                        } else {
                            for(var i = 0; i < defaultPaymentProviders.length; i++) {
                                footerPaymentMethods.push(defaultPaymentProviders[i]);
                            }
                        }

                        var footerCasinoLinksKeys = ['online-casino', 'live-casino', 'games', 'tv-games', 'electronic-bingo', 'traditional-bingo'];
                        var footerCasinoLinks = [];
                        for (var key in CMS.headerTopMenu) {
                            if(footerCasinoLinksKeys.indexOf(key) !== -1) {
                                footerCasinoLinks.push(CMS.headerTopMenu[key])
                            }
                        }

                        var footerPartnersSection = BaseConfig.get('FOOTER_PARTNERS_SECTION') ? BaseConfig.get('FOOTER_PARTNERS_SECTION') : '';
                        var affiliateUrl = BaseConfig.get('AFFILIATE_URL') ? BaseConfig.get('AFFILIATE_URL') : '';

                        //TODO remove when it's not used anymore
                        if (BaseConfig.get('FOOTER_COLUMN_PAGES_LINKS')) {
                            this.model.set('footerColumnPagesLinks', BaseConfig.get('FOOTER_COLUMN_PAGES_LINKS'));
                        }


                        var regexpDe = /\.de/;
                        var isDeWebsites = regexpDe.test(Config.BASE_URL);

                        this.model.set({
                            affiliateUrl: affiliateUrl && affiliateUrl[Config.LOCALE_SHORT] ? affiliateUrl[Config.LOCALE_SHORT] : affiliateUrl['en'],
                            footerCasinoLinks: footerCasinoLinks,
                            footerPartnersSection: footerPartnersSection,
                            paymentMethods: footerPaymentMethods,
                            customProvidedPartners: customProviders && customProviders.partners ? customProviders.partners : '',
                            customProvidedAffiliates: customProviders && customProviders.affiliates ? customProviders.affiliates : '',
                            disablePaymentMethodsLink: Config.DISABLE_PAYMENT_METHODS_LINK ? Config.DISABLE_PAYMENT_METHODS_LINK : 0,
                            isDeWebsites: isDeWebsites,
                            isVipUser: Config.IS_VIP_USER,
                            isVipBenefitsEnabled: Config.IS_VIP_BENEFITS_ENABLED,
                            assetsPath: BaseConfig.get('ASSETS_PATH'),
                            assetsCdnRootPath: BaseConfig.get('CDN_ASSETS_PATH'),
                        });
                    },
                    afterInitialize: function() {
                        if(typeof window.VueEventBus !== 'undefined' && !this.model.get('reinitializeView')){
                            window.VueEventBus.$emit('footer-content-ready')
                        }
                    },
                    getCasinoCategories: function () {
                        var data = [{"id":"376","casino_area_id":"119","slug":"376","image_url":"https://some","ord":"5","is_hidden":"0","title":"Landing Recommended","title_en":"Landing Recommended"},{"id":"378","casino_area_id":"119","slug":"378","image_url":"https://some","ord":"4","is_hidden":"0","title":"Top Games","title_en":"Top Games"},{"id":"377","casino_area_id":"119","slug":"377","image_url":"https://some","ord":"3","is_hidden":"0","title":"New Games","title_en":"New Games"},{"id":"379","casino_area_id":"119","slug":"379","image_url":"https://some","ord":"0","is_hidden":"0","title":"Jackpots","title_en":"Jackpots"},{"id":"380","casino_area_id":"119","slug":"380","image_url":"https://some","ord":"0","is_hidden":"0","title":"Live Casino","title_en":"Live Casino"},{"id":"381","casino_area_id":"119","slug":"381","image_url":"https://some","ord":"0","is_hidden":"0","title":"Game Providers","title_en":"Game Providers"}];
                        var extractedData = {};
                        for (var i = 0; i < data.length; i++){
                            extractedData[data[i].id] = data[i];
                        }
                        return extractedData;

                    },
                    getTrustlyKey: function () {
                        var trustlyKey = "trustly";
                        if(BaseConfig.get('MEMBER_COUNTRY_ISO_CODE') === 'de') {
                            trustlyKey = "trustly-tuv-approved" + (Config.LOCALE_SHORT === 'de' ? '-de' : '');
                        }
                        return trustlyKey;
                    },
                    checkProviderStatus: function(provider) {
                        if(BaseConfig.get('PROVIDERS_RESTRICTIONS')) {
                            var restrictedProvider = this.checkIfRestrictedProvider(provider);
                            return !restrictedProvider;
                        }

                        return true;
                    },
                    checkIfRestrictedProvider: function(provider) {
                        var providersRestictions = BaseConfig.get('PROVIDERS_RESTRICTIONS')['paymentProviders'];
                        var providerSpecificRestrictions = providersRestictions[provider];

                        if(!providerSpecificRestrictions) {
                            return false;
                        }

                        if(providerSpecificRestrictions["locale"] && providerSpecificRestrictions["locale"].indexOf(Config.LOCALE_SHORT) !== -1) {
                            return true;
                        }

                        if(providerSpecificRestrictions["user_ip_iso_code"] && providerSpecificRestrictions["user_ip_iso_code"].indexOf(Config.USER_IP_ISO) !== -1) {
                            return true;
                        }

                        if(providerSpecificRestrictions["member_country_iso_code"] && providerSpecificRestrictions["member_country_iso_code"].indexOf(BaseConfig.get('MEMBER_COUNTRY_ISO_CODE') || '') !== -1) {
                            return true;
                        }

                        return false;
                    },
                }
            ]
    }
}
; /** ----------------- **/ 
 
var SINGLE_COLUMN_LAYOUT = {
    type: "layout",
    config: {
        key: "1column-fluid",
        partial: "common/layouts/1column-fluid",
        target: "#page-content"
    },
    components:
        {
            main_content:
                {
                    type: "plain",
                    config: {
                        target: "#mainVueContainer"
                    },
                },
        }
}

function getBetSlipConfig(targetEl, skipBuild = false) {
    if(window.Config.ENABLE_BET_SLIP_V1 && !window.BaseConfig.get('IS_NEW_LAYOUT')) {
        return {
            type: "plain",
            config: {
                partial: "common/betslip/container_v1"
            }
        }
    }
    return {
        type: "module",
        skipBuild: skipBuild,
        config: {
            settings: "betSlip",
            info: {
                targetEl: targetEl
            }
        }
    }
}

var BET_SLIP_CONFIG = (() => getBetSlipConfig("#rightColumn", BaseConfig.get('IS_NEW_LAYOUT')))()


function CONFIG() {
    return {
        layouts:
            {
                "casino/landing": {
                    type: "layout",
                    config: {
                        key: "default",
                        partial: "common/layouts/default",
                        target: "body"
                    },
                    components: {
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {
                            }
                        },
                    }
                },
                "euro/home": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        leftColumnVueWrapper: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            left_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#leftColumn"
                                    },
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },

                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        vue_quick_bets: {
                                            type: "plain",
                                            config: {
                                                partial: "common/quick_bets/vue_quick_bets"
                                            }
                                        },
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        }
                                    }
                                }
                        }
                },
                "euro/esports": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT :  {
                    type: "layout",
                    data: {
                        rightColumnVueContainer: true,
                        vueContainers: true,
                        leftColumnVueWrapper: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content",
                    },
                    components: {
                            main_content: {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            right_column: {
                                type: "plain",
                                config: {
                                    target: "#rightColumn"
                                },
                                components: {
                                    bet_slip: BET_SLIP_CONFIG,
                                    vue_quick_bets: {
                                        type: "plain",
                                        config: {
                                            partial: "common/quick_bets/vue_quick_bets"
                                        }
                                    },
                                    mini_games: {
                                        type: "plain",
                                        skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                        config: {
                                            partial: "common/mini_games/mini_games"
                                        }
                                    },
                                    mini_promotions: {
                                        type: "plain",
                                        skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                        config: {
                                            partial: "common/mini_promotions/mini_promotions"
                                        }
                                    },
                                }
                            }
                        }
                },
                "euro/competition":  Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        rightColumnVueContainer: true,
                        vueContainers: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
	                    hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content",
                    },
                    components: {
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {
                            }
                        },
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#rightColumn"
                            },
                            components: {
                                bet_slip: BET_SLIP_CONFIG,
                                mini_games: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                    config: {
                                        partial: "common/mini_games/mini_games"
                                    }
                                },
                                mini_promotions: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                    config: {
                                        partial: "common/mini_promotions/mini_promotions"
                                    }
                                },
                            }
                        },
                        left_column: {
                            type: "plain",
                            config: {
                                target: "#leftColumn"
                            },
                            components: {
                                vue_quick_bets: {
                                    type: "plain",
                                    config: {
                                        partial: "common/quick_bets/vue_quick_bets",
                                        info: {
                                            showDots: true,
                                        }
                                    }
                                },
                            }
                        }
                    }
                },
                "euro/sport": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        leftColumnVueWrapper: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            left_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#leftColumn"
                                    },
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        vue_quick_bets: {
                                            type: "plain",
                                            config: {
                                                partial: "common/quick_bets/vue_quick_bets"
                                            }
                                        },
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        }
                                    }
                                }
                        }
                },
                "euro/sportRacing": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        vue_quick_bets: {
                                            type: "plain",
                                            config: {
                                                partial: "common/quick_bets/vue_quick_bets"
                                            }
                                        },
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        }
                                    }
                                }
                        }
                },
                "euro/event": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        leftColumnVueWrapper: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            left_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#leftColumn"
                                    },
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        vue_quick_bets: {
                                            type: "plain",
                                            config: {
                                                partial: "common/quick_bets/vue_quick_bets"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        },
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                    }
                                },
                        }
                },
                "euro/eventRacing": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                        event_wrapper: {
                                            type: "plain",
                                            config: {
                                                target: "#mainContent",
                                                partial: "common/general/event_wrapper"
                                            },
                                            components: {}
                                        },
                                    }
                                },
                            left_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#leftColumn"
                                    },
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        vue_quick_bets: {
                                            type: "plain",
                                            config: {
                                                partial: "common/quick_bets/vue_quick_bets"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                    }
                                },
                        }
                },
                "euro/live": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        // Deprecated code, we show the leftColumnWrapper, but it's empty, remove when possible
                        leftSidebarVueInformationContainer: Config.PLUGIN_MODE && CMS.helpMenu.length ? 1 : 0,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                    },
                    config: {
                        key: "2columns-fluid-scrollbars",
                        partial: "common/layouts/2columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                    }
                                }
                        }
                },
                "euro/eventLive": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    data: {
                        vueContainers: true,
                        leftSidebarVueInformationContainer: Config.PLUGIN_MODE && (CMS.helpMenu.length || BaseConfig.get('CUSTOM_HELP_MENU')) ? 1 : 0,
                        leftColumnVueWrapper: true,
                        rightCreditUserBalanceContainer: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
	                    hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components: {
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#rightColumn"
                            },

                            components: {
                                bet_slip: BET_SLIP_CONFIG,
                                mini_games: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                    config: {
                                        partial: "common/mini_games/mini_games"
                                    }
                                },
                                mini_sport: {
                                    type: "module",
                                    skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                    config: {
                                        settings: "miniSport",
                                        initialData: "getMiniSport",
                                        info: {
                                            targetEl: "#rightColumn"
                                        }
                                    }
                                },
                                mini_promotions: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                    config: {
                                        partial: "common/mini_promotions/mini_promotions"
                                    }
                                },
                            }
                        },
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {
                            }
                        },
                    }
                },
                "euro/liveCalendar": {
                    type: "layout",
                    data: {
                        // Deprecated code, remove when possible
                        leftSidebarVueInformationContainer: Config.PLUGIN_MODE && CMS.helpMenu.length ? 1 : 0,
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                    },
                    config: {
                        key: "2columns-fluid-scrollbars",
                        partial: "common/layouts/2columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components:
                        {
                            main_content:
                                {
                                    type: "plain",
                                    config: {},
                                    components: {
                                    }
                                },
                            right_column:
                                {
                                    type: "plain",
                                    config: {
                                        target: "#rightColumn"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                        mini_games: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                            config: {
                                                partial: "common/mini_games/mini_games"
                                            }
                                        },
                                        mini_promotions: {
                                            type: "plain",
                                            skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                            config: {
                                                partial: "common/mini_promotions/mini_promotions"
                                            }
                                        },
                                        mini_sport: {
                                            type: "module",
                                            skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                            config: {
                                                settings: "miniSport",
                                                initialData: "getMiniSport",
                                                info: {
                                                    targetEl: "#rightColumn"
                                                }
                                            }
                                        }
                                    }
                                }
                        }
                },
                "index/home": {
                    type: "layout",
                    config: {
                        key: "3columns",
                        partial: "common/layouts/3columns",
                        target: "#page-content"
                    },
                    data: {
                        rightColumnVueContainer: true,
                        leftColumnVueWrapper: true,
                        leftCreditUserBalanceContainer: true,
                    },
                    components: {
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {
                                carosel: {
                                    type: 'module',
                                    config: {
                                        settings: "carousel",
                                        initialData: "getCarousel",
                                        info: {
                                            targetEl: "#mainContent"
                                        }
                                    }
                                }
                                // index_sport removed - now handled by Vue AsianIndexHome component
                            }
                        },
                        left_column: {
                            type: "plain",
                            config: {
                                target: "#leftColumn"
                            },
                            components: {
                                bet_slip_holder: {
                                    type: "plain",
                                    config: {
                                        //target: "#leftColumn",
                                        partial: "common/general/sidebar_box"
                                    },
                                    data: {
                                        id: "betSlipContainer"
                                    },
                                    components: {
                                        bet_slip: BET_SLIP_CONFIG,
                                    }
                                },
                                favorites_events: {
                                    type: "module",
                                    config: {
                                        settings: "favoritesEvents",
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                },
                                sidebar_navigation: {
                                    type: "module",
                                    config: {
                                        initialData: 'getSidebarNavigation',
                                        settings: 'sidebarNavigation',
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                }
                            }

                        },
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#rightColumn"
                            },

                            components: {
                                search_box: {
                                    type: "module",
                                    config: {
                                        settings: "searchBox",
                                        initialData: "",
                                        info: {
                                            targetEl: "#rightColumn"
                                        }
                                    }
                                },
                                mini_games: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                    config: {
                                        partial: "common/mini_games/mini_games"
                                    }
                                },
                                mini_promotions: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                    config: {
                                        partial: "common/mini_promotions/mini_promotions"
                                    }
                                },
                                mini_sport: {
                                    type: "module",
                                    skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                    config: {
                                        settings: "miniSport",
                                        initialData: "getMiniSport",
                                        info: {
                                            targetEl: "#rightColumn"
                                        }
                                    }
                                },
                                live_chat: {
                                    type: "plain",
                                    config: {
                                        partial: "common/live_chat/live_chat"
                                    },
                                    data: {
                                        live_chat: TRANSLATIONS.live_chat,
                                        need: TRANSLATIONS.need,
                                        help: TRANSLATIONS.help,
                                        lets_talk: TRANSLATIONS.lets_talk,
                                        click_here_to_chat: TRANSLATIONS.click_here_to_chat
                                    }
                                },
                            }
                        }
                    }
                },
                "sport/home": {
                    type: "layout",
                    data: {
                        vueContainers: false,
                        leftColumnVueWrapper: true,
                        rightColumnVueContainer: true,
                        leftCreditUserBalanceContainer: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                    },
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    components: {
                        left_column: {
                            type: "plain",
                            config: {
                                target: "#leftColumn"
                            },
                            components: {
                                bet_slip: getBetSlipConfig("#leftColumn"),
                                favorites_events: {
                                    type: "module",
                                    config: {
                                        settings: "favoritesEvents",
                                        info: {
                                            // targetEl: "#leftColumn"
                                        }
                                    }
                                },
                                search_box: {
                                    type: "module",
                                    config: {
                                        settings: "searchBox",
                                        initialData: "",
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                },
                                sidebar_navigation: {
                                    type: "module",
                                    skipBuild: false,
                                    config: {
                                        initialData: 'getSidebarNavigation',
                                        settings: 'sidebarNavigation',
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                }
                            }
                        },
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {}
                        },
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#rightColumn"
                            },
                            components: {
                                mini_games: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                    config: {
                                        partial: "common/mini_games/mini_games"
                                    }
                                },
                                mini_promotions: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                    config: {
                                        partial: "common/mini_promotions/mini_promotions"
                                    }
                                },
                                mini_sport: {
                                    type: "module",
                                    skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                    config: {
                                        settings: "miniSport",
                                        initialData: "getMiniSport",
                                        info: {
                                            targetEl: "#rightColumn"
                                        }
                                    }
                                },
                            }
                        },
                    }
                },
                "sport/index": Boolean(window.BaseConfig.get('SPORTSBOOK_IFRAME')) ? SINGLE_COLUMN_LAYOUT : {
                    type: "layout",
                    config: {
                        key: "3columns-fluid-scrollbars",
                        partial: "common/layouts/3columns-fluid-scrollbars",
                        target: "#page-content"
                    },
                    data: {
                        vueContainers: true,
                        rightColumnVueContainer: true,
                        leftCreditUserBalanceContainer: true,
                        isNewLayout: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                        hideRightColumnInitially: Boolean(BaseConfig.get('HIDE_RIGHT_COLUMN_INITIALLY')),
                    },
                    components: {
                        left_column: {
                            type: "plain",
                            config: {
                                target: "#leftColumn"
                            },
                            components: {
                                bet_slip: getBetSlipConfig("#leftColumn", BaseConfig.get('IS_NEW_LAYOUT')),
                                favorites_events: {
                                    type: "module",
                                    config: {
                                        settings: "favoritesEvents",
                                        info: {
                                            // targetEl: "#leftColumn"
                                        }
                                    }
                                },
                                search_box: {
                                    type: "module",
                                    skipBuild: Boolean(BaseConfig.get('IS_NEW_LAYOUT')),
                                    config: {
                                        settings: "searchBox",
                                        initialData: "",
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                },
                                sidebar_navigation: {
                                    type: "module",
                                    skipBuild: false,
                                    config: {
                                        initialData: 'getSidebarNavigation',
                                        settings: 'sidebarNavigation',
                                        info: {
                                            targetEl: "#leftColumn"
                                        }
                                    }
                                }
                            }
                        },
                        main_content: {
                            type: "plain",
                            config: {},
                            components: {
                                filter_holder: {
                                    type: "plain",
                                    skipBuild: Config.ACTION === 'favorites' || Config.ACTION === 'search' ? true : false,
                                    config: {
                                        target: "#mainContent",
                                        partial: 'common/general/filter_wrapper',
                                    },
                                    components: {
                                        filer_league: {
                                            type: 'module',
                                            skipBuild: false,
                                            config: {
                                                settings: "filterLeagues",
                                                initialData: "getFilterLeagues",
                                                info: {
                                                    targetEl: "#filterContainerMain"
                                                }
                                            }
                                        },
                                        day_filter: {
                                            type: "module",
                                            skipBuild: Config.CONTROLLER == 'sport' && Config.ACTION == 'early' ? false : true,
                                            config: {
                                                settings: "dayFilters",
                                                initialData: "getDateFilters",
                                                info: {
                                                    targetEl: "#sportFilterInnerContainer"
                                                }
                                            }
                                        },
                                        filter_teasers: {
                                            type: 'module',
                                            config: {
                                                settings: "filterTeasers",
                                                initialData: "getFilterTeasers",
                                                info: {
                                                    targetEl: "#filterContainerSecondary"
                                                }
                                            }
                                        },
                                        teasers: {
                                            type: 'module',
                                            config: {
                                                settings: "teasers",
                                                initialData: "getTeasers",
                                                info: {
                                                    targetEl: "#filterContainerSecondary"
                                                }
                                            }
                                        }
                                    }
                                },
                                euro_sport_breadcrumb: {
                                    type: "module",
                                    config: {
                                        settings: "euroSportBreadcrumb",
                                        info: {
                                            targetEl: "#mainContent"
                                        }
                                    }
                                },
                                // index_sport removed - now handled by Vue AsianIndexHome component
                            }
                        },
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#rightColumn"
                            },
                            components: {
                                mini_games: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !Config.ENABLE_PLUGIN_MINI_GAMES && BaseConfig.get('USE_SB_OPERATOR_MINI_GAMES') !== '1',
                                    config: {
                                        partial: "common/mini_games/mini_games"
                                    }
                                },
                                mini_promotions: {
                                    type: "plain",
                                    skipBuild: Config.PLUGIN_MODE && !BaseConfig.get('MINI_PROMOTIONS'),
                                    config: {
                                        partial: "common/mini_promotions/mini_promotions"
                                    }
                                },
                                mini_sport: {
                                    type: "module",
                                    skipBuild: BaseConfig.get('DISABLE_R_COL_MINI_SPORT'),
                                    config: {
                                        settings: "miniSport",
                                        initialData: "getMiniSport",
                                        info: {
                                            targetEl: "#rightColumn"
                                        }
                                    }
                                },
                            }
                        },
                    }
                },
                "sport/superpot": SINGLE_COLUMN_LAYOUT,
                "index/landing": {
                    type: "layout",
                    config: {
                        key: "landing-fluid-scrollbars",
                        partial: "common/layouts/landing-fluid",
                        target: "#page-content"
                    }
                },
                "index/campaignPromotions": {
                    type: "layout",
                    config: {
                        key: "campaign-promotion-fluid-scrollbars",
                        partial: "common/layouts/campaign-promotion-page-fluid",
                        target: "#page-content"
                    },
                    components: {
                        right_column: {
                            type: "plain",
                            config: {
                                target: "#mainContent"
                            },
                        }
                    }
                },
            },
        globals: {
            vue_components: {
                type: "plain",
                config: {
                    externalScripts: true
                },
            },
            service_bar_primary: {
                type: "plain",
                skipBuild: ((BaseConfig.get('IS_CASINO_MODE') && !Config.IS_DEFAULT_HEADER_ENABLED) || Config.PLUGIN_MODE) || (Config.CASINO_ORIENTED_SPORTSBOOK && (Config.CONTROLLER != 'euro' && Config.CONTROLLER != 'sport')) || (BaseConfig.get('IS_NEW_LAYOUT') && Config.CONTROLLER == '' && Config.ACTION == '') || BaseConfig.get('HIDE_SERVICE_BAR_PRIMARY') ? true : false,
                config: {
                    target: "#serviceBarPrimary",
                    partial: "common/general/service_bar_primary"
                },
            },
            wallet_transfer: {
                type: 'module',
                skipBuild: !BaseConfig.get('WALLETS') || !Config.USER_LOGGED_IN ? true : false || Config.CONTROLLER == 'pages',
                config: {
                    settings: "walletTransfer",
                }
            },
            messages: {
                type: "module",
                config: {
                    settings: "serviceMessages",
                    initialData: "getHeaderIndicators",
                    info: {
                        targetEl: "#userInboxContainer"
                    }
                }
            },
            header_indicators_update: {
                type: "module",
                config: {
                    settings: "headerIndicators",
                }
            },
            footer: {
                type: "module",
                skipBuild: BaseConfig.get('FOOTER') !== '1' || (Config.PLUGIN_MODE || Config.ACTION == 'subscription' || Config.ACTION == 'promotionCampaign' || Config.CONTROLLER == 'marketing-pages'  || (Config.ACTION === 'vipClub' && !BaseConfig.get('ENABLE_FOOTER_IN_VIP_CLUB'))|| (Config.ACTION === '' && Config.CONTROLLER === '')) ? true : false,
                config: {
                    settings: 'footer',
                    info: {
                        targetEl: "#mainContent",
                        Config: Config,
                        BaseConfig: BaseConfig,
                        target: "#featureContentContainer"
                    }
                },
            }
        }
    }
}
; /** ----------------- **/ 
 function WebPage(webView, vue, parent, localeUrl) {
    this.webView = webView
    this.vue = vue
    this.parent = parent
    this.mediator = window.Mediator.getMediator()
    this.localeUrl = localeUrl
    this.navigateTo = function (location) {
        if (!location || typeof location !== 'string') {
            console.log('No valid location received in ', location)
            return
        }

        var currentUrl = window.location.pathname
        currentUrl = typeof window.stripApplicationPrefixFromUrl === 'function' ? window.stripApplicationPrefixFromUrl(currentUrl) : currentUrl

        // fall back to '/' if both localeUrl and location result in an empty string as $router.resolve(navigateToUrl) needs to resolve to a valid route , not the current one!
        var navigateToUrl = (this.localeUrl + (location === '/' ? '' : location)) || '/'

        if (currentUrl === navigateToUrl) {
            // If the current URL is the same as the target URL, do nothing
            return
        }
        //Close deposit modal after switching the URL
        window.WebPage.postMessage({
            type: 'TOGGLE_DEPOSIT_MODAL',
            payload: false,
        })

        // Logic for skipping vue routes that are not in the same scope as the current route and needs to be redirected with page reload
        const skipVueRoutesRegex = /(my|pages|superpot|gamification|forgotten-password|promo\/christmas|vipclub)/
        if (
            this.vue &&
            !skipVueRoutesRegex.test(currentUrl) &&
            !skipVueRoutesRegex.test(navigateToUrl)
        ) {
            var currentRoute = this.vue.$router.resolve(currentUrl)
            var matchedRoute = this.vue.$router.resolve(navigateToUrl)
            if (currentRoute.name && matchedRoute.name) {
                this.vue.$router.push(navigateToUrl)
                return
            }
        }

        if (typeof window.browserRedirectTo === 'function') {
            window.browserRedirectTo(navigateToUrl)
        } else {
            console.error('Cannot use browserRedirectTo, falling back to window.location.href')
            // @window-location-ignore
            window.location.href = navigateToUrl
        }
    }
}

WebPage.prototype.setVue = function (vue) {
    this.vue = vue
}

WebPage.prototype.sendMessage = function (data) {
    var message = JSON.stringify(data)

    if (this.parent) {
        this.parent.postMessage(message, '*')
    }

    if (!this.webView) {
        return
    }
    if (typeof this.webView.postMessage !== 'function') {
        //TODO we observe this error in sentry, however it doesn't seem to be breaking anything
        //will comment so it doesn't spam sentry
        // if(window.ErrorTracker && typeof window.ErrorTracker.trackError === 'function') {
        //     window.ErrorTracker.trackError(
        //         new Error(`window.ReactNativeWebView.postMessage is not a function. Cannot send: ${data.type}`),
        //         { tag: { namespace: 'webview' } })
        // }
        return
    }
    this.webView.postMessage(message)
}

WebPage.prototype.postMessage = function (data) {
    var type = data.type
    var payload = data.payload

    if (!type) {
        console.log('No type received in', data)
        return
    }

    if (!this.mediator) {
        console.log('No mediator detected', data)
        return
    }

    switch (type) {
    case 'EXTERNAL_CAROUSEL_DATA':
        this.vue.$store.commit('cms/SET_EXTERNAL_CMS_BANNERS', payload)
        break
    case 'TOGGLE_BET_SLIP':
        if (window.Config.ENABLE_BET_SLIP_V1) {
            window.VueEventBus.$emit('toggle_mobile_bet_slip')
        } else {
            this.mediator.trigger('BetSlipContainer_toggleBetSlipContainer')
        }

        if (this.vue && this.vue.$store.state.betBuilder.betBuilderModalOpened) {
            this.vue.$store.commit(
                'betBuilder/SET_BET_BUILDER_MODAL_OPENED',
                false
            )
        }
        break
    case 'TOGGLE_MY_BETS':
        this.mediator.trigger('MyBets_toggleMyBets')
        break
    case 'TOGGLE_BURGER_MENU':
        if (window.BaseConfig.get('IS_NEW_LAYOUT')){
            return
        }
        this.mediator.trigger('SideBar_toggleSidebar', payload)
        break
    case 'TOGGLE_USER_MENU':
        if (!window.BaseConfig.get('HEADER_MEMBER_SECTION_V2')) {
            this.mediator.trigger('UserMenu_toggleUserMenu', payload)
            return
        }
        if (!this.vue) {
            return
        }
        var isUserNavigationVisible = this.vue.$store.state.user.userNavigationVisible
        var toggleValue = (typeof payload !== 'undefined' || isUserNavigationVisible) ? payload : true
        this.vue.$store.commit(
            'user/SET_USER_NAVIGATION_VISIBLE',
            typeof payload !== 'undefined' ? payload : !isUserNavigationVisible
        )
        window.getBodyClassList()[toggleValue ? 'add' : 'remove']('modal-open')
        break
    case 'TOGGLE_DEPOSIT_MODAL':
        if (window.handlerInstance) {
            window.handlerInstance.handle(payload)
        }
        break
    case 'OPEN_LOGIN_MODAL':
        window.__PROMPT_AUTH_MODAL__('Login')
        break
    case 'HIDE_LOGIN_MODAL':
        window.__HIDE_AUTH_MODAL__('Login')
        break
    case 'NAVIGATE_TO':
        this.navigateTo(payload)
        break
    case 'SEARCH_FOR':
        if (!payload || typeof payload !== 'string') {
            console.log('No valid search query received in', data)
            return
        }
        var searchUrl = '/sports/search?search=' + payload
        this.navigateTo(searchUrl)
        break
    case 'SET_EXTERNAL_MINI_GAMES':
        if (!payload || typeof payload !== 'object') {
            console.log('No valid data format', data)
            return
        }
        console.log('SET_EXTERNAL_MINI_GAMES', payload)
        if (this.vue) {
            this.vue.$store.commit('shared/SET_EXTERNAL_MINI_GAMES', payload)
        }
        break
    case 'UPDATE_USER_BALANCE':
        this.mediator.trigger('UserBalance_forceUpdate')
        break
    case 'OPEN_MY_BETS_LIST':
        if (typeof window.browserRedirectTo === 'function') {
            window.browserRedirectTo(window.Config.LOCALE_URL + '/my/betlist')
        } else {
            console.error('Cannot use browserRedirectTo, falling back to window.location.href')
            // @window-location-ignore
            window.location.href = window.Config.LOCALE_URL + '/my/betlist'
        }
        break
    case 'SET_THEME_STYLES':
        if (!payload || typeof payload !== 'object') {
            console.log('No valid data format', data)
            return
        }
        window.ThemeBuilder.setThemeStyles(payload)
        break
    case 'RESET_THEME_STYLES':
        window.ThemeBuilder.resetThemeStyles()
        break
    case 'REMOVE_CSS_VARIABLE':
        if (!payload || typeof payload !== 'object') {
            console.log('No valid data format', data)
            return
        }
        window.ThemeBuilder.removeCSSVariable(payload)
        break
        //Will be used to handle DeepLinking to our components
    case 'TOGGLE_UI_FROM_WEBVIEW':
        if (!payload || typeof payload !== 'string') {
            console.log('Invalid data format', data)
            return
        }
        var component = payload.split(':')
        //Handle smartico deeplink
        if (component[0] === 'smartico') {
            if (typeof window._smartico !== 'undefined' && window.Config.USER_LOGGED_IN) {
                window._smartico.dp(payload.substring(payload.indexOf(':') + 1))
            }
        }
        break
    case 'OPEN_MY_SPORTSBOOK_MODAL':
        if (this.vue) {
            this.vue.$store.commit('user/SET_SPORTSBOOK_MODAL_OPENED', true)
        }
        break
    case 'OPEN_SPORT_SETTINGS_MODAL':
        if (this.vue) {
            this.vue.$store.commit('application/SET_SPORT_SETTINGS_MODAL_OPENED', true)
        }
        break
    case 'SET_USER_ODDS_FORMAT': {
        if (!payload || typeof payload !== 'string') {
            console.log('No valid data format', data)
            return
        }
        const params = { key: payload }
        if (this.vue) {
            this.vue.$store.dispatch('shared/CHANGE_ODD_FORMAT', params)
        }
        break
    }
    case 'REMOVE_BET_SLIP_SELECTIONS':
        this.mediator.trigger('BetSlip_removeAll')
        break
    case 'USER_REGISTRATION_SUCCESS':
        if (typeof window.trackRegEvent !== 'undefined') {
            window.trackRegEvent('reg_account_created', {
                member_id: window.BaseConfig.get('MEMBER_ID'),
                ...payload,
            })
        }
        break
    case 'CASHIER_INIT_EXTERNAL_URL_HANDLING':
        window.VueEventBus.$emit('CASHIER_INIT_EXTERNAL_URL_HANDLING')
        break
    case 'CLOSE_CASINO_GAME':
        window.getBodyClassList().remove('game-frame-visible')
        localStorage.removeItem('activeGameData')
        if (this.vue) {
            this.vue.$store.commit('casino/SET_ACTIVE_CASINO_GAME_DATA', null)
        }
        break
    default:
        console.log('Unknown message type')
        break
    }
}

window.WebPage = new WebPage(
    window.ReactNativeWebView,
    null,
    window.parent,
    window.Config.LOCALE_URL
)

window.WebPage.sendMessage({
    type: 'USER_LOGGED_IN',
    payload: !!window.Config.USER_LOGGED_IN,
})

window.WebPage.sendMessage({
    type: 'SET_FORCE_LOGIN_FAILURE',
    payload: !!window.Cookies.get('forceLoginPossibleFailure'),
})
window.Cookies.remove('forceLoginPossibleFailure')
; /** ----------------- **/ 
 initListenForDepositComplete();
if (Config.WHITE_LABEL_REGULATIONS.pause_casino_after_sport && Config.USER_LOGGED_IN === '1') {
    initListenForBlockCasino();
}
if (Config.WHITE_LABEL_REGULATIONS.pause_sport_after_casino && Config.USER_LOGGED_IN === '1') {
    initListenForBlockSport();
}

function setEpsCashierQuickDepositBootstrap(value) {
    window.EpsCashierQuickDepositBootstrap = value === true;
}

function clearEpsCashierQuickDepositBootstrap() {
    setEpsCashierQuickDepositBootstrap(false);
}

//TODO move all custom js in that block
$(function () {
    setEpsCashierQuickDepositBootstrap(false);
    initDropDownSelects();
    initPageReloadLinksBehaviour();
    preselectValues();
    initModalForms();
    initLiveChatPopup();
    initEmailVerificationModal();
    initHeaderLogin();
    initTooltips();
    initHelpPopups();
    initLicenceHref();
    initCookieMessage();
    setCookieMessage();
    initClearMultipleModals();
    saveGameLobbyUrl();
    checkDepositModal();
    initConversionFee();
    fixBlurryTooltips();
    initDepositRequiredModal();
    initLoginModal();
    window.vueRouteHelper = initDetectVueRoute();
    initPanicSelfExclude();
    initCommunicationMessages();
    initSmarticoGamificationAccessFromUrl();
    initGtagClickEvents();


    if (Config.WHITE_LABEL_REGULATIONS.reg_maiden_name) {
        initMaidenNameCheckbox();
    }

    if (typeof _smartico !== "undefined" && Config.USER_LOGGED_IN === "1") {
        _smartico.changeLanguage(Config.LOCALE_SHORT_ALIAS ? Config.LOCALE_SHORT_ALIAS : Config.LOCALE_SHORT);
    }

    if (localStorage.getItem('smarticoCalendar')) {
        setTimeout(function () {
            initSmarticoCalendar();
            window.localStorage.removeItem('smarticoCalendar');
        }, 1500);
    }

    if (localStorage.getItem('gamificationPopup')) {
        setTimeout(function () {
            initSmarticoGamificationPopup();
            localStorage.removeItem('gamificationPopup');
        }, 1500);
    }
    initKycForceUploadDocument();

    setTimeout(function () {
        initSessionCheck();
    }, 3000);

    if (typeof $solitics !== "undefined" && Config.USER_LOGGED_IN === "1") {
        if (BaseConfig.get('MEMBER_EMAIL') != $solitics.solitics_configuration.email) {
            localStorage.removeItem("SOLITICS_CONFIGURATION");
            var loginDetails = {
                memberId: BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '',
                email: BaseConfig.get('MEMBER_EMAIL') ? BaseConfig.get('MEMBER_EMAIL') : '',
                brand: BaseConfig.get('SOLITICS').brand,
                popupToken: BaseConfig.get('SOLITICS').popup_token,
            }
            $solitics.loginSuccess(loginDetails);
        }
        initSoliticsPageActivity('onPageEnter');
        initSoliticsButtonsActivity();
        $(window).bind('beforeunload', function () {
            initSoliticsPageActivity('onPageLeave');
        });
    }

    if (Config.USER_LOGGED_IN === "1") {
        if (Config.MY_SPORTSBOOK_DATA && Config.MY_SPORTSBOOK_DATA.is_my_sportsbook_allowed === '1') {
            $(document).on('click', '#sportsbookModalTrigger', function () {
                toggleSportsbookModal()
            });
        }
    }

    var idleExcludes = ['casino', 'my', 'promotions', 'results', 'recovery', 'pages'];
    if (idleExcludes.indexOf(Config.CONTROLLER) == -1) {
        setTimeout(function () {
            // Safari issue for detecting idle initially
            detectIdle();
        }, 3000);
    }

    Config.USER_IDLE = false;

    var $withdrawNotAllowedModal = $('#withdrawNotAllowedModal');
    $withdrawNotAllowedModal.on('show.bs.modal', function (e) {
        if (window.preventCashierModal(true)) {
            return e.preventDefault();
        }
    });

    var $paymentsNotAllowedModal = $('#paymentsNotAllowedModal');
    $paymentsNotAllowedModal.on('show.bs.modal', function (e) {
        if (BaseConfig.get('MEMBER_WITHDRAWAL_ALLOWED') === '1' && window.preventCashierModal(true)) {
            return e.preventDefault();
        }
    });

    function detectIdle() {
        var idleTime = 0,
            idleStart = new Date().getTime(),
            idleEnd = null,
            idleStartSet = false;

        $(document).on('mousemove', _.throttle(function () {
            sessionStorage.removeItem('idleCount');
        }, 1000));

        $('.idle-reload-confirm').on('click', function () {
            reloadIdlePage();
        });

        $('.idle-go-to-deposit').on('click', function () {
            if (Config.QUICK_DEPOSIT == 0) {
                $('.modal').modal('hide');
                // @window-location-ignore
                window.location.href = $(this).attr('data-href');
            }
        });

        var handleIdle = function () {
            if (Config.USER_LOGGED_IN == '1') {
                if (sessionStorage.getItem('idleCount') == null) {
                    sessionStorage.setItem("idleCount", 1);
                    if (Config.USER_IDLE) {
                        return;
                    }
                    reloadIdlePage();
                } else {
                    var currentIdleCount = Number(sessionStorage.getItem('idleCount'));
                    if (currentIdleCount >= 3) {
                        displayIdleModal();
                    } else {
                        sessionStorage.setItem("idleCount", currentIdleCount + 1);
                        if (Config.USER_IDLE) {
                            return;
                        }
                        reloadIdlePage();
                    }
                }
            } else {
                displayIdleModal();
            }
        };
        var awayCallback = function () {
            handleIdle();
        };

        var awayBackCallback = function () {
            sessionStorage.removeItem('idleCount');
        };

        var onVisibleCallback = function () {
            idleEnd = new Date().getTime();
            idleStartSet = false;
            idleTime = idleEnd - idleStart;
            if (idleTime > 720000) {
                handleIdle();
            } else {
                sessionStorage.removeItem('idleCount');
            }
        };

        var onHiddenCallback = function () {
            if (idleStartSet) {
                return;
            }
            idleStart = new Date().getTime();
            idleStartSet = true;
        };
        var idle = new Idle({
            onHidden: onHiddenCallback,
            onVisible: onVisibleCallback,
            onAway: awayCallback,
            onAwayBack: awayBackCallback,
            awayTimeout: 20 * 60000
        }).start();

    }

    function reloadIdlePage() {
        window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
        window.location.reload();
    }

    function displayIdleModal() {
        if (Config.USER_IDLE || BaseConfig.get('IS_CASINO_MODE') || Config.IS_LANDING_PAGE) {
            return;
        }
        Config.USER_IDLE = true;

        // Update User Idle in Vuex
        if (document.getElementById('appComponents')) {
            var bvModal = document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$bvModal;
            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_USER_IDLE', true);
        }

        // Compare with object as FF cannot check properly for undefined

        if (typeof window.__disconnectOddsSocket === 'function') {
            window.__disconnectOddsSocket();
        }
        sessionStorage.removeItem('idleCount');
        $('.modal').modal('hide');
        if (bvModal) {
            bvModal.hide('registrationModal')
        }
        if (Config.PLUGIN_MODE) {
            reloadIdlePage();
        } else {
            var idleModalId = getIdleModalId()
            if (document.getElementById('appComponents')) {
                document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$eventBus.$emit('show_modal', idleModalId)
            }
        }
    }

    function getIdleModalId() {
        var idleModalId = 'idleModal';

        if (Config.USER_LOGGED_IN != '1' && Config.IS_REGISTER_ALLOWED != 0 && $('#idleModalRegister').length) {
            idleModalId = 'idleModalRegister'
        }

        if (Config.USER_LOGGED_IN == '1' && Config.USER_TYPE == '0') {
            // Check if user balance is less than 10
            if ((Number(Config.USER_BALANCE) < 10)) {
                // Check if user has used deposit
                if (Config.IS_DEPOSITED != 0 && $('#idleModalReloadDeposit').length) {
                    idleModalId = 'idleModalReloadDeposit';
                } else {
                    if ($('#idleModalFirstDeposit').length) {
                        idleModalId = 'idleModalFirstDeposit'
                    }
                }
            }

        }
        return idleModalId
    }

    // Custom element's functionality
    function initDropDownSelects() {

        $('.dropdown-select .dropdown-item').on('click', function () {
            var $option = $(this);
            selectValue($option, true);
            $option.addClass('active').siblings().removeClass('active');
        });
    }

    function selectValue($option, trigger) {
        var value = $option.attr('value'),
            text = $option.text(),
            $input = $option.parent().find('input'),
            $title = $option.closest('.dropdown-select').find('.btn-dropdown-label');
        $title.text(text);
        if (trigger) {
            $input.val(value).trigger('change').trigger('input');
        }
    }

    function preselectValues() {
        $('.dropdown-select').each(function () {
            var $activeOption = $(this).find('.dropdown-item.active');
            if ($activeOption.length) {
                selectValue($activeOption);
            } else {
                var $firstOption = $(this).find('.dropdown-item').first();
                selectValue($firstOption);
            }
        });
    }

    function initPageReloadLinksBehaviour() {
        $(document).on('click', '.pr-link-item', function (e) {
            var bodyClassList = window.getBodyClassList()
            var $clickedEl = $(e.target),
                loaderTargetClassList = $clickedEl.attr('data-loader-el') ? $($clickedEl.attr('data-loader-el')).classList : bodyClassList;

            if (loaderTargetClassList) {
                loaderTargetClassList.add('loader-circle-box-content', 'loader-white', 'loader-center');
            }
            bodyClassList.add('blurred-content');
            setTimeout(function () {
                if (loaderTargetClassList) {
                    loaderTargetClassList.remove('loader-circle-box-content', 'loader-white', 'loader-center');
                }
                bodyClassList.remove('blurred-content');
            }, 5000)
        });
    }

    function initEmailVerificationModal() {
        var cryptouserVerifiedEmail = !Config.USER_LOGGED_IN && BaseConfig.get('ENABLE_CRYPTO') === '1'

        if ((Config.USER_STATUS !== 'suspended' && Config.IS_EMAIL_VERIFIED !== "0" && !Config.PLUGIN_MODE && BaseConfig.get('ENABLE_CRYPTO') === '0') || cryptouserVerifiedEmail) {
            window.localStorage.removeItem('userActivationModal');
        }

    }

    function initModalForms() {
        // Global -> clearing all form elements
        $('.modal').on('show.bs.modal', function () {
            var $form = $(this).find('form');
            if ($form.length) {
                $form.removeClass('was-validated');
                var $textFormElements = $form.find('input[type="email"], input[type="text"], input[type="password"]');
                if ($form.attr('clear-fields') != 'false') {
                    $textFormElements.removeClass('is-invalid');
                    $textFormElements.val('');
                }
            }
        });
    }

    function initHeaderLogin() {

        var $headerLoginForm = $('#header-login-form'),
            $loginModal = $('#login-guest-modal');

        $headerLoginForm.on('submit', function (e) {

            e.preventDefault();
            e.stopPropagation();

            getElement($headerLoginForm).ajaxRequest("login", {
                toastr: false,
                loadAction: $('body'),
                keepLoader: true,
                validate: function () {
                    var isValid = Validator.validateElements($headerLoginForm, false);
                    if (!isValid) {
                        var message = $loginModal.find('.error-mandatory').text();
                        displayLoginModal(message);
                    }
                    return isValid;
                },
                onError: function (response) {
                    if (typeof response.data.reload != "undefined" && response.data.reload == true) {
                        window.location.reload();
                    } else {
                        displayLoginModal(response.message);
                    }
                },

                onFailure: function () {
                    var message = $loginModal.find('.error-general').text();
                    displayLoginModal(message);
                },

                onSuccess: function (data) {
                    if (!data.referrer) {
                        data.referrer = "/";
                    }
                    // @window-location-ignore
                    window.location = data.referrer;
                }
            });

        });

        function displayLoginModal(message) {
            $headerLoginForm.find('input').val('');
            $loginModal.modal('show');
            var $loginError = $loginModal.find('.error-container').find('.alert');
            $loginError.removeClass('d-none').text(message)
        }

    }

    function reopenProactiveChatWidget () {
        var chatWidget = window.ChatWidget;
        if (!chatWidget) {
            return;
        }
        chatWidget.show();
        chatWidget.open();
        if (!chatWidget.chatOpened && typeof chatWidget.chatButtonHandler === 'function') {
            chatWidget.chatButtonHandler();
        }
    }

    function toggleZohoChat(onlyOpen) {
        if (window.ChatWidget) {
            if (typeof window.ChatWidget.getActiveSession === 'function' && window.ChatWidget.getActiveSession()) {
                reopenProactiveChatWidget();
                return;
            }
            if (window.ChatWidget.chatOpened === true || window.ChatWidget.hasActiveSession === true) {
                reopenProactiveChatWidget();
                return;
            }
        }

        if (typeof $zoho == 'object' && typeof $zoho.salesiq == 'object' && typeof $zoho.salesiq.floatwindow == 'object') {
            if (onlyOpen) {
                $zoho.salesiq.floatwindow.open();
            } else {

                if ($zoho.salesiq.floatwindow.visible() == "show" || $zoho.salesiq.floatwindow.visible() == "hide" || typeof $zoho.salesiq.floatwindow.visible() == "undefined") {
                    $zoho.salesiq.floatwindow.open();
                }
                else {
                    $zoho.salesiq.floatwindow.close();
                }
            }
        }
    }
    function initZdTags() {
        if (Config.USER_LOGGED_IN === "") {
            var tags = JSON.parse(window.localStorage.getItem("zEchatTags"));
            if (tags && tags.length) {
                window.ZendeskCommunicator.removeTags(tags);
                var userLoggedTagsPrefixes = ['rb_', 'svb_', 'cvb_', 'pl_']
                window.zESettings.webWidget.chat.tags = window.zESettings.webWidget.chat.tags.filter(function (el) {
                    return !userLoggedTagsPrefixes.some(function (prefix) {
                        return el.includes(prefix)
                    })
                })
                window.localStorage.removeItem("pendingPayments");
                window.localStorage.removeItem("zEchatTags");
            }
        }
        window.ZendeskCommunicator.addTags(window.zESettings.webWidget.chat.tags)
    }
    function isServiceNowActiveEnabled (value) {
        return value === true || value === 1 || value === '1' || value === 'true';
    }
    function hasServiceNowLiveChatEmbedConfig () {
        if (BaseConfig.get('ZENDESK_API_KEY')) {
            return false;
        }
        var page = window.__SN_EMBED__;
        if (page) {
            return Boolean(
                page.scriptUrl &&
                page.rawModuleId &&
                page.topicId &&
                isServiceNowActiveEnabled(page.isActive)
            );
        }
        return Boolean(
            isServiceNowActiveEnabled(BaseConfig.get('SERVICE_NOW_IS_ACTIVE')) &&
            BaseConfig.get('SERVICE_NOW_SCRIPT_URL') &&
            BaseConfig.get('SERVICE_NOW_MODULE_ID') &&
            BaseConfig.get('SERVICE_NOW_TOPIC_ID')
        );
    }

    function openServiceNowLiveChatFromLegacy () {
        if (!hasServiceNowLiveChatEmbedConfig()) {
            return;
        }
        if (Config.INTERNAL_CHAT && window.ChatWidget) {
            var snExternalSession = window.localStorage.getItem('externalChatSessionStarted') === '1';
            var proactiveActive =
                (typeof window.ChatWidget.getActiveSession === 'function' && window.ChatWidget.getActiveSession()) ||
                window.ChatWidget.chatOpened === true ||
                window.ChatWidget.hasActiveSession === true;
            if (proactiveActive && !snExternalSession) {
                reopenProactiveChatWidget();
                return;
            }
        }
        var invokeOpen = function () {
            if (typeof window.__OPEN_SERVICE_NOW_LIVE_CHAT__ === 'function') {
                window.__OPEN_SERVICE_NOW_LIVE_CHAT__();
                return;
            }
            window.__SN_LIVE_CHAT_OPEN_PENDING__ = true;
        };
        if (typeof window.__ENSURE_SERVICE_NOW_EMBED_BRIDGE__ === 'function') {
            void window.__ENSURE_SERVICE_NOW_EMBED_BRIDGE__().then(invokeOpen);
            return;
        }
        invokeOpen();
    }

    function initLiveChatPopup() {
        var hasSnEmbed = hasServiceNowLiveChatEmbedConfig();
        var hasChatProvider = Config.CHAT_INIT || BaseConfig.get('ZENDESK_API_KEY') || hasSnEmbed;
        if (!hasChatProvider || (!Config.HAS_LIVE_CHAT && !hasSnEmbed)) {
            return;
        }

        if (typeof zE !== 'undefined') {
            var zdLocale = initZendeskLocaleAndDepartments().locale;
            zE(function () {
                zendeskWidgetType = zE.prototype.constructor.widget
                window.ZendeskCommunicator = new ZendeskCommunicator();
                setZendeskLocaleTags();
                window.ZendeskCommunicator.setLocale(zdLocale);
                var identify = {};
                if (BaseConfig.get('MEMBER_NAME')) {
                    identify.name = BaseConfig.get('MEMBER_NAME');
                }
                if (BaseConfig.get('MEMBER_EMAIL')) {
                    identify.email = BaseConfig.get('MEMBER_EMAIL');
                }
                if (_.size(identify) && zendeskWidgetType === 'classic') {
                    zE.identify(identify);
                }

                window.ZendeskCommunicator.listenEvent('unreadMessages', function (number) {
                    window.__UPDATE_ZENDESK_WIDGET__('open');
                });
                initZdTags()
                if (zendeskWidgetType === 'classic') {
                    zE('webWidget:on', 'chat:end', function () {
                        window.ZendeskCommunicator.removeTags('deposit_assistance');
                    });
                    zE('webWidget:on', 'chat:start', function () {
                        updateDepartment()
                        window.UILogger.logEvent(window.UILogger.eventNames.LiveChat.start);
                    });
                }
            });
        }

        if (Config.ACTION == 'deposit' && (getParameterByName('d-type') == 'wafacash' || getParameterByName('d-type') == 'moroccan-bank-transfer')) {
            setTimeout(function () {
                toggleZohoChat(true)
            }, 2000);
        }

        $(document).on('click', '.live-chat-popup', function (e) {
            logLiveChatOpenEvent();
            var hasSnEmbedClick = hasServiceNowLiveChatEmbedConfig();
            if (window.BaseConfig.get('ZENDESK_API_KEY') || (!window.Config.HAS_LIVE_CHAT && !hasSnEmbedClick)) {
                return;
            }
            e.preventDefault();

            if (typeof kayako == 'object' && typeof kayako.show == 'function') {
                kayako.maximize();
            }

            var onlyOpen = false;
            if ($(e.currentTarget).attr('open')) {
                onlyOpen = true;
            }

            if (hasSnEmbedClick) {
                openServiceNowLiveChatFromLegacy();
                return false;
            }

            toggleZohoChat(onlyOpen);

            if (typeof zE !== 'undefined') {
                window.__UPDATE_ZENDESK_WIDGET__('show');
                window.__UPDATE_ZENDESK_WIDGET__('open');
            }

            if (typeof Comm100API !== 'undefined') {
                Comm100API.do('livechat.button.click');
            }

            if (typeof Tawk_API !== 'undefined') {
                Tawk_API.toggle();
            }

            if (typeof LiveChatWidget !== 'undefined') {
                var visibility = Object.values(LiveChatWidget.get('state'))[1];
                if (visibility === 'minimized') {
                    LiveChatWidget.call("maximize");
                } else {
                    LiveChatWidget.call("minimize");
                }
            }

            return false;
        });

    }

    /* DISABLE BROWSER AUTOCOMPLETE FUNCTIONALITY FOR PASSWORD FIELDS
    ****************************************************************/

    var checkCaretPosition = null;

    function maskPassword(maskedField, passwordField, fullMaskField) {
        var maskingSymbol = "\u25CF";
        var plainPassword = "";

        if (passwordField.val() != '') {
            for (var i = 0; i < maskedField.val().length; i++) {
                if (maskedField.val().charAt(i) == maskingSymbol) {
                    plainPassword += passwordField.val().charAt(i);
                } else {
                    plainPassword += maskedField.val().charAt(i);
                }
            }
        } else {
            plainPassword = maskedField.val();
        }

        var maskedPassword = encodeMaskedPassword(plainPassword, fullMaskField, maskingSymbol);

        if (passwordField.val() != plainPassword || maskedField.val() != maskedPassword) {
            passwordField.val(plainPassword);
            maskedField.val(maskedPassword);
        }
    }

    function encodeMaskedPassword(plainPassword, fullMaskField, maskingSymbol) {
        var characterLimit = fullMaskField === true ? 0 : 1;

        for (var maskedString = '', i = 0; i < plainPassword.length; i++) {
            if (i < plainPassword.length - characterLimit) {
                maskedString += maskingSymbol;
            } else {
                maskedString += plainPassword.charAt(i);
            }
        }

        return maskedString;
    }

    function keepCaretAtEnd(maskedField, state) {
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
        if (state == 'start') {
            if (isIE) {
                checkCaretPosition = window.setInterval(function () {
                    var range = maskedField[0].createTextRange();
                    var valueLength = maskedField.val().length;
                    var unitToMove = 'character';

                    range.moveEnd(unitToMove, valueLength);
                    range.moveStart(unitToMove, valueLength);
                    range.select();
                }, 200);
            } else {
                checkCaretPosition = window.setInterval(function () {
                    var valueLength = maskedField.val().length;
                    if (!(maskedField[0].selectionEnd == valueLength && maskedField[0].selectionStart <= valueLength)) {
                        maskedField[0].selectionStart = valueLength;
                        maskedField[0].selectionEnd = valueLength;
                    }
                }, 200);
            }
        } else if (state == 'stop') {
            window.clearInterval(checkCaretPosition);
        }
    }

    function initSessionCheck() {
        if (Config.USER_TYPE !== '' && Config.USER_LOGGED_IN == 1 && Config.hasOwnProperty('RESPONSIBLE_GAMING') && Config.RESPONSIBLE_GAMING.hasOwnProperty('session') && Config.RESPONSIBLE_GAMING.session.limit_on !== 'none' && Config.RESPONSIBLE_GAMING.session.amount != 0) {
            var now = new Date();
            var utcNowTimestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

            var dateLoggedAt = dateUtil(Config.USER_LOGGED_AT, 'YYYY-MM-DD HH:mm').toDate();
            var utcLoggedInTimestamp = Date.UTC(dateLoggedAt.getFullYear(), dateLoggedAt.getMonth(), dateLoggedAt.getDate(), dateLoggedAt.getHours(), dateLoggedAt.getMinutes(), dateLoggedAt.getSeconds());

            var timeDiffInMilliSeconds = Math.abs(utcNowTimestamp - utcLoggedInTimestamp);

            var showLogoutPopup = function () {
                Config.USER_IDLE = true;
                Config.USER_SESSION_LIMIT_REACHED = true;

                // Compare with object as FF cannot check properly for undefined

                if (typeof window.__disconnectOddsSocket === 'function') {
                    window.__disconnectOddsSocket();
                }
                $('.modal').modal('hide');
                window.getBodyClassList().add('blurred-content');
                $('#responsibleSessionModal').modal('show');

                if (Config.RESPONSIBLE_GAMING.session_per_periods) {
                    $.ajax({
                        url: "/" + Config.LOCALE_SHORT + "/auth/operation/markSessionDurationExpire",
                        method: "GET",
                    });
                }
            };

            var sessionLimitInMilliSeconds = 0;

            switch (Config.RESPONSIBLE_GAMING.session.period) {
                case 'sec':
                    sessionLimitInMilliSeconds = Config.RESPONSIBLE_GAMING.session.amount * 1000;
                    break;
                case 'min':
                    sessionLimitInMilliSeconds = Config.RESPONSIBLE_GAMING.session.amount * (1000 * 60);
                    break;
                case 'hour':
                    sessionLimitInMilliSeconds = Config.RESPONSIBLE_GAMING.session.amount * (1000 * 60 * 60);
                    break;
            }

            if (sessionLimitInMilliSeconds >= timeDiffInMilliSeconds) {
                var timeInMilliseconds = (sessionLimitInMilliSeconds - timeDiffInMilliSeconds);

                setTimeout(showLogoutPopup, timeInMilliseconds);
            }
            else {
                showLogoutPopup();
            }
        }

    }



    function initTooltips() {
        setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
        }, 1000)
    }

    function initHelpPopups() {
        $(document).on('click', '.help-popup', function (e) {
            e.preventDefault();
            var width;

            if ($(this).hasClass('slider-item-banner') || $(this).hasClass('btn-slide-action') || $(this).hasClass('popup-wide')) {
                width = 1300;
            }

            if ($(this).attr('href') === undefined) {
                var url = $(this).attr('data-href');
            } else {
                var url = $(this).attr('href');
            }

            PopupCenter(url, 'popupWindow', width ? width : '1000', '800', true, false, 'noopener, noreferrer');
        });
    }

    function initLicenceHref() {
        var license = $('.license-container').find('a').not('.license-link'),
            licenseLink = $('.license-link');

        setTimeout(function () {
            if (license.length > 0) {
                licenseLink.attr('href', license.attr('href'));
            } else {
                initLicenceHref();
            }
        }, 2000);
    }

    function initCookieMessage() {
        if (Config.PLUGIN_MODE) {
            return
        }
        var getCookie = localStorage.getItem("cookieMessageContainer");

        if (getCookie !== "true") {
            $(".cookie-message-holder").removeClass("d-none");
        }
    }
    function setCookieMessage() {
        $(".cookie-message-holder .btn-accept-cookie").click(function (e) {
            e.preventDefault();
            localStorage.setItem("cookieMessageContainer", "true");
            setGtmDataLayer([], 'cookie_consent');
            $(".cookie-message-holder").addClass("d-none");
        })
    }
    function initSoliticsPageActivity(pageEventType) {
        var track = BaseConfig.get('SOLITICS').soliticsTrack;
        if (track) {
            $solitics[pageEventType](track.page, track.data);
        }
    }
    function initSoliticsButtonsActivity() {
        $.each(BaseConfig.get('SOLITICS').track_buttons, function (index, value) {
            $(index).click(function (e) {
                if (typeof e.clientX === 'number') {
                    $solitics.onClick(value.key, {
                        "email": $solitics.solitics_configuration.email,
                        "user_id": $solitics.solitics_configuration.memberId
                    });
                }
            });
        });
    }

    function initClearMultipleModals() {
        $('.modal').on('hidden.bs.modal', function () {
            if ($('.modal:visible').length) {
                window.getBodyClassList().add('modal-open');
            }
            initClearModalErrors($(this));
        });
    }
    function initClearModalErrors($modal) {
        var $errorAlert = $modal.find('.error-container .alert');
        if (!$errorAlert.hasClass('d-none')) {
            $errorAlert.addClass('d-none').text('');
        }
    }

    function removeQuickDepositParam() {
        var currentUrl = new URL(window.location.href)
        if (!currentUrl.searchParams.has('quick_deposit')) {
            return
        }
        var $appComponents = $('#appComponents')[0]
        if ($appComponents && $appComponents.__vueParentComponent) {
            var globalProps = $appComponents.__vueParentComponent.appContext.config.globalProperties
            var vueRouter = globalProps.$router
            if (vueRouter) {
                var currentLocation = new URL(window.location.href)
                var newQuery = {}
                currentLocation.searchParams.forEach(function (value, key) {
                    if (key !== 'quick_deposit') {
                        newQuery[key] = value
                    }
                })
                vueRouter.replace({ path: currentLocation.pathname, query: newQuery })
            }
        }
        currentUrl.searchParams.delete('quick_deposit')
        window.history.replaceState(null, '', currentUrl.toString())
    }

    function checkDepositModal() {
        setEpsCashierQuickDepositBootstrap(getParameterByName('quick_deposit') == 'true');

        if (window.EpsCashierQuickDepositBootstrap === true) {
            if (Array.isArray(window.missingPersonalDetailsFields) && window.missingPersonalDetailsFields.length > 0) {
                return;
            }
            if (!Config.USER_LOGGED_IN) {
                if (!BaseConfig.get('VUE_LOGIN_ENABLED')) {
                    $('#login-guest-modal').modal('show');
                    removeQuickDepositParam();
                }
                // For Vue login modal, param removal is handled in LoginModal.vue
                return;
            }
            window.isQuickDepositParamActive = true
            removeQuickDepositParam()
            if (BaseConfig.get('MEMBER_DEPOSIT_ALLOWED') === '0' || BaseConfig.get('MEMBER_PAYMENTS_ALLOWED') === '0') {
                if (typeof window.trackRegEvent !== 'undefined') {
                    window.trackRegEvent('reg_deposit_not_allowed', {
                        MEMBER_DEPOSIT_ALLOWED: BaseConfig.get('MEMBER_DEPOSIT_ALLOWED'),
                        MEMBER_PAYMENTS_ALLOWED: BaseConfig.get('MEMBER_PAYMENTS_ALLOWED')
                    })
                }
                return;
            }

            var bonusCode = getParameterByName("bcode");
            if (bonusCode) {
                localStorage.setItem("depositBonusCode", bonusCode)
            }

                if (Config.QUICK_DEPOSIT == 1 && !$('#completeRegisterModal').length) {
                if (Config.CASHIER === 'default' || Config.GATE_2_WAY_PAYMENTS_ENABLED) {
                    $('#depositModal').modal('show');
                } else {
                    $('#cashierModal').modal('show');
                    if (typeof window.trackRegEvent !== 'undefined') {
                        window.trackRegEvent('reg_cashier_opens_automatically')
                    }
                }
                if ($('#cashierContainer')[0]) {
                    $('#cashierContainer')[0].__vueParentComponent.appContext.config.globalProperties.$store.commit('cashier/SET_CASHIER_METHOD', 'deposit');
                }
            } else if (!$('#completeRegisterModal').length) {
                clearEpsCashierQuickDepositBootstrap();
            }
        }
    }

    function initConversionFee() {
        var $conversionFeeInfo = $('#conversionFeeInfo');
        if (Config.CONTROLLER === 'my' && (Config.ACTION === 'deposit' || Config.ACTION === 'withdraw') && $conversionFeeInfo.length) {
            initConversionFeeCalculator($conversionFeeInfo);
            initConversionFeeUpdater($conversionFeeInfo);
        }
    }

    function initDepositRequiredModal() {
        var $gameLink = $('.open-deposit-required-modal');
        $gameLink.click(function () {
            if (Config.IS_DEPOSITED === "0") {
                $('#depositRequiredModal').modal('show');
                return false;
            }
        });
    }

    function initLoginModal() {
        if (getParameterByName("login") == "true") {
            if (!Config.USER_LOGGED_IN) {
                $('#login-guest-modal').modal('show');
            }
        }
    }

    function initDetectVueRoute() {
        return {
            isVueRoute: function () {
                var vueRoute = false;
                var $appComponents = $('#appComponents')[0];
                if ($appComponents && $appComponents.__vueParentComponent && $appComponents.__vueParentComponent.appContext.config.globalProperties.$route.name) {
                    vueRoute = true;
                }
                return vueRoute;
            },
            getVueRouteName: function () {
                if (window.vueRouteHelper.isVueRoute()) {
                    var $appComponents = $('#appComponents')[0];
                    return $appComponents.__vueParentComponent && $appComponents.__vueParentComponent.appContext.config.globalProperties.$route.name
                }
                return false
            },
            handleVueRoute: function (e, routeName, forceReload, routePath, params) {
                var isVueRoute = window.vueRouteHelper.isVueRoute();
                var $appComponents = $('#appComponents')[0];

                if (isVueRoute && !forceReload) {
                    e.preventDefault();
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$router.push(routePath);
                } else {
                    this.addLoader(e);
                }
            },
            addLoader: function (e) {
                if ($(e.currentTarget).attr('data-target')) {
                    return;
                }
                var bodyClassList = window.getBodyClassList()
                bodyClassList.add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                setTimeout(function () {
                    bodyClassList.remove('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
                }, 5000)
            },
        }
    }

    function initPanicSelfExclude() {
        if (Config.WHITE_LABEL_REGULATIONS.panic_button && Config.USER_LOGGED_IN === '1') {
            $(document).on('click', '.btn-panic', function () {
                var panicSelfExclude = document.getElementById("panicSelfExclude");
                if (panicSelfExclude) {
                    panicSelfExclude.__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_PANIC_SELF_EXCLUDE', true);
                }
            });
        }
    }

    function initKycForceUploadDocument() {
        if (Object.values(Config.FORCE_UPLOAD_DOCUMENT)[0] === 'id' && !localStorage.getItem('forceUploadDocumentModalDismissed')) {
            var $userVerifyAccountModal = $('#user-verify-account-modal');
            $userVerifyAccountModal.modal('show');
            $userVerifyAccountModal.on('hidden.bs.modal', function (e) {
                localStorage.setItem('forceUploadDocumentModalDismissed', true);
            });
        }
    }

    function initSmarticoGamificationAccessFromUrl() {
        if (getParameterByName('missions') == "true") {
            if (!Config.USER_LOGGED_IN) {
                $('#login-guest-modal').modal('show');
                return;
            }
            localStorage.setItem('gamificationPopup', 1);
        }
    }

    function initSmarticoCalendar() {
        var smarticoCalendarDeepLink = window.localStorage.getItem('smarticoCalendar');
        if (smarticoCalendarDeepLink) {
            if (typeof _smartico !== "undefined") {
                _smartico.dp(smarticoCalendarDeepLink);
            }
        }
    }

    function initSmarticoGamificationPopup() {
        var customDeepLink = BaseConfig.get('GAMIFICATION_CUSTOM_DEEP_LINK')
        if (typeof _smartico !== "undefined") {
            _smartico.dp(customDeepLink ? customDeepLink : 'dp:gf');
        }
    }

    function initCommunicationMessages() {
        window.addEventListener("message", function (e) {
            var forbiddenStrings = ['recaptcha-setup'];
            if (e && typeof e.data === 'string' && !forbiddenStrings.includes(e.data)) {
                try {
                    var message = JSON.parse(e.data);
                    if (message.data && message.data.updateUserBalance && typeof Mediator == 'object') {
                        Mediator.getMediator().trigger('UserBalance_forceUpdate');
                        if (BaseConfig.get('IS_CASINO_MODE') && document.querySelectorAll(".cl-header-user-login")[0]) {
                            document.querySelectorAll(".cl-header-user-login")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
                        }
                    }

                    if (message.data && message.data.updateHeaderIndicators && typeof Mediator == 'object') {
                        Mediator.getMediator().trigger('HeaderIndicators_forceUpdate', {
                            activate_coupon: 1,
                        });
                    }
                } catch (e) {
                    console.debug("initCommunicationMessages", e);
                }
            }
        })
    }

    function initGtagClickEvents() {
        $(document).on('click', '[data-tracking-event]', function () {
            var trackingEventName = $(this).attr('data-tracking-event');
            var trackingEventValue = $(this).attr('data-tracking-value');
            var trackingEventParams = $(this).attr('data-tracking-params');
            var event_params = {}

            if (trackingEventParams) {
                try {
                    event_params = JSON.parse(trackingEventParams)
                } catch (e) {
                    console.log(e)
                }
            } else if (trackingEventValue) {
                event_params = {
                    value: trackingEventValue
                }
            }

            if (trackingEventName === window.UILogger.eventNames.Payment['cashier__deposit-button_select']) {
                const cashierIntent = $('#appComponents')[0] && $('#appComponents')[0].__vueParentComponent && $('#appComponents')[0].__vueParentComponent.appContext.config.globalProperties.$store.state.cashier.cashierMethod || '';

                event_params.member_id = window.BaseConfig.get('MEMBER_ID') || '';
                event_params.intent = cashierIntent;
                event_params.first_time_deposit = window.Config.IS_DEPOSITED === '0';
                event_params.after_registration = window.EpsCashierQuickDepositBootstrap === true;
            }

            window.UILogger.logEvent(trackingEventName, event_params)
        });
    }
    function toggleSportsbookModal() {
        if (document.getElementById('appComponents')) {
            document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('user/SET_SPORTSBOOK_MODAL_OPENED', true);
        }
    }
});

/**
 * @param boolean notResizable.
 */
/**
 * @param {string} url.
 * @param {string} title.
 * @param {string} w.
 * @param {string} h.
 * @param {Boolean} resizable - pop up is resizable.
 */
function PopupCenter(url, title, w, h, resizable, returnWindowReference, additionalWindowFeatures) {

    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var systemZoom = width / window.screen.availWidth;
    var left = (width - w) / 2 / systemZoom + dualScreenLeft;
    var top = (height - h) / 2 / systemZoom + dualScreenTop;

    var windowFeatures = 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ', resizable=' + resizable;

    if (additionalWindowFeatures) {
        windowFeatures += ', ' + additionalWindowFeatures;
    }

    var newWindow = window.open(url, title, windowFeatures);

    // Puts focus on the newWindow and checks if its object exists (noopener, noreferrer)
    if (window.focus && newWindow) {
        newWindow.focus();
    }

    if (returnWindowReference) {
        return newWindow;
    }
}

function saveGameLobbyUrl() {
    if (Config.PLUGIN_MODE) {
        return
    }
    // Default Lobby URL
    var gameLobbyUrl = Config.LOCALE_URL + '/online-casino';

    $(document).on('click', '.traditional-bingo', function () {
        gameLobbyUrl = Config.LOCALE_URL + '/electronic-bingo';
        localStorage.setItem('gameLobbyUrl', gameLobbyUrl);
        $("#gameLobbyUrl").attr("href", gameLobbyUrl);

        var $loginModal = $('#login-guest-modal');
        var $loginFormModal = $loginModal.find('#login-modal-form');

        var attdDataLoginReferer = document.createAttribute("data-login-referer");
        attdDataLoginReferer.value = "gamePlay";

        var attdDataGameName = document.createAttribute("data-game-name");
        attdDataGameName.value = "traditional-bingo";

        $loginFormModal[0].setAttributeNode(attdDataLoginReferer);
        $loginFormModal[0].setAttributeNode(attdDataGameName);

        if (CMS.headerTopMenu && CMS.headerTopMenu['traditional-bingo']) {
            var attdDataGameUrl = document.createAttribute("data-game-url");
            attdDataGameUrl.value = CMS.headerTopMenu['traditional-bingo'].direct_link;
            $loginFormModal[0].setAttributeNode(attdDataGameUrl);
        }
        return;
    });

    var controllerActionsMap = {
        casino: {
            casino: '/online-casino',
            casinoLive: '/live-casino',
            games: '/games',
            tvGames: '/tv-games'
        },
        euro: {
            home: '/sports'
        }
    };

    if (controllerActionsMap[Config.CONTROLLER]) {
        if (controllerActionsMap[Config.CONTROLLER][Config.ACTION]) {
            gameLobbyUrl = Config.LOCALE_URL + controllerActionsMap[Config.CONTROLLER][Config.ACTION];
            localStorage.setItem('gameLobbyUrl', gameLobbyUrl);
        } else {
            // If the user opens a game and there is no data in Local Storage - set a default Lobby URL.
            if (Config.CONTROLLER === 'casino' && Config.ACTION === 'play' && localStorage.getItem("gameLobbyUrl") === null) {
                localStorage.setItem('gameLobbyUrl', gameLobbyUrl);
            }
        }
    } else {
        if (localStorage.getItem("gameLobbyUrl") !== null) {
            localStorage.removeItem("gameLobbyUrl");
        }
    }

    if ($("#gameLobbyUrl").length) {
        gameLobbyUrl = localStorage.getItem("gameLobbyUrl");
        $("#gameLobbyUrl").attr("href", gameLobbyUrl);
    }

    // If the user visits Virtual Sports, set default Game Lobby Url on click
    $(document).on('click', '.nav-item.virtual-sports', function () {
        localStorage.setItem('gameLobbyUrl', Config.LOCALE_URL + '/online-casino');
    });
}

function initConversionFeeCalculator($conversionFeeInfo) {
    var transactionType = $conversionFeeInfo.attr('data-transaction-type');
    var conversionInfo = JSON.parse($conversionFeeInfo.attr('data-conversion-info'));
    var $amountField = $conversionFeeInfo.closest('.payment-form-body').find('.payment-form-amount');

    $amountField.on('input', function () {
        var totalTransactionAmount = calculateTotalTransactionAmount($conversionFeeInfo, transactionType, conversionInfo);
        updateConversionInfoMessage($conversionFeeInfo, totalTransactionAmount);
    });
}

function initConversionFeeUpdater($conversionFeeInfo, modalView) {
    var transactionType = $conversionFeeInfo.attr('data-transaction-type');
    var paymentMethod = $conversionFeeInfo.attr('data-payment-method');
    var updatePeriod = 1000 * 60;

    var updateConversionInfoInterval = setInterval(function () {
        $.ajax({
            url: "/" + Config.LOCALE_SHORT + "/my/operation/updateConversionInfo",
            data: {
                transactionType: transactionType,
                paymentMethod: paymentMethod
            },
            dataType: "json",
            method: "GET",
            success: function (response) {
                var totalTransactionAmount = undefined;
                if (response.status === 'success') {
                    updateConversionInfo($conversionFeeInfo, response.data);
                    totalTransactionAmount = calculateTotalTransactionAmount($conversionFeeInfo, transactionType, response.data);
                }

                updateConversionInfoMessage($conversionFeeInfo, totalTransactionAmount);
            },
            error: function () {
                updateConversionInfoMessage($conversionFeeInfo);
            }
        });
    }, updatePeriod);

    if (modalView) {
        $('#depositModal').on('hidden.bs.modal', function () {
            clearInterval(updateConversionInfoInterval);
        });
        $('#depositModal').find('#depositModalBack').on("click", function (e) {
            clearInterval(updateConversionInfoInterval);
        });
    }
}

function calculateTotalTransactionAmount($conversionFeeInfo, transactionType, conversionInfo) {
    var $amountField = $conversionFeeInfo.closest('.payment-form-body').find('.payment-form-amount');
    var requestedAmount = $.trim($amountField.val());
    var fromRate = conversionInfo.local_currency.rate;
    var toRate = conversionInfo.base_currency.rate;
    var feePercentage = transactionType === 'deposit' ? conversionInfo['conversion_deposit_fee'] : conversionInfo['conversion_withdrawal_fee'];
    var totalTransactionAmount = 0;

    if (requestedAmount !== "" || requestedAmount !== "0") {
        var convertedAmount = (requestedAmount / fromRate) * toRate;
        if (transactionType === 'deposit') {
            totalTransactionAmount = parseFloat(convertedAmount * (1 + (parseFloat(feePercentage) / 100))).toFixed(2);
        } else {
            totalTransactionAmount = parseFloat(convertedAmount * (1 - (parseFloat(feePercentage) / 100))).toFixed(2);
        }
    }

    return totalTransactionAmount;
}

function updateConversionInfo($conversionFeeInfo, data) {
    $conversionFeeInfo.attr('data-conversion-info', JSON.stringify(data));
}

function updateConversionInfoMessage($conversionFeeInfo, totalTransactionAmount) {
    if (parseFloat(totalTransactionAmount) === 0 || typeof totalTransactionAmount === 'undefined') {
        $conversionFeeInfo.fadeOut();
    } else {
        $conversionFeeInfo.find('.totalTransactionAmount').text(totalTransactionAmount);
        $conversionFeeInfo.fadeIn();
    }
}

function toggleCashierModalLoader($modal, state, useStringSelector) {
    var $modalContent = useStringSelector ? $($modal).find('.modal-content') : $modal.find(".modal-content");
    if (!state) {
        $modalContent.removeClass('loader-circle-box-content loader-white loader-center');
    } else {
        $modalContent.addClass('loader-circle-box-content loader-white loader-center');
    }
}

function clearCashierModal($modal) {
    if (Config.CASHIER === 'praxis') {
        $modal.find("#cashierFrame").addClass('d-none').attr({
            height: ''
        });
        $modal.find('#paymentStatusContainer').html('');
    }

    // if(Config.CASHIER === 'default') {
    if ($modal.find('#paymentFormContainer').length) {
        $modal.find('#paymentFormContainer').html('').addClass('d-none');
    }

    renderPaymentStatusResponse($modal, "");
}

function renderPaymentStatusResponse($modal, html) {
    $modal.find('#paymentStatusContainer').html(html);
}

function generateErrorHtml(errorKey, errorMsg) {
    var message = errorMsg ? errorMsg : translation('DEPOSIT_MODAL.' + errorKey);
    var html = '<div class="deposit-summary-content"><div class="alert alert-info text-center" role="alert">' + message + '</div></div>';
    return html;
}

function detectHashChange($modal) {
    $(window).on('hashchange', function () {
        var hash = window.location.hash.substring(1);
        var delimiter = /[&=#]/g;
        var paymentDataArray = hash.split(delimiter);
        var paymentDataObj = {};

        for (var i = 0; i < paymentDataArray.length; i += 2) {
            if (paymentDataArray[i].length != 0) {
                paymentDataObj[paymentDataArray[i]] = paymentDataArray[i + 1];
            }
        }

        sanitizeUrl();
        reactOnPaymentMethodResponse($modal, paymentDataObj);
    });
}

function sanitizeUrl() {
    history.replaceState("", document.title, window.location.pathname);
}

function reactOnPaymentMethodResponse($modal, paymentDataObj, processingApproved) {
    if (Object.keys(paymentDataObj).length == 0) {
        return;
    }

    var lang = Config.LOCALE_SHORT,
        paymentData = {};

    paymentData['internal_payment_number'] = paymentDataObj['internal_payment_number'];
    paymentData['type'] = paymentDataObj['type'];
    paymentData['returned-payment-status'] = paymentDataObj['returned-payment-status'];
    paymentData['modalView'] = 1;

    // show APMReferenceID instead of payment id for interac
    if (paymentDataObj['APMReferenceID'] !== undefined) {
        paymentData['APMReferenceID'] = paymentDataObj['APMReferenceID'];
    }

    var errorHtml = generateErrorHtml('error_payment_response');

    toggleCashierModalLoader($modal, true);

    $.ajax({
        url: "/" + lang + "/my/after-payment",
        data: paymentData,
        dataType: "html",
        method: "GET",
        beforeSend: function () {
            clearCashierModal($modal);
        },
        success: function (data) {
            if (data) {
                renderPaymentStatusResponse($modal, data);
                if ($(data).find('.failed-deposit').length) {
                    zendeskDepositAssistance();
                }
                if (typeof Mediator == 'object') {
                    Mediator.getMediator().trigger('UserBalance_forceUpdate');
                    if (BaseConfig.get('IS_CASINO_MODE') && document.querySelectorAll(".cl-header-user-login")[0]) {
                        document.querySelectorAll(".cl-header-user-login")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
                    }
                }
                if (typeof checkDepositStatusUpdate === 'function') {
                    checkDepositStatusUpdate($modal, paymentData.internal_payment_number, false, processingApproved);
                }
            } else {
                renderPaymentStatusResponse($modal, errorHtml);
            }
        },
        error: function () {
            renderPaymentStatusResponse($modal, errorHtml);
        }
    }).always(function () {
        toggleCashierModalLoader($modal, false);
    });
}


$(function () {

    /* Backbone extend ENTER event
    ******************************/
    $('input').keyup(function (e) {
        if (e.keyCode == 13) {
            $(this).trigger('enter');
        }
    });


    /* Alphabet and numbers only
    ****************************/

    $('.noSpecialCharts').keypress(function (e) {
        var regex = new RegExp("[!#$%&'()*+,./№€§\\\\:;<=>?@^_`{|}~-]");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);

        if (regex.test(str)) {
            return false;
        }

        return true;
    });

    /* NUMBERS ONLY
    ***************/

    $('.onlyNumbersField').keypress(function (e) {
        var regex = new RegExp("^[0-9 ]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }
        e.preventDefault();
        return false;
    });

    /* AMOUNT ONLY
    ***************/

    $('.amountOnlyField').keydown(function (e) {
        var regex = new RegExp("^[0-9, ]+$"),
            code = e.keyCode,
            str = e.key;

        if (code == 8 || code == 46) {
            return true;
        }

        if (regex.test(str)) {
            return true;
        }
        e.preventDefault();
        return false;
    });
    $(document).on('input', '.reg-form-cell-phone', function (e) {
        var $input = $(e.target);
        var value = $input.val().replace(/\D/g, '');
        $input.val(value)
    });

    /* TO UPPERCASE
    ***************/
    $('.toUpperCase').keyup(function () {
        $(this).val($(this).val().replace(/([a-z])/, function (s) {
            return s.toUpperCase()
        }));
    });


});

/* URL DECODE FOR JS USAGE
*******************************/

urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    if (results == null) {
        return null;
    }
    else {
        return results[1] || 0;
    }
}


if (window.location.href.indexOf('search') >= 0) {
    urlParamSearch = urlParam('search');
    $(function () {
        $('.search_container input').val(decodeURI(urlParamSearch));
    })
}

/* Prevent Paste Special Chars
****************************/

$(function () {
    $(".noPasteSpecialCharts").bind('paste', function () {
        setTimeout(function () {
            var data = $('.noPasteSpecialCharts').val();
            var dataFull = data.toString().replace(/[!@#%&-=<>.*+?^${}()|[№€§_\]\\]/g, '');

            $('.noPasteSpecialCharts').val(dataFull);
        });
    });
});

function fixBlurryTooltips() {
    if (Popper) {
        Popper.Defaults.modifiers.computeStyle.gpuAcceleration = !(window.devicePixelRatio < 1.5 && /Win/.test(navigator.platform));
    }
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function manageReadOnlyFields(checkbox) {
    var checked = checkbox.is(":checked");

    $('input.deposit-read-only').each(function () {

        if (checked) {
            $(this).attr('readonly', 'readonly').val($(this).attr('default-value'));
        } else {
            $(this).removeAttr('readonly');
        }
    });

    $('select.deposit-read-only').each(function () {
        if (checked) {
            $(this).attr('disabled', 'disabled').val($(this).attr('default-value'));
        } else {
            $(this).removeAttr('disabled');
        }
    });
}

handleEuroViewUrlValues = function (topic) {
    var wSearchParams = window.location.search.split("&");
    var sportQuery = wSearchParams[0];
    var leaguesQuery = '&league_id=' + localStorage.getObj('selectedLeagues').join();
    var marketsQuery = '&market_type_id=' + localStorage.getObj('selectedMarkets').join();

    history.pushState(history.state, topic, sportQuery + leaguesQuery + marketsQuery);
}

manageStorageVariables = function (objectName, valueToHandle, clear) {
    if (typeof (Storage) == "undefined") {
        alert('Your browser doesnt support the current functionality');

        return true;
    }

    if (clear) {
        localStorage.setObj(objectName, []);
        return;
    }

    var selectedObject = localStorage.getObj(objectName);

    if (selectedObject == null) {
        selectedObject = [];
    }


    var marketIndex = selectedObject.indexOf(valueToHandle);

    if (marketIndex == -1) {
        selectedObject.push(valueToHandle)
    }
    else {
        delete selectedObject[marketIndex];
    }

    selectedObject = selectedObject.filter(function (val) {
        return val !== null;
    });

    localStorage.setObj(objectName, selectedObject);
}

Storage.prototype.setObj = function (key, obj) {
    return this.setItem(key, JSON.stringify(obj))
}
Storage.prototype.getObj = function (key) {
    return JSON.parse(this.getItem(key))
}
function initSoliticsPopupHandlers() {
    $('.solitics-iframe-content').each(function (key, iframe) {
        $(iframe).contents().find('.set-bonus-code').click(function (e) {
            if (Config.QUICK_DEPOSIT === '1') {
                e.preventDefault();
                toggleModal();
                localStorage.setItem("depositBonusCode", $(this).attr("data-code"));
                $("#depositModal").modal("show");
            }
        });
    });
}

function initListenForDepositComplete() {
    window.addEventListener('storage', function () {
        var depositCompleteUrl = window.localStorage.getItem('depositCompleteUrl');
        if (depositCompleteUrl) {
            localStorage.removeItem('depositCompleteUrl');
            // @window-location-ignore
            window.location.href = depositCompleteUrl;
        }
    });
}

function initListenForBlockSport() {
    window.addEventListener('storage', function () {
        var lastCasinoBetTime = window.localStorage.getItem((BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '') + 'lastCasinoBetTime');
        var casinoGameOpened = getCasinoGameOpened();
        var blockWagering = document.getElementById("blockWagering");
        if (blockWagering) {
            var store = blockWagering.__vueParentComponent.appContext.config.globalProperties.$store;
            if (lastCasinoBetTime > Date.now() - 60000) {
                store.commit('bets/SET_LAST_CASINO_BET_TIME', Number(lastCasinoBetTime));
            }
            if (casinoGameOpened === 'true') {
                store.commit('bets/SET_CASINO_GAME_OPENED', true);
            }
            if (casinoGameOpened === null) {
                store.commit('bets/SET_CASINO_GAME_OPENED', false);
            }
        }
    });
}

function initListenForBlockCasino() {
    window.addEventListener('storage', function () {
        var lastSportBetTime = window.localStorage.getItem((BaseConfig.get('MEMBER_ID') ? BaseConfig.get('MEMBER_ID') : '') + 'lastSportBetTime');
        var blockWagering = document.getElementById("blockWagering");
        if (blockWagering && (lastSportBetTime > Date.now() - 60000)) {
            var store = blockWagering.__vueParentComponent.appContext.config.globalProperties.$store;
            store.commit('bets/SET_LAST_SPORT_BET_TIME', Number(lastSportBetTime));
        }
    });
}

function CopyToClipboard($selectedElement) {
    $selectedElement[0].select()
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
}

function NormalizeTimeLocale(time, entity) {
    var entityLocale = dateUtil()._locale.relativeTime[entity];
    if (typeof entityLocale === 'function') {
        return entityLocale(time, true, entity).replace(/[0-9]/g, '');
    }
    return entityLocale.replace('%d', time);
}

function GetHumanReadableTime(milliseconds) {
    var duration = dateUtil(milliseconds);
    var s = Math.floor((duration / 1000) % 60);
    var m = Math.floor((duration / 1000 / 60) % 60);
    var h = Math.floor((duration / (1000 * 60 * 60)) % 24);
    var d = Math.floor(duration / (1000 * 60 * 60 * 24));
    var seconds = NormalizeTimeLocale(s, 'ss');
    var humanReadableTime = seconds;
    if (m) {
        var minutes = NormalizeTimeLocale(m, 'mm');
        humanReadableTime = minutes + ' ' + seconds;
    }
    if (h) {
        var hours = NormalizeTimeLocale(h, 'hh');
        humanReadableTime = hours + ' ' + minutes + ' ' + seconds;
    }
    if (d) {
        var days = NormalizeTimeLocale(d, 'dd');
        humanReadableTime = days + ' ' + hours + ' ' + minutes + ' ' + seconds;
    }
    return humanReadableTime
}

function initMaidenNameCheckbox() {
    var maidenNameField = $('#reg_form_maiden_name');
    $('#maiden_name_same_as_last').change(function () {
        if (this.checked) {
            maidenNameField.attr('readonly', true);
            maidenNameField.val('');
        } else {
            maidenNameField.attr('readonly', false);
        }
    });
}

function logLiveChatOpenEvent() {
    window.UILogger.logEvent(window.UILogger.eventNames.LiveChat.open, {
        isNewRegistration: false,
    });
    window.localStorage.setItem('UiLoggerSent', 'true');
}

(function updateLegacyUsernameFields() {
    var MAX_POLL_ATTEMPTS = 10;
    var POLL_INTERVAL_MS = 1000;
    var MODAL_UPDATE_DELAY_MS = 100;

    var attempts = 0;
    var labelText = translation('REGISTER.username_or_email');
    var placeholderText = translation('REGISTER.username_or_email_please');
    var requiredMessageText = translation('REGISTER.username_or_email_required');

    function updateFieldAndLabel(input, newName, oldIdPart, newIdPart) {
        var oldId = input.id;
        input.name = newName;
        input.id = input.id.replace(oldIdPart, newIdPart);
        input.setAttribute('placeholder', placeholderText);
        input.setAttribute('required-message', requiredMessageText);
        input.setAttribute('data-username-updated', 'true');

        var label = document.querySelector('label[for="' + oldId + '"]');
        if (label) {
            label.setAttribute('for', input.id);
            label.textContent = labelText;
        }

        var invalidFeedback = input.parentElement.querySelector('.invalid-feedback');
        if (invalidFeedback) {
            invalidFeedback.textContent = requiredMessageText;
        }
    }

    function updateUsernameFields() {
        // LOGIN MODAL: Only update placeholder, label, and validation message
        document.querySelectorAll('input[name="login_form[username]"]').forEach(function (input) {
            input.setAttribute('placeholder', placeholderText);
            input.setAttribute('required-message', requiredMessageText);

            var label = document.querySelector('label[for="' + input.id + '"]');
            if (label) label.textContent = labelText;

            var invalidFeedback = input.parentElement.querySelector('.invalid-feedback');
            if (invalidFeedback) invalidFeedback.textContent = requiredMessageText;
        });

        // FORGOT PASSWORD MODAL: Transform username or email field
        var modal = document.querySelector('#forgot-password-modal');
        if (!modal) return;

        var usernameInput = modal.querySelector('input[name="username"]:not([data-username-updated])');
        var emailInput = modal.querySelector('input[name="email"]:not([data-username-updated])');

        if (usernameInput) {
            updateFieldAndLabel(usernameInput, 'username_or_email', 'username', 'username_or_email');
            // Hide email field and remove from form submission
            if (emailInput) {
                emailInput.removeAttribute('name');
                emailInput.disabled = true;
                var emailGroup = emailInput.closest('.form-group');
                if (emailGroup) emailGroup.classList.add('d-none');
            }
        } else if (emailInput) {
            emailInput.type = 'text';
            updateFieldAndLabel(emailInput, 'username_or_email', 'email', 'username_or_email');
        }
    }

    var checkInterval = setInterval(function () {
        try {
            var appComponents = document.getElementById('appComponents');
            if (!appComponents || !appComponents.__vueParentComponent) return;

            var store = appComponents.__vueParentComponent.appContext.config.globalProperties.$store;
            var regConfig = store && store.state && store.state.application && store.state.application.registrationConfig;

            if (regConfig && regConfig.general_settings) {
                var useEmailAsUsername = regConfig.general_settings.use_email_as_username_for_login;

                if (useEmailAsUsername) {
                    updateUsernameFields();
                    $('#forgot-password-modal, #login-guest-modal').on('shown.bs.modal', function () {
                        setTimeout(updateUsernameFields, MODAL_UPDATE_DELAY_MS);
                    });
                }

                clearInterval(checkInterval);
            }
            // If regConfig not loaded yet, keep polling
        } catch (error) {
            // Store not ready
        }

        if (++attempts >= MAX_POLL_ATTEMPTS) {
            clearInterval(checkInterval);
        }
    }, POLL_INTERVAL_MS);
})();
; /** ----------------- **/ 
 $(function () {
    if (!Config.PLUGIN_MODE || BaseConfig.get('IS_NEW_PLUGIN_MESSAGES')){
        return
    }
    var sendMessageToParent = function (event, data) {
        var message = {
            event: event,
            data: data,
        }
        window.parent.postMessage(JSON.stringify(message), '*')
    }

    window.addEventListener('message', function (e) {
        if (e.source !== window) {
            try {
                var message = JSON.parse(e.data)
                if (window.WebPage) {
                    window.WebPage.postMessage(message)
                }
                if (message.event) {
                    // In case someone wants to send us scroll position or something else from the parent of the iframe
                    //Mediator.getMediator().trigger("IFrameParent_" + message.event, message.data);
                }
            } catch (e){

            }
        }
    }, false)

    // For mobile
    $(document).bind('touchmove', _.throttle(function (e) {
        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
        sendMessageToParent('touchmove', {
            screenX: touch.screenX,
            screenY: touch.screenY,
            pageX: touch.pageX,
            pageY: touch.pageY,
        })
    }, 1000, true))

    // For desktop
    $(document).mousemove(_.throttle(function (e) {
        sendMessageToParent('mousemove', {
            offsetX: e.originalEvent.offsetX,
            offsetY: e.originalEvent.offsetY,
            pageX: e.originalEvent.pageX,
            pageY: e.originalEvent.pageY,
        })
    }, 1000, true))

    var header = document.querySelector('#header')
    var leftColumn = document.querySelector('#leftColumn')
    var mainContent = document.querySelector('#mainContent')
    var rightColumn = document.querySelector('#rightColumn')
    var pageContentWrapper = document.querySelector('#pageContentWrapper')
    var bodyHeight = 0
    var elementsHeights = {
        header: 0,
        leftColumn: 0,
        mainContent: 0,
        rightColumn: 0,
        pageContentWrapper: 0,
    }

    if (window.ResizeObserver) {
        var heightObserver = new ResizeObserver(function(entries) {
            for (var i = 0; i < entries.length; i++){
                var entry = entries[i]
                var entryId = entry.target.id
                elementsHeights[entryId] = entry.contentRect.height
            }

            updateBodyHeight()
        })
    } else {
        console.log('Resize observer not supported!')
    }

    var updateBodyHeight = function() {
        var highestColumnHeight = getHighestColumnHeight()
        var currentHeight = elementsHeights['header'] + highestColumnHeight

        if (currentHeight !== bodyHeight && currentHeight > 0) {
            bodyHeight = currentHeight
            sendMessageToParent('update_height', {
                height: bodyHeight,
            })
        }
    }

    var getHighestColumnHeight = function() {
        var maxHeight = 0
        for (var element in elementsHeights) {
            if (element !== 'header' && elementsHeights[element] > maxHeight) {
                maxHeight = elementsHeights[element]
            }
        }
        return maxHeight
    }

    if (typeof heightObserver !== 'undefined') {
        if (header) {
            heightObserver.observe(header)
        }
        if (leftColumn) {
            heightObserver.observe(leftColumn)
        }
        if (mainContent) {
            heightObserver.observe(mainContent)
        }
        if (rightColumn) {
            heightObserver.observe(rightColumn)
        }
        if (pageContentWrapper) {
            heightObserver.observe(pageContentWrapper)
        }
    }
}); /** ----------------- **/ 
 $(function () {

    var $registerModal = $('.register-user-modal-email-registration'),
        $registerModalClose = $('.register-user-modal-email-registration .close'),
        $backButton = $registerModal.find('.modal-nav');


    var urlPath = window.location.pathname;
    if(/index\/register/.test(urlPath) && Config.SEND_EMAIL_REGISTRATION) {
        $registerModal.modal('show');
    }

    $registerModal.on('hide.bs.modal', function () {
        if(Config.USER_IDLE){
            window.getBodyClassList().add('loader-circle-box-content', 'loader-white', 'loader-center', 'blurred-content');
            window.location.reload();
        }
    });

    $registerModalClose.on('click', function () {
        $registerModal.modal('hide');
    });

    var $registerForm = $('#register-user-form'),
        $stepOne = $registerForm.find('.step-section-1'),
        $stepOneButton = $registerModal.find('.registration-step-1'),
        $stepThree = $registerForm.find('.step-section-3');

    $backButton.on('click', function() {
        $registerForm.attr('data-step', 2);
    });

    $stepOneButton.on('click', function() {
        if($stepOneButton.hasClass('filled-in') && $stepThree.hasClass('d-none')){
            $registerForm.attr('data-step', 1);
        }
    });

    Validator.initSelfValidation($registerForm);

    $registerForm.find('#reg_form_country_id').on('change', function () {
        preselectPhonePrefix();
    });

    function goToStepThree() {
        $stepOne.addClass('d-none');
        $stepThree.removeClass('d-none');
        $backButton.addClass('d-none');
        $registerModalClose.addClass('d-none');
        $registerModal.find('.registration-step-2').removeClass('active').addClass('filled-in');
        $registerModal.find('.registration-step-3').addClass('filled-in');
        $registerModal.find('.modal-title-sign').addClass('d-none');
        $registerModal.find('.modal-title-welcome').removeClass('d-none');
    }

    function preselectPhonePrefix() {
        var isoCode = $registerForm.find('#reg_form_country_id :selected').attr('data-iso');
        $registerForm.find('.phone-prefix-select [data-iso=' + isoCode + ']').prop("selected", true).trigger("change");
    }

    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('keypress',function (e) {
        if(['reg_form_fname', 'reg_form_lname'].indexOf($(e.currentTarget).attr('id')) !== -1 && Config.DISABLE_REGISTRATION_SPECIAL_CHARS){
            return;
        }

        var regex = new RegExp("^[a-z A-Z_\u00C0-\u017F\'\.\b-]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str) || Config.ALLOW_CYRILLIC_ON_REGISTER_FORM) {
            return true;
        }

        e.preventDefault();
        return false;
    });
    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('input', function(e){
        var $input = $(e.currentTarget),
            value = $input.val(),
            cyrillicRegex = new RegExp("[а-яА-Я0-9]+$");

        if (!Config.ALLOW_CYRILLIC_ON_REGISTER_FORM && cyrillicRegex.test(value)) {
            $input.val("");
            return false;
        }
        value = value.replace(/\s\s+/g, ' ');
        $input.val(value);
    });

    $registerForm.find('#reg_form_fname, #reg_form_lname, #reg_form_city, #reg_form_first_name, #reg_form_last_name').on('change', function(e){
        var $input = $(e.currentTarget),
            value = $input.val();
        value = value.trim();
        $input.val(value);
    });

    $registerForm.find('#reg_form_address').on('input', function(e){
        var $input = $(e.currentTarget),
            value = $input.val(),
            cyrillicRegex = new RegExp("[а-яА-Я]");

        if (!Config.ALLOW_CYRILLIC_ON_REGISTER_FORM && cyrillicRegex.test(value)) {
            $input.val("");
        }
    });

    $registerForm.find('.reg-form-cell-phone').keypress(function (e) {
        var regex = new RegExp("^[0-9]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }

        e.preventDefault();
        return false;
    });

    function sendTemplateTrackerDataToGoogleAnalytics(templateId, memberId) {

        // Setting the custom Template Tracker dimensions.
        ga('set', 'dimension1', templateId);
        ga('set', 'dimension2', memberId);

        /**
         * Sending an 'Event' hit.
         * The custom dimensions will be sent together with the 'Event' hit to Google Analytics.
         */
        ga('send', 'event', 'HomePageTemplateTracking', 'saveTemplateDataOnMemberRegistration');
    }

    $registerForm.on('submit', function (e) {
        if (!Config.SEND_EMAIL_REGISTRATION){
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        getElement($registerForm).ajaxRequest('sendMailRegistration', {
            request: {
                url: "/" + Config.LOCALE_SHORT + "/index/operation/sendMailRegistration"
            },
            extraData: {
                system_data: {
                    product_type: localStorage.getItem('productType')
                },
            },
            loadAction: $registerForm,
            toastr: false,
            validate: function () {
                return Validator.validateElements($registerForm);
            },
            onError: function (response) {
                console.log('Error!', response)
                if (response.error) {
                    //hide the loading box

                    var errors = response.error;
                    $registerForm.find('.is-invalid').removeClass('is-invalid');
                    for (var error in errors) {
                        $registerForm.find('#reg_form_' + error).addClass('is-invalid').next().text(errors[error]);
                    }
                } else {
                    console.log('Error!')
                }
            },

            onSuccess: function (data) {

                goToStepThree();

                if (data.has_affiliates && data.affiliate_code != null && data.affiliate_code != "") {
                    //Set Affiliates (Income Access) iframe property
                    $('<iframe>', {
                        style: "display:none",
                        src: data.affiliates_traceback_domain + '/Processing/Pixels/Registration.ashx?PlayerID=' + data.white_label_id + data.white_label_id + data.member_id + '&' + data.affiliate_campaign_type
                    }).appendTo('body');
                }

                /**
                 * If there is Home Page Tracker Template ID,
                 * send Template Tracker data to Google Analytics.
                 */
                if (!!BaseConfig.get('GOOGLE_ANALYTICS_TRACKER_1') && typeof data.member_home_page_template_id !== 'undefined' && data.member_home_page_template_id !== null) {
                    sendTemplateTrackerDataToGoogleAnalytics(data.member_home_page_template_id, data.member_id);
                }

                if (data && !data.agentRegistration) {
                    if (!data.referrer) {
                        data.referrer = "/";
                    }
                    $registerForm.find('#register-complete-button').on('click', function(){
                        handleRegisterRedirect(data);
                    });

                }
            }
        });
    });
});
; /** ----------------- **/ 
 $(function () {
    if (window.BaseConfig && window.BaseConfig.get('VUE_LOGIN_ENABLED')) return

    var $verifyEmailModal = $('#verify-email-modal'),
        $verifyEmailForm = $verifyEmailModal.find('#resend-token-form'),
        $errorContainer = $verifyEmailModal.find('.very-email-container .error-container'),
        $successContainer = $verifyEmailModal.find('.success-submit-form'),
        formSubmitted = false

    $verifyEmailModal.modal('show')

    Validator.initSelfValidation($verifyEmailForm)

    $verifyEmailModal.on('shown.bs.modal', function () {
        resetForm()
    })

    $verifyEmailForm.on('submit', function (e) {
        formSubmitted = false
        e.preventDefault()
        e.stopPropagation()
        getElement($verifyEmailForm).ajaxRequest('resendEmailVerificationToken', {
            loadAction: $verifyEmailForm,
            alert: {
                $el: $errorContainer,
                dismissible: false,
                className: 'alert-sm',
            },
            toastr: false,
            validate: function () {
                return Validator.validateElements($verifyEmailForm)
            },
            onSuccess: function (response) {
                $errorContainer.addClass('d-none')
                showSuccess(response.message)
            },
        })
    })

    function showSuccess(message) {
        formSubmitted = true
        $verifyEmailForm.addClass('d-none')
        $verifyEmailModal.find('.verify-email-message').addClass('d-none')
        $verifyEmailModal.find('.success-message').text(message)
        $successContainer.removeClass('d-none')
    }

    function resetForm() {
        if (formSubmitted){
            $verifyEmailForm.removeClass('d-none')
            $successContainer.addClass('d-none')
            $verifyEmailForm.find('input, select').each(function(index, element) {
                $(element).val('')
            })
        }
    }
})
; /** ----------------- **/ 
 window.__casinoLegacyScriptInitialized = false
const __vueMountedPromise = new Promise((resolve) => {
    window.addEventListener('__VUE_APPLICATION_MOUNTED__', () => {
        resolve()
    })
})

const __domLoadedPromise = new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", () => {
        //Add a timeout fallback if for some reason __VUE_APPLICATION_MOUNTED__ is not fired
        setTimeout(() => {
            console.log('Firing __VUE_APPLICATION_MOUNTED__ event manually')
            const event = new CustomEvent('__VUE_APPLICATION_MOUNTED__')
            window.dispatchEvent(event)
        }, 3000)
        resolve()
    })
})

Promise.all([__vueMountedPromise, __domLoadedPromise]).then(() => {
    initializeLegacyCasinoScripts()
});

//TODO sometimes it is not working because Vue application creates listeners and document ready is fired before listeners are not created
function initializeLegacyCasinoScripts() {

    if (Config.PLUGIN_MODE || window.__casinoLegacyScriptInitialized) {
        return
    }
    window.__casinoLegacyScriptInitialized = true

    if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
        if (window.VueEventBus && typeof window.VueEventBus.$emit === 'function') {
            window.VueEventBus.$emit('casino-game-channel-ready')
        }
        window.casinoGameChannel.onmessage = function (message) {
            if (message === 'closing-game' && Config.IS_MOBILE
                && document.getElementById('appComponents')
                && document.getElementById('appComponents').__vueParentComponent
                && document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$route.name === 'GameFrame') {
                setGameOpened();
            }
            if (message === 'closing-game' && !Config.IS_MOBILE && $('#game-frame.visible').length) {
                setGameOpened();
            }
            setGameOpenedStore();
        }
    }

    if (localStorage.getItem("loginReferer") !== null && localStorage.getItem("loginReferer") === "gamePlay") {
        var activeCasinoGame = JSON.parse(localStorage.getItem('activeGameData')) !== null ? JSON.parse(localStorage.getItem('activeGameData')) : false
        var gameName = activeCasinoGame.game_title ? activeCasinoGame.game_title : false
        var gameUrl = activeCasinoGame.gameUrl ? activeCasinoGame.gameUrl : false
        var gameProvider = activeCasinoGame.provider ? activeCasinoGame.provider : false
        var gameMode = "real";
        var gameFrameIsVisible = $('#game-frame.visible').length
        var gameOriginComponent = activeCasinoGame.origin_component || activeCasinoGame.originComponent

        if ((activeCasinoGame.isLiveSpin || gameUrl) && gameMode && gameName) {
            if (Config.IS_MOBILE) {
                if (activeCasinoGame.isLiveSpin) {
                    window.VueEventBus.$emit('play-live-spins', {
                        isScheduled: !gameUrl.length,
                        game_title: gameName,
                        sessionId: gameUrl,
                        originComponent: gameOriginComponent,
                    })
                } else {
                    togglePageLoader('show');
                    window.browserRedirectTo(Config.LOCALE_URL + gameUrl);
                }
            } else {
                if ((Config.WHITE_LABEL_REGULATIONS.pause_casino_reality_check || Config.WHITE_LABEL_REGULATIONS.pause_casino_after_sport) && Config.USER_LOGGED_IN === '1') {
                    var store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
                    if (store.state.bets.blockWageringCasino || store.state.bets.blockWageringRealityCheck) {
                        store.commit('bets/SET_BLOCK_WAGERING_MODAL', true);
                    } else {
                        if (!getCasinoGameOpenedStore() && gameFrameIsVisible) {
                            setGameOpenedStore();
                        }
                        if (getCasinoGameOpened() && !gameFrameIsVisible) {
                            $('#cannotPlayMultipleCasinoGamesModal').modal('show');
                            return;
                        }
                        if (getCasinoGameOpened() && gameFrameIsVisible) {
                            initMultipleCasinoGamesModal();
                        }
                        if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games && gameFrameIsVisible) {
                            setGameOpened();
                        }
                        if (Config.WHITE_LABEL_REGULATIONS.casino_modal_enabled) {
                            var $modal = $('#casinoGameDeclarationModal');
                            $modal.modal('show');
                            $modal.on('hide.bs.modal', function () {
                                togglePageLoader('show')
                                openGameFrame(gameUrl, gameMode, gameName, gameProvider);
                                $modal.off('hide.bs.modal');
                            });
                        }
                    }
                    return;
                }

                if (activeCasinoGame.isLiveSpin) {
                    window.VueEventBus.$emit('play-live-spins', {
                        isScheduled: !gameUrl.length,
                        game_title: gameName,
                        sessionId: gameUrl,
                        originComponent: gameOriginComponent,
                    })
                } else {
                    togglePageLoader('show')
                    openGameFrame(gameUrl, gameMode, gameName, gameProvider);
                }
            }
        }

        localStorage.removeItem("loginReferer");
    } else {
        if (typeof window.VueEventBus === 'object') {
            window.VueEventBus.$off('play-live-spins')
        }
    }

    if (Config.ACTION === 'play') {
        if (Config.INTERNAL_CHAT) {
            if (typeof window.startCasinoGameHeartbeat === 'function') {
                window.startCasinoGameHeartbeat();
            }
        }

        if (BaseConfig.get('LICENSE') && BaseConfig.get('LICENSE').mga && Config.IS_MOBILE !== '1') {
            window.VueEventBus.$emit('game-frame-content-ready')
        }
        if (Config.USER_LOGGED_IN === '1') {
            if (typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN) {
                console.log("_smartico: SUSPEND_POPUPS");
                _smartico.suspendPopups(true);
            }
            if (window.xpjs && window.geoCompliantBetting && window.geoCompliantBetting.isGamblingDenied() && window.geoCompliantBetting.getStatus() !== 'INITIALIZING') {
                window.geoCompliantBetting.startChecking();
                Mediator.getMediator().on('Xpoint_Response', function (target, data) {
                    if (data.status === 'ALLOWED') {
                        validateLaunchGame();
                    } else {
                        stopInternalChatCasinoHeartbeat();
                        window.VueEventBus.$emit('show_modal', 'geoCompliantModal');
                        $('#gameFrame').attr('src', '').remove();
                        $('#gameLobbyUrl').remove();
                    }
                    Mediator.getMediator().off('Xpoint_Response');
                })
                return;
            }
            validateLaunchGame();
        }

        if (Config.CASINO_FAVORITES_ENABLED) {
            var $gameFrameFavIcon = $('#game-frame .game-favorite-icon');
            if (Config.ACTION === 'play') {
                $.ajaxRequest("getFavoriteCasinoGame", {
                    toastr: false,
                    request: {
                        url: "/casino/operation/getMemberFavoritesCasinoGames"
                    },
                    onSuccess: function (response) {
                        if (response.data && Array.isArray(response.data)) {
                            response.data.forEach(function (game) {
                                if (game.casino_game_id === window.casinoGameId) {
                                    $gameFrameFavIcon.addClass('active').text('favorite')
                                }
                            });
                        }
                        $gameFrameFavIcon.removeClass('d-none');
                        if ($gameFrameFavIcon.length) {
                            $gameFrameFavIcon[0].dataset.id = window.casinoGameId;
                            $gameFrameFavIcon[0].dataset.categoryId = false;
                        }
                    },
                    onError: function (data) {
                        console.log(data)
                    }
                });
            } else {
                $gameFrameFavIcon.removeClass('d-none');
            }
        }
    }

    if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
        if (window.isMacOSDevice() || window.isIOSDevice()) {
            window.addEventListener('pagehide', window.handleBrowserTabClose);
        } else {
            window.addEventListener('beforeunload', window.handleBrowserTabClose);
        }
    }

    $(document).on("click", ".open-game-frame", function (e) {
        var clickedGame = e.currentTarget;
        e.preventDefault();
        if (Config.USER_LOGGED_IN && window.xpjs && window.geoCompliantBetting && window.geoCompliantBetting.isGamblingDenied()) {
            window.geoCompliantBetting.startChecking();
            Mediator.getMediator().on('Xpoint_Response', function (target, data) {
                if (data.status === 'ALLOWED') {
                    validateLaunchGameOnClickGameThumb(clickedGame);
                } else {
                    window.VueEventBus.$emit('show_modal', 'geoCompliantModal');
                }
                Mediator.getMediator().off('Xpoint_Response');
            })
            return;
        }
        validateLaunchGameOnClickGameThumb(clickedGame);
    });

    $(document).on("click", "#game-frame-close", function () {
        closeGameFrame();
    });

    $(document).mouseup(function (e) {
        if (typeof $gameCategoryNavAreas != "undefined"
            && !$gameCategoryNavAreas.is(e.target)
            && $gameCategoryNavAreas.has(e.target).length === 0) {
            destroyCategoryCarousel();
            $('#game-frame .category-tabs > li').removeClass('active');
            $('.category-game-tabs .tab-pane').removeClass('active');
            $('#game-embed-frame').removeClass('cat-nav-open');
        }
    });

    $(document).on("click", "#game-frame .category-tabs > li > a", function (e) {
        e.preventDefault();

        var targetEl = e.target,
            activeTab = $(targetEl).attr('href');

        destroyCategoryCarousel();
        $('.category-game-tabs .tab-pane').removeClass('active');

        if ($(targetEl).parent().hasClass('active')) {
            $(targetEl).parent().removeClass('active');
            $('#game-embed-frame').removeClass('cat-nav-open');
        } else {
            $('.category-tabs li').removeClass('active');
            initializeCategoryCarousel(activeTab);
            $(targetEl).parent().addClass('active');
            $('#game-embed-frame').addClass('cat-nav-open');
        }
    });

    $(document).on("click", "#game-frame .game-item > a", function (e) {
        e.preventDefault();

        var gameUrl = $(this).attr("href");
        var gameMode = "";
        var gameName = $(this).attr("data-game-name");
        var isLiveGame = $(this).attr("data-is-live-game") || $(this).attr("data-live");
        var isFreePlayEnabled = $(this).attr("data-is-free-play-enabled");

        if ($(this).attr("data-game-mode") !== undefined) {
            gameMode = $(this).attr("data-game-mode");
        }

        if (Config.USER_LOGGED_IN != 1 && (isFreePlayEnabled == '0' || BaseConfig.get('IS_CASINO_DEMO_GAME_ENABLED') != 1 || isLiveGame == '1') && !window.ReactNativeWebView) {
            openLoginForm(gameUrl, gameName);
        } else {
            if ((Config.WHITE_LABEL_REGULATIONS.pause_casino_after_sport || Config.WHITE_LABEL_REGULATIONS.pause_casino_reality_check) && Config.USER_LOGGED_IN === '1') {
                var store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
                if (store.state.bets.blockWageringCasino || store.state.bets.blockWageringRealityCheck) {
                    store.commit('bets/SET_BLOCK_WAGERING_MODAL', true);
                    return;
                }
                if (Config.WHITE_LABEL_REGULATIONS.casino_modal_enabled) {
                    var $modal = $('#casinoGameDeclarationModal');
                    $modal.modal('show');
                    $modal.on("hide.bs.modal", function () {
                        changeGame(gameUrl, gameMode, gameName);
                        $(this).off("hide.bs.modal");
                    });
                    return;
                }
            } else {
                changeGame(gameUrl, gameMode, gameName);
            }
        }

        if (Config.WHITE_LABEL_REGULATIONS.switch_betting_kind_rg_modal) {
            var gameTypeId = $(this).attr("data-game-type-id");
            if (gameTypeId && localStorage.getItem('last_bet_type') !== gameTypeId) {
                var vueStore = document.getElementById('gamblingLimitsModal').__vueParentComponent.appContext.config.globalProperties.$store;
                vueStore.commit('bets/SET_GAMBLING_LIMITS_MODAL_OPENED', true);
                localStorage.setItem('last_bet_type', gameTypeId);
            }
        }
    });

    $(document).on("click", "#game-frame .game-mode-type-label a, #game-frame .button-switch, #game-frame .btn-switch-game-mode", function (e) {
        e.preventDefault();

        var gameUrl = "";
        var gameMode = "";
        var currentGameMode = $("#game-embed-frame iframe").attr("data-game-mode");
        var gameName = $("#game-embed-frame iframe").attr("data-game-name");

        if ($(this).attr("href") !== undefined) {
            gameUrl = $(this).attr("href");
            gameMode = $(this).attr("data-game-mode");

            if (currentGameMode === gameMode) {
                return;
            }
        } else {
            gameUrl = $(this).attr("data-game-url");

            if (currentGameMode === "real") {
                gameMode = "demo";
            } else {
                gameMode = "real";
            }
        }

        if (BaseConfig.get('IS_CASINO_DEMO_GAME_ENABLED') != 1 && gameMode == "demo") {
            return;
        }

        if (Config.USER_LOGGED_IN != 1) {
            openLoginForm();
        } else {
            $("#game-frame .button-switch").attr("data-active-game-mode", gameMode);
            $("#game-frame .game-mode-type-label a").removeClass("active");
            $("#game-frame .game-mode-type-label a[data-game-mode='" + gameMode + "']").addClass("active");

            changeGame(gameUrl, gameMode, gameName);
        }
    });

    $(document).on("click", "#game-frame .btn-user-login", function () {
        openLoginForm();
    });

    $(document).on("click", ".fullscreen-btn", function () {
        var gameFrame = document.body;

        if (!$(this).hasClass('active')) {
            if (gameFrame.requestFullscreen) {
                gameFrame.requestFullscreen();
            } else if (gameFrame.mozRequestFullScreen) { /* Firefox */
                gameFrame.mozRequestFullScreen();
            } else if (gameFrame.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                gameFrame.webkitRequestFullscreen();
            } else if (gameFrame.msRequestFullscreen) { /* IE/Edge */
                gameFrame.msRequestFullscreen();
            }
        } else {
            document.exitFullscreen();
        }
    });
    $(document).on('fullscreenchange', function () {
        switchFullscreen();
    });

    var isRequestInProgress = false;
    $(document).on("click", "#game-frame .game-favorite-icon", function () {
        if (isRequestInProgress) {
            return;
        }
        isRequestInProgress = true;
        var gameFavIcon = $(this);
        var action = gameFavIcon.hasClass("active") ? 'remove' : 'add';
        var store = {};
        var storeEl = document.getElementById('appComponents') || document.getElementById('casinoLanding') || document.getElementById('miniGamesContainer');

        if (storeEl) {
            store = storeEl.__vueParentComponent.appContext.config.globalProperties.$store;
        }

        var gameId = gameFavIcon[0].dataset.id;
        var categoryId = gameFavIcon[0].dataset.categoryId;
        var jackpotId = gameFavIcon[0].dataset.jackpotId || window.jackpotId;

        // Check if game is from in-house jackpots category
        // For in-house jackpot games, don't send category_id as per backend requirement
        var isInHouseJackpot = !!jackpotId;

        // Build extraData conditionally - exclude category_id for in-house jackpot games
        var extraData = {
            game_id: gameId,
            action: action,
        };

        // Only add category_id if NOT an in-house jackpot game
        if (!isInHouseJackpot && categoryId) {
            extraData.category_id = categoryId;
        }

        $.ajaxRequest("setFavoriteCasinoGame", {
            toastr: false,
            request: {
                url: "/casino/operation/setFavoriteCasinoGame"
            },
            extraData: extraData,
            onSuccess: function (response) {
                if (response.data.action === 'add' && response.data.games && response.data.games[0]) {
                    gameFavIcon.addClass('active').html('favorite');
                    if (Config.ACTION !== 'play') {
                        store.commit('casino/SET_FAVORITE_GAME', response.data.games[0]);
                    }
                } else {
                    gameFavIcon.removeClass('active').html('favorite_outline');
                    if (Config.ACTION !== 'play') {
                        store.commit('casino/UNSET_FAVORITE_GAME', response.data.games.id);
                    }
                }
            },
            onError: function (data) {
                console.log(data)
            },
            onComplete: function () {
                isRequestInProgress = false;
            },
        });
    });

    $(document).on("click", ".getCasinoFavs", function () {

        ajaxRequest("getMemberFavoritesCasinoGames", {
            toastr: false,
            request: {
                url: "/" + Config.LOCALE_SHORT + "/casino/operation/getMemberFavoritesCasinoGames"
            },
            onSuccess: function (response) {
                console.log(response)
            },
            onError: function (data) {
                console.log(data)
            }
        });
    });
    $.fn.overlayMask = function (action) {

        var mask = this.find('#overlay-mask');

        mask.css({
            position: 'absolute',
            width: '100%',
            height: '26px',
            top: '0px',
            right: '0px',
            zIndex: 1,
            border: 0,
            background: '#000000'
        });
        if (!action || action === 'show') {
            mask.show();
        } else if (action === 'hide') {
            mask.hide();

        }
        return this;
    };
    if (window.VueEventBus) {
        window.VueEventBus.$on('resizing-vue-game-frame', function (intent) {
            if (intent === 'start') {
                resizeGameFrame();
                hideChatWidget();
            } else {
                clearGameFrameInterval();
                showChatWidget();
            }
        });
    }
}
function validateLaunchGame() {
    if (Config.IS_MOBILE === '1' && (typeof window.gameUrl == 'undefined' && window.openGameIn === 'tab')) {
        window.browserRedirectTo(Config.LOCALE_URL + '/online-casino');
        return;
    }

    var store = null;
    if (Config.WHITE_LABEL_REGULATIONS.pause_sport_after_casino || Config.WHITE_LABEL_REGULATIONS.pause_casino_reality_check) {
        store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
    }

    if (Config.WHITE_LABEL_REGULATIONS.switch_betting_kind_rg_modal) {
        var gameTypeId = document.getElementById('gameFrame') ? document.getElementById('gameFrame').getAttribute('data-game-type-id') : null;
        if (gameTypeId && localStorage.getItem('last_bet_type') !== gameTypeId) {
            var vueStore = document.getElementById('gamblingLimitsModal').__vueParentComponent.appContext.config.globalProperties.$store;
            vueStore.commit('bets/SET_GAMBLING_LIMITS_MODAL_OPENED', true);
            localStorage.setItem('last_bet_type', gameTypeId);
        }
    }

    if (store && (store.state.bets.blockWageringCasino || store.state.bets.blockWageringRealityCheck)) {
        if (Config.IS_MOBILE !== '1') {
            stopInternalChatCasinoHeartbeat();
            $('#gameFrame').attr('src', '').remove();
            $('#gameLobbyUrl').remove();
        }
        store.commit('bets/SET_BLOCK_WAGERING_MODAL', true);
        return;
    }

    if (getCasinoGameOpened()) {
        initMultipleCasinoGamesModal();
    }

    if (Config.USER_LOGGED_IN && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games && !getCasinoGameOpened()) {
        setGameOpened();
    }
    if (Config.USER_LOGGED_IN && !getCasinoGameOpenedStore()) {
        setGameOpenedStore();
    }

    if (store && !store.state.bets.blockWageringCasino && !store.state.bets.blockWageringRealityCheck && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
        store.commit('bets/SET_CASINO_GAME_OPENED', true);
    }

    if (Config.WHITE_LABEL_REGULATIONS.casino_modal_enabled) {
        displayCasinoGameDeclarationModal();
    } else {
        if (Config.IS_MOBILE === '1' && window.openGameIn === 'tab') {
            window.browserRedirectTo(window.gameUrl);
        }
    }
}
function validateLaunchGameOnClickGameThumb(clickedGame) {
    if ((Config.WHITE_LABEL_REGULATIONS.pause_casino_reality_check || Config.WHITE_LABEL_REGULATIONS.pause_casino_after_sport) && Config.USER_LOGGED_IN === '1') {
        var store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
        if (store.state.bets.blockWageringCasino || store.state.bets.blockWageringRealityCheck) {
            store.commit('bets/SET_BLOCK_WAGERING_MODAL', true);
            return;
        }
    }
    if (Config.WHITE_LABEL_REGULATIONS.block_wagering_no_deposit_limits && (Config.RESPONSIBLE_GAMING && !Config.RESPONSIBLE_GAMING.deposit)) {
        var store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
        store.commit('bets/SET_BLOCK_WAGERING_NO_DEPOSIT_LIMIT', true);
        store.commit('bets/SET_BLOCK_WAGERING_MODAL', true);
        return;
    }
    var gameFrame = {
        id: clickedGame.dataset.id,
        casinoCategoryId: clickedGame.dataset.casinoCategoryId,
        slug: clickedGame.dataset.slug,
        isLiveGame: clickedGame.dataset.isLiveGame,
        live: clickedGame.dataset.live,
        gameName: clickedGame.dataset.gameName,
        gameMode: clickedGame.dataset.gameMode,
        providerName: clickedGame.dataset.providerName,
        isFreePlayEnabled: clickedGame.dataset.isFreePlayEnabled,
        isFavorite: clickedGame.dataset.isFavorite,
        gameUrl: clickedGame.getAttribute('href')
    }

    if (getCasinoGameOpened()) {
        $('#cannotPlayMultipleCasinoGamesModal').modal('show');
        return;
    }

    if (Config.USER_LOGGED_IN === '1' && Config.WHITE_LABEL_REGULATIONS.casino_modal_enabled) {
        var $modal = $('#casinoGameDeclarationModal');
        $modal.modal('show');
        $modal.on("hide.bs.modal", function () {
            if (getCasinoGameOpened()) {
                $('#cannotPlayMultipleCasinoGamesModal').modal('show');
                return;
            }
            launchCasinoGame(gameFrame);
            $(this).off("hide.bs.modal");
        });
        return;
    }
    launchCasinoGame(gameFrame);
}
function setGameOpened() {
    if (!getCasinoGameOpened()) {
        localStorage.setItem('casinoGameOpened', 'true');
        window.VueEventBus.$emit('casino-game-opened')
    }
}

function setGameClosed() {
    localStorage.removeItem('casinoGameOpened');
}

function stopInternalChatCasinoHeartbeat() {
    if (Config.INTERNAL_CHAT && typeof window.stopCasinoGameHeartbeat === 'function') {
        window.stopCasinoGameHeartbeat();
    }
}

function getCasinoGameOpened() {
    return localStorage.getItem('casinoGameOpened');
}

// TODO: methods below are unconditionally operating with gameOpened flag to be always aware if game is opened.
// Perhaps, both sets of methods should be refactored and properly named

function setGameOpenedStore() {
    if (!getCasinoGameOpenedStore() && document.getElementById('appComponents')) {
        document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_CASINO_GAME_OPENED', true);
    }
}

function setGameClosedStore() {
    if (document.getElementById('appComponents') && document.getElementById('appComponents').__vueParentComponent) {
        document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.commit('application/SET_CASINO_GAME_OPENED', false);
    }
}

function getCasinoGameOpenedStore() {
    return document.getElementById('appComponents').__vueParentComponent.appContext.config.globalProperties.$store.state.application.casinoGameOpened
}

function togglePageLoader(state) {
    const bodyClassList = window.getBodyClassList()
    if (!state) {
        bodyClassList.remove('loader-circle-box-content', 'loader-white', 'loader-center');
    } else {
        bodyClassList.add('loader-circle-box-content', 'loader-white', 'loader-center');
    }
}

function checkIfImageExist(backgroundImage) {
    var img = new Image();
    img.onload = function () {
        changeBackgroundImage(backgroundImage, true);
    };
    img.onerror = function () {
        changeBackgroundImage(backgroundImage, false);
    };
    img.src = backgroundImage;
}

function getDefaultBackgroundImageFromCms() {
    var casinoKeys = {
        casino: 'casino',
        casinoLive: 'live-casino',
        tvGames: 'tv-games',
        games: 'games',
    };
    var casinoFolderPath = 'casino_game_frame_bg';
    //Add fallback if there is no match
    var casinoActionKey = casinoKeys[Config.ACTION] ? casinoKeys[Config.ACTION] : 'casino';
    var dynamicCasinoFileName = casinoActionKey + '-bg-image.jpg';

    return Config.WHITE_LABEL_THUMBS_MAIN_URL + Config.WHITE_LABEL_THUMBS_HOME_FOLDER + '/' + casinoFolderPath + '/' + dynamicCasinoFileName;
}

function getGameBackgroundImage(gameElement) {
    var backgroundImage = gameElement.attr('data-background-image') ? gameElement.attr('data-background-image') : false;

    return backgroundImage ? backgroundImage : getDefaultBackgroundImageFromCms();
}

function changeBackgroundImage(backgroundImage, imageIsLoaded) {
    var gameFrame = $("#game-frame");

    if (backgroundImage == null || !imageIsLoaded) {
        var defaultBackground = $('body').css('backgroundImage');

        if (gameFrame.css('backgroundImage') !== defaultBackground) {
            gameFrame.css('backgroundImage', defaultBackground);
        }
    } else {
        if (gameFrame.css('backgroundImage') !== backgroundImage) {
            gameFrame.css('backgroundImage', 'url("' + backgroundImage + '")');
        }
    }
}
function mountDepositButtonOnNewLayoutGameFrame() {
    if (BaseConfig.get('IS_NEW_LAYOUT')) {
        //Server side rendering skips templating the deposit button for the new layout and therefore the vue deposit button component is not mounted for new layout
        //Then the game HTML is served trough XHR and the deposit button component need to be mounted on demand
        window.VueEventBus.$emit('game-frame-deposit-button')
    }
}

function openGameFrame(gameUrl, gameMode, gameName, gameProvider, gameFrame) {
    $.ajax({
        url: gameUrl,
        dataType: "html",
        method: "GET",
        success: function (data) {
            if (data) {
                $("#game-frame #game-frame-container").append(data);
                $("#game-frame .game-frame-header .game-title").text(gameName);
                window.mountVueGameHeader({
                    game_title: gameName,
                    casino_game_id: window.casinoGameId,
                    game_mode: gameMode,
                    jackpot_id: window.jackpotId,
                })
                mountDepositButtonOnNewLayoutGameFrame()
                if (BaseConfig.get('LICENSE') && BaseConfig.get('LICENSE').mga && Config.IS_MOBILE !== '1') {
                    window.VueEventBus.$emit('game-frame-content-ready')
                }
                window.VueEventBus.$emit('init-gamification-button')
                resizeGameFrame();
                $("body").addClass("game-frame-visible");
                $("#game-frame").addClass("visible");

                var iframeElement = $(data).find('iframe:first'),
                    backgroundImage = getGameBackgroundImage(iframeElement);

                checkIfImageExist(backgroundImage);
                hideChatWidget();
                initCasinoMaskBar();
                window.VueEventBus.$emit('casino-game-opened')

                if (BaseConfig.get('IS_CASINO_DEMO_GAME_ENABLED') != 1) {
                    $("#game-frame .game-mode-type-label a[data-game-mode='demo']").addClass("disabled");
                }
                if (Config.USER_LOGGED_IN === '1' && (Config.WHITE_LABEL_REGULATIONS.pause_casino_after_sport || Config.WHITE_LABEL_REGULATIONS.pause_casino_reality_check)) {
                    var store = document.getElementById('blockWagering').__vueParentComponent.appContext.config.globalProperties.$store;
                    if (!store.state.bets.blockWageringCasino && !store.state.bets.blockWageringRealityCheck && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                        document.getElementById("blockWagering").__vueParentComponent.appContext.config.globalProperties.$store.commit('bets/SET_CASINO_GAME_OPENED', true);
                    }
                    setGameOpenedStore();
                    if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                        setGameOpened();
                    }
                }
                if (!Config.IS_MOBILE && Config.USER_LOGGED_IN === '1' && (Config.IS_TELEGRAM_USER || BaseConfig.get('ENABLE_CRYPTO') === '1')) {
                    var appComponentsEl = document.getElementById('appComponents');
                    if (appComponentsEl) {
                        appComponentsEl.__vueParentComponent.appContext.config.globalProperties.$store.commit('casino/SET_SHOW_CONVERSION_MESSAGE_MODAL', true);
                    }
                }

                if (typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN) {
                    console.log("_smartico: SUSPEND_POPUPS");
                    _smartico.suspendPopups(true);
                }
                if (gameFrame) {
                    setInitialDataForFavIcon(gameFrame);
                }
                if (Config.USER_LOGGED_IN === '1' && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                    setGameOpened();
                }
                if (Config.USER_LOGGED_IN === '1') {
                    setGameOpenedStore();
                }
            } else {
                if (Config.USER_LOGGED_IN === '1' && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                    stopInternalChatCasinoHeartbeat();
                    setGameClosed();
                }
                if (Config.USER_LOGGED_IN === '1') {
                    setGameClosedStore();
                }
            }
        },
        error: function () {
            if (Config.USER_LOGGED_IN === '1' && Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                stopInternalChatCasinoHeartbeat();
                setGameClosed();
            }
            if (Config.USER_LOGGED_IN === '1') {
                setGameClosedStore();
            }

        }
    }).always(function () {
        togglePageLoader();
        localStorage.removeItem('activeGameData')
    });

    // NOTE: close game frame on browser back button click
    window.addEventListener("popstate", closeGameFrame);
}


function mountVueGameHeader(casinoGameData) {
    if (Config.IS_MOBILE || !window.VueEventBus) {
        return
    }
    window.VueEventBus.$emit('desktop-casino-game-opened', casinoGameData)
}

function changeGame(gameUrl, gameMode, gameName) {
    var hasQueryParams = false;

    if (gameUrl.indexOf('?') != -1) {
        hasQueryParams = true;
    }
    if (window.g10np && window.g10np.BoosterPanelWidget && BaseConfig.get('IS_NEW_LAYOUT')) {
        console.log('[changeGame] unmounting BoosterPanelWidget')
        window.g10np.BoosterPanelWidget.unmount();
    }

    $.ajax({
        url: gameUrl + (hasQueryParams ? "&" : "?") + "gameMode=" + gameMode,
        dataType: "html",
        method: "GET",
        success: function (data) {
            $("#game-frame #game-frame-container").empty().append(data);
            $("#game-frame .game-frame-header .game-title").text(gameName);

            window.mountVueGameHeader({
                game_title: gameName,
                casino_game_id: window.casinoGameId,
                game_mode: gameMode,
                jackpot_id: window.jackpotId,
            })
            mountDepositButtonOnNewLayoutGameFrame()
            console.log('[changeGame] emitting init-gamification-button')
            window.VueEventBus.$emit('init-gamification-button')
            var iframeElement = $(data).find('iframe:first'),
                backgroundImage = getGameBackgroundImage(iframeElement);

            checkIfImageExist(backgroundImage);

            if (BaseConfig.get('IS_CASINO_DEMO_GAME_ENABLED') != 1) {
                $("#game-frame .game-mode-type-label a[data-game-mode='demo']").addClass("disabled");
            }

            var baseGameDataSet = window.gameDataSet;
            var extraGameDataSet = (window.casinoGameId && window.casinoCategoryId && window.isFavorite) ? {
                id: window.casinoGameId,
                casinoCategoryId: window.casinoCategoryId,
                isFavorite: window.isFavorite
            } : {};

            setInitialDataForFavIcon(Object.assign({}, baseGameDataSet, extraGameDataSet));

            switchFullscreen()
            localStorage.removeItem('activeGameData')
        }
    });
}

function initializeCategoryCarousel(activeTab) {
    gameCategoryListCarousel = $(activeTab + ' .owl-carousel'),
        $gameCategoryNavAreas = $('#game-frame-container .category-game-tabs, #game-frame-container .category-tabs > li > a');

    var rtlStatus = false;

    if (Config.LOCALE_DIRECTION == 'rtl') {
        rtlStatus = true;
    }

    gameCategoryListCarousel.on('initialized.owl.carousel', function (e) {
        $(activeTab).addClass("active");
    });

    gameCategoryListCarousel.owlCarousel({
        stagePadding: 50,
        dots: false,
        loop: true,
        rtl: rtlStatus,
        items: Boolean(BaseConfig.get('IS_NEW_LAYOUT')) ? 12 : 9
    });
}

function destroyCategoryCarousel() {
    if (typeof gameCategoryListCarousel !== 'undefined') {
        gameCategoryListCarousel.trigger('destroy.owl.carousel');
    }
}

function setLoginFormAttributes(gameUrl, gameName, reset, gameType) {
    var gameUrlToOpen = gameUrl ? gameUrl : $("#game-embed-frame iframe").attr("data-game-url");
    var gameNameToOpen = gameName ? gameName : $("#game-embed-frame iframe").attr("data-game-name");
    var isLiveSpin = gameType === 'liveSpin';
    var appElement = document.getElementById('appComponents');
    var appInstance = appElement.__vueParentComponent;
    var formAttributes = {
        "data-login-referer": reset ? "" : "gamePlay",
        "data-game-name": reset ? "" : gameNameToOpen,
        "data-game-url": reset ? "" : gameUrlToOpen,
        "data-is-livespin": reset ? "" : String(isLiveSpin)
    }

    $("#login-modal-form").attr(formAttributes);

    if (appInstance) {
        appInstance.appContext.config.globalProperties.$store.commit('application/SET_POST_LOGIN_ACTION', reset ? null : formAttributes);
    }
}

function openLoginForm(gameUrl, gameName, isLiveSpin) {
    if (isLiveSpin) {
        setLoginFormAttributes(gameUrl, gameName, false, 'liveSpin');
    } else {
        setLoginFormAttributes(gameUrl, gameName);
    }

    window.openModalScreen('Login');
}


function clearGameFrameInterval() {
    if (typeof window.gameFrameResize !== 'undefined') {
        clearInterval(window.gameFrameResize);
    }
}
function resizeGameFrame() {
    clearGameFrameInterval();
    window.gameFrameResize = setInterval(gameFrameResizer, 300);
}

function gameFrameResizer() {
    var $gameFrameVisible = $(".game-frame-inner").closest(".visible")
    if (!$gameFrameVisible.length) {
        return
    }
    var $gameFrameContainer = Boolean(BaseConfig.get('IS_NEW_LAYOUT')) ? $gameFrameVisible.find("#game-frame-container-inner") : $gameFrameVisible.find("#game-frame-container");

    var gameFrameRatio = $gameFrameContainer.find("iframe").attr("data-game-ratio") !== undefined ? $gameFrameContainer.find("iframe").attr("data-game-ratio") : 1.778;

    var gameFrameHeaderHeight = Boolean(BaseConfig.get('IS_NEW_LAYOUT'))
        ? $(".vue-game-frame-header-new-layout .game-navigation").outerHeight() || 0
        : $(".game-frame-inner .game-frame-header").outerHeight();

    var gameFrameContentWidthOffset = $gameFrameContainer.outerWidth() - $gameFrameContainer.width();
    var gameFrameContentHeightOffset = $gameFrameContainer.outerHeight() - $gameFrameContainer.height();
    var gameFrameCatNavHeight = $gameFrameContainer.find(".game-navigation-wrapper").length ? $gameFrameContainer.find(".game-navigation-wrapper").height() : 0;
    if (Boolean(BaseConfig.get('IS_NEW_LAYOUT'))) {
        gameFrameCatNavHeight = $gameFrameContainer.find(".game-navigation-wrapper").length ? $gameFrameContainer.find(".game-navigation-wrapper").height() : 0;
    }
    var gameFrameModeSwitcherHeight = $("#casinoGameModeBar").length !== 0 ? $("#casinoGameModeBar").outerHeight() : 0;
    var gameFrameBottomBarHeight = $("#casinoGameFrameBottomBar").length !== 0 ? $("#casinoGameFrameBottomBar").outerHeight() : 0;
    var maxGameFrameHeight = gameFrameRatio == 1.0000 ? $(window).height() - gameFrameHeaderHeight - gameFrameBottomBarHeight : $(window).height() - gameFrameHeaderHeight - gameFrameContentHeightOffset - gameFrameCatNavHeight - gameFrameModeSwitcherHeight - gameFrameBottomBarHeight;
    var menuWidth = Boolean(BaseConfig.get('IS_NEW_LAYOUT')) && !document.fullscreenElement && $('.casino-categories-navigation-menu').length ? $('.casino-categories-navigation-menu').outerWidth() : 0
    var maxGameFrameWidth = gameFrameRatio == 1.0000 ? $(window).width() : $(window).width() - gameFrameContentWidthOffset - menuWidth;
    var minGameFrameWidth = 952;
    var gameFrameHeight = "";
    var gameFrameWidth = "";
    var removeGameContainerPadding = false;

    if (gameFrameRatio == 1.0000) {
        gameFrameWidth = maxGameFrameWidth;
        var offsetGameNavigation = 0;
        if (Boolean(BaseConfig.get('IS_NEW_LAYOUT')) && $gameFrameContainer.find(".game-navigation-wrapper").length) {
            offsetGameNavigation = $gameFrameContainer.find(".game-navigation-wrapper").height();
        }
        gameFrameHeight = maxGameFrameHeight - offsetGameNavigation;
        removeGameContainerPadding = true;

        if (gameFrameWidth < minGameFrameWidth) {
            gameFrameWidth = minGameFrameWidth;
        }
    } else {
        if (maxGameFrameHeight * gameFrameRatio <= maxGameFrameWidth) {
            gameFrameHeight = maxGameFrameHeight;
            gameFrameWidth = Math.round(maxGameFrameHeight * gameFrameRatio);
        } else {
            gameFrameHeight = Math.round(maxGameFrameWidth / gameFrameRatio);
            gameFrameWidth = maxGameFrameWidth;
        }

        if (gameFrameWidth < minGameFrameWidth) {
            gameFrameWidth = minGameFrameWidth;
            gameFrameHeight = Math.round(minGameFrameWidth / gameFrameRatio)
        }
    }

    $gameFrameContainer.find("#game-embed-frame").css({
        'width': gameFrameWidth,
        'height': gameFrameHeight
    });

    if (removeGameContainerPadding) {
        $gameFrameContainer.addClass("p-0");
        if (Boolean(BaseConfig.get('IS_NEW_LAYOUT'))) {
            $gameFrameContainer.find(".game-navigation-wrapper").find('.game-navigation').addClass('px-2');
        }
    }

}

function switchFullscreen() {
    var element = document.fullscreenElement;

    if (element) {
        $(".fullscreen-btn").html('fullscreen_exit').addClass('active');
        if (Boolean(BaseConfig.get('IS_NEW_LAYOUT'))) {
            $('.casino-categories-navigation-menu').addClass('d-none');
        }

    } else {
        $(".fullscreen-btn").html('fullscreen').removeClass('active');
        if (Boolean(BaseConfig.get('IS_NEW_LAYOUT'))) {
            $('.casino-categories-navigation-menu').removeClass('d-none');
        }
    }
}

function hideChatWidget() {
    try {
        if (typeof zE === 'function') {
            window.__UPDATE_ZENDESK_WIDGET__('hide');
        }
        if (typeof $zoho === 'object') {
            $zoho.salesiq.floatbutton.visible("hide");
        }
        if (typeof $_Tawk === 'object') {
            $_Tawk.hideWidget();
        }
        if (typeof Comm100API !== 'undefined') {
            Comm100API.set('livechat.button.isVisible', false);
        }
        if (typeof window.fcWidget === 'object') {
            window.fcWidget.hide();
        }
        if (typeof window.LiveChatWidget !== 'undefined') {
            window.LiveChatWidget.call("hide");
        }
    } catch (e) {
        console.log('hideChatWidget error', e)
    }

}

function showChatWidget(options) {
    try {
        var skipZendeskShow = options && options.skipZendeskShow;

        if (BaseConfig.get('ZENDESK_API_KEY') && !skipZendeskShow) {
            window.__INITIALIZE_ZENDESK__(function () {
                window.__UPDATE_ZENDESK_WIDGET__('show')
            })
        }
        if (typeof $zoho === 'object') {
            $zoho.salesiq.floatbutton.visible("show");
        }
        if (typeof $_Tawk === 'object') {
            $_Tawk.showWidget();
        }
        if (typeof Comm100API !== 'undefined') {
            Comm100API.set('livechat.button.isVisible', true);
        }
        if (typeof window.fcWidget === 'object') {
            window.fcWidget.show();
        }
        if (typeof window.LiveChatWidget !== 'undefined') {
            window.LiveChatWidget.call("minimize");
        }
    } catch (e) {
        console.log('showChatWidget error', e)
    }
}

function resetGameFrame() {
    $("#game-frame").removeClass("visible");
    $("body").removeClass("game-frame-visible");
    $("#game-frame #game-frame-container").empty().removeClass("p-0");
    clearGameFrameInterval();
    if (document.fullscreenElement) {
        document.exitFullscreen();
    }
    if (Config.USER_LOGGED_IN === '1' && document.getElementById("blockWagering")) {
        if (Config.WHITE_LABEL_REGULATIONS.pause_sport_after_casino) {
            document.getElementById("blockWagering").__vueParentComponent.appContext.config.globalProperties.$store.commit('bets/SET_LAST_CASINO_BET_TIME', Date.now());
        }
        if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
            if (document.getElementById("blockWagering")) {
                document.getElementById("blockWagering").__vueParentComponent.appContext.config.globalProperties.$store.commit('bets/SET_CASINO_GAME_OPENED', false);
            }
        }
    }
    showChatWidget();
    stopInternalChatCasinoHeartbeat();
    if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
        setGameClosed();
        window.casinoGameChannel.postMessage('closing-game');
    }
    setGameClosedStore();
}

function closeGameFrame() {
    stopInternalChatCasinoHeartbeat();

    window.VueEventBus.$emit('game-frame-closed');

    var appElement = document.getElementById('appComponents');
    var appInstance = appElement.__vueParentComponent;

    if (appInstance) {
        var router = appInstance.appContext.config.globalProperties.$router;

        if (router.currentRoute.value.name === "Campaigns") {
            appInstance.appContext.config.globalProperties.$store.dispatch('user/GET_BONUSES');
        }
    }
    if (BaseConfig.get('IS_NEW_LAYOUT')) {
        // clear store data about active game for new layout
        appInstance.appContext.config.globalProperties.$store.commit('casino/SET_ACTIVE_CASINO_GAME_DATA', null);

        //To prevent multiple deposit button instances we destroy any previous instances on closing a game
        var $depositButton = document.querySelectorAll("#deposit-button.btn-game-frame-action")
        if ($depositButton && $depositButton[0] &&
            $depositButton[0].__vueParentComponent &&
            $depositButton[0].__vueParentComponent.appContext.config.globalProperties._
        ) {
            $depositButton[0].__vueParentComponent.appContext.config.globalProperties._.appContext.app.unmount()
        }
    }

    setLoginFormAttributes("", "", true);
    resetGameFrame();
    Mediator.getMediator().trigger("UserBalance_forceUpdate");
    if ($(".cl-header").length > 0) {
        document.querySelectorAll(".cl-header-user-login")[0].__vueParentComponent.appContext.config.globalProperties.$store.dispatch("user/GET_MEMBER_BALANCE");
    }
    game = undefined;
    if (typeof _smartico !== 'undefined' && Config.USER_LOGGED_IN) {
        console.log("_smartico: release_POPUPS");
        _smartico.suspendPopups(false);
    }

    var forceGameLobbyUrl = localStorage.getItem("forceGameLobbyUrl");
    if (forceGameLobbyUrl && window.location.pathname !== forceGameLobbyUrl) {
        localStorage.removeItem("forceGameLobbyUrl")
        window.browserRedirectTo(forceGameLobbyUrl);
    }

    // NOTE: remove back button click listener after game frame closed
    window.removeEventListener("popstate", closeGameFrame);

    if (window.g10np && window.g10np.BoosterPanelWidget && BaseConfig.get('IS_NEW_LAYOUT')) {
        window.g10np.BoosterPanelWidget.unmount();
    }
}

function launchCasinoGame(gameFrame) {
    var gameUrl = gameFrame.gameUrl
    var gameMode = "";
    var gameName = gameFrame.gameName;
    var isLiveGame = gameFrame.isLiveGame || gameFrame.live;
    var isFreePlayEnabled = gameFrame.isFreePlayEnabled;
    var gameProvider = gameFrame.providerName;

    if ((((!parseInt(BaseConfig.get('IS_CASINO_DEMO_GAME_ENABLED')) || !Config.CASINO_DEMO_MODE) && !Config.USER_LOGGED_IN) ||
        (!Config.USER_LOGGED_IN && typeof isLiveGame !== 'undefined' && isLiveGame === '1') ||
        (!Config.USER_LOGGED_IN && typeof isFreePlayEnabled !== 'undefined' && isFreePlayEnabled != '1')) &&
        !window.ReactNativeWebView) {
        openLoginForm(gameUrl, gameName);
        return;
    }

    if (gameFrame.gameMode !== undefined) {
        gameMode = gameFrame.gameMode;
    }
    setLoginFormAttributes(gameUrl, gameName);
    togglePageLoader('show');
    openGameFrame(gameUrl, gameMode, gameName, gameProvider, gameFrame);
}

function initMultipleCasinoGamesModal() {
    var $multipleCasinoGamesModal = $('#cannotPlayMultipleCasinoGamesModal');
    $multipleCasinoGamesModal.modal('show');
    $multipleCasinoGamesModal.on('hide.bs.modal', function () {
        if (Config.LAST_VIEW === 'asian') {
            return window.browserRedirectTo(Config.ASIAN_URL);
        } else {
            return window.browserRedirectTo(Config.EURO_URL);
        }
    });
}

function displayCasinoGameDeclarationModal() {
    var $modal = $('#casinoGameDeclarationModal');
    $modal.modal('show');
    $modal.on('hide.bs.modal', function () {
        if (Config.IS_MOBILE === '1') {
            window.browserRedirectTo(window.gameUrl);
        } else {
            if (getCasinoGameOpened()) {
                initMultipleCasinoGamesModal();
            }
            setGameOpenedStore();
            if (Config.WHITE_LABEL_REGULATIONS.stop_multiple_casino_games) {
                setGameOpened();
            }
        }
    });
}

function initCasinoMaskBar() {
    var gamesToMaskTopBar = [
        'real-baccarat-with-sarati',
        'real-baccarat-with-cortney',
        'real-baccarat-with-holly-microgmng',
        'real-roulette-with-matthew',
        'fortune-finder-with-holly',
        'real-roulette-with-dave-microgaming',
        'real-roulette-with-george-microgaming',
        'real-roulette-with-bailey',
        'real-roulette-with-holly',
        'real-roulette-with-caroline',
        'multifire-auto-roulette-microgaming',
        'real-auto-roulette',
        'real-roulette-with-sarati',
        'fortune-finder-with-holly',
        'real-roulette-with-dave-microgaming',
        'fortune-finder-with-sarati'
    ];

    if (typeof game !== 'undefined') {
        if (game.provider === 'microgaming' && Config.IS_MOBILE !== '1') {
            if ($.inArray(game.slug, gamesToMaskTopBar) !== -1) {
                $('#game-embed-frame').overlayMask('show');
            } else {
                $('#game-embed-frame').overlayMask('hide');
            }
        }

    }
}


function setInitialDataForFavIcon(dataset) {
    if (Config.CASINO_FAVORITES_ENABLED) {
        var $gameFrameFavIcon = $('#game-frame .game-favorite-icon');

        window.gameDataSet = dataset;
        if (typeof window.isFavorite !== 'undefined') {
            window.gameDataSet.isFavorite = window.isFavorite;
        }

        if ($gameFrameFavIcon && $gameFrameFavIcon[0]) {
            $gameFrameFavIcon[0].dataset.id = window.gameDataSet.id;
            $gameFrameFavIcon[0].dataset.categoryId = window.gameDataSet.casinoCategoryId;
        }
        $gameFrameFavIcon.removeClass('d-none')
        if (window.gameDataSet.isFavorite === 'true') {
            $gameFrameFavIcon.addClass('active').text('favorite');
        } else {
            $gameFrameFavIcon.removeClass('active').text('favorite_outline');
        }
    }
}

function handleBrowserTabClose() {
    var hasOpenedGame = localStorage.getItem('casinoGameOpened')
    stopInternalChatCasinoHeartbeat();
    setGameClosed();
    setGameClosedStore();
    if (hasOpenedGame) {
        //TODO after adding appropriate conditions for checking if the game is opened, add this as well
        window.casinoGameChannel.postMessage('closing-game');
    }

    if (Config.ACTION === 'play' && Config.USER_LOGGED_IN === '1') {
        if (Config.IS_MOBILE !== '1' && Config.WHITE_LABEL_REGULATIONS.pause_sport_after_casino) {
            if (!store.state.bets.blockWageringCasino && !store.state.bets.blockWageringRealityCheck) {
                document.getElementById("blockWagering").__vueParentComponent.appContext.config.globalProperties.$store.commit('bets/SET_LAST_CASINO_BET_TIME', Date.now());
            }
        }
    }

    if (!getCasinoGameOpened()) {
        window.casinoGameChannel.close();
    }
}

function isIOSDevice() {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
}

function isMacOSDevice() {
    return window.navigator.userAgent.includes('Macintosh');
}
; /** ----------------- **/ 
 var GameCommunicator = {
    source: undefined,
    origin: undefined,
    initialized: false,
    /**
     * Initiates the communication with the Iframe
     * @@param {iframe} element
     */
    init: function (element) {
        if (!this.initialized) {
            window.addEventListener("message", this.processGameMessage.bind(this));
        }
        this.initialized = true;
        this.source = element.contentWindow;
        var dummyAnchor = document.createElement('a');
        dummyAnchor.href = element.src;
        var origin = dummyAnchor.protocol + '//' + dummyAnchor.host
        this.origin = origin;
    },
    /**
     * Sends the message to the Iframe
     * @@param {object} data
     * Example of adding an Engage event listener: GameCommunicator.postMessage({ messageType: "addEventListener", eventType: "roundStarted" })
     * Example of calling Engage function: GameCommunicator.postMessage({ messageType: "request", eventType: "spin" })
     */
    postMessage: function (data) {
        console.log("GameCommunicator sent the following message:", data);
        try {
            this.source.postMessage(data, this.origin);
        } catch (e) {
            console.log(e)
        }
    },
    /**
     * Receives the messages the PNG game dispatches
     * @@param {object} e
     */
    processGameMessage: function (e) {
        console.log("GameCommunicator reveiced: ", e.data);
        switch (e.data.type) {
            case "reloadGame":
                console.log("reload code");
                // window.location.reload(); // stub implementation
                document.getElementById("gameFrame").src = document.getElementById('gameFrame').src
                break;
            case "backToLobby":
                if (Config.IS_MOBILE) {
                    var gameFrame = document.getElementById("gameFrame");
                    var exitUrl = null;
                    
                    try {
                        exitUrl = (gameFrame && gameFrame.src)
                            ? new URL(gameFrame.src).searchParams.get('rcexiturl')
                            : null;
                    } catch (err) {
                        console.log('GameCommunicator[backToLobby]: could not parse game frame src: ', err);
                    }

                    if (exitUrl) {
                        window.location.href = exitUrl;
                        return;
                    }

                    var $appComponents = $('#appComponents')[0];
                    $appComponents.__vueParentComponent.appContext.config.globalProperties.$router.push({name: 'Casino'});
                    return;
                }
                if (Config.ACTION === 'play') {
                    window.location.href = window.location.origin + Config.LOCALE_URL + '/online-casino';
                } else {
                    $("#game-frame-close").trigger('click');
                }
                break;
            case "playForReal":
                $('#login-guest-modal').modal('show');
                break;
            default:
                break;
        }
    },
    initGameCommunicatorListeners: function () {
        GameCommunicator.init(document.getElementById("gameFrame"));
        GameCommunicator.postMessage({ messageType: "addEventListener", eventType: "reloadGame" });
        GameCommunicator.postMessage({ messageType: "addEventListener", eventType: "backToLobby"});
        GameCommunicator.postMessage({ messageType: "addEventListener", eventType: "playForReal"});
    }
}
; /** ----------------- **/ 
 var PragmaticDGASocket = {
    websocket : null,
    wsUri : null,
    tableId : null,
    casinoId : null,
    tryToConnect : true,
    tableIds: [],
    onMessageCallback: null,
    // public
    connect : function(wsUri, casinoId, tableId, onMessageCallback) {
        var self = this;
        self.tryToConnect = true;
        self.wsUri = wsUri;
        console.log('connecting to ' + 'wss://' + wsUri + '/ws');
        if(self.websocket !== null && self.websocket.readyState !== 3){
            self.websocket.close();
            console.log('Socket open closing it');
        }
        self.websocket = new WebSocket('wss://' + wsUri + '/ws');
        self.websocket.onopen = function(evt) {
            self.onWsOpen(evt, casinoId, tableId)
        };
        self.websocket.onclose = function(evt) {
            self.onWsClose(evt)
        };
        self.websocket.onmessage = function(evt) {
            self.onWsMessage(evt)
        };
        self.websocket.onerror = function(evt) {
            self.onWsError(evt)
        };
        if (tableId) {
            self.tableId = tableId;
        }
        self.casinoId = casinoId;
        self.onMessageCallback = onMessageCallback
    },
    // public
    onMessage : function(data) {
        // to fill
        var self = this;
        if(data.tableKey) {
            // Subscribe for all available tables
            data.tableKey.forEach(function(tableId) {
                if(self.tableIds.indexOf(tableId) === -1) {
                    self.subscribe(self.casinoId, tableId)
                    self.tableIds.push(tableId);
                }
            })
        }else {
            if(self.onMessageCallback) {
                self.onMessageCallback(data)
            }
        }
    },
    // public
    onConnect : function() {
        var self = this;
        self.available(self.casinoId);
    },
    // public
    disconnect : function() {
        var self = this;
        self.tryToConnect = false;
        self.websocket.close();
        console.log('Disconnected');
    },
    // public
    subscribe : function(casinoId, tableId, currency) {
        var subscribeMessage = {
            type : 'subscribe',
            key : tableId,
            casinoId : casinoId,
            currency : currency
        }
        // console.log('subscribing' + tableId);

        var self = this;
        // console.log('Subscribing ' + tableId);
        var jsonSub = JSON.stringify(subscribeMessage);
        self.doWsSend(jsonSub);
    },

    // public
    available : function(casinoId) {
        var availableMessage = {
            type : 'available',
            casinoId : casinoId
        }
        console.log('checking availability');

        var self = this;
        // console.log('Subscribing ' + tableId);
        var jsonSub = JSON.stringify(availableMessage);
        self.doWsSend(jsonSub);
    },

    onWsOpen : function(evt) {
        var self = this;

        // console.log(evt.data);
        if (self.onConnect != null) {
            self.onConnect();
        }

        console.log('Connected to wss server');
        if (self.tableId) {
            self.subscribe(self.casinoId, self.tableId, Config.CURRENCY_CODE)
        }
    },

    onWsClose : function(evt) {
        console.log("DISCONNECTED");
        var self = this;
        if (self.tryToConnect === true) {
            console.log("RECONNECTING");
            self.connect(self.wsUri, self.casinoId, self.tableId);
        }
    },

    onWsMessage : function(evt) {
        var self = this;
        var data = JSON.parse(evt.data);
        // console.log(evt.data);
        if (self.onMessage != null) {
            self.onMessage(data);
        }
    },

    onWsError : function(evt) {
        console.log('ERROR: ' + evt.data);
    },

    doWsSend : function(message) {
        var self = this;
        // console.log("SENT: " + message);
        self.websocket.send(message);
    }
};
; /** ----------------- **/ 
 var balanceCounter;
var END2END_KEY = 'end2end';

var END2END_EVENTS = {
    'loadingFinished': 1, // Game has finished loading
    'connectionLost': 2, // Game has lost connection to the server
    'gameClosed': 3, // The user is inside the lobby and has closed the game
    'cashierOpened': 4, // User has opened the cashier or the deposit
    'invalidToken': 5, // Invalid Token.
    'logoClicked': 6, // User is in the lobby and has clicked in the logo to go the home page
    'windowClosed': 7, // User has closed the window, used in case of popup
    'balanceUpdated': 8, // User balance has been updated
};

var EndToEndGameCommunicator = {
    source: undefined,
    origin: undefined,
    initialized: false,
    /**
     * Initiates the communication with the Iframe
     * @@param {iframe} element
     */
    init: function (element) {
        if (!this.initialized)
        {
            window.addEventListener("message", this.processGameMessage.bind(this));
        }

        this.initialized = true;
        this.source = element.contentWindow;
        var dummyAnchor = document.createElement('a');
        dummyAnchor.href = element.src;
        var origin = dummyAnchor.protocol + '//' + dummyAnchor.host
        this.origin = origin;
    },
    /**
     * Sends the message to the Iframe
     * @@param {object} data
     * Example of adding an Engage event listener: GameCommunicator.postMessage({ messageType: "addEventListener", eventType: "roundStarted" })
     * Example of calling Engage function: GameCommunicator.postMessage({ messageType: "request", eventType: "spin" })
     */
    postMessage: function (data) {
        console.log("End2EndGameCommunicator sent the following message:", data);

        try {
            this.source.postMessage(data, this.origin);
        } catch (e) {
            console.log(e)
        }
    },
    /**
     * Receives the messages the PNG game dispatches
     * @@param {object*/
    processGameMessage: function (e) {
        console.log("End2EndGameCommunicator received: ", e);

        // if event is not from end2end
        if(!e.origin.includes(END2END_KEY)) {
            console.log("Event origin is not End2End!");
            return;
        }

        handleEnd2EndEvent(e.data.event);
    },
    /**
     * Init Game Communicator
     */
    initGameCommunicatorListeners: function () {
        EndToEndGameCommunicator.init(document.getElementById("gameFrame"));
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.loadingFinished});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.connectionLost});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.gameClosed});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.cashierOpened});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.invalidToken});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.logoClicked});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.windowClosed});
        EndToEndGameCommunicator.postMessage({ message: "addEventListener", event: END2END_EVENTS.balanceUpdated});
    }
}

function handleEnd2EndEvent(event) {
    switch (event) {
        case END2END_EVENTS.loadingFinished:
            console.log("Game has finished loading!");
            break;
        case END2END_EVENTS.connectionLost:
            console.log("Game has lost connection to the server!");
            break;
        case END2END_EVENTS.gameClosed:
            console.log("The user is inside the lobby and has closed the game!");
            closeEnd2EndGame();
            break;
        case END2END_EVENTS.cashierOpened:
            console.log("User has opened the cashier or the deposit!");
            end2EndOpenCashier();
            break;
        case END2END_EVENTS.invalidToken:
            console.log("Invalid Token!");
            launchEnd2EndGame();
            break;
        case END2END_EVENTS.logoClicked:
            console.log("User is in the lobby and has clicked in the logo to go the home page!");
            closeEnd2EndGame();
            break;
        case END2END_EVENTS.windowClosed:
            console.log("User has closed the window, used in case of popup!");
            closeEnd2EndGame();
            break;
        case END2END_EVENTS.balanceUpdated:
            console.log("User balance has been updated!");
            break;
        default:
            console.log("Unhandled event occurred: ", event);
            break;
    }
}

function closeEnd2EndGame() {
    if (Config.IS_MOBILE) {
        var $appComponents = $('#appComponents')[0];
        $appComponents.__vueParentComponent.appContext.config.globalProperties.$router.push({name: 'Casino'});
        return;
    }

    if (Config.ACTION === 'play') {
        window.location.href = window.location.origin + Config.LOCALE_URL + '/online-casino';
    } else {
        $("#game-frame-close").trigger('click');
    }
}

function end2EndOpenCashier() {
    let end2endModal;

    if(Config.CASHIER === 'default') {
        end2endModal = $('#depositModal');
    } else {
        end2endModal = $('#cashierModal');
    }

    end2endModal.addClass('end2endDeposit');
    end2endModal.modal('show');
}

function launchEnd2EndGame() {
    $.ajaxRequest("launchEnd2EndGame", {
        toastr: false,
        request: {
            url: "/casino/operation/launchEnd2EndGame"
        },
        extraData: {
            gameData: game,
        },
        onSuccess: function (response) {
            document.getElementById("gameFrame").src = response.data.link;
        },
        onError: function (data) {}
    });
}

$(document).on('hidden.bs.modal', '.end2endDeposit', function () {
    balanceCounter = 1;
    getMemberBalanceOperation();
    $(this).removeClass('end2endDeposit');
});

function getMemberBalanceOperation() {
    let balance;
    let pattern = /[^(\d+)\.(\d+)]/g;

    let responseObj = {
        event: 1, // update player balance
        data: {},
    };

    $.ajaxRequest("getMemberBalanceOperation", {
        toastr: false,
        request: {
            url: "/casino/operation/getMemberBalance"
        },
        onSuccess: function (response) {
            $.each(response.data, function(key, value) {
                if(value.info.key === 'balance') {
                    balance = value.info.amount;
                    responseObj.data.realMoney = balance.replace(pattern, '') * 1.00;
                }
                if(value.info.key === 'casino-bonus') {
                    balance = value.info.amount;
                    responseObj.data.bonusMoney = balance.replace(pattern, '') * 1.00;
                }
            });

            EndToEndGameCommunicator.postMessage(responseObj);

            if(balanceCounter < 4) {
                ++balanceCounter;

                setTimeout(function() { getMemberBalanceOperation(); },20000);
            }
        },
        onError: function (data) {},
    })
}
